var vU = Object.defineProperty;
var LU = (n, a, s) => a in n ? vU(n, a, { enumerable: !0, configurable: !0, writable: !0, value: s }) : n[a] = s;
var Ht = (n, a, s) => (LU(n, typeof a != "symbol" ? a + "" : a, s), s);
function yU(n, a) {
  for (var s = 0; s < a.length; s++) {
    const o = a[s];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const c in o)
        if (c !== "default" && !(c in n)) {
          const E = Object.getOwnPropertyDescriptor(o, c);
          E && Object.defineProperty(n, c, E.get ? E : {
            enumerable: !0,
            get: () => o[c]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
var Yt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xi(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function zm(n) {
  if (n.__esModule)
    return n;
  var a = n.default;
  if (typeof a == "function") {
    var s = function o() {
      return this instanceof o ? Reflect.construct(a, arguments, this.constructor) : a.apply(this, arguments);
    };
    s.prototype = a.prototype;
  } else
    s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(n).forEach(function(o) {
    var c = Object.getOwnPropertyDescriptor(n, o);
    Object.defineProperty(s, o, c.get ? c : {
      enumerable: !0,
      get: function() {
        return n[o];
      }
    });
  }), s;
}
var Zm = { exports: {} }, Bf = {}, qm = { exports: {} }, Kf = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Kf.exports;
(function(n, a) {
  (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var s = "18.2.0", o = Symbol.for("react.element"), c = Symbol.for("react.portal"), E = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), T = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), y = Symbol.iterator, O = "@@iterator";
    function g(C) {
      if (C === null || typeof C != "object")
        return null;
      var H = y && C[y] || C[O];
      return typeof H == "function" ? H : null;
    }
    var V = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, D = {
      transition: null
    }, G = {
      current: null,
      // Used to reproduce behavior of `batchedUpdates` in legacy mode.
      isBatchingLegacy: !1,
      didScheduleLegacyUpdate: !1
    }, P = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, U = {}, Y = null;
    function X(C) {
      Y = C;
    }
    U.setExtraStackFrame = function(C) {
      Y = C;
    }, U.getCurrentStack = null, U.getStackAddendum = function() {
      var C = "";
      Y && (C += Y);
      var H = U.getCurrentStack;
      return H && (C += H() || ""), C;
    };
    var _ = !1, F = !1, j = !1, z = !1, Z = !1, ee = {
      ReactCurrentDispatcher: V,
      ReactCurrentBatchConfig: D,
      ReactCurrentOwner: P
    };
    ee.ReactDebugCurrentFrame = U, ee.ReactCurrentActQueue = G;
    function oe(C) {
      {
        for (var H = arguments.length, $ = new Array(H > 1 ? H - 1 : 0), te = 1; te < H; te++)
          $[te - 1] = arguments[te];
        de("warn", C, $);
      }
    }
    function ne(C) {
      {
        for (var H = arguments.length, $ = new Array(H > 1 ? H - 1 : 0), te = 1; te < H; te++)
          $[te - 1] = arguments[te];
        de("error", C, $);
      }
    }
    function de(C, H, $) {
      {
        var te = ee.ReactDebugCurrentFrame, Te = te.getStackAddendum();
        Te !== "" && (H += "%s", $ = $.concat([Te]));
        var Pe = $.map(function(Ce) {
          return String(Ce);
        });
        Pe.unshift("Warning: " + H), Function.prototype.apply.call(console[C], console, Pe);
      }
    }
    var ve = {};
    function Fe(C, H) {
      {
        var $ = C.constructor, te = $ && ($.displayName || $.name) || "ReactClass", Te = te + "." + H;
        if (ve[Te])
          return;
        ne("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", H, te), ve[Te] = !0;
      }
    }
    var et = {
      /**
       * Checks whether or not this composite component is mounted.
       * @param {ReactClass} publicInstance The instance we want to test.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function(C) {
        return !1;
      },
      /**
       * Forces an update. This should only be invoked when it is known with
       * certainty that we are **not** in a DOM transaction.
       *
       * You may want to call this when you know that some deeper aspect of the
       * component's state has changed but `setState` was not called.
       *
       * This will not invoke `shouldComponentUpdate`, but it will invoke
       * `componentWillUpdate` and `componentDidUpdate`.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueForceUpdate: function(C, H, $) {
        Fe(C, "forceUpdate");
      },
      /**
       * Replaces all of the state. Always use this or `setState` to mutate state.
       * You should treat `this.state` as immutable.
       *
       * There is no guarantee that `this.state` will be immediately updated, so
       * accessing `this.state` after calling this method may return the old value.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} completeState Next state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueReplaceState: function(C, H, $, te) {
        Fe(C, "replaceState");
      },
      /**
       * Sets a subset of the state. This only exists because _pendingState is
       * internal. This provides a merging strategy that is not available to deep
       * properties which is confusing. TODO: Expose pendingState or don't use it
       * during the merge.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} partialState Next partial state to be merged with state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} Name of the calling function in the public API.
       * @internal
       */
      enqueueSetState: function(C, H, $, te) {
        Fe(C, "setState");
      }
    }, Ke = Object.assign, Et = {};
    Object.freeze(Et);
    function Ct(C, H, $) {
      this.props = C, this.context = H, this.refs = Et, this.updater = $ || et;
    }
    Ct.prototype.isReactComponent = {}, Ct.prototype.setState = function(C, H) {
      if (typeof C != "object" && typeof C != "function" && C != null)
        throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, C, H, "setState");
    }, Ct.prototype.forceUpdate = function(C) {
      this.updater.enqueueForceUpdate(this, C, "forceUpdate");
    };
    {
      var xn = {
        isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
        replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
      }, Tn = function(C, H) {
        Object.defineProperty(Ct.prototype, C, {
          get: function() {
            oe("%s(...) is deprecated in plain JavaScript React classes. %s", H[0], H[1]);
          }
        });
      };
      for (var _n in xn)
        xn.hasOwnProperty(_n) && Tn(_n, xn[_n]);
    }
    function Kt() {
    }
    Kt.prototype = Ct.prototype;
    function ot(C, H, $) {
      this.props = C, this.context = H, this.refs = Et, this.updater = $ || et;
    }
    var xt = ot.prototype = new Kt();
    xt.constructor = ot, Ke(xt, Ct.prototype), xt.isPureReactComponent = !0;
    function en() {
      var C = {
        current: null
      };
      return Object.seal(C), C;
    }
    var dn = Array.isArray;
    function Jt(C) {
      return dn(C);
    }
    function wn(C) {
      {
        var H = typeof Symbol == "function" && Symbol.toStringTag, $ = H && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return $;
      }
    }
    function An(C) {
      try {
        return Rn(C), !1;
      } catch {
        return !0;
      }
    }
    function Rn(C) {
      return "" + C;
    }
    function tn(C) {
      if (An(C))
        return ne("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", wn(C)), Rn(C);
    }
    function dr(C, H, $) {
      var te = C.displayName;
      if (te)
        return te;
      var Te = H.displayName || H.name || "";
      return Te !== "" ? $ + "(" + Te + ")" : $;
    }
    function Lr(C) {
      return C.displayName || "Context";
    }
    function rr(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && ne("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case E:
          return "Fragment";
        case c:
          return "Portal";
        case R:
          return "Profiler";
        case u:
          return "StrictMode";
        case N:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case T:
            var H = C;
            return Lr(H) + ".Consumer";
          case d:
            var $ = C;
            return Lr($._context) + ".Provider";
          case S:
            return dr(C, C.render, "ForwardRef");
          case v:
            var te = C.displayName || null;
            return te !== null ? te : rr(C.type) || "Memo";
          case M: {
            var Te = C, Pe = Te._payload, Ce = Te._init;
            try {
              return rr(Ce(Pe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Vr = Object.prototype.hasOwnProperty, yr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, jn, gr, Gn;
    Gn = {};
    function Ar(C) {
      if (Vr.call(C, "ref")) {
        var H = Object.getOwnPropertyDescriptor(C, "ref").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function Wt(C) {
      if (Vr.call(C, "key")) {
        var H = Object.getOwnPropertyDescriptor(C, "key").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function Dr(C, H) {
      var $ = function() {
        jn || (jn = !0, ne("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
      };
      $.isReactWarning = !0, Object.defineProperty(C, "key", {
        get: $,
        configurable: !0
      });
    }
    function La(C, H) {
      var $ = function() {
        gr || (gr = !0, ne("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
      };
      $.isReactWarning = !0, Object.defineProperty(C, "ref", {
        get: $,
        configurable: !0
      });
    }
    function ya(C) {
      if (typeof C.ref == "string" && P.current && C.__self && P.current.stateNode !== C.__self) {
        var H = rr(P.current.type);
        Gn[H] || (ne('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H, C.ref), Gn[H] = !0);
      }
    }
    var pe = function(C, H, $, te, Te, Pe, Ce) {
      var xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: C,
        key: H,
        ref: $,
        props: Ce,
        // Record the component responsible for creating this element.
        _owner: Pe
      };
      return xe._store = {}, Object.defineProperty(xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: te
      }), Object.defineProperty(xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Te
      }), Object.freeze && (Object.freeze(xe.props), Object.freeze(xe)), xe;
    };
    function Le(C, H, $) {
      var te, Te = {}, Pe = null, Ce = null, xe = null, ze = null;
      if (H != null) {
        Ar(H) && (Ce = H.ref, ya(H)), Wt(H) && (tn(H.key), Pe = "" + H.key), xe = H.__self === void 0 ? null : H.__self, ze = H.__source === void 0 ? null : H.__source;
        for (te in H)
          Vr.call(H, te) && !yr.hasOwnProperty(te) && (Te[te] = H[te]);
      }
      var Rt = arguments.length - 2;
      if (Rt === 1)
        Te.children = $;
      else if (Rt > 1) {
        for (var Ot = Array(Rt), It = 0; It < Rt; It++)
          Ot[It] = arguments[It + 2];
        Object.freeze && Object.freeze(Ot), Te.children = Ot;
      }
      if (C && C.defaultProps) {
        var bt = C.defaultProps;
        for (te in bt)
          Te[te] === void 0 && (Te[te] = bt[te]);
      }
      if (Pe || Ce) {
        var Bt = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
        Pe && Dr(Te, Bt), Ce && La(Te, Bt);
      }
      return pe(C, Pe, Ce, xe, ze, P.current, Te);
    }
    function ke(C, H) {
      var $ = pe(C.type, H, C.ref, C._self, C._source, C._owner, C.props);
      return $;
    }
    function dt(C, H, $) {
      if (C == null)
        throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + C + ".");
      var te, Te = Ke({}, C.props), Pe = C.key, Ce = C.ref, xe = C._self, ze = C._source, Rt = C._owner;
      if (H != null) {
        Ar(H) && (Ce = H.ref, Rt = P.current), Wt(H) && (tn(H.key), Pe = "" + H.key);
        var Ot;
        C.type && C.type.defaultProps && (Ot = C.type.defaultProps);
        for (te in H)
          Vr.call(H, te) && !yr.hasOwnProperty(te) && (H[te] === void 0 && Ot !== void 0 ? Te[te] = Ot[te] : Te[te] = H[te]);
      }
      var It = arguments.length - 2;
      if (It === 1)
        Te.children = $;
      else if (It > 1) {
        for (var bt = Array(It), Bt = 0; Bt < It; Bt++)
          bt[Bt] = arguments[Bt + 2];
        Te.children = bt;
      }
      return pe(C.type, Pe, Ce, xe, ze, Rt, Te);
    }
    function At(C) {
      return typeof C == "object" && C !== null && C.$$typeof === o;
    }
    var nn = ".", kt = ":";
    function ar(C) {
      var H = /[=:]/g, $ = {
        "=": "=0",
        ":": "=2"
      }, te = C.replace(H, function(Te) {
        return $[Te];
      });
      return "$" + te;
    }
    var Nt = !1, Rr = /\/+/g;
    function Lt(C) {
      return C.replace(Rr, "$&/");
    }
    function yt(C, H) {
      return typeof C == "object" && C !== null && C.key != null ? (tn(C.key), ar("" + C.key)) : H.toString(36);
    }
    function oa(C, H, $, te, Te) {
      var Pe = typeof C;
      (Pe === "undefined" || Pe === "boolean") && (C = null);
      var Ce = !1;
      if (C === null)
        Ce = !0;
      else
        switch (Pe) {
          case "string":
          case "number":
            Ce = !0;
            break;
          case "object":
            switch (C.$$typeof) {
              case o:
              case c:
                Ce = !0;
            }
        }
      if (Ce) {
        var xe = C, ze = Te(xe), Rt = te === "" ? nn + yt(xe, 0) : te;
        if (Jt(ze)) {
          var Ot = "";
          Rt != null && (Ot = Lt(Rt) + "/"), oa(ze, H, Ot, "", function(MT) {
            return MT;
          });
        } else
          ze != null && (At(ze) && (ze.key && (!xe || xe.key !== ze.key) && tn(ze.key), ze = ke(
            ze,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            $ + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (ze.key && (!xe || xe.key !== ze.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              Lt("" + ze.key) + "/"
            ) : "") + Rt
          )), H.push(ze));
        return 1;
      }
      var It, bt, Bt = 0, st = te === "" ? nn : te + kt;
      if (Jt(C))
        for (var fi = 0; fi < C.length; fi++)
          It = C[fi], bt = st + yt(It, fi), Bt += oa(It, H, $, bt, Te);
      else {
        var zs = g(C);
        if (typeof zs == "function") {
          var dl = C;
          zs === dl.entries && (Nt || oe("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Nt = !0);
          for (var bT = zs.call(dl), Pa, Al = 0; !(Pa = bT.next()).done; )
            It = Pa.value, bt = st + yt(It, Al++), Bt += oa(It, H, $, bt, Te);
        } else if (Pe === "object") {
          var Rl = String(C);
          throw new Error("Objects are not valid as a React child (found: " + (Rl === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : Rl) + "). If you meant to render a collection of children, use an array instead.");
        }
      }
      return Bt;
    }
    function Wr(C, H, $) {
      if (C == null)
        return C;
      var te = [], Te = 0;
      return oa(C, te, "", "", function(Pe) {
        return H.call($, Pe, Te++);
      }), te;
    }
    function zi(C) {
      var H = 0;
      return Wr(C, function() {
        H++;
      }), H;
    }
    function Vs(C, H, $) {
      Wr(C, function() {
        H.apply(this, arguments);
      }, $);
    }
    function el(C) {
      return Wr(C, function(H) {
        return H;
      }) || [];
    }
    function Zi(C) {
      if (!At(C))
        throw new Error("React.Children.only expected to receive a single React element child.");
      return C;
    }
    function qi(C) {
      var H = {
        $$typeof: T,
        // As a workaround to support multiple concurrent renderers, we categorize
        // some renderers as primary and others as secondary. We only expect
        // there to be two concurrent renderers at most: React Native (primary) and
        // Fabric (secondary); React DOM (primary) and React ART (secondary).
        // Secondary renderers store their context values on separate fields.
        _currentValue: C,
        _currentValue2: C,
        // Used to track how many concurrent renderers this context currently
        // supports within in a single renderer. Such as parallel server rendering.
        _threadCount: 0,
        // These are circular
        Provider: null,
        Consumer: null,
        // Add these to use same hidden class in VM as ServerContext
        _defaultValue: null,
        _globalName: null
      };
      H.Provider = {
        $$typeof: d,
        _context: H
      };
      var $ = !1, te = !1, Te = !1;
      {
        var Pe = {
          $$typeof: T,
          _context: H
        };
        Object.defineProperties(Pe, {
          Provider: {
            get: function() {
              return te || (te = !0, ne("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), H.Provider;
            },
            set: function(Ce) {
              H.Provider = Ce;
            }
          },
          _currentValue: {
            get: function() {
              return H._currentValue;
            },
            set: function(Ce) {
              H._currentValue = Ce;
            }
          },
          _currentValue2: {
            get: function() {
              return H._currentValue2;
            },
            set: function(Ce) {
              H._currentValue2 = Ce;
            }
          },
          _threadCount: {
            get: function() {
              return H._threadCount;
            },
            set: function(Ce) {
              H._threadCount = Ce;
            }
          },
          Consumer: {
            get: function() {
              return $ || ($ = !0, ne("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), H.Consumer;
            }
          },
          displayName: {
            get: function() {
              return H.displayName;
            },
            set: function(Ce) {
              Te || (oe("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", Ce), Te = !0);
            }
          }
        }), H.Consumer = Pe;
      }
      return H._currentRenderer = null, H._currentRenderer2 = null, H;
    }
    var ga = -1, ai = 0, Da = 1, la = 2;
    function kr(C) {
      if (C._status === ga) {
        var H = C._result, $ = H();
        if ($.then(function(Pe) {
          if (C._status === ai || C._status === ga) {
            var Ce = C;
            Ce._status = Da, Ce._result = Pe;
          }
        }, function(Pe) {
          if (C._status === ai || C._status === ga) {
            var Ce = C;
            Ce._status = la, Ce._result = Pe;
          }
        }), C._status === ga) {
          var te = C;
          te._status = ai, te._result = $;
        }
      }
      if (C._status === Da) {
        var Te = C._result;
        return Te === void 0 && ne(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, Te), "default" in Te || ne(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, Te), Te.default;
      } else
        throw C._result;
    }
    function ua(C) {
      var H = {
        // We use these fields to store the result.
        _status: ga,
        _result: C
      }, $ = {
        $$typeof: M,
        _payload: H,
        _init: kr
      };
      {
        var te, Te;
        Object.defineProperties($, {
          defaultProps: {
            configurable: !0,
            get: function() {
              return te;
            },
            set: function(Pe) {
              ne("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), te = Pe, Object.defineProperty($, "defaultProps", {
                enumerable: !0
              });
            }
          },
          propTypes: {
            configurable: !0,
            get: function() {
              return Te;
            },
            set: function(Pe) {
              ne("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Te = Pe, Object.defineProperty($, "propTypes", {
                enumerable: !0
              });
            }
          }
        });
      }
      return $;
    }
    function Qi(C) {
      C != null && C.$$typeof === v ? ne("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof C != "function" ? ne("forwardRef requires a render function but was given %s.", C === null ? "null" : typeof C) : C.length !== 0 && C.length !== 2 && ne("forwardRef render functions accept exactly two parameters: props and ref. %s", C.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), C != null && (C.defaultProps != null || C.propTypes != null) && ne("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
      var H = {
        $$typeof: S,
        render: C
      };
      {
        var $;
        Object.defineProperty(H, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return $;
          },
          set: function(te) {
            $ = te, !C.name && !C.displayName && (C.displayName = te);
          }
        });
      }
      return H;
    }
    var B;
    B = Symbol.for("react.module.reference");
    function ue(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === E || C === R || Z || C === u || C === N || C === m || z || C === w || _ || F || j || typeof C == "object" && C !== null && (C.$$typeof === M || C.$$typeof === v || C.$$typeof === d || C.$$typeof === T || C.$$typeof === S || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === B || C.getModuleId !== void 0));
    }
    function Re(C, H) {
      ue(C) || ne("memo: The first argument must be a component. Instead received: %s", C === null ? "null" : typeof C);
      var $ = {
        $$typeof: v,
        type: C,
        compare: H === void 0 ? null : H
      };
      {
        var te;
        Object.defineProperty($, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return te;
          },
          set: function(Te) {
            te = Te, !C.name && !C.displayName && (C.displayName = Te);
          }
        });
      }
      return $;
    }
    function Ie() {
      var C = V.current;
      return C === null && ne(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), C;
    }
    function je(C) {
      var H = Ie();
      if (C._context !== void 0) {
        var $ = C._context;
        $.Consumer === C ? ne("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : $.Provider === C && ne("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
      }
      return H.useContext(C);
    }
    function nt(C) {
      var H = Ie();
      return H.useState(C);
    }
    function Ve(C, H, $) {
      var te = Ie();
      return te.useReducer(C, H, $);
    }
    function ge(C) {
      var H = Ie();
      return H.useRef(C);
    }
    function rn(C, H) {
      var $ = Ie();
      return $.useEffect(C, H);
    }
    function gt(C, H) {
      var $ = Ie();
      return $.useInsertionEffect(C, H);
    }
    function Dt(C, H) {
      var $ = Ie();
      return $.useLayoutEffect(C, H);
    }
    function Hn(C, H) {
      var $ = Ie();
      return $.useCallback(C, H);
    }
    function Ea(C, H) {
      var $ = Ie();
      return $.useMemo(C, H);
    }
    function Ws(C, H, $) {
      var te = Ie();
      return te.useImperativeHandle(C, H, $);
    }
    function ir(C, H) {
      {
        var $ = Ie();
        return $.useDebugValue(C, H);
      }
    }
    function vT() {
      var C = Ie();
      return C.useTransition();
    }
    function ba(C) {
      var H = Ie();
      return H.useDeferredValue(C);
    }
    function Je() {
      var C = Ie();
      return C.useId();
    }
    function $i(C, H, $) {
      var te = Ie();
      return te.useSyncExternalStore(C, H, $);
    }
    var ii = 0, tl, nl, rl, al, il, sl, ol;
    function AE() {
    }
    AE.__reactDisabledLog = !0;
    function LT() {
      {
        if (ii === 0) {
          tl = console.log, nl = console.info, rl = console.warn, al = console.error, il = console.group, sl = console.groupCollapsed, ol = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: AE,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        ii++;
      }
    }
    function ll() {
      {
        if (ii--, ii === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Ke({}, C, {
              value: tl
            }),
            info: Ke({}, C, {
              value: nl
            }),
            warn: Ke({}, C, {
              value: rl
            }),
            error: Ke({}, C, {
              value: al
            }),
            group: Ke({}, C, {
              value: il
            }),
            groupCollapsed: Ke({}, C, {
              value: sl
            }),
            groupEnd: Ke({}, C, {
              value: ol
            })
          });
        }
        ii < 0 && ne("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var es = ee.ReactCurrentDispatcher, br;
    function si(C, H, $) {
      {
        if (br === void 0)
          try {
            throw Error();
          } catch (Te) {
            var te = Te.stack.trim().match(/\n( *(at )?)/);
            br = te && te[1] || "";
          }
        return `
` + br + C;
      }
    }
    var oi = !1, ks;
    {
      var ul = typeof WeakMap == "function" ? WeakMap : Map;
      ks = new ul();
    }
    function RE(C, H) {
      if (!C || oi)
        return "";
      {
        var $ = ks.get(C);
        if ($ !== void 0)
          return $;
      }
      var te;
      oi = !0;
      var Te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Pe;
      Pe = es.current, es.current = null, LT();
      try {
        if (H) {
          var Ce = function() {
            throw Error();
          };
          if (Object.defineProperty(Ce.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ce, []);
            } catch (st) {
              te = st;
            }
            Reflect.construct(C, [], Ce);
          } else {
            try {
              Ce.call();
            } catch (st) {
              te = st;
            }
            C.call(Ce.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (st) {
            te = st;
          }
          C();
        }
      } catch (st) {
        if (st && te && typeof st.stack == "string") {
          for (var xe = st.stack.split(`
`), ze = te.stack.split(`
`), Rt = xe.length - 1, Ot = ze.length - 1; Rt >= 1 && Ot >= 0 && xe[Rt] !== ze[Ot]; )
            Ot--;
          for (; Rt >= 1 && Ot >= 0; Rt--, Ot--)
            if (xe[Rt] !== ze[Ot]) {
              if (Rt !== 1 || Ot !== 1)
                do
                  if (Rt--, Ot--, Ot < 0 || xe[Rt] !== ze[Ot]) {
                    var It = `
` + xe[Rt].replace(" at new ", " at ");
                    return C.displayName && It.includes("<anonymous>") && (It = It.replace("<anonymous>", C.displayName)), typeof C == "function" && ks.set(C, It), It;
                  }
                while (Rt >= 1 && Ot >= 0);
              break;
            }
        }
      } finally {
        oi = !1, es.current = Pe, ll(), Error.prepareStackTrace = Te;
      }
      var bt = C ? C.displayName || C.name : "", Bt = bt ? si(bt) : "";
      return typeof C == "function" && ks.set(C, Bt), Bt;
    }
    function El(C, H, $) {
      return RE(C, !1);
    }
    function yT(C) {
      var H = C.prototype;
      return !!(H && H.isReactComponent);
    }
    function li(C, H, $) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return RE(C, yT(C));
      if (typeof C == "string")
        return si(C);
      switch (C) {
        case N:
          return si("Suspense");
        case m:
          return si("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case S:
            return El(C.render);
          case v:
            return li(C.type, H, $);
          case M: {
            var te = C, Te = te._payload, Pe = te._init;
            try {
              return li(Pe(Te), H, $);
            } catch {
            }
          }
        }
      return "";
    }
    var pE = {}, cl = ee.ReactDebugCurrentFrame;
    function Xs(C) {
      if (C) {
        var H = C._owner, $ = li(C.type, C._source, H ? H.type : null);
        cl.setExtraStackFrame($);
      } else
        cl.setExtraStackFrame(null);
    }
    function SE(C, H, $, te, Te) {
      {
        var Pe = Function.call.bind(Vr);
        for (var Ce in C)
          if (Pe(C, Ce)) {
            var xe = void 0;
            try {
              if (typeof C[Ce] != "function") {
                var ze = Error((te || "React class") + ": " + $ + " type `" + Ce + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[Ce] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ze.name = "Invariant Violation", ze;
              }
              xe = C[Ce](H, Ce, te, $, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Rt) {
              xe = Rt;
            }
            xe && !(xe instanceof Error) && (Xs(Te), ne("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", te || "React class", $, Ce, typeof xe), Xs(null)), xe instanceof Error && !(xe.message in pE) && (pE[xe.message] = !0, Xs(Te), ne("Failed %s type: %s", $, xe.message), Xs(null));
          }
      }
    }
    function it(C) {
      if (C) {
        var H = C._owner, $ = li(C.type, C._source, H ? H.type : null);
        X($);
      } else
        X(null);
    }
    var fl;
    fl = !1;
    function Tl() {
      if (P.current) {
        var C = rr(P.current.type);
        if (C)
          return `

Check the render method of \`` + C + "`.";
      }
      return "";
    }
    function Ye(C) {
      if (C !== void 0) {
        var H = C.fileName.replace(/^.*[\\\/]/, ""), $ = C.lineNumber;
        return `

Check your code at ` + H + ":" + $ + ".";
      }
      return "";
    }
    function hE(C) {
      return C != null ? Ye(C.__source) : "";
    }
    var Bn = {};
    function ts(C) {
      var H = Tl();
      if (!H) {
        var $ = typeof C == "string" ? C : C.displayName || C.name;
        $ && (H = `

Check the top-level render call using <` + $ + ">.");
      }
      return H;
    }
    function ui(C, H) {
      if (!(!C._store || C._store.validated || C.key != null)) {
        C._store.validated = !0;
        var $ = ts(H);
        if (!Bn[$]) {
          Bn[$] = !0;
          var te = "";
          C && C._owner && C._owner !== P.current && (te = " It was passed a child from " + rr(C._owner.type) + "."), it(C), ne('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $, te), it(null);
        }
      }
    }
    function NE(C, H) {
      if (typeof C == "object") {
        if (Jt(C))
          for (var $ = 0; $ < C.length; $++) {
            var te = C[$];
            At(te) && ui(te, H);
          }
        else if (At(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var Te = g(C);
          if (typeof Te == "function" && Te !== C.entries)
            for (var Pe = Te.call(C), Ce; !(Ce = Pe.next()).done; )
              At(Ce.value) && ui(Ce.value, H);
        }
      }
    }
    function pn(C) {
      {
        var H = C.type;
        if (H == null || typeof H == "string")
          return;
        var $;
        if (typeof H == "function")
          $ = H.propTypes;
        else if (typeof H == "object" && (H.$$typeof === S || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        H.$$typeof === v))
          $ = H.propTypes;
        else
          return;
        if ($) {
          var te = rr(H);
          SE($, C.props, "prop", te, C);
        } else if (H.PropTypes !== void 0 && !fl) {
          fl = !0;
          var Te = rr(H);
          ne("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Te || "Unknown");
        }
        typeof H.getDefaultProps == "function" && !H.getDefaultProps.isReactClassApproved && ne("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function wt(C) {
      {
        for (var H = Object.keys(C.props), $ = 0; $ < H.length; $++) {
          var te = H[$];
          if (te !== "children" && te !== "key") {
            it(C), ne("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", te), it(null);
            break;
          }
        }
        C.ref !== null && (it(C), ne("Invalid attribute `ref` supplied to `React.Fragment`."), it(null));
      }
    }
    function OE(C, H, $) {
      var te = ue(C);
      if (!te) {
        var Te = "";
        (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (Te += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var Pe = hE(H);
        Pe ? Te += Pe : Te += Tl();
        var Ce;
        C === null ? Ce = "null" : Jt(C) ? Ce = "array" : C !== void 0 && C.$$typeof === o ? (Ce = "<" + (rr(C.type) || "Unknown") + " />", Te = " Did you accidentally export a JSX literal instead of a component?") : Ce = typeof C, ne("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ce, Te);
      }
      var xe = Le.apply(this, arguments);
      if (xe == null)
        return xe;
      if (te)
        for (var ze = 2; ze < arguments.length; ze++)
          NE(arguments[ze], C);
      return C === E ? wt(xe) : pn(xe), xe;
    }
    var pr = !1;
    function sr(C) {
      var H = OE.bind(null, C);
      return H.type = C, pr || (pr = !0, oe("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(H, "type", {
        enumerable: !1,
        get: function() {
          return oe("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
            value: C
          }), C;
        }
      }), H;
    }
    function ca(C, H, $) {
      for (var te = dt.apply(this, arguments), Te = 2; Te < arguments.length; Te++)
        NE(arguments[Te], te.type);
      return pn(te), te;
    }
    function gT(C, H) {
      var $ = D.transition;
      D.transition = {};
      var te = D.transition;
      D.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        C();
      } finally {
        if (D.transition = $, $ === null && te._updatedFibers) {
          var Te = te._updatedFibers.size;
          Te > 10 && oe("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), te._updatedFibers.clear();
        }
      }
    }
    var js = !1, ns = null;
    function IE(C) {
      if (ns === null)
        try {
          var H = ("require" + Math.random()).slice(0, 7), $ = n && n[H];
          ns = $.call(n, "timers").setImmediate;
        } catch {
          ns = function(Te) {
            js === !1 && (js = !0, typeof MessageChannel > "u" && ne("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
            var Pe = new MessageChannel();
            Pe.port1.onmessage = Te, Pe.port2.postMessage(void 0);
          };
        }
      return ns(C);
    }
    var Ei = 0, _E = !1;
    function DT(C) {
      {
        var H = Ei;
        Ei++, G.current === null && (G.current = []);
        var $ = G.isBatchingLegacy, te;
        try {
          if (G.isBatchingLegacy = !0, te = C(), !$ && G.didScheduleLegacyUpdate) {
            var Te = G.current;
            Te !== null && (G.didScheduleLegacyUpdate = !1, Js(Te));
          }
        } catch (bt) {
          throw Ma(H), bt;
        } finally {
          G.isBatchingLegacy = $;
        }
        if (te !== null && typeof te == "object" && typeof te.then == "function") {
          var Pe = te, Ce = !1, xe = {
            then: function(bt, Bt) {
              Ce = !0, Pe.then(function(st) {
                Ma(H), Ei === 0 ? Ks(st, bt, Bt) : bt(st);
              }, function(st) {
                Ma(H), Bt(st);
              });
            }
          };
          return !_E && typeof Promise < "u" && Promise.resolve().then(function() {
          }).then(function() {
            Ce || (_E = !0, ne("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
          }), xe;
        } else {
          var ze = te;
          if (Ma(H), Ei === 0) {
            var Rt = G.current;
            Rt !== null && (Js(Rt), G.current = null);
            var Ot = {
              then: function(bt, Bt) {
                G.current === null ? (G.current = [], Ks(ze, bt, Bt)) : bt(ze);
              }
            };
            return Ot;
          } else {
            var It = {
              then: function(bt, Bt) {
                bt(ze);
              }
            };
            return It;
          }
        }
      }
    }
    function Ma(C) {
      C !== Ei - 1 && ne("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Ei = C;
    }
    function Ks(C, H, $) {
      {
        var te = G.current;
        if (te !== null)
          try {
            Js(te), IE(function() {
              te.length === 0 ? (G.current = null, H(C)) : Ks(C, H, $);
            });
          } catch (Te) {
            $(Te);
          }
        else
          H(C);
      }
    }
    var ci = !1;
    function Js(C) {
      if (!ci) {
        ci = !0;
        var H = 0;
        try {
          for (; H < C.length; H++) {
            var $ = C[H];
            do
              $ = $(!0);
            while ($ !== null);
          }
          C.length = 0;
        } catch (te) {
          throw C = C.slice(H + 1), te;
        } finally {
          ci = !1;
        }
      }
    }
    var CE = OE, mE = ca, vE = sr, LE = {
      map: Wr,
      forEach: Vs,
      count: zi,
      toArray: el,
      only: Zi
    };
    a.Children = LE, a.Component = Ct, a.Fragment = E, a.Profiler = R, a.PureComponent = ot, a.StrictMode = u, a.Suspense = N, a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ee, a.cloneElement = mE, a.createContext = qi, a.createElement = CE, a.createFactory = vE, a.createRef = en, a.forwardRef = Qi, a.isValidElement = At, a.lazy = ua, a.memo = Re, a.startTransition = gT, a.unstable_act = DT, a.useCallback = Hn, a.useContext = je, a.useDebugValue = ir, a.useDeferredValue = ba, a.useEffect = rn, a.useId = Je, a.useImperativeHandle = Ws, a.useInsertionEffect = gt, a.useLayoutEffect = Dt, a.useMemo = Ea, a.useReducer = Ve, a.useRef = ge, a.useState = nt, a.useSyncExternalStore = $i, a.useTransition = vT, a.version = s, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })();
})(Kf, Kf.exports);
var gU = Kf.exports;
qm.exports = gU;
var x = qm.exports;
const Qm = /* @__PURE__ */ Xi(x), DU = /* @__PURE__ */ yU({
  __proto__: null,
  default: Qm
}, [x]);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function() {
  var n = x, a = Symbol.for("react.element"), s = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), E = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), R = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), S = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), M = Symbol.iterator, w = "@@iterator";
  function y(B) {
    if (B === null || typeof B != "object")
      return null;
    var ue = M && B[M] || B[w];
    return typeof ue == "function" ? ue : null;
  }
  var O = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  function g(B) {
    {
      for (var ue = arguments.length, Re = new Array(ue > 1 ? ue - 1 : 0), Ie = 1; Ie < ue; Ie++)
        Re[Ie - 1] = arguments[Ie];
      V("error", B, Re);
    }
  }
  function V(B, ue, Re) {
    {
      var Ie = O.ReactDebugCurrentFrame, je = Ie.getStackAddendum();
      je !== "" && (ue += "%s", Re = Re.concat([je]));
      var nt = Re.map(function(Ve) {
        return String(Ve);
      });
      nt.unshift("Warning: " + ue), Function.prototype.apply.call(console[B], console, nt);
    }
  }
  var D = !1, G = !1, P = !1, U = !1, Y = !1, X;
  X = Symbol.for("react.module.reference");
  function _(B) {
    return !!(typeof B == "string" || typeof B == "function" || B === o || B === E || Y || B === c || B === T || B === S || U || B === v || D || G || P || typeof B == "object" && B !== null && (B.$$typeof === m || B.$$typeof === N || B.$$typeof === u || B.$$typeof === R || B.$$typeof === d || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    B.$$typeof === X || B.getModuleId !== void 0));
  }
  function F(B, ue, Re) {
    var Ie = B.displayName;
    if (Ie)
      return Ie;
    var je = ue.displayName || ue.name || "";
    return je !== "" ? Re + "(" + je + ")" : Re;
  }
  function j(B) {
    return B.displayName || "Context";
  }
  function z(B) {
    if (B == null)
      return null;
    if (typeof B.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof B == "function")
      return B.displayName || B.name || null;
    if (typeof B == "string")
      return B;
    switch (B) {
      case o:
        return "Fragment";
      case s:
        return "Portal";
      case E:
        return "Profiler";
      case c:
        return "StrictMode";
      case T:
        return "Suspense";
      case S:
        return "SuspenseList";
    }
    if (typeof B == "object")
      switch (B.$$typeof) {
        case R:
          var ue = B;
          return j(ue) + ".Consumer";
        case u:
          var Re = B;
          return j(Re._context) + ".Provider";
        case d:
          return F(B, B.render, "ForwardRef");
        case N:
          var Ie = B.displayName || null;
          return Ie !== null ? Ie : z(B.type) || "Memo";
        case m: {
          var je = B, nt = je._payload, Ve = je._init;
          try {
            return z(Ve(nt));
          } catch {
            return null;
          }
        }
      }
    return null;
  }
  var Z = Object.assign, ee = 0, oe, ne, de, ve, Fe, et, Ke;
  function Et() {
  }
  Et.__reactDisabledLog = !0;
  function Ct() {
    {
      if (ee === 0) {
        oe = console.log, ne = console.info, de = console.warn, ve = console.error, Fe = console.group, et = console.groupCollapsed, Ke = console.groupEnd;
        var B = {
          configurable: !0,
          enumerable: !0,
          value: Et,
          writable: !0
        };
        Object.defineProperties(console, {
          info: B,
          log: B,
          warn: B,
          error: B,
          group: B,
          groupCollapsed: B,
          groupEnd: B
        });
      }
      ee++;
    }
  }
  function xn() {
    {
      if (ee--, ee === 0) {
        var B = {
          configurable: !0,
          enumerable: !0,
          writable: !0
        };
        Object.defineProperties(console, {
          log: Z({}, B, {
            value: oe
          }),
          info: Z({}, B, {
            value: ne
          }),
          warn: Z({}, B, {
            value: de
          }),
          error: Z({}, B, {
            value: ve
          }),
          group: Z({}, B, {
            value: Fe
          }),
          groupCollapsed: Z({}, B, {
            value: et
          }),
          groupEnd: Z({}, B, {
            value: Ke
          })
        });
      }
      ee < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
  }
  var Tn = O.ReactCurrentDispatcher, _n;
  function Kt(B, ue, Re) {
    {
      if (_n === void 0)
        try {
          throw Error();
        } catch (je) {
          var Ie = je.stack.trim().match(/\n( *(at )?)/);
          _n = Ie && Ie[1] || "";
        }
      return `
` + _n + B;
    }
  }
  var ot = !1, xt;
  {
    var en = typeof WeakMap == "function" ? WeakMap : Map;
    xt = new en();
  }
  function dn(B, ue) {
    if (!B || ot)
      return "";
    {
      var Re = xt.get(B);
      if (Re !== void 0)
        return Re;
    }
    var Ie;
    ot = !0;
    var je = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    var nt;
    nt = Tn.current, Tn.current = null, Ct();
    try {
      if (ue) {
        var Ve = function() {
          throw Error();
        };
        if (Object.defineProperty(Ve.prototype, "props", {
          set: function() {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(Ve, []);
          } catch (ir) {
            Ie = ir;
          }
          Reflect.construct(B, [], Ve);
        } else {
          try {
            Ve.call();
          } catch (ir) {
            Ie = ir;
          }
          B.call(Ve.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (ir) {
          Ie = ir;
        }
        B();
      }
    } catch (ir) {
      if (ir && Ie && typeof ir.stack == "string") {
        for (var ge = ir.stack.split(`
`), rn = Ie.stack.split(`
`), gt = ge.length - 1, Dt = rn.length - 1; gt >= 1 && Dt >= 0 && ge[gt] !== rn[Dt]; )
          Dt--;
        for (; gt >= 1 && Dt >= 0; gt--, Dt--)
          if (ge[gt] !== rn[Dt]) {
            if (gt !== 1 || Dt !== 1)
              do
                if (gt--, Dt--, Dt < 0 || ge[gt] !== rn[Dt]) {
                  var Hn = `
` + ge[gt].replace(" at new ", " at ");
                  return B.displayName && Hn.includes("<anonymous>") && (Hn = Hn.replace("<anonymous>", B.displayName)), typeof B == "function" && xt.set(B, Hn), Hn;
                }
              while (gt >= 1 && Dt >= 0);
            break;
          }
      }
    } finally {
      ot = !1, Tn.current = nt, xn(), Error.prepareStackTrace = je;
    }
    var Ea = B ? B.displayName || B.name : "", Ws = Ea ? Kt(Ea) : "";
    return typeof B == "function" && xt.set(B, Ws), Ws;
  }
  function Jt(B, ue, Re) {
    return dn(B, !1);
  }
  function wn(B) {
    var ue = B.prototype;
    return !!(ue && ue.isReactComponent);
  }
  function An(B, ue, Re) {
    if (B == null)
      return "";
    if (typeof B == "function")
      return dn(B, wn(B));
    if (typeof B == "string")
      return Kt(B);
    switch (B) {
      case T:
        return Kt("Suspense");
      case S:
        return Kt("SuspenseList");
    }
    if (typeof B == "object")
      switch (B.$$typeof) {
        case d:
          return Jt(B.render);
        case N:
          return An(B.type, ue, Re);
        case m: {
          var Ie = B, je = Ie._payload, nt = Ie._init;
          try {
            return An(nt(je), ue, Re);
          } catch {
          }
        }
      }
    return "";
  }
  var Rn = Object.prototype.hasOwnProperty, tn = {}, dr = O.ReactDebugCurrentFrame;
  function Lr(B) {
    if (B) {
      var ue = B._owner, Re = An(B.type, B._source, ue ? ue.type : null);
      dr.setExtraStackFrame(Re);
    } else
      dr.setExtraStackFrame(null);
  }
  function rr(B, ue, Re, Ie, je) {
    {
      var nt = Function.call.bind(Rn);
      for (var Ve in B)
        if (nt(B, Ve)) {
          var ge = void 0;
          try {
            if (typeof B[Ve] != "function") {
              var rn = Error((Ie || "React class") + ": " + Re + " type `" + Ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof B[Ve] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw rn.name = "Invariant Violation", rn;
            }
            ge = B[Ve](ue, Ve, Ie, Re, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (gt) {
            ge = gt;
          }
          ge && !(ge instanceof Error) && (Lr(je), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ie || "React class", Re, Ve, typeof ge), Lr(null)), ge instanceof Error && !(ge.message in tn) && (tn[ge.message] = !0, Lr(je), g("Failed %s type: %s", Re, ge.message), Lr(null));
        }
    }
  }
  var Vr = Array.isArray;
  function yr(B) {
    return Vr(B);
  }
  function jn(B) {
    {
      var ue = typeof Symbol == "function" && Symbol.toStringTag, Re = ue && B[Symbol.toStringTag] || B.constructor.name || "Object";
      return Re;
    }
  }
  function gr(B) {
    try {
      return Gn(B), !1;
    } catch {
      return !0;
    }
  }
  function Gn(B) {
    return "" + B;
  }
  function Ar(B) {
    if (gr(B))
      return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", jn(B)), Gn(B);
  }
  var Wt = O.ReactCurrentOwner, Dr = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  }, La, ya, pe;
  pe = {};
  function Le(B) {
    if (Rn.call(B, "ref")) {
      var ue = Object.getOwnPropertyDescriptor(B, "ref").get;
      if (ue && ue.isReactWarning)
        return !1;
    }
    return B.ref !== void 0;
  }
  function ke(B) {
    if (Rn.call(B, "key")) {
      var ue = Object.getOwnPropertyDescriptor(B, "key").get;
      if (ue && ue.isReactWarning)
        return !1;
    }
    return B.key !== void 0;
  }
  function dt(B, ue) {
    if (typeof B.ref == "string" && Wt.current && ue && Wt.current.stateNode !== ue) {
      var Re = z(Wt.current.type);
      pe[Re] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(Wt.current.type), B.ref), pe[Re] = !0);
    }
  }
  function At(B, ue) {
    {
      var Re = function() {
        La || (La = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
      };
      Re.isReactWarning = !0, Object.defineProperty(B, "key", {
        get: Re,
        configurable: !0
      });
    }
  }
  function nn(B, ue) {
    {
      var Re = function() {
        ya || (ya = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
      };
      Re.isReactWarning = !0, Object.defineProperty(B, "ref", {
        get: Re,
        configurable: !0
      });
    }
  }
  var kt = function(B, ue, Re, Ie, je, nt, Ve) {
    var ge = {
      // This tag allows us to uniquely identify this as a React Element
      $$typeof: a,
      // Built-in properties that belong on the element
      type: B,
      key: ue,
      ref: Re,
      props: Ve,
      // Record the component responsible for creating this element.
      _owner: nt
    };
    return ge._store = {}, Object.defineProperty(ge._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(ge, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: Ie
    }), Object.defineProperty(ge, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: je
    }), Object.freeze && (Object.freeze(ge.props), Object.freeze(ge)), ge;
  };
  function ar(B, ue, Re, Ie, je) {
    {
      var nt, Ve = {}, ge = null, rn = null;
      Re !== void 0 && (Ar(Re), ge = "" + Re), ke(ue) && (Ar(ue.key), ge = "" + ue.key), Le(ue) && (rn = ue.ref, dt(ue, je));
      for (nt in ue)
        Rn.call(ue, nt) && !Dr.hasOwnProperty(nt) && (Ve[nt] = ue[nt]);
      if (B && B.defaultProps) {
        var gt = B.defaultProps;
        for (nt in gt)
          Ve[nt] === void 0 && (Ve[nt] = gt[nt]);
      }
      if (ge || rn) {
        var Dt = typeof B == "function" ? B.displayName || B.name || "Unknown" : B;
        ge && At(Ve, Dt), rn && nn(Ve, Dt);
      }
      return kt(B, ge, rn, je, Ie, Wt.current, Ve);
    }
  }
  var Nt = O.ReactCurrentOwner, Rr = O.ReactDebugCurrentFrame;
  function Lt(B) {
    if (B) {
      var ue = B._owner, Re = An(B.type, B._source, ue ? ue.type : null);
      Rr.setExtraStackFrame(Re);
    } else
      Rr.setExtraStackFrame(null);
  }
  var yt;
  yt = !1;
  function oa(B) {
    return typeof B == "object" && B !== null && B.$$typeof === a;
  }
  function Wr() {
    {
      if (Nt.current) {
        var B = z(Nt.current.type);
        if (B)
          return `

Check the render method of \`` + B + "`.";
      }
      return "";
    }
  }
  function zi(B) {
    {
      if (B !== void 0) {
        var ue = B.fileName.replace(/^.*[\\\/]/, ""), Re = B.lineNumber;
        return `

Check your code at ` + ue + ":" + Re + ".";
      }
      return "";
    }
  }
  var Vs = {};
  function el(B) {
    {
      var ue = Wr();
      if (!ue) {
        var Re = typeof B == "string" ? B : B.displayName || B.name;
        Re && (ue = `

Check the top-level render call using <` + Re + ">.");
      }
      return ue;
    }
  }
  function Zi(B, ue) {
    {
      if (!B._store || B._store.validated || B.key != null)
        return;
      B._store.validated = !0;
      var Re = el(ue);
      if (Vs[Re])
        return;
      Vs[Re] = !0;
      var Ie = "";
      B && B._owner && B._owner !== Nt.current && (Ie = " It was passed a child from " + z(B._owner.type) + "."), Lt(B), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Re, Ie), Lt(null);
    }
  }
  function qi(B, ue) {
    {
      if (typeof B != "object")
        return;
      if (yr(B))
        for (var Re = 0; Re < B.length; Re++) {
          var Ie = B[Re];
          oa(Ie) && Zi(Ie, ue);
        }
      else if (oa(B))
        B._store && (B._store.validated = !0);
      else if (B) {
        var je = y(B);
        if (typeof je == "function" && je !== B.entries)
          for (var nt = je.call(B), Ve; !(Ve = nt.next()).done; )
            oa(Ve.value) && Zi(Ve.value, ue);
      }
    }
  }
  function ga(B) {
    {
      var ue = B.type;
      if (ue == null || typeof ue == "string")
        return;
      var Re;
      if (typeof ue == "function")
        Re = ue.propTypes;
      else if (typeof ue == "object" && (ue.$$typeof === d || // Note: Memo only checks outer props here.
      // Inner props are checked in the reconciler.
      ue.$$typeof === N))
        Re = ue.propTypes;
      else
        return;
      if (Re) {
        var Ie = z(ue);
        rr(Re, B.props, "prop", Ie, B);
      } else if (ue.PropTypes !== void 0 && !yt) {
        yt = !0;
        var je = z(ue);
        g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", je || "Unknown");
      }
      typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function ai(B) {
    {
      for (var ue = Object.keys(B.props), Re = 0; Re < ue.length; Re++) {
        var Ie = ue[Re];
        if (Ie !== "children" && Ie !== "key") {
          Lt(B), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ie), Lt(null);
          break;
        }
      }
      B.ref !== null && (Lt(B), g("Invalid attribute `ref` supplied to `React.Fragment`."), Lt(null));
    }
  }
  function Da(B, ue, Re, Ie, je, nt) {
    {
      var Ve = _(B);
      if (!Ve) {
        var ge = "";
        (B === void 0 || typeof B == "object" && B !== null && Object.keys(B).length === 0) && (ge += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var rn = zi(je);
        rn ? ge += rn : ge += Wr();
        var gt;
        B === null ? gt = "null" : yr(B) ? gt = "array" : B !== void 0 && B.$$typeof === a ? (gt = "<" + (z(B.type) || "Unknown") + " />", ge = " Did you accidentally export a JSX literal instead of a component?") : gt = typeof B, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", gt, ge);
      }
      var Dt = ar(B, ue, Re, je, nt);
      if (Dt == null)
        return Dt;
      if (Ve) {
        var Hn = ue.children;
        if (Hn !== void 0)
          if (Ie)
            if (yr(Hn)) {
              for (var Ea = 0; Ea < Hn.length; Ea++)
                qi(Hn[Ea], B);
              Object.freeze && Object.freeze(Hn);
            } else
              g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          else
            qi(Hn, B);
      }
      return B === o ? ai(Dt) : ga(Dt), Dt;
    }
  }
  function la(B, ue, Re) {
    return Da(B, ue, Re, !0);
  }
  function kr(B, ue, Re) {
    return Da(B, ue, Re, !1);
  }
  var ua = kr, Qi = la;
  Bf.Fragment = o, Bf.jsx = ua, Bf.jsxs = Qi;
})();
Zm.exports = Bf;
var p = Zm.exports;
const bU = `@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,d09GRgABAAAAAC1kAA8AAAAATSwAAQABAAAAAAAAAAAAAAAAAAAAAAAAAABHREVGAAABWAAAAEMAAABiBK0EGUdQT1MAAAGcAAADFwAACCDOxdmBR1NVQgAABLQAAAB/AAAAtISHkQFPUy8yAAAFNAAAAEsAAABgZuGc5lNUQVQAAAWAAAAAPAAAAEjneMwnY21hcAAABbwAAAEiAAABmEuFf1xnYXNwAAAG4AAAAAgAAAAIAAAAEGdseWYAAAboAAAg/AAAOEx6ykhFaGVhZAAAJ+QAAAA2AAAANhJhHcRoaGVhAAAoHAAAAB8AAAAkB+YDtmhtdHgAACg8AAACCAAAA4QZ4iYZbG9jYQAAKkQAAAG6AAABxMW71OJtYXhwAAAsAAAAABwAAAAgAPIA225hbWUAACwcAAABNAAAAn4+FV8FcG9zdAAALVAAAAATAAAAIP+fADJ42iTBsQ1AAAAAwX+lwiwSjQW0KjuYxQxqjSl94g4ZmPjtDIzMlaWyVrbKUTkrV+WuPJW39hsz0BwBGAbyGQCIhQjHAHjaYmBkYGDgYpBjUGNgdnHzCWFQSK4symFQyEksyWNQYGDMTi3KA7BODry1AFEQPs8veEb5l4ugtm0zqG3btjmd7N3L3bqTfHtyZi35yVbf5bdQqv17+cr4UwRw5J/85aPIp9jP1RIsfkLhWqxCBql2ZSM6nltanpJbsquyC3Kiayaw4NVyWgyxBX1jHcxBB6tYwRrjAC1mZEUeEA5VuWj417jyys/JJYkjhc4WaMWFUPY92mWeC3ZwgQPGcJKunBNSj11nvbHeOVJAJlTWh13lP6zvpoUbHKpy2XcfWH7wzLRw6RzH1spx8tgW0fd9IRTK9LoprGLXeiJXYkr31/0OPM8SMyq2oJ5liXYP0IxZsQj7+hTDSabLbcM+yysc4sDrhLbFEA7Ijm21OMAFjhgjFXpfaH3ofjCuz+VRYe+BuhXz7aFF7DJ/z4mOYaTI5baDPhowgHTtbJNMzOhzdgnR4Eli1jr2kY6hJN9j7GN5MyGZVPl4Y1hFg0fepXbT7NUmD40eu9/1XTVmHeehX1gv9u46ogfkMAMoisLnZ2wne6ht29aowxprqG1j0MZ2MoitLeXOnW8D757nqwN2spI1rGcDG9nEFrayk90c5ginOcNZznGBi1zlGje5xT3u84CHPOYZL3nFa97wjvd84DNf+c4PfvKX/9RRTwONtNBGOx100kMvffQzyDAjTDHNDIssEbLSilkjpayXbDZIzEbJZpOEbJGQrZLHTgnYLeUcljyOSOiL8zkrhZyTiAsSclFib4i4KRG3pJp7EnOfhwQ8lhKeSRYvJYdXkvJacngjubyTXN5LGZ8l4atk8VMq+CuVXl5AgxTRKBm0SOoGGfTQRybDUsWI1DAlCdOSMiMJi1LIkhQRsspd8lwkwxXyXSF2hdAVCtnLPhK3iDkpiVvkukXs/RneH3JdElcIXaGMuxK7RYZbhK6Qw3NeELhCpv8ceH+Bvx14f+T9Of576gpFrlDMf0ndIsstIlfIpI12AreI3CKbfkkZYJDAXUrdpZxJCVwncp1M14mYk8CNStwoaxnfKq6YAHjaTcexCkFhAEDh7/+xeAbJJOlOyCQKyWDDA8h6A1k8grJ6JXgq3JtkOOd0BJRVJQrjyWyhsT4dUkm6Om70xHS7zi5zS9T8uAPicD6t6Y6my5o+IAj8Uf824fUid/g1iKqK9g4enqKKko2tnZu7oKhr4OIqKGnnd3Z9A5ijG4cAeNpjYGEyY5zAwMrAwNTFFMHAwOANoRnjGIwYzRlQABOEgAI/fz9XhgMsSQpbmNf8F2NgYGlieKXAwDgdrIid6RiQUmBgBgDvBwvBAHjaDcexEUBAFAXAfd8FcleCxkSYEd6MNhSkODZbEbNCV1jVvR8jOMd2ZRFNN6HS8lAvJvnfQfgA0okFUHjaZIlDogJQFIa/+zr32batsKPMScY0GwvJC2oledjBT2ANMACnM1QLFpUBLjnEwKbYxS9RqUtHJvpE3+kvbXwcTiYgNvFJSErSkr4+1Nf6Vf8vm9UZ3aK45JpbnvnFpVDraledA2Aki4kcZvJYKPBKisC0IHgwCgAAAAD4e9QW2bZtu65Bsm3btg9xpf696vYmSI9gvUL0CdUvzIBwgyIMiTQsyohPX6KNiTUuzoR4kxJMSTTt248kM5LNSjEnzYJ0izJkWpZlRbZVOdbkWpdnQ75NSwpsKbTt158iO4rtKrGn1L4yB8odqnCk0rEqJ6qdqnGm1rk6F+pdanCl0bUmN5rdanGn1b02D9o96vCk07MuL2KMSjUv0IcA7/9HhFNcAAAAAQAB//8AD3jalXsFYBtH9vfOiIyyZEmWLNuyBZZsi7UiCw2SbMsUM4WcpIGe27qUxkm5vXPKB6Vj5rtiUuY2KTPD1ysflBm9+t7OrteSi/+4lrKTmTfvzXvv92CnlIjyURR24YNUGaWktBTVqDYbTdaA0k8bfRoJUvrNIqRUV9HYZWTaFKUq9GQlswVtr6hhLiwpr6srK8cXajV1S7dgV+XSr3Bk6dmSUiAI1Ch8EVCVUSUUhWhkthllZiQSoUAU2bJrmVtnetHj5/0IH1yKPP880qANzG8pnHuNokQ/hVUVVCWsMmrIjxJ+A+xqpQhdil5kdqJR5h/oJ0wzs3ROH3ryeXwwkUsw7yeATi0aZ/5GIaol9xk+D99DWShK5U9g2lellbmw2STHGrUBHoPBkFYOzy7c4hw/cc2GxYaQNjNoa9vUaWrqnm1tGu2pilStPTLYs3vKg7a3n7AtPpEyuUM6emxHMDo34q2NuAyBrDW54zSK7NZHdot+w25SqUwqq9JWadRSs8lqC1VVwXjAb7PCzzdzEbZYKst0Ybc+VqfRNOpMlkpFTXs4/k2Mqcok5fJqW5NTLreVlFXr9SqlQlRXz3E7BZoJwhmDmhrJ4XK/OMiY0WPMUWiG+WMiwZ4pFWXe5efbYX4xRdHC7Cn0CHMMGmCugInM5xHm6mXKZ3CUkdKsNMIvDZ/4jDQzk8mgP7LKRn3MPnyQuQPF+BXUr2GFCGjD3KkMO4UbF6mJTVJGJTIjlhJCtBI/wOQcDJPpBovRduEOJoluXboJ6OnRa7CQwqCLz/Ed+F5KRdkoSgIKDhCNGEAVcoyIOhIwxqkHHde7e9Ljm9nd1bt7wuOb3s1cYc3MRuKzaYu1a2MkNptulMS2nZLqOuWQaGL7yZ3wHUHbI98b8dJjh4Yih456fGOH5u+qpwKrd2X1rjXb4MvmCwVDNlobDARB84KBrObCifFIOlBninfFvVr1VDqCzAI3wJ0kvjWfIZ8Ib05qFXVJfZni0BRCLcAX4Y/7Bt7qwBeuBt4aqOZl3oIho0tkNoFN2lYOx8baqRHYOaxrYR2cNu6VOLqmaM9Eh7xDN3VUPLVr2k/PHJdOz2fES19Iuo+Whjadki2plLRu6m4yJ5sN9ICzdfPpfb2nzoaS6eP6+3alQZNKOJ4hggMUMivhJ2DEQ0uZJdyG9y7twnsTFGK1LC6FOTAX0doQLVKxgCESmeFLhbZ0bDmk8/i9CCzn0cQFF8aZx3oRXsS3fvEF8zBzMz52KcKCBxjOWaidtSkF7LgHqBVRVA2mWdNB6/7zvz7mzQzzFljKqehEpoP5BJWgG1jNGXMfofdwJVhLmKJC/mCQ9d6A32o2weGQJ41GXaXVSKU2q9Vmk7Lea20EBQas7ByNmjiyMby53TrcMJBuGXLo6U30xvmy8lKFuFqPkHk+4htyonWlZaaexp5pQ8TmHbvQ22UrK3N0DNQbPGbz4bPvystREGGEDEqr02vvEcv1JX3l8oivjjZawRVYLkU/AC5DVA81TFFa4CHA8wpKs3Lc8o/wyaKMxsjaOo9zVhvRb4idaxMYb3RhYgT3ewecoU1t5rQBy4qKe2O2UYdu2/r2tdqG7cm+YzsRE5WEJkH3ypiiY4pOzZs1fZO6wLRWgYtLUV1bQ/e0MYzPEgfGgv5xv6jE3uNyZ5pKi1VNykC8weBMhbzu1uxCr6RCHJ6g/S2Kxpgx6W/26fxNRmWlOqAtKYl5GwKGd1onfb7JVlaHttxHWALyNggWS4STEdaXD53IhpytG7psHTv7e+ZrOqoGPf5xGpgwJd1FnfL2iRJ736ZQdnd3Z6umyRlcH4tubNU169SNUSO3Sx/ZJQS7rMbkr950NZQjoz5Wq9ZYdUZLZbnW73R/LSv26pqKUm1on4DIFXKk0XwNd4oScVkZi99goeQsnMBlLdVYcBqwv1q2omSRkdMmcoQ3ZmydO3v7j+5ATIckMOajZyqjoLn30SmgI5oeDZTYezeFe3b3ZBe6i/KUgmyt417vBIsZsKdlZU8wGoIZmNiZgGxSATJMvTs7Efy5URwc9fmnVOx2dOuGjK3jmD7/kF/EnCoOjpf07OmRyiXhCZ+/WWGNmOy9m4GJbj89GQbNgz56QVyEn6GqAPXNSr+VGCcJIsEg2RKjVCJi7W0tS6Xqj0g6k7ZKZJ6csnXamVvxM8y1kXRDfIimOErUebh4Oa70pnDx0sf8WTpALhVl/nJ0EPEaDvg5jaPm8Ia01ZrZEA6vz1it6Q0f0eN+P/ffmB/OcDYYnu21w3c4CN+oLLIhFJ5tjWwMRzbAXk05OzaQvaz5ewG60CATd3YBl4hEAdgZqQMTCZO1c8Yf31YXT/Vvae6kK0UmX6TWnvbXekdLHH2zgRDsk/RsXTKh9p0xY9j02xqvTWOJ9dnCG4nfVABYGHAxh6QiFkJFtIqNOSFapsXPdr4QPWwu+kLHTRsn4x2dsYmN7LEgEbOEi5n460/+9a9Pvs5SseYW8GOAoBo2+hplcpE5AEEzFDIqaY05gFuZ58WShshoxBZrqRZL0V/GE3jvhT+57Qh3omnL5XvvWNp1YJFCuT/nXPh0oFK7nA2AxeTlPiGAUC49OD3DzJjTQXVLlUpRV97UXCRLC7nCe8nken9RcVQqbbFZaSveSzKHXG45v8RS4JfPJNAbsJtkOUuZggzxSshOlnbBbJLzkNkSMlsP53QTJyGbV6hYI4FPBFGHBCmRHqmZpeE3ZtMb3xxmvkDqoS82pTd/gQ5HkywD5PcvzI9RlrmK/QWKztzH6EP8IOUsxBKwJHMgz6hkNgGgZeRTikp7jjEGq8fDfVONKU8q3RhuMCdb6AEtXb+tOz4TCPiS6diO4mTY6PAMdrS0W8LmiMUWMbmaTaGEeyQcnKhSbmpPTHlYudaBnD9fztVoJaJJ9Euja9rTTD8c6c/w1qUInln6Yy7HzRXNYytloiiIz09T18M3ptbl5vCronmqnKoTqNAycwgoqVgkoDn10XJMCGd74nSM6X/GmzKhEG4O+ltQCJk6+M12PXI+u50I19EGfYutzkDXcRaWwyeSiL/awr5sXYW2FQHO+ewQS1k5ee2eQZ5l5JnPxuC5ZNk28JFcDgK2QWxxCusyzDGskeG9xEL4PAXWlJM1VI7BR5BKhNIGWHlDbDJCIzDhPzu1Wnk983A/wk/2ME+qW6w4qte3Yx3jRg8vfb/Zwq5PA70WWK9mJSQhOBCgNWpydOyZvlYVSdl2zqeGZujZuhTylVSWbpt/5bmRvioFGoNUVkS4/ozkwFqqhtMEbzlSs00wKTMiefO+/q20b0vvtZdFu42G7uSluCoNuc4bwU3t0S2RqLOnqaXbwZyBDyxFgTcPZIS/hXqlmcf2EF+kAJYHjFYbgXliqULePBA7Ykof1XWP2yObsyoFZi5HA2K5KrUpYR9KaSONi5uHTppweadPkNqyfoMjWucZDTrckeZm36BHH3aaUxPxbSd2pE/bFmctTAYf0+Rs6qFiCtBwMAAsGkE6s1K1Ip/s6PQdd+wb2ErTW3qZ9OWRbmNdd9uluCV0yCGhXZx8uIVRciICYeLb1wP1ckpJvNu44tUqo8pIPFt0Eji1ZvCLzenNny8h2X1Ls2gOTTN/Ys5H3cw15HcRKQttaS2xC7AO/DhQl4NeAThUcEi0hnVsqGyZp3qYx6tCweYGo0nxPhjX+RiHfTGTZekGWIlgeY7wBTJzGAUrWQf9HgtVBw5kUMyLphLMq14CcmC3uTNwF6wwsHpagRR2N1gGBEhcJHnI4S32CoVR0TUyNe6acmVYgq5N7iN3HXtcaUQsWT87u02vZ/7DFmsPVOv27jnpeIKCuQXR/UBfD/QD5gB/SOZ8QFTRGtG57rdY8BsqgMRXE4uLlSjM4d8qXHzoAEUQ8ViCiD7Wg6y274yJpGLSvNPqjnwrLAZs3rNOF+vrvw0bdZXi08l5LpDKQEHkJeIKUuI4zRyWyXzvgyHmw9f7FhdZsfBBQSAeRQ4lVkt8kVitCmoVIARR0aycSq+11D6RffXDgRcMlrWw9tYTTkBJEib6FxeZK9kzqRRo5Nv9SuCpHE5PTc2xPKCaMebwNE45x8ac161EG5wCKiKgciexQaBizA9cIiSa+2AN8xG/+syCSIXP5M/gbQ7XEAnn+XX61sRhQqUOQbywVgdrFEtgpZFDUUFn5tWmyeGrGOyvb1vw2C0tdmWFsaJ7eHLCOe3KMHuB4g+rdfFjhk86vsA2AYdhl1Hg7zaCemQXwmEA/jKKdeOJdczRHGcJnIXZmPLnPhY3A5IFqQx0M7j0Aj75ZCskI6kVwVw+beYTVxk32Aj/qE3g5YRP3BzY0+VZ1+ha6xr/yeFx1/CRHeXt21rHf75N26wODTmGzlvfdfSwI3z4cKWpontH89Jf/RvbBk/u75zv7J1PrnX5K+QKhX/zudOp3RuCKCHq2TOw5ceDUknd+j1dsxeN+aZ3dXWfvMmART7jp/0njFaWDZ46NrMrmtlNekjHkh6SjbVNlyjw9V0rmQatTc0PO762ZaQe3Ow76wfSzm3Ht391g8iTbpIusrU5nPUQ368x88bA1efbE/NchX7VgUWo0XO55aoaS8FyiCXD2guJHRFf4lCDd6VJ9wsvDCIZ8+7gf/4zwLz71AC4k515HK1H25l7ASYvZl4gCJEGGj8DGrqvjJGEoVVxcj6xOlKCMeRFWwNLidRnsNZq4+hp2ZRbEwwJgdekN1i2+cOpJlPa4nZ6ufArFaOdO8UemiVtbZAs7kUlpVwo5n0/wfutkmhGAxsI9v5LbWvatvOITmByY30KDPyBUqXAJPN3WMh73kWctAINVsQv05lKrltF6U8HFvNoYUqb+1zUiu+jvFSE7TmSopQIGgyt9J2MBpHQ6WTDPPlBbGiHSk5bqXJVlFVrzGJ19cyudGb3Wj/CS/u5ls9kh7xdO31ULH3cjF4tjpgd6OHUkSkJFom7j0bXa7w1ClVjRT2oLOJvnw3lt4Hamgy+QWgDdfijkmoDKub7QJjS5RYIx2GqnbWYELDCcxT4LuybNSqecfQHqak+Nq1XSyJme6XKKS/TgRCaauhMcX0rTggfCMH1rURiaWo+LcFiaFmBIcoq6njuQt8uyKkiNSdBLsf1KokHFJEsk9QQogVspRpI/vwUilI3gp5Hcg6cATVZ8isBruHHRxyfTwuBg0MidKqqWV2pqC23+Gubu9b7J9LprpLKoveGcpm5hHvoMVlRTCpxDIWjc8MePiKhOLO/avu5a3oOi3O59By+66urNcjav5xPswl7YU4NSTqxTxfp3taReq2wWAuCI+XFiVJzJqBp1kK5Jre1yMvyurtCtdZPW5FcCB9AHbh8WYg7wFh+3JkGlvoEKsBOQeQhONHCeY7EDGHzy1BhRrclNxcgxfbFAx+szqkJF6J1JAMo6CsThgp7yz3A0qr+MvAlVJ5E73Wc3qnfUjcK4xcI4w9Tl1A3LdeeouNgvJ6f/2vqehjn+7JYyq5cfibrR/n195H1xM7IeAM3jrrJOKk4ybiRn38MdRNXieIikBF2Q8SVChXpZ7MvNtHXyFB558ZYbWIu03+8KahfHw322zeuTz/KXI8ufA79wxLrb05vCbaFjHZvU483MxV+LhF6mRIqx9OEyvFJ6mrqRmH8AmH8YZD1puUcWvRjGG/ixx+DWlOU16tvoJxf0a2v0gqFiU0oS6SyvH75wiTXtRcpVJnZKHTIKytECAoTrl1eKRd/uX0/6nYE2f54wOEINFkDbAs/0Ggt4HLtCpcwTqolIpWLHz9ApCIVIjkFO38KC+QUyDiZb+fn/yxv/sXC+BPUpWScxC4y38HP/xXRI8QL9EbeexcSD0lX46gkJPJsaOat6zOy2slbh5Ssrsy5sZLzZq2gfRLfBWIamrWNc1QtWoWyvtzvO3xuDqhfceDAdmvmYVlRXCrtS6+UJMn2dT5C14FP4msSQpc3KptNSAG0fGNjv8peVVlXa/Aaak3nvbwGlTJvrfnfK4PMh79pNnr6AdniZbW02ZBtuYV5CG1Gm+HTw/zyCf9Mo7/fwWfLZC8lyZZFLHER8K1i0w3VxQs5Nr3ILez6aADSjY9QlxMNk/TiEidzLck3uoBGM3jJu0JfhgQb+PyK1i6t4f9K+qnAvip1aCwT97cGNya6t9XTVQN+R6fFFLOmU560ZbI/PF4dbNhZ7JlKtG9SVk0EwyPuRMjU7DJFbJaIOWxpb+kY9DiM4SSH0S7S7zABF/kdsEK81pBje0HdwiOrrGg1dpszjwjNMDxfgOEJFnsLK9ZSgiv82xV4lpP+Dnuqw9+1+q7cmP7d7/azzYVDsrn05dHuhrru5GVcWfJjvvpOLX28Un2PwEcfUK+kTMRuiS+zr8BkNpY0BL+QLQRxnqc/gqyu/nCDvsqStLQ3uv79ik6TtnRry5W29qb/hw9a2webI7Sjbk3daCXzGUoVTdau1Rga7Y6snbd9O5FMSiTlK054DpJnPqeG5yTFVaR9pCJN/x97dF/35tb0nXp3AYNFUa4NeVbeFMh1om/v5+nkq9/hVlQQmfp4mcRERv79FTwriIxZ+DgFFy/3Qc3KLAq9j4vjDLEN8i6BzFaT2VaKgmqwmPRBVdAmJsYAvWKV2UaKWpn19sv6f5nKZH42cPmBwX9mMqlLUNnSi/BnifngDfgDNKpzn0HYVlL2AqQBRBAO9Sv7ni91b60Jq7rpeE+EDrRWWdShgCNa6dfOxH29dkuDi/ZNSkO+arMt7Lb7kVvXVG3zmE21Lr8xbm9MKuQZtztl4SWGeFdc2PPMplA8nmLuwkXMKPonNLn/yMzkcvzcGwAtd4H8Uuop+MJUFnKTYXwDdGZqvqLjGaA5TKDVUkI12802PO/6VarH63K57CJvD7cJQz90PrsN7m3zGpqsDd42ipzOEnqL68hrl/0cUBjcvrqmxagWSdFw6hEs1rtTokRdZs+GHwGv903P/WhUkO0oWE2qYRb/YC309JXZzIMPdbbf4LgJGvc/Rdtgze+Z61CGWcdbwBewppSs0RgDsAiiPfDekkoxT+DiF15Y+viNN3hrcBBr0Am28yaszOuTZtHvU8yruJjlivHDHBXMuZefQ+ialfdfh665Dt0XBxsj7yByVlwCM9T59hAKcfAtx6crzZXVpapSvUuj/0/3zZelPlE7fM+UlnikRX5fO5YwcXT70h/dMdInjsDHtUALdjUGpNKCtA/kQsc2ZJrGJ1KtSXOmKvVMRcXkzM9+lGlTlH8Gb3tE5PRmyElUUXruNGjfVzZQs6mdUzNN/ZE9R8FrSQ3tnEdnpHDxNTNZz4AraAzUG+h6OIWipU8Iln+MpbiSe4NkFRKrEJg7SVEKGqdi10RGFdJPuQOjQdH770k8w63uoZpA7aG9ydlOkyW1obgu3FTtcQWm/B73aKDJWxPocPZv9NKzAy4K59jXMa/gZ0B+AzlvAa2/Qo6te/akbr31B9PTtv7oWaeBHFU+5ylY6vrTn1z78wWBQyF+D5rme6Qqm3HF41V0yGi97yr8i6vvG74iloleefX+7zMJ8Hre45H5JqrAdq6gKM4usBsoyoGeqKAv+uID6X+eqQzRjfoGY/mvwWBb0Wa/J1hvZY6iUI6BxecRTigbSGckaQnLCZ4G4Pr5z1PvuF6PX+J65x3WPnPd6DmYaynA7yAL2qTiZ/GOrfOXQxlSQ41nlJuUvW3InGi21tfWp4CoscHiCI95nFPXVChdJUWbRjuHLCVFygcBJW9XFpf5tg4OHJPgovaiqAz2qyY9Dv58zPk4qaU1+EE3wcXBFaT8ac/CAjkqHiof2s8hQR/ByY5CnCRF8HeGTSEUPV0dr1VXNbLhpELf4aa/BUsdNUZluS68L+9CEKqp+RZ4rSwTcyGInP0iQVkl1ytmD0MpnAG6t+XAQCo1cOnAnZd0Lyyg/72Oi//1L05u8la3nOAB8cDVIUbT25my6H7W+887+6/QWcDrXtq69SWwtTd37HgT7ONTIPEceIC6wP6VAoXObDZ1/vltlwzc+cKaA22QmOzY4WRe+xcQeP11iu+V9nB2qSrYWSl6aeCSQVh1cCCFHmr9F7cEPcTLmoE1FQKCktxbQNFsfIjDUYbev0BiYCes8CxjrlHoq3ai37NzAT/ZmQRBiRWLOr/aijkjJr19Qe9SvKfAihvSZkDkFPp944A1z4p3zKTWWFTqp9lNcPFH6irf1oGR3R3g69Hcx6JqrKJ8VEdBj9RqJcWWTLjbIGTGgsGxYyLy70KfVFRtXOdtiOga2owbzxm0JEfcJfbOpuhctlhVkky3HdWbPSy2brpYVezONHwUGnVZs3QYsG2wSasvLS0r6TllmF7X1RwMzoTbdiQQMi70Z49sT86lx063IFSrQad6JsLemQ55WXJDODncRG5pLJJbGibW8r7xLohMAxXt9uhX3sAoC/c5F44s6tuZ+vKFC2PILJlnMSy3SGJbqRDbiCZJfMvGSYSb379AkZl2LIKZRWxU5yKb5r9PdF25r+OJx5+AdCCI7ln65Al2ZhHQ/JBEMIIhNhkAiIjWakMhWsR6zrWWi4uKLu4/eLDvp+T74vaFhXvl8nuRCEnvq6i4j/nsTuJFEaDzqYBFAforoiFQu2GoJD8iti0sxH6VFxXBCvOjah2Jqlyz1LS6WUri6zENJpXGMm63p+p0tKW62qxJP1NRJMbr1zkcLNGGWtGxxyJpEQm4udzyDQ4shYhLfB9014uf4d4wfeWVDvBmLB9adasju7DwFRc7PtwP1lwKcWcPWIOLCn2581l49amw8anl78eUKpXGkpIqVZ2oQp1aS/cd04GYTnFo1OOH+03K9inaP5NWV4g8Bttl6GS4zkJ7xwJoUG3XqZR15bWKctxi9fbYV92csfd6rS0STY2Eu0ADfCpB8lOAT5qKsbJ/U7uz8CYP170WbvMM6XXODMePUmkqJYwrVOkZf9/RLOOS4JiHu97jtNrvB4YDYyzDC8dIyjQ8T85v5l1RgY9AF3J853LLN2dAg1oKnrkKgWTMO7nuFfxQBMUS6B6wISM85DeZhIqKiw/Q6gzRSB1Y47S2O8oNCqWmosXuHfVHUymftEzyxwGkV66Z74jN+KSyaFFPtGNHgo0d6AUuYs7hMFedaPN7mqvyZ5KQF+TQJBXPy6JzcZIRa1fwvKCWW8b1kXaFWaUs05Q4XHye/NHsrLQoKhZne559g6M0tzoyEIaWKRBWuLUsDxAbOM/dB2vY7uWy3xY6rlmDmrvrU5bIoK090mZOaToHF351o1zRPBw97wddHcryd5c+XuB3vxkoKYRqgGy+UhH0s9sLVQE5Bb4uECpFVpNHc7XPBkoYfUoYfXgOCXUiO/dYbu5x7Fz+VhiWgkaEZ7L2b3zn6hQKCTbDju/kx18l46RSJOPHcXtFEIy/mrOQ8zGAlr+6T0mzHiLHd/Xvrg3pJ2ORftv2LaFnmf3oJ88qjtxpSow/1xHTuV32Ae+aSe8b8fgbkmPX+8ZiRkqo+A4KFd+TW4RRwskunsPvU0jIatnxE1fGKZFwbwxuxOXfK16+OAYpWZWPb1NycVwqE26PzXOXxz7E2urx7eN6LTQoNXr2Chm8WvnyJTLst3tCYY+dNjutnnDEbXVQBXxdUcAvqUXI+OnciR4Oo1wFRmQ+hZO5hxJGnxJGHz50Ze6zwugTJ8EoFyHI3FO5uesRlxehU5Yr7eXoyPYXJuO4mIuN/NnOkLWn8bz+nWJXy8ALL4LVqzqS8COk/VxHcoOqWatU1JfT7unpaRR872c/G7Omby8qCkul2ThXDuyLxydcQFMOKPQfoGla1dFx47w4K1tuSMbldXJlibq40WW0thfLftF/9119Py8quqD/lmG7q6XzNpk0KhHHHE199oHS8odQEUJ3yeV3MRvpzR5Pn51Ec/h4lkMkcFwbTx8413KhPRT8/pXdbCDvufKEE/dn2dDes+9N11tsJH/L9SYb2N9k6ZjBE/ZhJeUW7vKGhMyGf+krdCX5v3Gx4b+t07TPVWPT+MZpe8Zf4S1t9Boi3bVOfTJGRyA99Gcrw/odUkvK7W6Xlxtddfa4UWevr9UaFK6muiYV2Gi9o9pmrvaFCMLGSXeibgVhC6GxEGmHOwSALMDbPJxE1xPYzeW4+48ELaoJWvB3E+FZT/qQMIrxd6xtTzv00NTf/75IavSzl2tb9Gjw4YeDp66ubTth3wj4ag0V5KxCyRqq8O6f60UK1/FJL1K4ji/TGDAa6NhmSMUbtkWD052NpgaxpNXUWqFwdLWYykpajRGEdfq6YKZZH6ZNYkWwqyTlg2vozx/ijTv7Zv2hTY0SSaI+WVqkiSmlRUlDAiNDb1NLX8SkbnTpf9MYNZNzX1wd2YgzrY5s8aGCcyZVhBDXcv8E7X3IxTVZnsqEng9IWy4ojG//jNy+rKhPSB/ozdlZrvNT4NlED6xn3wv5cPwG10u5HJeHE31eQPTJ17PwfDZ55m9Tw7Nq+dad6HH+jR/7xmHlhZ8Nn8G+4OP/rxBELmkKb/yiBGn4vmQ5rBUycTYWoC9AhhTIgkJspfPGG2yojXN3GUQ9/G7sTlzJZmQX48in6LDMWGLpnf/hZvZOA/zuIvcauJwfn8NFdBW/0fLaO/ehC3/1caorzhzH5f7ofoYmGLf8/ymBrJjIzt/Ph2clkT0EXb/P8QNUglhgwA+WZg7RQeGrsLwnDXII5VLhK+81RMv3tuqU1VuKTqs1lJTeUfQ/qaTR09ljHzAabGsT22d1asPGolO01UrFgaLXG7W69KBnjdlgXS8aG/Raa3UNLO0Gsbgm2UQH1JU+TfVQ1tfYoG9QVpSWNtTUN7SEwpBIVLHOSMXxAirDT0K8k/HVMvzGIzMRvLAe/sAMO55DRvwMP8MWorXwu6axta3F2tqG55TrDleuY+UP4ovQBGhDxNKBYhYWXeR2c8jXRy2BhahWd4tDBKQvqI7zXXKLqc7mWWlY2FQqHc22InI5gYaUeoycPs8VPD9Cnvnd4flRog0L7kVJ0t+lCvu5V6SyPqeb7eFmC7u2dhFGk6J5YhWFd15v83aawPaW77m2r77ZKs/Fqf9Azl9RIF+ADWyjK74oeKE9TvyPys1R58IqCaxiG4myYjp2bvf558ceYmlW5VyoGGxJmU+TJyr93sqL+IzweqiftrIXp3nK51GJAsrn9Zx/fuIRivzrorAvG4g1Q0PnQs24n/u3BeoXsFL4t3XrfrG4mCA3d3zUADWOzmb1GwKPGbdYBlDi/wMPx+eLAAEAAAAEBqjKkfm6Xw889QALA+gAAAAA09xeIwAAAADbK3R2/x3/IQUaBH8AAAAGAAIAAAAAAAB42mNgZGBgXvNfjIGB1fy/7L92VimgCCp4CAB6agWkAHjaRZMDrJ1BEIXPztzatm3btm3bjduotm0bMWvbtm27/zs7uUjyrTI6uzvSE6VlI5LqoeC57EZhoxc6STPyGJ3wE510GNcfeP6OPEI26Y1UofRIKjOQUnIhl25ELsmHAkYTD20aoAluo4m04X4QCmoxpJAbyC83gi0+n4TQyefRW8jMGMXkJ7pF8HaW83E472nOzCkDAZmIetqG+zMoKROQQK/R/wdtbiGZZICTMYx5NRxzPO2GkElILSehmhGdQhW5v4i2oTYoa1oZ13QcoM0R1GN8QhuifZCBZMTPcJ190MY0PAjXRlurk3oM6rH7IVFdZWPaTMuPMKzf9ISxvLwT05abtcwh80h8FLKcvHu787E8G4g29j6Mbxpicy63CI39G2g65HdnkUlacx+hEvf7ODcg/l0qorG7hzSSHSmYu7Js5nkx5tLgjabh3Jo2hZDGbQz+u29orNnDMTPRLjeauPvBL6kDld6Ws452pU0ZVPH/wOKmJ6mQUNIydojwTxhLkUTWIJX/H1bnQ1htVhdxASpbndRjRP4UiehyJ4JnYV2mhbNh9VOPEdZld0JtbiUSuI9I7h4joduLPJYz8jdzcd0LdeysYrDLfKjD9HLWd+ikSn2jkUq2IY3vF/v31VEBQDVShJQneVwWUh9F3Ezb5wW4zozk2Ae4KkjvZ+M8mYrScV9loJ142gXBA7TlMBQAwJpJ3abNfWvbtm3btm3btm2bh2sbB2vzGzMMw+RjajJ9mS1MPGuxOdiKbF22F7uV/ckV4qpwvblJ3H2+Lj+BvytoQg2hrzBS2C+8F1Uxv9hO7CYOFceK28T3YrKkSGWlNlIXqY80RJomzZP2STelBLmM3FteJK+Sj8u35BQlvzJCWa6cVJ4pcaqn1lI7qtfUFM3VQKugddWWase153oxfbm+Xt+tv0UCKoaaoJFoNdqODqPz6Dq6i16ijzjCOXARXAFPx4vxerwbH8eX8U38Bn8xiNHAGGQcNT4aP414M5fZwexhDjBHmE/MN+YH87+ZamW2OlsjrSnWIeu29dFKsUWb2LnthvYAe7V92050wMnmVHJaOAuc467rFnYbuYPcOe5W97T702vszfDWeoe8B16Cn9Mv6Lfy9wVyYAYQNAiGBCuDw8Gj4G+QRjTikwwkDylBKpNBZCyZSZaS++Q1+UT+krRQC/0wd1g87BiuDM+GqVH+qHhUPuodnY1eUY56NEaz0/y0Lu1GJ9G1dCvdCyIEkBdKQRvoAn1gCMyFXXAV7sEPSI2hGI3lTAdbCHvEAAB42mNgZGBgeMiQycDOkMfABuYhADMDMwAscQHOeNpEzIEFhVAAheH/vO6LcgWFNEASgABN0RxNExopAWiANEEzhA4BH/iAyEqCQgbsYIua3f5RcNkJI7cd6NTbfxpNdkqr2S4YtLwWRG12+E6VRB12Ra7zaYwcdCQAgiD6/uQQnG3bdpy17f37e2csM5mZruqutDggT4EmJZLESVBhkHlmmfMO8igT9b8nSEar7t8U3xqfJyUTRgV7VP0T5OXL4lGSZCmgyhOUTbJLXC5IUmZaXV40xqTRdTnVmIeo+qjxNd+IzDF5cpiDa4IqolrDf+sRT/9jPipPkpOPmrf6WcWikbPMs8wG19x4j9j4p/1STv3Tdsow+C/uWeQU9OXR+5OzzzzuwFNgnRlPmbBcUlzRnvZ+zC8vG9d/wzGXvBD93t+Z1zziMPc4ZVHuFT7eYlZ42mNgZgCD/3MYjBiwAAAqgwHRAA==) format("woff");unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0100-02AF,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1E00-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Raleway;font-style:normal;font-display:swap;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}
`, oC = "/contextlines";
/**
 * @remix-run/router v1.11.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Jf() {
  return Jf = Object.assign ? Object.assign.bind() : function(n) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var o in s)
        Object.prototype.hasOwnProperty.call(s, o) && (n[o] = s[o]);
    }
    return n;
  }, Jf.apply(this, arguments);
}
var Yi;
(function(n) {
  n.Pop = "POP", n.Push = "PUSH", n.Replace = "REPLACE";
})(Yi || (Yi = {}));
function MU(n) {
  n === void 0 && (n = {});
  let {
    initialEntries: a = ["/"],
    initialIndex: s,
    v5Compat: o = !1
  } = n, c;
  c = a.map((v, M) => S(v, typeof v == "string" ? null : v.state, M === 0 ? "default" : void 0));
  let E = d(s ?? c.length - 1), u = Yi.Pop, R = null;
  function d(v) {
    return Math.min(Math.max(v, 0), c.length - 1);
  }
  function T() {
    return c[E];
  }
  function S(v, M, w) {
    M === void 0 && (M = null);
    let y = UU(c ? T().pathname : "/", v, M, w);
    return Yr(y.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(v)), y;
  }
  function N(v) {
    return typeof v == "string" ? v : zf(v);
  }
  return {
    get index() {
      return E;
    },
    get action() {
      return u;
    },
    get location() {
      return T();
    },
    createHref: N,
    createURL(v) {
      return new URL(N(v), "http://localhost");
    },
    encodeLocation(v) {
      let M = typeof v == "string" ? Hs(v) : v;
      return {
        pathname: M.pathname || "",
        search: M.search || "",
        hash: M.hash || ""
      };
    },
    push(v, M) {
      u = Yi.Push;
      let w = S(v, M);
      E += 1, c.splice(E, c.length, w), o && R && R({
        action: u,
        location: w,
        delta: 1
      });
    },
    replace(v, M) {
      u = Yi.Replace;
      let w = S(v, M);
      c[E] = w, o && R && R({
        action: u,
        location: w,
        delta: 0
      });
    },
    go(v) {
      u = Yi.Pop;
      let M = d(E + v), w = c[M];
      E = M, R && R({
        action: u,
        location: w,
        delta: v
      });
    },
    listen(v) {
      return R = v, () => {
        R = null;
      };
    }
  };
}
function Vt(n, a) {
  if (n === !1 || n === null || typeof n > "u")
    throw new Error(a);
}
function Yr(n, a) {
  if (!n) {
    typeof console < "u" && console.warn(a);
    try {
      throw new Error(a);
    } catch {
    }
  }
}
function PU() {
  return Math.random().toString(36).substr(2, 8);
}
function UU(n, a, s, o) {
  return s === void 0 && (s = null), Jf({
    pathname: typeof n == "string" ? n : n.pathname,
    search: "",
    hash: ""
  }, typeof a == "string" ? Hs(a) : a, {
    state: s,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: a && a.key || o || PU()
  });
}
function zf(n) {
  let {
    pathname: a = "/",
    search: s = "",
    hash: o = ""
  } = n;
  return s && s !== "?" && (a += s.charAt(0) === "?" ? s : "?" + s), o && o !== "#" && (a += o.charAt(0) === "#" ? o : "#" + o), a;
}
function Hs(n) {
  let a = {};
  if (n) {
    let s = n.indexOf("#");
    s >= 0 && (a.hash = n.substr(s), n = n.substr(0, s));
    let o = n.indexOf("?");
    o >= 0 && (a.search = n.substr(o), n = n.substr(0, o)), n && (a.pathname = n);
  }
  return a;
}
var lC;
(function(n) {
  n.data = "data", n.deferred = "deferred", n.redirect = "redirect", n.error = "error";
})(lC || (lC = {}));
function xU(n, a, s) {
  s === void 0 && (s = "/");
  let o = typeof a == "string" ? Hs(a) : a, c = Us(o.pathname || "/", s);
  if (c == null)
    return null;
  let E = $m(n);
  wU(E);
  let u = null;
  for (let R = 0; u == null && R < E.length; ++R)
    u = XU(
      E[R],
      // Incoming pathnames are generally encoded from either window.location
      // or from router.navigate, but we want to match against the unencoded
      // paths in the route definitions.  Memory router locations won't be
      // encoded here but there also shouldn't be anything to decode so this
      // should be a safe operation.  This avoids needing matchRoutes to be
      // history-aware.
      KU(c)
    );
  return u;
}
function $m(n, a, s, o) {
  a === void 0 && (a = []), s === void 0 && (s = []), o === void 0 && (o = "");
  let c = (E, u, R) => {
    let d = {
      relativePath: R === void 0 ? E.path || "" : R,
      caseSensitive: E.caseSensitive === !0,
      childrenIndex: u,
      route: E
    };
    d.relativePath.startsWith("/") && (Vt(d.relativePath.startsWith(o), 'Absolute route path "' + d.relativePath + '" nested under path ' + ('"' + o + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes."), d.relativePath = d.relativePath.slice(o.length));
    let T = ni([o, d.relativePath]), S = s.concat(d);
    E.children && E.children.length > 0 && (Vt(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      E.index !== !0,
      "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + T + '".')
    ), $m(E.children, a, S, T)), !(E.path == null && !E.index) && a.push({
      path: T,
      score: WU(T, E.index),
      routesMeta: S
    });
  };
  return n.forEach((E, u) => {
    var R;
    if (E.path === "" || !((R = E.path) != null && R.includes("?")))
      c(E, u);
    else
      for (let d of ev(E.path))
        c(E, u, d);
  }), a;
}
function ev(n) {
  let a = n.split("/");
  if (a.length === 0)
    return [];
  let [s, ...o] = a, c = s.endsWith("?"), E = s.replace(/\?$/, "");
  if (o.length === 0)
    return c ? [E, ""] : [E];
  let u = ev(o.join("/")), R = [];
  return R.push(...u.map((d) => d === "" ? E : [E, d].join("/"))), c && R.push(...u), R.map((d) => n.startsWith("/") && d === "" ? "/" : d);
}
function wU(n) {
  n.sort((a, s) => a.score !== s.score ? s.score - a.score : kU(a.routesMeta.map((o) => o.childrenIndex), s.routesMeta.map((o) => o.childrenIndex)));
}
const GU = /^:\w+$/, HU = 3, BU = 2, FU = 1, YU = 10, VU = -2, uC = (n) => n === "*";
function WU(n, a) {
  let s = n.split("/"), o = s.length;
  return s.some(uC) && (o += VU), a && (o += BU), s.filter((c) => !uC(c)).reduce((c, E) => c + (GU.test(E) ? HU : E === "" ? FU : YU), o);
}
function kU(n, a) {
  return n.length === a.length && n.slice(0, -1).every((o, c) => o === a[c]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    n[n.length - 1] - a[a.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function XU(n, a) {
  let {
    routesMeta: s
  } = n, o = {}, c = "/", E = [];
  for (let u = 0; u < s.length; ++u) {
    let R = s[u], d = u === s.length - 1, T = c === "/" ? a : a.slice(c.length) || "/", S = cS({
      path: R.relativePath,
      caseSensitive: R.caseSensitive,
      end: d
    }, T);
    if (!S)
      return null;
    Object.assign(o, S.params);
    let N = R.route;
    E.push({
      // TODO: Can this as be avoided?
      params: o,
      pathname: ni([c, S.pathname]),
      pathnameBase: qU(ni([c, S.pathnameBase])),
      route: N
    }), S.pathnameBase !== "/" && (c = ni([c, S.pathnameBase]));
  }
  return E;
}
function cS(n, a) {
  typeof n == "string" && (n = {
    path: n,
    caseSensitive: !1,
    end: !0
  });
  let [s, o] = jU(n.path, n.caseSensitive, n.end), c = a.match(s);
  if (!c)
    return null;
  let E = c[0], u = E.replace(/(.)\/+$/, "$1"), R = c.slice(1);
  return {
    params: o.reduce((T, S, N) => {
      let {
        paramName: m,
        isOptional: v
      } = S;
      if (m === "*") {
        let w = R[N] || "";
        u = E.slice(0, E.length - w.length).replace(/(.)\/+$/, "$1");
      }
      const M = R[N];
      return v && !M ? T[m] = void 0 : T[m] = JU(M || "", m), T;
    }, {}),
    pathname: E,
    pathnameBase: u,
    pattern: n
  };
}
function jU(n, a, s) {
  a === void 0 && (a = !1), s === void 0 && (s = !0), Yr(n === "*" || !n.endsWith("*") || n.endsWith("/*"), 'Route path "' + n + '" will be treated as if it were ' + ('"' + n.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + n.replace(/\*$/, "/*") + '".'));
  let o = [], c = "^" + n.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:(\w+)(\?)?/g, (u, R, d) => (o.push({
    paramName: R,
    isOptional: d != null
  }), d ? "/?([^\\/]+)?" : "/([^\\/]+)"));
  return n.endsWith("*") ? (o.push({
    paramName: "*"
  }), c += n === "*" || n === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : s ? c += "\\/*$" : n !== "" && n !== "/" && (c += "(?:(?=\\/|$))"), [new RegExp(c, a ? void 0 : "i"), o];
}
function KU(n) {
  try {
    return decodeURI(n);
  } catch (a) {
    return Yr(!1, 'The URL path "' + n + '" could not be decoded because it is is a malformed URL segment. This is probably due to a bad percent ' + ("encoding (" + a + ").")), n;
  }
}
function JU(n, a) {
  try {
    return decodeURIComponent(n);
  } catch (s) {
    return Yr(!1, 'The value for the URL param "' + a + '" will not be decoded because' + (' the string "' + n + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + s + ").")), n;
  }
}
function Us(n, a) {
  if (a === "/")
    return n;
  if (!n.toLowerCase().startsWith(a.toLowerCase()))
    return null;
  let s = a.endsWith("/") ? a.length - 1 : a.length, o = n.charAt(s);
  return o && o !== "/" ? null : n.slice(s) || "/";
}
function zU(n, a) {
  a === void 0 && (a = "/");
  let {
    pathname: s,
    search: o = "",
    hash: c = ""
  } = typeof n == "string" ? Hs(n) : n;
  return {
    pathname: s ? s.startsWith("/") ? s : ZU(s, a) : a,
    search: QU(o),
    hash: $U(c)
  };
}
function ZU(n, a) {
  let s = a.replace(/\/+$/, "").split("/");
  return n.split("/").forEach((c) => {
    c === ".." ? s.length > 1 && s.pop() : c !== "." && s.push(c);
  }), s.length > 1 ? s.join("/") : "/";
}
function Pp(n, a, s, o) {
  return "Cannot include a '" + n + "' character in a manually specified " + ("`to." + a + "` field [" + JSON.stringify(o) + "].  Please separate it out to the ") + ("`to." + s + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function tv(n) {
  return n.filter((a, s) => s === 0 || a.route.path && a.route.path.length > 0);
}
function nv(n, a, s, o) {
  o === void 0 && (o = !1);
  let c;
  typeof n == "string" ? c = Hs(n) : (c = Jf({}, n), Vt(!c.pathname || !c.pathname.includes("?"), Pp("?", "pathname", "search", c)), Vt(!c.pathname || !c.pathname.includes("#"), Pp("#", "pathname", "hash", c)), Vt(!c.search || !c.search.includes("#"), Pp("#", "search", "hash", c)));
  let E = n === "" || c.pathname === "", u = E ? "/" : c.pathname, R;
  if (o || u == null)
    R = s;
  else {
    let N = a.length - 1;
    if (u.startsWith("..")) {
      let m = u.split("/");
      for (; m[0] === ".."; )
        m.shift(), N -= 1;
      c.pathname = m.join("/");
    }
    R = N >= 0 ? a[N] : "/";
  }
  let d = zU(c, R), T = u && u !== "/" && u.endsWith("/"), S = (E || u === ".") && s.endsWith("/");
  return !d.pathname.endsWith("/") && (T || S) && (d.pathname += "/"), d;
}
const ni = (n) => n.join("/").replace(/\/\/+/g, "/"), qU = (n) => n.replace(/\/+$/, "").replace(/^\/*/, "/"), QU = (n) => !n || n === "?" ? "" : n.startsWith("?") ? n : "?" + n, $U = (n) => !n || n === "#" ? "" : n.startsWith("#") ? n : "#" + n;
function ex(n) {
  return n != null && typeof n.status == "number" && typeof n.statusText == "string" && typeof n.internal == "boolean" && "data" in n;
}
const rv = ["post", "put", "patch", "delete"];
new Set(rv);
const tx = ["get", ...rv];
new Set(tx);
/**
 * React Router v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Zf() {
  return Zf = Object.assign ? Object.assign.bind() : function(n) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var o in s)
        Object.prototype.hasOwnProperty.call(s, o) && (n[o] = s[o]);
    }
    return n;
  }, Zf.apply(this, arguments);
}
const tE = /* @__PURE__ */ x.createContext(null);
tE.displayName = "DataRouter";
const CS = /* @__PURE__ */ x.createContext(null);
CS.displayName = "DataRouterState";
const nx = /* @__PURE__ */ x.createContext(null);
nx.displayName = "Await";
const va = /* @__PURE__ */ x.createContext(null);
va.displayName = "Navigation";
const nE = /* @__PURE__ */ x.createContext(null);
nE.displayName = "Location";
const sa = /* @__PURE__ */ x.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
sa.displayName = "Route";
const mS = /* @__PURE__ */ x.createContext(null);
mS.displayName = "RouteError";
function rx(n, a) {
  let {
    relative: s
  } = a === void 0 ? {} : a;
  rE() || Vt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let {
    basename: o,
    navigator: c
  } = x.useContext(va), {
    hash: E,
    pathname: u,
    search: R
  } = aE(n, {
    relative: s
  }), d = u;
  return o !== "/" && (d = u === "/" ? o : ni([o, u])), c.createHref({
    pathname: d,
    search: R,
    hash: E
  });
}
function rE() {
  return x.useContext(nE) != null;
}
function ji() {
  return rE() || Vt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), x.useContext(nE).location;
}
const av = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function iv(n) {
  x.useContext(va).static || x.useLayoutEffect(n);
}
function aT() {
  let {
    isDataRoute: n
  } = x.useContext(sa);
  return n ? hx() : ax();
}
function ax() {
  rE() || Vt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let n = x.useContext(tE), {
    basename: a,
    navigator: s
  } = x.useContext(va), {
    matches: o
  } = x.useContext(sa), {
    pathname: c
  } = ji(), E = JSON.stringify(tv(o).map((d) => d.pathnameBase)), u = x.useRef(!1);
  return iv(() => {
    u.current = !0;
  }), x.useCallback(function(d, T) {
    if (T === void 0 && (T = {}), Yr(u.current, av), !u.current)
      return;
    if (typeof d == "number") {
      s.go(d);
      return;
    }
    let S = nv(d, JSON.parse(E), c, T.relative === "path");
    n == null && a !== "/" && (S.pathname = S.pathname === "/" ? a : ni([a, S.pathname])), (T.replace ? s.replace : s.push)(S, T.state, T);
  }, [a, s, E, c, n]);
}
const ix = /* @__PURE__ */ x.createContext(null);
function sx(n) {
  let a = x.useContext(sa).outlet;
  return a && /* @__PURE__ */ x.createElement(ix.Provider, {
    value: n
  }, a);
}
function Zo() {
  let {
    matches: n
  } = x.useContext(sa), a = n[n.length - 1];
  return a ? a.params : {};
}
function aE(n, a) {
  let {
    relative: s
  } = a === void 0 ? {} : a, {
    matches: o
  } = x.useContext(sa), {
    pathname: c
  } = ji(), E = JSON.stringify(tv(o).map((u) => u.pathnameBase));
  return x.useMemo(() => nv(n, JSON.parse(E), c, s === "path"), [n, E, c, s]);
}
function ox(n, a) {
  return lx(n, a);
}
function lx(n, a, s) {
  rE() || Vt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let {
    navigator: o
  } = x.useContext(va), {
    matches: c
  } = x.useContext(sa), E = c[c.length - 1], u = E ? E.params : {}, R = E ? E.pathname : "/", d = E ? E.pathnameBase : "/", T = E && E.route;
  {
    let O = T && T.path || "";
    Nx(R, !T || O.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + R + '" (under <Route path="' + O + '">) but the ') + `parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

` + ('Please change the parent <Route path="' + O + '"> to <Route ') + ('path="' + (O === "/" ? "*" : O + "/*") + '">.'));
  }
  let S = ji(), N;
  if (a) {
    var m;
    let O = typeof a == "string" ? Hs(a) : a;
    d === "/" || (m = O.pathname) != null && m.startsWith(d) || Vt(!1, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + d + '" ') + ('but pathname "' + O.pathname + '" was given in the `location` prop.')), N = O;
  } else
    N = S;
  let v = N.pathname || "/", M = d === "/" ? v : v.slice(d.length) || "/", w = xU(n, {
    pathname: M
  });
  Yr(T || w != null, 'No routes matched location "' + N.pathname + N.search + N.hash + '" '), Yr(w == null || w[w.length - 1].route.element !== void 0 || w[w.length - 1].route.Component !== void 0, 'Matched leaf route at location "' + N.pathname + N.search + N.hash + '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.');
  let y = Tx(w && w.map((O) => Object.assign({}, O, {
    params: Object.assign({}, u, O.params),
    pathname: ni([
      d,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(O.pathname).pathname : O.pathname
    ]),
    pathnameBase: O.pathnameBase === "/" ? d : ni([
      d,
      // Re-encode pathnames that were decoded inside matchRoutes
      o.encodeLocation ? o.encodeLocation(O.pathnameBase).pathname : O.pathnameBase
    ])
  })), c, s);
  return a && y ? /* @__PURE__ */ x.createElement(nE.Provider, {
    value: {
      location: Zf({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: "default"
      }, N),
      navigationType: Yi.Pop
    }
  }, y) : y;
}
function ux() {
  let n = Sx(), a = ex(n) ? n.status + " " + n.statusText : n instanceof Error ? n.message : JSON.stringify(n), s = n instanceof Error ? n.stack : null, o = "rgba(200,200,200, 0.5)", c = {
    padding: "0.5rem",
    backgroundColor: o
  }, E = {
    padding: "2px 4px",
    backgroundColor: o
  }, u = null;
  return console.error("Error handled by React Router default ErrorBoundary:", n), u = /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ x.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ x.createElement("code", {
    style: E
  }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ x.createElement("code", {
    style: E
  }, "errorElement"), " prop on your route.")), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ x.createElement("h3", {
    style: {
      fontStyle: "italic"
    }
  }, a), s ? /* @__PURE__ */ x.createElement("pre", {
    style: c
  }, s) : null, u);
}
const Ex = /* @__PURE__ */ x.createElement(ux, null);
class cx extends x.Component {
  constructor(a) {
    super(a), this.state = {
      location: a.location,
      revalidation: a.revalidation,
      error: a.error
    };
  }
  static getDerivedStateFromError(a) {
    return {
      error: a
    };
  }
  static getDerivedStateFromProps(a, s) {
    return s.location !== a.location || s.revalidation !== "idle" && a.revalidation === "idle" ? {
      error: a.error,
      location: a.location,
      revalidation: a.revalidation
    } : {
      error: a.error || s.error,
      location: s.location,
      revalidation: a.revalidation || s.revalidation
    };
  }
  componentDidCatch(a, s) {
    console.error("React Router caught the following error during render", a, s);
  }
  render() {
    return this.state.error ? /* @__PURE__ */ x.createElement(sa.Provider, {
      value: this.props.routeContext
    }, /* @__PURE__ */ x.createElement(mS.Provider, {
      value: this.state.error,
      children: this.props.component
    })) : this.props.children;
  }
}
function fx(n) {
  let {
    routeContext: a,
    match: s,
    children: o
  } = n, c = x.useContext(tE);
  return c && c.static && c.staticContext && (s.route.errorElement || s.route.ErrorBoundary) && (c.staticContext._deepestRenderedBoundaryId = s.route.id), /* @__PURE__ */ x.createElement(sa.Provider, {
    value: a
  }, o);
}
function Tx(n, a, s) {
  var o;
  if (a === void 0 && (a = []), s === void 0 && (s = null), n == null) {
    var c;
    if ((c = s) != null && c.errors)
      n = s.matches;
    else
      return null;
  }
  let E = n, u = (o = s) == null ? void 0 : o.errors;
  if (u != null) {
    let R = E.findIndex((d) => d.route.id && (u == null ? void 0 : u[d.route.id]));
    R >= 0 || Vt(!1, "Could not find a matching route for errors on route IDs: " + Object.keys(u).join(",")), E = E.slice(0, Math.min(E.length, R + 1));
  }
  return E.reduceRight((R, d, T) => {
    let S = d.route.id ? u == null ? void 0 : u[d.route.id] : null, N = null;
    s && (N = d.route.errorElement || Ex);
    let m = a.concat(E.slice(0, T + 1)), v = () => {
      let M;
      return S ? M = N : d.route.Component ? M = /* @__PURE__ */ x.createElement(d.route.Component, null) : d.route.element ? M = d.route.element : M = R, /* @__PURE__ */ x.createElement(fx, {
        match: d,
        routeContext: {
          outlet: R,
          matches: m,
          isDataRoute: s != null
        },
        children: M
      });
    };
    return s && (d.route.ErrorBoundary || d.route.errorElement || T === 0) ? /* @__PURE__ */ x.createElement(cx, {
      location: s.location,
      revalidation: s.revalidation,
      component: N,
      error: S,
      children: v(),
      routeContext: {
        outlet: null,
        matches: m,
        isDataRoute: !0
      }
    }) : v();
  }, null);
}
var sv = /* @__PURE__ */ function(n) {
  return n.UseBlocker = "useBlocker", n.UseRevalidator = "useRevalidator", n.UseNavigateStable = "useNavigate", n;
}(sv || {}), Zu = /* @__PURE__ */ function(n) {
  return n.UseBlocker = "useBlocker", n.UseLoaderData = "useLoaderData", n.UseActionData = "useActionData", n.UseRouteError = "useRouteError", n.UseNavigation = "useNavigation", n.UseRouteLoaderData = "useRouteLoaderData", n.UseMatches = "useMatches", n.UseRevalidator = "useRevalidator", n.UseNavigateStable = "useNavigate", n.UseRouteId = "useRouteId", n;
}(Zu || {});
function vS(n) {
  return n + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function dx(n) {
  let a = x.useContext(tE);
  return a || Vt(!1, vS(n)), a;
}
function Ax(n) {
  let a = x.useContext(CS);
  return a || Vt(!1, vS(n)), a;
}
function Rx(n) {
  let a = x.useContext(sa);
  return a || Vt(!1, vS(n)), a;
}
function LS(n) {
  let a = Rx(n), s = a.matches[a.matches.length - 1];
  return s.route.id || Vt(!1, n + ' can only be used on routes that contain a unique "id"'), s.route.id;
}
function px() {
  return LS(Zu.UseRouteId);
}
function Sx() {
  var n;
  let a = x.useContext(mS), s = Ax(Zu.UseRouteError), o = LS(Zu.UseRouteError);
  return a || ((n = s.errors) == null ? void 0 : n[o]);
}
function hx() {
  let {
    router: n
  } = dx(sv.UseNavigateStable), a = LS(Zu.UseNavigateStable), s = x.useRef(!1);
  return iv(() => {
    s.current = !0;
  }), x.useCallback(function(c, E) {
    E === void 0 && (E = {}), Yr(s.current, av), s.current && (typeof c == "number" ? n.navigate(c) : n.navigate(c, Zf({
      fromRouteId: a
    }, E)));
  }, [n, a]);
}
const EC = {};
function Nx(n, a, s) {
  !a && !EC[n] && (EC[n] = !0, Yr(!1, s));
}
const Ox = "startTransition", cC = DU[Ox];
function Ix(n) {
  let {
    basename: a,
    children: s,
    initialEntries: o,
    initialIndex: c,
    future: E
  } = n, u = x.useRef();
  u.current == null && (u.current = MU({
    initialEntries: o,
    initialIndex: c,
    v5Compat: !0
  }));
  let R = u.current, [d, T] = x.useState({
    action: R.action,
    location: R.location
  }), {
    v7_startTransition: S
  } = E || {}, N = x.useCallback((m) => {
    S && cC ? cC(() => T(m)) : T(m);
  }, [T, S]);
  return x.useLayoutEffect(() => R.listen(N), [R, N]), /* @__PURE__ */ x.createElement(_x, {
    basename: a,
    children: s,
    location: d.location,
    navigationType: d.action,
    navigator: R
  });
}
function ov(n) {
  return sx(n.context);
}
function jt(n) {
  Vt(!1, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function _x(n) {
  let {
    basename: a = "/",
    children: s = null,
    location: o,
    navigationType: c = Yi.Pop,
    navigator: E,
    static: u = !1
  } = n;
  rE() && Vt(!1, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
  let R = a.replace(/^\/*/, "/"), d = x.useMemo(() => ({
    basename: R,
    navigator: E,
    static: u
  }), [R, E, u]);
  typeof o == "string" && (o = Hs(o));
  let {
    pathname: T = "/",
    search: S = "",
    hash: N = "",
    state: m = null,
    key: v = "default"
  } = o, M = x.useMemo(() => {
    let w = Us(T, R);
    return w == null ? null : {
      location: {
        pathname: w,
        search: S,
        hash: N,
        state: m,
        key: v
      },
      navigationType: c
    };
  }, [R, T, S, N, m, v, c]);
  return Yr(M != null, '<Router basename="' + R + '"> is not able to match the URL ' + ('"' + T + S + N + '" because it does not start with the ') + "basename, so the <Router> won't render anything."), M == null ? null : /* @__PURE__ */ x.createElement(va.Provider, {
    value: d
  }, /* @__PURE__ */ x.createElement(nE.Provider, {
    children: s,
    value: M
  }));
}
function Ki(n) {
  let {
    children: a,
    location: s
  } = n;
  return ox(fS(a), s);
}
new Promise(() => {
});
function fS(n, a) {
  a === void 0 && (a = []);
  let s = [];
  return x.Children.forEach(n, (o, c) => {
    if (!/* @__PURE__ */ x.isValidElement(o))
      return;
    let E = [...a, c];
    if (o.type === x.Fragment) {
      s.push.apply(s, fS(o.props.children, E));
      return;
    }
    o.type !== jt && Vt(!1, "[" + (typeof o.type == "string" ? o.type : o.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"), !o.props.index || !o.props.children || Vt(!1, "An index route cannot have child routes.");
    let u = {
      id: o.props.id || E.join("-"),
      caseSensitive: o.props.caseSensitive,
      element: o.props.element,
      Component: o.props.Component,
      index: o.props.index,
      path: o.props.path,
      loader: o.props.loader,
      action: o.props.action,
      errorElement: o.props.errorElement,
      ErrorBoundary: o.props.ErrorBoundary,
      hasErrorBoundary: o.props.ErrorBoundary != null || o.props.errorElement != null,
      shouldRevalidate: o.props.shouldRevalidate,
      handle: o.props.handle,
      lazy: o.props.lazy
    };
    o.props.children && (u.children = fS(o.props.children, E)), s.push(u);
  }), s;
}
/**
 * React Router DOM v6.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ko() {
  return Ko = Object.assign ? Object.assign.bind() : function(n) {
    for (var a = 1; a < arguments.length; a++) {
      var s = arguments[a];
      for (var o in s)
        Object.prototype.hasOwnProperty.call(s, o) && (n[o] = s[o]);
    }
    return n;
  }, Ko.apply(this, arguments);
}
function yS(n, a) {
  if (n == null)
    return {};
  var s = {}, o = Object.keys(n), c, E;
  for (E = 0; E < o.length; E++)
    c = o[E], !(a.indexOf(c) >= 0) && (s[c] = n[c]);
  return s;
}
const Ff = "get", Yf = "application/x-www-form-urlencoded";
function iT(n) {
  return n != null && typeof n.tagName == "string";
}
function Cx(n) {
  return iT(n) && n.tagName.toLowerCase() === "button";
}
function mx(n) {
  return iT(n) && n.tagName.toLowerCase() === "form";
}
function vx(n) {
  return iT(n) && n.tagName.toLowerCase() === "input";
}
function Lx(n) {
  return !!(n.metaKey || n.altKey || n.ctrlKey || n.shiftKey);
}
function yx(n, a) {
  return n.button === 0 && // Ignore everything but left clicks
  (!a || a === "_self") && // Let browser handle "target=_blank" etc.
  !Lx(n);
}
let yf = null;
function gx() {
  if (yf === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), yf = !1;
    } catch {
      yf = !0;
    }
  return yf;
}
const Dx = /* @__PURE__ */ new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
function Up(n) {
  return n != null && !Dx.has(n) ? (Yr(!1, '"' + n + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + Yf + '"')), null) : n;
}
function bx(n, a) {
  let s, o, c, E, u;
  if (mx(n)) {
    let R = n.getAttribute("action");
    o = R ? Us(R, a) : null, s = n.getAttribute("method") || Ff, c = Up(n.getAttribute("enctype")) || Yf, E = new FormData(n);
  } else if (Cx(n) || vx(n) && (n.type === "submit" || n.type === "image")) {
    let R = n.form;
    if (R == null)
      throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
    let d = n.getAttribute("formaction") || R.getAttribute("action");
    if (o = d ? Us(d, a) : null, s = n.getAttribute("formmethod") || R.getAttribute("method") || Ff, c = Up(n.getAttribute("formenctype")) || Up(R.getAttribute("enctype")) || Yf, E = new FormData(R, n), !gx()) {
      let {
        name: T,
        type: S,
        value: N
      } = n;
      if (S === "image") {
        let m = T ? T + "." : "";
        E.append(m + "x", "0"), E.append(m + "y", "0");
      } else
        T && E.append(T, N);
    }
  } else {
    if (iT(n))
      throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    s = Ff, o = null, c = Yf, u = n;
  }
  return E && c === "text/plain" && (u = E, E = void 0), {
    action: o,
    method: s.toLowerCase(),
    encType: c,
    formData: E,
    body: u
  };
}
const Mx = ["onClick", "relative", "reloadDocument", "replace", "state", "target", "to", "preventScrollReset", "unstable_viewTransition"], Px = ["aria-current", "caseSensitive", "className", "end", "style", "to", "unstable_viewTransition", "children"], Ux = ["fetcherKey", "navigate", "reloadDocument", "replace", "state", "method", "action", "onSubmit", "relative", "preventScrollReset", "unstable_viewTransition"], lv = /* @__PURE__ */ x.createContext({
  isTransitioning: !1
});
lv.displayName = "ViewTransition";
const xx = /* @__PURE__ */ x.createContext(/* @__PURE__ */ new Map());
xx.displayName = "Fetchers";
const wx = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Gx = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, fn = /* @__PURE__ */ x.forwardRef(function(a, s) {
  let {
    onClick: o,
    relative: c,
    reloadDocument: E,
    replace: u,
    state: R,
    target: d,
    to: T,
    preventScrollReset: S,
    unstable_viewTransition: N
  } = a, m = yS(a, Mx), {
    basename: v
  } = x.useContext(va), M, w = !1;
  if (typeof T == "string" && Gx.test(T) && (M = T, wx))
    try {
      let V = new URL(window.location.href), D = T.startsWith("//") ? new URL(V.protocol + T) : new URL(T), G = Us(D.pathname, v);
      D.origin === V.origin && G != null ? T = G + D.search + D.hash : w = !0;
    } catch {
      Yr(!1, '<Link to="' + T + '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.');
    }
  let y = rx(T, {
    relative: c
  }), O = Fx(T, {
    replace: u,
    state: R,
    target: d,
    preventScrollReset: S,
    relative: c,
    unstable_viewTransition: N
  });
  function g(V) {
    o && o(V), V.defaultPrevented || O(V);
  }
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ x.createElement("a", Ko({}, m, {
      href: M || y,
      onClick: w || E ? o : g,
      ref: s,
      target: d
    }))
  );
});
fn.displayName = "Link";
const uv = /* @__PURE__ */ x.forwardRef(function(a, s) {
  let {
    "aria-current": o = "page",
    caseSensitive: c = !1,
    className: E = "",
    end: u = !1,
    style: R,
    to: d,
    unstable_viewTransition: T,
    children: S
  } = a, N = yS(a, Px), m = aE(d, {
    relative: N.relative
  }), v = ji(), M = x.useContext(CS), {
    navigator: w
  } = x.useContext(va), y = M != null && // Conditional usage is OK here because the usage of a data router is static
  // eslint-disable-next-line react-hooks/rules-of-hooks
  jx(m) && T === !0, O = w.encodeLocation ? w.encodeLocation(m).pathname : m.pathname, g = v.pathname, V = M && M.navigation && M.navigation.location ? M.navigation.location.pathname : null;
  c || (g = g.toLowerCase(), V = V ? V.toLowerCase() : null, O = O.toLowerCase());
  let D = g === O || !u && g.startsWith(O) && g.charAt(O.length) === "/", G = V != null && (V === O || !u && V.startsWith(O) && V.charAt(O.length) === "/"), P = {
    isActive: D,
    isPending: G,
    isTransitioning: y
  }, U = D ? o : void 0, Y;
  typeof E == "function" ? Y = E(P) : Y = [E, D ? "active" : null, G ? "pending" : null, y ? "transitioning" : null].filter(Boolean).join(" ");
  let X = typeof R == "function" ? R(P) : R;
  return /* @__PURE__ */ x.createElement(fn, Ko({}, N, {
    "aria-current": U,
    className: Y,
    ref: s,
    style: X,
    to: d,
    unstable_viewTransition: T
  }), typeof S == "function" ? S(P) : S);
});
uv.displayName = "NavLink";
const Hx = /* @__PURE__ */ x.forwardRef((n, a) => {
  let {
    fetcherKey: s,
    navigate: o,
    reloadDocument: c,
    replace: E,
    state: u,
    method: R = Ff,
    action: d,
    onSubmit: T,
    relative: S,
    preventScrollReset: N,
    unstable_viewTransition: m
  } = n, v = yS(n, Ux), M = kx(), w = Xx(d, {
    relative: S
  }), y = R.toLowerCase() === "get" ? "get" : "post", O = (g) => {
    if (T && T(g), g.defaultPrevented)
      return;
    g.preventDefault();
    let V = g.nativeEvent.submitter, D = (V == null ? void 0 : V.getAttribute("formmethod")) || R;
    M(V || g.currentTarget, {
      fetcherKey: s,
      method: D,
      navigate: o,
      replace: E,
      state: u,
      relative: S,
      preventScrollReset: N,
      unstable_viewTransition: m
    });
  };
  return /* @__PURE__ */ x.createElement("form", Ko({
    ref: a,
    method: y,
    action: w,
    onSubmit: c ? T : O
  }, v));
});
Hx.displayName = "Form";
var qf;
(function(n) {
  n.UseScrollRestoration = "useScrollRestoration", n.UseSubmit = "useSubmit", n.UseSubmitFetcher = "useSubmitFetcher", n.UseFetcher = "useFetcher", n.useViewTransitionState = "useViewTransitionState";
})(qf || (qf = {}));
var fC;
(function(n) {
  n.UseFetcher = "useFetcher", n.UseFetchers = "useFetchers", n.UseScrollRestoration = "useScrollRestoration";
})(fC || (fC = {}));
function Bx(n) {
  return n + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function Ev(n) {
  let a = x.useContext(tE);
  return a || Vt(!1, Bx(n)), a;
}
function Fx(n, a) {
  let {
    target: s,
    replace: o,
    state: c,
    preventScrollReset: E,
    relative: u,
    unstable_viewTransition: R
  } = a === void 0 ? {} : a, d = aT(), T = ji(), S = aE(n, {
    relative: u
  });
  return x.useCallback((N) => {
    if (yx(N, s)) {
      N.preventDefault();
      let m = o !== void 0 ? o : zf(T) === zf(S);
      d(n, {
        replace: m,
        state: c,
        preventScrollReset: E,
        relative: u,
        unstable_viewTransition: R
      });
    }
  }, [T, d, S, o, c, s, n, E, u, R]);
}
function Yx() {
  if (typeof document > "u")
    throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let Vx = 0, Wx = () => "__" + String(++Vx) + "__";
function kx() {
  let {
    router: n
  } = Ev(qf.UseSubmit), {
    basename: a
  } = x.useContext(va), s = px();
  return x.useCallback(function(o, c) {
    c === void 0 && (c = {}), Yx();
    let {
      action: E,
      method: u,
      encType: R,
      formData: d,
      body: T
    } = bx(o, a);
    if (c.navigate === !1) {
      let S = c.fetcherKey || Wx();
      n.fetch(S, s, c.action || E, {
        preventScrollReset: c.preventScrollReset,
        formData: d,
        body: T,
        formMethod: c.method || u,
        formEncType: c.encType || R
      });
    } else
      n.navigate(c.action || E, {
        preventScrollReset: c.preventScrollReset,
        formData: d,
        body: T,
        formMethod: c.method || u,
        formEncType: c.encType || R,
        replace: c.replace,
        state: c.state,
        fromRouteId: s,
        unstable_viewTransition: c.unstable_viewTransition
      });
  }, [n, a, s]);
}
function Xx(n, a) {
  let {
    relative: s
  } = a === void 0 ? {} : a, {
    basename: o
  } = x.useContext(va), c = x.useContext(sa);
  c || Vt(!1, "useFormAction must be used inside a RouteContext");
  let [E] = c.matches.slice(-1), u = Ko({}, aE(n || ".", {
    relative: s
  })), R = ji();
  if (n == null && (u.search = R.search, E.route.index)) {
    let d = new URLSearchParams(u.search);
    d.delete("index"), u.search = d.toString() ? "?" + d.toString() : "";
  }
  return (!n || n === ".") && E.route.index && (u.search = u.search ? u.search.replace(/^\?/, "?index&") : "?index"), o !== "/" && (u.pathname = u.pathname === "/" ? o : ni([o, u.pathname])), zf(u);
}
function jx(n, a) {
  a === void 0 && (a = {});
  let s = x.useContext(lv);
  s == null && Vt(!1, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
  let {
    basename: o
  } = Ev(qf.useViewTransitionState), c = aE(n, {
    relative: a.relative
  });
  if (!s.isTransitioning)
    return !1;
  let E = Us(s.currentLocation.pathname, o) || s.currentLocation.pathname, u = Us(s.nextLocation.pathname, o) || s.nextLocation.pathname;
  return cS(c.pathname, u) != null || cS(c.pathname, E) != null;
}
var cv = {}, fv = {}, gS = { exports: {} }, Pt = String, Tv = function() {
  return { isColorSupported: !1, reset: Pt, bold: Pt, dim: Pt, italic: Pt, underline: Pt, inverse: Pt, hidden: Pt, strikethrough: Pt, black: Pt, red: Pt, green: Pt, yellow: Pt, blue: Pt, magenta: Pt, cyan: Pt, white: Pt, gray: Pt, bgBlack: Pt, bgRed: Pt, bgGreen: Pt, bgYellow: Pt, bgBlue: Pt, bgMagenta: Pt, bgCyan: Pt, bgWhite: Pt };
};
gS.exports = Tv();
gS.exports.createColors = Tv;
var Kx = gS.exports;
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function a(d, T) {
    for (var S in T)
      Object.defineProperty(d, S, {
        enumerable: !0,
        get: T[S]
      });
  }
  a(n, {
    dim: function() {
      return u;
    },
    default: function() {
      return R;
    }
  });
  const s = /* @__PURE__ */ o(Kx);
  function o(d) {
    return d && d.__esModule ? d : {
      default: d
    };
  }
  let c = /* @__PURE__ */ new Set();
  function E(d, T, S) {
    typeof {} < "u" || S && c.has(S) || (S && c.add(S), console.warn(""), T.forEach((N) => console.warn(d, "-", N)));
  }
  function u(d) {
    return s.default.dim(d);
  }
  const R = {
    info(d, T) {
      E(s.default.bold(s.default.cyan("info")), ...Array.isArray(d) ? [
        d
      ] : [
        T,
        d
      ]);
    },
    warn(d, T) {
      E(s.default.bold(s.default.yellow("warn")), ...Array.isArray(d) ? [
        d
      ] : [
        T,
        d
      ]);
    },
    risk(d, T) {
      E(s.default.bold(s.default.magenta("risk")), ...Array.isArray(d) ? [
        d
      ] : [
        T,
        d
      ]);
    }
  };
})(fv);
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "default", {
    enumerable: !0,
    get: function() {
      return c;
    }
  });
  const a = /* @__PURE__ */ s(fv);
  function s(E) {
    return E && E.__esModule ? E : {
      default: E
    };
  }
  function o({ version: E, from: u, to: R }) {
    a.default.warn(`${u}-color-renamed`, [
      `As of Tailwind CSS ${E}, \`${u}\` has been renamed to \`${R}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const c = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return o({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return o({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return o({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return o({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return o({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(cv);
let xp = cv;
var Jx = (xp.__esModule ? xp : { default: xp }).default;
const zx = /* @__PURE__ */ Xi(Jx), Zx = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: 100, height: 100, viewBox: "0 0 48 48", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("path", { d: "M 22 1 C 19.802666 1 18 2.8026661 18 5 L 18 6 L 9 6 C 7.3555411 6 6 7.3544268 6 9 L 6 11 C 6 12.645573 7.3555411 14 9 14 L 33 14 A 1.0001 1.0001 0 1 0 33 12 L 9 12 C 8.4364589 12 8 11.564427 8 11 L 8 9 C 8 8.4355732 8.4364589 8 9 8 L 19 8 A 1.0001 1.0001 0 0 0 20 7 L 20 5 C 20 3.8833339 20.883334 3 22 3 L 26 3 C 27.116666 3 28 3.8833339 28 5 L 28 7 A 1.0001 1.0001 0 0 0 29 8 L 39 8 C 39.563541 8 40 8.4355732 40 9 L 40 11 C 40 11.564427 39.563541 12 39 12 L 38 12 A 1.0001 1.0001 0 0 0 37 13.003906 L 37.105469 40.080078 C 37.060923 41.715433 35.743427 43 34.107422 43 L 14.025391 43 C 12.348977 43 11.014814 41.656796 11.025391 39.980469 A 1.0001 1.0001 0 0 0 11.025391 39.974609 L 11 16.998047 A 1.0001 1.0001 0 1 0 9 17.001953 L 9.0253906 39.96875 C 9.0079668 42.730423 11.263804 45 14.025391 45 L 34.107422 45 C 36.805417 45 39.032014 42.831411 39.105469 40.134766 A 1.0001 1.0001 0 0 0 39.105469 40.103516 L 39.003906 13.998047 C 40.646254 13.995478 42 12.64401 42 11 L 42 9 C 42 7.3544268 40.644459 6 39 6 L 30 6 L 30 5 C 30 2.8026661 28.197334 1 26 1 L 22 1 z M 16.984375 19.986328 A 1.0001 1.0001 0 0 0 16 21 L 16 38 A 1.0001 1.0001 0 1 0 18 38 L 18 21 A 1.0001 1.0001 0 0 0 16.984375 19.986328 z M 23.984375 19.986328 A 1.0001 1.0001 0 0 0 23 21 L 23 38 A 1.0001 1.0001 0 1 0 25 38 L 25 21 A 1.0001 1.0001 0 0 0 23.984375 19.986328 z M 30.984375 19.986328 A 1.0001 1.0001 0 0 0 30 21 L 30 38 A 1.0001 1.0001 0 1 0 32 38 L 32 21 A 1.0001 1.0001 0 0 0 30.984375 19.986328 z" })), dv = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { width: 256, height: 256, viewBox: "0 0 256 256", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: 256, height: 256, fill: "none" }), /* @__PURE__ */ x.createElement("path", { d: "M121.678 68.6777C140.081 50.2742 169.919 50.2742 188.322 68.6777C206.726 87.0811 206.726 116.919 188.322 135.322C169.919 153.726 140.081 153.726 121.678 135.322C120.734 134.378 119.733 133.525 118.686 132.764C108.865 124.59 94.2507 125.11 85.0381 134.322L57.5381 161.822C47.775 171.585 47.775 187.415 57.5381 197.178C67.3012 206.941 83.1303 206.941 92.8934 197.178L104.862 185.209C142.205 207.751 191.449 202.907 223.678 170.678C261.607 132.748 261.607 71.252 223.678 33.3223C185.748 -4.60732 124.252 -4.60732 86.3223 33.3223C77.5523 42.0923 70.7787 52.1712 66.0472 62.9564C60.5003 75.6003 66.2535 90.3468 78.8974 95.8938C91.5413 101.441 106.288 95.6875 111.835 83.0436C114.109 77.8604 117.374 72.9809 121.678 68.6777Z", fill: "currentColor" }), /* @__PURE__ */ x.createElement("path", { d: "M59 224C59 238.359 47.3594 250 33 250C18.6406 250 7 238.359 7 224C7 209.641 18.6406 198 33 198C47.3594 198 59 209.641 59 224Z", fill: "currentColor" }), /* @__PURE__ */ x.createElement("path", { d: "M155 130C170.464 130 183 117.464 183 102C183 86.536 170.464 74 155 74C139.536 74 127 86.536 127 102C127 117.464 139.536 130 155 130Z", fill: "currentColor" })), qx = new EventTarget();
function iE() {
  if (typeof window > "u")
    return qx;
  const n = window;
  return n.__spotlight || (n.__spotlight = {}), n.__spotlight.eventTarget || (n.__spotlight.eventTarget = new EventTarget()), n.__spotlight.eventTarget;
}
async function Av(n, a) {
  iE().dispatchEvent(
    new CustomEvent(n, {
      detail: a || {}
    })
  );
}
async function sT(n, a) {
  iE().addEventListener(n, a);
}
async function Qx(n, a) {
  iE().removeEventListener(n, a);
}
function $e(...n) {
  return n.filter(Boolean).join(" ");
}
function Rv(n, a, s = !1) {
  x.useEffect(() => {
    function o(c) {
      s || c.stopPropagation(), n.every((E) => E in c ? c[E] : c.key.toLowerCase() === E.toLowerCase()) && a();
    }
    return window.addEventListener("keyup", o), () => {
      window.removeEventListener("keyup", o);
    };
  }, [n, a, s]);
}
function DS({ tabs: n, nested: a, setOpen: s }) {
  const o = aT(), c = ji();
  return Rv(["Escape"], () => {
    s && c.pathname.split("/").length === 2 ? s(!1) : o(-1);
  }), /* @__PURE__ */ p.jsxs("div", { children: [
    /* @__PURE__ */ p.jsxs("div", { className: "sm:hidden", children: [
      /* @__PURE__ */ p.jsx("label", { htmlFor: "tabs", className: "sr-only", children: "Select a tab" }),
      /* @__PURE__ */ p.jsx(
        "select",
        {
          id: "tabs",
          name: "tabs",
          className: "border-primary-800 bg-primary-800 hover:bg-primary-700 hover:border-primary-700 focus:bg-primary-800 text-primary-100 block w-full rounded-md py-2 pl-3 pr-10 focus:outline-none sm:text-sm",
          onChange: (E) => {
            const u = n.find((R) => R.id === E.target.value);
            u && u.onSelect && u.onSelect(), o(`${a ? "" : "/"}${(u == null ? void 0 : u.id) || "not-found"}`);
          },
          children: n.map((E, u) => {
            var R;
            return /* @__PURE__ */ p.jsxs("option", { value: E.id, children: [
              E.title,
              " ",
              (R = E.notificationCount) == null ? void 0 : R.count
            ] }, u);
          })
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx("div", { className: "hidden sm:block", children: /* @__PURE__ */ p.jsx("nav", { className: "border-b-primary-700 flex space-x-8 border-b px-6", "aria-label": "Tabs", children: n.map((E) => {
      var u;
      return /* @__PURE__ */ p.jsxs(
        uv,
        {
          to: `${a ? "" : "/"}${E.id}`,
          replace: !0,
          className: ({ isActive: R }) => $e(
            R ? "border-primary-200 text-primary-100 [&>.count]:bg-primary-100 [&>.count]:text-primary-600" : "text-primary-400 hover:border-primary-400 hover:text-primary-100 [&>.count]:bg-primary-700 [&>.count]:text-primary-200 border-transparent",
            "-m-y -mx-2 flex select-none whitespace-nowrap border-b-2 px-2 py-3 text-sm font-medium"
          ),
          onClick: () => E.onSelect && E.onSelect(),
          children: [
            E.title,
            E.notificationCount !== void 0 ? /* @__PURE__ */ p.jsx("span", { className: "count ml-3 hidden rounded px-2.5 py-0.5 text-xs font-medium md:inline-block", children: (u = E.notificationCount) == null ? void 0 : u.count }) : null
          ]
        },
        E.id
      );
    }) }) })
  ] });
}
function $x({
  integrations: n,
  integrationData: a,
  setTriggerButtonCount: s,
  setOpen: o
}) {
  const [c, E] = x.useState({ count: 0, severe: !1 }), u = n.map((d) => {
    var T;
    if (d.tabs) {
      const S = ((T = a[d.name]) == null ? void 0 : T.map((N) => N.event)) || [];
      return d.tabs({ processedEvents: S }).map((N) => ({
        ...N,
        processedEvents: S
      }));
    }
    return [];
  }).flat(), R = u.reduce(
    (d, T) => {
      var S, N;
      return {
        count: d.count + (((S = T.notificationCount) == null ? void 0 : S.count) || 0),
        severe: d.severe || ((N = T.notificationCount) == null ? void 0 : N.severe) || !1
      };
    },
    { count: 0, severe: !1 }
  );
  return R.count !== c.count && E(R), x.useEffect(() => {
    s(c);
  }, [c, s]), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(DS, { tabs: u, setOpen: o }),
    /* @__PURE__ */ p.jsx("div", { className: "flex-1 overflow-auto overflow-x-hidden", children: /* @__PURE__ */ p.jsxs(Ki, { children: [
      /* @__PURE__ */ p.jsx(jt, { path: "/not-found", element: /* @__PURE__ */ p.jsx("p", { children: "Not Found - How'd you manage to get here?" }) }, "not-found"),
      u.map((d) => {
        const T = d.content && d.content;
        return T ? /* @__PURE__ */ p.jsx(
          jt,
          {
            path: `/${d.id}/*`,
            element: x.createElement(T, { processedEvents: d.processedEvents })
          },
          d.id
        ) : null;
      })
    ] }) })
  ] });
}
function e2({
  isOpen: n,
  setOpen: a,
  fullPage: s,
  children: o
}) {
  return s ? /* @__PURE__ */ p.jsx(p.Fragment, { children: o }) : /* @__PURE__ */ p.jsx(
    "div",
    {
      className: $e("spotlight-fullscreen-blur", n ? "" : "!hidden"),
      onClick: (c) => {
        c.target === c.currentTarget && a(!1);
      },
      children: o
    }
  );
}
function t2({
  integrations: n,
  isOpen: a,
  setOpen: s,
  integrationData: o,
  isOnline: c,
  setTriggerButtonCount: E,
  fullPage: u,
  showClearEventsButton: R
}) {
  return /* @__PURE__ */ p.jsx(e2, { isOpen: a, setOpen: s, fullPage: u, children: /* @__PURE__ */ p.jsxs("div", { className: $e("spotlight-debugger", u ? "spotlight-fullscreen" : ""), children: [
    /* @__PURE__ */ p.jsxs("div", { className: "text-primary-200 flex items-center gap-x-2 px-6 py-4", children: [
      /* @__PURE__ */ p.jsxs("h1", { className: "font-raleway flex flex-1 items-end gap-x-1 leading-7 opacity-80", children: [
        /* @__PURE__ */ p.jsxs("div", { className: "inline-flex items-center gap-x-4", children: [
          /* @__PURE__ */ p.jsx(dv, { height: 32, width: 32 }),
          /* @__PURE__ */ p.jsx("div", { className: "text-3xl font-light uppercase leading-7 tracking-widest", children: "Spotlight" })
        ] }),
        /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex items-center gap-x-1 text-sm", children: [
          /* @__PURE__ */ p.jsx("span", { children: "by" }),
          /* @__PURE__ */ p.jsx("a", { rel: "noopener", href: "https://sentry.io", target: "_blank", className: "font-semibold hover:underline", children: "Sentry" }),
          /* @__PURE__ */ p.jsxs("a", { href: "https://github.com/getsentry/spotlight", target: "_blank", rel: "noopener", className: "sl-flex ml-2", children: [
            /* @__PURE__ */ p.jsx("span", { className: "sr-only", children: "GitHub" }),
            /* @__PURE__ */ p.jsx(
              "svg",
              {
                "aria-hidden": "true",
                className: "astro-6byselsc",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "currentColor",
                children: /* @__PURE__ */ p.jsx("path", { d: "M12 .3a12 12 0 0 0-3.8 23.38c.6.12.83-.26.83-.57L9 21.07c-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.08-.74.09-.73.09-.73 1.2.09 1.83 1.24 1.83 1.24 1.08 1.83 2.81 1.3 3.5 1 .1-.78.42-1.31.76-1.61-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.14-.3-.54-1.52.1-3.18 0 0 1-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.28-1.55 3.29-1.23 3.29-1.23.64 1.66.24 2.88.12 3.18a4.65 4.65 0 0 1 1.23 3.22c0 4.61-2.8 5.63-5.48 5.92.42.36.81 1.1.81 2.22l-.01 3.29c0 .31.2.69.82.57A12 12 0 0 0 12 .3Z" })
              }
            )
          ] }),
          /* @__PURE__ */ p.jsxs(
            "div",
            {
              className: $e("ml-2 flex items-center gap-x-2 pl-2 text-xs", c ? "" : "text-red-400"),
              children: [
                /* @__PURE__ */ p.jsx(
                  "div",
                  {
                    className: $e(
                      " block h-2 w-2 rounded-full",
                      c ? "bg-green-400" : "animate-pulse bg-red-400"
                    )
                  }
                ),
                c ? "Connected to Sidecar" : "Not connected to Sidecar"
              ]
            }
          )
        ] })
      ] }),
      R && /* @__PURE__ */ p.jsxs(
        "button",
        {
          className: "bg-primary-900 text-primary-300 hover:bg-primary-800 mr-1 flex items-center gap-1 rounded-md px-2 py-1 hover:transition-colors",
          onClick: () => {
            iE().dispatchEvent(
              new CustomEvent("clearEvents", {
                detail: {}
              })
            );
          },
          children: [
            /* @__PURE__ */ p.jsx(Zx, { width: 18, height: 18, className: "fill-red-400 stroke-red-400" }),
            /* @__PURE__ */ p.jsx("span", { className: "leading-8", children: "Clear Events" })
          ]
        }
      ),
      !u && /* @__PURE__ */ p.jsx(
        "button",
        {
          className: "hover:bg-primary-800 -my-1 -mr-3 cursor-pointer rounded px-3 py-1 font-mono text-2xl",
          onClick: () => {
            s(!1);
          },
          children: "✕"
        }
      )
    ] }),
    /* @__PURE__ */ p.jsx(
      $x,
      {
        integrations: n,
        integrationData: o,
        setTriggerButtonCount: E,
        setOpen: s
      }
    )
  ] }) });
}
const bS = "http://localhost:8969/stream", TS = {
  "sentry:focus-local-events": !0
}, pv = "bottomRight";
function n2(n) {
  switch (n) {
    case "centerRight":
      return "bottom-[45%] right-4";
    case "centerLeft":
      return "bottom-[45%] left-4";
    case "topLeft":
      return "top-4 left-4";
    case "topRight":
      return "top-4 right-4";
    case "bottomLeft":
      return "bottom-4 left-4";
    case "bottomRight":
    default:
      return "bottom-4 right-4";
  }
}
function r2({
  count: n,
  children: a,
  severe: s = !1,
  ...o
}) {
  return /* @__PURE__ */ p.jsxs("div", { className: "gap-x hover:bg-primary-400 relative flex items-center rounded p-3", ...o, children: [
    a,
    !!n && /* @__PURE__ */ p.jsx(
      "span",
      {
        className: $e(
          s ? "bg-red-500" : "bg-primary-500",
          "absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full font-sans text-[0.65rem] font-medium"
        ),
        children: n
      }
    )
  ] });
}
function a2({
  isOpen: n,
  setOpen: a,
  notificationCount: s,
  anchor: o = pv
}) {
  const c = s.count, E = 24;
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: $e(
        "z-[999999]",
        "fixed inline-flex items-center rounded font-medium",
        "font-raleway bg-primary-700 cursor-pointer text-white",
        "flex-col",
        n2(o),
        n ? "!hidden" : ""
      ),
      id: "spotlight-overlay-trigger",
      title: "Spotlight by Sentry",
      onClick: () => a(!n),
      children: /* @__PURE__ */ p.jsx(r2, { count: c, severe: !!s.severe, children: /* @__PURE__ */ p.jsx(dv, { height: E, width: E }) })
    }
  );
}
let MS = !1;
function i2() {
  MS = !0;
}
function vt(...n) {
  MS && console.log("🔎 [Spotlight]", ...n);
}
function TC(...n) {
  MS && console.warn("🔎 [Spotlight]", ...n);
}
function s2(n, a, s, o) {
  vt("Connecting to sidecar at", n);
  const c = new EventSource(n), E = [];
  for (const [u, R] of a.entries()) {
    const d = (T) => {
      vt(`Received new ${u} event`);
      for (const S of R) {
        if (!S.processEvent)
          return;
        const N = S.processEvent({
          contentType: u,
          data: T.data
        });
        N && s((m) => {
          const v = S.name;
          return {
            ...m,
            [v]: [...m[v] || [], N]
          };
        });
      }
    };
    vt("Adding listener for", u, "sum", E.length), E.push([u, d]), c.addEventListener(u, d);
  }
  return c.addEventListener("open", () => {
    o(!0), vt("Open");
  }), c.addEventListener("error", (u) => {
    o(!1), console.error("EventSource failed:", u);
  }), () => {
    vt(`Removing ${E.length} listeners`), E.forEach((u) => {
      c.removeEventListener(u[0], u[1]), vt("Removed listener for type", u[0]);
    });
  };
}
function o2({
  openOnInit: n = !1,
  showTriggerButton: a = !0,
  integrations: s = [],
  sidecarUrl: o,
  anchor: c,
  fullPage: E = !1,
  showClearEventsButton: u = !0
}) {
  vt("App rerender");
  const [R, d] = x.useState({}), [T, S] = x.useState(!1), [N, m] = x.useState({ count: 0, severe: !1 }), [v, M] = x.useState(n), [w, y] = x.useState(0);
  Rv(["ctrlKey", "F12"], () => {
    M((D) => !D);
  }), x.useEffect(() => {
    const D = /* @__PURE__ */ new Map();
    s.forEach(
      (P) => {
        var U;
        return (U = P.forwardedContentType) == null ? void 0 : U.forEach((Y) => {
          const X = D.get(Y) || [];
          X.push(P), D.set(Y, X);
        });
      }
    );
    const G = s2(o, D, d, S);
    return () => {
      vt("useEffect cleanup"), G();
    };
  }, [s, o, w]);
  const O = iE(), g = aT(), V = () => {
    const { origin: D } = new URL(o), G = `${D}/clear`;
    fetch(G, {
      method: "DELETE",
      mode: "cors"
    }).catch((P) => {
      console.error("Spotlight can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/", P);
    }), s.forEach((P) => {
      const U = P.name;
      P.processEvent && (d((Y) => ({ ...Y, [U]: [] })), P.reset && P.reset());
    }), y((P) => P + 1);
  };
  return x.useEffect(() => {
    const D = (U) => {
      vt("Open"), M(!0), U.detail.path && g(U.detail.path);
    }, G = () => {
      vt("Close"), M(!1);
    }, P = (U) => {
      vt("Navigate"), g(U.detail);
    };
    return O.addEventListener("open", D), O.addEventListener("close", G), O.addEventListener("navigate", P), O.addEventListener("clearEvents", V), () => {
      O.removeEventListener("open", D), O.removeEventListener("close", G), O.removeEventListener("navigate", P), O.removeEventListener("clearEvents", V);
    };
  }, [O, g]), x.useEffect(() => {
    v ? (O.dispatchEvent(new CustomEvent("opened")), document.body.style.overflow = "hidden") : (O.dispatchEvent(new CustomEvent("closed")), document.body.style.overflow = "auto");
  }, [v, O]), x.useEffect(() => {
    N.severe && O.dispatchEvent(
      new CustomEvent("severeEventCount", { detail: { count: N.count } })
    );
  }, [N, O]), vt("Integration data:", R), /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    a && /* @__PURE__ */ p.jsx(a2, { isOpen: v, setOpen: M, notificationCount: N, anchor: c }),
    /* @__PURE__ */ p.jsx(
      t2,
      {
        isOpen: E || v,
        setOpen: M,
        isOnline: T,
        integrations: s,
        integrationData: R,
        setTriggerButtonCount: m,
        fullPage: E,
        showClearEventsButton: u
      }
    )
  ] });
}
const l2 = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 640px){.container{max-width:640px}}@media (min-width: 768px){.container{max-width:768px}}@media (min-width: 1024px){.container{max-width:1024px}}@media (min-width: 1280px){.container{max-width:1280px}}@media (min-width: 1536px){.container{max-width:1536px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.-left-1{left:-.25rem}.-right-2{right:-.5rem}.-top-1{top:-.25rem}.-top-2{top:-.5rem}.bottom-0{bottom:0}.bottom-4{bottom:1rem}.bottom-\\[45\\%\\]{bottom:45%}.bottom-full{bottom:100%}.left-0{left:0}.left-1\\/2{left:50%}.left-1\\/4{left:25%}.left-4{left:1rem}.left-full{left:100%}.right-0{right:0}.right-1{right:.25rem}.right-4{right:1rem}.right-full{right:100%}.top-0{top:0}.top-1\\/2{top:50%}.top-4{top:1rem}.top-\\[5px\\]{top:5px}.top-full{top:100%}.z-10{z-index:10}.z-20{z-index:20}.z-\\[999999\\]{z-index:999999}.-m-0{margin:-0px}.-m-0\\.5{margin:-.125rem}.-m-2{margin:-.5rem}.-mx-2{margin-left:-.5rem;margin-right:-.5rem}.-my-1{margin-top:-.25rem;margin-bottom:-.25rem}.mx-2{margin-left:.5rem;margin-right:.5rem}.mx-6{margin-left:1.5rem;margin-right:1.5rem}.-mr-3{margin-right:-.75rem}.mb-2{margin-bottom:.5rem}.mb-4{margin-bottom:1rem}.mb-8{margin-bottom:2rem}.ml-2{margin-left:.5rem}.ml-3{margin-left:.75rem}.ml-4{margin-left:1rem}.mr-1{margin-right:.25rem}.mr-2{margin-right:.5rem}.mt-2{margin-top:.5rem}.block{display:block}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.\\!hidden{display:none!important}.hidden{display:none}.h-2{height:.5rem}.h-4{height:1rem}.h-5{height:1.25rem}.h-6{height:1.5rem}.h-8{height:2rem}.h-\\[21px\\]{height:21px}.h-\\[42px\\]{height:42px}.h-auto{height:auto}.h-full{height:100%}.max-h-\\[150px\\]{max-height:150px}.w-1{width:.25rem}.w-1\\/12{width:8.333333%}.w-10{width:2.5rem}.w-16{width:4rem}.w-2{width:.5rem}.w-2\\/5{width:40%}.w-40{width:10rem}.w-48{width:12rem}.w-5{width:1.25rem}.w-6{width:1.5rem}.w-80{width:20rem}.w-\\[15\\%\\]{width:15%}.w-\\[21px\\]{width:21px}.w-\\[42px\\]{width:42px}.w-auto{width:auto}.w-full{width:100%}.max-w-\\[150px\\]{max-width:150px}.max-w-full{max-width:100%}.max-w-sm{max-width:24rem}.flex-1{flex:1 1 0%}.flex-\\[0\\.25\\]{flex:.25}.flex-none{flex:none}.grow{flex-grow:1}.table-fixed{table-layout:fixed}.-translate-x-1\\/2{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-0{--tw-translate-y: -0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-0\\.5{--tw-translate-y: -.125rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-x-\\[-2px\\]{--tw-translate-x: -2px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-0{--tw-translate-y: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-0\\.5{--tw-translate-y: .125rem;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-90{--tw-rotate: -90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-0{--tw-rotate: 0deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}.cursor-col-resize{cursor:col-resize}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.grid-cols-2-auto{grid-template-columns:minmax(auto,max-content) 1fr}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-6{gap:1.5rem}.gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.5rem * var(--tw-space-y-reverse))}.space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}.space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}.divide-x>:not([hidden])~:not([hidden]){--tw-divide-x-reverse: 0;border-right-width:calc(1px * var(--tw-divide-x-reverse));border-left-width:calc(1px * calc(1 - var(--tw-divide-x-reverse)))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-primary-700>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(67 56 202 / var(--tw-divide-opacity))}.divide-primary-800>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(55 48 163 / var(--tw-divide-opacity))}.divide-primary-900>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(49 46 129 / var(--tw-divide-opacity))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.whitespace-nowrap{white-space:nowrap}.whitespace-pre-line{white-space:pre-line}.whitespace-pre-wrap{white-space:pre-wrap}.break-words{overflow-wrap:break-word}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:.5rem}.rounded-md{border-radius:.375rem}.rounded-sm{border-radius:.125rem}.rounded-r-full{border-top-right-radius:9999px;border-bottom-right-radius:9999px}.border{border-width:1px}.border-y{border-top-width:1px;border-bottom-width:1px}.\\!border-t-0{border-top-width:0px!important}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-l{border-left-width:1px}.border-primary-200{--tw-border-opacity: 1;border-color:rgb(199 210 254 / var(--tw-border-opacity))}.border-primary-300{--tw-border-opacity: 1;border-color:rgb(165 180 252 / var(--tw-border-opacity))}.border-primary-400{--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}.border-primary-500{--tw-border-opacity: 1;border-color:rgb(99 102 241 / var(--tw-border-opacity))}.border-primary-600{--tw-border-opacity: 1;border-color:rgb(79 70 229 / var(--tw-border-opacity))}.border-primary-800{--tw-border-opacity: 1;border-color:rgb(55 48 163 / var(--tw-border-opacity))}.border-primary-900{--tw-border-opacity: 1;border-color:rgb(49 46 129 / var(--tw-border-opacity))}.border-primary-950{--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity))}.border-transparent{border-color:transparent}.border-b-primary-400{--tw-border-opacity: 1;border-bottom-color:rgb(129 140 248 / var(--tw-border-opacity))}.border-b-primary-700{--tw-border-opacity: 1;border-bottom-color:rgb(67 56 202 / var(--tw-border-opacity))}.border-b-primary-900{--tw-border-opacity: 1;border-bottom-color:rgb(49 46 129 / var(--tw-border-opacity))}.border-l-primary-400{--tw-border-opacity: 1;border-left-color:rgb(129 140 248 / var(--tw-border-opacity))}.\\!bg-transparent{background-color:transparent!important}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity))}.bg-green-400{--tw-bg-opacity: 1;background-color:rgb(74 222 128 / var(--tw-bg-opacity))}.bg-primary-200{--tw-bg-opacity: 1;background-color:rgb(199 210 254 / var(--tw-bg-opacity))}.bg-primary-400{--tw-bg-opacity: 1;background-color:rgb(129 140 248 / var(--tw-bg-opacity))}.bg-primary-500{--tw-bg-opacity: 1;background-color:rgb(99 102 241 / var(--tw-bg-opacity))}.bg-primary-600{--tw-bg-opacity: 1;background-color:rgb(79 70 229 / var(--tw-bg-opacity))}.bg-primary-700{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity))}.bg-primary-800{--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.bg-primary-900{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}.bg-primary-950{--tw-bg-opacity: 1;background-color:rgb(30 27 75 / var(--tw-bg-opacity))}.bg-red-400{--tw-bg-opacity: 1;background-color:rgb(248 113 113 / var(--tw-bg-opacity))}.bg-red-500{--tw-bg-opacity: 1;background-color:rgb(239 68 68 / var(--tw-bg-opacity))}.bg-transparent{background-color:transparent}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.bg-opacity-20{--tw-bg-opacity: .2}.bg-opacity-30{--tw-bg-opacity: .3}.bg-gradient-to-br{background-image:linear-gradient(to bottom right,var(--tw-gradient-stops))}.from-primary-900{--tw-gradient-from: #312e81 var(--tw-gradient-from-position);--tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)}.to-primary-950{--tw-gradient-to: #1e1b4b var(--tw-gradient-to-position)}.to-20\\%{--tw-gradient-to-position: 20%}.fill-green-400{fill:#4ade80}.fill-primary-200{fill:#c7d2fe}.fill-primary-300{fill:#a5b4fc}.fill-primary-50{fill:#eef2ff}.fill-red-400{fill:#f87171}.stroke-gray-400{stroke:#9ca3af}.stroke-green-400{stroke:#4ade80}.stroke-primary-200{stroke:#c7d2fe}.stroke-primary-300{stroke:#a5b4fc}.stroke-primary-400{stroke:#818cf8}.stroke-primary-500{stroke:#6366f1}.stroke-primary-600{stroke:#4f46e5}.stroke-primary-700{stroke:#4338ca}.stroke-red-400{stroke:#f87171}.p-0{padding:0}.p-0\\.5{padding:.125rem}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-3{padding:.75rem}.p-4{padding:1rem}.p-6{padding:1.5rem}.px-1{padding-left:.25rem;padding-right:.25rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-3\\.5{padding-top:.875rem;padding-bottom:.875rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-4{padding-bottom:1rem}.pb-6{padding-bottom:1.5rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pr-10{padding-right:2.5rem}.pr-4{padding-right:1rem}.pr-6{padding-right:1.5rem}.pt-2{padding-top:.5rem}.text-left{text-align:left}.text-right{text-align:right}.align-top{vertical-align:top}.\\!font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace!important}.font-mono{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}.font-raleway{font-family:Raleway,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.font-sans{font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.text-2xl{font-size:1.5rem;line-height:2rem}.text-3xl{font-size:1.875rem;line-height:2.25rem}.text-\\[0\\.65rem\\]{font-size:.65rem}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xl{font-size:1.25rem;line-height:1.75rem}.text-xs{font-size:.75rem;line-height:1rem}.font-bold{font-weight:700}.font-light{font-weight:300}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.leading-7{line-height:1.75rem}.leading-8{line-height:2rem}.tracking-widest{letter-spacing:.1em}.text-green-400{--tw-text-opacity: 1;color:rgb(74 222 128 / var(--tw-text-opacity))}.text-orange-400{--tw-text-opacity: 1;color:rgb(251 146 60 / var(--tw-text-opacity))}.text-primary-100{--tw-text-opacity: 1;color:rgb(224 231 255 / var(--tw-text-opacity))}.text-primary-200{--tw-text-opacity: 1;color:rgb(199 210 254 / var(--tw-text-opacity))}.text-primary-300{--tw-text-opacity: 1;color:rgb(165 180 252 / var(--tw-text-opacity))}.text-primary-400{--tw-text-opacity: 1;color:rgb(129 140 248 / var(--tw-text-opacity))}.text-primary-50{--tw-text-opacity: 1;color:rgb(238 242 255 / var(--tw-text-opacity))}.text-primary-500{--tw-text-opacity: 1;color:rgb(99 102 241 / var(--tw-text-opacity))}.text-red-400{--tw-text-opacity: 1;color:rgb(248 113 113 / var(--tw-text-opacity))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity))}.text-yellow-400{--tw-text-opacity: 1;color:rgb(250 204 21 / var(--tw-text-opacity))}.underline{text-decoration-line:underline}.opacity-80{opacity:.8}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-inner{--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / .05);--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.ring{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.spotlight-fullscreen-blur{position:fixed;display:flex;height:100vh;width:100vw;flex-direction:column;overflow:hidden;background-color:rgb(0 0 0 / var(--tw-bg-opacity));--tw-bg-opacity: .5;--tw-backdrop-blur: blur(4px);-webkit-backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);z-index:999998}.spotlight-debugger{display:flex;height:100%;flex-direction:column;overflow:hidden;border-radius:.5rem;background-image:linear-gradient(to bottom right,var(--tw-gradient-stops));--tw-gradient-from: #312e81 var(--tw-gradient-from-position);--tw-gradient-to: rgb(49 46 129 / 0) var(--tw-gradient-to-position);--tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);--tw-gradient-to: #1e1b4b var(--tw-gradient-to-position);--tw-gradient-to-position: 20%;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity));--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);margin:2.5vh}.spotlight-fullscreen{position:relative;border-radius:0;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow);margin:0}.spotlight-sidepanel{-webkit-app-region:no-drag;animation:sidepanel .1s ease-in}@keyframes sidepanel{0%{transform:translate(100%)}to{transform:translate(0)}}ul.tree{position:relative}ul.tree ul.tree{position:static}ul.tree,ul.tree ul{list-style:none;margin:0;padding:0}ul.tree ul{margin-left:8px}ul.tree li{border-left-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}ul.tree li:last-child{border-width:0px}ul.tree>li:first-child:before{display:none}ul.tree>li:before,ul.tree ul.tree>li:before{border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity));position:absolute;margin-top:-2px;height:15px;width:12px;content:"";display:inline-block;margin-left:-16px}ul.tree li:last-child:before{border-left-width:1px;--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}.tree .node{display:flex;align-items:center;-moz-column-gap:.25rem;column-gap:.25rem;overflow:auto;padding-top:.25rem;padding-bottom:.25rem;padding-left:.25rem}.tree .waterfall{position:absolute;right:0;height:1.75rem;border-left-width:2px;--tw-border-opacity: 1;border-left-color:rgb(55 48 163 / var(--tw-border-opacity));--tw-bg-opacity: 1;background-color:rgb(30 27 75 / var(--tw-bg-opacity));padding-top:.25rem;padding-bottom:.25rem;padding-left:.25rem}.table-values{border-collapse:collapse;--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity));font-size:.875rem;line-height:1.25rem}.table-values tbody th{width:8.333333%;border-top-width:1px;border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity));padding:.25rem .5rem;text-align:right;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-weight:400;--tw-text-opacity: 1;color:rgb(165 180 252 / var(--tw-text-opacity))}.table-values tbody td{border-top-width:1px;border-bottom-width:1px;--tw-border-opacity: 1;border-color:rgb(30 27 75 / var(--tw-border-opacity));padding:.25rem .5rem}.hydration-error-wrapper pre{--tw-text-opacity: 1 !important;color:rgb(165 180 252 / var(--tw-text-opacity))!important}.hydration-error-wrapper td[class^=react-diff][class$=title-block]{--tw-bg-opacity: 1 !important;background-color:rgb(49 46 129 / var(--tw-bg-opacity))!important}.react-json-view{border-radius:.125rem;background-color:rgb(49 46 129 / var(--tw-bg-opacity))!important;--tw-bg-opacity: .5 !important;padding:.5rem}.react-json-view .string-value{word-break:break-word}input:checked{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}input:checked~.dot{--tw-translate-x: 100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.last\\:border-b-0:last-child{border-bottom-width:0px}.hover\\:border-primary-400:hover{--tw-border-opacity: 1;border-color:rgb(129 140 248 / var(--tw-border-opacity))}.hover\\:border-primary-500:hover{--tw-border-opacity: 1;border-color:rgb(99 102 241 / var(--tw-border-opacity))}.hover\\:border-primary-700:hover{--tw-border-opacity: 1;border-color:rgb(67 56 202 / var(--tw-border-opacity))}.hover\\:bg-primary-400:hover{--tw-bg-opacity: 1;background-color:rgb(129 140 248 / var(--tw-bg-opacity))}.hover\\:bg-primary-700:hover{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity))}.hover\\:bg-primary-800:hover{--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.hover\\:bg-primary-900:hover{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}.hover\\:text-primary-100:hover{--tw-text-opacity: 1;color:rgb(224 231 255 / var(--tw-text-opacity))}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:transition-colors:hover{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.focus\\:bg-primary-800:focus{--tw-bg-opacity: 1;background-color:rgb(55 48 163 / var(--tw-bg-opacity))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.group:hover .group-hover\\:bg-primary-900{--tw-bg-opacity: 1;background-color:rgb(49 46 129 / var(--tw-bg-opacity))}@media (min-width: 640px){.sm\\:block{display:block}.sm\\:hidden{display:none}.sm\\:text-sm{font-size:.875rem;line-height:1.25rem}}@media (min-width: 768px){.md\\:inline-block{display:inline-block}}.\\[\\&\\>\\.count\\]\\:bg-primary-100>.count{--tw-bg-opacity: 1;background-color:rgb(224 231 255 / var(--tw-bg-opacity))}.\\[\\&\\>\\.count\\]\\:bg-primary-700>.count{--tw-bg-opacity: 1;background-color:rgb(67 56 202 / var(--tw-bg-opacity))}.\\[\\&\\>\\.count\\]\\:text-primary-200>.count{--tw-text-opacity: 1;color:rgb(199 210 254 / var(--tw-text-opacity))}.\\[\\&\\>\\.count\\]\\:text-primary-600>.count{--tw-text-opacity: 1;color:rgb(79 70 229 / var(--tw-text-opacity))}
`;
async function Sv(n = [], a) {
  if (!n)
    return [[], []];
  const s = [], o = [];
  for (const c of n)
    if (Array.isArray(c)) {
      const E = await Sv(c, a);
      s.push(...E[0]), o.push(...E[1]);
    } else if (c) {
      if (c.setup) {
        const E = await c.setup(a);
        E && o.push(E);
      }
      s.push(c);
    }
  return [s, o];
}
function dC() {
  let n = (/* @__PURE__ */ new Date()).getTime();
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(a) {
    let s = Math.random() * 16;
    return s = (n + s) % 16 | 0, n = Math.floor(n / 16), (a === "x" ? s : s & 3 | 8).toString(16);
  });
}
function hv() {
  return u2(window.fetch) ? window.fetch.__sentry_original__ : window.fetch;
}
function u2(n) {
  return "__sentry_original__" in n;
}
function oT(n) {
  return n.includes("javascript.astro") ? "javascript.astro" : n.includes("javascript") ? "javascript" : n.includes("java") ? "java" : n.includes("python") ? "python" : n.includes("php.laravel") ? "php.laravel" : n.includes("php.symfony") ? "php.symfony" : n.includes("php") ? "php" : n.includes("ruby") ? "ruby" : n.includes("dotnet") ? "dotnet" : "unknown";
}
function E2(n) {
  const a = [], s = /* @__PURE__ */ new Map(), o = [...n].sort((c, E) => (c.parent_span_id ? 1 : 0) - (E.parent_span_id ? 1 : 0));
  return o.forEach((c) => {
    let E = c2(c, s, o);
    if (c.children || (c.children = []), E)
      E.children || (E.children = []), E.children.push(c);
    else if (c.parent_span_id) {
      const u = o.find((R) => !R.parent_span_id);
      vt(u ? `Creating orphan for parent (${c.parent_span_id}) for span (${c.span_id})` : `Root span (${c.parent_span_id}) for span (${c.span_id}). Creating orphan.`), E = {
        trace_id: c.trace_id,
        span_id: c.parent_span_id,
        parent_span_id: u ? u.span_id : null,
        op: "orphan",
        description: "missing or unknown parent span",
        children: [c],
        start_timestamp: c.start_timestamp,
        timestamp: c.timestamp,
        status: "unknown"
      }, s.set(E.span_id, E), u ? (u.children || (u.children = []), u.children.push(E)) : a.push(E);
    } else
      a.push(c);
    s.set(c.span_id, c);
  }), a;
}
function c2(n, a, s) {
  if (n.parent_span_id)
    return a.has(n.parent_span_id) ? a.get(n.parent_span_id) : s.find((o) => o.span_id === n.parent_span_id);
}
function gf(n) {
  return typeof n == "string" ? new Date(n).getTime() : n * 1e3;
}
class f2 {
  constructor(a = []) {
    Ht(this, "events", []);
    Ht(this, "eventIds", /* @__PURE__ */ new Set());
    Ht(this, "sdks", []);
    Ht(this, "traces", []);
    Ht(this, "tracesById", {});
    Ht(this, "localTraceIds", /* @__PURE__ */ new Set());
    Ht(this, "envelopes", []);
    Ht(this, "subscribers", /* @__PURE__ */ new Map());
    Ht(this, "contextLinesProvider", new URL(bS).origin + oC);
    a.forEach((s) => this.pushEvent(s));
  }
  setSidecarUrl(a) {
    const { origin: s } = new URL(a);
    this.contextLinesProvider = s + oC;
  }
  inferSdkFromEvent(a) {
    const s = {
      name: "unknown",
      version: "unknown",
      lastSeen: (/* @__PURE__ */ new Date()).getTime()
    };
    return a.sdk ? (s.name = a.sdk.name || s.name, s.version = a.sdk.version || s.version) : a.platform && (s.name = a.platform), s;
  }
  pushEnvelope({ envelope: a, rawEnvelope: s }) {
    const [o, c] = a, E = new Date(o.sent_at).getTime();
    let u;
    o.sdk && o.sdk.name && o.sdk.version ? u = {
      name: o.sdk.name,
      version: o.sdk.version,
      lastSeen: E
    } : c.length > 0 ? u = this.inferSdkFromEvent(c[0][1]) : u = {
      name: "unknown",
      version: "0.0.0",
      lastSeen: E
    };
    const R = this.sdks.find((d) => d.name === u.name && d.version === u.version);
    R ? R.lastSeen = E : this.sdks.push({
      name: u.name,
      version: u.version,
      lastSeen: E
    });
    for (const [d, T] of c)
      (d.type === "event" || d.type === "transaction") && (T.platform = oT(u.name), this.pushEvent(T));
    return this.envelopes.push({ envelope: a, rawEnvelope: s });
  }
  async pushEvent(a) {
    var o;
    if (a.event_id || (a.event_id = dC()), this.eventIds.has(a.event_id))
      return;
    T2(a) && await this.processStacktrace(a), a.timestamp = gf(a.timestamp), a.start_timestamp && (a.start_timestamp = gf(a.start_timestamp));
    const s = (o = a.contexts) == null ? void 0 : o.trace;
    if (this.events.push(a), s) {
      const c = this.tracesById[s.trace_id], E = a.start_timestamp ? a.start_timestamp : (/* @__PURE__ */ new Date()).getTime(), u = c ?? {
        ...s,
        spans: [],
        transactions: [],
        errors: 0,
        timestamp: a.timestamp,
        start_timestamp: E,
        status: s.status,
        rootTransactionName: a.transaction || "(unknown transaction)",
        rootTransaction: null
      };
      if (a.type === "transaction") {
        u.transactions.push(a), u.transactions.sort((T, S) => T.start_timestamp - S.start_timestamp);
        const d = [];
        u.transactions.forEach((T) => {
          d.push({
            ...T.contexts.trace,
            tags: T == null ? void 0 : T.tags,
            start_timestamp: T.start_timestamp,
            timestamp: T.timestamp,
            description: s.description || T.transaction,
            transaction: T
          }), T.spans && d.push(
            ...T.spans.map((S) => ({
              ...S,
              timestamp: gf(S.timestamp),
              start_timestamp: gf(S.start_timestamp)
            }))
          );
        }), u.spans = d, u.spanTree = E2(u.spans);
      } else
        u.errors += 1;
      u.start_timestamp = Math.min(E, u.start_timestamp), u.timestamp = Math.max(a.timestamp, u.timestamp), s.status !== "ok" && (u.status = s.status);
      const R = u.transactions.filter((d) => !d.contexts.trace.parent_span_id);
      R.length === 1 ? (u.rootTransaction = R[0], u.rootTransactionName = R[0].transaction || "(unknown transaction)") : R.length > 1 ? u.rootTransactionName = "(multiple root transactions)" : u.rootTransactionName = "(missing root transaction)", c || (this.traces.unshift(u), this.tracesById[u.trace_id] = u), this.subscribers.forEach(([d, T]) => d === "trace" && T(u));
    }
    this.subscribers.forEach(([c, E]) => c === "event" && E(a)), this.eventIds.add(a.event_id);
  }
  getEvents() {
    return [...this.events];
  }
  getTraces() {
    return [...this.traces];
  }
  getSdks() {
    return [...this.sdks];
  }
  getEnvelopes() {
    return [...this.envelopes];
  }
  getEventById(a) {
    return this.events.find((s) => s.event_id === a);
  }
  getTraceById(a) {
    return this.tracesById[a];
  }
  getEventsByTrace(a, s) {
    return this.events.filter(
      (o) => {
        var c, E, u, R;
        return ((E = (c = o.contexts) == null ? void 0 : c.trace) == null ? void 0 : E.trace_id) === a && (!s || ((R = (u = o.contexts) == null ? void 0 : u.trace) == null ? void 0 : R.span_id) === s);
      }
    );
  }
  getSpanById(a, s) {
    const o = this.tracesById[a];
    if (o)
      return o.spans.find((c) => c.span_id === s);
  }
  resetData() {
    this.envelopes = [], this.events = [], this.eventIds = /* @__PURE__ */ new Set(), this.traces = [], this.tracesById = {}, this.localTraceIds = /* @__PURE__ */ new Set();
  }
  subscribe(...a) {
    const s = dC();
    return this.subscribers.set(s, a), () => {
      this.subscribers.delete(s);
    };
  }
  /**
   * Mark a traceId as being seen in the local session.
   *
   * @param traceId
   */
  trackLocalTrace(a) {
    this.localTraceIds.add(a);
  }
  /**
   * Determine if a traceId was seen in the local session.
   *
   * A result of `null` means "unknown", which implies there is no known
   * information about any session-initiated traces.
   */
  isTraceLocal(a) {
    return this.localTraceIds.has(a) ? !0 : this.localTraceIds.size > 0 ? !1 : null;
  }
  /**
   * Reverses the stack trace and tries to fill missing context lines
   * @param errorEvent
   * @returns
   */
  async processStacktrace(a) {
    return !a.exception || !a.exception.values ? [] : Promise.all(
      (a.exception.values ?? []).map(async (s) => {
        var o;
        if (!s.stacktrace || (o = s.stacktrace.frames) != null && o.every((c) => c.post_context && c.pre_context && c.context_line)) {
          vt("Skipping contextlines request for", s);
          return;
        }
        s.stacktrace.frames.reverse();
        try {
          const E = await hv()(this.contextLinesProvider, {
            method: "PUT",
            body: JSON.stringify(s.stacktrace)
          });
          if (!E.ok || E.status !== 200)
            return;
          const u = await E.json();
          s.stacktrace = u;
        } catch {
        }
      })
    );
  }
}
const Ut = new f2();
function T2(n) {
  return n.type != "transaction";
}
const Nv = Object.prototype.toString;
function d2(n) {
  switch (Nv.call(n)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return lT(n, Error);
  }
}
function Ov(n, a) {
  return Nv.call(n) === `[object ${a}]`;
}
function A2(n) {
  return Ov(n, "String");
}
function R2(n) {
  return Ov(n, "Object");
}
function p2(n) {
  return typeof Event < "u" && lT(n, Event);
}
function S2(n) {
  return typeof Element < "u" && lT(n, Element);
}
function h2(n) {
  return R2(n) && "nativeEvent" in n && "preventDefault" in n && "stopPropagation" in n;
}
function lT(n, a) {
  try {
    return n instanceof a;
  } catch {
    return !1;
  }
}
function N2(n) {
  return !!(typeof n == "object" && n !== null && (n.__isVue || n._isVue));
}
const Vf = globalThis, O2 = Vf, I2 = 80;
function _2(n, a = {}) {
  if (!n)
    return "<unknown>";
  try {
    let s = n;
    const o = 5, c = [];
    let E = 0, u = 0;
    const R = " > ", d = R.length;
    let T;
    const S = Array.isArray(a) ? a : a.keyAttrs, N = !Array.isArray(a) && a.maxStringLength || I2;
    for (; s && E++ < o && (T = C2(s, S), !(T === "html" || E > 1 && u + c.length * d + T.length >= N)); )
      c.push(T), u += T.length, s = s.parentNode;
    return c.reverse().join(R);
  } catch {
    return "<unknown>";
  }
}
function C2(n, a) {
  const s = n, o = [];
  let c, E, u, R, d;
  if (!s || !s.tagName)
    return "";
  if (O2.HTMLElement && s instanceof HTMLElement && s.dataset) {
    if (s.dataset.sentryComponent)
      return s.dataset.sentryComponent;
    if (s.dataset.sentryElement)
      return s.dataset.sentryElement;
  }
  o.push(s.tagName.toLowerCase());
  const T = a && a.length ? a.filter((N) => s.getAttribute(N)).map((N) => [N, s.getAttribute(N)]) : null;
  if (T && T.length)
    T.forEach((N) => {
      o.push(`[${N[0]}="${N[1]}"]`);
    });
  else if (s.id && o.push(`#${s.id}`), c = s.className, c && A2(c))
    for (E = c.split(/\s+/), d = 0; d < E.length; d++)
      o.push(`.${E[d]}`);
  const S = ["aria-label", "type", "name", "title", "alt"];
  for (d = 0; d < S.length; d++)
    u = S[d], R = s.getAttribute(u), R && o.push(`[${u}="${R}"]`);
  return o.join("");
}
function m2(n) {
  if (d2(n))
    return {
      message: n.message,
      name: n.name,
      stack: n.stack,
      ...RC(n)
    };
  if (p2(n)) {
    const a = {
      type: n.type,
      target: AC(n.target),
      currentTarget: AC(n.currentTarget),
      ...RC(n)
    };
    return typeof CustomEvent < "u" && lT(n, CustomEvent) && (a.detail = n.detail), a;
  } else
    return n;
}
function AC(n) {
  try {
    return S2(n) ? _2(n) : Object.prototype.toString.call(n);
  } catch {
    return "<unknown>";
  }
}
function RC(n) {
  if (typeof n == "object" && n !== null) {
    const a = {};
    for (const s in n)
      Object.prototype.hasOwnProperty.call(n, s) && (a[s] = n[s]);
    return a;
  } else
    return {};
}
const wp = "<anonymous>";
function v2(n) {
  try {
    return !n || typeof n != "function" ? wp : n.name || wp;
  } catch {
    return wp;
  }
}
function L2() {
  const n = typeof WeakSet == "function", a = n ? /* @__PURE__ */ new WeakSet() : [];
  function s(c) {
    if (n)
      return a.has(c) ? !0 : (a.add(c), !1);
    for (let E = 0; E < a.length; E++)
      if (a[E] === c)
        return !0;
    return a.push(c), !1;
  }
  function o(c) {
    if (n)
      a.delete(c);
    else
      for (let E = 0; E < a.length; E++)
        if (a[E] === c) {
          a.splice(E, 1);
          break;
        }
  }
  return [s, o];
}
function y2(n, a = 100, s = 1 / 0) {
  try {
    return dS("", n, a, s);
  } catch (o) {
    return { ERROR: `**non-serializable** (${o})` };
  }
}
function dS(n, a, s = 1 / 0, o = 1 / 0, c = L2()) {
  const [E, u] = c;
  if (a == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof a) && !Number.isNaN(a))
    return a;
  const R = g2(n, a);
  if (!R.startsWith("[object "))
    return R;
  if (a.__sentry_skip_normalization__)
    return a;
  const d = typeof a.__sentry_override_normalization_depth__ == "number" ? a.__sentry_override_normalization_depth__ : s;
  if (d === 0)
    return R.replace("object ", "");
  if (E(a))
    return "[Circular ~]";
  const T = a;
  if (T && typeof T.toJSON == "function")
    try {
      const v = T.toJSON();
      return dS("", v, d - 1, o, c);
    } catch {
    }
  const S = Array.isArray(a) ? [] : {};
  let N = 0;
  const m = m2(a);
  for (const v in m) {
    if (!Object.prototype.hasOwnProperty.call(m, v))
      continue;
    if (N >= o) {
      S[v] = "[MaxProperties ~]";
      break;
    }
    const M = m[v];
    S[v] = dS(v, M, d - 1, o, c), N++;
  }
  return u(a), S;
}
function g2(n, a) {
  try {
    if (n === "domain" && a && typeof a == "object" && a._events)
      return "[Domain]";
    if (n === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && a === global)
      return "[Global]";
    if (typeof window < "u" && a === window)
      return "[Window]";
    if (typeof document < "u" && a === document)
      return "[Document]";
    if (N2(a))
      return "[VueViewModel]";
    if (h2(a))
      return "[SyntheticEvent]";
    if (typeof a == "number" && a !== a)
      return "[NaN]";
    if (typeof a == "function")
      return `[Function: ${v2(a)}]`;
    if (typeof a == "symbol")
      return `[${String(a)}]`;
    if (typeof a == "bigint")
      return `[BigInt: ${String(a)}]`;
    const s = D2(a);
    return /^HTML(\w*)Element$/.test(s) ? `[HTMLElement: ${s}]` : `[object ${s}]`;
  } catch (s) {
    return `**non-serializable** (${s})`;
  }
}
function D2(n) {
  const a = Object.getPrototypeOf(n);
  return a ? a.constructor.name : "null prototype";
}
function pC(n) {
  return Vf.__SENTRY__ && Vf.__SENTRY__.encodePolyfill ? Vf.__SENTRY__.encodePolyfill(n) : new TextEncoder().encode(n);
}
function b2(n) {
  const [a, s] = n;
  let o = JSON.stringify(a);
  function c(E) {
    typeof o == "string" ? o = typeof E == "string" ? o + E : [pC(o), E] : o.push(typeof E == "string" ? pC(E) : E);
  }
  for (const E of s) {
    const [u, R] = E;
    if (c(`
${JSON.stringify(u)}
`), typeof R == "string" || R instanceof Uint8Array)
      c(R);
    else {
      let d;
      try {
        d = JSON.stringify(R);
      } catch {
        d = JSON.stringify(y2(R));
      }
      c(d);
    }
  }
  return typeof o == "string" ? o : M2(o);
}
function M2(n) {
  const a = n.reduce((c, E) => c + E.length, 0), s = new Uint8Array(a);
  let o = 0;
  for (const c of n)
    s.set(c, o), o += c.length;
  return s;
}
const P2 = (n) => {
  const a = (n == null ? void 0 : n.sidecarUrl) ?? bS;
  return {
    name: "SpotlightBrowser",
    setupOnce: () => {
    },
    setup: () => {
      vt("Using Sidecar URL", a);
    },
    processEvent: async (s) => {
      var c, E;
      if (x2(s))
        return null;
      const o = (E = (c = s.contexts) == null ? void 0 : c.trace) == null ? void 0 : E.trace_id;
      return o && Ut.trackLocalTrace(o), s.type || !s.exception || !s.exception.values, s;
    },
    afterAllSetup: (s) => {
      U2(s, a);
    }
  };
};
function U2(n, a) {
  const s = hv();
  n.on("beforeEnvelope", (o) => {
    s(a, {
      method: "POST",
      body: b2(o),
      headers: {
        "Content-Type": "application/x-sentry-envelope"
      },
      mode: "cors"
    }).catch((c) => {
      console.error(
        "Sentry SDK can't connect to Sidecar is it running? See: https://spotlightjs.com/sidecar/npx/",
        c
      );
    });
  });
}
function x2(n) {
  var a, s;
  return n.type === "transaction" && ((s = (a = n.contexts) == null ? void 0 : a.trace) == null ? void 0 : s.op) === "ui.action.click" && n.spans ? !!n.spans.find((c) => {
    var E;
    return (E = c.description) == null ? void 0 : E.includes("#sentry-spotlight");
  }) : !1;
}
var Iv = { exports: {} };
(function(n, a) {
  (function(s, o) {
    n.exports = o();
  })(Yt, function() {
    var s = 1e3, o = 6e4, c = 36e5, E = "millisecond", u = "second", R = "minute", d = "hour", T = "day", S = "week", N = "month", m = "quarter", v = "year", M = "date", w = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, O = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(z) {
      var Z = ["th", "st", "nd", "rd"], ee = z % 100;
      return "[" + z + (Z[(ee - 20) % 10] || Z[ee] || Z[0]) + "]";
    } }, V = function(z, Z, ee) {
      var oe = String(z);
      return !oe || oe.length >= Z ? z : "" + Array(Z + 1 - oe.length).join(ee) + z;
    }, D = { s: V, z: function(z) {
      var Z = -z.utcOffset(), ee = Math.abs(Z), oe = Math.floor(ee / 60), ne = ee % 60;
      return (Z <= 0 ? "+" : "-") + V(oe, 2, "0") + ":" + V(ne, 2, "0");
    }, m: function z(Z, ee) {
      if (Z.date() < ee.date())
        return -z(ee, Z);
      var oe = 12 * (ee.year() - Z.year()) + (ee.month() - Z.month()), ne = Z.clone().add(oe, N), de = ee - ne < 0, ve = Z.clone().add(oe + (de ? -1 : 1), N);
      return +(-(oe + (ee - ne) / (de ? ne - ve : ve - ne)) || 0);
    }, a: function(z) {
      return z < 0 ? Math.ceil(z) || 0 : Math.floor(z);
    }, p: function(z) {
      return { M: N, y: v, w: S, d: T, D: M, h: d, m: R, s: u, ms: E, Q: m }[z] || String(z || "").toLowerCase().replace(/s$/, "");
    }, u: function(z) {
      return z === void 0;
    } }, G = "en", P = {};
    P[G] = g;
    var U = function(z) {
      return z instanceof F;
    }, Y = function z(Z, ee, oe) {
      var ne;
      if (!Z)
        return G;
      if (typeof Z == "string") {
        var de = Z.toLowerCase();
        P[de] && (ne = de), ee && (P[de] = ee, ne = de);
        var ve = Z.split("-");
        if (!ne && ve.length > 1)
          return z(ve[0]);
      } else {
        var Fe = Z.name;
        P[Fe] = Z, ne = Fe;
      }
      return !oe && ne && (G = ne), ne || !oe && G;
    }, X = function(z, Z) {
      if (U(z))
        return z.clone();
      var ee = typeof Z == "object" ? Z : {};
      return ee.date = z, ee.args = arguments, new F(ee);
    }, _ = D;
    _.l = Y, _.i = U, _.w = function(z, Z) {
      return X(z, { locale: Z.$L, utc: Z.$u, x: Z.$x, $offset: Z.$offset });
    };
    var F = function() {
      function z(ee) {
        this.$L = Y(ee.locale, null, !0), this.parse(ee);
      }
      var Z = z.prototype;
      return Z.parse = function(ee) {
        this.$d = function(oe) {
          var ne = oe.date, de = oe.utc;
          if (ne === null)
            return /* @__PURE__ */ new Date(NaN);
          if (_.u(ne))
            return /* @__PURE__ */ new Date();
          if (ne instanceof Date)
            return new Date(ne);
          if (typeof ne == "string" && !/Z$/i.test(ne)) {
            var ve = ne.match(y);
            if (ve) {
              var Fe = ve[2] - 1 || 0, et = (ve[7] || "0").substring(0, 3);
              return de ? new Date(Date.UTC(ve[1], Fe, ve[3] || 1, ve[4] || 0, ve[5] || 0, ve[6] || 0, et)) : new Date(ve[1], Fe, ve[3] || 1, ve[4] || 0, ve[5] || 0, ve[6] || 0, et);
            }
          }
          return new Date(ne);
        }(ee), this.$x = ee.x || {}, this.init();
      }, Z.init = function() {
        var ee = this.$d;
        this.$y = ee.getFullYear(), this.$M = ee.getMonth(), this.$D = ee.getDate(), this.$W = ee.getDay(), this.$H = ee.getHours(), this.$m = ee.getMinutes(), this.$s = ee.getSeconds(), this.$ms = ee.getMilliseconds();
      }, Z.$utils = function() {
        return _;
      }, Z.isValid = function() {
        return this.$d.toString() !== w;
      }, Z.isSame = function(ee, oe) {
        var ne = X(ee);
        return this.startOf(oe) <= ne && ne <= this.endOf(oe);
      }, Z.isAfter = function(ee, oe) {
        return X(ee) < this.startOf(oe);
      }, Z.isBefore = function(ee, oe) {
        return this.endOf(oe) < X(ee);
      }, Z.$g = function(ee, oe, ne) {
        return _.u(ee) ? this[oe] : this.set(ne, ee);
      }, Z.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, Z.valueOf = function() {
        return this.$d.getTime();
      }, Z.startOf = function(ee, oe) {
        var ne = this, de = !!_.u(oe) || oe, ve = _.p(ee), Fe = function(Kt, ot) {
          var xt = _.w(ne.$u ? Date.UTC(ne.$y, ot, Kt) : new Date(ne.$y, ot, Kt), ne);
          return de ? xt : xt.endOf(T);
        }, et = function(Kt, ot) {
          return _.w(ne.toDate()[Kt].apply(ne.toDate("s"), (de ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ot)), ne);
        }, Ke = this.$W, Et = this.$M, Ct = this.$D, xn = "set" + (this.$u ? "UTC" : "");
        switch (ve) {
          case v:
            return de ? Fe(1, 0) : Fe(31, 11);
          case N:
            return de ? Fe(1, Et) : Fe(0, Et + 1);
          case S:
            var Tn = this.$locale().weekStart || 0, _n = (Ke < Tn ? Ke + 7 : Ke) - Tn;
            return Fe(de ? Ct - _n : Ct + (6 - _n), Et);
          case T:
          case M:
            return et(xn + "Hours", 0);
          case d:
            return et(xn + "Minutes", 1);
          case R:
            return et(xn + "Seconds", 2);
          case u:
            return et(xn + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, Z.endOf = function(ee) {
        return this.startOf(ee, !1);
      }, Z.$set = function(ee, oe) {
        var ne, de = _.p(ee), ve = "set" + (this.$u ? "UTC" : ""), Fe = (ne = {}, ne[T] = ve + "Date", ne[M] = ve + "Date", ne[N] = ve + "Month", ne[v] = ve + "FullYear", ne[d] = ve + "Hours", ne[R] = ve + "Minutes", ne[u] = ve + "Seconds", ne[E] = ve + "Milliseconds", ne)[de], et = de === T ? this.$D + (oe - this.$W) : oe;
        if (de === N || de === v) {
          var Ke = this.clone().set(M, 1);
          Ke.$d[Fe](et), Ke.init(), this.$d = Ke.set(M, Math.min(this.$D, Ke.daysInMonth())).$d;
        } else
          Fe && this.$d[Fe](et);
        return this.init(), this;
      }, Z.set = function(ee, oe) {
        return this.clone().$set(ee, oe);
      }, Z.get = function(ee) {
        return this[_.p(ee)]();
      }, Z.add = function(ee, oe) {
        var ne, de = this;
        ee = Number(ee);
        var ve = _.p(oe), Fe = function(Et) {
          var Ct = X(de);
          return _.w(Ct.date(Ct.date() + Math.round(Et * ee)), de);
        };
        if (ve === N)
          return this.set(N, this.$M + ee);
        if (ve === v)
          return this.set(v, this.$y + ee);
        if (ve === T)
          return Fe(1);
        if (ve === S)
          return Fe(7);
        var et = (ne = {}, ne[R] = o, ne[d] = c, ne[u] = s, ne)[ve] || 1, Ke = this.$d.getTime() + ee * et;
        return _.w(Ke, this);
      }, Z.subtract = function(ee, oe) {
        return this.add(-1 * ee, oe);
      }, Z.format = function(ee) {
        var oe = this, ne = this.$locale();
        if (!this.isValid())
          return ne.invalidDate || w;
        var de = ee || "YYYY-MM-DDTHH:mm:ssZ", ve = _.z(this), Fe = this.$H, et = this.$m, Ke = this.$M, Et = ne.weekdays, Ct = ne.months, xn = ne.meridiem, Tn = function(ot, xt, en, dn) {
          return ot && (ot[xt] || ot(oe, de)) || en[xt].slice(0, dn);
        }, _n = function(ot) {
          return _.s(Fe % 12 || 12, ot, "0");
        }, Kt = xn || function(ot, xt, en) {
          var dn = ot < 12 ? "AM" : "PM";
          return en ? dn.toLowerCase() : dn;
        };
        return de.replace(O, function(ot, xt) {
          return xt || function(en) {
            switch (en) {
              case "YY":
                return String(oe.$y).slice(-2);
              case "YYYY":
                return _.s(oe.$y, 4, "0");
              case "M":
                return Ke + 1;
              case "MM":
                return _.s(Ke + 1, 2, "0");
              case "MMM":
                return Tn(ne.monthsShort, Ke, Ct, 3);
              case "MMMM":
                return Tn(Ct, Ke);
              case "D":
                return oe.$D;
              case "DD":
                return _.s(oe.$D, 2, "0");
              case "d":
                return String(oe.$W);
              case "dd":
                return Tn(ne.weekdaysMin, oe.$W, Et, 2);
              case "ddd":
                return Tn(ne.weekdaysShort, oe.$W, Et, 3);
              case "dddd":
                return Et[oe.$W];
              case "H":
                return String(Fe);
              case "HH":
                return _.s(Fe, 2, "0");
              case "h":
                return _n(1);
              case "hh":
                return _n(2);
              case "a":
                return Kt(Fe, et, !0);
              case "A":
                return Kt(Fe, et, !1);
              case "m":
                return String(et);
              case "mm":
                return _.s(et, 2, "0");
              case "s":
                return String(oe.$s);
              case "ss":
                return _.s(oe.$s, 2, "0");
              case "SSS":
                return _.s(oe.$ms, 3, "0");
              case "Z":
                return ve;
            }
            return null;
          }(ot) || ve.replace(":", "");
        });
      }, Z.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, Z.diff = function(ee, oe, ne) {
        var de, ve = this, Fe = _.p(oe), et = X(ee), Ke = (et.utcOffset() - this.utcOffset()) * o, Et = this - et, Ct = function() {
          return _.m(ve, et);
        };
        switch (Fe) {
          case v:
            de = Ct() / 12;
            break;
          case N:
            de = Ct();
            break;
          case m:
            de = Ct() / 3;
            break;
          case S:
            de = (Et - Ke) / 6048e5;
            break;
          case T:
            de = (Et - Ke) / 864e5;
            break;
          case d:
            de = Et / c;
            break;
          case R:
            de = Et / o;
            break;
          case u:
            de = Et / s;
            break;
          default:
            de = Et;
        }
        return ne ? de : _.a(de);
      }, Z.daysInMonth = function() {
        return this.endOf(N).$D;
      }, Z.$locale = function() {
        return P[this.$L];
      }, Z.locale = function(ee, oe) {
        if (!ee)
          return this.$L;
        var ne = this.clone(), de = Y(ee, oe, !0);
        return de && (ne.$L = de), ne;
      }, Z.clone = function() {
        return _.w(this.$d, this);
      }, Z.toDate = function() {
        return new Date(this.valueOf());
      }, Z.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, Z.toISOString = function() {
        return this.$d.toISOString();
      }, Z.toString = function() {
        return this.$d.toUTCString();
      }, z;
    }(), j = F.prototype;
    return X.prototype = j, [["$ms", E], ["$s", u], ["$m", R], ["$H", d], ["$W", T], ["$M", N], ["$y", v], ["$D", M]].forEach(function(z) {
      j[z[1]] = function(Z) {
        return this.$g(Z, z[0], z[1]);
      };
    }), X.extend = function(z, Z) {
      return z.$i || (z(Z, F, X), z.$i = !0), X;
    }, X.locale = Y, X.isDayjs = U, X.unix = function(z) {
      return X(1e3 * z);
    }, X.en = P[G], X.Ls = P, X.p = {}, X;
  });
})(Iv);
var w2 = Iv.exports;
const xs = /* @__PURE__ */ Xi(w2);
var _v = { exports: {} };
(function(n, a) {
  (function(s, o) {
    n.exports = o();
  })(Yt, function() {
    return function(s, o, c) {
      s = s || {};
      var E = o.prototype, u = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function R(T, S, N, m) {
        return E.fromToBase(T, S, N, m);
      }
      c.en.relativeTime = u, E.fromToBase = function(T, S, N, m, v) {
        for (var M, w, y, O = N.$locale().relativeTime || u, g = s.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], V = g.length, D = 0; D < V; D += 1) {
          var G = g[D];
          G.d && (M = m ? c(T).diff(N, G.d, !0) : N.diff(T, G.d, !0));
          var P = (s.rounding || Math.round)(Math.abs(M));
          if (y = M > 0, P <= G.r || !G.r) {
            P <= 1 && D > 0 && (G = g[D - 1]);
            var U = O[G.l];
            v && (P = v("" + P)), w = typeof U == "string" ? U.replace("%d", P) : U(P, S, G.l, y);
            break;
          }
        }
        if (S)
          return w;
        var Y = y ? O.future : O.past;
        return typeof Y == "function" ? Y(w) : Y.replace("%s", w);
      }, E.to = function(T, S) {
        return R(T, S, this, !0);
      }, E.from = function(T, S) {
        return R(T, S, this);
      };
      var d = function(T) {
        return T.$u ? c.utc() : c();
      };
      E.toNow = function(T) {
        return this.to(d(this), T);
      }, E.fromNow = function(T) {
        return this.from(d(this), T);
      };
    };
  });
})(_v);
var G2 = _v.exports;
const H2 = /* @__PURE__ */ Xi(G2);
globalThis && globalThis.__awaiter;
globalThis && globalThis.__awaiter;
const B2 = typeof window < "u" ? x.useLayoutEffect : x.useEffect;
function F2(n, a) {
  const s = x.useRef(n);
  B2(() => {
    s.current = n;
  }, [n]), x.useEffect(() => {
    if (!a && a !== 0)
      return;
    const o = setTimeout(() => s.current(), a);
    return () => clearTimeout(o);
  }, [a]);
}
xs.extend(H2);
function uT({ date: n, ...a }) {
  const [s, o] = x.useState(n ? xs(n).fromNow() : null);
  return F2(() => {
    n || o(null), o(xs(n).fromNow());
  }, 5e3), n ? /* @__PURE__ */ p.jsx("time", { dateTime: n instanceof Date ? n.toISOString() : `${n}`, ...a, children: s }) : null;
}
const Cv = x.createContext({
  open: () => {
  },
  close: () => {
  },
  experiments: TS
}), Y2 = ({ children: n, context: a }) => /* @__PURE__ */ p.jsx(Cv.Provider, { value: a, children: n }), ET = () => x.useContext(Cv);
function PS(n) {
  return /* @__PURE__ */ p.jsx("span", { className: "bg-primary-800 inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium", ...n });
}
const Bs = Qm.createContext({
  events: [],
  setEvents: () => {
  }
});
function V2(n, a) {
  return a.action === "RESET" && Array.isArray(a.e) ? a.e : a.action === "APPEND" && !Array.isArray(a.e) ? [a.e, ...n] : n;
}
const sE = ({ children: n }) => {
  const [a, s] = x.useReducer(V2, Ut.getEvents());
  x.useEffect(() => {
    const c = Ut.subscribe("event", (E) => {
      s({ action: "APPEND", e: E });
    });
    return () => {
      c();
    };
  }, []);
  const o = {
    events: a,
    setEvents: s
  };
  return /* @__PURE__ */ p.jsx(Bs.Provider, { value: o, children: n });
}, oE = () => (x.useContext(Bs), {
  isLocalToSession: (n) => Ut.isTraceLocal(n)
}), W2 = () => {
  x.useContext(Bs);
  const n = oE(), a = Ut.getEnvelopes(), s = a.filter(({ envelope: o }) => {
    var E;
    const { trace_id: c } = ((E = o[0]) == null ? void 0 : E.trace) || {};
    return c ? n.isLocalToSession(c) !== !1 : !1;
  });
  return [a, s];
};
function cT({
  itemCount: n,
  ...a
}) {
  return /* @__PURE__ */ p.jsxs(
    "button",
    {
      className: "bg-primary-900 hover:bg-primary-800 text-primary-200 flex w-full cursor-pointer items-center gap-x-4 px-6 py-2 text-sm",
      ...a,
      children: [
        /* @__PURE__ */ p.jsxs("strong", { children: [
          n.toLocaleString(),
          " ",
          n !== 1 ? "items were" : "item was",
          " hidden from different sessions."
        ] }),
        /* @__PURE__ */ p.jsx("a", { className: "hover:bg-primary-900 border-primary-500 rounded border px-1.5 py-0.5", children: "Reveal" })
      ]
    }
  );
}
const k2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#1C1E24" }), /* @__PURE__ */ x.createElement("path", { d: "M7.34904 16.6227C6.46072 15.8193 6.20237 14.1347 6.57044 12.9137C7.21456 13.6852 8.10288 13.9294 9.02659 14.0675C10.4493 14.2798 11.8473 14.1984 13.1674 13.5578C13.3196 13.4835 13.4576 13.3844 13.6239 13.2888C13.7478 13.6428 13.7796 14.0002 13.7372 14.3647C13.631 15.2531 13.1815 15.9396 12.4702 16.4599C12.187 16.6687 11.8827 16.8563 11.5889 17.0509C10.6864 17.6561 10.4422 18.3604 10.782 19.3903C10.7891 19.4151 10.7962 19.4398 10.8138 19.5C10.3538 19.2983 10.014 19.001 9.75919 18.6117C9.48668 18.1976 9.35573 17.7411 9.35219 17.2491C9.34865 17.0085 9.34865 16.7678 9.31326 16.5307C9.2354 15.9538 8.95935 15.6954 8.44263 15.6813C7.91176 15.6671 7.49415 15.9892 7.3809 16.4988C7.37382 16.5378 7.35966 16.5767 7.34904 16.6227Z", fill: "url(#paint0_linear_24_21)" }), /* @__PURE__ */ x.createElement("path", { d: "M2.87915 13.2888C2.87915 13.2888 5.31053 12.1068 7.74899 12.1068L9.5858 6.43354C9.65304 6.16103 9.85477 5.97346 10.0813 5.97346C10.3078 5.97346 10.5095 6.16103 10.5768 6.43354L12.4171 12.1068C15.3015 12.1068 17.2834 13.2888 17.2834 13.2888C17.2834 13.2888 13.1568 2.0698 13.1462 2.04503C13.0294 1.71589 12.8276 1.5 12.5587 1.5H7.60389C7.33491 1.5 7.1438 1.71589 7.01639 2.04503C7.00577 2.0698 2.87915 13.2888 2.87915 13.2888Z", fill: "white" }), /* @__PURE__ */ x.createElement("linearGradient", { id: "paint0_linear_24_21", x1: 6.40822, y1: 19.5017, x2: 14.9504, y2: 15.4119, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ x.createElement("stop", { stopColor: "#D83333" }), /* @__PURE__ */ x.createElement("stop", { offset: 1, stopColor: "#F041FF" }))), X2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "black" }), /* @__PURE__ */ x.createElement("path", { d: "M3.87808 10.1069L6.25501 11.7126C6.33425 11.7696 6.40847 11.8332 6.47686 11.9028C6.54902 11.972 6.59081 12.0669 6.59306 12.1669V13.0648C6.59379 13.0942 6.58855 13.1233 6.57765 13.1506C6.56676 13.1778 6.55045 13.2026 6.5297 13.2233C6.50895 13.2441 6.48421 13.2604 6.45696 13.2713C6.42972 13.2822 6.40055 13.2874 6.37122 13.2867H6.32368C6.29977 13.2808 6.2767 13.2719 6.25501 13.2603L2.55756 10.7671C2.47383 10.7161 2.39742 10.6539 2.33043 10.5823C2.27192 10.5072 2.24365 10.413 2.2512 10.3182V9.88503C2.24365 9.79018 2.27192 9.69595 2.33043 9.62092C2.39742 9.5493 2.47383 9.4871 2.55756 9.43605L6.25501 6.94291C6.2767 6.93126 6.29977 6.92239 6.32368 6.9165H6.37122C6.40055 6.91578 6.42972 6.92102 6.45696 6.93191C6.48421 6.94281 6.50895 6.95912 6.5297 6.97987C6.55045 7.00061 6.56676 7.02536 6.57765 7.0526C6.58855 7.07985 6.59379 7.10902 6.59306 7.13835V8.0363C6.59081 8.13625 6.54902 8.23122 6.47686 8.30041C6.40847 8.37 6.33425 8.43362 6.25501 8.49056L3.87808 10.1069ZM11.0591 5.81783C11.0968 5.73571 11.1506 5.66205 11.2175 5.60127C11.3029 5.52964 11.4126 5.4937 11.5239 5.50091H12.3162C12.3776 5.50159 12.4363 5.5263 12.4798 5.56974C12.5232 5.61318 12.5479 5.67189 12.5486 5.73332C12.5475 5.76605 12.5403 5.79829 12.5275 5.8284L8.94623 14.3748C8.91106 14.4541 8.86083 14.5259 8.79833 14.5861C8.75521 14.6239 8.70496 14.6527 8.65053 14.6709C8.59611 14.689 8.53861 14.6961 8.4814 14.6917H7.72343C7.6929 14.692 7.66263 14.6861 7.63448 14.6743C7.60632 14.6624 7.58087 14.645 7.55968 14.623C7.53795 14.6017 7.52068 14.5762 7.50889 14.5481C7.4971 14.52 7.49103 14.4898 7.49102 14.4593C7.4921 14.4266 7.49927 14.3943 7.51214 14.3642L11.0591 5.81783ZM13.745 8.50905C13.6658 8.4521 13.5915 8.38849 13.5231 8.31889C13.4869 8.285 13.458 8.24413 13.438 8.19874C13.418 8.15335 13.4075 8.10438 13.4069 8.05479V7.15684C13.4062 7.12751 13.4115 7.09833 13.4223 7.07109C13.4332 7.04385 13.4496 7.0191 13.4703 6.99835C13.491 6.97761 13.5158 6.96129 13.543 6.9504C13.5703 6.93951 13.5995 6.93427 13.6288 6.93499H13.6763C13.7001 6.94131 13.7231 6.95016 13.745 6.9614L17.4424 9.45454C17.5262 9.50559 17.6026 9.56779 17.6696 9.63941C17.7281 9.71443 17.7564 9.80867 17.7488 9.90351V10.3472C17.7564 10.4421 17.7281 10.5363 17.6696 10.6113C17.6026 10.6829 17.5262 10.7451 17.4424 10.7962L13.745 13.2629C13.7231 13.2741 13.7001 13.283 13.6763 13.2893H13.6288C13.5995 13.29 13.5703 13.2848 13.543 13.2739C13.5158 13.263 13.491 13.2467 13.4703 13.226C13.4496 13.2052 13.4332 13.1805 13.4223 13.1532C13.4115 13.126 13.4062 13.0968 13.4069 13.0675V12.1695C13.4075 12.1199 13.418 12.071 13.438 12.0256C13.458 11.9802 13.4869 11.9393 13.5231 11.9054C13.5915 11.8358 13.6658 11.7722 13.745 11.7153L16.1219 10.1095L13.745 8.50905Z", fill: "white" })), j2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#512BD4" }), /* @__PURE__ */ x.createElement("path", { d: "M2.57578 12.9997C2.50091 13.0017 2.42641 12.9886 2.35661 12.9613C2.28681 12.9339 2.22311 12.8929 2.16921 12.8406C2.11579 12.7901 2.07322 12.7291 2.04412 12.6614C2.01501 12.5937 2 12.5207 2 12.4469C2 12.3732 2.01501 12.3002 2.04412 12.2325C2.07322 12.1648 2.11579 12.1038 2.16921 12.0533C2.22264 11.9999 2.28614 11.9579 2.35596 11.9296C2.42578 11.9012 2.50052 11.8873 2.57578 11.8885C2.65151 11.8869 2.72679 11.9007 2.79712 11.929C2.86745 11.9573 2.93141 11.9996 2.98517 12.0533C3.03934 12.1034 3.08259 12.1642 3.11217 12.232C3.14176 12.2997 3.15704 12.3729 3.15704 12.4469C3.15704 12.521 3.14176 12.5942 3.11217 12.6619C3.08259 12.7297 3.03934 12.7905 2.98517 12.8406C2.93094 12.8933 2.86678 12.9345 2.79647 12.9618C2.72615 12.9892 2.65112 13.0021 2.57578 12.9997ZM8.95948 12.9088H7.92047L5.18742 8.56601C5.11892 8.45836 5.06122 8.34411 5.0152 8.22496H4.98978C5.01972 8.49384 5.03104 8.7645 5.02367 9.03496V12.9088H4.10324V7H5.21001L7.86683 11.2405C7.97976 11.4167 8.05035 11.5247 8.08423 11.6042H8.09835C8.06639 11.3403 8.05318 11.0743 8.05882 10.8085V7H8.9736L8.95948 12.9088ZM13.4317 12.9088H10.2187V7H13.3047V7.83274H11.1674V9.50676H13.1438V10.3338H11.1674V12.0817H13.4261L13.4317 12.9088ZM18 7.83274H16.354V12.9088H15.4025V7.83274H13.7621V7H17.9972L18 7.83274Z", fill: "white" })), K2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#F6DE1E" }), /* @__PURE__ */ x.createElement("path", { d: "M9.81752 13.2758L11.6447 12.2074C11.7364 12.3528 11.8364 12.4928 11.9442 12.6268C12.2279 13.0135 12.6219 13.3054 13.0746 13.464C13.5272 13.6226 14.0173 13.6405 14.4803 13.5154C14.6427 13.4775 14.7978 13.4134 14.9396 13.3257C15.0846 13.2473 15.2079 13.1343 15.2986 12.9968C15.3892 12.8592 15.4444 12.7013 15.4593 12.5372C15.4741 12.3731 15.4481 12.2078 15.3835 12.0562C15.319 11.9046 15.2179 11.7713 15.0894 11.6683C14.9535 11.5416 14.7985 11.4371 14.6301 11.3587C14.1907 11.1391 13.7315 10.9394 13.2822 10.7397C12.6436 10.4966 12.0447 10.1601 11.5049 9.74124C11.133 9.40822 10.8477 8.98966 10.6737 8.52171C10.4998 8.05376 10.4424 7.5505 10.5065 7.05539C10.5548 6.3807 10.8362 5.74381 11.3025 5.25382C11.7688 4.76382 12.391 4.45122 13.0625 4.36955C13.6856 4.25973 14.3247 4.28012 14.9396 4.42946C15.3959 4.54452 15.8221 4.75659 16.1891 5.05122C16.5561 5.34586 16.8553 5.71613 17.0663 6.13682L15.2891 7.22513C15.1992 7.09533 15.1193 6.96553 15.0295 6.84572C14.8594 6.60603 14.6195 6.42467 14.3425 6.32639C14.0655 6.22811 13.765 6.21769 13.4818 6.29657C13.3128 6.33745 13.1573 6.42178 13.0309 6.54122C12.9045 6.66065 12.8114 6.81104 12.761 6.97749C12.7105 7.14394 12.7045 7.32069 12.7433 7.49021C12.7822 7.65974 12.8647 7.81617 12.9826 7.94402C13.1498 8.12085 13.3499 8.26331 13.5717 8.36337C14.061 8.61298 14.5702 8.81268 15.0694 9.04232C15.6152 9.27894 16.1286 9.58427 16.597 9.95091C17.0075 10.2711 17.3274 10.6927 17.5252 11.1742C17.7231 11.6557 17.792 12.1804 17.7253 12.6967C17.6998 13.3291 17.467 13.9356 17.0629 14.4228C16.6587 14.9099 16.1056 15.2506 15.4887 15.3925C14.2474 15.7651 12.9128 15.6728 11.7346 15.1329C10.8937 14.7634 10.2135 14.1044 9.81752 13.2758ZM1.75 13.5254L3.58716 12.4071L3.9466 12.9363C4.10704 13.1976 4.35176 13.3963 4.64037 13.4998C4.92899 13.6033 5.24425 13.6052 5.53414 13.5054C5.67198 13.4791 5.80061 13.4175 5.9074 13.3264C6.01418 13.2354 6.09545 13.1182 6.1432 12.9862C6.20173 12.8037 6.24514 12.6167 6.273 12.4271C6.28299 12.2608 6.28299 12.0941 6.273 11.9279V4.40949H8.52951C8.53396 4.47931 8.53396 4.54934 8.52951 4.61916V12.1375C8.5401 12.575 8.48969 13.0119 8.37974 13.4355C8.26201 13.9195 8.01345 14.3618 7.66126 14.7139C7.30906 15.0661 6.8668 15.3147 6.38283 15.4324C5.35267 15.732 4.24743 15.6322 3.28762 15.1529C2.60433 14.8018 2.06173 14.2275 1.75 13.5254Z", fill: "black" })), J2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#FF2D20" }), /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9977 5.75125C18.0008 5.77237 18.0008 5.79384 17.9977 5.81497V9.13041C17.9977 9.17283 17.9864 9.21449 17.9651 9.25113C17.9437 9.28778 17.913 9.31808 17.876 9.33895L15.1013 10.9455V14.118C15.1017 14.1603 15.0908 14.2019 15.0697 14.2386C15.0487 14.2753 15.0182 14.3056 14.9815 14.3266L9.17131 17.671C9.15804 17.6787 9.14374 17.6846 9.12883 17.6884H9.11339C9.07276 17.6981 9.03043 17.6981 8.9898 17.6884H8.9705C8.95664 17.6834 8.9431 17.6776 8.92995 17.671L3.12165 14.3266C3.08472 14.3057 3.05399 14.2754 3.03262 14.2388C3.01124 14.2021 2.99999 14.1605 3 14.118V4.1698C3.00038 4.14822 3.00363 4.1268 3.00965 4.10608C3.00998 4.09964 3.00998 4.0932 3.00965 4.08677C3.00965 4.07325 3.01931 4.06167 3.0251 4.05008L3.04248 4.02691C3.05044 4.01458 3.0602 4.00351 3.07145 3.99408L3.09462 3.97477L3.12165 3.95546L6.01807 2.28326C6.05457 2.26149 6.09627 2.25 6.13876 2.25C6.18125 2.25 6.22295 2.26149 6.25944 2.28326L9.15587 3.95546L9.1829 3.97477L9.20607 3.99408C9.21362 4.00272 9.22071 4.01174 9.22731 4.02112C9.23355 4.02805 9.23876 4.03586 9.24276 4.04429C9.2497 4.05594 9.25552 4.06822 9.26014 4.08097V4.10222C9.2631 4.12271 9.2631 4.14352 9.26014 4.16401V10.3836L11.6815 8.98945V5.81304C11.6786 5.79255 11.6786 5.77174 11.6815 5.75125V5.73001C11.6865 5.71742 11.6923 5.70516 11.6989 5.69332C11.7029 5.68548 11.7082 5.67831 11.7144 5.67208C11.7144 5.66242 11.7279 5.65084 11.7356 5.64311L11.7588 5.62573L11.7858 5.60449L14.6822 3.93229C14.7191 3.91148 14.7606 3.90054 14.8029 3.90054C14.8452 3.90054 14.8868 3.91148 14.9236 3.93229L17.82 5.60449L17.8471 5.62573C17.8552 5.6309 17.863 5.63671 17.8702 5.64311C17.8702 5.64311 17.8838 5.66242 17.8915 5.67208L17.9089 5.69332C17.9089 5.7049 17.9089 5.71842 17.9243 5.73001C17.9398 5.74159 17.9958 5.74352 17.9977 5.75125V5.75125ZM17.5227 8.98945V6.23205L16.507 6.81134L15.1013 7.62041V10.3836L17.5227 8.98945V8.98945ZM14.6262 13.9771V11.2178L13.2379 12.0075L9.29296 14.259V17.0434L14.6262 13.9771ZM3.48467 4.58881V13.9771L8.8083 17.0434V14.259L6.02773 12.6834L6.0007 12.664C6.0007 12.664 5.98525 12.6525 5.97945 12.6447C5.97242 12.6368 5.96596 12.6285 5.96014 12.6196C5.95374 12.6124 5.94793 12.6046 5.94277 12.5965L5.93118 12.5675C5.92649 12.5582 5.92262 12.5485 5.9196 12.5385C5.91867 12.527 5.91867 12.5153 5.9196 12.5038V5.98296L4.50035 5.17389L3.48467 4.59461V4.58881ZM6.14745 2.77758L3.72797 4.1698L6.14745 5.56394L8.57272 4.1698L6.14745 2.77758ZM7.40643 11.4669L8.81023 10.6578V4.58881L7.79262 5.1681L6.38882 5.98296V12.0558L7.40643 11.4669ZM14.8599 4.41696L12.4346 5.81497L14.8541 7.20718L17.2736 5.81304L14.8599 4.41696ZM14.6185 7.62234L13.207 6.81713L12.1894 6.23785V8.98945L13.5932 9.79852L14.6108 10.3778L14.6185 7.62234ZM9.05159 13.8419L12.6007 11.8144L14.3656 10.8007L11.9557 9.40074L9.17324 11.0034L6.64177 12.4729L9.05159 13.8419Z", fill: "white" })), z2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#2D4C91" }), /* @__PURE__ */ x.createElement("path", { d: "M0 20V0L20 20H0Z", fill: "#425D9C" }), /* @__PURE__ */ x.createElement("path", { d: "M8.12371 5.00349V6.77678C8.12934 6.79827 8.13361 6.82011 8.13651 6.84216V9.15424C8.13775 9.28858 8.14501 9.41923 8.15215 9.54798C8.15976 9.68495 8.16724 9.81976 8.16724 9.95458V10.054C8.161 10.0539 8.15489 10.0522 8.1495 10.049C8.14411 10.0458 8.13963 10.0412 8.13651 10.0357C7.86509 9.59451 7.59281 9.15424 7.31968 8.71484L5.04585 5.07149C5.03361 5.04763 5.01458 5.02811 4.99127 5.0155C4.96796 5.0029 4.94146 4.9978 4.91526 5.00087H4.11891V10.9563H4.80515V6.55969C4.80515 6.44592 4.79811 6.3328 4.79107 6.21968C4.78403 6.10656 4.77699 5.99344 4.77699 5.87967C4.77577 5.85964 4.77577 5.83955 4.77699 5.81951C4.78374 5.8333 4.79098 5.84356 4.79698 5.85206C4.80464 5.8629 4.81028 5.87087 4.81028 5.87967C4.82562 5.91031 4.84059 5.94135 4.8556 5.97245C4.89566 6.0555 4.93596 6.13905 4.9844 6.21707L7.9291 10.8935C7.93907 10.9136 7.95456 10.9302 7.97367 10.9414C7.99279 10.9525 8.01468 10.9577 8.03665 10.9563H8.80483V5.00349H8.12371Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M10.3233 5.01133V9.03393L10.3258 9.11501V10.972H13.4267V10.3129H11.03V9.80811C11.0288 9.79332 11.0288 9.77844 11.03 9.76365V8.24929H13.1195V7.61634H11.03V5.63382H13.2731V5.01133H10.3233Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M2.88107 10.7698C2.90166 10.7097 2.90986 10.6458 2.90518 10.5823C2.90986 10.5187 2.90166 10.4549 2.88107 10.3947C2.86048 10.3346 2.82795 10.2794 2.78553 10.2327C2.7431 10.186 2.69169 10.1487 2.63451 10.1232C2.57733 10.0977 2.51562 10.0846 2.45323 10.0846C2.39084 10.0846 2.32913 10.0977 2.27195 10.1232C2.21477 10.1487 2.16335 10.186 2.12093 10.2327C2.0785 10.2794 2.04598 10.3346 2.02539 10.3947C2.0048 10.4549 1.99659 10.5187 2.00128 10.5823C1.99659 10.6458 2.0048 10.7097 2.02539 10.7698C2.04598 10.83 2.0785 10.8852 2.12093 10.9319C2.16335 10.9786 2.21477 11.0159 2.27195 11.0414C2.32913 11.0668 2.39084 11.08 2.45323 11.08C2.51562 11.08 2.57733 11.0668 2.63451 11.0414C2.69169 11.0159 2.7431 10.9786 2.78553 10.9319C2.82795 10.8852 2.86048 10.83 2.88107 10.7698Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M13.9542 5.63382H15.6289V10.9537H16.3023V5.63382H18V5.00087H13.9542V5.63382Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M6.26412 15.0721H5.95187V12.5005H6.33726L7.22338 14.0688H7.23745L8.12357 12.5005H8.50334V15.0721H8.19109V13.0104H8.17702L7.24589 14.6311H7.20932L6.27819 12.9994H6.26412V15.0721Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.95208 12.5005H10.3515L11.3192 15.0363V15.0721H10.9704L10.7229 14.3996H9.57512L9.32757 15.0721H8.98719V15.0363L9.95208 12.5005ZM10.1434 12.8561L9.68202 14.1129H10.6188L10.1574 12.8561H10.1434Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M13.6991 14.1653C13.6991 14.7551 13.3222 15.1052 12.6948 15.1052C12.0788 15.1052 11.6962 14.7579 11.6962 14.1653V12.5005H12.0225V14.157C12.0225 14.5539 12.2363 14.8103 12.6948 14.8103C13.1534 14.8103 13.37 14.5539 13.37 14.157V12.5005H13.6991V14.1653Z", fill: "#FEFEFE" }), /* @__PURE__ */ x.createElement("path", { d: "M14.7428 15.0721H14.4136V12.5005H14.7428V15.0721Z", fill: "#FEFEFE" })), Z2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#333333" }), /* @__PURE__ */ x.createElement("path", { d: "M10.3823 2.103C10.1375 1.96909 9.84695 1.96909 9.60227 2.103L3.16359 5.7199C2.9189 5.85389 2.78125 6.10687 2.78125 6.37485V13.6234C2.78125 13.8914 2.93417 14.1444 3.16359 14.2784L9.60227 17.8953C9.84695 18.0292 10.1375 18.0292 10.3823 17.8953L16.8209 14.2784C17.0657 14.1444 17.2032 13.8914 17.2032 13.6234V6.37485C17.2032 6.10687 17.0503 5.85389 16.8209 5.7199L10.3823 2.103Z", fill: "url(#paint0_linear_58_1395)" }), /* @__PURE__ */ x.createElement("path", { d: "M16.8363 5.71985L10.367 2.10294C10.3059 2.07318 10.2294 2.04341 10.1682 2.02856L2.91901 14.0997C2.98016 14.1741 3.05666 14.2336 3.13308 14.2783L9.60237 17.8952C9.78591 17.9994 9.99998 18.0291 10.1988 17.9696L17.0045 5.85384C16.9586 5.79431 16.8975 5.74962 16.8363 5.71985Z", fill: "url(#paint1_linear_58_1395)" }), /* @__PURE__ */ x.createElement("path", { d: "M16.8365 14.2782C17.02 14.174 17.1577 13.9954 17.2188 13.8019L10.1378 2.01355C9.9543 1.98378 9.75542 1.99863 9.58723 2.10285L3.16382 5.70484L10.0919 17.9993C10.1836 17.9844 10.2908 17.9546 10.3825 17.91L16.8365 14.2782Z", fill: "url(#paint2_linear_58_1395)" }), /* @__PURE__ */ x.createElement("linearGradient", { id: "paint0_linear_58_1395", x1: 12.6145, y1: 4.79675, x2: 7.0435, y2: 16.4743, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ x.createElement("stop", { stopColor: "#3F873F" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.3296, stopColor: "#3F8B3D" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.6367, stopColor: "#3E9638" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.9341, stopColor: "#3DA92E" }), /* @__PURE__ */ x.createElement("stop", { offset: 1, stopColor: "#3DAE2B" })), /* @__PURE__ */ x.createElement("linearGradient", { id: "paint1_linear_58_1395", x1: 9.0138, y1: 10.8455, x2: 25.0331, y2: -1.31604, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ x.createElement("stop", { offset: 0.1376, stopColor: "#3F873F" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.4016, stopColor: "#52A044" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.7129, stopColor: "#64B749" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.9081, stopColor: "#6ABF4B" })), /* @__PURE__ */ x.createElement("linearGradient", { id: "paint2_linear_58_1395", x1: 2.54543, y1: 9.99663, x2: 17.4441, y2: 9.99663, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ x.createElement("stop", { offset: 0.0919165, stopColor: "#6ABF4B" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.2871, stopColor: "#64B749" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.5984, stopColor: "#52A044" }), /* @__PURE__ */ x.createElement("stop", { offset: 0.8624, stopColor: "#3F873F" }))), q2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#5C669A" }), /* @__PURE__ */ x.createElement("path", { d: "M3.05693 7.48484H5.50324C6.22329 7.48484 6.744 7.6902 7.06537 8.10093C7.38673 8.51165 7.49328 9.06587 7.38501 9.76359C7.34016 10.0917 7.24449 10.4109 7.10146 10.7096C6.9598 11.0219 6.76139 11.3051 6.5163 11.5448C6.25472 11.8343 5.91568 12.0427 5.53933 12.1455C5.18656 12.2308 4.82477 12.2733 4.46182 12.2718H3.36626L3.02084 13.9989H1.75L3.05693 7.48484V7.48484ZM4.12413 8.51595L3.57764 11.2458C3.61368 11.2483 3.64986 11.2483 3.68591 11.2458H3.8148C4.30799 11.264 4.80103 11.2058 5.27639 11.0731C5.66564 10.9468 5.92599 10.5034 6.04972 9.74812C6.16057 9.11141 6.04972 8.74537 5.72235 8.64742C5.32643 8.54311 4.91742 8.49708 4.50822 8.51079C4.43781 8.51446 4.36725 8.51446 4.29684 8.51079H4.10608L4.12413 8.51595ZM8.83114 5.75H10.0865L9.73078 7.48484H10.8598C11.3521 7.45801 11.8397 7.59191 12.2493 7.86635C12.5586 8.10866 12.6514 8.5675 12.5225 9.24804L11.9167 12.2769H10.6278L11.213 9.38724C11.2479 9.28161 11.2609 9.16998 11.2511 9.05916C11.2414 8.94835 11.2091 8.8407 11.1563 8.74279C11.0719 8.66675 10.9718 8.61024 10.8631 8.57727C10.7544 8.5443 10.6397 8.53569 10.5273 8.55204H9.51425L8.77443 12.2769H7.50874L8.82341 5.75516L8.83114 5.75ZM13.881 7.48484H16.3273C17.0474 7.48484 17.5681 7.6902 17.8894 8.10093C18.2108 8.51165 18.3173 9.06587 18.2091 9.76359C18.1642 10.0917 18.0686 10.4109 17.9255 10.7096C17.7839 11.0219 17.5855 11.3051 17.3404 11.5448C17.0788 11.8343 16.7397 12.0427 16.3634 12.1455C16.0106 12.2308 15.6488 12.2733 15.2859 12.2718H14.1903L13.8449 13.9989H12.5741L13.881 7.48484V7.48484ZM14.9482 8.51595L14.4017 11.2458C14.4378 11.2483 14.4739 11.2483 14.51 11.2458H14.6389C15.1321 11.264 15.6251 11.2058 16.1005 11.0731C16.4897 10.9468 16.7501 10.5034 16.8738 9.74812C16.9846 9.11141 16.8738 8.74537 16.5464 8.64742C16.1506 8.54278 15.7415 8.49675 15.3323 8.51079C15.2619 8.51446 15.1913 8.51446 15.1209 8.51079H14.9301", fill: "white" })), Q2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#5A9FD4" }), /* @__PURE__ */ x.createElement("path", { d: "M9.90587 1.99998C9.29457 2.00073 8.68442 2.05292 8.08187 2.15598C6.46587 2.44198 6.17387 3.03798 6.17387 4.13998V5.59998H9.99987V6.07998H4.73987C3.63187 6.07998 2.65987 6.74598 2.35587 8.01398C1.99987 9.46798 1.99987 10.376 2.35587 11.894C2.62787 13.024 3.27587 13.83 4.38387 13.83H5.69787V12.086C5.71173 11.4592 5.96772 10.8621 6.41217 10.4199C6.85661 9.97765 7.455 9.72468 8.08187 9.71398H11.8939C12.1464 9.71189 12.3961 9.66003 12.6286 9.56138C12.8612 9.46273 13.072 9.31921 13.249 9.13904C13.426 8.95886 13.5658 8.74557 13.6603 8.51134C13.7548 8.27711 13.8022 8.02655 13.7999 7.77398V4.13998C13.7999 3.10598 12.9279 2.32798 11.8919 2.15598C11.2354 2.04868 10.5711 1.9965 9.90587 1.99998V1.99998ZM7.84187 3.16998C7.98625 3.1676 8.12809 3.20821 8.24933 3.28666C8.37057 3.3651 8.46574 3.47783 8.52275 3.61051C8.57975 3.74319 8.596 3.88983 8.56944 4.03177C8.54289 4.17371 8.47471 4.30455 8.3736 4.40765C8.27248 4.51074 8.14299 4.58143 8.00158 4.61074C7.86018 4.64004 7.71326 4.62662 7.5795 4.5722C7.44574 4.51778 7.33119 4.42481 7.25041 4.30511C7.16964 4.18541 7.12628 4.04439 7.12587 3.89998C7.12427 3.7083 7.19874 3.52382 7.33296 3.38697C7.46718 3.25013 7.6502 3.17209 7.84187 3.16998V3.16998Z", fill: "white" }), /* @__PURE__ */ x.createElement("path", { d: "M14.2778 6.08002V7.77402C14.2723 8.40851 14.0207 9.01609 13.576 9.46867C13.1312 9.92124 12.5281 10.1835 11.8938 10.2H8.08183C7.57353 10.2105 7.08946 10.4192 6.73296 10.7817C6.37647 11.1441 6.17581 11.6316 6.17383 12.14V15.77C6.17383 16.804 7.07183 17.412 8.08183 17.708C9.32274 18.0969 10.6529 18.0969 11.8938 17.708C12.8558 17.43 13.7998 16.87 13.7998 15.77V14.314H9.99983V13.83H15.7118C16.8198 13.83 17.2338 13.056 17.6198 11.894C18.0198 10.694 18.0018 9.54802 17.6198 8.01402C17.3458 6.91002 16.8198 6.08002 15.7118 6.08002H14.2778ZM12.1338 15.28C12.2784 15.2776 12.4204 15.3183 12.5417 15.397C12.663 15.4756 12.7582 15.5886 12.8151 15.7215C12.872 15.8544 12.888 16.0012 12.8611 16.1433C12.8342 16.2853 12.7657 16.4162 12.6642 16.5191C12.5626 16.622 12.4328 16.6924 12.2911 16.7213C12.1494 16.7501 12.0024 16.7361 11.8687 16.6811C11.735 16.6261 11.6207 16.5325 11.5404 16.4122C11.4601 16.292 11.4175 16.1506 11.4178 16.006C11.4173 15.8154 11.4924 15.6324 11.6266 15.497C11.7608 15.3617 11.9432 15.2851 12.1338 15.284V15.28Z", fill: "white" })), $2 = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#BD0012" }), /* @__PURE__ */ x.createElement("path", { d: "M6.63437 15.6819L13.1969 11.4725L16.5625 17.0507L6.63437 15.7007V15.6819ZM17.5 5.2944V5.38815C17.5 5.81003 17.4531 6.24128 17.4344 6.66315V7.49753C17.4344 8.06003 17.3687 8.62253 17.3406 9.1944V10.0382L17.2562 11.6975V12.56C17.2562 12.8507 17.2094 13.4225 17.1906 13.8538C17.1906 14.135 17.1906 14.4163 17.1438 14.6882C17.1438 15.1382 17.0969 15.5788 17.0781 16.0194C17.0594 16.46 17.0781 16.6475 17.0312 16.9569L16.9844 16.91L16.4406 16.0757L13.5812 11.4819C13.4594 11.2757 13.4594 11.2757 13.5812 11.0694L16.7125 6.3819C16.9469 6.03503 17.1719 5.68815 17.4062 5.35065L17.5 5.2944ZM3.60625 9.6069L4.75 7.89128C4.91269 7.66377 5.10148 7.4561 5.3125 7.27253L7.32813 5.39753C7.59404 5.15315 7.88649 4.93931 8.2 4.76003L10.3188 3.5694C10.3611 3.5487 10.4076 3.53794 10.4547 3.53794C10.5018 3.53794 10.5483 3.5487 10.5906 3.5694C10.8906 3.69128 11.2 3.7944 11.5281 3.9069H11.5937V3.9819C11.3125 4.52565 11.0406 5.0694 10.7687 5.61315C10.7257 5.70241 10.6651 5.78211 10.5906 5.84753L7.9375 8.24753C7.77813 8.39753 7.6375 8.5569 7.47812 8.69753C7.38874 8.77898 7.29137 8.85122 7.1875 8.91315C6.30625 9.39128 5.40625 9.85065 4.50625 10.2632C4.47089 10.289 4.4282 10.303 4.38438 10.303C4.34055 10.303 4.29786 10.289 4.2625 10.2632L3.60625 9.6069ZM7.62812 9.48503L12.8125 11.1538L6.25 15.3725C6.25 15.2975 7.5625 9.67253 7.62812 9.48503V9.48503ZM16.8906 5.2944L13.2063 10.8257L11.3313 6.2319C11.3781 6.2319 16.2063 5.36003 16.8906 5.2944ZM7.70313 9.0444L10.9375 6.16628L12.8125 10.7225L7.70313 9.0444ZM5.89375 15.5225L2.5 15.6069L4.27188 11.3694L5.89375 15.5225ZM5.94063 14.5382L4.49688 10.7882L7.1875 9.4194C7.12187 9.7194 7.05625 10.0007 6.98125 10.2819L6.78438 11.135C6.70938 11.4257 6.64375 11.7069 6.56875 11.9975L6.37188 12.8413C6.29688 13.1225 6.23125 13.4132 6.16562 13.6944C6.1 13.9757 6.03437 14.2569 5.95 14.5382H5.94063ZM11.1906 5.79128C11.1825 5.75105 11.1825 5.70962 11.1906 5.6694C11.4531 5.12565 11.725 4.5819 11.9969 4.04753C12.0531 3.93503 12.0906 3.91628 12.2031 3.95378L13.4031 4.26315L16.0562 4.96628H16.1875C16.1406 5.05065 11.7719 5.72565 11.1906 5.79128V5.79128ZM13.075 3.71003L16.7219 2.90378L17.5 4.92878L13.075 3.71003ZM3.15625 16.1225C3.18018 16.1009 3.20847 16.0847 3.2392 16.075C3.26993 16.0653 3.30239 16.0623 3.33438 16.0663H4.01875L5.66875 16.0194C5.95107 16.0148 6.23329 16.0336 6.5125 16.0757L7.45 16.1882L8.58437 16.3382L9.70937 16.4975L10.7687 16.6475L11.7719 16.7882L13.1781 16.9756L14.2937 17.1257H14.3969H14.3406L13.5719 17.0507L12.7 16.9756L11.5937 16.8725L10.7312 16.7882L9.6625 16.6944L8.8 16.61L7.72188 16.5444L6.85938 16.4694L5.8 16.3663L4.92813 16.2913L3.99062 16.2069L3.15625 16.1225ZM2.5 14.4257C2.79063 12.9819 3.08125 11.5382 3.38125 10.0757L3.70937 10.4225L3.98125 10.6944C4.08437 10.8069 4.10313 10.8632 4.0375 11.0038L3.35313 12.5882L2.62188 14.2944L2.5 14.435V14.4257ZM11.2094 3.26003C11.6312 3.17565 14.6687 2.7819 14.7531 2.80065H14.6781L13.9938 2.96003L12.1563 3.4194C11.9123 3.48295 11.6538 3.45976 11.425 3.35378L11.2094 3.26003Z", fill: "white" })), ew = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("rect", { width: "100%", height: "100%", fill: "#1A171B" }), /* @__PURE__ */ x.createElement("path", { d: "M15.7932 1.50213C14.5166 1.54665 13.4023 2.25017 12.5729 3.22356C11.6545 4.29065 11.0435 5.55637 10.6033 6.84841C9.81576 6.20297 9.20826 5.36742 7.94487 5.00308C6.96838 4.72275 5.94272 4.83852 4.99953 5.54127C4.55272 5.87502 4.2449 6.37953 4.09855 6.85383C3.71949 8.08625 4.49696 9.18315 4.85008 9.57692L5.62213 10.4043C5.78126 10.5666 6.16458 10.9898 5.97718 11.5965C5.77468 12.2563 4.9794 12.6833 4.16359 12.4316C3.79925 12.3205 3.27577 12.0491 3.39309 11.667C3.44149 11.5105 3.55339 11.3936 3.6134 11.2585C3.66838 11.1423 3.69471 11.0552 3.71136 11.0041C3.86043 10.5174 3.65677 9.88434 3.13561 9.72366C2.64931 9.57459 2.15177 9.69269 1.95895 10.3188C1.74019 11.03 2.08053 12.3209 3.90379 12.8831C6.0399 13.5394 7.84691 12.3763 8.10323 10.8593C8.26468 9.90913 7.83568 9.20328 7.04969 8.29533L6.40928 7.58716C6.02132 7.19959 5.88813 6.53905 6.28964 6.03144C6.62843 5.60322 7.11086 5.42046 7.90111 5.63535C9.05454 5.94859 9.56873 6.7489 10.4267 7.39434C10.0725 8.55629 9.84092 9.7225 9.63145 10.7683L9.50368 11.5481C8.89038 14.7648 8.42227 16.5312 7.20573 17.5452C6.96064 17.7195 6.61023 17.9804 6.08211 17.9986C5.80527 18.0071 5.71583 17.8167 5.71196 17.7338C5.70537 17.5394 5.86916 17.4504 5.97795 17.3629C6.14057 17.2742 6.38644 17.1271 6.36979 16.6559C6.35198 16.0991 5.89084 15.6163 5.2241 15.6383C4.72463 15.6554 3.96342 16.1254 3.99207 16.9857C4.02188 17.8743 4.85008 18.5403 6.09876 18.4981C6.76627 18.4753 8.25694 18.2035 9.72593 16.4572C11.4357 14.4555 11.9139 12.1606 12.2736 10.481L12.6751 8.26358C12.8982 8.29029 13.1367 8.30811 13.3961 8.3143C15.5256 8.35921 16.5908 7.25612 16.6066 6.45387C16.6171 5.96833 16.288 5.49054 15.8272 5.50139C15.4973 5.51068 15.0831 5.73021 14.9835 6.18632C14.8864 6.63391 15.6611 7.03774 15.0556 7.42996C14.6254 7.70835 13.8541 7.90466 12.7681 7.74514L12.9655 6.65365C13.3686 4.58375 13.8657 2.03761 15.7517 1.97566C15.8892 1.96869 16.3921 1.98185 16.4037 2.31445C16.4072 2.42557 16.3797 2.45383 16.2496 2.70822C16.1172 2.90646 16.0673 3.07527 16.0735 3.26925C16.0917 3.79776 16.4936 4.14507 17.0747 4.12416C17.853 4.09899 18.0768 3.34127 18.064 2.95214C18.0326 2.038 17.0689 1.46031 15.7932 1.50213Z", fill: "white" }));
function Vi({
  platform: n,
  event: a,
  size: s,
  width: o = 42,
  height: c = 42,
  title: E,
  ...u
}) {
  switch (n || (a == null ? void 0 : a.platform) || "unknown") {
    case "ruby":
      return /* @__PURE__ */ p.jsx($2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "python":
      return /* @__PURE__ */ p.jsx(Q2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "javascript.astro":
      return /* @__PURE__ */ p.jsx(k2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "javascript":
      return /* @__PURE__ */ p.jsx(K2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "node":
      return /* @__PURE__ */ p.jsx(Z2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "php":
      return /* @__PURE__ */ p.jsx(q2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "php.laravel":
      return /* @__PURE__ */ p.jsx(J2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "php.symfony":
      return /* @__PURE__ */ p.jsx(ew, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "dotnet":
    case "csharp":
      return /* @__PURE__ */ p.jsx(j2, { title: E, width: s ?? o, height: s ?? c, ...u });
    case "dotnet.maui":
      return /* @__PURE__ */ p.jsx(z2, { title: E, width: s ?? o, height: s ?? c, ...u });
    default:
      return /* @__PURE__ */ p.jsx(X2, { title: E, width: s ?? o, height: s ?? c, ...u });
  }
}
function US({
  title: n,
  subtitle: a,
  backto: s
}) {
  return /* @__PURE__ */ p.jsxs("div", { className: "border-b-primary-400 mb-4 flex border-b pb-4", children: [
    /* @__PURE__ */ p.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ p.jsx("h2", { className: "text-primary-300 text-xl", children: n }),
      a && /* @__PURE__ */ p.jsx("h3", { className: "font-mono", children: a })
    ] }),
    /* @__PURE__ */ p.jsx(
      fn,
      {
        className: "hover:bg-primary-900 -my-1 flex cursor-pointer items-center justify-center rounded px-6 py-1 font-mono text-2xl",
        to: s,
        children: "✕"
      }
    )
  ] });
}
function xS(n) {
  const a = aT();
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: "fixed bottom-0 left-0 right-0 top-0 z-10 bg-black  bg-opacity-30",
      onClick: () => a(n.backto),
      children: /* @__PURE__ */ p.jsx(
        "div",
        {
          onClick: (s) => s.stopPropagation(),
          className: "spotlight-sidepanel border-l-primary-400 from-primary-900 to-primary-950 fixed bottom-0 left-1/4 right-0 top-0 z-20 flex h-full flex-col overflow-auto border-l bg-gradient-to-br to-20% px-6 py-4",
          ...n
        }
      )
    }
  );
}
const tw = x.lazy(() => import("./main-d5f617e5.js").then((n) => n.m)), nw = () => {
};
function Gp({
  data: n,
  onUpdateData: a = nw,
  editingEnabled: s = !1,
  clipboardEnabled: o = !1,
  displayDataTypes: c = !1,
  quotesOnKeys: E = !1
}) {
  return /* @__PURE__ */ p.jsx(x.Suspense, { fallback: /* @__PURE__ */ p.jsx("div", { children: "loading..." }), children: /* @__PURE__ */ p.jsx(
    tw,
    {
      theme: "bright",
      displayDataTypes: c,
      quotesOnKeys: E,
      shouldCollapse: ({ src: u, type: R }) => R === "array" && Object.values(u).length > 5,
      src: n,
      enableClipboard: o,
      onEdit: s && ((u) => {
        if (u.new_value == "error")
          return !1;
        a(u.updated_src);
      }),
      onDelete: s && ((u) => {
        if (u.new_value == "error")
          return !1;
        a(u.updated_src);
      }),
      onAdd: s && ((u) => {
        if (u.new_value == "error")
          return !1;
        a(u.updated_src);
      })
    }
  ) });
}
function rw({ data: n }) {
  const [a, s] = x.useState(!1), { envelope: o, rawEnvelope: c } = n, E = o[0], u = o[1];
  return /* @__PURE__ */ p.jsxs(xS, { backto: "/devInfo", children: [
    /* @__PURE__ */ p.jsx(
      US,
      {
        title: "Envelope Details",
        subtitle: /* @__PURE__ */ p.jsx(p.Fragment, { children: E.event_id && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          "Event Id ",
          /* @__PURE__ */ p.jsx("span", { className: "text-primary-500", children: "—" }),
          " ",
          E.event_id
        ] }) }),
        backto: "/devInfo"
      }
    ),
    /* @__PURE__ */ p.jsxs("label", { htmlFor: "json-toggle", className: "mb-8 flex cursor-pointer items-center", children: [
      /* @__PURE__ */ p.jsxs("div", { className: "relative flex h-4 items-center gap-2", children: [
        /* @__PURE__ */ p.jsx(
          "input",
          {
            id: "json-toggle",
            type: "checkbox",
            className: "sr-only",
            onChange: () => s((R) => !R),
            checked: a
          }
        ),
        /* @__PURE__ */ p.jsx("div", { className: "bg-primary-400 h-4 w-10 rounded-full shadow-inner" }),
        /* @__PURE__ */ p.jsx("div", { className: "dot absolute -left-1 -top-1 h-6 w-6 rounded-full bg-white shadow transition" })
      ] }),
      /* @__PURE__ */ p.jsx("span", { className: "ml-2", children: "Show Raw Data" })
    ] }),
    a ? /* @__PURE__ */ p.jsx("div", { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ p.jsx(Gp, { data: c }) }) : /* @__PURE__ */ p.jsxs("div", { className: "flex flex-col gap-6 space-y-6", children: [
      /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-4 text-xl font-semibold", children: "Header" }),
        /* @__PURE__ */ p.jsx(Gp, { data: E })
      ] }),
      /* @__PURE__ */ p.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 text-xl font-semibold", children: "Items" }),
        u.map((R, d) => {
          var T;
          return /* @__PURE__ */ p.jsx(Gp, { data: R }, `${d}-${(T = R[0]) == null ? void 0 : T.type}`);
        })
      ] })
    ] })
  ] });
}
function SC() {
  const { eventId: n } = Zo(), a = ET(), s = oE(), [o, c] = W2(), E = o.length - c.length, [u, R] = x.useState(!a.experiments["sentry:focus-local-events"]), d = n && Ut.getEnvelopes().find(({ envelope: T }) => T[0].event_id === n) || null;
  return o && o.length ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    E > 0 && !u && /* @__PURE__ */ p.jsx(
      cT,
      {
        itemCount: E,
        onClick: () => {
          R(!0);
        }
      }
    ),
    /* @__PURE__ */ p.jsxs("div", { children: [
      /* @__PURE__ */ p.jsx("div", { className: "border-b-primary-700 flex w-full items-center justify-between border-b px-6 py-4", children: /* @__PURE__ */ p.jsx("h1", { className: "text-2xl font-bold", children: "Event Envelopes" }) }),
      /* @__PURE__ */ p.jsx("div", { className: "flex flex-col", children: (u ? o : c).map(({ envelope: T }) => {
        var M, w;
        const S = T[0], N = S.event_id, { trace_id: m } = (S == null ? void 0 : S.trace) || {}, v = T[1].length > 0 ? T[1][0] : null;
        return typeof N == "string" ? /* @__PURE__ */ p.jsx(fn, { to: `/devInfo/${S.event_id}`, children: /* @__PURE__ */ p.jsxs(
          "div",
          {
            className: $e(
              "hover:bg-primary-900 border-b-primary-900 flex cursor-pointer items-center gap-4 border-b px-6 py-2 transition-all",
              n === N ? "bg-primary-900" : ""
            ),
            children: [
              /* @__PURE__ */ p.jsx(Vi, { className: "rounded-md", platform: oT(((M = S.sdk) == null ? void 0 : M.name) || "unknown") }),
              /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-[0.25] flex-col truncate font-mono text-sm", children: [
                /* @__PURE__ */ p.jsx("h2", { className: "text-primary-50 text-xs", children: "Event Id" }),
                /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-x-2", children: [
                  /* @__PURE__ */ p.jsx("div", { children: N.substring(0, 8) }),
                  m && s.isLocalToSession(m) ? /* @__PURE__ */ p.jsx(PS, { title: "This trace is part of your local session.", children: "Local" }) : null
                ] })
              ] }),
              /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-[0.25] flex-col truncate font-mono text-sm", children: [
                /* @__PURE__ */ p.jsx("h2", { className: "text-primary-50 text-xs", children: "Type" }),
                v && ((w = v[0]) != null && w.type) ? /* @__PURE__ */ p.jsx(p.Fragment, { children: v[0].type }) : "-"
              ] }),
              /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-[0.25] flex-col truncate font-mono text-sm", children: [
                /* @__PURE__ */ p.jsx("h2", { className: "text-primary-50 text-xs", children: "Recieved" }),
                S.sent_at ? /* @__PURE__ */ p.jsx(uT, { date: S.sent_at }) : "-"
              ] })
            ]
          },
          `${S.event_id}`
        ) }, N) : null;
      }) })
    ] }),
    d && /* @__PURE__ */ p.jsx(rw, { data: d })
  ] }) : /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "No Envelopes found." });
}
function aw() {
  return /* @__PURE__ */ p.jsx(sE, { children: /* @__PURE__ */ p.jsxs(Ki, { children: [
    /* @__PURE__ */ p.jsx(jt, { path: "/:eventId", element: /* @__PURE__ */ p.jsx(SC, {}) }),
    /* @__PURE__ */ p.jsx(jt, { path: "/", element: /* @__PURE__ */ p.jsx(SC, {}) })
  ] }) });
}
function wS(n) {
  return /* @__PURE__ */ p.jsx("div", { className: "divide-primary-900 border-primary-900 bg-primary-950 divide-y border-y", ...n });
}
const GS = () => (x.useContext(Bs), Ut.getEvents()), iw = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("path", { d: "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z" }));
function sw(n) {
  return n === void 0 ? "undefined" : JSON.stringify(
    n,
    (a, s) => typeof s == "function" || typeof s == "symbol" || typeof s == "bigint" ? s.toString() : s,
    2
  );
}
function ow(n) {
  const a = n.lastIndexOf("?");
  return a > -1 && (n = n.slice(0, a)), n.indexOf("/node_modules/") === -1 ? n : `npm:${n.replace(/\/node_modules\//gi, "npm:").split("npm:").pop()}`;
}
function lw({ vars: n }) {
  return /* @__PURE__ */ p.jsx("table", { className: "table-values w-full", children: /* @__PURE__ */ p.jsx("tbody", { children: Object.entries(n).map(([a, s]) => /* @__PURE__ */ p.jsxs("tr", { children: [
    /* @__PURE__ */ p.jsx("th", { children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: a }) }),
    /* @__PURE__ */ p.jsx("td", { children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: sw(s) }) })
  ] }, a)) }) });
}
function uw({
  frame: n,
  defaultExpand: a = !1,
  platform: s
}) {
  var R;
  const [o, c] = x.useState(a), E = !!n.context_line, u = s === "java" ? n.module : n.filename || n.module;
  return /* @__PURE__ */ p.jsxs("li", { className: "border-primary-900 bg-primary-900 border-b last:border-b-0", children: [
    /* @__PURE__ */ p.jsxs(
      "div",
      {
        className: $e(
          E ? "hover:bg-primary-800 cursor-pointer" : "",
          "border-primary-950 text-primary-400 border-b px-2 py-1"
        ),
        onClick: E ? () => c(!o) : void 0,
        children: [
          u ? /* @__PURE__ */ p.jsxs("span", { className: "text-primary-100", children: [
            ow(u),
            " in "
          ] }) : null,
          /* @__PURE__ */ p.jsx("span", { className: "text-primary-100", children: n.function }),
          n.lineno !== void 0 && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            " ",
            "at line",
            " ",
            /* @__PURE__ */ p.jsxs("span", { className: "text-primary-100", children: [
              n.lineno,
              n.colno !== void 0 && `:${n.colno}`
            ] })
          ] }),
          o && !((R = n.filename) != null && R.includes(":")) ? /* @__PURE__ */ p.jsx(
            iw,
            {
              width: 18,
              height: 18,
              title: "Open in editor",
              className: "mx-2 inline fill-green-400 stroke-green-400 align-top",
              onClick: (d) => {
                fetch("http://localhost:8969/open", {
                  method: "POST",
                  body: `${n.filename}:${n.lineno}:${n.colno}`,
                  credentials: "omit"
                }), d.stopPropagation();
              }
            }
          ) : null
        ]
      }
    ),
    o && /* @__PURE__ */ p.jsxs("div", { className: "bg-primary-950", children: [
      n.pre_context && n.pre_context.map((d, T) => /* @__PURE__ */ p.jsxs("div", { className: "flex items-center", children: [
        n.lineno !== void 0 && /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 w-16 text-right", children: n.lineno - n.pre_context.length + T }),
        /* @__PURE__ */ p.jsx("pre", { className: "text-primary-100 flex-1  whitespace-pre-wrap px-2 py-1", children: d })
      ] }, T)),
      !!n.context_line && /* @__PURE__ */ p.jsxs(
        "div",
        {
          className: $e(
            n.pre_context || n.post_context ? "bg-primary-600" : "bg-primary-900",
            "flex items-center"
          ),
          children: [
            n.lineno !== void 0 && /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 w-16 text-right", children: n.lineno }),
            /* @__PURE__ */ p.jsx("pre", { className: "text-primary-100 whitespace-pre-wrap px-2 py-1", children: n.context_line })
          ]
        }
      ),
      n.post_context && n.post_context.map((d, T) => /* @__PURE__ */ p.jsxs("div", { className: "flex items-center", children: [
        n.lineno !== void 0 && /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 w-16 text-right", children: n.lineno + 1 + T }),
        /* @__PURE__ */ p.jsx("pre", { className: "text-primary-100 flex-1  whitespace-pre-wrap px-2 py-1", children: d })
      ] }, T)),
      n.vars && /* @__PURE__ */ p.jsx(lw, { vars: n.vars })
    ] })
  ] });
}
function mv({ event: n }) {
  const a = HS(n.exception);
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs("strong", { className: "font-bold", children: [
      a[0].type,
      ":"
    ] }),
    " ",
    a[0].value
  ] });
}
function Ew({ event: n }) {
  const a = HS(n.exception);
  return /* @__PURE__ */ p.jsx("div", { className: "space-y-4 font-mono", children: /* @__PURE__ */ p.jsxs("h3", { className: "flex flex-col", children: [
    /* @__PURE__ */ p.jsx("strong", { className: "text-xl", children: a[0].type }),
    /* @__PURE__ */ p.jsx("span", { className: "", children: a[0].value })
  ] }) });
}
function cw({ event: n }) {
  const a = HS(n.exception);
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx("ol", { className: "space-y-4", children: a.map((s, o) => {
    var c;
    return /* @__PURE__ */ p.jsxs("li", { className: "space-y-4 font-mono", children: [
      /* @__PURE__ */ p.jsxs("h3", { className: "bg-primary-950 flex flex-col", children: [
        /* @__PURE__ */ p.jsx("strong", { className: "text-xl", children: s.type }),
        /* @__PURE__ */ p.jsx("pre", { children: s.value })
      ] }),
      /* @__PURE__ */ p.jsx("ul", { className: "border-primary-600 border", children: (c = s.stacktrace) == null ? void 0 : c.frames.map((E, u) => /* @__PURE__ */ p.jsx(
        uw,
        {
          frame: E,
          defaultExpand: o === 0 && u === 0,
          platform: n.platform
        },
        u
      )) })
    ] }, o);
  }) }) });
}
function HS(n) {
  return n.value ? [n.value] : n.values;
}
function BS(n) {
  return typeof n.message == "string" ? n.message : n.message !== void 0 && typeof n.message.formatted == "string" ? n.message.formatted : "";
}
function fw({ event: n }) {
  return "exception" in n ? /* @__PURE__ */ p.jsx(mv, { event: n }) : /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsx("strong", { className: "font-bold", children: BS(n) }) });
}
function Tw({ event: n }) {
  return "exception" in n ? /* @__PURE__ */ p.jsx(Ew, { event: n }) : /* @__PURE__ */ p.jsx("div", { className: "space-y-4 font-mono", children: /* @__PURE__ */ p.jsx("h3", { className: "flex flex-col", children: /* @__PURE__ */ p.jsx("strong", { className: "text-xl", children: BS(n) }) }) });
}
function dw({ event: n }) {
  return "exception" in n ? /* @__PURE__ */ p.jsx(cw, { event: n }) : /* @__PURE__ */ p.jsxs("h3", { className: "bg-primary-950 flex flex-col", children: [
    /* @__PURE__ */ p.jsx("strong", { className: "text-xl", children: "Message:" }),
    /* @__PURE__ */ p.jsx("pre", { children: BS(n) })
  ] });
}
function Aw(n) {
  return /* @__PURE__ */ p.jsx(Tw, { event: n });
}
function Rw() {
  const n = GS(), a = oE(), s = ET(), o = n.filter((d) => d.type !== "transaction"), [c, E] = x.useState(!s.experiments["sentry:focus-local-events"]), u = c ? o : o.filter(
    (d) => {
      var T, S, N, m;
      return ((S = (T = d.contexts) == null ? void 0 : T.trace) != null && S.trace_id ? a.isLocalToSession((m = (N = d.contexts) == null ? void 0 : N.trace) == null ? void 0 : m.trace_id) : null) !== !1;
    }
  ), R = o.length - u.length;
  return o.length !== 0 ? /* @__PURE__ */ p.jsxs(wS, { children: [
    R > 0 && /* @__PURE__ */ p.jsx(
      cT,
      {
        itemCount: R,
        onClick: () => {
          E(!0);
        }
      }
    ),
    u.map((d) => {
      var S, N;
      const T = (N = (S = d.contexts) == null ? void 0 : S.trace) == null ? void 0 : N.trace_id;
      return /* @__PURE__ */ p.jsxs(
        fn,
        {
          className: "hover:bg-primary-900 flex cursor-pointer items-center gap-x-4 px-6 py-2",
          to: `${d.event_id}/details`,
          children: [
            /* @__PURE__ */ p.jsx(Vi, { event: d, className: "text-primary-300 rounded-md" }),
            /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex w-48 flex-col truncate font-mono text-sm", children: [
              /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-x-2", children: [
                /* @__PURE__ */ p.jsx("div", { children: (d.event_id || "").substring(0, 8) }),
                T && a.isLocalToSession(T) ? /* @__PURE__ */ p.jsx(PS, { title: "This event is part of your local session.", children: "Local" }) : null
              ] }),
              /* @__PURE__ */ p.jsx("span", {}),
              /* @__PURE__ */ p.jsx(uT, { date: d.timestamp })
            ] }),
            /* @__PURE__ */ p.jsx("div", { className: "flex-1", children: Aw(d) })
          ]
        },
        d.event_id
      );
    })
  ] }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no events recorded matching this query. 🤔" });
}
var vv = { exports: {} };
(function(n, a) {
  (function(s, o) {
    n.exports = o();
  })(Yt, function() {
    var s = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(o, c, E) {
      var u = c.prototype, R = u.format;
      E.en.formats = s, u.format = function(d) {
        d === void 0 && (d = "YYYY-MM-DDTHH:mm:ssZ");
        var T = this.$locale().formats, S = function(N, m) {
          return N.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(v, M, w) {
            var y = w && w.toUpperCase();
            return M || m[w] || s[w] || m[y].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(O, g, V) {
              return g || V.slice(1);
            });
          });
        }(d, T === void 0 ? {} : T);
        return R.call(this, S);
      };
    };
  });
})(vv);
var pw = vv.exports;
const Lv = /* @__PURE__ */ Xi(pw);
xs.extend(Lv);
function Sw({
  date: n,
  ...a
}) {
  return n ? /* @__PURE__ */ p.jsx("time", { dateTime: n instanceof Date ? n.toISOString() : `${n}`, ...a, children: xs(n).format(a.format ? a.format : "LTS") }) : null;
}
const hw = `Sentry.addBreadcrumb({
  category: "auth",
  message: "Authenticated user " + user.email,
  level: "info",
});`;
function Nw(n) {
  if (!n.breadcrumbs)
    return [];
  if (Array.isArray(n.breadcrumbs))
    return n.breadcrumbs;
  if (Array.isArray(n.breadcrumbs.values))
    return n.breadcrumbs.values;
}
function Ow({ event: n }) {
  const a = Nw(n);
  return !a || !a.length || a.every((s) => !s.message) ? /* @__PURE__ */ p.jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ p.jsx("div", { className: "text-primary-300", children: "No breadcrumbs available for this event. Try adding some to make debugging easier." }),
    /* @__PURE__ */ p.jsx("pre", { className: "whitespace-pre-wrap ", children: hw })
  ] }) : /* @__PURE__ */ p.jsx("div", { className: "divide-primary-800 grid-cols-2-auto -mx-2 grid space-y-2 divide-y", children: a.map((s, o) => s.message ? /* @__PURE__ */ p.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ p.jsxs("div", { className: "flex flex-none flex-col p-2", children: [
      /* @__PURE__ */ p.jsx("div", { className: "text-lg font-semibold", children: s.category || " " }),
      /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 text-xs", children: /* @__PURE__ */ p.jsx(Sw, { date: s.timestamp, format: "HH:mm:ss" }) })
    ] }),
    /* @__PURE__ */ p.jsx(
      "pre",
      {
        className: $e(
          "flex grow items-center whitespace-pre-line p-2 !font-mono",
          o === 0 ? "!border-t-0" : ""
        ),
        children: s.message
      }
    )
  ] }, o) : null) });
}
function Iw({ tagKey: n, value: a }) {
  return /* @__PURE__ */ p.jsxs("div", { className: "border-primary-300 bg-primary-900 divide-x-primary-300 inline-flex divide-x whitespace-nowrap rounded-full border font-mono text-sm", children: [
    /* @__PURE__ */ p.jsx("div", { className: "px-2 py-1 font-semibold", children: n }),
    /* @__PURE__ */ p.jsx("div", { className: "bg-primary-800 rounded-r-full px-2 py-1", children: a })
  ] });
}
function _w({ tags: n }) {
  return /* @__PURE__ */ p.jsx("div", { className: "flex flex-row flex-wrap gap-2 pt-2", children: Object.keys(n).map((a) => /* @__PURE__ */ p.jsx(Iw, { tagKey: a, value: n[a] }, a)) });
}
const Cw = `Sentry.setContext("character", {
  name: "Mighty Fighter",
  age: 19,
  attack_type: "melee",
});`;
function mw({ event: n }) {
  const a = { extra: n.extra, ...n.contexts }, s = n.tags;
  return (!a || !Object.values(a).find((o) => !!o)) && !s ? /* @__PURE__ */ p.jsxs("div", { className: "space-y-4 px-6", children: [
    /* @__PURE__ */ p.jsx("div", { className: "text-primary-300", children: "No context available for this event. Try adding some to make debugging easier." }),
    /* @__PURE__ */ p.jsx("pre", { className: "whitespace-pre-wrap ", children: Cw })
  ] }) : /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    s && /* @__PURE__ */ p.jsxs("div", { className: "pb-4", children: [
      /* @__PURE__ */ p.jsx("h2", { className: "font-bold uppercase", children: "Tags" }),
      /* @__PURE__ */ p.jsx(_w, { tags: s })
    ] }),
    /* @__PURE__ */ p.jsx("div", { className: "space-y-6", children: Object.entries(a).map(([o, c]) => c ? /* @__PURE__ */ p.jsxs("div", { children: [
      /* @__PURE__ */ p.jsx("h2", { className: "font-bold uppercase", children: o }),
      /* @__PURE__ */ p.jsx("table", { className: "w-full", children: /* @__PURE__ */ p.jsx("tbody", { children: Object.entries(c).map(([E, u]) => /* @__PURE__ */ p.jsxs("tr", { children: [
        /* @__PURE__ */ p.jsx("th", { className: "text-primary-300 w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: E }) }),
        /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "text-primary-300 whitespace-nowrap font-mono", children: JSON.stringify(u, void 0, 2) }) })
      ] }, E)) }) })
    ] }, o) : null) })
  ] });
}
function vw(n) {
  return /* @__PURE__ */ p.jsx(dw, { event: n });
}
function Lw(n) {
  return /* @__PURE__ */ p.jsx(fw, { event: n });
}
function yw() {
  var u;
  const { eventId: n } = Zo(), [a, s] = x.useState("details");
  if (!n)
    return /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 p-6", children: "Unknown event id" });
  const o = Ut.getEventById(n);
  if (!o)
    return /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 p-6", children: "Event not found." });
  const c = [
    {
      id: "details",
      title: "Details",
      active: a === "details",
      onSelect: () => s("details")
    },
    {
      id: "breadcrumbs",
      title: "Breadcrumbs",
      active: a === "breadcrumbs",
      onSelect: () => s("breadcrumbs")
    },
    {
      id: "contexts",
      title: "Context",
      active: a === "contexts",
      onSelect: () => s("contexts")
    }
  ], E = (u = o.contexts) == null ? void 0 : u.trace;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsxs("div", { className: "bg-primary-950 flex items-center gap-x-2 px-6 py-4", children: [
      /* @__PURE__ */ p.jsx(Vi, { event: o, className: "rounded-md" }),
      /* @__PURE__ */ p.jsx("h1", { className: "max-w-full flex-1 truncate text-2xl", children: Lw(o) }),
      !!E && /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 font-mono", children: [
        /* @__PURE__ */ p.jsxs("div", { children: [
          "T:",
          " ",
          /* @__PURE__ */ p.jsx(fn, { className: "cursor-pointer underline", to: `/traces/${E.trace_id}`, children: E.trace_id })
        ] }),
        /* @__PURE__ */ p.jsxs("div", { children: [
          "S:",
          " ",
          /* @__PURE__ */ p.jsx(fn, { className: "cursor-pointer underline", to: `/traces/${E.trace_id}/${E.span_id}`, children: E.span_id })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ p.jsx(DS, { tabs: c, nested: !0 }),
    /* @__PURE__ */ p.jsxs("div", { className: "flex-1 px-6 py-4", children: [
      /* @__PURE__ */ p.jsxs(Ki, { children: [
        /* @__PURE__ */ p.jsx(jt, { path: "breadcrumbs", element: /* @__PURE__ */ p.jsx(Ow, { event: o }) }),
        /* @__PURE__ */ p.jsx(jt, { path: "contexts", element: /* @__PURE__ */ p.jsx(mw, { event: o }) }),
        /* @__PURE__ */ p.jsx(jt, { path: "*", element: vw(o) })
      ] }),
      /* @__PURE__ */ p.jsx(ov, {})
    ] })
  ] });
}
function gw() {
  return /* @__PURE__ */ p.jsx(sE, { children: /* @__PURE__ */ p.jsxs(Ki, { children: [
    /* @__PURE__ */ p.jsx(jt, { path: "/", element: /* @__PURE__ */ p.jsx(Rw, {}) }),
    /* @__PURE__ */ p.jsx(jt, { path: "/:eventId/*", element: /* @__PURE__ */ p.jsx(yw, {}) })
  ] }) });
}
const fT = () => {
  x.useContext(Bs);
  const n = oE(), a = Ut.getTraces(), s = a.filter((E) => n.isLocalToSession(E.trace_id) !== !1), o = a.reduce((E, u) => [...E, ...u.spans], []), c = s.reduce((E, u) => [...E, ...u.spans], []);
  return [o, c];
}, TT = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", width: 24, height: 24, viewBox: "0 0 24 24", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("path", { d: "M17,14 C17.8092996,14 18.2680938,14.9010044 17.836059,15.5493995 L17.7682213,15.6401844 L12.7682213,21.6401844 C12.3950792,22.0879549 11.7283228,22.1178063 11.3160321,21.7297385 L11.2317787,21.6401844 L6.23177872,15.6401844 C5.71367776,15.0184632 6.11213562,14.0891988 6.88682851,14.0060047 L7,14 L17,14 Z M11.2317787,2.3598156 C11.6049208,1.91204508 12.2716772,1.88219371 12.6839679,2.2702615 L12.7682213,2.3598156 L17.7682213,8.3598156 C18.2863222,8.98153675 17.8878644,9.91080124 17.1131715,9.99399528 L17,10 L7,10 C6.19070043,10 5.73190618,9.09899556 6.16394105,8.45060047 L6.23177872,8.3598156 L11.2317787,2.3598156 Z" })), dT = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", width: 24, height: 24, viewBox: "-96 0 512 512", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z" })), ei = {
  avgDuration: "AVG_DURATION",
  timeSpent: "TIME_SPENT",
  description: "DESC",
  avgEncodedSize: "AVG_ENCODED_SIZE"
}, Dw = [
  {
    id: "description",
    title: "Resource Description",
    sortKey: ei.description,
    primary: !0
  },
  {
    id: "avgDuration",
    title: "Avg Duration",
    sortKey: ei.avgDuration
  },
  {
    id: "timeSpent",
    title: "Time Spent",
    sortKey: ei.timeSpent
  },
  {
    id: "avgEncodedSize",
    title: "Avg Encoded Size",
    sortKey: ei.avgEncodedSize
  }
], bs = {
  queryDesc: "QUERY_DESCRIPTION",
  timeSpent: "TIME_SPENT",
  avgDuration: "AVG_DURATION"
}, bw = [
  {
    id: "queryDesc",
    title: "Query Description",
    sortKey: bs.queryDesc,
    primary: !0
  },
  {
    id: "avgDuration",
    title: "Avg Duration",
    sortKey: bs.avgDuration
  },
  {
    id: "timeSpent",
    title: "Time Spent",
    sortKey: bs.timeSpent
  }
], Ms = {
  foundIn: "FOUND_IN",
  spanId: "SPAN_ID",
  timeSpent: "TIME_SPENT"
}, Mw = [
  {
    id: "foundIn",
    title: "Found In",
    sortKey: Ms.foundIn,
    primary: !0
  },
  {
    id: "spanId",
    title: "Span Id",
    sortKey: Ms.spanId
  },
  {
    id: "timeSpent",
    title: "Time Spent",
    sortKey: Ms.timeSpent
  }
], nr = {
  pages: "Pages",
  lcp: "LCP",
  fcp: "FCP",
  fid: "FID",
  cls: "CLS",
  ttfb: "TTFB",
  score: "PERFORMANCE_TOTAL_SCORE"
}, Pw = [
  {
    id: "pages",
    title: "Pages",
    sortKey: nr.pages,
    primary: !0
  },
  {
    id: "lcp",
    title: "LCP",
    sortKey: nr.lcp
  },
  {
    id: "fcp",
    title: "FCP",
    sortKey: nr.fcp
  },
  {
    id: "fid",
    title: "FID",
    sortKey: nr.fid
  },
  {
    id: "cls",
    title: "CLS",
    sortKey: nr.cls
  },
  {
    id: "ttfb",
    title: "TTFB",
    sortKey: nr.ttfb
  },
  {
    id: "score",
    title: "Perf Score",
    sortKey: nr.score
  }
], yv = {
  profiles: [
    {
      name: "Chrome",
      scoreComponents: [
        { measurement: "fcp", weight: 0.15, p10: 900, p50: 1600, optional: !1 },
        { measurement: "lcp", weight: 0.3, p10: 1200, p50: 2400, optional: !1 },
        { measurement: "fid", weight: 0.3, p10: 100, p50: 300, optional: !0 },
        { measurement: "cls", weight: 0.15, p10: 0.1, p50: 0.25, optional: !1 },
        { measurement: "ttfb", weight: 0.1, p10: 200, p50: 400, optional: !1 }
      ],
      condition: { op: "eq", name: "event.contexts.browser.name", value: "Chrome" }
    }
    // TODO: Currently not getting browser data in events, so made these comments and sticked to chrome always.
    // {
    //   "name": "Firefox",
    //   "scoreComponents": [
    //     {"measurement": "fcp", "weight": 0.15, "p10": 900.0, "p50": 1600.0, "optional": false},
    //     {"measurement": "lcp", "weight": 0.0, "p10": 1200.0, "p50": 2400.0, "optional": false},
    //     {"measurement": "fid", "weight": 0.30, "p10": 100.0, "p50": 300.0, "optional": true},
    //     {"measurement": "cls", "weight": 0.0, "p10": 0.1, "p50": 0.25, "optional": false},
    //     {"measurement": "ttfb", "weight": 0.10, "p10": 200.0, "p50": 400.0, "optional": false}
    //   ],
    //   "condition": {"op": "eq", "name": "event.contexts.browser.name", "value": "Firefox"}
    // },
    // {
    //   "name": "Safari",
    //   "scoreComponents": [
    //     {"measurement": "fcp", "weight": 0.15, "p10": 900.0, "p50": 1600.0, "optional": false},
    //     {"measurement": "lcp", "weight": 0.0, "p10": 1200.0, "p50": 2400.0, "optional": false},
    //     {"measurement": "fid", "weight": 0.0, "p10": 100.0, "p50": 300.0, "optional": true},
    //     {"measurement": "cls", "weight": 0.0, "p10": 0.1, "p50": 0.25, "optional": false},
    //     {"measurement": "ttfb", "weight": 0.10, "p10": 200.0, "p50": 400.0, "optional": false}
    //   ],
    //   "condition": {"op": "eq", "name": "event.contexts.browser.name", "value": "Safari"}
    // },
    // {
    //   "name": "Edge",
    //   "scoreComponents": [
    //     {"measurement": "fcp", "weight": 0.15, "p10": 900.0, "p50": 1600.0, "optional": false},
    //     {"measurement": "lcp", "weight": 0.30, "p10": 1200.0, "p50": 2400.0, "optional": false},
    //     {"measurement": "fid", "weight": 0.30, "p10": 100.0, "p50": 300.0, "optional": true},
    //     {"measurement": "cls", "weight": 0.15, "p10": 0.1, "p50": 0.25, "optional": false},
    //     {"measurement": "ttfb", "weight": 0.10, "p10": 200.0, "p50": 400.0, "optional": false}
    //   ],
    //   "condition": {"op": "eq", "name": "event.contexts.browser.name", "value": "Edge"}
    // },
    // {
    //   "name": "Opera",
    //   "scoreComponents": [
    //     {"measurement": "fcp", "weight": 0.15, "p10": 900.0, "p50": 1600.0, "optional": false},
    //     {"measurement": "lcp", "weight": 0.30, "p10": 1200.0, "p50": 2400.0, "optional": false},
    //     {"measurement": "fid", "weight": 0.30, "p10": 100.0, "p50": 300.0, "optional": true},
    //     {"measurement": "cls", "weight": 0.15, "p10": 0.1, "p50": 0.25, "optional": false},
    //     {"measurement": "ttfb", "weight": 0.10, "p10": 200.0, "p50": 400.0, "optional": false}
    //   ],
    //   "condition": {"op": "eq", "name": "event.contexts.browser.name", "value": "Opera"}
    // }
  ]
}, hC = 1e3, NC = 6e4, OC = 36e5, IC = 864e5, _C = 6048e5, CC = 26298e5, mC = 315576e5, Bi = {
  yr: "yr",
  mo: "mo",
  wk: "wk",
  d: "d",
  hr: "hr",
  min: "min",
  s: "s",
  ms: "ms"
};
function Jo(n, a) {
  const s = typeof n == "string" ? new Date(n).getTime() : n, o = typeof a == "string" ? new Date(a).getTime() : a;
  return Math.floor(o - s);
}
function Uw(n) {
  if (n > 1e3)
    return "text-red-400";
  if (n > 500)
    return "text-orange-400";
  if (n > 100)
    return "text-yellow-400";
}
function Fi(n, a = 2) {
  return n % 1 !== 0 || n % 1 === 0 && n.toString().includes(".") ? n.toFixed(a) : n.toFixed(0);
}
function fr(n) {
  return n >= mC ? `${Fi(n / mC)}${Bi.yr}` : n >= CC ? `${Fi(n / CC)}${Bi.mo}` : n >= _C ? `${Fi(n / _C)}${Bi.wk}` : n >= IC ? `${Fi(n / IC)}${Bi.d}` : n >= OC ? `${Fi(n / OC)}${Bi.hr}` : n >= NC ? `${Fi(n / NC)}${Bi.min}` : n >= hC ? `${Fi(n / hC)}${Bi.s}` : `${Fi(n)}${Bi.ms}`;
}
const xw = (n, a) => {
  if (a) {
    const s = new RegExp(a);
    return n.filter((o) => s.test(o.op || ""));
  }
  return [];
}, ww = ({ query: n, spanData: a }) => {
  const o = a.filter((u) => u.description === n).map((u) => u.timestamp - u.start_timestamp), c = o.reduce((u, R) => u + R, 0);
  return {
    avgDuration: c / o.length,
    timeSpent: c,
    description: n
  };
}, Gw = ({ showAll: n }) => {
  const [a, s] = fT(), [o, c] = x.useState([]), [E, u] = x.useState({
    active: bs.timeSpent,
    asc: !1
  }), R = (T) => {
    E.active === T ? u((S) => ({
      active: T,
      asc: !S.asc
    })) : u({
      active: T,
      asc: !1
    });
  }, d = (T, S) => {
    switch (E.active) {
      case bs.queryDesc:
        return T.description < S.description ? -1 : T.description > S.description ? 1 : 0;
      case bs.avgDuration:
        return T.avgDuration - S.avgDuration;
      case bs.timeSpent:
        return T.timeSpent - S.timeSpent;
      default:
        return T.timeSpent - S.timeSpent;
    }
  };
  return x.useEffect(() => {
    const T = xw(n ? a : s, /db\.[A-Za-z]+/);
    if (T.length > 0) {
      const S = [
        ...new Set(
          T.map((N) => N == null ? void 0 : N.description).map(String).filter((N) => N.trim() !== "")
        )
      ];
      c(
        S.map((N) => ww({ query: N, spanData: T })).sort((N, m) => E.asc ? d(N, m) : d(m, N))
      );
    }
  }, [n, E]), o && o.length ? /* @__PURE__ */ p.jsxs("table", { className: "divide-primary-700 w-full table-fixed divide-y", children: [
    /* @__PURE__ */ p.jsx("thead", { children: /* @__PURE__ */ p.jsx("tr", { children: bw.map((T) => /* @__PURE__ */ p.jsx(
      "th",
      {
        scope: "col",
        className: $e(
          "text-primary-100 select-none px-6 py-3.5 text-sm font-semibold",
          T.primary ? "w-2/5" : "w-[15%]"
        ),
        children: /* @__PURE__ */ p.jsxs(
          "div",
          {
            className: $e(
              "flex cursor-pointer items-center gap-1",
              T.primary ? "justify-start" : "justify-end"
            ),
            onClick: () => R(T.sortKey),
            children: [
              T.title,
              E.active === T.sortKey ? /* @__PURE__ */ p.jsx(
                dT,
                {
                  width: 12,
                  height: 12,
                  className: $e(
                    "fill-primary-300",
                    E.asc ? "-translate-y-0.5 rotate-0" : "translate-y-0.5 rotate-180"
                  )
                }
              ) : /* @__PURE__ */ p.jsx(TT, { width: 12, height: 12, className: "stroke-primary-300" })
            ]
          }
        )
      },
      T.id
    )) }) }),
    /* @__PURE__ */ p.jsx("tbody", { children: o.map((T) => /* @__PURE__ */ p.jsxs("tr", { className: "hover:bg-primary-900", children: [
      /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-2/5 truncate whitespace-nowrap px-6 py-4 text-left text-sm font-medium", children: /* @__PURE__ */ p.jsx(fn, { className: "truncate hover:underline", to: `/performance/queries/${T.description}`, children: T.description }) }),
      /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: fr(T.avgDuration) }),
      /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: fr(T.timeSpent) })
    ] }, T.description)) })
  ] }) : /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "No Database queries found. Add integration in Sentry initialization to track Database queries." });
}, gv = ({
  title: n,
  titleId: a,
  ...s
}) => /* @__PURE__ */ x.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-chevron-down", viewBox: "0 0 16 16", "aria-labelledby": a, ...s }, n ? /* @__PURE__ */ x.createElement("title", { id: a }, n) : null, /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" }));
function Dv({ crumbs: n }) {
  return /* @__PURE__ */ p.jsx("div", { className: "flex items-center gap-1 px-6 py-4", children: n.map((a, s) => {
    const o = s === n.length - 1;
    return /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-1", children: [
      s > 0 && /* @__PURE__ */ p.jsx(gv, { width: 12, height: 12, className: "stroke-primary-300 -rotate-90" }),
      a.link && a.to ? /* @__PURE__ */ p.jsx(
        fn,
        {
          className: $e(
            o ? "text-primary-200" : "text-primary-300",
            "hover:text-primary-100 truncate text-sm hover:underline"
          ),
          to: a.to,
          children: a.label
        }
      ) : /* @__PURE__ */ p.jsx("span", { className: $e(o ? "text-primary-200" : "text-primary-300", "truncate text-sm"), children: a.label })
    ] }, a.id);
  }) });
}
const Hw = (n, a) => a ? n.filter((s) => s.description === a) : [], Bw = ({ showAll: n }) => {
  const [a, s] = fT(), { type: o } = Zo(), [c, E] = x.useState([]), [u, R] = x.useState({
    active: Ms.timeSpent,
    asc: !1
  }), d = (S) => {
    u.active === S ? R((N) => ({
      active: S,
      asc: !N.asc
    })) : R({
      active: S,
      asc: !1
    });
  }, T = (S, N) => {
    switch (u.active) {
      case Ms.foundIn:
        return S.trace_id < N.trace_id ? -1 : S.trace_id > N.trace_id ? 1 : 0;
      case Ms.spanId:
        return S.span_id < N.span_id ? -1 : S.span_id > N.span_id ? 1 : 0;
      case Ms.timeSpent: {
        const m = S.timestamp - S.start_timestamp, v = N.timestamp - N.start_timestamp;
        return m - v;
      }
      default: {
        const m = S.timestamp - S.start_timestamp, v = N.timestamp - N.start_timestamp;
        return m - v;
      }
    }
  };
  return x.useEffect(() => {
    E(
      Hw(n ? a : s, o).sort((S, N) => u.asc ? T(S, N) : T(N, S))
    );
  }, [n, u]), o && c && c.length ? /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(
      Dv,
      {
        crumbs: [
          {
            id: "queries",
            label: "Queries",
            link: !0,
            to: "/performance/queries"
          },
          {
            id: "querySummary",
            label: "Query Summary",
            link: !1
          }
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs("table", { className: "divide-primary-700 w-full table-fixed divide-y", children: [
      /* @__PURE__ */ p.jsx("thead", { children: /* @__PURE__ */ p.jsx("tr", { children: Mw.map((S) => /* @__PURE__ */ p.jsx(
        "th",
        {
          scope: "col",
          className: $e(
            "text-primary-100 px-6 py-3.5 text-sm font-semibold",
            S.primary ? "w-2/5" : "w-[15%]"
          ),
          children: /* @__PURE__ */ p.jsxs(
            "div",
            {
              className: $e(
                "flex cursor-pointer select-none items-center gap-1",
                S.primary ? "justify-start" : "justify-end"
              ),
              onClick: () => d(S.sortKey),
              children: [
                S.title,
                u.active === S.sortKey ? /* @__PURE__ */ p.jsx(
                  dT,
                  {
                    width: 12,
                    height: 12,
                    className: $e(
                      "fill-primary-300",
                      u.asc ? "-translate-y-0.5 rotate-0" : "translate-y-0.5 rotate-180"
                    )
                  }
                ) : /* @__PURE__ */ p.jsx(TT, { width: 12, height: 12, className: "stroke-primary-300" })
              ]
            }
          )
        },
        S.id
      )) }) }),
      /* @__PURE__ */ p.jsx("tbody", { children: c.map((S) => /* @__PURE__ */ p.jsxs("tr", { className: "hover:bg-primary-900", children: [
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-2/5 truncate whitespace-nowrap px-6 py-4 text-left text-sm font-medium", children: /* @__PURE__ */ p.jsx(fn, { className: "truncate hover:underline", to: `/traces/${S.trace_id}`, children: S.trace_id }) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: /* @__PURE__ */ p.jsx(fn, { className: "truncate hover:underline", to: `/traces/${S.trace_id}/${S.span_id}`, children: S.span_id }) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: fr(S.timestamp - S.start_timestamp) })
      ] }, S.span_id)) })
    ] })
  ] }) : /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "Query not found." });
}, Fw = (n) => {
  switch (n) {
    case "top":
      return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
    case "bottom":
      return "top-full left-1/2 transform -translate-x-1/2 mt-2";
    case "left":
      return "top-1/2 right-full transform -translate-y-1/2 mr-2";
    default:
      return "top-1/2 left-full transform -translate-y-1/2 ml-2";
  }
}, Yw = ({ content: n, position: a = "right", children: s }) => {
  const [o, c] = x.useState(!1), E = () => {
    c(!0);
  }, u = () => {
    c(!1);
  };
  return /* @__PURE__ */ p.jsxs("div", { className: "relative inline-block max-w-full", onMouseEnter: E, onMouseLeave: u, children: [
    s,
    o && /* @__PURE__ */ p.jsx("div", { className: $e("absolute z-10", Fw(a)), children: n })
  ] });
};
function bv(n, a = 2) {
  if (n == 0)
    return "0 B";
  const s = 1024, o = a, c = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], E = Math.floor(Math.log(n) / Math.log(s));
  return parseFloat((n / Math.pow(s, E)).toFixed(o)) + " " + c[E];
}
const Vw = ({ resource: n, spanData: a }) => {
  const s = a.filter((u) => u.description === n), o = s.reduce(
    (u, R) => u + (R.timestamp - R.start_timestamp),
    0
  ), c = o / s.length, E = s.reduce((u, R) => {
    const d = R.data && R.data["http.response_content_length"];
    return typeof d == "number" ? u + d : u;
  }, 0) / s.length;
  return {
    avgDuration: c,
    timeSpent: o,
    description: n,
    avgEncodedSize: E,
    similarResources: s
  };
}, Ww = (n, a) => {
  if (a.type)
    return n.filter((s) => s.description === a.type);
  if (a.regex) {
    const s = new RegExp(a.regex);
    return n.filter((o) => s.test(o.op || ""));
  }
  return [];
}, kw = ({ showAll: n }) => {
  const [a, s] = fT(), [o, c] = x.useState({
    active: ei.timeSpent,
    asc: !1
  }), [E, u] = x.useState([]), R = (T, S) => {
    switch (o.active) {
      case ei.description:
        return T.description < S.description ? -1 : T.description > S.description ? 1 : 0;
      case ei.avgEncodedSize:
        return T.avgEncodedSize - S.avgEncodedSize;
      case ei.avgDuration:
        return T.avgDuration - S.avgDuration;
      case ei.timeSpent:
        return T.timeSpent - S.timeSpent;
      default:
        return T.timeSpent - S.timeSpent;
    }
  }, d = (T) => {
    o.active === T ? c((S) => ({
      active: T,
      asc: !S.asc
    })) : c({
      active: T,
      asc: !1
    });
  };
  return x.useEffect(() => {
    const T = Ww(n ? a : s, { regex: /resource\.[A-Za-z]+/ });
    if (T.length > 0) {
      const S = [
        ...new Set(
          T.map((N) => N == null ? void 0 : N.description).map(String).filter((N) => N.trim() !== "")
        )
      ];
      u(
        S.map((N) => Vw({ resource: N, spanData: T })).sort((N, m) => o.asc ? R(N, m) : R(m, N))
      );
    }
  }, [o, n]), E && E.length ? /* @__PURE__ */ p.jsxs("table", { className: "divide-primary-700 w-full table-fixed divide-y", children: [
    /* @__PURE__ */ p.jsx("thead", { children: /* @__PURE__ */ p.jsx("tr", { children: Dw.map((T) => /* @__PURE__ */ p.jsx(
      "th",
      {
        scope: "col",
        className: $e(
          "text-primary-100 px-6 py-3.5 text-sm font-semibold",
          T.primary ? "w-2/5" : "w-[15%]"
        ),
        children: /* @__PURE__ */ p.jsxs(
          "div",
          {
            className: $e(
              "flex cursor-pointer select-none items-center gap-1",
              T.primary ? "justify-start" : "justify-end"
            ),
            onClick: () => d(T.sortKey),
            children: [
              T.title,
              o.active === T.sortKey ? /* @__PURE__ */ p.jsx(
                dT,
                {
                  width: 12,
                  height: 12,
                  className: $e(
                    "fill-primary-300",
                    o.asc ? "-translate-y-0.5 rotate-0" : "translate-y-0.5 rotate-180"
                  )
                }
              ) : /* @__PURE__ */ p.jsx(TT, { width: 12, height: 12, className: "stroke-primary-300" })
            ]
          }
        )
      },
      T.id
    )) }) }),
    /* @__PURE__ */ p.jsx("tbody", { children: E.map((T) => {
      var S;
      return /* @__PURE__ */ p.jsxs("tr", { className: "hover:bg-primary-900", children: [
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 relative w-2/5 whitespace-nowrap px-6 py-4 text-left text-sm font-medium", children: /* @__PURE__ */ p.jsx(
          Yw,
          {
            position: "right",
            content: T.similarResources[0].op === "resource.img" && ((S = T.description) == null ? void 0 : S.indexOf("/")) === 0 && /* @__PURE__ */ p.jsxs("div", { className: "bg-primary-800 cursor-pointer rounded-lg p-4 shadow-md", children: [
              /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold", children: "Preview" }),
              /* @__PURE__ */ p.jsx(
                "img",
                {
                  src: T.description,
                  className: "inline-block max-h-[150px] max-w-[150px] rounded p-1",
                  alt: "preview"
                }
              )
            ] }),
            children: /* @__PURE__ */ p.jsx("div", { className: "truncate", children: T.description })
          }
        ) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: fr(T.avgDuration) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: fr(T.timeSpent) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: bv(T.avgEncodedSize) })
      ] }, T.description);
    }) })
  ] }) : /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "No Resource found." });
}, Mv = Math.sqrt(2);
function Xw(n) {
  const a = 0.254829592, s = -0.284496736, o = 1.421413741, c = -1.453152027, E = 1.061405429, u = 0.3275911, R = n < 0 ? -1 : 1, d = Math.abs(n), T = 1 / (1 + u * d), S = 1 - ((((E * T + c) * T + o) * T + s) * T + a) * T * Math.exp(-d * d);
  return R * S;
}
function jw(n, a) {
  return Math.abs(Math.log(n) - Math.log(a)) / (Mv * 0.9061938024368232);
}
function Kw(n, a, s) {
  return 0.5 * (1 - Xw((Math.log(n) - Math.log(s)) / (Mv * jw(s, a))));
}
function Pv(n, a) {
  if (a)
    for (const s of a.profiles) {
      const o = n.measurements;
      if (o) {
        let c = !1, E = 0, u = 0;
        for (const R of s.scoreComponents)
          R.optional && !Object.prototype.hasOwnProperty.call(o, R.measurement) || (u += R.weight);
        if (Math.abs(u) < Number.EPSILON)
          break;
        for (const R of s.scoreComponents) {
          let d = 0;
          if (Object.prototype.hasOwnProperty.call(o, R.measurement)) {
            d = R.weight / u;
            const T = o[R.measurement].value, S = Kw(Math.max(0, T), R.p10, R.p50), N = S * d;
            E += N, c = !0, o[`score.${R.measurement}`] = {
              value: S,
              unit: "ratio"
            };
          } else
            o[`score.${R.measurement}`] = {
              value: 0,
              unit: "ratio"
            };
          o[`score.weight.${R.measurement}`] = {
            value: d,
            unit: "ratio"
          };
        }
        c && (o["score.total"] = {
          value: E,
          unit: "ratio"
        });
        break;
      }
    }
}
function Jw(n, a, s, o, c, E, u, R) {
  const d = n / 2 + o + R, T = {
    x: a + n / 2 - E / 2,
    y: s + n / 2 + u / 2
  }, S = Object.values(c).reduce((j, z) => j + z, 0), N = -90, m = (j) => j / S * 360, [v, M, w, y, O] = [
    c.lcp,
    c.fcp,
    c.fid,
    c.cls,
    c.ttfb
  ].map(m), g = T.x + d * Math.cos((N + v / 2) * Math.PI / 180), V = T.y + d * Math.sin((N + v / 2) * Math.PI / 180), D = T.x + d * Math.cos((N + v + M / 2) * Math.PI / 180), G = T.y + d * Math.sin((N + v + M / 2) * Math.PI / 180), P = T.x + d * Math.cos((N + v + M + w / 2) * Math.PI / 180), U = T.y + d * Math.sin((N + v + M + w / 2) * Math.PI / 180), Y = T.x + d * Math.cos((N + v + M + w + y / 2) * Math.PI / 180), X = T.y + d * Math.sin((N + v + M + w + y / 2) * Math.PI / 180), _ = T.x - 12 + d * Math.cos((N + v + M + w + y + O / 2) * Math.PI / 180), F = T.y + d * Math.sin((N + v + M + w + y + O / 2) * Math.PI / 180);
  return {
    lcpX: g,
    lcpY: V,
    fcpX: D,
    fcpY: G,
    fidX: P,
    fidY: U,
    clsX: Y,
    clsY: X,
    ttfbX: _,
    ttfbY: F
  };
}
const zw = ({ showAll: n }) => {
  const a = GS(), [s, o] = x.useState([]), [c, E] = x.useState({
    active: nr.score,
    asc: !1
  }), u = (d) => {
    c.active === d ? E((T) => ({
      active: d,
      asc: !T.asc
    })) : E({
      active: d,
      asc: !1
    });
  }, R = (d, T) => {
    switch (c.active) {
      case nr.pages:
        return d.transaction && T.transaction && d.transaction < T.transaction ? -1 : d.transaction && T.transaction && d.transaction > T.transaction ? 1 : 0;
      case nr.lcp:
        return d.measurements["score.lcp"].value - T.measurements["score.lcp"].value;
      case nr.fid:
        return d.measurements["score.fid"].value - T.measurements["score.fid"].value;
      case nr.fcp:
        return d.measurements["score.fcp"].value - T.measurements["score.fcp"].value;
      case nr.cls:
        return d.measurements["score.cls"].value - T.measurements["score.cls"].value;
      case nr.ttfb:
        return d.measurements["score.ttfb"].value - T.measurements["score.ttfb"].value;
      case nr.score:
        return d.measurements["score.total"].value - T.measurements["score.total"].value;
      default:
        return d.measurements["score.total"].value - T.measurements["score.total"].value;
    }
  };
  return x.useEffect(() => {
    var T, S;
    const d = [];
    for (const N of a)
      if (N.measurements && ((S = (T = N == null ? void 0 : N.contexts) == null ? void 0 : T.trace) == null ? void 0 : S.op) === "pageload") {
        const m = { ...N };
        Pv(m, yv), d.push(m);
      }
    o(
      d.sort((N, m) => c.asc ? R(N, m) : R(m, N))
    );
  }, [n, c]), s && s.length ? /* @__PURE__ */ p.jsx(p.Fragment, { children: /* @__PURE__ */ p.jsxs("table", { className: "divide-primary-700 w-full table-fixed divide-y", children: [
    /* @__PURE__ */ p.jsx("thead", { children: /* @__PURE__ */ p.jsx("tr", { children: Pw.map((d) => /* @__PURE__ */ p.jsx(
      "th",
      {
        scope: "col",
        className: $e(
          "text-primary-100 px-6 py-3.5 text-sm font-semibold",
          d.primary ? "w-2/5" : "w-[15%]"
        ),
        children: /* @__PURE__ */ p.jsxs(
          "div",
          {
            className: $e(
              "flex cursor-pointer select-none items-center gap-1",
              d.primary ? "justify-start" : "justify-end"
            ),
            onClick: () => u(d.sortKey),
            children: [
              d.title,
              c.active === d.sortKey ? /* @__PURE__ */ p.jsx(
                dT,
                {
                  width: 12,
                  height: 12,
                  className: $e(
                    "fill-primary-300",
                    c.asc ? "-translate-y-0.5 rotate-0" : "translate-y-0.5 rotate-180"
                  )
                }
              ) : /* @__PURE__ */ p.jsx(TT, { width: 12, height: 12, className: "stroke-primary-300" })
            ]
          }
        )
      },
      d.id
    )) }) }),
    /* @__PURE__ */ p.jsx("tbody", { children: s.map((d) => {
      var T, S, N, m, v, M;
      return /* @__PURE__ */ p.jsxs("tr", { className: "hover:bg-primary-900", children: [
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-2/5 truncate whitespace-nowrap px-6 py-4 text-left text-sm font-medium", children: /* @__PURE__ */ p.jsx(fn, { className: "truncate hover:underline", to: `/performance/webvitals/${d.event_id}`, children: d.transaction }) }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (T = d.measurements) != null && T.lcp ? fr(d.measurements.lcp.value) : "-" }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (S = d.measurements) != null && S.fcp ? fr(d.measurements.fcp.value) : "-" }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (N = d.measurements) != null && N.fid ? fr(d.measurements.fid.value) : "-" }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (m = d.measurements) != null && m.cls ? d.measurements.cls.value : "-" }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (v = d.measurements) != null && v.ttfb ? fr(d.measurements.ttfb.value) : "-" }),
        /* @__PURE__ */ p.jsx("td", { className: "text-primary-200 w-[15%] whitespace-nowrap px-6 py-4 text-right text-sm font-medium", children: (M = d.measurements["score.total"]) != null && M.value ? Math.trunc(d.measurements["score.total"].value * 100) : "-" })
      ] }, d.event_id);
    }) })
  ] }) }) : /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "No Measurements found." });
}, Zw = -90, qw = 1;
function Qw({
  values: n,
  maxValues: a,
  size: s = 20,
  barWidth: o = 3,
  text: c,
  textCss: E,
  segmentColors: u,
  backgroundColors: R,
  progressEndcaps: d,
  onHoverActions: T,
  onUnhover: S,
  ...N
}) {
  const m = s / 2, v = s / 4, M = s / 2 - o / 2, w = 2 * Math.PI * M, y = x.useMemo(() => {
    const O = a.reduce((V, D) => V + D, 0);
    let g = Zw;
    return a.flatMap((V, D) => {
      const G = Math.min(Math.max(n[D], 0), V), P = n.length > 1 ? qw : 0, U = (1 - Math.max(V - P, 0) / O) * w, Y = (1 - Math.max(G - P, 0) / O) * w, X = g;
      g += 360 * V / O;
      const _ = M + o / 2, F = `${_}-${R[D]}-${u[D]}`;
      return [
        /* @__PURE__ */ p.jsx(
          "circle",
          {
            strokeDashoffset: U,
            r: M,
            cx: _,
            cy: _,
            onMouseOver: () => T == null ? void 0 : T[D](),
            onMouseLeave: () => S == null ? void 0 : S(),
            className: $e(R[D]),
            style: {
              fill: "none",
              strokeWidth: o,
              strokeDasharray: `${w} ${w}`,
              transform: `rotate(${X}deg)`,
              transformOrigin: "50% 50%",
              transition: "stroke 300ms"
            }
          },
          `ring-bg-${F}`
        ),
        /* @__PURE__ */ p.jsx(
          "circle",
          {
            strokeDashoffset: Y,
            strokeLinecap: d,
            r: M,
            cx: _,
            cy: _,
            onMouseOver: () => T == null ? void 0 : T[D](),
            onMouseLeave: () => S == null ? void 0 : S(),
            className: $e(u[D]),
            style: {
              fill: "none",
              strokeWidth: o,
              strokeDasharray: `${w} ${w}`,
              transform: `rotate(${X}deg)`,
              transformOrigin: "50% 50%",
              transition: "stroke 300ms, stroke-dashoffset 300ms"
            }
          },
          `ring-bar-${F}`
        )
      ];
    });
  }, [
    R,
    o,
    w,
    a,
    T,
    S,
    d,
    M,
    u,
    n
  ]);
  return /* @__PURE__ */ p.jsxs("svg", { className: "relative", role: "img", height: M * 2 + o, width: M * 2 + o, ...N, children: [
    y,
    /* @__PURE__ */ p.jsx(
      "foreignObject",
      {
        height: m,
        width: m,
        x: v,
        y: v,
        children: c !== void 0 ? /* @__PURE__ */ p.jsx(
          "div",
          {
            className: $e(
              "text-primary-100 flex h-full w-full items-center justify-center text-xl font-bold",
              E
            ),
            children: c
          }
        ) : null
      }
    )
  ] });
}
class AS extends Error {
}
function $w(n, { signal: a }) {
  return new Promise((s, o) => {
    a.aborted && o(new AS());
    const c = () => {
      o(new AS());
    }, E = new IntersectionObserver((u) => {
      for (const R of u) {
        const d = R.boundingClientRect;
        s(d), a.removeEventListener("abort", c);
      }
      E.disconnect();
    });
    a.addEventListener("abort", c), E.observe(n);
  });
}
function eG({
  elem: n,
  onPositionChange: a,
  onMouseEnter: s,
  onMouseMove: o,
  onMouseLeave: c,
  ...E
}) {
  const u = x.useRef(new AbortController()), R = x.useCallback(
    async (T) => {
      if (!n.current) {
        a(void 0);
        return;
      }
      try {
        const S = await $w(n.current, {
          signal: u.current.signal
        });
        a({
          height: S.height,
          left: Math.min(T.clientX - S.left, S.width),
          top: Math.min(T.clientY - S.top, S.height),
          width: S.width
        });
      } catch (S) {
        if (S instanceof AS)
          return;
      }
    },
    [a, u, n]
  ), d = x.useCallback(() => {
    u.current && (u.current.abort(), u.current = new AbortController()), a(void 0);
  }, [a, u]);
  return {
    ...E,
    onMouseEnter: (T) => {
      R(T), s == null || s(T);
    },
    onMouseMove: (T) => {
      var S;
      (S = n.current) != null && S.contains(T.target) && (R(T), o == null || o(T));
    },
    onMouseLeave: (T) => {
      d(), c == null || c(T);
    }
  };
}
function Wu({ webVital: n, coordinates: a, labelCoordinates: s = {} }) {
  var E, u;
  const o = ((E = s == null ? void 0 : s[n]) == null ? void 0 : E.x) ?? 0, c = ((u = s == null ? void 0 : s[n]) == null ? void 0 : u.y) ?? 0;
  return /* @__PURE__ */ p.jsx(
    "text",
    {
      className: "fill-primary-200 stroke-primary-200 uppercase",
      x: a.x + o,
      y: a.y + c,
      children: n
    }
  );
}
const tG = ({
  metricScore: n,
  metricWeights: a,
  totalScore: s,
  size: o = 200,
  barWidth: c = 25,
  left: E = 40,
  top: u = 25,
  labelWidthPadding: R = 28,
  labelHeightPadding: d = 14,
  radiusPadding: T = 4
}) => {
  const [S, N] = x.useState(null), [m, v] = x.useState({ x: 0, y: 0 }), M = x.useRef(null), w = eG({
    elem: M,
    onPositionChange: (_) => {
      if (_) {
        const { left: F, top: j } = _;
        v({ x: F, y: j });
      }
    }
  }), { lcpX: y, lcpY: O, fcpX: g, fcpY: V, fidX: D, fidY: G, clsX: P, clsY: U, ttfbX: Y, ttfbY: X } = Jw(
    o,
    E,
    u,
    c,
    a,
    R,
    d,
    T
  );
  return /* @__PURE__ */ p.jsxs("div", { ref: M, ...w, children: [
    S && /* @__PURE__ */ p.jsxs(
      "div",
      {
        className: $e(
          "bg-primary-900 border-primary-400 absolute flex w-40 items-center justify-between rounded-lg border p-3 shadow-lg"
        ),
        style: {
          transform: `translate3d(${m.x - 100}px, ${m.y - 74}px, 0px)`
        },
        children: [
          /* @__PURE__ */ p.jsx("span", { className: "text-primary-200", children: `${S.toUpperCase()} Score:` }),
          /* @__PURE__ */ p.jsx("span", { className: "text-primary-200 font-semibold", children: n[`${S}Score`] })
        ]
      }
    ),
    /* @__PURE__ */ p.jsxs("svg", { height: o + 3 * u, width: o + 3 * E, children: [
      /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
        a.lcp > 0 && /* @__PURE__ */ p.jsx(
          Wu,
          {
            webVital: "lcp",
            coordinates: {
              x: y,
              y: O
            }
          }
        ),
        a.fcp > 0 && /* @__PURE__ */ p.jsx(
          Wu,
          {
            webVital: "fcp",
            coordinates: {
              x: g,
              y: V
            }
          }
        ),
        a.fid > 0 && /* @__PURE__ */ p.jsx(
          Wu,
          {
            webVital: "fid",
            coordinates: {
              x: D,
              y: G
            }
          }
        ),
        a.cls > 0 && /* @__PURE__ */ p.jsx(
          Wu,
          {
            webVital: "cls",
            coordinates: {
              x: P,
              y: U
            }
          }
        ),
        a.ttfb > 0 && /* @__PURE__ */ p.jsx(
          Wu,
          {
            webVital: "ttfb",
            coordinates: {
              x: Y,
              y: X
            }
          }
        )
      ] }),
      /* @__PURE__ */ p.jsx(
        Qw,
        {
          values: [
            (n.lcpScore ?? 0) * a.lcp * 0.01,
            (n.fcpScore ?? 0) * a.fcp * 0.01,
            (n.fidScore ?? 0) * a.fid * 0.01,
            (n.clsScore ?? 0) * a.cls * 0.01,
            (n.ttfbScore ?? 0) * a.ttfb * 0.01
          ],
          maxValues: [a.lcp, a.fcp, a.fid, a.cls, a.ttfb],
          text: s,
          size: o,
          barWidth: c,
          segmentColors: [
            "stroke-primary-300",
            "stroke-primary-400",
            "stroke-primary-500",
            "stroke-primary-600",
            "stroke-primary-700"
          ],
          backgroundColors: [
            "stroke-gray-400",
            "stroke-gray-400",
            "stroke-gray-400",
            "stroke-gray-400",
            "stroke-gray-400"
          ],
          x: E,
          y: u,
          onHoverActions: [
            () => N("lcp"),
            () => N("fcp"),
            () => N("fid"),
            () => N("cls"),
            () => N("ttfb")
          ],
          onUnhover: () => N(null)
        }
      )
    ] })
  ] });
}, nG = () => {
  var o, c, E, u, R;
  const n = GS(), { page: a } = Zo(), s = [];
  if (n.filter((d) => d.event_id === a).map((d) => {
    const T = { ...d };
    Pv(T, yv), s.push(T);
  }), a && s.length) {
    const d = {
      fcpScore: Math.trunc(s[0].measurements["score.fcp"].value * 100),
      lcpScore: Math.trunc(s[0].measurements["score.lcp"].value * 100),
      fidScore: Math.trunc(s[0].measurements["score.fid"].value * 100),
      clsScore: Math.trunc(s[0].measurements["score.cls"].value * 100),
      ttfbScore: Math.trunc(s[0].measurements["score.ttfb"].value * 100)
    }, T = {
      fcp: Math.trunc(s[0].measurements["score.weight.fcp"].value * 100),
      lcp: Math.trunc(s[0].measurements["score.weight.lcp"].value * 100),
      fid: Math.trunc(s[0].measurements["score.weight.fid"].value * 100),
      cls: Math.trunc(s[0].measurements["score.weight.cls"].value * 100),
      ttfb: Math.trunc(s[0].measurements["score.weight.ttfb"].value * 100)
    }, S = Math.trunc(s[0].measurements["score.total"].value * 100), N = [
      {
        id: "fcpScore",
        description: "First Contentful Paint",
        label: "FCP",
        score: (o = s[0].measurements) != null && o.fcp ? fr(s[0].measurements.fcp.value) : "-"
      },
      {
        id: "lcpScore",
        description: "Largest Contentful Paint",
        label: "LCP",
        score: (c = s[0].measurements) != null && c.lcp ? fr(s[0].measurements.lcp.value) : "-"
      },
      {
        id: "fidScore",
        description: "First Input Delay",
        label: "FID",
        score: (E = s[0].measurements) != null && E.fid ? fr(s[0].measurements.fid.value) : "-"
      },
      {
        id: "clsScore",
        description: "Cumulative Layout Shift",
        label: "CLS",
        score: (u = s[0].measurements) != null && u.cls ? fr(s[0].measurements.cls.value) : "-"
      },
      {
        id: "ttfbScore",
        description: "Time to First Byte",
        label: "TTFB",
        score: (R = s[0].measurements) != null && R.ttfb ? fr(s[0].measurements.ttfb.value) : "-"
      }
    ];
    return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
      /* @__PURE__ */ p.jsx(
        Dv,
        {
          crumbs: [
            {
              id: "webVitals",
              label: "Web Vitals",
              link: !0,
              to: "/performance/webvitals"
            },
            {
              id: "performanceSummary",
              label: "Performance Summary",
              link: !1
            }
          ]
        }
      ),
      /* @__PURE__ */ p.jsxs("div", { className: "w-full px-6", children: [
        /* @__PURE__ */ p.jsx("div", { className: "flex w-full items-center justify-center p-6", children: /* @__PURE__ */ p.jsx(tG, { totalScore: S, metricWeights: T, metricScore: d }) }),
        /* @__PURE__ */ p.jsx("div", { className: "flex w-full flex-wrap justify-center gap-2", children: N.map((m) => /* @__PURE__ */ p.jsxs(
          "div",
          {
            className: "bg-primary-900 border-primary-400 flex w-80 flex-col items-center gap-4 rounded-lg border p-2 shadow-lg",
            children: [
              /* @__PURE__ */ p.jsx("span", { className: "text-primary-300 text-base font-semibold", children: m.label }),
              /* @__PURE__ */ p.jsx("span", { className: "text-primary-300 text-sm font-light", children: m.description }),
              /* @__PURE__ */ p.jsx("h2", { className: "text-primary-300 text-lg font-bold", children: m.score ?? "-" })
            ]
          },
          m.id
        )) })
      ] })
    ] });
  }
  return /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 px-6 py-4", children: "No measurement found." });
};
function rG() {
  const n = ET(), [a, s] = fT(), [o, c] = x.useState(""), [E, u] = x.useState(!n.experiments["sentry:focus-local-events"]), R = a.length - s.length, d = [
    {
      id: "queries",
      title: "Queries",
      active: o === "queries",
      onSelect: () => c("queries")
    },
    {
      id: "webvitals",
      title: "Web Vitals",
      active: o === "webvitals",
      onSelect: () => c("webvitals")
    },
    {
      id: "resources",
      title: "Resources",
      active: o === "resources",
      onSelect: () => c("resources")
    }
  ];
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    !E && R > 0 && /* @__PURE__ */ p.jsx(
      cT,
      {
        itemCount: R,
        onClick: () => {
          u(!0);
        }
      }
    ),
    /* @__PURE__ */ p.jsx(DS, { tabs: d, nested: !0 }),
    /* @__PURE__ */ p.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ p.jsxs(Ki, { children: [
        /* @__PURE__ */ p.jsx(jt, { path: "queries/:type", element: /* @__PURE__ */ p.jsx(Bw, { showAll: E }) }),
        /* @__PURE__ */ p.jsx(jt, { path: "resources", element: /* @__PURE__ */ p.jsx(kw, { showAll: E }) }),
        /* @__PURE__ */ p.jsx(jt, { path: "webvitals", element: /* @__PURE__ */ p.jsx(zw, { showAll: E }) }),
        /* @__PURE__ */ p.jsx(jt, { path: "webvitals/:page", element: /* @__PURE__ */ p.jsx(nG, {}) }),
        /* @__PURE__ */ p.jsx(jt, { path: "*", element: /* @__PURE__ */ p.jsx(Gw, { showAll: E }) })
      ] }),
      /* @__PURE__ */ p.jsx(ov, {})
    ] })
  ] });
}
function aG() {
  return /* @__PURE__ */ p.jsx(sE, { children: /* @__PURE__ */ p.jsx(Ki, { children: /* @__PURE__ */ p.jsx(jt, { path: "/*", element: /* @__PURE__ */ p.jsx(rG, {}) }) }) });
}
const iG = () => (x.useContext(Bs), Ut.getSdks());
function sG() {
  const n = iG();
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: n.length !== 0 ? /* @__PURE__ */ p.jsx(wS, { children: n.map((a) => /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-x-4 px-6 py-2", children: [
    /* @__PURE__ */ p.jsx(Vi, { className: "rounded-md", platform: oT(a.name) }),
    /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-col truncate font-mono text-sm", children: [
      /* @__PURE__ */ p.jsx("div", { children: a.name }),
      /* @__PURE__ */ p.jsx("div", { children: a.version }),
      /* @__PURE__ */ p.jsx(uT, { date: a.lastSeen })
    ] })
  ] }, `${a.name}-${a.version}`)) }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no SDKs that have reported yet. 🤔" }) });
}
function oG() {
  return /* @__PURE__ */ p.jsx(sE, { children: /* @__PURE__ */ p.jsx(Ki, { children: /* @__PURE__ */ p.jsx(jt, { path: "/", element: /* @__PURE__ */ p.jsx(sG, {}) }) }) });
}
const lG = () => (x.useContext(Bs), Ut.getTraces());
function uG(n) {
  return [...new Set((n.transactions || []).map((a) => {
    var s;
    return oT(((s = a.sdk) == null ? void 0 : s.name) || "unknown");
  }))];
}
function Uv({ trace: n }) {
  const a = uG(n);
  return a.length === 0 ? /* @__PURE__ */ p.jsx(Vi, { className: "rounded-md", platform: "unknown" }) : a.length === 1 ? /* @__PURE__ */ p.jsx(Vi, { className: "rounded-md", platform: a[0] }) : /* @__PURE__ */ p.jsx("div", { className: "bg-primary-900 flex h-[42px] w-[42px] flex-wrap items-center justify-center overflow-hidden rounded-md", children: a.slice(0, 4).map(
    (s, o) => o < 3 ? /* @__PURE__ */ p.jsx(Vi, { title: s, size: 21, platform: s }, s) : /* @__PURE__ */ p.jsx(
      "div",
      {
        title: (a.slice(3) || []).join(", "),
        className: "h-[21px] w-[21px] bg-black p-0.5 text-xs font-bold text-white",
        children: `+${a.length - 3}`
      },
      (a.slice(3) || []).join(", ")
    )
  ) });
}
function EG() {
  const n = lG(), a = oE(), s = ET(), [o, c] = x.useState(!s.experiments["sentry:focus-local-events"]), E = o ? n : n.filter((R) => a.isLocalToSession(R.trace_id) !== !1), u = n.length - E.length;
  return /* @__PURE__ */ p.jsx(p.Fragment, { children: n.length !== 0 ? /* @__PURE__ */ p.jsxs(wS, { children: [
    u > 0 && /* @__PURE__ */ p.jsx(
      cT,
      {
        itemCount: u,
        onClick: () => {
          c(!0);
        }
      }
    ),
    E.map((R) => {
      const d = Jo(R.start_timestamp, R.timestamp);
      return /* @__PURE__ */ p.jsxs(
        fn,
        {
          className: "hover:bg-primary-900 flex cursor-pointer items-center gap-x-4 px-6 py-2",
          to: R.trace_id,
          children: [
            /* @__PURE__ */ p.jsx(Uv, { trace: R }),
            /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex w-48 flex-col truncate font-mono text-sm", children: [
              /* @__PURE__ */ p.jsxs("div", { className: "flex items-center gap-x-2", children: [
                /* @__PURE__ */ p.jsx("div", { children: R.trace_id.substring(0, 8) }),
                a.isLocalToSession(R.trace_id) ? /* @__PURE__ */ p.jsx(PS, { title: "This trace is part of your local session.", children: "Local" }) : null
              ] }),
              /* @__PURE__ */ p.jsx(uT, { date: R.start_timestamp })
            ] }),
            /* @__PURE__ */ p.jsxs("div", { className: "flex flex-col truncate font-mono", children: [
              /* @__PURE__ */ p.jsx("div", { children: R.rootTransactionName }),
              /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex space-x-2 text-sm", children: [
                /* @__PURE__ */ p.jsx(
                  "div",
                  {
                    className: $e(
                      R.status === "ok" ? "text-green-400" : R.status ? "text-red-400" : ""
                    ),
                    children: R.status || ""
                  }
                ),
                /* @__PURE__ */ p.jsx("div", { children: "—" }),
                /* @__PURE__ */ p.jsxs("div", { children: [
                  d,
                  " ms"
                ] }),
                /* @__PURE__ */ p.jsx("div", { children: "—" }),
                /* @__PURE__ */ p.jsxs("div", { children: [
                  R.spans.length.toLocaleString(),
                  " spans, ",
                  R.transactions.length.toLocaleString(),
                  " txns"
                ] })
              ] })
            ] })
          ]
        },
        R.trace_id
      );
    })
  ] }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 p-6", children: "Looks like there's no traces recorded matching this query. 🤔" }) });
}
xs.extend(Lv);
function FS({ date: n, ...a }) {
  return n ? /* @__PURE__ */ p.jsx("time", { dateTime: n instanceof Date ? n.toISOString() : `${n}`, ...a, children: xs(n).format("LL LTS") }) : null;
}
let Ee;
(function(n) {
  n.QUOTED_IDENTIFIER = "QUOTED_IDENTIFIER", n.IDENTIFIER = "IDENTIFIER", n.STRING = "STRING", n.VARIABLE = "VARIABLE", n.RESERVED_KEYWORD = "RESERVED_KEYWORD", n.RESERVED_FUNCTION_NAME = "RESERVED_FUNCTION_NAME", n.RESERVED_PHRASE = "RESERVED_PHRASE", n.RESERVED_SET_OPERATION = "RESERVED_SET_OPERATION", n.RESERVED_CLAUSE = "RESERVED_CLAUSE", n.RESERVED_SELECT = "RESERVED_SELECT", n.RESERVED_JOIN = "RESERVED_JOIN", n.ARRAY_IDENTIFIER = "ARRAY_IDENTIFIER", n.ARRAY_KEYWORD = "ARRAY_KEYWORD", n.CASE = "CASE", n.END = "END", n.WHEN = "WHEN", n.ELSE = "ELSE", n.THEN = "THEN", n.LIMIT = "LIMIT", n.BETWEEN = "BETWEEN", n.AND = "AND", n.OR = "OR", n.XOR = "XOR", n.OPERATOR = "OPERATOR", n.COMMA = "COMMA", n.ASTERISK = "ASTERISK", n.DOT = "DOT", n.OPEN_PAREN = "OPEN_PAREN", n.CLOSE_PAREN = "CLOSE_PAREN", n.LINE_COMMENT = "LINE_COMMENT", n.BLOCK_COMMENT = "BLOCK_COMMENT", n.NUMBER = "NUMBER", n.NAMED_PARAMETER = "NAMED_PARAMETER", n.QUOTED_PARAMETER = "QUOTED_PARAMETER", n.NUMBERED_PARAMETER = "NUMBERED_PARAMETER", n.POSITIONAL_PARAMETER = "POSITIONAL_PARAMETER", n.CUSTOM_PARAMETER = "CUSTOM_PARAMETER", n.DELIMITER = "DELIMITER", n.EOF = "EOF";
})(Ee || (Ee = {}));
const xv = (n) => ({
  type: Ee.EOF,
  raw: "«EOF»",
  text: "«EOF»",
  start: n
}), ws = xv(1 / 0), ku = (n) => (a) => a.type === n.type && a.text === n.text, ki = {
  ARRAY: ku({
    text: "ARRAY",
    type: Ee.RESERVED_KEYWORD
  }),
  BY: ku({
    text: "BY",
    type: Ee.RESERVED_KEYWORD
  }),
  SET: ku({
    text: "SET",
    type: Ee.RESERVED_CLAUSE
  }),
  STRUCT: ku({
    text: "STRUCT",
    type: Ee.RESERVED_KEYWORD
  }),
  WINDOW: ku({
    text: "WINDOW",
    type: Ee.RESERVED_CLAUSE
  })
}, wv = (n) => n === Ee.RESERVED_KEYWORD || n === Ee.RESERVED_FUNCTION_NAME || n === Ee.RESERVED_PHRASE || n === Ee.RESERVED_CLAUSE || n === Ee.RESERVED_SELECT || n === Ee.RESERVED_SET_OPERATION || n === Ee.RESERVED_JOIN || n === Ee.ARRAY_KEYWORD || n === Ee.CASE || n === Ee.END || n === Ee.WHEN || n === Ee.ELSE || n === Ee.THEN || n === Ee.LIMIT || n === Ee.BETWEEN || n === Ee.AND || n === Ee.OR || n === Ee.XOR, cG = (n) => n === Ee.AND || n === Ee.OR || n === Ee.XOR, fe = (n) => n.flatMap(fG), fG = (n) => Gv(TG(n)).map((a) => a.trim()), vC = /[^[\]{}]+/y, LC = /\{.*?\}/y, yC = /\[.*?\]/y, TG = (n) => {
  let a = 0;
  const s = [];
  for (; a < n.length; ) {
    vC.lastIndex = a;
    const o = vC.exec(n);
    o && (s.push([o[0].trim()]), a += o[0].length), yC.lastIndex = a;
    const c = yC.exec(n);
    if (c) {
      const u = c[0].slice(1, -1).split("|").map((R) => R.trim());
      s.push(["", ...u]), a += c[0].length;
    }
    LC.lastIndex = a;
    const E = LC.exec(n);
    if (E) {
      const u = E[0].slice(1, -1).split("|").map((R) => R.trim());
      s.push(u), a += E[0].length;
    }
    if (!o && !c && !E)
      throw new Error(`Unbalanced parenthesis in: ${n}`);
  }
  return s;
}, Gv = ([n, ...a]) => n === void 0 ? [""] : Gv(a).flatMap((s) => n.map((o) => o.trim() + " " + s.trim())), dG = (n) => [...new Set(n)], zu = (n) => n[n.length - 1], Hv = (n) => n.sort((a, s) => s.length - a.length || a.localeCompare(s)), Bv = (n) => n.reduce((a, s) => Math.max(a, s.length), 0), Fv = (n) => n.replace(/\s+/gu, " "), ut = (n) => dG(Object.values(n).flat()), Hp = (n) => /\n/.test(n), AG = ut({
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/lexical#reserved_keywords
  keywords: ["ALL", "AND", "ANY", "ARRAY", "AS", "ASC", "ASSERT_ROWS_MODIFIED", "AT", "BETWEEN", "BY", "CASE", "CAST", "COLLATE", "CONTAINS", "CREATE", "CROSS", "CUBE", "CURRENT", "DEFAULT", "DEFINE", "DESC", "DISTINCT", "ELSE", "END", "ENUM", "ESCAPE", "EXCEPT", "EXCLUDE", "EXISTS", "EXTRACT", "FALSE", "FETCH", "FOLLOWING", "FOR", "FROM", "FULL", "GROUP", "GROUPING", "GROUPS", "HASH", "HAVING", "IF", "IGNORE", "IN", "INNER", "INTERSECT", "INTERVAL", "INTO", "IS", "JOIN", "LATERAL", "LEFT", "LIKE", "LIMIT", "LOOKUP", "MERGE", "NATURAL", "NEW", "NO", "NOT", "NULL", "NULLS", "OF", "ON", "OR", "ORDER", "OUTER", "OVER", "PARTITION", "PRECEDING", "PROTO", "RANGE", "RECURSIVE", "RESPECT", "RIGHT", "ROLLUP", "ROWS", "SELECT", "SET", "SOME", "STRUCT", "TABLE", "TABLESAMPLE", "THEN", "TO", "TREAT", "TRUE", "UNBOUNDED", "UNION", "UNNEST", "USING", "WHEN", "WHERE", "WINDOW", "WITH", "WITHIN"],
  datatypes: [
    "ARRAY",
    // parametric, ARRAY<T>
    "BOOL",
    "BYTES",
    // parameterised, BYTES(Length)
    "DATE",
    "DATETIME",
    "GEOGRAPHY",
    "INTERVAL",
    "INT64",
    "INT",
    "SMALLINT",
    "INTEGER",
    "BIGINT",
    "TINYINT",
    "BYTEINT",
    "NUMERIC",
    // parameterised, NUMERIC(Precision[, Scale])
    "DECIMAL",
    // parameterised, DECIMAL(Precision[, Scale])
    "BIGNUMERIC",
    // parameterised, BIGNUMERIC(Precision[, Scale])
    "BIGDECIMAL",
    // parameterised, BIGDECIMAL(Precision[, Scale])
    "FLOAT64",
    "STRING",
    // parameterised, STRING(Length)
    "STRUCT",
    // parametric, STRUCT<T>
    "TIME",
    "TIMEZONE"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conversion_functions#formatting_syntax
  stringFormat: ["HEX", "BASEX", "BASE64M", "ASCII", "UTF-8", "UTF8"],
  misc: ["SAFE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  ddl: [
    "LIKE",
    // CREATE TABLE LIKE
    "COPY",
    // CREATE TABLE COPY
    "CLONE",
    // CREATE TABLE CLONE
    "IN",
    "OUT",
    "INOUT",
    "RETURNS",
    "LANGUAGE",
    "CASCADE",
    "RESTRICT",
    "DETERMINISTIC"
  ]
}), RG = ut({
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
  aead: ["KEYS.NEW_KEYSET", "KEYS.ADD_KEY_FROM_RAW_BYTES", "AEAD.DECRYPT_BYTES", "AEAD.DECRYPT_STRING", "AEAD.ENCRYPT", "KEYS.KEYSET_CHAIN", "KEYS.KEYSET_FROM_JSON", "KEYS.KEYSET_TO_JSON", "KEYS.ROTATE_KEYSET", "KEYS.KEYSET_LENGTH"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_analytic_functions
  aggregateAnalytic: ["ANY_VALUE", "ARRAY_AGG", "AVG", "CORR", "COUNT", "COUNTIF", "COVAR_POP", "COVAR_SAMP", "MAX", "MIN", "ST_CLUSTERDBSCAN", "STDDEV_POP", "STDDEV_SAMP", "STRING_AGG", "SUM", "VAR_POP", "VAR_SAMP"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
  aggregate: ["ANY_VALUE", "ARRAY_AGG", "ARRAY_CONCAT_AGG", "AVG", "BIT_AND", "BIT_OR", "BIT_XOR", "COUNT", "COUNTIF", "LOGICAL_AND", "LOGICAL_OR", "MAX", "MIN", "STRING_AGG", "SUM"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/approximate_aggregate_functions
  approximateAggregate: ["APPROX_COUNT_DISTINCT", "APPROX_QUANTILES", "APPROX_TOP_COUNT", "APPROX_TOP_SUM"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/array_functions
  array: [
    // 'ARRAY',
    "ARRAY_CONCAT",
    "ARRAY_LENGTH",
    "ARRAY_TO_STRING",
    "GENERATE_ARRAY",
    "GENERATE_DATE_ARRAY",
    "GENERATE_TIMESTAMP_ARRAY",
    "ARRAY_REVERSE",
    "OFFSET",
    "SAFE_OFFSET",
    "ORDINAL",
    "SAFE_ORDINAL"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/bit_functions
  bitwise: ["BIT_COUNT"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conversion_functions
  conversion: [
    // 'CASE',
    "PARSE_BIGNUMERIC",
    "PARSE_NUMERIC",
    "SAFE_CAST"
  ],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
  date: ["CURRENT_DATE", "EXTRACT", "DATE", "DATE_ADD", "DATE_SUB", "DATE_DIFF", "DATE_TRUNC", "DATE_FROM_UNIX_DATE", "FORMAT_DATE", "LAST_DAY", "PARSE_DATE", "UNIX_DATE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/datetime_functions
  datetime: ["CURRENT_DATETIME", "DATETIME", "EXTRACT", "DATETIME_ADD", "DATETIME_SUB", "DATETIME_DIFF", "DATETIME_TRUNC", "FORMAT_DATETIME", "LAST_DAY", "PARSE_DATETIME"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/debugging_functions
  debugging: ["ERROR"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/federated_query_functions
  federatedQuery: ["EXTERNAL_QUERY"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
  geography: ["S2_CELLIDFROMPOINT", "S2_COVERINGCELLIDS", "ST_ANGLE", "ST_AREA", "ST_ASBINARY", "ST_ASGEOJSON", "ST_ASTEXT", "ST_AZIMUTH", "ST_BOUNDARY", "ST_BOUNDINGBOX", "ST_BUFFER", "ST_BUFFERWITHTOLERANCE", "ST_CENTROID", "ST_CENTROID_AGG", "ST_CLOSESTPOINT", "ST_CLUSTERDBSCAN", "ST_CONTAINS", "ST_CONVEXHULL", "ST_COVEREDBY", "ST_COVERS", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_DUMP", "ST_DWITHIN", "ST_ENDPOINT", "ST_EQUALS", "ST_EXTENT", "ST_EXTERIORRING", "ST_GEOGFROM", "ST_GEOGFROMGEOJSON", "ST_GEOGFROMTEXT", "ST_GEOGFROMWKB", "ST_GEOGPOINT", "ST_GEOGPOINTFROMGEOHASH", "ST_GEOHASH", "ST_GEOMETRYTYPE", "ST_INTERIORRINGS", "ST_INTERSECTION", "ST_INTERSECTS", "ST_INTERSECTSBOX", "ST_ISCOLLECTION", "ST_ISEMPTY", "ST_LENGTH", "ST_MAKELINE", "ST_MAKEPOLYGON", "ST_MAKEPOLYGONORIENTED", "ST_MAXDISTANCE", "ST_NPOINTS", "ST_NUMGEOMETRIES", "ST_NUMPOINTS", "ST_PERIMETER", "ST_POINTN", "ST_SIMPLIFY", "ST_SNAPTOGRID", "ST_STARTPOINT", "ST_TOUCHES", "ST_UNION", "ST_UNION_AGG", "ST_WITHIN", "ST_X", "ST_Y"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/hash_functions
  hash: ["FARM_FINGERPRINT", "MD5", "SHA1", "SHA256", "SHA512"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/hll_functions
  hll: ["HLL_COUNT.INIT", "HLL_COUNT.MERGE", "HLL_COUNT.MERGE_PARTIAL", "HLL_COUNT.EXTRACT"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/interval_functions
  interval: ["MAKE_INTERVAL", "EXTRACT", "JUSTIFY_DAYS", "JUSTIFY_HOURS", "JUSTIFY_INTERVAL"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
  json: ["JSON_EXTRACT", "JSON_QUERY", "JSON_EXTRACT_SCALAR", "JSON_VALUE", "JSON_EXTRACT_ARRAY", "JSON_QUERY_ARRAY", "JSON_EXTRACT_STRING_ARRAY", "JSON_VALUE_ARRAY", "TO_JSON_STRING"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
  math: ["ABS", "SIGN", "IS_INF", "IS_NAN", "IEEE_DIVIDE", "RAND", "SQRT", "POW", "POWER", "EXP", "LN", "LOG", "LOG10", "GREATEST", "LEAST", "DIV", "SAFE_DIVIDE", "SAFE_MULTIPLY", "SAFE_NEGATE", "SAFE_ADD", "SAFE_SUBTRACT", "MOD", "ROUND", "TRUNC", "CEIL", "CEILING", "FLOOR", "COS", "COSH", "ACOS", "ACOSH", "SIN", "SINH", "ASIN", "ASINH", "TAN", "TANH", "ATAN", "ATANH", "ATAN2", "RANGE_BUCKET"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/navigation_functions
  navigation: ["FIRST_VALUE", "LAST_VALUE", "NTH_VALUE", "LEAD", "LAG", "PERCENTILE_CONT", "PERCENTILE_DISC"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/net_functions
  net: ["NET.IP_FROM_STRING", "NET.SAFE_IP_FROM_STRING", "NET.IP_TO_STRING", "NET.IP_NET_MASK", "NET.IP_TRUNC", "NET.IPV4_FROM_INT64", "NET.IPV4_TO_INT64", "NET.HOST", "NET.PUBLIC_SUFFIX", "NET.REG_DOMAIN"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/numbering_functions
  numbering: ["RANK", "DENSE_RANK", "PERCENT_RANK", "CUME_DIST", "NTILE", "ROW_NUMBER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/security_functions
  security: ["SESSION_USER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/statistical_aggregate_functions
  statisticalAggregate: ["CORR", "COVAR_POP", "COVAR_SAMP", "STDDEV_POP", "STDDEV_SAMP", "STDDEV", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
  string: ["ASCII", "BYTE_LENGTH", "CHAR_LENGTH", "CHARACTER_LENGTH", "CHR", "CODE_POINTS_TO_BYTES", "CODE_POINTS_TO_STRING", "CONCAT", "CONTAINS_SUBSTR", "ENDS_WITH", "FORMAT", "FROM_BASE32", "FROM_BASE64", "FROM_HEX", "INITCAP", "INSTR", "LEFT", "LENGTH", "LPAD", "LOWER", "LTRIM", "NORMALIZE", "NORMALIZE_AND_CASEFOLD", "OCTET_LENGTH", "REGEXP_CONTAINS", "REGEXP_EXTRACT", "REGEXP_EXTRACT_ALL", "REGEXP_INSTR", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPLACE", "REPEAT", "REVERSE", "RIGHT", "RPAD", "RTRIM", "SAFE_CONVERT_BYTES_TO_STRING", "SOUNDEX", "SPLIT", "STARTS_WITH", "STRPOS", "SUBSTR", "SUBSTRING", "TO_BASE32", "TO_BASE64", "TO_CODE_POINTS", "TO_HEX", "TRANSLATE", "TRIM", "UNICODE", "UPPER"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
  time: ["CURRENT_TIME", "TIME", "EXTRACT", "TIME_ADD", "TIME_SUB", "TIME_DIFF", "TIME_TRUNC", "FORMAT_TIME", "PARSE_TIME"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
  timestamp: ["CURRENT_TIMESTAMP", "EXTRACT", "STRING", "TIMESTAMP", "TIMESTAMP_ADD", "TIMESTAMP_SUB", "TIMESTAMP_DIFF", "TIMESTAMP_TRUNC", "FORMAT_TIMESTAMP", "PARSE_TIMESTAMP", "TIMESTAMP_SECONDS", "TIMESTAMP_MILLIS", "TIMESTAMP_MICROS", "UNIX_SECONDS", "UNIX_MILLIS", "UNIX_MICROS"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/uuid_functions
  uuid: ["GENERATE_UUID"],
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/conditional_expressions
  conditional: ["COALESCE", "IF", "IFNULL", "NULLIF"],
  // https://cloud.google.com/bigquery/docs/reference/legacy-sql
  legacyAggregate: ["AVG", "BIT_AND", "BIT_OR", "BIT_XOR", "CORR", "COUNT", "COVAR_POP", "COVAR_SAMP", "EXACT_COUNT_DISTINCT", "FIRST", "GROUP_CONCAT", "GROUP_CONCAT_UNQUOTED", "LAST", "MAX", "MIN", "NEST", "NTH", "QUANTILES", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "SUM", "TOP", "UNIQUE", "VARIANCE", "VAR_POP", "VAR_SAMP"],
  legacyBitwise: ["BIT_COUNT"],
  legacyCasting: ["BOOLEAN", "BYTES", "CAST", "FLOAT", "HEX_STRING", "INTEGER", "STRING"],
  legacyComparison: [
    // expr 'IN',
    "COALESCE",
    "GREATEST",
    "IFNULL",
    "IS_INF",
    "IS_NAN",
    "IS_EXPLICITLY_DEFINED",
    "LEAST",
    "NVL"
  ],
  legacyDatetime: ["CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATE", "DATE_ADD", "DATEDIFF", "DAY", "DAYOFWEEK", "DAYOFYEAR", "FORMAT_UTC_USEC", "HOUR", "MINUTE", "MONTH", "MSEC_TO_TIMESTAMP", "NOW", "PARSE_UTC_USEC", "QUARTER", "SEC_TO_TIMESTAMP", "SECOND", "STRFTIME_UTC_USEC", "TIME", "TIMESTAMP", "TIMESTAMP_TO_MSEC", "TIMESTAMP_TO_SEC", "TIMESTAMP_TO_USEC", "USEC_TO_TIMESTAMP", "UTC_USEC_TO_DAY", "UTC_USEC_TO_HOUR", "UTC_USEC_TO_MONTH", "UTC_USEC_TO_WEEK", "UTC_USEC_TO_YEAR", "WEEK", "YEAR"],
  legacyIp: ["FORMAT_IP", "PARSE_IP", "FORMAT_PACKED_IP", "PARSE_PACKED_IP"],
  legacyJson: ["JSON_EXTRACT", "JSON_EXTRACT_SCALAR"],
  legacyMath: ["ABS", "ACOS", "ACOSH", "ASIN", "ASINH", "ATAN", "ATANH", "ATAN2", "CEIL", "COS", "COSH", "DEGREES", "EXP", "FLOOR", "LN", "LOG", "LOG2", "LOG10", "PI", "POW", "RADIANS", "RAND", "ROUND", "SIN", "SINH", "SQRT", "TAN", "TANH"],
  legacyRegex: ["REGEXP_MATCH", "REGEXP_EXTRACT", "REGEXP_REPLACE"],
  legacyString: [
    "CONCAT",
    // expr CONTAINS 'str'
    "INSTR",
    "LEFT",
    "LENGTH",
    "LOWER",
    "LPAD",
    "LTRIM",
    "REPLACE",
    "RIGHT",
    "RPAD",
    "RTRIM",
    "SPLIT",
    "SUBSTR",
    "UPPER"
  ],
  legacyTableWildcard: ["TABLE_DATE_RANGE", "TABLE_DATE_RANGE_STRICT", "TABLE_QUERY"],
  legacyUrl: ["HOST", "DOMAIN", "TLD"],
  legacyWindow: ["AVG", "COUNT", "MAX", "MIN", "STDDEV", "SUM", "CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "RANK", "RATIO_TO_REPORT", "ROW_NUMBER"],
  legacyMisc: ["CURRENT_USER", "EVERY", "FROM_BASE64", "HASH", "FARM_FINGERPRINT", "IF", "POSITION", "SHA1", "SOME", "TO_BASE64"],
  other: ["BQ.JOBS.CANCEL", "BQ.REFRESH_MATERIALIZED_VIEW"],
  ddl: ["OPTIONS"],
  pivot: ["PIVOT", "UNPIVOT"],
  // Data types with parameters like VARCHAR(100)
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/data-types#parameterized_data_types
  dataTypes: ["BYTES", "NUMERIC", "DECIMAL", "BIGNUMERIC", "BIGDECIMAL", "STRING"]
}), pG = fe(["SELECT [ALL | DISTINCT] [AS STRUCT | AS VALUE]"]), SG = fe([
  // Queries: https://cloud.google.com/bigquery/docs/reference/standard-sql/query-syntax
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "QUALIFY",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "OMIT RECORD IF",
  // legacy
  // Data modification: https://cloud.google.com/bigquery/docs/reference/standard-sql/dml-syntax
  // - insert:
  "INSERT [INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [BY SOURCE | BY TARGET] [THEN]",
  "UPDATE SET",
  // Data definition, https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  "CREATE [OR REPLACE] [MATERIALIZED] VIEW [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMP|TEMPORARY|SNAPSHOT|EXTERNAL] TABLE [IF NOT EXISTS]",
  "CLUSTER BY",
  "FOR SYSTEM_TIME AS OF",
  // CREATE SNAPSHOT TABLE
  "WITH CONNECTION",
  "WITH PARTITION COLUMNS",
  "REMOTE WITH CONNECTION"
]), gC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP [SNAPSHOT | EXTERNAL] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "ADD COLUMN [IF NOT EXISTS]",
  "DROP COLUMN [IF EXISTS]",
  "RENAME TO",
  "ALTER COLUMN [IF EXISTS]",
  "SET DEFAULT COLLATE",
  // for alter column
  "SET OPTIONS",
  // for alter column
  "DROP NOT NULL",
  // for alter column
  "SET DATA TYPE",
  // for alter column
  // - alter schema
  "ALTER SCHEMA [IF EXISTS]",
  // - alter view
  "ALTER [MATERIALIZED] VIEW [IF EXISTS]",
  // - alter bi_capacity
  "ALTER BI_CAPACITY",
  // - truncate:
  "TRUNCATE TABLE",
  // - create schema
  "CREATE SCHEMA [IF NOT EXISTS]",
  "DEFAULT COLLATE",
  // stored procedures
  "CREATE [OR REPLACE] [TEMP|TEMPORARY|TABLE] FUNCTION [IF NOT EXISTS]",
  "CREATE [OR REPLACE] PROCEDURE [IF NOT EXISTS]",
  // row access policy
  "CREATE [OR REPLACE] ROW ACCESS POLICY [IF NOT EXISTS]",
  "GRANT TO",
  "FILTER USING",
  // capacity
  "CREATE CAPACITY",
  "AS JSON",
  // reservation
  "CREATE RESERVATION",
  // assignment
  "CREATE ASSIGNMENT",
  // search index
  "CREATE SEARCH INDEX [IF NOT EXISTS]",
  // drop
  "DROP SCHEMA [IF EXISTS]",
  "DROP [MATERIALIZED] VIEW [IF EXISTS]",
  "DROP [TABLE] FUNCTION [IF EXISTS]",
  "DROP PROCEDURE [IF EXISTS]",
  "DROP ROW ACCESS POLICY",
  "DROP ALL ROW ACCESS POLICIES",
  "DROP CAPACITY [IF EXISTS]",
  "DROP RESERVATION [IF EXISTS]",
  "DROP ASSIGNMENT [IF EXISTS]",
  "DROP SEARCH INDEX [IF EXISTS]",
  "DROP [IF EXISTS]",
  // DCL, https://cloud.google.com/bigquery/docs/reference/standard-sql/data-control-language
  "GRANT",
  "REVOKE",
  // Script, https://cloud.google.com/bigquery/docs/reference/standard-sql/scripting
  "DECLARE",
  "EXECUTE IMMEDIATE",
  "LOOP",
  "END LOOP",
  "REPEAT",
  "END REPEAT",
  "WHILE",
  "END WHILE",
  "BREAK",
  "LEAVE",
  "CONTINUE",
  "ITERATE",
  "FOR",
  "END FOR",
  "BEGIN",
  "BEGIN TRANSACTION",
  "COMMIT TRANSACTION",
  "ROLLBACK TRANSACTION",
  "RAISE",
  "RETURN",
  "CALL",
  // Debug, https://cloud.google.com/bigquery/docs/reference/standard-sql/debugging-statements
  "ASSERT",
  // Other, https://cloud.google.com/bigquery/docs/reference/standard-sql/other-statements
  "EXPORT DATA"
]), hG = fe(["UNION {ALL | DISTINCT}", "EXCEPT DISTINCT", "INTERSECT DISTINCT"]), NG = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN"]), OG = fe([
  // https://cloud.google.com/bigquery/docs/reference/standard-sql/query-syntax#tablesample_operator
  "TABLESAMPLE SYSTEM",
  // From DDL: https://cloud.google.com/bigquery/docs/reference/standard-sql/data-definition-language
  "ANY TYPE",
  "ALL COLUMNS",
  "NOT DETERMINISTIC",
  // inside window definitions
  "{ROWS | RANGE} BETWEEN",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), IG = {
  tokenizerOptions: {
    reservedSelect: pG,
    reservedClauses: [...SG, ...gC],
    reservedSetOperations: hG,
    reservedJoins: NG,
    reservedPhrases: OG,
    reservedKeywords: AG,
    reservedFunctionNames: RG,
    extraParens: ["[]"],
    stringTypes: [
      // The triple-quoted strings are listed first, so they get matched first.
      // Otherwise the first two quotes of """ will get matched as an empty "" string.
      {
        quote: '""".."""',
        prefixes: ["R", "B", "RB", "BR"]
      },
      {
        quote: "'''..'''",
        prefixes: ["R", "B", "RB", "BR"]
      },
      '""-bs',
      "''-bs",
      {
        quote: '""-raw',
        prefixes: ["R", "B", "RB", "BR"],
        requirePrefix: !0
      },
      {
        quote: "''-raw",
        prefixes: ["R", "B", "RB", "BR"],
        requirePrefix: !0
      }
    ],
    identTypes: ["``"],
    identChars: {
      dashes: !0
    },
    paramTypes: {
      positional: !0,
      named: ["@"],
      quoted: ["@"]
    },
    variableTypes: [{
      regex: String.raw`@@\w+`
    }],
    lineCommentTypes: ["--", "#"],
    operators: ["&", "|", "^", "~", ">>", "<<", "||", "=>"],
    postProcess: _G
  },
  formatOptions: {
    onelineClauses: gC
  }
};
function _G(n) {
  return CG(mG(n));
}
function CG(n) {
  let a = ws;
  return n.map((s) => s.text === "OFFSET" && a.text === "[" ? (a = s, {
    ...s,
    type: Ee.RESERVED_FUNCTION_NAME
  }) : (a = s, s));
}
function mG(n) {
  const a = [];
  for (let o = 0; o < n.length; o++) {
    var s;
    const c = n[o];
    if ((ki.ARRAY(c) || ki.STRUCT(c)) && ((s = n[o + 1]) === null || s === void 0 ? void 0 : s.text) === "<") {
      const E = vG(n, o + 1), u = n.slice(o, E + 1);
      a.push({
        type: Ee.IDENTIFIER,
        raw: u.map(DC("raw")).join(""),
        text: u.map(DC("text")).join(""),
        start: c.start
      }), o = E;
    } else
      a.push(c);
  }
  return a;
}
const DC = (n) => (a) => a.type === Ee.IDENTIFIER || a.type === Ee.COMMA ? a[n] + " " : a[n];
function vG(n, a) {
  let s = 0;
  for (let o = a; o < n.length; o++) {
    const c = n[o];
    if (c.text === "<" ? s++ : c.text === ">" ? s-- : c.text === ">>" && (s -= 2), s === 0)
      return o;
  }
  return n.length - 1;
}
const LG = ut({
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-aggregate
  aggregate: ["ARRAY_AGG", "AVG", "CORR", "CORRELATION", "COUNT", "COUNT_BIG", "COVAR_POP", "COVARIANCE", "COVAR", "COVAR_SAMP", "COVARIANCE_SAMP", "CUME_DIST", "GROUPING", "LISTAGG", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_ICPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "STDDEV_POP", "STDDEV", "STDDEV_SAMP", "SUM", "VAR_POP", "VARIANCE", "VAR", "VAR_SAMP", "VARIANCE_SAMP", "XMLAGG"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-scalar
  scalar: ["ABS", "ABSVAL", "ACOS", "ADD_DAYS", "ADD_MONTHS", "ARRAY_DELETE", "ARRAY_FIRST", "ARRAY_LAST", "ARRAY_NEXT", "ARRAY_PRIOR", "ARRAY_TRIM", "ASCII", "ASCII_CHR", "ASCII_STR", "ASCIISTR", "ASIN", "ATAN", "ATANH", "ATAN2", "BIGINT", "BINARY", "BITAND", "BITANDNOT", "BITOR", "BITXOR", "BITNOT", "BLOB", "BTRIM", "CARDINALITY", "CCSID_ENCODING", "CEILING", "CEIL", "CHAR", "CHAR9", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHR", "CLOB", "COALESCE", "COLLATION_KEY", "COMPARE_DECFLOAT", "CONCAT", "CONTAINS", "COS", "COSH", "DATE", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFWEEK_ISO", "DAYOFYEAR", "DAYS", "DAYS_BETWEEN", "DBCLOB", "DECFLOAT", "DECFLOAT_FORMAT", "DECFLOAT_SORTKEY", "DECIMAL", "DEC", "DECODE", "DECRYPT_BINARY", "DECRYPT_BIT", "DECRYPT_CHAR", "DECRYPT_DB", "DECRYPT_DATAKEY_BIGINT", "DECRYPT_DATAKEY_BIT", "DECRYPT_DATAKEY_CLOB", "DECRYPT_DATAKEY_DBCLOB", "DECRYPT_DATAKEY_DECIMAL", "DECRYPT_DATAKEY_INTEGER", "DECRYPT_DATAKEY_VARCHAR", "DECRYPT_DATAKEY_VARGRAPHIC", "DEGREES", "DIFFERENCE", "DIGITS", "DOUBLE_PRECISION", "DOUBLE", "DSN_XMLVALIDATE", "EBCDIC_CHR", "EBCDIC_STR", "ENCRYPT_DATAKEY", "ENCRYPT_TDES", "EXP", "EXTRACT", "FLOAT", "FLOOR", "GENERATE_UNIQUE", "GENERATE_UNIQUE_BINARY", "GETHINT", "GETVARIABLE", "GRAPHIC", "GREATEST", "HASH", "HASH_CRC32", "HASH_MD5", "HASH_SHA1", "HASH_SHA256", "HEX", "HOUR", "IDENTITY_VAL_LOCAL", "IFNULL", "INSERT", "INSTR", "INTEGER", "INT", "JULIAN_DAY", "LAST_DAY", "LCASE", "LEAST", "LEFT", "LENGTH", "LN", "LOCATE", "LOCATE_IN_STRING", "LOG10", "LOWER", "LPAD", "LTRIM", "MAX", "MAX_CARDINALITY", "MICROSECOND", "MIDNIGHT_SECONDS", "MIN", "MINUTE", "MOD", "MONTH", "MONTHS_BETWEEN", "MQREAD", "MQREADCLOB", "MQRECEIVE", "MQRECEIVECLOB", "MQSEND", "MULTIPLY_ALT", "NEXT_DAY", "NEXT_MONTH", "NORMALIZE_DECFLOAT", "NORMALIZE_STRING", "NULLIF", "NVL", "OVERLAY", "PACK", "POSITION", "POSSTR", "POWER", "POW", "QUANTIZE", "QUARTER", "RADIANS", "RAISE_ERROR", "RANDOM", "RAND", "REAL", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_LIKE", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPEAT", "REPLACE", "RID", "RIGHT", "ROUND", "ROUND_TIMESTAMP", "ROWID", "RPAD", "RTRIM", "SCORE", "SECOND", "SIGN", "SIN", "SINH", "SMALLINT", "SOUNDEX", "SOAPHTTPC", "SOAPHTTPV", "SOAPHTTPNC", "SOAPHTTPNV", "SPACE", "SQRT", "STRIP", "STRLEFT", "STRPOS", "STRRIGHT", "SUBSTR", "SUBSTRING", "TAN", "TANH", "TIME", "TIMESTAMP", "TIMESTAMPADD", "TIMESTAMPDIFF", "TIMESTAMP_FORMAT", "TIMESTAMP_ISO", "TIMESTAMP_TZ", "TO_CHAR", "TO_CLOB", "TO_DATE", "TO_NUMBER", "TOTALORDER", "TO_TIMESTAMP", "TRANSLATE", "TRIM", "TRIM_ARRAY", "TRUNCATE", "TRUNC", "TRUNC_TIMESTAMP", "UCASE", "UNICODE", "UNICODE_STR", "UNISTR", "UPPER", "VALUE", "VARBINARY", "VARCHAR", "VARCHAR9", "VARCHAR_BIT_FORMAT", "VARCHAR_FORMAT", "VARGRAPHIC", "VERIFY_GROUP_FOR_USER", "VERIFY_ROLE_FOR_USER", "VERIFY_TRUSTED_CONTEXT_ROLE_FOR_USER", "WEEK", "WEEK_ISO", "WRAP", "XMLATTRIBUTES", "XMLCOMMENT", "XMLCONCAT", "XMLDOCUMENT", "XMLELEMENT", "XMLFOREST", "XMLMODIFY", "XMLNAMESPACES", "XMLPARSE", "XMLPI", "XMLQUERY", "XMLSERIALIZE", "XMLTEXT", "XMLXSROBJECTID", "XSLTRANSFORM", "YEAR"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-table
  table: ["ADMIN_TASK_LIST", "ADMIN_TASK_OUTPUT", "ADMIN_TASK_STATUS", "BLOCKING_THREADS", "MQREADALL", "MQREADALLCLOB", "MQRECEIVEALL", "MQRECEIVEALLCLOB", "XMLTABLE"],
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=functions-row
  row: ["UNPACK"],
  // https://www.ibm.com/docs/en/db2-for-zos/12?topic=expressions-olap-specification
  olap: ["CUME_DIST", "PERCENT_RANK", "RANK", "DENSE_RANK", "NTILE", "LAG", "LEAD", "ROW_NUMBER", "FIRST_VALUE", "LAST_VALUE", "NTH_VALUE", "RATIO_TO_REPORT"],
  // Type casting
  cast: ["CAST"]
}), yG = ut({
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=words-reserved#db2z_reservedwords__newresword
  standard: ["ALL", "ALLOCATE", "ALLOW", "ALTERAND", "ANY", "AS", "ARRAY", "ARRAY_EXISTS", "ASENSITIVE", "ASSOCIATE", "ASUTIME", "AT", "AUDIT", "AUX", "AUXILIARY", "BEFORE", "BEGIN", "BETWEEN", "BUFFERPOOL", "BY", "CAPTURE", "CASCADED", "CAST", "CCSID", "CHARACTER", "CHECK", "CLONE", "CLUSTER", "COLLECTION", "COLLID", "COLUMN", "CONDITION", "CONNECTION", "CONSTRAINT", "CONTENT", "CONTINUE", "CREATE", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_LC_CTYPE", "CURRENT_PATH", "CURRENT_SCHEMA", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRVAL", "CURSOR", "DATA", "DATABASE", "DBINFO", "DECLARE", "DEFAULT", "DESCRIPTOR", "DETERMINISTIC", "DISABLE", "DISALLOW", "DISTINCT", "DO", "DOCUMENT", "DSSIZE", "DYNAMIC", "EDITPROC", "ELSE", "ELSEIF", "ENCODING", "ENCRYPTION", "ENDING", "END-EXEC", "ERASE", "ESCAPE", "EXCEPTION", "EXISTS", "EXIT", "EXTERNAL", "FENCED", "FIELDPROC", "FINAL", "FIRST", "FOR", "FREE", "FULL", "FUNCTION", "GENERATED", "GET", "GLOBAL", "GOTO", "GROUP", "HANDLER", "HOLD", "HOURS", "IF", "IMMEDIATE", "IN", "INCLUSIVE", "INDEX", "INHERIT", "INNER", "INOUT", "INSENSITIVE", "INTO", "IS", "ISOBID", "ITERATE", "JAR", "KEEP", "KEY", "LANGUAGE", "LAST", "LC_CTYPE", "LEAVE", "LIKE", "LOCAL", "LOCALE", "LOCATOR", "LOCATORS", "LOCK", "LOCKMAX", "LOCKSIZE", "LONG", "LOOP", "MAINTAINED", "MATERIALIZED", "MICROSECONDS", "MINUTEMINUTES", "MODIFIES", "MONTHS", "NEXT", "NEXTVAL", "NO", "NONE", "NOT", "NULL", "NULLS", "NUMPARTS", "OBID", "OF", "OLD", "ON", "OPTIMIZATION", "OPTIMIZE", "ORDER", "ORGANIZATION", "OUT", "OUTER", "PACKAGE", "PARAMETER", "PART", "PADDED", "PARTITION", "PARTITIONED", "PARTITIONING", "PATH", "PIECESIZE", "PERIOD", "PLAN", "PRECISION", "PREVVAL", "PRIOR", "PRIQTY", "PRIVILEGES", "PROCEDURE", "PROGRAM", "PSID", "PUBLIC", "QUERY", "QUERYNO", "READS", "REFERENCES", "RESIGNAL", "RESTRICT", "RESULT", "RESULT_SET_LOCATOR", "RETURN", "RETURNS", "ROLE", "ROLLUP", "ROUND_CEILING", "ROUND_DOWN", "ROUND_FLOOR", "ROUND_HALF_DOWN", "ROUND_HALF_EVEN", "ROUND_HALF_UP", "ROUND_UP", "ROW", "ROWSET", "SCHEMA", "SCRATCHPAD", "SECONDS", "SECQTY", "SECURITY", "SEQUENCE", "SENSITIVE", "SESSION_USER", "SIMPLE", "SOME", "SOURCE", "SPECIFIC", "STANDARD", "STATIC", "STATEMENT", "STAY", "STOGROUP", "STORES", "STYLE", "SUMMARY", "SYNONYM", "SYSDATE", "SYSTEM", "SYSTIMESTAMP", "TABLE", "TABLESPACE", "THEN", "TO", "TRIGGER", "TYPE", "UNDO", "UNIQUE", "UNTIL", "USER", "USING", "VALIDPROC", "VARIABLE", "VARIANT", "VCAT", "VERSIONING", "VIEW", "VOLATILE", "VOLUMES", "WHILE", "WLM", "XMLEXISTS", "XMLCAST", "YEARS", "ZONE"]
}), gG = fe(["SELECT [ALL | DISTINCT]"]), DG = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY [INPUT SEQUENCE]",
  "FETCH FIRST",
  // Data modification
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  "INSERT",
  // Data definition
  "CREATE [OR REPLACE] VIEW",
  "CREATE [GLOBAL TEMPORARY] TABLE"
]), bC = fe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  "WITH {RR | RS | CS | UR}",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [HIERARCHY]",
  // alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [COLUMN]",
  "ALTER [COLUMN]",
  "SET DATA TYPE",
  // for alter column
  "SET NOT NULL",
  // for alter column
  "DROP {IDENTITY | EXPRESSION | DEFAULT | NOT NULL}",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // other
  "SET [CURRENT] SCHEMA",
  "AFTER",
  "GO",
  // https://www.ibm.com/docs/en/db2-for-zos/11?topic=statements-list-supported
  "ALLOCATE CURSOR",
  "ALTER DATABASE",
  "ALTER FUNCTION",
  "ALTER INDEX",
  "ALTER MASK",
  "ALTER PERMISSION",
  "ALTER PROCEDURE",
  "ALTER SEQUENCE",
  "ALTER STOGROUP",
  "ALTER TABLESPACE",
  "ALTER TRIGGER",
  "ALTER TRUSTED CONTEXT",
  "ALTER VIEW",
  "ASSOCIATE LOCATORS",
  "BEGIN DECLARE SECTION",
  "CALL",
  "CLOSE",
  "COMMENT",
  "COMMIT",
  "CONNECT",
  "CREATE ALIAS",
  "CREATE AUXILIARY TABLE",
  "CREATE DATABASE",
  "CREATE FUNCTION",
  "CREATE GLOBAL TEMPORARY TABLE",
  "CREATE INDEX",
  "CREATE LOB TABLESPACE",
  "CREATE MASK",
  "CREATE PERMISSION",
  "CREATE PROCEDURE",
  "CREATE ROLE",
  "CREATE SEQUENCE",
  "CREATE STOGROUP",
  "CREATE SYNONYM",
  "CREATE TABLESPACE",
  "CREATE TRIGGER",
  "CREATE TRUSTED CONTEXT",
  "CREATE TYPE",
  "CREATE VARIABLE",
  "DECLARE CURSOR",
  "DECLARE GLOBAL TEMPORARY TABLE",
  "DECLARE STATEMENT",
  "DECLARE TABLE",
  "DECLARE VARIABLE",
  "DESCRIBE CURSOR",
  "DESCRIBE INPUT",
  "DESCRIBE OUTPUT",
  "DESCRIBE PROCEDURE",
  "DESCRIBE TABLE",
  "DROP",
  "END DECLARE SECTION",
  "EXCHANGE",
  "EXECUTE",
  "EXECUTE IMMEDIATE",
  "EXPLAIN",
  "FETCH",
  "FREE LOCATOR",
  "GET DIAGNOSTICS",
  "GRANT",
  "HOLD LOCATOR",
  "INCLUDE",
  "LABEL",
  "LOCK TABLE",
  "OPEN",
  "PREPARE",
  "REFRESH",
  "RELEASE",
  "RELEASE SAVEPOINT",
  "RENAME",
  "REVOKE",
  "ROLLBACK",
  "SAVEPOINT",
  "SELECT INTO",
  "SET CONNECTION",
  "SET CURRENT ACCELERATOR",
  "SET CURRENT APPLICATION COMPATIBILITY",
  "SET CURRENT APPLICATION ENCODING SCHEME",
  "SET CURRENT DEBUG MODE",
  "SET CURRENT DECFLOAT ROUNDING MODE",
  "SET CURRENT DEGREE",
  "SET CURRENT EXPLAIN MODE",
  "SET CURRENT GET_ACCEL_ARCHIVE",
  "SET CURRENT LOCALE LC_CTYPE",
  "SET CURRENT MAINTAINED TABLE TYPES FOR OPTIMIZATION",
  "SET CURRENT OPTIMIZATION HINT",
  "SET CURRENT PACKAGE PATH",
  "SET CURRENT PACKAGESET",
  "SET CURRENT PRECISION",
  "SET CURRENT QUERY ACCELERATION",
  "SET CURRENT QUERY ACCELERATION WAITFORDATA",
  "SET CURRENT REFRESH AGE",
  "SET CURRENT ROUTINE VERSION",
  "SET CURRENT RULES",
  "SET CURRENT SQLID",
  "SET CURRENT TEMPORAL BUSINESS_TIME",
  "SET CURRENT TEMPORAL SYSTEM_TIME",
  "SET ENCRYPTION PASSWORD",
  "SET PATH",
  "SET SESSION TIME ZONE",
  "SIGNAL",
  "VALUES INTO",
  "WHENEVER"
]), bG = fe(["UNION [ALL]", "EXCEPT [ALL]", "INTERSECT [ALL]"]), MG = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN"]), PG = fe(["ON DELETE", "ON UPDATE", "SET NULL", "{ROWS | RANGE} BETWEEN"]), UG = {
  tokenizerOptions: {
    reservedSelect: gG,
    reservedClauses: [...DG, ...bC],
    reservedSetOperations: bG,
    reservedJoins: MG,
    reservedPhrases: PG,
    reservedKeywords: yG,
    reservedFunctionNames: LG,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["G", "N", "U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X", "BX", "GX", "UX"],
      requirePrefix: !0
    }],
    identTypes: ['""-qq'],
    identChars: {
      first: "@#$"
    },
    paramTypes: {
      positional: !0,
      named: [":"]
    },
    paramChars: {
      first: "@#$",
      rest: "@#$"
    },
    operators: ["**", "¬=", "¬>", "¬<", "!>", "!<", "||"]
  },
  formatOptions: {
    onelineClauses: bC
  }
}, xG = ut({
  // https://cwiki.apache.org/confluence/display/Hive/LanguageManual+UDF
  math: [
    "ABS",
    "ACOS",
    "ASIN",
    "ATAN",
    "BIN",
    "BROUND",
    "CBRT",
    "CEIL",
    "CEILING",
    "CONV",
    "COS",
    "DEGREES",
    // 'E',
    "EXP",
    "FACTORIAL",
    "FLOOR",
    "GREATEST",
    "HEX",
    "LEAST",
    "LN",
    "LOG",
    "LOG10",
    "LOG2",
    "NEGATIVE",
    "PI",
    "PMOD",
    "POSITIVE",
    "POW",
    "POWER",
    "RADIANS",
    "RAND",
    "ROUND",
    "SHIFTLEFT",
    "SHIFTRIGHT",
    "SHIFTRIGHTUNSIGNED",
    "SIGN",
    "SIN",
    "SQRT",
    "TAN",
    "UNHEX",
    "WIDTH_BUCKET"
  ],
  array: ["ARRAY_CONTAINS", "MAP_KEYS", "MAP_VALUES", "SIZE", "SORT_ARRAY"],
  conversion: ["BINARY", "CAST"],
  date: ["ADD_MONTHS", "DATE", "DATE_ADD", "DATE_FORMAT", "DATE_SUB", "DATEDIFF", "DAY", "DAYNAME", "DAYOFMONTH", "DAYOFYEAR", "EXTRACT", "FROM_UNIXTIME", "FROM_UTC_TIMESTAMP", "HOUR", "LAST_DAY", "MINUTE", "MONTH", "MONTHS_BETWEEN", "NEXT_DAY", "QUARTER", "SECOND", "TIMESTAMP", "TO_DATE", "TO_UTC_TIMESTAMP", "TRUNC", "UNIX_TIMESTAMP", "WEEKOFYEAR", "YEAR"],
  conditional: ["ASSERT_TRUE", "COALESCE", "IF", "ISNOTNULL", "ISNULL", "NULLIF", "NVL"],
  string: ["ASCII", "BASE64", "CHARACTER_LENGTH", "CHR", "CONCAT", "CONCAT_WS", "CONTEXT_NGRAMS", "DECODE", "ELT", "ENCODE", "FIELD", "FIND_IN_SET", "FORMAT_NUMBER", "GET_JSON_OBJECT", "IN_FILE", "INITCAP", "INSTR", "LCASE", "LENGTH", "LEVENSHTEIN", "LOCATE", "LOWER", "LPAD", "LTRIM", "NGRAMS", "OCTET_LENGTH", "PARSE_URL", "PRINTF", "QUOTE", "REGEXP_EXTRACT", "REGEXP_REPLACE", "REPEAT", "REVERSE", "RPAD", "RTRIM", "SENTENCES", "SOUNDEX", "SPACE", "SPLIT", "STR_TO_MAP", "SUBSTR", "SUBSTRING", "TRANSLATE", "TRIM", "UCASE", "UNBASE64", "UPPER"],
  masking: ["MASK", "MASK_FIRST_N", "MASK_HASH", "MASK_LAST_N", "MASK_SHOW_FIRST_N", "MASK_SHOW_LAST_N"],
  misc: ["AES_DECRYPT", "AES_ENCRYPT", "CRC32", "CURRENT_DATABASE", "CURRENT_USER", "HASH", "JAVA_METHOD", "LOGGED_IN_USER", "MD5", "REFLECT", "SHA", "SHA1", "SHA2", "SURROGATE_KEY", "VERSION"],
  aggregate: ["AVG", "COLLECT_LIST", "COLLECT_SET", "CORR", "COUNT", "COVAR_POP", "COVAR_SAMP", "HISTOGRAM_NUMERIC", "MAX", "MIN", "NTILE", "PERCENTILE", "PERCENTILE_APPROX", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "STDDEV_POP", "STDDEV_SAMP", "SUM", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  table: ["EXPLODE", "INLINE", "JSON_TUPLE", "PARSE_URL_TUPLE", "POSEXPLODE", "STACK"],
  // https://cwiki.apache.org/confluence/display/Hive/LanguageManual+WindowingAndAnalytics
  window: ["LEAD", "LAG", "FIRST_VALUE", "LAST_VALUE", "RANK", "ROW_NUMBER", "DENSE_RANK", "CUME_DIST", "PERCENT_RANK", "NTILE"],
  // Parameterized data types
  // https://cwiki.apache.org/confluence/pages/viewpage.action?pageId=82706456
  // Though in reality Hive only supports parameters for DECIMAL(),
  // it doesn't hurt to allow others in here as well.
  dataTypes: ["DECIMAL", "NUMERIC", "VARCHAR", "CHAR"]
}), wG = ut({
  // https://cwiki.apache.org/confluence/display/hive/languagemanual+ddl
  // Non-reserved keywords have proscribed meanings in. HiveQL, but can still be used as table or column names
  nonReserved: ["ADD", "ADMIN", "AFTER", "ANALYZE", "ARCHIVE", "ASC", "BEFORE", "BUCKET", "BUCKETS", "CASCADE", "CHANGE", "CLUSTER", "CLUSTERED", "CLUSTERSTATUS", "COLLECTION", "COLUMNS", "COMMENT", "COMPACT", "COMPACTIONS", "COMPUTE", "CONCATENATE", "CONTINUE", "DATA", "DATABASES", "DATETIME", "DAY", "DBPROPERTIES", "DEFERRED", "DEFINED", "DELIMITED", "DEPENDENCY", "DESC", "DIRECTORIES", "DIRECTORY", "DISABLE", "DISTRIBUTE", "ELEM_TYPE", "ENABLE", "ESCAPED", "EXCLUSIVE", "EXPLAIN", "EXPORT", "FIELDS", "FILE", "FILEFORMAT", "FIRST", "FORMAT", "FORMATTED", "FUNCTIONS", "HOLD_DDLTIME", "HOUR", "IDXPROPERTIES", "IGNORE", "INDEX", "INDEXES", "INPATH", "INPUTDRIVER", "INPUTFORMAT", "ITEMS", "JAR", "KEYS", "KEY_TYPE", "LIMIT", "LINES", "LOAD", "LOCATION", "LOCK", "LOCKS", "LOGICAL", "LONG", "MAPJOIN", "MATERIALIZED", "METADATA", "MINUS", "MINUTE", "MONTH", "MSCK", "NOSCAN", "NO_DROP", "OFFLINE", "OPTION", "OUTPUTDRIVER", "OUTPUTFORMAT", "OVERWRITE", "OWNER", "PARTITIONED", "PARTITIONS", "PLUS", "PRETTY", "PRINCIPALS", "PROTECTION", "PURGE", "READ", "READONLY", "REBUILD", "RECORDREADER", "RECORDWRITER", "RELOAD", "RENAME", "REPAIR", "REPLACE", "REPLICATION", "RESTRICT", "REWRITE", "ROLE", "ROLES", "SCHEMA", "SCHEMAS", "SECOND", "SEMI", "SERDE", "SERDEPROPERTIES", "SERVER", "SETS", "SHARED", "SHOW", "SHOW_DATABASE", "SKEWED", "SORT", "SORTED", "SSL", "STATISTICS", "STORED", "STREAMTABLE", "STRING", "STRUCT", "TABLES", "TBLPROPERTIES", "TEMPORARY", "TERMINATED", "TINYINT", "TOUCH", "TRANSACTIONS", "UNARCHIVE", "UNDO", "UNIONTYPE", "UNLOCK", "UNSET", "UNSIGNED", "URI", "USE", "UTC", "UTCTIMESTAMP", "VALUE_TYPE", "VIEW", "WHILE", "YEAR", "AUTOCOMMIT", "ISOLATION", "LEVEL", "OFFSET", "SNAPSHOT", "TRANSACTION", "WORK", "WRITE", "ABORT", "KEY", "LAST", "NORELY", "NOVALIDATE", "NULLS", "RELY", "VALIDATE", "DETAIL", "DOW", "EXPRESSION", "OPERATOR", "QUARTER", "SUMMARY", "VECTORIZATION", "WEEK", "YEARS", "MONTHS", "WEEKS", "DAYS", "HOURS", "MINUTES", "SECONDS", "TIMESTAMPTZ", "ZONE"],
  reserved: ["ALL", "ALTER", "AND", "ARRAY", "AS", "AUTHORIZATION", "BETWEEN", "BIGINT", "BINARY", "BOOLEAN", "BOTH", "BY", "CASE", "CAST", "CHAR", "COLUMN", "CONF", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_DATE", "CURRENT_TIMESTAMP", "CURSOR", "DATABASE", "DATE", "DECIMAL", "DELETE", "DESCRIBE", "DISTINCT", "DOUBLE", "DROP", "ELSE", "END", "EXCHANGE", "EXISTS", "EXTENDED", "EXTERNAL", "FALSE", "FETCH", "FLOAT", "FOLLOWING", "FOR", "FROM", "FULL", "FUNCTION", "GRANT", "GROUP", "GROUPING", "HAVING", "IF", "IMPORT", "IN", "INNER", "INSERT", "INT", "INTERSECT", "INTERVAL", "INTO", "IS", "JOIN", "LATERAL", "LEFT", "LESS", "LIKE", "LOCAL", "MACRO", "MAP", "MORE", "NONE", "NOT", "NULL", "OF", "ON", "OR", "ORDER", "OUT", "OUTER", "OVER", "PARTIALSCAN", "PARTITION", "PERCENT", "PRECEDING", "PRESERVE", "PROCEDURE", "RANGE", "READS", "REDUCE", "REVOKE", "RIGHT", "ROLLUP", "ROW", "ROWS", "SELECT", "SET", "SMALLINT", "TABLE", "TABLESAMPLE", "THEN", "TIMESTAMP", "TO", "TRANSFORM", "TRIGGER", "TRUE", "TRUNCATE", "UNBOUNDED", "UNION", "UNIQUEJOIN", "UPDATE", "USER", "USING", "UTC_TMESTAMP", "VALUES", "VARCHAR", "WHEN", "WHERE", "WINDOW", "WITH", "COMMIT", "ONLY", "REGEXP", "RLIKE", "ROLLBACK", "START", "CACHE", "CONSTRAINT", "FOREIGN", "PRIMARY", "REFERENCES", "DAYOFWEEK", "EXTRACT", "FLOOR", "INTEGER", "PRECISION", "VIEWS", "TIME", "NUMERIC", "SYNC"],
  fileTypes: ["TEXTFILE", "SEQUENCEFILE", "ORC", "CSV", "TSV", "PARQUET", "AVRO", "RCFILE", "JSONFILE", "INPUTFORMAT", "OUTPUTFORMAT"]
}), GG = fe(["SELECT [ALL | DISTINCT]"]), HG = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "SORT BY",
  "CLUSTER BY",
  "DISTRIBUTE BY",
  "LIMIT",
  // Data manipulation
  // - insert:
  //   Hive does not actually support plain INSERT INTO, only INSERT INTO TABLE
  //   but it's a nuisance to not support it, as all other dialects do.
  "INSERT INTO [TABLE]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  "INSERT [VALUES]",
  // - insert overwrite directory:
  //   https://cwiki.apache.org/confluence/display/Hive/LanguageManual+DML#LanguageManualDML-Writingdataintothefilesystemfromqueries
  "INSERT OVERWRITE [LOCAL] DIRECTORY",
  // - load:
  //   https://cwiki.apache.org/confluence/display/Hive/LanguageManual+DML#LanguageManualDML-Loadingfilesintotables
  "LOAD DATA [LOCAL] INPATH",
  "[OVERWRITE] INTO TABLE",
  // Data definition
  "CREATE [MATERIALIZED] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY] [EXTERNAL] TABLE [IF NOT EXISTS]"
]), MC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "RENAME TO",
  // - truncate:
  "TRUNCATE [TABLE]",
  // other
  "ALTER",
  "CREATE",
  "USE",
  "DESCRIBE",
  "DROP",
  "FETCH",
  "SHOW",
  "STORED AS",
  "STORED BY",
  "ROW FORMAT"
]), BG = fe(["UNION [ALL | DISTINCT]"]), FG = fe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  // non-standard joins
  "LEFT SEMI JOIN"
]), YG = fe(["{ROWS | RANGE} BETWEEN"]), VG = {
  tokenizerOptions: {
    reservedSelect: GG,
    reservedClauses: [...HG, ...MC],
    reservedSetOperations: BG,
    reservedJoins: FG,
    reservedPhrases: YG,
    reservedKeywords: wG,
    reservedFunctionNames: xG,
    extraParens: ["[]"],
    stringTypes: ['""-bs', "''-bs"],
    identTypes: ["``"],
    variableTypes: [{
      quote: "{}",
      prefixes: ["$"],
      requirePrefix: !0
    }],
    operators: ["%", "~", "^", "|", "&", "<=>", "==", "!", "||"]
  },
  formatOptions: {
    onelineClauses: MC
  }
}, WG = ut({
  // https://mariadb.com/kb/en/information-schema-keywords-table/
  all: [
    "ACCESSIBLE",
    "ACCOUNT",
    "ACTION",
    "ADD",
    "ADMIN",
    "AFTER",
    "AGAINST",
    "AGGREGATE",
    "ALL",
    "ALGORITHM",
    "ALTER",
    "ALWAYS",
    "ANALYZE",
    "AND",
    "ANY",
    "AS",
    "ASC",
    "ASCII",
    "ASENSITIVE",
    "AT",
    "ATOMIC",
    "AUTHORS",
    "AUTO_INCREMENT",
    "AUTOEXTEND_SIZE",
    "AUTO",
    "AVG",
    "AVG_ROW_LENGTH",
    "BACKUP",
    "BEFORE",
    "BEGIN",
    "BETWEEN",
    "BIGINT",
    "BINARY",
    "BINLOG",
    "BIT",
    "BLOB",
    "BLOCK",
    "BODY",
    "BOOL",
    "BOOLEAN",
    "BOTH",
    "BTREE",
    "BY",
    "BYTE",
    "CACHE",
    "CALL",
    "CASCADE",
    "CASCADED",
    "CASE",
    "CATALOG_NAME",
    "CHAIN",
    "CHANGE",
    "CHANGED",
    "CHAR",
    "CHARACTER",
    "CHARSET",
    "CHECK",
    "CHECKPOINT",
    "CHECKSUM",
    "CIPHER",
    "CLASS_ORIGIN",
    "CLIENT",
    "CLOB",
    "CLOSE",
    "COALESCE",
    "CODE",
    "COLLATE",
    "COLLATION",
    "COLUMN",
    "COLUMN_NAME",
    "COLUMNS",
    "COLUMN_ADD",
    "COLUMN_CHECK",
    "COLUMN_CREATE",
    "COLUMN_DELETE",
    "COLUMN_GET",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPACT",
    "COMPLETION",
    "COMPRESSED",
    "CONCURRENT",
    "CONDITION",
    "CONNECTION",
    "CONSISTENT",
    "CONSTRAINT",
    "CONSTRAINT_CATALOG",
    "CONSTRAINT_NAME",
    "CONSTRAINT_SCHEMA",
    "CONTAINS",
    "CONTEXT",
    "CONTINUE",
    "CONTRIBUTORS",
    "CONVERT",
    "CPU",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_DATE",
    "CURRENT_POS",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURSOR",
    "CURSOR_NAME",
    "CYCLE",
    "DATA",
    "DATABASE",
    "DATABASES",
    "DATAFILE",
    "DATE",
    "DATETIME",
    "DAY",
    "DAY_HOUR",
    "DAY_MICROSECOND",
    "DAY_MINUTE",
    "DAY_SECOND",
    "DEALLOCATE",
    "DEC",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DEFINER",
    "DELAYED",
    "DELAY_KEY_WRITE",
    "DELETE",
    "DELETE_DOMAIN_ID",
    "DESC",
    "DESCRIBE",
    "DES_KEY_FILE",
    "DETERMINISTIC",
    "DIAGNOSTICS",
    "DIRECTORY",
    "DISABLE",
    "DISCARD",
    "DISK",
    "DISTINCT",
    "DISTINCTROW",
    "DIV",
    "DO",
    "DOUBLE",
    "DO_DOMAIN_IDS",
    "DROP",
    "DUAL",
    "DUMPFILE",
    "DUPLICATE",
    "DYNAMIC",
    "EACH",
    "ELSE",
    "ELSEIF",
    "ELSIF",
    "EMPTY",
    "ENABLE",
    "ENCLOSED",
    "END",
    "ENDS",
    "ENGINE",
    "ENGINES",
    "ENUM",
    "ERROR",
    "ERRORS",
    "ESCAPE",
    "ESCAPED",
    "EVENT",
    "EVENTS",
    "EVERY",
    "EXAMINED",
    "EXCEPT",
    "EXCHANGE",
    "EXCLUDE",
    "EXECUTE",
    "EXCEPTION",
    "EXISTS",
    "EXIT",
    "EXPANSION",
    "EXPIRE",
    "EXPORT",
    "EXPLAIN",
    "EXTENDED",
    "EXTENT_SIZE",
    "FALSE",
    "FAST",
    "FAULTS",
    "FEDERATED",
    "FETCH",
    "FIELDS",
    "FILE",
    "FIRST",
    "FIXED",
    "FLOAT",
    "FLOAT4",
    "FLOAT8",
    "FLUSH",
    "FOLLOWING",
    "FOLLOWS",
    "FOR",
    "FORCE",
    "FOREIGN",
    "FORMAT",
    "FOUND",
    "FROM",
    "FULL",
    "FULLTEXT",
    "FUNCTION",
    "GENERAL",
    "GENERATED",
    "GET_FORMAT",
    "GET",
    "GLOBAL",
    "GOTO",
    "GRANT",
    "GRANTS",
    "GROUP",
    "HANDLER",
    "HARD",
    "HASH",
    "HAVING",
    "HELP",
    "HIGH_PRIORITY",
    "HISTORY",
    "HOST",
    "HOSTS",
    "HOUR",
    "HOUR_MICROSECOND",
    "HOUR_MINUTE",
    "HOUR_SECOND",
    // 'ID', // conflicts with common column name
    "IDENTIFIED",
    "IF",
    "IGNORE",
    "IGNORED",
    "IGNORE_DOMAIN_IDS",
    "IGNORE_SERVER_IDS",
    "IMMEDIATE",
    "IMPORT",
    "INTERSECT",
    "IN",
    "INCREMENT",
    "INDEX",
    "INDEXES",
    "INFILE",
    "INITIAL_SIZE",
    "INNER",
    "INOUT",
    "INSENSITIVE",
    "INSERT",
    "INSERT_METHOD",
    "INSTALL",
    "INT",
    "INT1",
    "INT2",
    "INT3",
    "INT4",
    "INT8",
    "INTEGER",
    "INTERVAL",
    "INVISIBLE",
    "INTO",
    "IO",
    "IO_THREAD",
    "IPC",
    "IS",
    "ISOLATION",
    "ISOPEN",
    "ISSUER",
    "ITERATE",
    "INVOKER",
    "JOIN",
    "JSON",
    "JSON_TABLE",
    "KEY",
    "KEYS",
    "KEY_BLOCK_SIZE",
    "KILL",
    "LANGUAGE",
    "LAST",
    "LAST_VALUE",
    "LASTVAL",
    "LEADING",
    "LEAVE",
    "LEAVES",
    "LEFT",
    "LESS",
    "LEVEL",
    "LIKE",
    "LIMIT",
    "LINEAR",
    "LINES",
    "LIST",
    "LOAD",
    "LOCAL",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCK",
    "LOCKED",
    "LOCKS",
    "LOGFILE",
    "LOGS",
    "LONG",
    "LONGBLOB",
    "LONGTEXT",
    "LOOP",
    "LOW_PRIORITY",
    "MASTER",
    "MASTER_CONNECT_RETRY",
    "MASTER_DELAY",
    "MASTER_GTID_POS",
    "MASTER_HOST",
    "MASTER_LOG_FILE",
    "MASTER_LOG_POS",
    "MASTER_PASSWORD",
    "MASTER_PORT",
    "MASTER_SERVER_ID",
    "MASTER_SSL",
    "MASTER_SSL_CA",
    "MASTER_SSL_CAPATH",
    "MASTER_SSL_CERT",
    "MASTER_SSL_CIPHER",
    "MASTER_SSL_CRL",
    "MASTER_SSL_CRLPATH",
    "MASTER_SSL_KEY",
    "MASTER_SSL_VERIFY_SERVER_CERT",
    "MASTER_USER",
    "MASTER_USE_GTID",
    "MASTER_HEARTBEAT_PERIOD",
    "MATCH",
    "MAX_CONNECTIONS_PER_HOUR",
    "MAX_QUERIES_PER_HOUR",
    "MAX_ROWS",
    "MAX_SIZE",
    "MAX_STATEMENT_TIME",
    "MAX_UPDATES_PER_HOUR",
    "MAX_USER_CONNECTIONS",
    "MAXVALUE",
    "MEDIUM",
    "MEDIUMBLOB",
    "MEDIUMINT",
    "MEDIUMTEXT",
    "MEMORY",
    "MERGE",
    "MESSAGE_TEXT",
    "MICROSECOND",
    "MIDDLEINT",
    "MIGRATE",
    "MINUS",
    "MINUTE",
    "MINUTE_MICROSECOND",
    "MINUTE_SECOND",
    "MINVALUE",
    "MIN_ROWS",
    "MOD",
    "MODE",
    "MODIFIES",
    "MODIFY",
    "MONITOR",
    "MONTH",
    "MUTEX",
    "MYSQL",
    "MYSQL_ERRNO",
    "NAME",
    "NAMES",
    "NATIONAL",
    "NATURAL",
    "NCHAR",
    "NESTED",
    "NEVER",
    "NEW",
    "NEXT",
    "NEXTVAL",
    "NO",
    "NOMAXVALUE",
    "NOMINVALUE",
    "NOCACHE",
    "NOCYCLE",
    "NO_WAIT",
    "NOWAIT",
    "NODEGROUP",
    "NONE",
    "NOT",
    "NOTFOUND",
    "NO_WRITE_TO_BINLOG",
    "NULL",
    "NUMBER",
    "NUMERIC",
    "NVARCHAR",
    "OF",
    "OFFSET",
    "OLD_PASSWORD",
    "ON",
    "ONE",
    "ONLINE",
    "ONLY",
    "OPEN",
    "OPTIMIZE",
    "OPTIONS",
    "OPTION",
    "OPTIONALLY",
    "OR",
    "ORDER",
    "ORDINALITY",
    "OTHERS",
    "OUT",
    "OUTER",
    "OUTFILE",
    "OVER",
    "OVERLAPS",
    "OWNER",
    "PACKAGE",
    "PACK_KEYS",
    "PAGE",
    "PAGE_CHECKSUM",
    "PARSER",
    "PARSE_VCOL_EXPR",
    "PATH",
    "PERIOD",
    "PARTIAL",
    "PARTITION",
    "PARTITIONING",
    "PARTITIONS",
    "PASSWORD",
    "PERSISTENT",
    "PHASE",
    "PLUGIN",
    "PLUGINS",
    "PORT",
    "PORTION",
    "PRECEDES",
    "PRECEDING",
    "PRECISION",
    "PREPARE",
    "PRESERVE",
    "PREV",
    "PREVIOUS",
    "PRIMARY",
    "PRIVILEGES",
    "PROCEDURE",
    "PROCESS",
    "PROCESSLIST",
    "PROFILE",
    "PROFILES",
    "PROXY",
    "PURGE",
    "QUARTER",
    "QUERY",
    "QUICK",
    "RAISE",
    "RANGE",
    "RAW",
    "READ",
    "READ_ONLY",
    "READ_WRITE",
    "READS",
    "REAL",
    "REBUILD",
    "RECOVER",
    "RECURSIVE",
    "REDO_BUFFER_SIZE",
    "REDOFILE",
    "REDUNDANT",
    "REFERENCES",
    "REGEXP",
    "RELAY",
    "RELAYLOG",
    "RELAY_LOG_FILE",
    "RELAY_LOG_POS",
    "RELAY_THREAD",
    "RELEASE",
    "RELOAD",
    "REMOVE",
    "RENAME",
    "REORGANIZE",
    "REPAIR",
    "REPEATABLE",
    "REPLACE",
    "REPLAY",
    "REPLICA",
    "REPLICAS",
    "REPLICA_POS",
    "REPLICATION",
    "REPEAT",
    "REQUIRE",
    "RESET",
    "RESIGNAL",
    "RESTART",
    "RESTORE",
    "RESTRICT",
    "RESUME",
    "RETURNED_SQLSTATE",
    "RETURN",
    "RETURNING",
    "RETURNS",
    "REUSE",
    "REVERSE",
    "REVOKE",
    "RIGHT",
    "RLIKE",
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROUTINE",
    "ROW",
    "ROWCOUNT",
    "ROWNUM",
    "ROWS",
    "ROWTYPE",
    "ROW_COUNT",
    "ROW_FORMAT",
    "RTREE",
    "SAVEPOINT",
    "SCHEDULE",
    "SCHEMA",
    "SCHEMA_NAME",
    "SCHEMAS",
    "SECOND",
    "SECOND_MICROSECOND",
    "SECURITY",
    "SELECT",
    "SENSITIVE",
    "SEPARATOR",
    "SEQUENCE",
    "SERIAL",
    "SERIALIZABLE",
    "SESSION",
    "SERVER",
    "SET",
    "SETVAL",
    "SHARE",
    "SHOW",
    "SHUTDOWN",
    "SIGNAL",
    "SIGNED",
    "SIMPLE",
    "SKIP",
    "SLAVE",
    "SLAVES",
    "SLAVE_POS",
    "SLOW",
    "SNAPSHOT",
    "SMALLINT",
    "SOCKET",
    "SOFT",
    "SOME",
    "SONAME",
    "SOUNDS",
    "SOURCE",
    "STAGE",
    "STORED",
    "SPATIAL",
    "SPECIFIC",
    "REF_SYSTEM_ID",
    "SQL",
    "SQLEXCEPTION",
    "SQLSTATE",
    "SQLWARNING",
    "SQL_BIG_RESULT",
    "SQL_BUFFER_RESULT",
    "SQL_CACHE",
    "SQL_CALC_FOUND_ROWS",
    "SQL_NO_CACHE",
    "SQL_SMALL_RESULT",
    "SQL_THREAD",
    "SQL_TSI_SECOND",
    "SQL_TSI_MINUTE",
    "SQL_TSI_HOUR",
    "SQL_TSI_DAY",
    "SQL_TSI_WEEK",
    "SQL_TSI_MONTH",
    "SQL_TSI_QUARTER",
    "SQL_TSI_YEAR",
    "SSL",
    "START",
    "STARTING",
    "STARTS",
    "STATEMENT",
    "STATS_AUTO_RECALC",
    "STATS_PERSISTENT",
    "STATS_SAMPLE_PAGES",
    "STATUS",
    "STOP",
    "STORAGE",
    "STRAIGHT_JOIN",
    "STRING",
    "SUBCLASS_ORIGIN",
    "SUBJECT",
    "SUBPARTITION",
    "SUBPARTITIONS",
    "SUPER",
    "SUSPEND",
    "SWAPS",
    "SWITCHES",
    "SYSDATE",
    "SYSTEM",
    "SYSTEM_TIME",
    "TABLE",
    "TABLE_NAME",
    "TABLES",
    "TABLESPACE",
    "TABLE_CHECKSUM",
    "TEMPORARY",
    "TEMPTABLE",
    "TERMINATED",
    "TEXT",
    "THAN",
    "THEN",
    "TIES",
    "TIME",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TINYBLOB",
    "TINYINT",
    "TINYTEXT",
    "TO",
    "TRAILING",
    "TRANSACTION",
    "TRANSACTIONAL",
    "THREADS",
    "TRIGGER",
    "TRIGGERS",
    "TRUE",
    "TRUNCATE",
    "TYPE",
    "TYPES",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNDEFINED",
    "UNDO_BUFFER_SIZE",
    "UNDOFILE",
    "UNDO",
    "UNICODE",
    "UNION",
    "UNIQUE",
    "UNKNOWN",
    "UNLOCK",
    "UNINSTALL",
    "UNSIGNED",
    "UNTIL",
    "UPDATE",
    "UPGRADE",
    "USAGE",
    "USE",
    "USER",
    "USER_RESOURCES",
    "USE_FRM",
    "USING",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "VALUE",
    "VALUES",
    "VARBINARY",
    "VARCHAR",
    "VARCHARACTER",
    "VARCHAR2",
    "VARIABLES",
    "VARYING",
    "VIA",
    "VIEW",
    "VIRTUAL",
    "VISIBLE",
    "VERSIONING",
    "WAIT",
    "WARNINGS",
    "WEEK",
    "WEIGHT_STRING",
    "WHEN",
    "WHERE",
    "WHILE",
    "WINDOW",
    "WITH",
    "WITHIN",
    "WITHOUT",
    "WORK",
    "WRAPPER",
    "WRITE",
    "X509",
    "XOR",
    "XA",
    "XML",
    "YEAR",
    "YEAR_MONTH",
    "ZEROFILL"
  ]
}), kG = ut({
  // https://mariadb.com/kb/en/information-schema-sql_functions-table/
  all: [
    "ADDDATE",
    "ADD_MONTHS",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "CAST",
    "COUNT",
    "CUME_DIST",
    "CURDATE",
    "CURTIME",
    "DATE_ADD",
    "DATE_SUB",
    "DATE_FORMAT",
    "DECODE",
    "DENSE_RANK",
    "EXTRACT",
    "FIRST_VALUE",
    "GROUP_CONCAT",
    "JSON_ARRAYAGG",
    "JSON_OBJECTAGG",
    "LAG",
    "LEAD",
    "MAX",
    "MEDIAN",
    "MID",
    "MIN",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "POSITION",
    "PERCENT_RANK",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "RANK",
    "ROW_NUMBER",
    "SESSION_USER",
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUM",
    "SYSTEM_USER",
    "TRIM",
    "TRIM_ORACLE",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "ABS",
    "ACOS",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    "ASIN",
    "ATAN",
    "ATAN2",
    "BENCHMARK",
    "BIN",
    "BINLOG_GTID_POS",
    "BIT_COUNT",
    "BIT_LENGTH",
    "CEIL",
    "CEILING",
    "CHARACTER_LENGTH",
    "CHAR_LENGTH",
    "CHR",
    "COERCIBILITY",
    "COLUMN_CHECK",
    "COLUMN_EXISTS",
    "COLUMN_LIST",
    "COLUMN_JSON",
    "COMPRESS",
    "CONCAT",
    "CONCAT_OPERATOR_ORACLE",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT_TZ",
    "COS",
    "COT",
    "CRC32",
    "DATEDIFF",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DEGREES",
    "DECODE_HISTOGRAM",
    "DECODE_ORACLE",
    "DES_DECRYPT",
    "DES_ENCRYPT",
    "ELT",
    "ENCODE",
    "ENCRYPT",
    "EXP",
    "EXPORT_SET",
    "EXTRACTVALUE",
    "FIELD",
    "FIND_IN_SET",
    "FLOOR",
    "FORMAT",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GET_LOCK",
    "GREATEST",
    "HEX",
    "IFNULL",
    "INSTR",
    "ISNULL",
    "IS_FREE_LOCK",
    "IS_USED_LOCK",
    "JSON_ARRAY",
    "JSON_ARRAY_APPEND",
    "JSON_ARRAY_INSERT",
    "JSON_COMPACT",
    "JSON_CONTAINS",
    "JSON_CONTAINS_PATH",
    "JSON_DEPTH",
    "JSON_DETAILED",
    "JSON_EXISTS",
    "JSON_EXTRACT",
    "JSON_INSERT",
    "JSON_KEYS",
    "JSON_LENGTH",
    "JSON_LOOSE",
    "JSON_MERGE",
    "JSON_MERGE_PATCH",
    "JSON_MERGE_PRESERVE",
    "JSON_QUERY",
    "JSON_QUOTE",
    "JSON_OBJECT",
    "JSON_REMOVE",
    "JSON_REPLACE",
    "JSON_SET",
    "JSON_SEARCH",
    "JSON_TYPE",
    "JSON_UNQUOTE",
    "JSON_VALID",
    "JSON_VALUE",
    "LAST_DAY",
    "LAST_INSERT_ID",
    "LCASE",
    "LEAST",
    "LENGTH",
    "LENGTHB",
    "LN",
    "LOAD_FILE",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LOWER",
    "LPAD",
    "LPAD_ORACLE",
    "LTRIM",
    "LTRIM_ORACLE",
    "MAKEDATE",
    "MAKETIME",
    "MAKE_SET",
    "MASTER_GTID_WAIT",
    "MASTER_POS_WAIT",
    "MD5",
    "MONTHNAME",
    "NAME_CONST",
    "NVL",
    "NVL2",
    "OCT",
    "OCTET_LENGTH",
    "ORD",
    "PERIOD_ADD",
    "PERIOD_DIFF",
    "PI",
    "POW",
    "POWER",
    "QUOTE",
    "REGEXP_INSTR",
    "REGEXP_REPLACE",
    "REGEXP_SUBSTR",
    "RADIANS",
    "RAND",
    "RELEASE_ALL_LOCKS",
    "RELEASE_LOCK",
    "REPLACE_ORACLE",
    "REVERSE",
    "ROUND",
    "RPAD",
    "RPAD_ORACLE",
    "RTRIM",
    "RTRIM_ORACLE",
    "SEC_TO_TIME",
    "SHA",
    "SHA1",
    "SHA2",
    "SIGN",
    "SIN",
    "SLEEP",
    "SOUNDEX",
    "SPACE",
    "SQRT",
    "STRCMP",
    "STR_TO_DATE",
    "SUBSTR_ORACLE",
    "SUBSTRING_INDEX",
    "SUBTIME",
    "SYS_GUID",
    "TAN",
    "TIMEDIFF",
    "TIME_FORMAT",
    "TIME_TO_SEC",
    "TO_BASE64",
    "TO_CHAR",
    "TO_DAYS",
    "TO_SECONDS",
    "UCASE",
    "UNCOMPRESS",
    "UNCOMPRESSED_LENGTH",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "UUID",
    "UUID_SHORT",
    "VERSION",
    "WEEKDAY",
    "WEEKOFYEAR",
    "WSREP_LAST_WRITTEN_GTID",
    "WSREP_LAST_SEEN_GTID",
    "WSREP_SYNC_WAIT_UPTO_GTID",
    "YEARWEEK",
    // CASE expression shorthands
    "COALESCE",
    "NULLIF",
    // Data types with parameters
    // https://mariadb.com/kb/en/data-types/
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    // 'NUMBER', // ?? In oracle mode only
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "BIT",
    "BINARY",
    "BLOB",
    "CHAR",
    "NATIONAL CHAR",
    "CHAR BYTE",
    "ENUM",
    "VARBINARY",
    "VARCHAR",
    "NATIONAL VARCHAR",
    // 'SET' // handled as special-case in postProcess
    "TIME",
    "DATETIME",
    "TIMESTAMP",
    "YEAR"
  ]
}), XG = fe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), jG = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT [LOW_PRIORITY | DELAYED | HIGH_PRIORITY] [IGNORE] [INTO]",
  "REPLACE [LOW_PRIORITY | DELAYED] [INTO]",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [SQL SECURITY DEFINER | SQL SECURITY INVOKER] VIEW [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMPORARY] TABLE [IF NOT EXISTS]",
  // other
  "RETURNING"
]), PC = fe([
  // - update:
  "UPDATE [LOW_PRIORITY] [IGNORE]",
  // - delete:
  "DELETE [LOW_PRIORITY] [QUICK] [IGNORE] FROM",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER [ONLINE] [IGNORE] TABLE [IF EXISTS]",
  "ADD [COLUMN] [IF NOT EXISTS]",
  "{CHANGE | MODIFY} [COLUMN] [IF EXISTS]",
  "DROP [COLUMN] [IF EXISTS]",
  "RENAME [TO]",
  "RENAME COLUMN",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  "SET {VISIBLE | INVISIBLE}",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://mariadb.com/docs/reference/mdb/sql-statements/
  "ALTER DATABASE",
  "ALTER DATABASE COMMENT",
  "ALTER EVENT",
  "ALTER FUNCTION",
  "ALTER PROCEDURE",
  "ALTER SCHEMA",
  "ALTER SCHEMA COMMENT",
  "ALTER SEQUENCE",
  "ALTER SERVER",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE",
  "ANALYZE TABLE",
  "BACKUP LOCK",
  "BACKUP STAGE",
  "BACKUP UNLOCK",
  "BEGIN",
  "BINLOG",
  "CACHE INDEX",
  "CALL",
  "CHANGE MASTER TO",
  "CHECK TABLE",
  "CHECK VIEW",
  "CHECKSUM TABLE",
  "COMMIT",
  "CREATE AGGREGATE FUNCTION",
  "CREATE DATABASE",
  "CREATE EVENT",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE PROCEDURE",
  "CREATE ROLE",
  "CREATE SEQUENCE",
  "CREATE SERVER",
  "CREATE SPATIAL INDEX",
  "CREATE TRIGGER",
  "CREATE UNIQUE INDEX",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DROP DATABASE",
  "DROP EVENT",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP PREPARE",
  "DROP PROCEDURE",
  "DROP ROLE",
  "DROP SEQUENCE",
  "DROP SERVER",
  "DROP TRIGGER",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "GET DIAGNOSTICS",
  "GET DIAGNOSTICS CONDITION",
  "GRANT",
  "HANDLER",
  "HELP",
  "INSTALL PLUGIN",
  "INSTALL SONAME",
  "KILL",
  "LOAD DATA INFILE",
  "LOAD INDEX INTO CACHE",
  "LOAD XML INFILE",
  "LOCK TABLE",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "PURGE MASTER LOGS",
  "RELEASE SAVEPOINT",
  "RENAME TABLE",
  "RENAME USER",
  "REPAIR TABLE",
  "REPAIR VIEW",
  "RESET MASTER",
  "RESET QUERY CACHE",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESIGNAL",
  "REVOKE",
  "ROLLBACK",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET GLOBAL TRANSACTION",
  "SET NAMES",
  "SET PASSWORD",
  "SET ROLE",
  "SET STATEMENT",
  "SET TRANSACTION",
  "SHOW",
  "SHOW ALL REPLICAS STATUS",
  "SHOW ALL SLAVES STATUS",
  "SHOW AUTHORS",
  "SHOW BINARY LOGS",
  "SHOW BINLOG EVENTS",
  "SHOW BINLOG STATUS",
  "SHOW CHARACTER SET",
  "SHOW CLIENT_STATISTICS",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CONTRIBUTORS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE EVENT",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PACKAGE",
  "SHOW CREATE PACKAGE BODY",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE SEQUENCE",
  "SHOW CREATE TABLE",
  "SHOW CREATE TRIGGER",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINE INNODB STATUS",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW EVENTS",
  "SHOW EXPLAIN",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW INDEXES",
  "SHOW INDEX_STATISTICS",
  "SHOW KEYS",
  "SHOW LOCALES",
  "SHOW MASTER LOGS",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PACKAGE BODY CODE",
  "SHOW PACKAGE BODY STATUS",
  "SHOW PACKAGE STATUS",
  "SHOW PLUGINS",
  "SHOW PLUGINS SONAME",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW QUERY_RESPONSE_TIME",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA",
  "SHOW REPLICA HOSTS",
  "SHOW REPLICA STATUS",
  "SHOW SCHEMAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW SLAVE STATUS",
  "SHOW STATUS",
  "SHOW STORAGE ENGINES",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW TRIGGERS",
  "SHOW USER_STATISTICS",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHOW WSREP_MEMBERSHIP",
  "SHOW WSREP_STATUS",
  "SHUTDOWN",
  "SIGNAL",
  "START ALL REPLICAS",
  "START ALL SLAVES",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP ALL REPLICAS",
  "STOP ALL SLAVES",
  "STOP REPLICA",
  "STOP SLAVE",
  "UNINSTALL PLUGIN",
  "UNINSTALL SONAME",
  "UNLOCK TABLE",
  "USE",
  "XA BEGIN",
  "XA COMMIT",
  "XA END",
  "XA PREPARE",
  "XA RECOVER",
  "XA ROLLBACK",
  "XA START"
]), KG = fe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]", "MINUS [ALL | DISTINCT]"]), JG = fe([
  "JOIN",
  "{LEFT | RIGHT} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), zG = fe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), ZG = {
  tokenizerOptions: {
    reservedSelect: XG,
    reservedClauses: [...jG, ...PC],
    reservedSetOperations: KG,
    reservedJoins: JG,
    reservedPhrases: zG,
    supportsXor: !0,
    reservedKeywords: WG,
    reservedFunctionNames: kG,
    // TODO: support _ char set prefixes such as _utf8, _latin1, _binary, _utf8mb4, etc.
    stringTypes: ['""-qq-bs', "''-qq-bs", {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_.$]+"
    }, {
      quote: '""-qq-bs',
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "''-qq-bs",
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    paramTypes: {
      positional: !0
    },
    lineCommentTypes: ["--", "#"],
    operators: ["%", ":=", "&", "|", "^", "~", "<<", ">>", "<=>", "&&", "||", "!"],
    postProcess: qG
  },
  formatOptions: {
    onelineClauses: PC
  }
};
function qG(n) {
  return n.map((a, s) => {
    const o = n[s + 1] || ws;
    return ki.SET(a) && o.text === "(" ? {
      ...a,
      type: Ee.RESERVED_FUNCTION_NAME
    } : a;
  });
}
const QG = ut({
  // https://dev.mysql.com/doc/refman/8.0/en/keywords.html
  all: [
    "ACCESSIBLE",
    // (R)
    "ACCOUNT",
    "ACTION",
    "ACTIVE",
    "ADD",
    // (R)
    "ADMIN",
    "AFTER",
    "AGAINST",
    "AGGREGATE",
    "ALGORITHM",
    "ALL",
    // (R)
    "ALTER",
    // (R)
    "ALWAYS",
    "ANALYZE",
    // (R)
    "AND",
    // (R)
    "ANY",
    "ARRAY",
    "AS",
    // (R)
    "ASC",
    // (R)
    "ASCII",
    "ASENSITIVE",
    // (R)
    "AT",
    "ATTRIBUTE",
    "AUTHENTICATION",
    "AUTOEXTEND_SIZE",
    "AUTO_INCREMENT",
    "AVG",
    "AVG_ROW_LENGTH",
    "BACKUP",
    "BEFORE",
    // (R)
    "BEGIN",
    "BETWEEN",
    // (R)
    "BIGINT",
    // (R)
    "BINARY",
    // (R)
    "BINLOG",
    "BIT",
    "BLOB",
    // (R)
    "BLOCK",
    "BOOL",
    "BOOLEAN",
    "BOTH",
    // (R)
    "BTREE",
    "BUCKETS",
    "BY",
    // (R)
    "BYTE",
    "CACHE",
    "CALL",
    // (R)
    "CASCADE",
    // (R)
    "CASCADED",
    "CASE",
    // (R)
    "CATALOG_NAME",
    "CHAIN",
    "CHALLENGE_RESPONSE",
    "CHANGE",
    // (R)
    "CHANGED",
    "CHANNEL",
    "CHAR",
    // (R)
    "CHARACTER",
    // (R)
    "CHARSET",
    "CHECK",
    // (R)
    "CHECKSUM",
    "CIPHER",
    "CLASS_ORIGIN",
    "CLIENT",
    "CLONE",
    "CLOSE",
    "COALESCE",
    "CODE",
    "COLLATE",
    // (R)
    "COLLATION",
    "COLUMN",
    // (R)
    "COLUMNS",
    "COLUMN_FORMAT",
    "COLUMN_NAME",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPACT",
    "COMPLETION",
    "COMPONENT",
    "COMPRESSED",
    "COMPRESSION",
    "CONCURRENT",
    "CONDITION",
    // (R)
    "CONNECTION",
    "CONSISTENT",
    "CONSTRAINT",
    // (R)
    "CONSTRAINT_CATALOG",
    "CONSTRAINT_NAME",
    "CONSTRAINT_SCHEMA",
    "CONTAINS",
    "CONTEXT",
    "CONTINUE",
    // (R)
    "CONVERT",
    // (R)
    "CPU",
    "CREATE",
    // (R)
    "CROSS",
    // (R)
    "CUBE",
    // (R)
    "CUME_DIST",
    // (R)
    "CURRENT",
    "CURRENT_DATE",
    // (R)
    "CURRENT_TIME",
    // (R)
    "CURRENT_TIMESTAMP",
    // (R)
    "CURRENT_USER",
    // (R)
    "CURSOR",
    // (R)
    "CURSOR_NAME",
    "DATA",
    "DATABASE",
    // (R)
    "DATABASES",
    // (R)
    "DATAFILE",
    "DATE",
    "DATETIME",
    "DAY",
    "DAY_HOUR",
    // (R)
    "DAY_MICROSECOND",
    // (R)
    "DAY_MINUTE",
    // (R)
    "DAY_SECOND",
    // (R)
    "DEALLOCATE",
    "DEC",
    // (R)
    "DECIMAL",
    // (R)
    "DECLARE",
    // (R)
    "DEFAULT",
    // (R)
    "DEFAULT_AUTH",
    "DEFINER",
    "DEFINITION",
    "DELAYED",
    // (R)
    "DELAY_KEY_WRITE",
    "DELETE",
    // (R)
    "DENSE_RANK",
    // (R)
    "DESC",
    // (R)
    "DESCRIBE",
    // (R)
    "DESCRIPTION",
    "DETERMINISTIC",
    // (R)
    "DIAGNOSTICS",
    "DIRECTORY",
    "DISABLE",
    "DISCARD",
    "DISK",
    "DISTINCT",
    // (R)
    "DISTINCTROW",
    // (R)
    "DIV",
    // (R)
    "DO",
    "DOUBLE",
    // (R)
    "DROP",
    // (R)
    "DUAL",
    // (R)
    "DUMPFILE",
    "DUPLICATE",
    "DYNAMIC",
    "EACH",
    // (R)
    "ELSE",
    // (R)
    "ELSEIF",
    // (R)
    "EMPTY",
    // (R)
    "ENABLE",
    "ENCLOSED",
    // (R)
    "ENCRYPTION",
    "END",
    "ENDS",
    "ENFORCED",
    "ENGINE",
    "ENGINES",
    "ENGINE_ATTRIBUTE",
    "ENUM",
    "ERROR",
    "ERRORS",
    "ESCAPE",
    "ESCAPED",
    // (R)
    "EVENT",
    "EVENTS",
    "EVERY",
    "EXCEPT",
    // (R)
    "EXCHANGE",
    "EXCLUDE",
    "EXECUTE",
    "EXISTS",
    // (R)
    "EXIT",
    // (R)
    "EXPANSION",
    "EXPIRE",
    "EXPLAIN",
    // (R)
    "EXPORT",
    "EXTENDED",
    "EXTENT_SIZE",
    "FACTOR",
    "FAILED_LOGIN_ATTEMPTS",
    "FALSE",
    // (R)
    "FAST",
    "FAULTS",
    "FETCH",
    // (R)
    "FIELDS",
    "FILE",
    "FILE_BLOCK_SIZE",
    "FILTER",
    "FINISH",
    "FIRST",
    "FIRST_VALUE",
    // (R)
    "FIXED",
    "FLOAT",
    // (R)
    "FLOAT4",
    // (R)
    "FLOAT8",
    // (R)
    "FLUSH",
    "FOLLOWING",
    "FOLLOWS",
    "FOR",
    // (R)
    "FORCE",
    // (R)
    "FOREIGN",
    // (R)
    "FORMAT",
    "FOUND",
    "FROM",
    // (R)
    "FULL",
    "FULLTEXT",
    // (R)
    "FUNCTION",
    // (R)
    "GENERAL",
    "GENERATED",
    // (R)
    "GEOMCOLLECTION",
    "GEOMETRY",
    "GEOMETRYCOLLECTION",
    "GET",
    // (R)
    "GET_FORMAT",
    "GET_MASTER_PUBLIC_KEY",
    "GET_SOURCE_PUBLIC_KEY",
    "GLOBAL",
    "GRANT",
    // (R)
    "GRANTS",
    "GROUP",
    // (R)
    "GROUPING",
    // (R)
    "GROUPS",
    // (R)
    "GROUP_REPLICATION",
    "GTID_ONLY",
    "HANDLER",
    "HASH",
    "HAVING",
    // (R)
    "HELP",
    "HIGH_PRIORITY",
    // (R)
    "HISTOGRAM",
    "HISTORY",
    "HOST",
    "HOSTS",
    "HOUR",
    "HOUR_MICROSECOND",
    // (R)
    "HOUR_MINUTE",
    // (R)
    "HOUR_SECOND",
    // (R)
    "IDENTIFIED",
    "IF",
    // (R)
    "IGNORE",
    // (R)
    "IGNORE_SERVER_IDS",
    "IMPORT",
    "IN",
    // (R)
    "INACTIVE",
    "INDEX",
    // (R)
    "INDEXES",
    "INFILE",
    // (R)
    "INITIAL",
    "INITIAL_SIZE",
    "INITIATE",
    "INNER",
    // (R)
    "INOUT",
    // (R)
    "INSENSITIVE",
    // (R)
    "INSERT",
    // (R)
    "INSERT_METHOD",
    "INSTALL",
    "INSTANCE",
    "IN",
    // <-- moved over from functions
    "INT",
    // (R)
    "INT1",
    // (R)
    "INT2",
    // (R)
    "INT3",
    // (R)
    "INT4",
    // (R)
    "INT8",
    // (R)
    "INTEGER",
    // (R)
    "INTERSECT",
    // (R)
    "INTERVAL",
    // (R)
    "INTO",
    // (R)
    "INVISIBLE",
    "INVOKER",
    "IO",
    "IO_AFTER_GTIDS",
    // (R)
    "IO_BEFORE_GTIDS",
    // (R)
    "IO_THREAD",
    "IPC",
    "IS",
    // (R)
    "ISOLATION",
    "ISSUER",
    "ITERATE",
    // (R)
    "JOIN",
    // (R)
    "JSON",
    "JSON_TABLE",
    // (R)
    "JSON_VALUE",
    "KEY",
    // (R)
    "KEYRING",
    "KEYS",
    // (R)
    "KEY_BLOCK_SIZE",
    "KILL",
    // (R)
    "LAG",
    // (R)
    "LANGUAGE",
    "LAST",
    "LAST_VALUE",
    // (R)
    "LATERAL",
    // (R)
    "LEAD",
    // (R)
    "LEADING",
    // (R)
    "LEAVE",
    // (R)
    "LEAVES",
    "LEFT",
    // (R)
    "LESS",
    "LEVEL",
    "LIKE",
    // (R)
    "LIMIT",
    // (R)
    "LINEAR",
    // (R)
    "LINES",
    // (R)
    "LINESTRING",
    "LIST",
    "LOAD",
    // (R)
    "LOCAL",
    "LOCALTIME",
    // (R)
    "LOCALTIMESTAMP",
    // (R)
    "LOCK",
    // (R)
    "LOCKED",
    "LOCKS",
    "LOGFILE",
    "LOGS",
    "LONG",
    // (R)
    "LONGBLOB",
    // (R)
    "LONGTEXT",
    // (R)
    "LOOP",
    // (R)
    "LOW_PRIORITY",
    // (R)
    "MASTER",
    "MASTER_AUTO_POSITION",
    "MASTER_BIND",
    // (R)
    "MASTER_COMPRESSION_ALGORITHMS",
    "MASTER_CONNECT_RETRY",
    "MASTER_DELAY",
    "MASTER_HEARTBEAT_PERIOD",
    "MASTER_HOST",
    "MASTER_LOG_FILE",
    "MASTER_LOG_POS",
    "MASTER_PASSWORD",
    "MASTER_PORT",
    "MASTER_PUBLIC_KEY_PATH",
    "MASTER_RETRY_COUNT",
    "MASTER_SSL",
    "MASTER_SSL_CA",
    "MASTER_SSL_CAPATH",
    "MASTER_SSL_CERT",
    "MASTER_SSL_CIPHER",
    "MASTER_SSL_CRL",
    "MASTER_SSL_CRLPATH",
    "MASTER_SSL_KEY",
    "MASTER_SSL_VERIFY_SERVER_CERT",
    // (R)
    "MASTER_TLS_CIPHERSUITES",
    "MASTER_TLS_VERSION",
    "MASTER_USER",
    "MASTER_ZSTD_COMPRESSION_LEVEL",
    "MATCH",
    // (R)
    "MAXVALUE",
    // (R)
    "MAX_CONNECTIONS_PER_HOUR",
    "MAX_QUERIES_PER_HOUR",
    "MAX_ROWS",
    "MAX_SIZE",
    "MAX_UPDATES_PER_HOUR",
    "MAX_USER_CONNECTIONS",
    "MEDIUM",
    "MEDIUMBLOB",
    // (R)
    "MEDIUMINT",
    // (R)
    "MEDIUMTEXT",
    // (R)
    "MEMBER",
    "MEMORY",
    "MERGE",
    "MESSAGE_TEXT",
    "MICROSECOND",
    "MIDDLEINT",
    // (R)
    "MIGRATE",
    "MINUTE",
    "MINUTE_MICROSECOND",
    // (R)
    "MINUTE_SECOND",
    // (R)
    "MIN_ROWS",
    "MOD",
    // (R)
    "MODE",
    "MODIFIES",
    // (R)
    "MODIFY",
    "MONTH",
    "MULTILINESTRING",
    "MULTIPOINT",
    "MULTIPOLYGON",
    "MUTEX",
    "MYSQL_ERRNO",
    "NAME",
    "NAMES",
    "NATIONAL",
    "NATURAL",
    // (R)
    "NCHAR",
    "NDB",
    "NDBCLUSTER",
    "NESTED",
    "NETWORK_NAMESPACE",
    "NEVER",
    "NEW",
    "NEXT",
    "NO",
    "NODEGROUP",
    "NONE",
    "NOT",
    // (R)
    "NOWAIT",
    "NO_WAIT",
    "NO_WRITE_TO_BINLOG",
    // (R)
    "NTH_VALUE",
    // (R)
    "NTILE",
    // (R)
    "NULL",
    // (R)
    "NULLS",
    "NUMBER",
    "NUMERIC",
    // (R)
    "NVARCHAR",
    "OF",
    // (R)
    "OFF",
    "OFFSET",
    "OJ",
    "OLD",
    "ON",
    // (R)
    "ONE",
    "ONLY",
    "OPEN",
    "OPTIMIZE",
    // (R)
    "OPTIMIZER_COSTS",
    // (R)
    "OPTION",
    // (R)
    "OPTIONAL",
    "OPTIONALLY",
    // (R)
    "OPTIONS",
    "OR",
    // (R)
    "ORDER",
    // (R)
    "ORDINALITY",
    "ORGANIZATION",
    "OTHERS",
    "OUT",
    // (R)
    "OUTER",
    // (R)
    "OUTFILE",
    // (R)
    "OVER",
    // (R)
    "OWNER",
    "PACK_KEYS",
    "PAGE",
    "PARSER",
    "PARTIAL",
    "PARTITION",
    // (R)
    "PARTITIONING",
    "PARTITIONS",
    "PASSWORD",
    "PASSWORD_LOCK_TIME",
    "PATH",
    "PERCENT_RANK",
    // (R)
    "PERSIST",
    "PERSIST_ONLY",
    "PHASE",
    "PLUGIN",
    "PLUGINS",
    "PLUGIN_DIR",
    "POINT",
    "POLYGON",
    "PORT",
    "PRECEDES",
    "PRECEDING",
    "PRECISION",
    // (R)
    "PREPARE",
    "PRESERVE",
    "PREV",
    "PRIMARY",
    // (R)
    "PRIVILEGES",
    "PRIVILEGE_CHECKS_USER",
    "PROCEDURE",
    // (R)
    "PROCESS",
    "PROCESSLIST",
    "PROFILE",
    "PROFILES",
    "PROXY",
    "PURGE",
    // (R)
    "QUARTER",
    "QUERY",
    "QUICK",
    "RANDOM",
    "RANGE",
    // (R)
    "RANK",
    // (R)
    "READ",
    // (R)
    "READS",
    // (R)
    "READ_ONLY",
    "READ_WRITE",
    // (R)
    "REAL",
    // (R)
    "REBUILD",
    "RECOVER",
    "RECURSIVE",
    // (R)
    "REDO_BUFFER_SIZE",
    "REDUNDANT",
    "REFERENCE",
    "REFERENCES",
    // (R)
    "REGEXP",
    // (R)
    "REGISTRATION",
    "RELAY",
    "RELAYLOG",
    "RELAY_LOG_FILE",
    "RELAY_LOG_POS",
    "RELAY_THREAD",
    "RELEASE",
    // (R)
    "RELOAD",
    "REMOVE",
    "RENAME",
    // (R)
    "REORGANIZE",
    "REPAIR",
    "REPEAT",
    // (R)
    "REPEATABLE",
    "REPLACE",
    // (R)
    "REPLICA",
    "REPLICAS",
    "REPLICATE_DO_DB",
    "REPLICATE_DO_TABLE",
    "REPLICATE_IGNORE_DB",
    "REPLICATE_IGNORE_TABLE",
    "REPLICATE_REWRITE_DB",
    "REPLICATE_WILD_DO_TABLE",
    "REPLICATE_WILD_IGNORE_TABLE",
    "REPLICATION",
    "REQUIRE",
    // (R)
    "REQUIRE_ROW_FORMAT",
    "RESET",
    "RESIGNAL",
    // (R)
    "RESOURCE",
    "RESPECT",
    "RESTART",
    "RESTORE",
    "RESTRICT",
    // (R)
    "RESUME",
    "RETAIN",
    "RETURN",
    // (R)
    "RETURNED_SQLSTATE",
    "RETURNING",
    "RETURNS",
    "REUSE",
    "REVERSE",
    "REVOKE",
    // (R)
    "RIGHT",
    // (R)
    "RLIKE",
    // (R)
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROTATE",
    "ROUTINE",
    "ROW",
    // (R)
    "ROWS",
    // (R)
    "ROW_COUNT",
    "ROW_FORMAT",
    "ROW_NUMBER",
    // (R)
    "RTREE",
    "SAVEPOINT",
    "SCHEDULE",
    "SCHEMA",
    // (R)
    "SCHEMAS",
    // (R)
    "SCHEMA_NAME",
    "SECOND",
    "SECONDARY",
    "SECONDARY_ENGINE",
    "SECONDARY_ENGINE_ATTRIBUTE",
    "SECONDARY_LOAD",
    "SECONDARY_UNLOAD",
    "SECOND_MICROSECOND",
    // (R)
    "SECURITY",
    "SELECT",
    // (R)
    "SENSITIVE",
    // (R)
    "SEPARATOR",
    // (R)
    "SERIAL",
    "SERIALIZABLE",
    "SERVER",
    "SESSION",
    "SET",
    // (R)
    "SHARE",
    "SHOW",
    // (R)
    "SHUTDOWN",
    "SIGNAL",
    // (R)
    "SIGNED",
    "SIMPLE",
    "SKIP",
    "SLAVE",
    "SLOW",
    "SMALLINT",
    // (R)
    "SNAPSHOT",
    "SOCKET",
    "SOME",
    "SONAME",
    "SOUNDS",
    "SOURCE",
    "SOURCE_AUTO_POSITION",
    "SOURCE_BIND",
    "SOURCE_COMPRESSION_ALGORITHMS",
    "SOURCE_CONNECT_RETRY",
    "SOURCE_DELAY",
    "SOURCE_HEARTBEAT_PERIOD",
    "SOURCE_HOST",
    "SOURCE_LOG_FILE",
    "SOURCE_LOG_POS",
    "SOURCE_PASSWORD",
    "SOURCE_PORT",
    "SOURCE_PUBLIC_KEY_PATH",
    "SOURCE_RETRY_COUNT",
    "SOURCE_SSL",
    "SOURCE_SSL_CA",
    "SOURCE_SSL_CAPATH",
    "SOURCE_SSL_CERT",
    "SOURCE_SSL_CIPHER",
    "SOURCE_SSL_CRL",
    "SOURCE_SSL_CRLPATH",
    "SOURCE_SSL_KEY",
    "SOURCE_SSL_VERIFY_SERVER_CERT",
    "SOURCE_TLS_CIPHERSUITES",
    "SOURCE_TLS_VERSION",
    "SOURCE_USER",
    "SOURCE_ZSTD_COMPRESSION_LEVEL",
    "SPATIAL",
    // (R)
    "SPECIFIC",
    // (R)
    "SQL",
    // (R)
    "SQLEXCEPTION",
    // (R)
    "SQLSTATE",
    // (R)
    "SQLWARNING",
    // (R)
    "SQL_AFTER_GTIDS",
    "SQL_AFTER_MTS_GAPS",
    "SQL_BEFORE_GTIDS",
    "SQL_BIG_RESULT",
    // (R)
    "SQL_BUFFER_RESULT",
    "SQL_CALC_FOUND_ROWS",
    // (R)
    "SQL_NO_CACHE",
    "SQL_SMALL_RESULT",
    // (R)
    "SQL_THREAD",
    "SQL_TSI_DAY",
    "SQL_TSI_HOUR",
    "SQL_TSI_MINUTE",
    "SQL_TSI_MONTH",
    "SQL_TSI_QUARTER",
    "SQL_TSI_SECOND",
    "SQL_TSI_WEEK",
    "SQL_TSI_YEAR",
    "SRID",
    "SSL",
    // (R)
    "STACKED",
    "START",
    "STARTING",
    // (R)
    "STARTS",
    "STATS_AUTO_RECALC",
    "STATS_PERSISTENT",
    "STATS_SAMPLE_PAGES",
    "STATUS",
    "STOP",
    "STORAGE",
    "STORED",
    // (R)
    "STRAIGHT_JOIN",
    // (R)
    "STREAM",
    "STRING",
    "SUBCLASS_ORIGIN",
    "SUBJECT",
    "SUBPARTITION",
    "SUBPARTITIONS",
    "SUPER",
    "SUSPEND",
    "SWAPS",
    "SWITCHES",
    "SYSTEM",
    // (R)
    "TABLE",
    // (R)
    "TABLES",
    "TABLESPACE",
    "TABLE_CHECKSUM",
    "TABLE_NAME",
    "TEMPORARY",
    "TEMPTABLE",
    "TERMINATED",
    // (R)
    "TEXT",
    "THAN",
    "THEN",
    // (R)
    "THREAD_PRIORITY",
    "TIES",
    "TIME",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TINYBLOB",
    // (R)
    "TINYINT",
    // (R)
    "TINYTEXT",
    // (R)
    "TLS",
    "TO",
    // (R)
    "TRAILING",
    // (R)
    "TRANSACTION",
    "TRIGGER",
    // (R)
    "TRIGGERS",
    "TRUE",
    // (R)
    "TRUNCATE",
    "TYPE",
    "TYPES",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNDEFINED",
    "UNDO",
    // (R)
    "UNDOFILE",
    "UNDO_BUFFER_SIZE",
    "UNICODE",
    "UNINSTALL",
    "UNION",
    // (R)
    "UNIQUE",
    // (R)
    "UNKNOWN",
    "UNLOCK",
    // (R)
    "UNREGISTER",
    "UNSIGNED",
    // (R)
    "UNTIL",
    "UPDATE",
    // (R)
    "UPGRADE",
    "USAGE",
    // (R)
    "USE",
    // (R)
    "USER",
    "USER_RESOURCES",
    "USE_FRM",
    "USING",
    // (R)
    "UTC_DATE",
    // (R)
    "UTC_TIME",
    // (R)
    "UTC_TIMESTAMP",
    // (R)
    "VALIDATION",
    "VALUE",
    "VALUES",
    // (R)
    "VARBINARY",
    // (R)
    "VARCHAR",
    // (R)
    "VARCHARACTER",
    // (R)
    "VARIABLES",
    "VARYING",
    // (R)
    "VCPU",
    "VIEW",
    "VIRTUAL",
    // (R)
    "VISIBLE",
    "WAIT",
    "WARNINGS",
    "WEEK",
    "WEIGHT_STRING",
    "WHEN",
    // (R)
    "WHERE",
    // (R)
    "WHILE",
    // (R)
    "WINDOW",
    // (R)
    "WITH",
    // (R)
    "WITHOUT",
    "WORK",
    "WRAPPER",
    "WRITE",
    // (R)
    "X509",
    "XA",
    "XID",
    "XML",
    "XOR",
    // (R)
    "YEAR",
    "YEAR_MONTH",
    // (R)
    "ZEROFILL",
    // (R)
    "ZONE"
  ]
}), $G = ut({
  // https://dev.mysql.com/doc/refman/8.0/en/built-in-function-reference.html
  all: [
    "ABS",
    "ACOS",
    "ADDDATE",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    // 'AND',
    "ANY_VALUE",
    "ASCII",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BENCHMARK",
    "BIN",
    "BIN_TO_UUID",
    "BINARY",
    "BIT_AND",
    "BIT_COUNT",
    "BIT_LENGTH",
    "BIT_OR",
    "BIT_XOR",
    "CAN_ACCESS_COLUMN",
    "CAN_ACCESS_DATABASE",
    "CAN_ACCESS_TABLE",
    "CAN_ACCESS_USER",
    "CAN_ACCESS_VIEW",
    "CAST",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHAR_LENGTH",
    "CHARACTER_LENGTH",
    "CHARSET",
    "COALESCE",
    "COERCIBILITY",
    "COLLATION",
    "COMPRESS",
    "CONCAT",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT",
    "CONVERT_TZ",
    "COS",
    "COT",
    "COUNT",
    "CRC32",
    "CUME_DIST",
    "CURDATE",
    "CURRENT_DATE",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURTIME",
    "DATABASE",
    "DATE",
    "DATE_ADD",
    "DATE_FORMAT",
    "DATE_SUB",
    "DATEDIFF",
    "DAY",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DEFAULT",
    "DEGREES",
    "DENSE_RANK",
    "DIV",
    "ELT",
    "EXP",
    "EXPORT_SET",
    "EXTRACT",
    "EXTRACTVALUE",
    "FIELD",
    "FIND_IN_SET",
    "FIRST_VALUE",
    "FLOOR",
    "FORMAT",
    "FORMAT_BYTES",
    "FORMAT_PICO_TIME",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GEOMCOLLECTION",
    "GEOMETRYCOLLECTION",
    "GET_DD_COLUMN_PRIVILEGES",
    "GET_DD_CREATE_OPTIONS",
    "GET_DD_INDEX_SUB_PART_LENGTH",
    "GET_FORMAT",
    "GET_LOCK",
    "GREATEST",
    "GROUP_CONCAT",
    "GROUPING",
    "GTID_SUBSET",
    "GTID_SUBTRACT",
    "HEX",
    "HOUR",
    "ICU_VERSION",
    "IF",
    "IFNULL",
    // 'IN',
    "INET_ATON",
    "INET_NTOA",
    "INET6_ATON",
    "INET6_NTOA",
    "INSERT",
    "INSTR",
    "INTERNAL_AUTO_INCREMENT",
    "INTERNAL_AVG_ROW_LENGTH",
    "INTERNAL_CHECK_TIME",
    "INTERNAL_CHECKSUM",
    "INTERNAL_DATA_FREE",
    "INTERNAL_DATA_LENGTH",
    "INTERNAL_DD_CHAR_LENGTH",
    "INTERNAL_GET_COMMENT_OR_ERROR",
    "INTERNAL_GET_ENABLED_ROLE_JSON",
    "INTERNAL_GET_HOSTNAME",
    "INTERNAL_GET_USERNAME",
    "INTERNAL_GET_VIEW_WARNING_OR_ERROR",
    "INTERNAL_INDEX_COLUMN_CARDINALITY",
    "INTERNAL_INDEX_LENGTH",
    "INTERNAL_IS_ENABLED_ROLE",
    "INTERNAL_IS_MANDATORY_ROLE",
    "INTERNAL_KEYS_DISABLED",
    "INTERNAL_MAX_DATA_LENGTH",
    "INTERNAL_TABLE_ROWS",
    "INTERNAL_UPDATE_TIME",
    "INTERVAL",
    "IS",
    "IS_FREE_LOCK",
    "IS_IPV4",
    "IS_IPV4_COMPAT",
    "IS_IPV4_MAPPED",
    "IS_IPV6",
    "IS NOT",
    "IS NOT NULL",
    "IS NULL",
    "IS_USED_LOCK",
    "IS_UUID",
    "ISNULL",
    "JSON_ARRAY",
    "JSON_ARRAY_APPEND",
    "JSON_ARRAY_INSERT",
    "JSON_ARRAYAGG",
    "JSON_CONTAINS",
    "JSON_CONTAINS_PATH",
    "JSON_DEPTH",
    "JSON_EXTRACT",
    "JSON_INSERT",
    "JSON_KEYS",
    "JSON_LENGTH",
    "JSON_MERGE",
    "JSON_MERGE_PATCH",
    "JSON_MERGE_PRESERVE",
    "JSON_OBJECT",
    "JSON_OBJECTAGG",
    "JSON_OVERLAPS",
    "JSON_PRETTY",
    "JSON_QUOTE",
    "JSON_REMOVE",
    "JSON_REPLACE",
    "JSON_SCHEMA_VALID",
    "JSON_SCHEMA_VALIDATION_REPORT",
    "JSON_SEARCH",
    "JSON_SET",
    "JSON_STORAGE_FREE",
    "JSON_STORAGE_SIZE",
    "JSON_TABLE",
    "JSON_TYPE",
    "JSON_UNQUOTE",
    "JSON_VALID",
    "JSON_VALUE",
    "LAG",
    "LAST_DAY",
    "LAST_INSERT_ID",
    "LAST_VALUE",
    "LCASE",
    "LEAD",
    "LEAST",
    "LEFT",
    "LENGTH",
    "LIKE",
    "LINESTRING",
    "LN",
    "LOAD_FILE",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LOWER",
    "LPAD",
    "LTRIM",
    "MAKE_SET",
    "MAKEDATE",
    "MAKETIME",
    "MASTER_POS_WAIT",
    "MATCH",
    "MAX",
    "MBRCONTAINS",
    "MBRCOVEREDBY",
    "MBRCOVERS",
    "MBRDISJOINT",
    "MBREQUALS",
    "MBRINTERSECTS",
    "MBROVERLAPS",
    "MBRTOUCHES",
    "MBRWITHIN",
    "MD5",
    "MEMBER OF",
    "MICROSECOND",
    "MID",
    "MIN",
    "MINUTE",
    "MOD",
    "MONTH",
    "MONTHNAME",
    "MULTILINESTRING",
    "MULTIPOINT",
    "MULTIPOLYGON",
    "NAME_CONST",
    "NOT",
    "NOT IN",
    "NOT LIKE",
    "NOT REGEXP",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "OCT",
    "OCTET_LENGTH",
    // 'OR',
    "ORD",
    "PERCENT_RANK",
    "PERIOD_ADD",
    "PERIOD_DIFF",
    "PI",
    "POINT",
    "POLYGON",
    "POSITION",
    "POW",
    "POWER",
    "PS_CURRENT_THREAD_ID",
    "PS_THREAD_ID",
    "QUARTER",
    "QUOTE",
    "RADIANS",
    "RAND",
    "RANDOM_BYTES",
    "RANK",
    "REGEXP",
    "REGEXP_INSTR",
    "REGEXP_LIKE",
    "REGEXP_REPLACE",
    "REGEXP_SUBSTR",
    "RELEASE_ALL_LOCKS",
    "RELEASE_LOCK",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RLIKE",
    "ROLES_GRAPHML",
    "ROUND",
    "ROW_COUNT",
    "ROW_NUMBER",
    "RPAD",
    "RTRIM",
    "SCHEMA",
    "SEC_TO_TIME",
    "SECOND",
    "SESSION_USER",
    "SHA1",
    "SHA2",
    "SIGN",
    "SIN",
    "SLEEP",
    "SOUNDEX",
    "SOUNDS LIKE",
    "SOURCE_POS_WAIT",
    "SPACE",
    "SQRT",
    "ST_AREA",
    "ST_ASBINARY",
    "ST_ASGEOJSON",
    "ST_ASTEXT",
    "ST_BUFFER",
    "ST_BUFFER_STRATEGY",
    "ST_CENTROID",
    "ST_COLLECT",
    "ST_CONTAINS",
    "ST_CONVEXHULL",
    "ST_CROSSES",
    "ST_DIFFERENCE",
    "ST_DIMENSION",
    "ST_DISJOINT",
    "ST_DISTANCE",
    "ST_DISTANCE_SPHERE",
    "ST_ENDPOINT",
    "ST_ENVELOPE",
    "ST_EQUALS",
    "ST_EXTERIORRING",
    "ST_FRECHETDISTANCE",
    "ST_GEOHASH",
    "ST_GEOMCOLLFROMTEXT",
    "ST_GEOMCOLLFROMWKB",
    "ST_GEOMETRYN",
    "ST_GEOMETRYTYPE",
    "ST_GEOMFROMGEOJSON",
    "ST_GEOMFROMTEXT",
    "ST_GEOMFROMWKB",
    "ST_HAUSDORFFDISTANCE",
    "ST_INTERIORRINGN",
    "ST_INTERSECTION",
    "ST_INTERSECTS",
    "ST_ISCLOSED",
    "ST_ISEMPTY",
    "ST_ISSIMPLE",
    "ST_ISVALID",
    "ST_LATFROMGEOHASH",
    "ST_LATITUDE",
    "ST_LENGTH",
    "ST_LINEFROMTEXT",
    "ST_LINEFROMWKB",
    "ST_LINEINTERPOLATEPOINT",
    "ST_LINEINTERPOLATEPOINTS",
    "ST_LONGFROMGEOHASH",
    "ST_LONGITUDE",
    "ST_MAKEENVELOPE",
    "ST_MLINEFROMTEXT",
    "ST_MLINEFROMWKB",
    "ST_MPOINTFROMTEXT",
    "ST_MPOINTFROMWKB",
    "ST_MPOLYFROMTEXT",
    "ST_MPOLYFROMWKB",
    "ST_NUMGEOMETRIES",
    "ST_NUMINTERIORRING",
    "ST_NUMPOINTS",
    "ST_OVERLAPS",
    "ST_POINTATDISTANCE",
    "ST_POINTFROMGEOHASH",
    "ST_POINTFROMTEXT",
    "ST_POINTFROMWKB",
    "ST_POINTN",
    "ST_POLYFROMTEXT",
    "ST_POLYFROMWKB",
    "ST_SIMPLIFY",
    "ST_SRID",
    "ST_STARTPOINT",
    "ST_SWAPXY",
    "ST_SYMDIFFERENCE",
    "ST_TOUCHES",
    "ST_TRANSFORM",
    "ST_UNION",
    "ST_VALIDATE",
    "ST_WITHIN",
    "ST_X",
    "ST_Y",
    "STATEMENT_DIGEST",
    "STATEMENT_DIGEST_TEXT",
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DATE",
    "STRCMP",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "SUBTIME",
    "SUM",
    "SYSDATE",
    "SYSTEM_USER",
    "TAN",
    "TIME",
    "TIME_FORMAT",
    "TIME_TO_SEC",
    "TIMEDIFF",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TO_BASE64",
    "TO_DAYS",
    "TO_SECONDS",
    "TRIM",
    "TRUNCATE",
    "UCASE",
    "UNCOMPRESS",
    "UNCOMPRESSED_LENGTH",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "USER",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "UUID",
    "UUID_SHORT",
    "UUID_TO_BIN",
    "VALIDATE_PASSWORD_STRENGTH",
    "VALUES",
    "VAR_POP",
    "VAR_SAMP",
    "VARIANCE",
    "VERSION",
    "WAIT_FOR_EXECUTED_GTID_SET",
    "WAIT_UNTIL_SQL_THREAD_AFTER_GTIDS",
    "WEEK",
    "WEEKDAY",
    "WEEKOFYEAR",
    "WEIGHT_STRING",
    // 'XOR',
    "YEAR",
    "YEARWEEK",
    // Data types with parameters
    // https://dev.mysql.com/doc/refman/8.0/en/data-types.html
    "BIT",
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "DATETIME",
    "TIMESTAMP",
    "TIME",
    "YEAR",
    "CHAR",
    "NATIONAL CHAR",
    "VARCHAR",
    "NATIONAL VARCHAR",
    "BINARY",
    "VARBINARY",
    "BLOB",
    "TEXT",
    "ENUM"
    // 'SET' // handled as special-case in postProcess
  ]
}), e3 = fe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), t3 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [LOW_PRIORITY | DELAYED | HIGH_PRIORITY] [IGNORE] [INTO]",
  "REPLACE [LOW_PRIORITY | DELAYED] [INTO]",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [SQL SECURITY DEFINER | SQL SECURITY INVOKER] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY] TABLE [IF NOT EXISTS]"
]), UC = fe([
  // - update:
  "UPDATE [LOW_PRIORITY] [IGNORE]",
  // - delete:
  "DELETE [LOW_PRIORITY] [QUICK] [IGNORE] FROM",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "{CHANGE | MODIFY} [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [TO | AS]",
  "RENAME COLUMN",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://dev.mysql.com/doc/refman/8.0/en/sql-statements.html
  "ALTER DATABASE",
  "ALTER EVENT",
  "ALTER FUNCTION",
  "ALTER INSTANCE",
  "ALTER LOGFILE GROUP",
  "ALTER PROCEDURE",
  "ALTER RESOURCE GROUP",
  "ALTER SERVER",
  "ALTER TABLESPACE",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE TABLE",
  "BINLOG",
  "CACHE INDEX",
  "CALL",
  "CHANGE MASTER TO",
  "CHANGE REPLICATION FILTER",
  "CHANGE REPLICATION SOURCE TO",
  "CHECK TABLE",
  "CHECKSUM TABLE",
  "CLONE",
  "COMMIT",
  "CREATE DATABASE",
  "CREATE EVENT",
  "CREATE FUNCTION",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE LOGFILE GROUP",
  "CREATE PROCEDURE",
  "CREATE RESOURCE GROUP",
  "CREATE ROLE",
  "CREATE SERVER",
  "CREATE SPATIAL REFERENCE SYSTEM",
  "CREATE TABLESPACE",
  "CREATE TRIGGER",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DROP DATABASE",
  "DROP EVENT",
  "DROP FUNCTION",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP LOGFILE GROUP",
  "DROP PROCEDURE",
  "DROP RESOURCE GROUP",
  "DROP ROLE",
  "DROP SERVER",
  "DROP SPATIAL REFERENCE SYSTEM",
  "DROP TABLESPACE",
  "DROP TRIGGER",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "GRANT",
  "HANDLER",
  "HELP",
  "IMPORT TABLE",
  "INSTALL COMPONENT",
  "INSTALL PLUGIN",
  "KILL",
  "LOAD DATA",
  "LOAD INDEX INTO CACHE",
  "LOAD XML",
  "LOCK INSTANCE FOR BACKUP",
  "LOCK TABLES",
  "MASTER_POS_WAIT",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "RELEASE SAVEPOINT",
  "RENAME TABLE",
  "RENAME USER",
  "REPAIR TABLE",
  "RESET",
  "RESET MASTER",
  "RESET PERSIST",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESTART",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET NAMES",
  "SET PASSWORD",
  "SET RESOURCE GROUP",
  "SET ROLE",
  "SET TRANSACTION",
  "SHOW",
  "SHOW BINARY LOGS",
  "SHOW BINLOG EVENTS",
  "SHOW CHARACTER SET",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE EVENT",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE TABLE",
  "SHOW CREATE TRIGGER",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW EVENTS",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PLUGINS",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA STATUS",
  "SHOW REPLICAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW STATUS",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW TRIGGERS",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHUTDOWN",
  "SOURCE_POS_WAIT",
  "START GROUP_REPLICATION",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP GROUP_REPLICATION",
  "STOP REPLICA",
  "STOP SLAVE",
  "TABLE",
  "UNINSTALL COMPONENT",
  "UNINSTALL PLUGIN",
  "UNLOCK INSTANCE",
  "UNLOCK TABLES",
  "USE",
  "XA",
  // flow control
  // 'IF',
  "ITERATE",
  "LEAVE",
  "LOOP",
  "REPEAT",
  "RETURN",
  "WHILE"
]), n3 = fe(["UNION [ALL | DISTINCT]"]), r3 = fe([
  "JOIN",
  "{LEFT | RIGHT} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), a3 = fe(["ON {UPDATE | DELETE} [SET NULL]", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), i3 = {
  tokenizerOptions: {
    reservedSelect: e3,
    reservedClauses: [...t3, ...UC],
    reservedSetOperations: n3,
    reservedJoins: r3,
    reservedPhrases: a3,
    supportsXor: !0,
    reservedKeywords: QG,
    reservedFunctionNames: $G,
    // TODO: support _ char set prefixes such as _utf8, _latin1, _binary, _utf8mb4, etc.
    stringTypes: ['""-qq-bs', {
      quote: "''-qq-bs",
      prefixes: ["N"]
    }, {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_.$]+"
    }, {
      quote: '""-qq-bs',
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "''-qq-bs",
      prefixes: ["@"],
      requirePrefix: !0
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    paramTypes: {
      positional: !0
    },
    lineCommentTypes: ["--", "#"],
    operators: ["%", ":=", "&", "|", "^", "~", "<<", ">>", "<=>", "->", "->>", "&&", "||", "!"],
    postProcess: s3
  },
  formatOptions: {
    onelineClauses: UC
  }
};
function s3(n) {
  return n.map((a, s) => {
    const o = n[s + 1] || ws;
    return ki.SET(a) && o.text === "(" ? {
      ...a,
      type: Ee.RESERVED_FUNCTION_NAME
    } : a;
  });
}
const o3 = ut({
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/functions.html
  all: [
    "ABORT",
    "ABS",
    "ACOS",
    "ADVISOR",
    "ARRAY_AGG",
    "ARRAY_AGG",
    "ARRAY_APPEND",
    "ARRAY_AVG",
    "ARRAY_BINARY_SEARCH",
    "ARRAY_CONCAT",
    "ARRAY_CONTAINS",
    "ARRAY_COUNT",
    "ARRAY_DISTINCT",
    "ARRAY_EXCEPT",
    "ARRAY_FLATTEN",
    "ARRAY_IFNULL",
    "ARRAY_INSERT",
    "ARRAY_INTERSECT",
    "ARRAY_LENGTH",
    "ARRAY_MAX",
    "ARRAY_MIN",
    "ARRAY_MOVE",
    "ARRAY_POSITION",
    "ARRAY_PREPEND",
    "ARRAY_PUT",
    "ARRAY_RANGE",
    "ARRAY_REMOVE",
    "ARRAY_REPEAT",
    "ARRAY_REPLACE",
    "ARRAY_REVERSE",
    "ARRAY_SORT",
    "ARRAY_STAR",
    "ARRAY_SUM",
    "ARRAY_SYMDIFF",
    "ARRAY_SYMDIFF1",
    "ARRAY_SYMDIFFN",
    "ARRAY_UNION",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BASE64",
    "BASE64_DECODE",
    "BASE64_ENCODE",
    "BITAND ",
    "BITCLEAR ",
    "BITNOT ",
    "BITOR ",
    "BITSET ",
    "BITSHIFT ",
    "BITTEST ",
    "BITXOR ",
    "CEIL",
    "CLOCK_LOCAL",
    "CLOCK_MILLIS",
    "CLOCK_STR",
    "CLOCK_TZ",
    "CLOCK_UTC",
    "COALESCE",
    "CONCAT",
    "CONCAT2",
    "CONTAINS",
    "CONTAINS_TOKEN",
    "CONTAINS_TOKEN_LIKE",
    "CONTAINS_TOKEN_REGEXP",
    "COS",
    "COUNT",
    "COUNT",
    "COUNTN",
    "CUME_DIST",
    "CURL",
    "DATE_ADD_MILLIS",
    "DATE_ADD_STR",
    "DATE_DIFF_MILLIS",
    "DATE_DIFF_STR",
    "DATE_FORMAT_STR",
    "DATE_PART_MILLIS",
    "DATE_PART_STR",
    "DATE_RANGE_MILLIS",
    "DATE_RANGE_STR",
    "DATE_TRUNC_MILLIS",
    "DATE_TRUNC_STR",
    "DECODE",
    "DECODE_JSON",
    "DEGREES",
    "DENSE_RANK",
    "DURATION_TO_STR",
    // 'E',
    "ENCODED_SIZE",
    "ENCODE_JSON",
    "EXP",
    "FIRST_VALUE",
    "FLOOR",
    "GREATEST",
    "HAS_TOKEN",
    "IFINF",
    "IFMISSING",
    "IFMISSINGORNULL",
    "IFNAN",
    "IFNANORINF",
    "IFNULL",
    "INITCAP",
    "ISARRAY",
    "ISATOM",
    "ISBITSET",
    "ISBOOLEAN",
    "ISNUMBER",
    "ISOBJECT",
    "ISSTRING",
    "LAG",
    "LAST_VALUE",
    "LEAD",
    "LEAST",
    "LENGTH",
    "LN",
    "LOG",
    "LOWER",
    "LTRIM",
    "MAX",
    "MEAN",
    "MEDIAN",
    "META",
    "MILLIS",
    "MILLIS_TO_LOCAL",
    "MILLIS_TO_STR",
    "MILLIS_TO_TZ",
    "MILLIS_TO_UTC",
    "MILLIS_TO_ZONE_NAME",
    "MIN",
    "MISSINGIF",
    "NANIF",
    "NEGINFIF",
    "NOW_LOCAL",
    "NOW_MILLIS",
    "NOW_STR",
    "NOW_TZ",
    "NOW_UTC",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "NVL",
    "NVL2",
    "OBJECT_ADD",
    "OBJECT_CONCAT",
    "OBJECT_INNER_PAIRS",
    "OBJECT_INNER_VALUES",
    "OBJECT_LENGTH",
    "OBJECT_NAMES",
    "OBJECT_PAIRS",
    "OBJECT_PUT",
    "OBJECT_REMOVE",
    "OBJECT_RENAME",
    "OBJECT_REPLACE",
    "OBJECT_UNWRAP",
    "OBJECT_VALUES",
    "PAIRS",
    "PERCENT_RANK",
    "PI",
    "POLY_LENGTH",
    "POSINFIF",
    "POSITION",
    "POWER",
    "RADIANS",
    "RANDOM",
    "RANK",
    "RATIO_TO_REPORT",
    "REGEXP_CONTAINS",
    "REGEXP_LIKE",
    "REGEXP_MATCHES",
    "REGEXP_POSITION",
    "REGEXP_REPLACE",
    "REGEXP_SPLIT",
    "REGEX_CONTAINS",
    "REGEX_LIKE",
    "REGEX_MATCHES",
    "REGEX_POSITION",
    "REGEX_REPLACE",
    "REGEX_SPLIT",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "ROUND",
    "ROW_NUMBER",
    "RTRIM",
    "SEARCH",
    "SEARCH_META",
    "SEARCH_SCORE",
    "SIGN",
    "SIN",
    "SPLIT",
    "SQRT",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DURATION",
    "STR_TO_MILLIS",
    "STR_TO_TZ",
    "STR_TO_UTC",
    "STR_TO_ZONE_NAME",
    "SUBSTR",
    "SUFFIXES",
    "SUM",
    "TAN",
    "TITLE",
    "TOARRAY",
    "TOATOM",
    "TOBOOLEAN",
    "TOKENS",
    "TOKENS",
    "TONUMBER",
    "TOOBJECT",
    "TOSTRING",
    "TRIM",
    "TRUNC",
    // 'TYPE', // disabled
    "UPPER",
    "UUID",
    "VARIANCE",
    "VARIANCE_POP",
    "VARIANCE_SAMP",
    "VAR_POP",
    "VAR_SAMP",
    "WEEKDAY_MILLIS",
    "WEEKDAY_STR",
    // type casting
    // not implemented in N1QL, but added here now for the sake of tests
    // https://docs.couchbase.com/server/current/analytics/3_query.html#Vs_SQL-92
    "CAST"
  ]
}), l3 = ut({
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html
  all: ["ADVISE", "ALL", "ALTER", "ANALYZE", "AND", "ANY", "ARRAY", "AS", "ASC", "AT", "BEGIN", "BETWEEN", "BINARY", "BOOLEAN", "BREAK", "BUCKET", "BUILD", "BY", "CALL", "CASE", "CAST", "CLUSTER", "COLLATE", "COLLECTION", "COMMIT", "COMMITTED", "CONNECT", "CONTINUE", "CORRELATED", "COVER", "CREATE", "CURRENT", "DATABASE", "DATASET", "DATASTORE", "DECLARE", "DECREMENT", "DELETE", "DERIVED", "DESC", "DESCRIBE", "DISTINCT", "DO", "DROP", "EACH", "ELEMENT", "ELSE", "END", "EVERY", "EXCEPT", "EXCLUDE", "EXECUTE", "EXISTS", "EXPLAIN", "FALSE", "FETCH", "FILTER", "FIRST", "FLATTEN", "FLUSH", "FOLLOWING", "FOR", "FORCE", "FROM", "FTS", "FUNCTION", "GOLANG", "GRANT", "GROUP", "GROUPS", "GSI", "HASH", "HAVING", "IF", "ISOLATION", "IGNORE", "ILIKE", "IN", "INCLUDE", "INCREMENT", "INDEX", "INFER", "INLINE", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "JAVASCRIPT", "JOIN", "KEY", "KEYS", "KEYSPACE", "KNOWN", "LANGUAGE", "LAST", "LEFT", "LET", "LETTING", "LEVEL", "LIKE", "LIMIT", "LSM", "MAP", "MAPPING", "MATCHED", "MATERIALIZED", "MERGE", "MINUS", "MISSING", "NAMESPACE", "NEST", "NL", "NO", "NOT", "NTH_VALUE", "NULL", "NULLS", "NUMBER", "OBJECT", "OFFSET", "ON", "OPTION", "OPTIONS", "OR", "ORDER", "OTHERS", "OUTER", "OVER", "PARSE", "PARTITION", "PASSWORD", "PATH", "POOL", "PRECEDING", "PREPARE", "PRIMARY", "PRIVATE", "PRIVILEGE", "PROBE", "PROCEDURE", "PUBLIC", "RANGE", "RAW", "REALM", "REDUCE", "RENAME", "RESPECT", "RETURN", "RETURNING", "REVOKE", "RIGHT", "ROLE", "ROLLBACK", "ROW", "ROWS", "SATISFIES", "SAVEPOINT", "SCHEMA", "SCOPE", "SELECT", "SELF", "SEMI", "SET", "SHOW", "SOME", "START", "STATISTICS", "STRING", "SYSTEM", "THEN", "TIES", "TO", "TRAN", "TRANSACTION", "TRIGGER", "TRUE", "TRUNCATE", "UNBOUNDED", "UNDER", "UNION", "UNIQUE", "UNKNOWN", "UNNEST", "UNSET", "UPDATE", "UPSERT", "USE", "USER", "USING", "VALIDATE", "VALUE", "VALUED", "VALUES", "VIA", "VIEW", "WHEN", "WHERE", "WHILE", "WINDOW", "WITH", "WITHIN", "WORK", "XOR"]
}), u3 = fe(["SELECT [ALL | DISTINCT]"]), E3 = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE INTO",
  "WHEN [NOT] MATCHED THEN",
  "UPDATE SET",
  "INSERT",
  // other
  "NEST",
  "UNNEST",
  "RETURNING"
]), xC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - set schema:
  "SET SCHEMA",
  // https://docs.couchbase.com/server/current/n1ql/n1ql-language-reference/reservedwords.html
  "ADVISE",
  "ALTER INDEX",
  "BEGIN TRANSACTION",
  "BUILD INDEX",
  "COMMIT TRANSACTION",
  "CREATE COLLECTION",
  "CREATE FUNCTION",
  "CREATE INDEX",
  "CREATE PRIMARY INDEX",
  "CREATE SCOPE",
  "DROP COLLECTION",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP PRIMARY INDEX",
  "DROP SCOPE",
  "EXECUTE",
  "EXECUTE FUNCTION",
  "EXPLAIN",
  "GRANT",
  "INFER",
  "PREPARE",
  "REVOKE",
  "ROLLBACK TRANSACTION",
  "SAVEPOINT",
  "SET TRANSACTION",
  "UPDATE STATISTICS",
  "UPSERT",
  // other
  "LET",
  "SET CURRENT SCHEMA",
  "SHOW",
  "USE [PRIMARY] KEYS"
]), c3 = fe(["UNION [ALL]", "EXCEPT [ALL]", "INTERSECT [ALL]"]), f3 = fe(["JOIN", "{LEFT | RIGHT} [OUTER] JOIN", "INNER JOIN"]), T3 = fe(["{ROWS | RANGE | GROUPS} BETWEEN"]), d3 = {
  tokenizerOptions: {
    reservedSelect: u3,
    reservedClauses: [...E3, ...xC],
    reservedSetOperations: c3,
    reservedJoins: f3,
    reservedPhrases: T3,
    supportsXor: !0,
    reservedKeywords: l3,
    reservedFunctionNames: o3,
    // NOTE: single quotes are actually not supported in N1QL,
    // but we support them anyway as all other SQL dialects do,
    // which simplifies writing tests that are shared between all dialects.
    stringTypes: ['""-bs', "''-bs"],
    identTypes: ["``"],
    extraParens: ["[]", "{}"],
    paramTypes: {
      positional: !0,
      numbered: ["$"],
      named: ["$"]
    },
    lineCommentTypes: ["#", "--"],
    operators: ["%", "==", ":", "||"]
  },
  formatOptions: {
    onelineClauses: xC
  }
}, A3 = ut({
  // https://docs.oracle.com/cd/B19306_01/appdev.102/b14261/reservewords.htm
  all: [
    // 'A',
    "ADD",
    "AGENT",
    "AGGREGATE",
    "ALL",
    "ALTER",
    "AND",
    "ANY",
    "ARRAY",
    "ARROW",
    "AS",
    "ASC",
    "AT",
    "ATTRIBUTE",
    "AUTHID",
    "AVG",
    "BEGIN",
    "BETWEEN",
    "BFILE_BASE",
    "BINARY",
    "BLOB_BASE",
    "BLOCK",
    "BODY",
    "BOTH",
    "BOUND",
    "BULK",
    "BY",
    "BYTE",
    // 'C',
    "CALL",
    "CALLING",
    "CASCADE",
    "CASE",
    "CHAR",
    "CHAR_BASE",
    "CHARACTER",
    "CHARSET",
    "CHARSETFORM",
    "CHARSETID",
    "CHECK",
    "CLOB_BASE",
    "CLOSE",
    "CLUSTER",
    "CLUSTERS",
    "COLAUTH",
    "COLLECT",
    "COLUMNS",
    "COMMENT",
    "COMMIT",
    "COMMITTED",
    "COMPILED",
    "COMPRESS",
    "CONNECT",
    "CONSTANT",
    "CONSTRUCTOR",
    "CONTEXT",
    "CONVERT",
    "COUNT",
    "CRASH",
    "CREATE",
    "CURRENT",
    "CURSOR",
    "CUSTOMDATUM",
    "DANGLING",
    "DATA",
    "DATE",
    "DATE_BASE",
    "DAY",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DEFINE",
    "DELETE",
    "DESC",
    "DETERMINISTIC",
    "DISTINCT",
    "DOUBLE",
    "DROP",
    "DURATION",
    "ELEMENT",
    "ELSE",
    "ELSIF",
    "EMPTY",
    "END",
    "ESCAPE",
    "EXCEPT",
    "EXCEPTION",
    "EXCEPTIONS",
    "EXCLUSIVE",
    "EXECUTE",
    "EXISTS",
    "EXIT",
    "EXTERNAL",
    "FETCH",
    "FINAL",
    "FIXED",
    "FLOAT",
    "FOR",
    "FORALL",
    "FORCE",
    "FORM",
    "FROM",
    "FUNCTION",
    "GENERAL",
    "GOTO",
    "GRANT",
    "GROUP",
    "HASH",
    "HAVING",
    "HEAP",
    "HIDDEN",
    "HOUR",
    "IDENTIFIED",
    "IF",
    "IMMEDIATE",
    "IN",
    "INCLUDING",
    "INDEX",
    "INDEXES",
    "INDICATOR",
    "INDICES",
    "INFINITE",
    "INSERT",
    "INSTANTIABLE",
    "INT",
    "INTERFACE",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "INVALIDATE",
    "IS",
    "ISOLATION",
    "JAVA",
    "LANGUAGE",
    "LARGE",
    "LEADING",
    "LENGTH",
    "LEVEL",
    "LIBRARY",
    "LIKE",
    "LIKE2",
    "LIKE4",
    "LIKEC",
    "LIMIT",
    "LIMITED",
    "LOCAL",
    "LOCK",
    "LONG",
    "LOOP",
    "MAP",
    "MAX",
    "MAXLEN",
    "MEMBER",
    "MERGE",
    "MIN",
    "MINUS",
    "MINUTE",
    "MOD",
    "MODE",
    "MODIFY",
    "MONTH",
    "MULTISET",
    "NAME",
    "NAN",
    "NATIONAL",
    "NATIVE",
    "NCHAR",
    "NEW",
    "NOCOMPRESS",
    "NOCOPY",
    "NOT",
    "NOWAIT",
    "NULL",
    "NUMBER_BASE",
    "OBJECT",
    "OCICOLL",
    "OCIDATE",
    "OCIDATETIME",
    "OCIDURATION",
    "OCIINTERVAL",
    "OCILOBLOCATOR",
    "OCINUMBER",
    "OCIRAW",
    "OCIREF",
    "OCIREFCURSOR",
    "OCIROWID",
    "OCISTRING",
    "OCITYPE",
    "OF",
    "ON",
    "ONLY",
    "OPAQUE",
    "OPEN",
    "OPERATOR",
    "OPTION",
    "OR",
    "ORACLE",
    "ORADATA",
    "ORDER",
    "OVERLAPS",
    "ORGANIZATION",
    "ORLANY",
    "ORLVARY",
    "OTHERS",
    "OUT",
    "OVERRIDING",
    "PACKAGE",
    "PARALLEL_ENABLE",
    "PARAMETER",
    "PARAMETERS",
    "PARTITION",
    "PASCAL",
    "PIPE",
    "PIPELINED",
    "PRAGMA",
    "PRECISION",
    "PRIOR",
    "PRIVATE",
    "PROCEDURE",
    "PUBLIC",
    "RAISE",
    "RANGE",
    "RAW",
    "READ",
    "RECORD",
    "REF",
    "REFERENCE",
    "REM",
    "REMAINDER",
    "RENAME",
    "RESOURCE",
    "RESULT",
    "RETURN",
    "RETURNING",
    "REVERSE",
    "REVOKE",
    "ROLLBACK",
    "ROW",
    "SAMPLE",
    "SAVE",
    "SAVEPOINT",
    "SB1",
    "SB2",
    "SB4",
    "SECOND",
    "SEGMENT",
    "SELECT",
    "SELF",
    "SEPARATE",
    "SEQUENCE",
    "SERIALIZABLE",
    "SET",
    "SHARE",
    "SHORT",
    "SIZE",
    "SIZE_T",
    "SOME",
    "SPARSE",
    "SQL",
    "SQLCODE",
    "SQLDATA",
    "SQLNAME",
    "SQLSTATE",
    "STANDARD",
    "START",
    "STATIC",
    "STDDEV",
    "STORED",
    "STRING",
    "STRUCT",
    "STYLE",
    "SUBMULTISET",
    "SUBPARTITION",
    "SUBSTITUTABLE",
    "SUBTYPE",
    "SUM",
    "SYNONYM",
    "TABAUTH",
    "TABLE",
    "TDO",
    "THE",
    "THEN",
    "TIME",
    "TIMESTAMP",
    "TIMEZONE_ABBR",
    "TIMEZONE_HOUR",
    "TIMEZONE_MINUTE",
    "TIMEZONE_REGION",
    "TO",
    "TRAILING",
    "TRANSAC",
    "TRANSACTIONAL",
    "TRUSTED",
    "TYPE",
    "UB1",
    "UB2",
    "UB4",
    "UNDER",
    "UNION",
    "UNIQUE",
    "UNSIGNED",
    "UNTRUSTED",
    "UPDATE",
    "USE",
    "USING",
    "VALIST",
    "VALUE",
    "VALUES",
    "VARIABLE",
    "VARIANCE",
    "VARRAY",
    "VARYING",
    "VIEW",
    "VIEWS",
    "VOID",
    "WHEN",
    "WHERE",
    "WHILE",
    "WITH",
    "WORK",
    "WRAPPED",
    "WRITE",
    "YEAR",
    "ZONE"
  ]
}), R3 = ut({
  // https://docs.oracle.com/cd/B19306_01/server.102/b14200/functions001.htm
  numeric: ["ABS", "ACOS", "ASIN", "ATAN", "ATAN2", "BITAND", "CEIL", "COS", "COSH", "EXP", "FLOOR", "LN", "LOG", "MOD", "NANVL", "POWER", "REMAINDER", "ROUND", "SIGN", "SIN", "SINH", "SQRT", "TAN", "TANH", "TRUNC", "WIDTH_BUCKET"],
  character: ["CHR", "CONCAT", "INITCAP", "LOWER", "LPAD", "LTRIM", "NLS_INITCAP", "NLS_LOWER", "NLSSORT", "NLS_UPPER", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPLACE", "RPAD", "RTRIM", "SOUNDEX", "SUBSTR", "TRANSLATE", "TREAT", "TRIM", "UPPER", "NLS_CHARSET_DECL_LEN", "NLS_CHARSET_ID", "NLS_CHARSET_NAME", "ASCII", "INSTR", "LENGTH", "REGEXP_INSTR"],
  datetime: ["ADD_MONTHS", "CURRENT_DATE", "CURRENT_TIMESTAMP", "DBTIMEZONE", "EXTRACT", "FROM_TZ", "LAST_DAY", "LOCALTIMESTAMP", "MONTHS_BETWEEN", "NEW_TIME", "NEXT_DAY", "NUMTODSINTERVAL", "NUMTOYMINTERVAL", "ROUND", "SESSIONTIMEZONE", "SYS_EXTRACT_UTC", "SYSDATE", "SYSTIMESTAMP", "TO_CHAR", "TO_TIMESTAMP", "TO_TIMESTAMP_TZ", "TO_DSINTERVAL", "TO_YMINTERVAL", "TRUNC", "TZ_OFFSET"],
  comparison: ["GREATEST", "LEAST"],
  conversion: ["ASCIISTR", "BIN_TO_NUM", "CAST", "CHARTOROWID", "COMPOSE", "CONVERT", "DECOMPOSE", "HEXTORAW", "NUMTODSINTERVAL", "NUMTOYMINTERVAL", "RAWTOHEX", "RAWTONHEX", "ROWIDTOCHAR", "ROWIDTONCHAR", "SCN_TO_TIMESTAMP", "TIMESTAMP_TO_SCN", "TO_BINARY_DOUBLE", "TO_BINARY_FLOAT", "TO_CHAR", "TO_CLOB", "TO_DATE", "TO_DSINTERVAL", "TO_LOB", "TO_MULTI_BYTE", "TO_NCHAR", "TO_NCLOB", "TO_NUMBER", "TO_DSINTERVAL", "TO_SINGLE_BYTE", "TO_TIMESTAMP", "TO_TIMESTAMP_TZ", "TO_YMINTERVAL", "TO_YMINTERVAL", "TRANSLATE", "UNISTR"],
  largeObject: ["BFILENAME", "EMPTY_BLOB,", "EMPTY_CLOB"],
  collection: ["CARDINALITY", "COLLECT", "POWERMULTISET", "POWERMULTISET_BY_CARDINALITY", "SET"],
  hierarchical: ["SYS_CONNECT_BY_PATH"],
  dataMining: ["CLUSTER_ID", "CLUSTER_PROBABILITY", "CLUSTER_SET", "FEATURE_ID", "FEATURE_SET", "FEATURE_VALUE", "PREDICTION", "PREDICTION_COST", "PREDICTION_DETAILS", "PREDICTION_PROBABILITY", "PREDICTION_SET"],
  xml: ["APPENDCHILDXML", "DELETEXML", "DEPTH", "EXTRACT", "EXISTSNODE", "EXTRACTVALUE", "INSERTCHILDXML", "INSERTXMLBEFORE", "PATH", "SYS_DBURIGEN", "SYS_XMLAGG", "SYS_XMLGEN", "UPDATEXML", "XMLAGG", "XMLCDATA", "XMLCOLATTVAL", "XMLCOMMENT", "XMLCONCAT", "XMLFOREST", "XMLPARSE", "XMLPI", "XMLQUERY", "XMLROOT", "XMLSEQUENCE", "XMLSERIALIZE", "XMLTABLE", "XMLTRANSFORM"],
  encoding: ["DECODE", "DUMP", "ORA_HASH", "VSIZE"],
  nullRelated: ["COALESCE", "LNNVL", "NULLIF", "NVL", "NVL2"],
  env: ["SYS_CONTEXT", "SYS_GUID", "SYS_TYPEID", "UID", "USER", "USERENV"],
  aggregate: ["AVG", "COLLECT", "CORR", "CORR_S", "CORR_K", "COUNT", "COVAR_POP", "COVAR_SAMP", "CUME_DIST", "DENSE_RANK", "FIRST", "GROUP_ID", "GROUPING", "GROUPING_ID", "LAST", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "RANK", "REGR_SLOPE", "REGR_INTERCEPT", "REGR_COUNT", "REGR_R2", "REGR_AVGX", "REGR_AVGY", "REGR_SXX", "REGR_SYY", "REGR_SXY", "STATS_BINOMIAL_TEST", "STATS_CROSSTAB", "STATS_F_TEST", "STATS_KS_TEST", "STATS_MODE", "STATS_MW_TEST", "STATS_ONE_WAY_ANOVA", "STATS_T_TEST_ONE", "STATS_T_TEST_PAIRED", "STATS_T_TEST_INDEP", "STATS_T_TEST_INDEPU", "STATS_WSR_TEST", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "SUM", "VAR_POP", "VAR_SAMP", "VARIANCE"],
  // Windowing functions (minus the ones already listed in aggregates)
  window: ["FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTILE", "RATIO_TO_REPORT", "ROW_NUMBER"],
  objectReference: ["DEREF", "MAKE_REF", "REF", "REFTOHEX", "VALUE"],
  model: ["CV", "ITERATION_NUMBER", "PRESENTNNV", "PRESENTV", "PREVIOUS"],
  // Parameterized data types
  // https://docs.oracle.com/en/database/oracle/oracle-database/19/sqlrf/Data-Types.html
  dataTypes: [
    // Oracle builtin data types
    "VARCHAR2",
    "NVARCHAR2",
    "NUMBER",
    "FLOAT",
    "TIMESTAMP",
    "INTERVAL YEAR",
    "INTERVAL DAY",
    "RAW",
    "UROWID",
    "NCHAR",
    // ANSI Data Types
    "CHARACTER",
    "CHAR",
    "CHARACTER VARYING",
    "CHAR VARYING",
    "NATIONAL CHARACTER",
    "NATIONAL CHAR",
    "NATIONAL CHARACTER VARYING",
    "NATIONAL CHAR VARYING",
    "NCHAR VARYING",
    "NUMERIC",
    "DECIMAL",
    "FLOAT",
    // SQL/DS and DB2 Data Types
    "VARCHAR"
  ]
}), p3 = fe(["SELECT [ALL | DISTINCT | UNIQUE]"]), S3 = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER [SIBLINGS] BY",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  "FOR UPDATE [OF]",
  // Data manipulation
  // - insert:
  "INSERT [INTO | ALL INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [THEN]",
  "UPDATE SET",
  // Data definition
  "CREATE [OR REPLACE] [NO FORCE | FORCE] [EDITIONING | EDITIONABLE | EDITIONABLE EDITIONING | NONEDITIONABLE] VIEW",
  "CREATE MATERIALIZED VIEW",
  "CREATE [GLOBAL TEMPORARY | PRIVATE TEMPORARY | SHARDED | DUPLICATED | IMMUTABLE BLOCKCHAIN | BLOCKCHAIN | IMMUTABLE] TABLE",
  // other
  "RETURNING"
]), wC = fe([
  // - update:
  "UPDATE [ONLY]",
  // - delete:
  "DELETE FROM [ONLY]",
  // - drop table:
  "DROP TABLE",
  // - alter table:
  "ALTER TABLE",
  "ADD",
  "DROP {COLUMN | UNUSED COLUMNS | COLUMNS CONTINUE}",
  "MODIFY",
  "RENAME TO",
  "RENAME COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "SET SCHEMA",
  "BEGIN",
  "CONNECT BY",
  "DECLARE",
  "EXCEPT",
  "EXCEPTION",
  "LOOP",
  "START WITH"
]), h3 = fe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), N3 = fe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN",
  // non-standard joins
  "{CROSS | OUTER} APPLY"
]), O3 = fe(["ON {UPDATE | DELETE} [SET NULL]", "ON COMMIT", "{ROWS | RANGE} BETWEEN"]), I3 = {
  tokenizerOptions: {
    reservedSelect: p3,
    reservedClauses: [...S3, ...wC],
    reservedSetOperations: h3,
    reservedJoins: N3,
    reservedPhrases: O3,
    supportsXor: !0,
    reservedKeywords: A3,
    reservedFunctionNames: R3,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["N"]
    }, {
      quote: "q''",
      prefixes: ["N"]
    }],
    // PL/SQL doesn't actually support escaping of quotes in identifiers,
    // but for the sake of simpler testing we'll support this anyway
    // as all other SQL dialects with "identifiers" do.
    identTypes: ['""-qq'],
    identChars: {
      rest: "$#"
    },
    variableTypes: [{
      regex: "&{1,2}[A-Za-z][A-Za-z0-9_$#]*"
    }],
    paramTypes: {
      numbered: [":"],
      named: [":"]
    },
    paramChars: {},
    // Empty object used on purpose to not allow $ and # chars as specified in identChars
    operators: [
      "**",
      ":=",
      "%",
      "~=",
      "^=",
      // '..', // Conflicts with float followed by dot (so "2..3" gets parsed as ["2.", ".", "3"])
      ">>",
      "<<",
      "=>",
      "@",
      "||"
    ],
    postProcess: _3
  },
  formatOptions: {
    alwaysDenseOperators: ["@"],
    onelineClauses: wC
  }
};
function _3(n) {
  let a = ws;
  return n.map((s) => ki.SET(s) && ki.BY(a) ? {
    ...s,
    type: Ee.RESERVED_KEYWORD
  } : (wv(s.type) && (a = s), s));
}
const C3 = ut({
  // https://www.postgresql.org/docs/14/functions.html
  //
  // https://www.postgresql.org/docs/14/functions-math.html
  math: ["ABS", "ACOS", "ACOSD", "ACOSH", "ASIN", "ASIND", "ASINH", "ATAN", "ATAN2", "ATAN2D", "ATAND", "ATANH", "CBRT", "CEIL", "CEILING", "COS", "COSD", "COSH", "COT", "COTD", "DEGREES", "DIV", "EXP", "FACTORIAL", "FLOOR", "GCD", "LCM", "LN", "LOG", "LOG10", "MIN_SCALE", "MOD", "PI", "POWER", "RADIANS", "RANDOM", "ROUND", "SCALE", "SETSEED", "SIGN", "SIN", "SIND", "SINH", "SQRT", "TAN", "TAND", "TANH", "TRIM_SCALE", "TRUNC", "WIDTH_BUCKET"],
  // https://www.postgresql.org/docs/14/functions-string.html
  string: ["ABS", "ASCII", "BIT_LENGTH", "BTRIM", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHR", "CONCAT", "CONCAT_WS", "FORMAT", "INITCAP", "LEFT", "LENGTH", "LOWER", "LPAD", "LTRIM", "MD5", "NORMALIZE", "OCTET_LENGTH", "OVERLAY", "PARSE_IDENT", "PG_CLIENT_ENCODING", "POSITION", "QUOTE_IDENT", "QUOTE_LITERAL", "QUOTE_NULLABLE", "REGEXP_MATCH", "REGEXP_MATCHES", "REGEXP_REPLACE", "REGEXP_SPLIT_TO_ARRAY", "REGEXP_SPLIT_TO_TABLE", "REPEAT", "REPLACE", "REVERSE", "RIGHT", "RPAD", "RTRIM", "SPLIT_PART", "SPRINTF", "STARTS_WITH", "STRING_AGG", "STRING_TO_ARRAY", "STRING_TO_TABLE", "STRPOS", "SUBSTR", "SUBSTRING", "TO_ASCII", "TO_HEX", "TRANSLATE", "TRIM", "UNISTR", "UPPER"],
  // https://www.postgresql.org/docs/14/functions-binarystring.html
  binary: ["BIT_COUNT", "BIT_LENGTH", "BTRIM", "CONVERT", "CONVERT_FROM", "CONVERT_TO", "DECODE", "ENCODE", "GET_BIT", "GET_BYTE", "LENGTH", "LTRIM", "MD5", "OCTET_LENGTH", "OVERLAY", "POSITION", "RTRIM", "SET_BIT", "SET_BYTE", "SHA224", "SHA256", "SHA384", "SHA512", "STRING_AGG", "SUBSTR", "SUBSTRING", "TRIM"],
  // https://www.postgresql.org/docs/14/functions-bitstring.html
  bitstring: ["BIT_COUNT", "BIT_LENGTH", "GET_BIT", "LENGTH", "OCTET_LENGTH", "OVERLAY", "POSITION", "SET_BIT", "SUBSTRING"],
  // https://www.postgresql.org/docs/14/functions-matching.html
  pattern: ["REGEXP_MATCH", "REGEXP_MATCHES", "REGEXP_REPLACE", "REGEXP_SPLIT_TO_ARRAY", "REGEXP_SPLIT_TO_TABLE"],
  // https://www.postgresql.org/docs/14/functions-formatting.html
  datatype: ["TO_CHAR", "TO_DATE", "TO_NUMBER", "TO_TIMESTAMP"],
  // https://www.postgresql.org/docs/14/functions-datetime.html
  datetime: [
    // 'AGE',
    "CLOCK_TIMESTAMP",
    "CURRENT_DATE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "DATE_BIN",
    "DATE_PART",
    "DATE_TRUNC",
    "EXTRACT",
    "ISFINITE",
    "JUSTIFY_DAYS",
    "JUSTIFY_HOURS",
    "JUSTIFY_INTERVAL",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "MAKE_DATE",
    "MAKE_INTERVAL",
    "MAKE_TIME",
    "MAKE_TIMESTAMP",
    "MAKE_TIMESTAMPTZ",
    "NOW",
    "PG_SLEEP",
    "PG_SLEEP_FOR",
    "PG_SLEEP_UNTIL",
    "STATEMENT_TIMESTAMP",
    "TIMEOFDAY",
    "TO_TIMESTAMP",
    "TRANSACTION_TIMESTAMP"
  ],
  // https://www.postgresql.org/docs/14/functions-enum.html
  enum: ["ENUM_FIRST", "ENUM_LAST", "ENUM_RANGE"],
  // https://www.postgresql.org/docs/14/functions-geometry.html
  geometry: ["AREA", "BOUND_BOX", "BOX", "CENTER", "CIRCLE", "DIAGONAL", "DIAMETER", "HEIGHT", "ISCLOSED", "ISOPEN", "LENGTH", "LINE", "LSEG", "NPOINTS", "PATH", "PCLOSE", "POINT", "POLYGON", "POPEN", "RADIUS", "SLOPE", "WIDTH"],
  // https://www.postgresql.org/docs/14/functions-net.html
  network: ["ABBREV", "BROADCAST", "FAMILY", "HOST", "HOSTMASK", "INET_MERGE", "INET_SAME_FAMILY", "MACADDR8_SET7BIT", "MASKLEN", "NETMASK", "NETWORK", "SET_MASKLEN", "TEXT", "TRUNC"],
  // https://www.postgresql.org/docs/14/functions-textsearch.html
  textsearch: ["ARRAY_TO_TSVECTOR", "GET_CURRENT_TS_CONFIG", "JSONB_TO_TSVECTOR", "JSON_TO_TSVECTOR", "LENGTH", "NUMNODE", "PHRASETO_TSQUERY", "PLAINTO_TSQUERY", "QUERYTREE", "SETWEIGHT", "STRIP", "TO_TSQUERY", "TO_TSVECTOR", "TSQUERY_PHRASE", "TSVECTOR_TO_ARRAY", "TS_DEBUG", "TS_DELETE", "TS_FILTER", "TS_HEADLINE", "TS_LEXIZE", "TS_PARSE", "TS_RANK", "TS_RANK_CD", "TS_REWRITE", "TS_STAT", "TS_TOKEN_TYPE", "WEBSEARCH_TO_TSQUERY"],
  // https://www.postgresql.org/docs/14/functions-uuid.html
  uuid: ["UUID"],
  // https://www.postgresql.org/docs/14/functions-xml.html
  xml: ["CURSOR_TO_XML", "CURSOR_TO_XMLSCHEMA", "DATABASE_TO_XML", "DATABASE_TO_XMLSCHEMA", "DATABASE_TO_XML_AND_XMLSCHEMA", "NEXTVAL", "QUERY_TO_XML", "QUERY_TO_XMLSCHEMA", "QUERY_TO_XML_AND_XMLSCHEMA", "SCHEMA_TO_XML", "SCHEMA_TO_XMLSCHEMA", "SCHEMA_TO_XML_AND_XMLSCHEMA", "STRING", "TABLE_TO_XML", "TABLE_TO_XMLSCHEMA", "TABLE_TO_XML_AND_XMLSCHEMA", "XMLAGG", "XMLCOMMENT", "XMLCONCAT", "XMLELEMENT", "XMLEXISTS", "XMLFOREST", "XMLPARSE", "XMLPI", "XMLROOT", "XMLSERIALIZE", "XMLTABLE", "XML_IS_WELL_FORMED", "XML_IS_WELL_FORMED_CONTENT", "XML_IS_WELL_FORMED_DOCUMENT", "XPATH", "XPATH_EXISTS"],
  // https://www.postgresql.org/docs/14/functions-json.html
  json: ["ARRAY_TO_JSON", "JSONB_AGG", "JSONB_ARRAY_ELEMENTS", "JSONB_ARRAY_ELEMENTS_TEXT", "JSONB_ARRAY_LENGTH", "JSONB_BUILD_ARRAY", "JSONB_BUILD_OBJECT", "JSONB_EACH", "JSONB_EACH_TEXT", "JSONB_EXTRACT_PATH", "JSONB_EXTRACT_PATH_TEXT", "JSONB_INSERT", "JSONB_OBJECT", "JSONB_OBJECT_AGG", "JSONB_OBJECT_KEYS", "JSONB_PATH_EXISTS", "JSONB_PATH_EXISTS_TZ", "JSONB_PATH_MATCH", "JSONB_PATH_MATCH_TZ", "JSONB_PATH_QUERY", "JSONB_PATH_QUERY_ARRAY", "JSONB_PATH_QUERY_ARRAY_TZ", "JSONB_PATH_QUERY_FIRST", "JSONB_PATH_QUERY_FIRST_TZ", "JSONB_PATH_QUERY_TZ", "JSONB_POPULATE_RECORD", "JSONB_POPULATE_RECORDSET", "JSONB_PRETTY", "JSONB_SET", "JSONB_SET_LAX", "JSONB_STRIP_NULLS", "JSONB_TO_RECORD", "JSONB_TO_RECORDSET", "JSONB_TYPEOF", "JSON_AGG", "JSON_ARRAY_ELEMENTS", "JSON_ARRAY_ELEMENTS_TEXT", "JSON_ARRAY_LENGTH", "JSON_BUILD_ARRAY", "JSON_BUILD_OBJECT", "JSON_EACH", "JSON_EACH_TEXT", "JSON_EXTRACT_PATH", "JSON_EXTRACT_PATH_TEXT", "JSON_OBJECT", "JSON_OBJECT_AGG", "JSON_OBJECT_KEYS", "JSON_POPULATE_RECORD", "JSON_POPULATE_RECORDSET", "JSON_STRIP_NULLS", "JSON_TO_RECORD", "JSON_TO_RECORDSET", "JSON_TYPEOF", "ROW_TO_JSON", "TO_JSON", "TO_JSONB", "TO_TIMESTAMP"],
  // https://www.postgresql.org/docs/14/functions-sequence.html
  sequence: ["CURRVAL", "LASTVAL", "NEXTVAL", "SETVAL"],
  // https://www.postgresql.org/docs/14/functions-conditional.html
  conditional: [
    // 'CASE',
    "COALESCE",
    "GREATEST",
    "LEAST",
    "NULLIF"
  ],
  // https://www.postgresql.org/docs/14/functions-array.html
  array: ["ARRAY_AGG", "ARRAY_APPEND", "ARRAY_CAT", "ARRAY_DIMS", "ARRAY_FILL", "ARRAY_LENGTH", "ARRAY_LOWER", "ARRAY_NDIMS", "ARRAY_POSITION", "ARRAY_POSITIONS", "ARRAY_PREPEND", "ARRAY_REMOVE", "ARRAY_REPLACE", "ARRAY_TO_STRING", "ARRAY_UPPER", "CARDINALITY", "STRING_TO_ARRAY", "TRIM_ARRAY", "UNNEST"],
  // https://www.postgresql.org/docs/14/functions-range.html
  range: ["ISEMPTY", "LOWER", "LOWER_INC", "LOWER_INF", "MULTIRANGE", "RANGE_MERGE", "UPPER", "UPPER_INC", "UPPER_INF"],
  // https://www.postgresql.org/docs/14/functions-aggregate.html
  aggregate: [
    // 'ANY',
    "ARRAY_AGG",
    "AVG",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "BOOL_AND",
    "BOOL_OR",
    "COALESCE",
    "CORR",
    "COUNT",
    "COVAR_POP",
    "COVAR_SAMP",
    "CUME_DIST",
    "DENSE_RANK",
    "EVERY",
    "GROUPING",
    "JSONB_AGG",
    "JSONB_OBJECT_AGG",
    "JSON_AGG",
    "JSON_OBJECT_AGG",
    "MAX",
    "MIN",
    "MODE",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "PERCENT_RANK",
    "RANGE_AGG",
    "RANGE_INTERSECT_AGG",
    "RANK",
    "REGR_AVGX",
    "REGR_AVGY",
    "REGR_COUNT",
    "REGR_INTERCEPT",
    "REGR_R2",
    "REGR_SLOPE",
    "REGR_SXX",
    "REGR_SXY",
    "REGR_SYY",
    // 'SOME',
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STRING_AGG",
    "SUM",
    "TO_JSON",
    "TO_JSONB",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "XMLAGG"
  ],
  // https://www.postgresql.org/docs/14/functions-window.html
  window: ["CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "RANK", "ROW_NUMBER"],
  // https://www.postgresql.org/docs/14/functions-srf.html
  set: ["GENERATE_SERIES", "GENERATE_SUBSCRIPTS"],
  // https://www.postgresql.org/docs/14/functions-info.html
  sysInfo: ["ACLDEFAULT", "ACLEXPLODE", "COL_DESCRIPTION", "CURRENT_CATALOG", "CURRENT_DATABASE", "CURRENT_QUERY", "CURRENT_ROLE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_USER", "FORMAT_TYPE", "HAS_ANY_COLUMN_PRIVILEGE", "HAS_COLUMN_PRIVILEGE", "HAS_DATABASE_PRIVILEGE", "HAS_FOREIGN_DATA_WRAPPER_PRIVILEGE", "HAS_FUNCTION_PRIVILEGE", "HAS_LANGUAGE_PRIVILEGE", "HAS_SCHEMA_PRIVILEGE", "HAS_SEQUENCE_PRIVILEGE", "HAS_SERVER_PRIVILEGE", "HAS_TABLESPACE_PRIVILEGE", "HAS_TABLE_PRIVILEGE", "HAS_TYPE_PRIVILEGE", "INET_CLIENT_ADDR", "INET_CLIENT_PORT", "INET_SERVER_ADDR", "INET_SERVER_PORT", "MAKEACLITEM", "OBJ_DESCRIPTION", "PG_BACKEND_PID", "PG_BLOCKING_PIDS", "PG_COLLATION_IS_VISIBLE", "PG_CONF_LOAD_TIME", "PG_CONTROL_CHECKPOINT", "PG_CONTROL_INIT", "PG_CONTROL_SYSTEM", "PG_CONVERSION_IS_VISIBLE", "PG_CURRENT_LOGFILE", "PG_CURRENT_SNAPSHOT", "PG_CURRENT_XACT_ID", "PG_CURRENT_XACT_ID_IF_ASSIGNED", "PG_DESCRIBE_OBJECT", "PG_FUNCTION_IS_VISIBLE", "PG_GET_CATALOG_FOREIGN_KEYS", "PG_GET_CONSTRAINTDEF", "PG_GET_EXPR", "PG_GET_FUNCTIONDEF", "PG_GET_FUNCTION_ARGUMENTS", "PG_GET_FUNCTION_IDENTITY_ARGUMENTS", "PG_GET_FUNCTION_RESULT", "PG_GET_INDEXDEF", "PG_GET_KEYWORDS", "PG_GET_OBJECT_ADDRESS", "PG_GET_OWNED_SEQUENCE", "PG_GET_RULEDEF", "PG_GET_SERIAL_SEQUENCE", "PG_GET_STATISTICSOBJDEF", "PG_GET_TRIGGERDEF", "PG_GET_USERBYID", "PG_GET_VIEWDEF", "PG_HAS_ROLE", "PG_IDENTIFY_OBJECT", "PG_IDENTIFY_OBJECT_AS_ADDRESS", "PG_INDEXAM_HAS_PROPERTY", "PG_INDEX_COLUMN_HAS_PROPERTY", "PG_INDEX_HAS_PROPERTY", "PG_IS_OTHER_TEMP_SCHEMA", "PG_JIT_AVAILABLE", "PG_LAST_COMMITTED_XACT", "PG_LISTENING_CHANNELS", "PG_MY_TEMP_SCHEMA", "PG_NOTIFICATION_QUEUE_USAGE", "PG_OPCLASS_IS_VISIBLE", "PG_OPERATOR_IS_VISIBLE", "PG_OPFAMILY_IS_VISIBLE", "PG_OPTIONS_TO_TABLE", "PG_POSTMASTER_START_TIME", "PG_SAFE_SNAPSHOT_BLOCKING_PIDS", "PG_SNAPSHOT_XIP", "PG_SNAPSHOT_XMAX", "PG_SNAPSHOT_XMIN", "PG_STATISTICS_OBJ_IS_VISIBLE", "PG_TABLESPACE_DATABASES", "PG_TABLESPACE_LOCATION", "PG_TABLE_IS_VISIBLE", "PG_TRIGGER_DEPTH", "PG_TS_CONFIG_IS_VISIBLE", "PG_TS_DICT_IS_VISIBLE", "PG_TS_PARSER_IS_VISIBLE", "PG_TS_TEMPLATE_IS_VISIBLE", "PG_TYPEOF", "PG_TYPE_IS_VISIBLE", "PG_VISIBLE_IN_SNAPSHOT", "PG_XACT_COMMIT_TIMESTAMP", "PG_XACT_COMMIT_TIMESTAMP_ORIGIN", "PG_XACT_STATUS", "PQSERVERVERSION", "ROW_SECURITY_ACTIVE", "SESSION_USER", "SHOBJ_DESCRIPTION", "TO_REGCLASS", "TO_REGCOLLATION", "TO_REGNAMESPACE", "TO_REGOPER", "TO_REGOPERATOR", "TO_REGPROC", "TO_REGPROCEDURE", "TO_REGROLE", "TO_REGTYPE", "TXID_CURRENT", "TXID_CURRENT_IF_ASSIGNED", "TXID_CURRENT_SNAPSHOT", "TXID_SNAPSHOT_XIP", "TXID_SNAPSHOT_XMAX", "TXID_SNAPSHOT_XMIN", "TXID_STATUS", "TXID_VISIBLE_IN_SNAPSHOT", "USER", "VERSION"],
  // https://www.postgresql.org/docs/14/functions-admin.html
  sysAdmin: ["BRIN_DESUMMARIZE_RANGE", "BRIN_SUMMARIZE_NEW_VALUES", "BRIN_SUMMARIZE_RANGE", "CONVERT_FROM", "CURRENT_SETTING", "GIN_CLEAN_PENDING_LIST", "PG_ADVISORY_LOCK", "PG_ADVISORY_LOCK_SHARED", "PG_ADVISORY_UNLOCK", "PG_ADVISORY_UNLOCK_ALL", "PG_ADVISORY_UNLOCK_SHARED", "PG_ADVISORY_XACT_LOCK", "PG_ADVISORY_XACT_LOCK_SHARED", "PG_BACKUP_START_TIME", "PG_CANCEL_BACKEND", "PG_COLLATION_ACTUAL_VERSION", "PG_COLUMN_COMPRESSION", "PG_COLUMN_SIZE", "PG_COPY_LOGICAL_REPLICATION_SLOT", "PG_COPY_PHYSICAL_REPLICATION_SLOT", "PG_CREATE_LOGICAL_REPLICATION_SLOT", "PG_CREATE_PHYSICAL_REPLICATION_SLOT", "PG_CREATE_RESTORE_POINT", "PG_CURRENT_WAL_FLUSH_LSN", "PG_CURRENT_WAL_INSERT_LSN", "PG_CURRENT_WAL_LSN", "PG_DATABASE_SIZE", "PG_DROP_REPLICATION_SLOT", "PG_EXPORT_SNAPSHOT", "PG_FILENODE_RELATION", "PG_GET_WAL_REPLAY_PAUSE_STATE", "PG_IMPORT_SYSTEM_COLLATIONS", "PG_INDEXES_SIZE", "PG_IS_IN_BACKUP", "PG_IS_IN_RECOVERY", "PG_IS_WAL_REPLAY_PAUSED", "PG_LAST_WAL_RECEIVE_LSN", "PG_LAST_WAL_REPLAY_LSN", "PG_LAST_XACT_REPLAY_TIMESTAMP", "PG_LOGICAL_EMIT_MESSAGE", "PG_LOGICAL_SLOT_GET_BINARY_CHANGES", "PG_LOGICAL_SLOT_GET_CHANGES", "PG_LOGICAL_SLOT_PEEK_BINARY_CHANGES", "PG_LOGICAL_SLOT_PEEK_CHANGES", "PG_LOG_BACKEND_MEMORY_CONTEXTS", "PG_LS_ARCHIVE_STATUSDIR", "PG_LS_DIR", "PG_LS_LOGDIR", "PG_LS_TMPDIR", "PG_LS_WALDIR", "PG_PARTITION_ANCESTORS", "PG_PARTITION_ROOT", "PG_PARTITION_TREE", "PG_PROMOTE", "PG_READ_BINARY_FILE", "PG_READ_FILE", "PG_RELATION_FILENODE", "PG_RELATION_FILEPATH", "PG_RELATION_SIZE", "PG_RELOAD_CONF", "PG_REPLICATION_ORIGIN_ADVANCE", "PG_REPLICATION_ORIGIN_CREATE", "PG_REPLICATION_ORIGIN_DROP", "PG_REPLICATION_ORIGIN_OID", "PG_REPLICATION_ORIGIN_PROGRESS", "PG_REPLICATION_ORIGIN_SESSION_IS_SETUP", "PG_REPLICATION_ORIGIN_SESSION_PROGRESS", "PG_REPLICATION_ORIGIN_SESSION_RESET", "PG_REPLICATION_ORIGIN_SESSION_SETUP", "PG_REPLICATION_ORIGIN_XACT_RESET", "PG_REPLICATION_ORIGIN_XACT_SETUP", "PG_REPLICATION_SLOT_ADVANCE", "PG_ROTATE_LOGFILE", "PG_SIZE_BYTES", "PG_SIZE_PRETTY", "PG_START_BACKUP", "PG_STAT_FILE", "PG_STOP_BACKUP", "PG_SWITCH_WAL", "PG_TABLESPACE_SIZE", "PG_TABLE_SIZE", "PG_TERMINATE_BACKEND", "PG_TOTAL_RELATION_SIZE", "PG_TRY_ADVISORY_LOCK", "PG_TRY_ADVISORY_LOCK_SHARED", "PG_TRY_ADVISORY_XACT_LOCK", "PG_TRY_ADVISORY_XACT_LOCK_SHARED", "PG_WALFILE_NAME", "PG_WALFILE_NAME_OFFSET", "PG_WAL_LSN_DIFF", "PG_WAL_REPLAY_PAUSE", "PG_WAL_REPLAY_RESUME", "SET_CONFIG"],
  // https://www.postgresql.org/docs/14/functions-trigger.html
  trigger: ["SUPPRESS_REDUNDANT_UPDATES_TRIGGER", "TSVECTOR_UPDATE_TRIGGER", "TSVECTOR_UPDATE_TRIGGER_COLUMN"],
  // https://www.postgresql.org/docs/14/functions-event-triggers.html
  eventTrigger: ["PG_EVENT_TRIGGER_DDL_COMMANDS", "PG_EVENT_TRIGGER_DROPPED_OBJECTS", "PG_EVENT_TRIGGER_TABLE_REWRITE_OID", "PG_EVENT_TRIGGER_TABLE_REWRITE_REASON", "PG_GET_OBJECT_ADDRESS"],
  // https://www.postgresql.org/docs/14/functions-statistics.html
  stats: ["PG_MCV_LIST_ITEMS"],
  cast: ["CAST"],
  // Parameterized data types
  // https://www.postgresql.org/docs/current/datatype.html
  dataTypes: ["BIT", "BIT VARYING", "CHARACTER", "CHARACTER VARYING", "VARCHAR", "CHAR", "DECIMAL", "NUMERIC", "TIME", "TIMESTAMP", "ENUM"]
}), m3 = ut({
  // https://www.postgresql.org/docs/14/sql-keywords-appendix.html
  all: [
    "ABORT",
    "ABSOLUTE",
    "ACCESS",
    "ACTION",
    "ADD",
    "ADMIN",
    "AFTER",
    "AGGREGATE",
    "ALL",
    // reserved
    "ALSO",
    "ALTER",
    "ALWAYS",
    "ANALYSE",
    // reserved
    "ANALYZE",
    // reserved
    "AND",
    // reserved
    "ANY",
    // reserved
    "ARRAY",
    // reserved, requires AS
    "AS",
    // reserved, requires AS
    "ASC",
    // reserved
    "ASENSITIVE",
    "ASSERTION",
    "ASSIGNMENT",
    "ASYMMETRIC",
    // reserved
    "AT",
    "ATOMIC",
    "ATTACH",
    "ATTRIBUTE",
    "AUTHORIZATION",
    // reserved (can be function or type)
    "BACKWARD",
    "BEFORE",
    "BEGIN",
    "BETWEEN",
    // (cannot be function or type)
    "BIGINT",
    // (cannot be function or type)
    "BINARY",
    // reserved (can be function or type)
    "BIT",
    // (cannot be function or type)
    "BOOLEAN",
    // (cannot be function or type)
    "BOTH",
    // reserved
    "BREADTH",
    "BY",
    "CACHE",
    "CALL",
    "CALLED",
    "CASCADE",
    "CASCADED",
    "CASE",
    // reserved
    "CAST",
    // reserved
    "CATALOG",
    "CHAIN",
    "CHAR",
    // (cannot be function or type), requires AS
    "CHARACTER",
    // (cannot be function or type), requires AS
    "CHARACTERISTICS",
    "CHECK",
    // reserved
    "CHECKPOINT",
    "CLASS",
    "CLOSE",
    "CLUSTER",
    "COALESCE",
    // (cannot be function or type)
    "COLLATE",
    // reserved
    "COLLATION",
    // reserved (can be function or type)
    "COLUMN",
    // reserved
    "COLUMNS",
    "COMMENT",
    "COMMENTS",
    "COMMIT",
    "COMMITTED",
    "COMPRESSION",
    "CONCURRENTLY",
    // reserved (can be function or type)
    "CONFIGURATION",
    "CONFLICT",
    "CONNECTION",
    "CONSTRAINT",
    // reserved
    "CONSTRAINTS",
    "CONTENT",
    "CONTINUE",
    "CONVERSION",
    "COPY",
    "COST",
    "CREATE",
    // reserved, requires AS
    "CROSS",
    // reserved (can be function or type)
    "CSV",
    "CUBE",
    "CURRENT",
    "CURRENT_CATALOG",
    // reserved
    "CURRENT_DATE",
    // reserved
    "CURRENT_ROLE",
    // reserved
    "CURRENT_SCHEMA",
    // reserved (can be function or type)
    "CURRENT_TIME",
    // reserved
    "CURRENT_TIMESTAMP",
    // reserved
    "CURRENT_USER",
    // reserved
    "CURSOR",
    "CYCLE",
    "DATA",
    "DATABASE",
    "DAY",
    // requires AS
    "DEALLOCATE",
    "DEC",
    // (cannot be function or type)
    "DECIMAL",
    // (cannot be function or type)
    "DECLARE",
    "DEFAULT",
    // reserved
    "DEFAULTS",
    "DEFERRABLE",
    // reserved
    "DEFERRED",
    "DEFINER",
    "DELETE",
    "DELIMITER",
    "DELIMITERS",
    "DEPENDS",
    "DEPTH",
    "DESC",
    // reserved
    "DETACH",
    "DICTIONARY",
    "DISABLE",
    "DISCARD",
    "DISTINCT",
    // reserved
    "DO",
    // reserved
    "DOCUMENT",
    "DOMAIN",
    "DOUBLE",
    "DROP",
    "EACH",
    "ELSE",
    // reserved
    "ENABLE",
    "ENCODING",
    "ENCRYPTED",
    "END",
    // reserved
    "ENUM",
    "ESCAPE",
    "EVENT",
    "EXCEPT",
    // reserved, requires AS
    "EXCLUDE",
    "EXCLUDING",
    "EXCLUSIVE",
    "EXECUTE",
    "EXISTS",
    // (cannot be function or type)
    "EXPLAIN",
    "EXPRESSION",
    "EXTENSION",
    "EXTERNAL",
    "EXTRACT",
    // (cannot be function or type)
    "FALSE",
    // reserved
    "FAMILY",
    "FETCH",
    // reserved, requires AS
    "FILTER",
    // requires AS
    "FINALIZE",
    "FIRST",
    "FLOAT",
    // (cannot be function or type)
    "FOLLOWING",
    "FOR",
    // reserved, requires AS
    "FORCE",
    "FOREIGN",
    // reserved
    "FORWARD",
    "FREEZE",
    // reserved (can be function or type)
    "FROM",
    // reserved, requires AS
    "FULL",
    // reserved (can be function or type)
    "FUNCTION",
    "FUNCTIONS",
    "GENERATED",
    "GLOBAL",
    "GRANT",
    // reserved, requires AS
    "GRANTED",
    "GREATEST",
    // (cannot be function or type)
    "GROUP",
    // reserved, requires AS
    "GROUPING",
    // (cannot be function or type)
    "GROUPS",
    "HANDLER",
    "HAVING",
    // reserved, requires AS
    "HEADER",
    "HOLD",
    "HOUR",
    // requires AS
    "IDENTITY",
    "IF",
    "ILIKE",
    // reserved (can be function or type)
    "IMMEDIATE",
    "IMMUTABLE",
    "IMPLICIT",
    "IMPORT",
    "IN",
    // reserved
    "INCLUDE",
    "INCLUDING",
    "INCREMENT",
    "INDEX",
    "INDEXES",
    "INHERIT",
    "INHERITS",
    "INITIALLY",
    // reserved
    "INLINE",
    "INNER",
    // reserved (can be function or type)
    "INOUT",
    // (cannot be function or type)
    "INPUT",
    "INSENSITIVE",
    "INSERT",
    "INSTEAD",
    "INT",
    // (cannot be function or type)
    "INTEGER",
    // (cannot be function or type)
    "INTERSECT",
    // reserved, requires AS
    "INTERVAL",
    // (cannot be function or type)
    "INTO",
    // reserved, requires AS
    "INVOKER",
    "IS",
    // reserved (can be function or type)
    "ISNULL",
    // reserved (can be function or type), requires AS
    "ISOLATION",
    "JOIN",
    // reserved (can be function or type)
    "KEY",
    "LABEL",
    "LANGUAGE",
    "LARGE",
    "LAST",
    "LATERAL",
    // reserved
    "LEADING",
    // reserved
    "LEAKPROOF",
    "LEAST",
    // (cannot be function or type)
    "LEFT",
    // reserved (can be function or type)
    "LEVEL",
    "LIKE",
    // reserved (can be function or type)
    "LIMIT",
    // reserved, requires AS
    "LISTEN",
    "LOAD",
    "LOCAL",
    "LOCALTIME",
    // reserved
    "LOCALTIMESTAMP",
    // reserved
    "LOCATION",
    "LOCK",
    "LOCKED",
    "LOGGED",
    "MAPPING",
    "MATCH",
    "MATERIALIZED",
    "MAXVALUE",
    "METHOD",
    "MINUTE",
    // requires AS
    "MINVALUE",
    "MODE",
    "MONTH",
    // requires AS
    "MOVE",
    "NAME",
    "NAMES",
    "NATIONAL",
    // (cannot be function or type)
    "NATURAL",
    // reserved (can be function or type)
    "NCHAR",
    // (cannot be function or type)
    "NEW",
    "NEXT",
    "NFC",
    "NFD",
    "NFKC",
    "NFKD",
    "NO",
    "NONE",
    // (cannot be function or type)
    "NORMALIZE",
    // (cannot be function or type)
    "NORMALIZED",
    "NOT",
    // reserved
    "NOTHING",
    "NOTIFY",
    "NOTNULL",
    // reserved (can be function or type), requires AS
    "NOWAIT",
    "NULL",
    // reserved
    "NULLIF",
    // (cannot be function or type)
    "NULLS",
    "NUMERIC",
    // (cannot be function or type)
    "OBJECT",
    "OF",
    "OFF",
    "OFFSET",
    // reserved, requires AS
    "OIDS",
    "OLD",
    "ON",
    // reserved, requires AS
    "ONLY",
    // reserved
    "OPERATOR",
    "OPTION",
    "OPTIONS",
    "OR",
    // reserved
    "ORDER",
    // reserved, requires AS
    "ORDINALITY",
    "OTHERS",
    "OUT",
    // (cannot be function or type)
    "OUTER",
    // reserved (can be function or type)
    "OVER",
    // requires AS
    "OVERLAPS",
    // reserved (can be function or type), requires AS
    "OVERLAY",
    // (cannot be function or type)
    "OVERRIDING",
    "OWNED",
    "OWNER",
    "PARALLEL",
    "PARSER",
    "PARTIAL",
    "PARTITION",
    "PASSING",
    "PASSWORD",
    "PLACING",
    // reserved
    "PLANS",
    "POLICY",
    "POSITION",
    // (cannot be function or type)
    "PRECEDING",
    "PRECISION",
    // (cannot be function or type), requires AS
    "PREPARE",
    "PREPARED",
    "PRESERVE",
    "PRIMARY",
    // reserved
    "PRIOR",
    "PRIVILEGES",
    "PROCEDURAL",
    "PROCEDURE",
    "PROCEDURES",
    "PROGRAM",
    "PUBLICATION",
    "QUOTE",
    "RANGE",
    "READ",
    "REAL",
    // (cannot be function or type)
    "REASSIGN",
    "RECHECK",
    "RECURSIVE",
    "REF",
    "REFERENCES",
    // reserved
    "REFERENCING",
    "REFRESH",
    "REINDEX",
    "RELATIVE",
    "RELEASE",
    "RENAME",
    "REPEATABLE",
    "REPLACE",
    "REPLICA",
    "RESET",
    "RESTART",
    "RESTRICT",
    "RETURN",
    "RETURNING",
    // reserved, requires AS
    "RETURNS",
    "REVOKE",
    "RIGHT",
    // reserved (can be function or type)
    "ROLE",
    "ROLLBACK",
    "ROLLUP",
    "ROUTINE",
    "ROUTINES",
    "ROW",
    // (cannot be function or type)
    "ROWS",
    "RULE",
    "SAVEPOINT",
    "SCHEMA",
    "SCHEMAS",
    "SCROLL",
    "SEARCH",
    "SECOND",
    // requires AS
    "SECURITY",
    "SELECT",
    // reserved
    "SEQUENCE",
    "SEQUENCES",
    "SERIALIZABLE",
    "SERVER",
    "SESSION",
    "SESSION_USER",
    // reserved
    "SET",
    "SETOF",
    // (cannot be function or type)
    "SETS",
    "SHARE",
    "SHOW",
    "SIMILAR",
    // reserved (can be function or type)
    "SIMPLE",
    "SKIP",
    "SMALLINT",
    // (cannot be function or type)
    "SNAPSHOT",
    "SOME",
    // reserved
    "SQL",
    "STABLE",
    "STANDALONE",
    "START",
    "STATEMENT",
    "STATISTICS",
    "STDIN",
    "STDOUT",
    "STORAGE",
    "STORED",
    "STRICT",
    "STRIP",
    "SUBSCRIPTION",
    "SUBSTRING",
    // (cannot be function or type)
    "SUPPORT",
    "SYMMETRIC",
    // reserved
    "SYSID",
    "SYSTEM",
    "TABLE",
    // reserved
    "TABLES",
    "TABLESAMPLE",
    // reserved (can be function or type)
    "TABLESPACE",
    "TEMP",
    "TEMPLATE",
    "TEMPORARY",
    "TEXT",
    "THEN",
    // reserved
    "TIES",
    "TIME",
    // (cannot be function or type)
    "TIMESTAMP",
    // (cannot be function or type)
    "TO",
    // reserved, requires AS
    "TRAILING",
    // reserved
    "TRANSACTION",
    "TRANSFORM",
    "TREAT",
    // (cannot be function or type)
    "TRIGGER",
    "TRIM",
    // (cannot be function or type)
    "TRUE",
    // reserved
    "TRUNCATE",
    "TRUSTED",
    "TYPE",
    "TYPES",
    "UESCAPE",
    "UNBOUNDED",
    "UNCOMMITTED",
    "UNENCRYPTED",
    "UNION",
    // reserved, requires AS
    "UNIQUE",
    // reserved
    "UNKNOWN",
    "UNLISTEN",
    "UNLOGGED",
    "UNTIL",
    "UPDATE",
    "USER",
    // reserved
    "USING",
    // reserved
    "VACUUM",
    "VALID",
    "VALIDATE",
    "VALIDATOR",
    "VALUE",
    "VALUES",
    // (cannot be function or type)
    "VARCHAR",
    // (cannot be function or type)
    "VARIADIC",
    // reserved
    "VARYING",
    // requires AS
    "VERBOSE",
    // reserved (can be function or type)
    "VERSION",
    "VIEW",
    "VIEWS",
    "VOLATILE",
    "WHEN",
    // reserved
    "WHERE",
    // reserved, requires AS
    "WHITESPACE",
    "WINDOW",
    // reserved, requires AS
    "WITH",
    // reserved, requires AS
    "WITHIN",
    // requires AS
    "WITHOUT",
    // requires AS
    "WORK",
    "WRAPPER",
    "WRITE",
    "XML",
    "XMLATTRIBUTES",
    // (cannot be function or type)
    "XMLCONCAT",
    // (cannot be function or type)
    "XMLELEMENT",
    // (cannot be function or type)
    "XMLEXISTS",
    // (cannot be function or type)
    "XMLFOREST",
    // (cannot be function or type)
    "XMLNAMESPACES",
    // (cannot be function or type)
    "XMLPARSE",
    // (cannot be function or type)
    "XMLPI",
    // (cannot be function or type)
    "XMLROOT",
    // (cannot be function or type)
    "XMLSERIALIZE",
    // (cannot be function or type)
    "XMLTABLE",
    // (cannot be function or type)
    "YEAR",
    // requires AS
    "YES",
    "ZONE"
  ]
}), v3 = fe(["SELECT [ALL | DISTINCT]"]), L3 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  "FOR {UPDATE | NO KEY UPDATE | SHARE | KEY SHARE} [OF]",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [TEMP | TEMPORARY] [RECURSIVE] VIEW",
  "CREATE MATERIALIZED VIEW [IF NOT EXISTS]",
  "CREATE [GLOBAL | LOCAL] [TEMPORARY | TEMP | UNLOGGED] TABLE [IF NOT EXISTS]",
  // other
  "RETURNING"
]), GC = fe([
  // - update:
  "UPDATE [ONLY]",
  "WHERE CURRENT OF",
  // - insert:
  "ON CONFLICT",
  // - delete:
  "DELETE FROM [ONLY]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS] [ONLY]",
  "ALTER TABLE ALL IN TABLESPACE",
  "RENAME [COLUMN]",
  "RENAME TO",
  "ADD [COLUMN] [IF NOT EXISTS]",
  "DROP [COLUMN] [IF EXISTS]",
  "ALTER [COLUMN]",
  "[SET DATA] TYPE",
  // for alter column
  "{SET | DROP} DEFAULT",
  // for alter column
  "{SET | DROP} NOT NULL",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE] [ONLY]",
  // other
  "SET SCHEMA",
  "AFTER",
  // https://www.postgresql.org/docs/14/sql-commands.html
  "ABORT",
  "ALTER AGGREGATE",
  "ALTER COLLATION",
  "ALTER CONVERSION",
  "ALTER DATABASE",
  "ALTER DEFAULT PRIVILEGES",
  "ALTER DOMAIN",
  "ALTER EVENT TRIGGER",
  "ALTER EXTENSION",
  "ALTER FOREIGN DATA WRAPPER",
  "ALTER FOREIGN TABLE",
  "ALTER FUNCTION",
  "ALTER GROUP",
  "ALTER INDEX",
  "ALTER LANGUAGE",
  "ALTER LARGE OBJECT",
  "ALTER MATERIALIZED VIEW",
  "ALTER OPERATOR",
  "ALTER OPERATOR CLASS",
  "ALTER OPERATOR FAMILY",
  "ALTER POLICY",
  "ALTER PROCEDURE",
  "ALTER PUBLICATION",
  "ALTER ROLE",
  "ALTER ROUTINE",
  "ALTER RULE",
  "ALTER SCHEMA",
  "ALTER SEQUENCE",
  "ALTER SERVER",
  "ALTER STATISTICS",
  "ALTER SUBSCRIPTION",
  "ALTER SYSTEM",
  "ALTER TABLESPACE",
  "ALTER TEXT SEARCH CONFIGURATION",
  "ALTER TEXT SEARCH DICTIONARY",
  "ALTER TEXT SEARCH PARSER",
  "ALTER TEXT SEARCH TEMPLATE",
  "ALTER TRIGGER",
  "ALTER TYPE",
  "ALTER USER",
  "ALTER USER MAPPING",
  "ALTER VIEW",
  "ANALYZE",
  "BEGIN",
  "CALL",
  "CHECKPOINT",
  "CLOSE",
  "CLUSTER",
  "COMMENT",
  "COMMIT",
  "COMMIT PREPARED",
  "COPY",
  "CREATE ACCESS METHOD",
  "CREATE AGGREGATE",
  "CREATE CAST",
  "CREATE COLLATION",
  "CREATE CONVERSION",
  "CREATE DATABASE",
  "CREATE DOMAIN",
  "CREATE EVENT TRIGGER",
  "CREATE EXTENSION",
  "CREATE FOREIGN DATA WRAPPER",
  "CREATE FOREIGN TABLE",
  "CREATE FUNCTION",
  "CREATE GROUP",
  "CREATE INDEX",
  "CREATE LANGUAGE",
  "CREATE OPERATOR",
  "CREATE OPERATOR CLASS",
  "CREATE OPERATOR FAMILY",
  "CREATE POLICY",
  "CREATE PROCEDURE",
  "CREATE PUBLICATION",
  "CREATE ROLE",
  "CREATE RULE",
  "CREATE SCHEMA",
  "CREATE SEQUENCE",
  "CREATE SERVER",
  "CREATE STATISTICS",
  "CREATE SUBSCRIPTION",
  "CREATE TABLESPACE",
  "CREATE TEXT SEARCH CONFIGURATION",
  "CREATE TEXT SEARCH DICTIONARY",
  "CREATE TEXT SEARCH PARSER",
  "CREATE TEXT SEARCH TEMPLATE",
  "CREATE TRANSFORM",
  "CREATE TRIGGER",
  "CREATE TYPE",
  "CREATE USER",
  "CREATE USER MAPPING",
  "DEALLOCATE",
  "DECLARE",
  "DISCARD",
  "DROP ACCESS METHOD",
  "DROP AGGREGATE",
  "DROP CAST",
  "DROP COLLATION",
  "DROP CONVERSION",
  "DROP DATABASE",
  "DROP DOMAIN",
  "DROP EVENT TRIGGER",
  "DROP EXTENSION",
  "DROP FOREIGN DATA WRAPPER",
  "DROP FOREIGN TABLE",
  "DROP FUNCTION",
  "DROP GROUP",
  "DROP INDEX",
  "DROP LANGUAGE",
  "DROP MATERIALIZED VIEW",
  "DROP OPERATOR",
  "DROP OPERATOR CLASS",
  "DROP OPERATOR FAMILY",
  "DROP OWNED",
  "DROP POLICY",
  "DROP PROCEDURE",
  "DROP PUBLICATION",
  "DROP ROLE",
  "DROP ROUTINE",
  "DROP RULE",
  "DROP SCHEMA",
  "DROP SEQUENCE",
  "DROP SERVER",
  "DROP STATISTICS",
  "DROP SUBSCRIPTION",
  "DROP TABLESPACE",
  "DROP TEXT SEARCH CONFIGURATION",
  "DROP TEXT SEARCH DICTIONARY",
  "DROP TEXT SEARCH PARSER",
  "DROP TEXT SEARCH TEMPLATE",
  "DROP TRANSFORM",
  "DROP TRIGGER",
  "DROP TYPE",
  "DROP USER",
  "DROP USER MAPPING",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FETCH",
  "GRANT",
  "IMPORT FOREIGN SCHEMA",
  "LISTEN",
  "LOAD",
  "LOCK",
  "MOVE",
  "NOTIFY",
  "PREPARE",
  "PREPARE TRANSACTION",
  "REASSIGN OWNED",
  "REFRESH MATERIALIZED VIEW",
  "REINDEX",
  "RELEASE SAVEPOINT",
  "RESET",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK PREPARED",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SECURITY LABEL",
  "SELECT INTO",
  "SET CONSTRAINTS",
  "SET ROLE",
  "SET SESSION AUTHORIZATION",
  "SET TRANSACTION",
  "SHOW",
  "START TRANSACTION",
  "UNLISTEN",
  "VACUUM"
]), y3 = fe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), g3 = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), D3 = fe([
  "ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]",
  "{ROWS | RANGE | GROUPS} BETWEEN",
  // https://www.postgresql.org/docs/current/datatype-datetime.html
  "{TIMESTAMP | TIME} {WITH | WITHOUT} TIME ZONE",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), b3 = {
  tokenizerOptions: {
    reservedSelect: v3,
    reservedClauses: [...L3, ...GC],
    reservedSetOperations: y3,
    reservedJoins: g3,
    reservedPhrases: D3,
    reservedKeywords: m3,
    reservedFunctionNames: C3,
    nestedBlockComments: !0,
    extraParens: ["[]"],
    stringTypes: ["$$", {
      quote: "''-qq",
      prefixes: ["U&"]
    }, {
      quote: "''-bs",
      prefixes: ["E"],
      requirePrefix: !0
    }, {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: [{
      quote: '""-qq',
      prefixes: ["U&"]
    }],
    identChars: {
      rest: "$"
    },
    paramTypes: {
      numbered: ["$"]
    },
    operators: [
      // Arithmetic
      "%",
      "^",
      "|/",
      "||/",
      "@",
      // Assignment
      ":=",
      // Bitwise
      "&",
      "|",
      "#",
      "~",
      "<<",
      ">>",
      // Byte comparison
      "~>~",
      "~<~",
      "~>=~",
      "~<=~",
      // Geometric
      "@-@",
      "@@",
      "##",
      "<->",
      "&&",
      "&<",
      "&>",
      "<<|",
      "&<|",
      "|>>",
      "|&>",
      "<^",
      "^>",
      "?#",
      "?-",
      "?|",
      "?-|",
      "?||",
      "@>",
      "<@",
      "~=",
      // JSON
      "?",
      "@?",
      "?&",
      "->",
      "->>",
      "#>",
      "#>>",
      "#-",
      // Named function params
      "=>",
      // Network address
      ">>=",
      "<<=",
      // Pattern matching
      "~~",
      "~~*",
      "!~~",
      "!~~*",
      // POSIX RegExp
      "~",
      "~*",
      "!~",
      "!~*",
      // Range/multirange
      "-|-",
      // String concatenation
      "||",
      // Text search
      "@@@",
      "!!",
      // Trigram/trigraph
      "<%",
      "%>",
      "<<%",
      "%>>",
      "<<->",
      "<->>",
      "<<<->",
      "<->>>",
      // Type cast
      "::"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: GC
  }
}, M3 = ut({
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Aggregate_Functions.html
  aggregate: ["ANY_VALUE", "APPROXIMATE PERCENTILE_DISC", "AVG", "COUNT", "LISTAGG", "MAX", "MEDIAN", "MIN", "PERCENTILE_CONT", "STDDEV_SAMP", "STDDEV_POP", "SUM", "VAR_SAMP", "VAR_POP"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Array_Functions.html
  array: ["array", "array_concat", "array_flatten", "get_array_length", "split_to_array", "subarray"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_bitwise_aggregate_functions.html
  bitwise: ["BIT_AND", "BIT_OR", "BOOL_AND", "BOOL_OR"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_conditional_expressions.html
  conditional: ["COALESCE", "DECODE", "GREATEST", "LEAST", "NVL", "NVL2", "NULLIF"],
  // https://docs.aws.amazon.com/redshift/latest/dg/Date_functions_header.html
  dateTime: ["ADD_MONTHS", "AT TIME ZONE", "CONVERT_TIMEZONE", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATE_CMP", "DATE_CMP_TIMESTAMP", "DATE_CMP_TIMESTAMPTZ", "DATE_PART_YEAR", "DATEADD", "DATEDIFF", "DATE_PART", "DATE_TRUNC", "EXTRACT", "GETDATE", "INTERVAL_CMP", "LAST_DAY", "MONTHS_BETWEEN", "NEXT_DAY", "SYSDATE", "TIMEOFDAY", "TIMESTAMP_CMP", "TIMESTAMP_CMP_DATE", "TIMESTAMP_CMP_TIMESTAMPTZ", "TIMESTAMPTZ_CMP", "TIMESTAMPTZ_CMP_DATE", "TIMESTAMPTZ_CMP_TIMESTAMP", "TIMEZONE", "TO_TIMESTAMP", "TRUNC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/geospatial-functions.html
  spatial: ["AddBBox", "DropBBox", "GeometryType", "ST_AddPoint", "ST_Angle", "ST_Area", "ST_AsBinary", "ST_AsEWKB", "ST_AsEWKT", "ST_AsGeoJSON", "ST_AsText", "ST_Azimuth", "ST_Boundary", "ST_Collect", "ST_Contains", "ST_ContainsProperly", "ST_ConvexHull", "ST_CoveredBy", "ST_Covers", "ST_Crosses", "ST_Dimension", "ST_Disjoint", "ST_Distance", "ST_DistanceSphere", "ST_DWithin", "ST_EndPoint", "ST_Envelope", "ST_Equals", "ST_ExteriorRing", "ST_Force2D", "ST_Force3D", "ST_Force3DM", "ST_Force3DZ", "ST_Force4D", "ST_GeometryN", "ST_GeometryType", "ST_GeomFromEWKB", "ST_GeomFromEWKT", "ST_GeomFromText", "ST_GeomFromWKB", "ST_InteriorRingN", "ST_Intersects", "ST_IsPolygonCCW", "ST_IsPolygonCW", "ST_IsClosed", "ST_IsCollection", "ST_IsEmpty", "ST_IsSimple", "ST_IsValid", "ST_Length", "ST_LengthSphere", "ST_Length2D", "ST_LineFromMultiPoint", "ST_LineInterpolatePoint", "ST_M", "ST_MakeEnvelope", "ST_MakeLine", "ST_MakePoint", "ST_MakePolygon", "ST_MemSize", "ST_MMax", "ST_MMin", "ST_Multi", "ST_NDims", "ST_NPoints", "ST_NRings", "ST_NumGeometries", "ST_NumInteriorRings", "ST_NumPoints", "ST_Perimeter", "ST_Perimeter2D", "ST_Point", "ST_PointN", "ST_Points", "ST_Polygon", "ST_RemovePoint", "ST_Reverse", "ST_SetPoint", "ST_SetSRID", "ST_Simplify", "ST_SRID", "ST_StartPoint", "ST_Touches", "ST_Within", "ST_X", "ST_XMax", "ST_XMin", "ST_Y", "ST_YMax", "ST_YMin", "ST_Z", "ST_ZMax", "ST_ZMin", "SupportsBBox"],
  // https://docs.aws.amazon.com/redshift/latest/dg/hash-functions.html
  hash: ["CHECKSUM", "FUNC_SHA1", "FNV_HASH", "MD5", "SHA", "SHA1", "SHA2"],
  // https://docs.aws.amazon.com/redshift/latest/dg/hyperloglog-functions.html
  hyperLogLog: ["HLL", "HLL_CREATE_SKETCH", "HLL_CARDINALITY", "HLL_COMBINE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/json-functions.html
  json: ["IS_VALID_JSON", "IS_VALID_JSON_ARRAY", "JSON_ARRAY_LENGTH", "JSON_EXTRACT_ARRAY_ELEMENT_TEXT", "JSON_EXTRACT_PATH_TEXT", "JSON_PARSE", "JSON_SERIALIZE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/Math_functions.html
  math: ["ABS", "ACOS", "ASIN", "ATAN", "ATAN2", "CBRT", "CEILING", "CEIL", "COS", "COT", "DEGREES", "DEXP", "DLOG1", "DLOG10", "EXP", "FLOOR", "LN", "LOG", "MOD", "PI", "POWER", "RADIANS", "RANDOM", "ROUND", "SIN", "SIGN", "SQRT", "TAN", "TO_HEX", "TRUNC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/ml-function.html
  machineLearning: ["EXPLAIN_MODEL"],
  // https://docs.aws.amazon.com/redshift/latest/dg/String_functions_header.html
  string: ["ASCII", "BPCHARCMP", "BTRIM", "BTTEXT_PATTERN_CMP", "CHAR_LENGTH", "CHARACTER_LENGTH", "CHARINDEX", "CHR", "COLLATE", "CONCAT", "CRC32", "DIFFERENCE", "INITCAP", "LEFT", "RIGHT", "LEN", "LENGTH", "LOWER", "LPAD", "RPAD", "LTRIM", "OCTETINDEX", "OCTET_LENGTH", "POSITION", "QUOTE_IDENT", "QUOTE_LITERAL", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REPEAT", "REPLACE", "REPLICATE", "REVERSE", "RTRIM", "SOUNDEX", "SPLIT_PART", "STRPOS", "STRTOL", "SUBSTRING", "TEXTLEN", "TRANSLATE", "TRIM", "UPPER"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Type_Info_Functions.html
  superType: ["decimal_precision", "decimal_scale", "is_array", "is_bigint", "is_boolean", "is_char", "is_decimal", "is_float", "is_integer", "is_object", "is_scalar", "is_smallint", "is_varchar", "json_typeof"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Window_functions.html
  window: ["AVG", "COUNT", "CUME_DIST", "DENSE_RANK", "FIRST_VALUE", "LAST_VALUE", "LAG", "LEAD", "LISTAGG", "MAX", "MEDIAN", "MIN", "NTH_VALUE", "NTILE", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "RANK", "RATIO_TO_REPORT", "ROW_NUMBER", "STDDEV_SAMP", "STDDEV_POP", "SUM", "VAR_SAMP", "VAR_POP"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_Data_type_formatting.html
  dataType: ["CAST", "CONVERT", "TO_CHAR", "TO_DATE", "TO_NUMBER", "TEXT_TO_INT_ALT", "TEXT_TO_NUMERIC_ALT"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_System_administration_functions.html
  sysAdmin: ["CHANGE_QUERY_PRIORITY", "CHANGE_SESSION_PRIORITY", "CHANGE_USER_PRIORITY", "CURRENT_SETTING", "PG_CANCEL_BACKEND", "PG_TERMINATE_BACKEND", "REBOOT_CLUSTER", "SET_CONFIG"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_System_information_functions.html
  sysInfo: ["CURRENT_AWS_ACCOUNT", "CURRENT_DATABASE", "CURRENT_NAMESPACE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_USER", "CURRENT_USER_ID", "HAS_ASSUMEROLE_PRIVILEGE", "HAS_DATABASE_PRIVILEGE", "HAS_SCHEMA_PRIVILEGE", "HAS_TABLE_PRIVILEGE", "PG_BACKEND_PID", "PG_GET_COLS", "PG_GET_GRANTEE_BY_IAM_ROLE", "PG_GET_IAM_ROLE_BY_USER", "PG_GET_LATE_BINDING_VIEW_COLS", "PG_LAST_COPY_COUNT", "PG_LAST_COPY_ID", "PG_LAST_UNLOAD_ID", "PG_LAST_QUERY_ID", "PG_LAST_UNLOAD_COUNT", "SESSION_USER", "SLICE_NUM", "USER", "VERSION"],
  dataTypes: ["DECIMAL", "NUMERIC", "CHAR", "CHARACTER", "VARCHAR", "CHARACTER VARYING", "NCHAR", "NVARCHAR", "VARBYTE"]
}), P3 = ut({
  // https://docs.aws.amazon.com/redshift/latest/dg/r_pg_keywords.html
  standard: ["AES128", "AES256", "ALL", "ALLOWOVERWRITE", "ANY", "ARRAY", "AS", "ASC", "AUTHORIZATION", "BACKUP", "BETWEEN", "BINARY", "BOTH", "CHECK", "COLUMN", "CONSTRAINT", "CREATE", "CROSS", "DEFAULT", "DEFERRABLE", "DEFLATE", "DEFRAG", "DESC", "DISABLE", "DISTINCT", "DO", "ENABLE", "ENCODE", "ENCRYPT", "ENCRYPTION", "EXPLICIT", "FALSE", "FOR", "FOREIGN", "FREEZE", "FROM", "FULL", "GLOBALDICT256", "GLOBALDICT64K", "GROUP", "IDENTITY", "IGNORE", "ILIKE", "IN", "INITIALLY", "INNER", "INTO", "IS", "ISNULL", "LANGUAGE", "LEADING", "LIKE", "LIMIT", "LOCALTIME", "LOCALTIMESTAMP", "LUN", "LUNS", "MINUS", "NATURAL", "NEW", "NOT", "NOTNULL", "NULL", "NULLS", "OFF", "OFFLINE", "OFFSET", "OID", "OLD", "ON", "ONLY", "OPEN", "ORDER", "OUTER", "OVERLAPS", "PARALLEL", "PARTITION", "PERCENT", "PERMISSIONS", "PLACING", "PRIMARY", "RECOVER", "REFERENCES", "REJECTLOG", "RESORT", "RESPECT", "RESTORE", "SIMILAR", "SNAPSHOT", "SOME", "SYSTEM", "TABLE", "TAG", "TDES", "THEN", "TIMESTAMP", "TO", "TOP", "TRAILING", "TRUE", "UNIQUE", "USING", "VERBOSE", "WALLET", "WITHOUT"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-conversion.html
  dataConversionParams: ["ACCEPTANYDATE", "ACCEPTINVCHARS", "BLANKSASNULL", "DATEFORMAT", "EMPTYASNULL", "ENCODING", "ESCAPE", "EXPLICIT_IDS", "FILLRECORD", "IGNOREBLANKLINES", "IGNOREHEADER", "REMOVEQUOTES", "ROUNDEC", "TIMEFORMAT", "TRIMBLANKS", "TRUNCATECOLUMNS"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-load.html
  dataLoadParams: ["COMPROWS", "COMPUPDATE", "MAXERROR", "NOLOAD", "STATUPDATE"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-format.html
  dataFormatParams: ["FORMAT", "CSV", "DELIMITER", "FIXEDWIDTH", "SHAPEFILE", "AVRO", "JSON", "PARQUET", "ORC"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-authorization.html
  copyAuthParams: ["ACCESS_KEY_ID", "CREDENTIALS", "ENCRYPTED", "IAM_ROLE", "MASTER_SYMMETRIC_KEY", "SECRET_ACCESS_KEY", "SESSION_TOKEN"],
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-file-compression.html
  copyCompressionParams: ["BZIP2", "GZIP", "LZOP", "ZSTD"],
  // https://docs.aws.amazon.com/redshift/latest/dg/r_COPY-alphabetical-parm-list.html
  copyMiscParams: ["MANIFEST", "READRATIO", "REGION", "SSH"],
  // https://docs.aws.amazon.com/redshift/latest/dg/c_Compression_encodings.html
  compressionEncodings: ["RAW", "AZ64", "BYTEDICT", "DELTA", "DELTA32K", "LZO", "MOSTLY8", "MOSTLY16", "MOSTLY32", "RUNLENGTH", "TEXT255", "TEXT32K"],
  misc: [
    // CREATE EXTERNAL SCHEMA (https://docs.aws.amazon.com/redshift/latest/dg/r_CREATE_EXTERNAL_SCHEMA.html)
    "CATALOG_ROLE",
    "SECRET_ARN",
    "EXTERNAL",
    // https://docs.aws.amazon.com/redshift/latest/dg/c_choosing_dist_sort.html
    "AUTO",
    "EVEN",
    "KEY",
    "PREDICATE",
    // ANALYZE | ANALYSE (https://docs.aws.amazon.com/redshift/latest/dg/r_ANALYZE.html)
    // unknown
    "COMPRESSION"
  ],
  /**
   * Other keywords not included:
   * STL: https://docs.aws.amazon.com/redshift/latest/dg/c_intro_STL_tables.html
   * SVCS: https://docs.aws.amazon.com/redshift/latest/dg/svcs_views.html
   * SVL: https://docs.aws.amazon.com/redshift/latest/dg/svl_views.html
   * SVV: https://docs.aws.amazon.com/redshift/latest/dg/svv_views.html
   */
  // https://docs.aws.amazon.com/redshift/latest/dg/r_Character_types.html#r_Character_types-text-and-bpchar-types
  dataTypes: ["BPCHAR", "TEXT"]
}), U3 = fe(["SELECT [ALL | DISTINCT]"]), x3 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE | MATERIALIZED] VIEW",
  "CREATE [TEMPORARY | TEMP | LOCAL TEMPORARY | LOCAL TEMP] TABLE [IF NOT EXISTS]"
]), HC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ALTER TABLE APPEND",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME TO",
  "RENAME COLUMN",
  "ALTER COLUMN",
  "TYPE",
  // for alter column
  "ENCODE",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://docs.aws.amazon.com/redshift/latest/dg/c_SQL_commands.html
  "ABORT",
  "ALTER DATABASE",
  "ALTER DATASHARE",
  "ALTER DEFAULT PRIVILEGES",
  "ALTER GROUP",
  "ALTER MATERIALIZED VIEW",
  "ALTER PROCEDURE",
  "ALTER SCHEMA",
  "ALTER USER",
  "ANALYSE",
  "ANALYZE",
  "ANALYSE COMPRESSION",
  "ANALYZE COMPRESSION",
  "BEGIN",
  "CALL",
  "CANCEL",
  "CLOSE",
  "COMMENT",
  "COMMIT",
  "COPY",
  "CREATE DATABASE",
  "CREATE DATASHARE",
  "CREATE EXTERNAL FUNCTION",
  "CREATE EXTERNAL SCHEMA",
  "CREATE EXTERNAL TABLE",
  "CREATE FUNCTION",
  "CREATE GROUP",
  "CREATE LIBRARY",
  "CREATE MODEL",
  "CREATE PROCEDURE",
  "CREATE SCHEMA",
  "CREATE USER",
  "DEALLOCATE",
  "DECLARE",
  "DESC DATASHARE",
  "DROP DATABASE",
  "DROP DATASHARE",
  "DROP FUNCTION",
  "DROP GROUP",
  "DROP LIBRARY",
  "DROP MODEL",
  "DROP MATERIALIZED VIEW",
  "DROP PROCEDURE",
  "DROP SCHEMA",
  "DROP USER",
  "DROP VIEW",
  "DROP",
  "EXECUTE",
  "EXPLAIN",
  "FETCH",
  "GRANT",
  "LOCK",
  "PREPARE",
  "REFRESH MATERIALIZED VIEW",
  "RESET",
  "REVOKE",
  "ROLLBACK",
  "SELECT INTO",
  "SET SESSION AUTHORIZATION",
  "SET SESSION CHARACTERISTICS",
  "SHOW",
  "SHOW EXTERNAL TABLE",
  "SHOW MODEL",
  "SHOW DATASHARES",
  "SHOW PROCEDURE",
  "SHOW TABLE",
  "SHOW VIEW",
  "START TRANSACTION",
  "UNLOAD",
  "VACUUM"
]), w3 = fe(["UNION [ALL]", "EXCEPT", "INTERSECT", "MINUS"]), G3 = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), H3 = fe([
  // https://docs.aws.amazon.com/redshift/latest/dg/copy-parameters-data-conversion.html
  "NULL AS",
  // https://docs.aws.amazon.com/redshift/latest/dg/r_CREATE_EXTERNAL_SCHEMA.html
  "DATA CATALOG",
  "HIVE METASTORE",
  // in window specifications
  "{ROWS | RANGE} BETWEEN"
]), B3 = {
  tokenizerOptions: {
    reservedSelect: U3,
    reservedClauses: [...x3, ...HC],
    reservedSetOperations: w3,
    reservedJoins: G3,
    reservedPhrases: H3,
    reservedKeywords: P3,
    reservedFunctionNames: M3,
    stringTypes: ["''-qq"],
    identTypes: ['""-qq'],
    identChars: {
      first: "#"
    },
    paramTypes: {
      numbered: ["$"]
    },
    operators: [
      "^",
      "%",
      "@",
      "|/",
      "||/",
      "&",
      "|",
      // '#', conflicts with first char of identifier
      "~",
      "<<",
      ">>",
      "||",
      "::"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: HC
  }
}, F3 = ut({
  // https://deepkb.com/CO_000013/en/kb/IMPORT-fbfa59f0-2bf1-31fe-bb7b-0f9efe9932c6/spark-sql-keywords
  all: [
    "ADD",
    "AFTER",
    "ALL",
    "ALTER",
    "ANALYZE",
    "AND",
    "ANTI",
    "ANY",
    "ARCHIVE",
    "ARRAY",
    "AS",
    "ASC",
    "AT",
    "AUTHORIZATION",
    "BETWEEN",
    "BOTH",
    "BUCKET",
    "BUCKETS",
    "BY",
    "CACHE",
    "CASCADE",
    "CAST",
    "CHANGE",
    "CHECK",
    "CLEAR",
    "CLUSTER",
    "CLUSTERED",
    "CODEGEN",
    "COLLATE",
    "COLLECTION",
    "COLUMN",
    "COLUMNS",
    "COMMENT",
    "COMMIT",
    "COMPACT",
    "COMPACTIONS",
    "COMPUTE",
    "CONCATENATE",
    "CONSTRAINT",
    "COST",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_DATE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "DATA",
    "DATABASE",
    "DATABASES",
    "DAY",
    "DBPROPERTIES",
    "DEFINED",
    "DELETE",
    "DELIMITED",
    "DESC",
    "DESCRIBE",
    "DFS",
    "DIRECTORIES",
    "DIRECTORY",
    "DISTINCT",
    "DISTRIBUTE",
    "DIV",
    "DROP",
    "ESCAPE",
    "ESCAPED",
    "EXCEPT",
    "EXCHANGE",
    "EXISTS",
    "EXPORT",
    "EXTENDED",
    "EXTERNAL",
    "EXTRACT",
    "FALSE",
    "FETCH",
    "FIELDS",
    "FILTER",
    "FILEFORMAT",
    "FIRST",
    "FIRST_VALUE",
    "FOLLOWING",
    "FOR",
    "FOREIGN",
    "FORMAT",
    "FORMATTED",
    "FULL",
    "FUNCTION",
    "FUNCTIONS",
    "GLOBAL",
    "GRANT",
    "GROUP",
    "GROUPING",
    "HOUR",
    "IF",
    "IGNORE",
    "IMPORT",
    "IN",
    "INDEX",
    "INDEXES",
    "INNER",
    "INPATH",
    "INPUTFORMAT",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "IS",
    "ITEMS",
    "KEYS",
    "LAST",
    "LAST_VALUE",
    "LATERAL",
    "LAZY",
    "LEADING",
    "LEFT",
    "LIKE",
    "LINES",
    "LIST",
    "LOCAL",
    "LOCATION",
    "LOCK",
    "LOCKS",
    "LOGICAL",
    "MACRO",
    "MAP",
    "MATCHED",
    "MERGE",
    "MINUTE",
    "MONTH",
    "MSCK",
    "NAMESPACE",
    "NAMESPACES",
    "NATURAL",
    "NO",
    "NOT",
    "NULL",
    "NULLS",
    "OF",
    "ONLY",
    "OPTION",
    "OPTIONS",
    "OR",
    "ORDER",
    "OUT",
    "OUTER",
    "OUTPUTFORMAT",
    "OVER",
    "OVERLAPS",
    "OVERLAY",
    "OVERWRITE",
    "OWNER",
    "PARTITION",
    "PARTITIONED",
    "PARTITIONS",
    "PERCENT",
    "PLACING",
    "POSITION",
    "PRECEDING",
    "PRIMARY",
    "PRINCIPALS",
    "PROPERTIES",
    "PURGE",
    "QUERY",
    "RANGE",
    "RECORDREADER",
    "RECORDWRITER",
    "RECOVER",
    "REDUCE",
    "REFERENCES",
    "RENAME",
    "REPAIR",
    "REPLACE",
    "RESPECT",
    "RESTRICT",
    "REVOKE",
    "RIGHT",
    "RLIKE",
    "ROLE",
    "ROLES",
    "ROLLBACK",
    "ROLLUP",
    "ROW",
    "ROWS",
    "SCHEMA",
    "SECOND",
    "SELECT",
    "SEMI",
    "SEPARATED",
    "SERDE",
    "SERDEPROPERTIES",
    "SESSION_USER",
    "SETS",
    "SHOW",
    "SKEWED",
    "SOME",
    "SORT",
    "SORTED",
    "START",
    "STATISTICS",
    "STORED",
    "STRATIFY",
    "STRUCT",
    "SUBSTR",
    "SUBSTRING",
    "TABLE",
    "TABLES",
    "TBLPROPERTIES",
    "TEMPORARY",
    "TERMINATED",
    "THEN",
    "TO",
    "TOUCH",
    "TRAILING",
    "TRANSACTION",
    "TRANSACTIONS",
    "TRIM",
    "TRUE",
    "TRUNCATE",
    "UNARCHIVE",
    "UNBOUNDED",
    "UNCACHE",
    "UNIQUE",
    "UNKNOWN",
    "UNLOCK",
    "UNSET",
    "USE",
    "USER",
    "USING",
    "VIEW",
    "WINDOW",
    "YEAR",
    // other
    "ANALYSE",
    "ARRAY_ZIP",
    "COALESCE",
    "CONTAINS",
    "CONVERT",
    "DAYS",
    "DAY_HOUR",
    "DAY_MINUTE",
    "DAY_SECOND",
    "DECODE",
    "DEFAULT",
    "DISTINCTROW",
    "ENCODE",
    "EXPLODE",
    "EXPLODE_OUTER",
    "FIXED",
    "GREATEST",
    "GROUP_CONCAT",
    "HOURS",
    "HOUR_MINUTE",
    "HOUR_SECOND",
    "IFNULL",
    "LEAST",
    "LEVEL",
    "MINUTE_SECOND",
    "NULLIF",
    "OFFSET",
    "ON",
    "OPTIMIZE",
    "REGEXP",
    "SEPARATOR",
    "SIZE",
    "STRING",
    "TYPE",
    "TYPES",
    "UNSIGNED",
    "VARIABLES",
    "YEAR_MONTH"
  ]
}), Y3 = ut({
  // http://spark.apache.org/docs/latest/sql-ref-functions.html
  //
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#aggregate-functions
  aggregate: [
    // 'ANY',
    "APPROX_COUNT_DISTINCT",
    "APPROX_PERCENTILE",
    "AVG",
    "BIT_AND",
    "BIT_OR",
    "BIT_XOR",
    "BOOL_AND",
    "BOOL_OR",
    "COLLECT_LIST",
    "COLLECT_SET",
    "CORR",
    "COUNT",
    "COUNT",
    "COUNT",
    "COUNT_IF",
    "COUNT_MIN_SKETCH",
    "COVAR_POP",
    "COVAR_SAMP",
    "EVERY",
    "FIRST",
    "FIRST_VALUE",
    "GROUPING",
    "GROUPING_ID",
    "KURTOSIS",
    "LAST",
    "LAST_VALUE",
    "MAX",
    "MAX_BY",
    "MEAN",
    "MIN",
    "MIN_BY",
    "PERCENTILE",
    "PERCENTILE",
    "PERCENTILE_APPROX",
    "SKEWNESS",
    // 'SOME',
    "STD",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "SUM",
    "VAR_POP",
    "VAR_SAMP",
    "VARIANCE"
  ],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#window-functions
  window: ["CUME_DIST", "DENSE_RANK", "LAG", "LEAD", "NTH_VALUE", "NTILE", "PERCENT_RANK", "RANK", "ROW_NUMBER"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#array-functions
  array: ["ARRAY", "ARRAY_CONTAINS", "ARRAY_DISTINCT", "ARRAY_EXCEPT", "ARRAY_INTERSECT", "ARRAY_JOIN", "ARRAY_MAX", "ARRAY_MIN", "ARRAY_POSITION", "ARRAY_REMOVE", "ARRAY_REPEAT", "ARRAY_UNION", "ARRAYS_OVERLAP", "ARRAYS_ZIP", "FLATTEN", "SEQUENCE", "SHUFFLE", "SLICE", "SORT_ARRAY"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#map-functions
  map: ["ELEMENT_AT", "ELEMENT_AT", "MAP", "MAP_CONCAT", "MAP_ENTRIES", "MAP_FROM_ARRAYS", "MAP_FROM_ENTRIES", "MAP_KEYS", "MAP_VALUES", "STR_TO_MAP"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#date-and-timestamp-functions
  datetime: ["ADD_MONTHS", "CURRENT_DATE", "CURRENT_DATE", "CURRENT_TIMESTAMP", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "DATE_ADD", "DATE_FORMAT", "DATE_FROM_UNIX_DATE", "DATE_PART", "DATE_SUB", "DATE_TRUNC", "DATEDIFF", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFYEAR", "EXTRACT", "FROM_UNIXTIME", "FROM_UTC_TIMESTAMP", "HOUR", "LAST_DAY", "MAKE_DATE", "MAKE_DT_INTERVAL", "MAKE_INTERVAL", "MAKE_TIMESTAMP", "MAKE_YM_INTERVAL", "MINUTE", "MONTH", "MONTHS_BETWEEN", "NEXT_DAY", "NOW", "QUARTER", "SECOND", "SESSION_WINDOW", "TIMESTAMP_MICROS", "TIMESTAMP_MILLIS", "TIMESTAMP_SECONDS", "TO_DATE", "TO_TIMESTAMP", "TO_UNIX_TIMESTAMP", "TO_UTC_TIMESTAMP", "TRUNC", "UNIX_DATE", "UNIX_MICROS", "UNIX_MILLIS", "UNIX_SECONDS", "UNIX_TIMESTAMP", "WEEKDAY", "WEEKOFYEAR", "WINDOW", "YEAR"],
  // http://spark.apache.org/docs/latest/sql-ref-functions-builtin.html#json-functions
  json: ["FROM_JSON", "GET_JSON_OBJECT", "JSON_ARRAY_LENGTH", "JSON_OBJECT_KEYS", "JSON_TUPLE", "SCHEMA_OF_JSON", "TO_JSON"],
  // http://spark.apache.org/docs/latest/api/sql/index.html
  misc: [
    "ABS",
    "ACOS",
    "ACOSH",
    "AGGREGATE",
    "ARRAY_SORT",
    "ASCII",
    "ASIN",
    "ASINH",
    "ASSERT_TRUE",
    "ATAN",
    "ATAN2",
    "ATANH",
    "BASE64",
    "BIGINT",
    "BIN",
    "BINARY",
    "BIT_COUNT",
    "BIT_GET",
    "BIT_LENGTH",
    "BOOLEAN",
    "BROUND",
    "BTRIM",
    "CARDINALITY",
    "CBRT",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHAR_LENGTH",
    "CHARACTER_LENGTH",
    "CHR",
    "CONCAT",
    "CONCAT_WS",
    "CONV",
    "COS",
    "COSH",
    "COT",
    "CRC32",
    "CURRENT_CATALOG",
    "CURRENT_DATABASE",
    "CURRENT_USER",
    "DATE",
    "DECIMAL",
    "DEGREES",
    "DOUBLE",
    // 'E',
    "ELT",
    "EXP",
    "EXPM1",
    "FACTORIAL",
    "FIND_IN_SET",
    "FLOAT",
    "FLOOR",
    "FORALL",
    "FORMAT_NUMBER",
    "FORMAT_STRING",
    "FROM_CSV",
    "GETBIT",
    "HASH",
    "HEX",
    "HYPOT",
    "INITCAP",
    "INLINE",
    "INLINE_OUTER",
    "INPUT_FILE_BLOCK_LENGTH",
    "INPUT_FILE_BLOCK_START",
    "INPUT_FILE_NAME",
    "INSTR",
    "INT",
    "ISNAN",
    "ISNOTNULL",
    "ISNULL",
    "JAVA_METHOD",
    "LCASE",
    "LEFT",
    "LENGTH",
    "LEVENSHTEIN",
    "LN",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG1P",
    "LOG2",
    "LOWER",
    "LPAD",
    "LTRIM",
    "MAP_FILTER",
    "MAP_ZIP_WITH",
    "MD5",
    "MOD",
    "MONOTONICALLY_INCREASING_ID",
    "NAMED_STRUCT",
    "NANVL",
    "NEGATIVE",
    "NVL",
    "NVL2",
    "OCTET_LENGTH",
    "OVERLAY",
    "PARSE_URL",
    "PI",
    "PMOD",
    "POSEXPLODE",
    "POSEXPLODE_OUTER",
    "POSITION",
    "POSITIVE",
    "POW",
    "POWER",
    "PRINTF",
    "RADIANS",
    "RAISE_ERROR",
    "RAND",
    "RANDN",
    "RANDOM",
    "REFLECT",
    "REGEXP_EXTRACT",
    "REGEXP_EXTRACT_ALL",
    "REGEXP_LIKE",
    "REGEXP_REPLACE",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RINT",
    "ROUND",
    "RPAD",
    "RTRIM",
    "SCHEMA_OF_CSV",
    "SENTENCES",
    "SHA",
    "SHA1",
    "SHA2",
    "SHIFTLEFT",
    "SHIFTRIGHT",
    "SHIFTRIGHTUNSIGNED",
    "SIGN",
    "SIGNUM",
    "SIN",
    "SINH",
    "SMALLINT",
    "SOUNDEX",
    "SPACE",
    "SPARK_PARTITION_ID",
    "SPLIT",
    "SQRT",
    "STACK",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "TAN",
    "TANH",
    "TIMESTAMP",
    "TINYINT",
    "TO_CSV",
    "TRANSFORM_KEYS",
    "TRANSFORM_VALUES",
    "TRANSLATE",
    "TRIM",
    "TRY_ADD",
    "TRY_DIVIDE",
    "TYPEOF",
    "UCASE",
    "UNBASE64",
    "UNHEX",
    "UPPER",
    "UUID",
    "VERSION",
    "WIDTH_BUCKET",
    "XPATH",
    "XPATH_BOOLEAN",
    "XPATH_DOUBLE",
    "XPATH_FLOAT",
    "XPATH_INT",
    "XPATH_LONG",
    "XPATH_NUMBER",
    "XPATH_SHORT",
    "XPATH_STRING",
    "XXHASH64",
    "ZIP_WITH"
  ],
  cast: ["CAST"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Parameterized data types
  // https://spark.apache.org/docs/latest/sql-ref-datatypes.html
  dataTypes: [
    "DECIMAL",
    "DEC",
    "NUMERIC",
    // No varchar type in Spark, only STRING. Added for the sake of tests
    "VARCHAR"
  ]
}), V3 = fe(["SELECT [ALL | DISTINCT]"]), W3 = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "SORT BY",
  "CLUSTER BY",
  "DISTRIBUTE BY",
  "LIMIT",
  // Data manipulation
  // - insert:
  "INSERT [INTO | OVERWRITE] [TABLE]",
  "VALUES",
  // - insert overwrite directory:
  //   https://spark.apache.org/docs/latest/sql-ref-syntax-dml-insert-overwrite-directory.html
  "INSERT OVERWRITE [LOCAL] DIRECTORY",
  // - load:
  //   https://spark.apache.org/docs/latest/sql-ref-syntax-dml-load.html
  "LOAD DATA [LOCAL] INPATH",
  "[OVERWRITE] INTO TABLE",
  // Data definition
  "CREATE [OR REPLACE] [GLOBAL TEMPORARY | TEMPORARY] VIEW [IF NOT EXISTS]",
  "CREATE [EXTERNAL] TABLE [IF NOT EXISTS]"
]), BC = fe([
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD COLUMNS",
  "DROP {COLUMN | COLUMNS}",
  "RENAME TO",
  "RENAME COLUMN",
  "ALTER COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "LATERAL VIEW",
  "ALTER DATABASE",
  "ALTER VIEW",
  "CREATE DATABASE",
  "CREATE FUNCTION",
  "DROP DATABASE",
  "DROP FUNCTION",
  "DROP VIEW",
  "REPAIR TABLE",
  "USE DATABASE",
  // Data Retrieval
  "TABLESAMPLE",
  "PIVOT",
  "TRANSFORM",
  "EXPLAIN",
  // Auxiliary
  "ADD FILE",
  "ADD JAR",
  "ANALYZE TABLE",
  "CACHE TABLE",
  "CLEAR CACHE",
  "DESCRIBE DATABASE",
  "DESCRIBE FUNCTION",
  "DESCRIBE QUERY",
  "DESCRIBE TABLE",
  "LIST FILE",
  "LIST JAR",
  "REFRESH",
  "REFRESH TABLE",
  "REFRESH FUNCTION",
  "RESET",
  "SHOW COLUMNS",
  "SHOW CREATE TABLE",
  "SHOW DATABASES",
  "SHOW FUNCTIONS",
  "SHOW PARTITIONS",
  "SHOW TABLE EXTENDED",
  "SHOW TABLES",
  "SHOW TBLPROPERTIES",
  "SHOW VIEWS",
  "UNCACHE TABLE"
]), k3 = fe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), X3 = fe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL [INNER] JOIN",
  "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN",
  // non-standard-joins
  "[LEFT] {ANTI | SEMI} JOIN",
  "NATURAL [LEFT] {ANTI | SEMI} JOIN"
]), j3 = fe(["ON DELETE", "ON UPDATE", "CURRENT ROW", "{ROWS | RANGE} BETWEEN"]), K3 = {
  tokenizerOptions: {
    reservedSelect: V3,
    reservedClauses: [...W3, ...BC],
    reservedSetOperations: k3,
    reservedJoins: X3,
    reservedPhrases: j3,
    supportsXor: !0,
    reservedKeywords: F3,
    reservedFunctionNames: Y3,
    extraParens: ["[]"],
    stringTypes: ["''-bs", '""-bs', {
      quote: "''-raw",
      prefixes: ["R", "X"],
      requirePrefix: !0
    }, {
      quote: '""-raw',
      prefixes: ["R", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    variableTypes: [{
      quote: "{}",
      prefixes: ["$"],
      requirePrefix: !0
    }],
    operators: ["%", "~", "^", "|", "&", "<=>", "==", "!", "||", "->"],
    postProcess: J3
  },
  formatOptions: {
    onelineClauses: BC
  }
};
function J3(n) {
  return n.map((a, s) => {
    const o = n[s - 1] || ws, c = n[s + 1] || ws;
    return ki.WINDOW(a) && c.type === Ee.OPEN_PAREN ? {
      ...a,
      type: Ee.RESERVED_FUNCTION_NAME
    } : a.text === "ITEMS" && a.type === Ee.RESERVED_KEYWORD && !(o.text === "COLLECTION" && c.text === "TERMINATED") ? {
      ...a,
      type: Ee.IDENTIFIER,
      text: a.raw
    } : a;
  });
}
const z3 = ut({
  // https://www.sqlite.org/lang_corefunc.html
  scalar: ["ABS", "CHANGES", "CHAR", "COALESCE", "FORMAT", "GLOB", "HEX", "IFNULL", "IIF", "INSTR", "LAST_INSERT_ROWID", "LENGTH", "LIKE", "LIKELIHOOD", "LIKELY", "LOAD_EXTENSION", "LOWER", "LTRIM", "NULLIF", "PRINTF", "QUOTE", "RANDOM", "RANDOMBLOB", "REPLACE", "ROUND", "RTRIM", "SIGN", "SOUNDEX", "SQLITE_COMPILEOPTION_GET", "SQLITE_COMPILEOPTION_USED", "SQLITE_OFFSET", "SQLITE_SOURCE_ID", "SQLITE_VERSION", "SUBSTR", "SUBSTRING", "TOTAL_CHANGES", "TRIM", "TYPEOF", "UNICODE", "UNLIKELY", "UPPER", "ZEROBLOB"],
  // https://www.sqlite.org/lang_aggfunc.html
  aggregate: ["AVG", "COUNT", "GROUP_CONCAT", "MAX", "MIN", "SUM", "TOTAL"],
  // https://www.sqlite.org/lang_datefunc.html
  datetime: ["DATE", "TIME", "DATETIME", "JULIANDAY", "UNIXEPOCH", "STRFTIME"],
  // https://www.sqlite.org/windowfunctions.html#biwinfunc
  window: ["row_number", "rank", "dense_rank", "percent_rank", "cume_dist", "ntile", "lag", "lead", "first_value", "last_value", "nth_value"],
  // https://www.sqlite.org/lang_mathfunc.html
  math: ["ACOS", "ACOSH", "ASIN", "ASINH", "ATAN", "ATAN2", "ATANH", "CEIL", "CEILING", "COS", "COSH", "DEGREES", "EXP", "FLOOR", "LN", "LOG", "LOG", "LOG10", "LOG2", "MOD", "PI", "POW", "POWER", "RADIANS", "SIN", "SINH", "SQRT", "TAN", "TANH", "TRUNC"],
  // https://www.sqlite.org/json1.html
  json: ["JSON", "JSON_ARRAY", "JSON_ARRAY_LENGTH", "JSON_ARRAY_LENGTH", "JSON_EXTRACT", "JSON_INSERT", "JSON_OBJECT", "JSON_PATCH", "JSON_REMOVE", "JSON_REPLACE", "JSON_SET", "JSON_TYPE", "JSON_TYPE", "JSON_VALID", "JSON_QUOTE", "JSON_GROUP_ARRAY", "JSON_GROUP_OBJECT", "JSON_EACH", "JSON_TREE"],
  cast: ["CAST"],
  // SQLite allows parameters for all data types
  // Well, in fact it allows any word as a data type, e.g. CREATE TABLE foo (col1 madeupname(123));
  // https://www.sqlite.org/datatype3.html
  dataTypes: ["CHARACTER", "VARCHAR", "VARYING CHARACTER", "NCHAR", "NATIVE CHARACTER", "NVARCHAR", "NUMERIC", "DECIMAL"]
}), Z3 = ut({
  // https://www.sqlite.org/lang_keywords.html
  all: ["ABORT", "ACTION", "ADD", "AFTER", "ALL", "ALTER", "AND", "ANY", "ARE", "ARRAY", "ALWAYS", "ANALYZE", "AS", "ASC", "ATTACH", "AUTOINCREMENT", "BEFORE", "BEGIN", "BETWEEN", "BY", "CASCADE", "CASE", "CAST", "CHECK", "COLLATE", "COLUMN", "COMMIT", "CONFLICT", "CONSTRAINT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "DATABASE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DESC", "DETACH", "DISTINCT", "DO", "DROP", "EACH", "ELSE", "END", "ESCAPE", "EXCEPT", "EXCLUDE", "EXCLUSIVE", "EXISTS", "EXPLAIN", "FAIL", "FILTER", "FIRST", "FOLLOWING", "FOR", "FOREIGN", "FROM", "FULL", "GENERATED", "GLOB", "GROUP", "GROUPS", "HAVING", "IF", "IGNORE", "IMMEDIATE", "IN", "INDEX", "INDEXED", "INITIALLY", "INNER", "INSERT", "INSTEAD", "INTERSECT", "INTO", "IS", "ISNULL", "JOIN", "KEY", "LAST", "LEFT", "LIKE", "LIMIT", "MATCH", "MATERIALIZED", "NATURAL", "NO", "NOT", "NOTHING", "NOTNULL", "NULL", "NULLS", "OF", "OFFSET", "ON", "ONLY", "OPEN", "OR", "ORDER", "OTHERS", "OUTER", "OVER", "PARTITION", "PLAN", "PRAGMA", "PRECEDING", "PRIMARY", "QUERY", "RAISE", "RANGE", "RECURSIVE", "REFERENCES", "REGEXP", "REINDEX", "RELEASE", "RENAME", "REPLACE", "RESTRICT", "RETURNING", "RIGHT", "ROLLBACK", "ROW", "ROWS", "SAVEPOINT", "SELECT", "SET", "TABLE", "TEMP", "TEMPORARY", "THEN", "TIES", "TO", "TRANSACTION", "TRIGGER", "UNBOUNDED", "UNION", "UNIQUE", "UPDATE", "USING", "VACUUM", "VALUES", "VIEW", "VIRTUAL", "WHEN", "WHERE", "WINDOW", "WITH", "WITHOUT"]
}), q3 = fe(["SELECT [ALL | DISTINCT]"]), Q3 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [OR ABORT | OR FAIL | OR IGNORE | OR REPLACE | OR ROLLBACK] INTO",
  "REPLACE INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [TEMPORARY | TEMP] VIEW [IF NOT EXISTS]",
  "CREATE [TEMPORARY | TEMP] TABLE [IF NOT EXISTS]"
]), FC = fe([
  // - update:
  "UPDATE [OR ABORT | OR FAIL | OR IGNORE | OR REPLACE | OR ROLLBACK]",
  // - insert:
  "ON CONFLICT",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD [COLUMN]",
  "DROP [COLUMN]",
  "RENAME [COLUMN]",
  "RENAME TO",
  // - set schema
  "SET SCHEMA"
]), $3 = fe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), e5 = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), t5 = fe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE | GROUPS} BETWEEN"]), n5 = {
  tokenizerOptions: {
    reservedSelect: q3,
    reservedClauses: [...Q3, ...FC],
    reservedSetOperations: $3,
    reservedJoins: e5,
    reservedPhrases: t5,
    reservedKeywords: Z3,
    reservedFunctionNames: z3,
    stringTypes: [
      "''-qq",
      {
        quote: "''-raw",
        prefixes: ["X"],
        requirePrefix: !0
      }
      // Depending on context SQLite also supports double-quotes for strings,
      // and single-quotes for identifiers.
    ],
    identTypes: ['""-qq', "``", "[]"],
    // https://www.sqlite.org/lang_expr.html#parameters
    paramTypes: {
      positional: !0,
      numbered: ["?"],
      named: [":", "@", "$"]
    },
    operators: ["%", "~", "&", "|", "<<", ">>", "==", "->", "->>", "||"]
  },
  formatOptions: {
    onelineClauses: FC
  }
}, r5 = ut({
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_9_set_function_specification
  set: ["GROUPING"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_10_window_function
  window: ["RANK", "DENSE_RANK", "PERCENT_RANK", "CUME_DIST", "ROW_NUMBER"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_27_numeric_value_function
  numeric: ["POSITION", "OCCURRENCES_REGEX", "POSITION_REGEX", "EXTRACT", "CHAR_LENGTH", "CHARACTER_LENGTH", "OCTET_LENGTH", "CARDINALITY", "ABS", "MOD", "LN", "EXP", "POWER", "SQRT", "FLOOR", "CEIL", "CEILING", "WIDTH_BUCKET"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_29_string_value_function
  string: ["SUBSTRING", "SUBSTRING_REGEX", "UPPER", "LOWER", "CONVERT", "TRANSLATE", "TRANSLATE_REGEX", "TRIM", "OVERLAY", "NORMALIZE", "SPECIFICTYPE"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_31_datetime_value_function
  datetime: ["CURRENT_DATE", "CURRENT_TIME", "LOCALTIME", "CURRENT_TIMESTAMP", "LOCALTIMESTAMP"],
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_6_38_multiset_value_function
  // SET serves multiple roles: a SET() function and a SET keyword e.g. in UPDATE table SET ...
  // multiset: ['SET'], (disabled for now)
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#_10_9_aggregate_function
  aggregate: [
    "COUNT",
    "AVG",
    "MAX",
    "MIN",
    "SUM",
    // 'EVERY',
    // 'ANY',
    // 'SOME',
    "STDDEV_POP",
    "STDDEV_SAMP",
    "VAR_SAMP",
    "VAR_POP",
    "COLLECT",
    "FUSION",
    "INTERSECTION",
    "COVAR_POP",
    "COVAR_SAMP",
    "CORR",
    "REGR_SLOPE",
    "REGR_INTERCEPT",
    "REGR_COUNT",
    "REGR_R2",
    "REGR_AVGX",
    "REGR_AVGY",
    "REGR_SXX",
    "REGR_SYY",
    "REGR_SXY",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC"
  ],
  // CAST is a pretty complex case, involving multiple forms:
  // - CAST(col AS int)
  // - CAST(...) WITH ...
  // - CAST FROM int
  // - CREATE CAST(mycol AS int) WITH ...
  cast: ["CAST"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Non-standard functions that have widespread support
  nonStandard: ["ROUND", "SIN", "COS", "TAN", "ASIN", "ACOS", "ATAN"],
  // Data types with parameters like VARCHAR(100)
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#predefined-type
  dataTypes: ["CHARACTER", "CHAR", "CHARACTER VARYING", "CHAR VARYING", "VARCHAR", "CHARACTER LARGE OBJECT", "CHAR LARGE OBJECT", "CLOB", "NATIONAL CHARACTER", "NATIONAL CHAR", "NCHAR", "NATIONAL CHARACTER VARYING", "NATIONAL CHAR VARYING", "NCHAR VARYING", "NATIONAL CHARACTER LARGE OBJECT", "NCHAR LARGE OBJECT", "NCLOB", "BINARY", "BINARY VARYING", "VARBINARY", "BINARY LARGE OBJECT", "BLOB", "NUMERIC", "DECIMAL", "DEC", "TIME", "TIMESTAMP"]
}), a5 = ut({
  // https://jakewheat.github.io/sql-overview/sql-2008-foundation-grammar.html#reserved-word
  all: [
    "ALL",
    "ALLOCATE",
    "ALTER",
    "ANY",
    // <- moved over from functions
    "ARE",
    "ARRAY",
    "AS",
    "ASENSITIVE",
    "ASYMMETRIC",
    "AT",
    "ATOMIC",
    "AUTHORIZATION",
    "BEGIN",
    "BETWEEN",
    "BIGINT",
    "BINARY",
    "BLOB",
    "BOOLEAN",
    "BOTH",
    "BY",
    "CALL",
    "CALLED",
    "CASCADED",
    "CAST",
    "CHAR",
    "CHARACTER",
    "CHECK",
    "CLOB",
    "CLOSE",
    "COALESCE",
    "COLLATE",
    "COLUMN",
    "COMMIT",
    "CONDITION",
    "CONNECT",
    "CONSTRAINT",
    "CORRESPONDING",
    "CREATE",
    "CROSS",
    "CUBE",
    "CURRENT",
    "CURRENT_CATALOG",
    "CURRENT_DEFAULT_TRANSFORM_GROUP",
    "CURRENT_PATH",
    "CURRENT_ROLE",
    "CURRENT_SCHEMA",
    "CURRENT_TRANSFORM_GROUP_FOR_TYPE",
    "CURRENT_USER",
    "CURSOR",
    "CYCLE",
    "DATE",
    "DAY",
    "DEALLOCATE",
    "DEC",
    "DECIMAL",
    "DECLARE",
    "DEFAULT",
    "DELETE",
    "DEREF",
    "DESCRIBE",
    "DETERMINISTIC",
    "DISCONNECT",
    "DISTINCT",
    "DOUBLE",
    "DROP",
    "DYNAMIC",
    "EACH",
    "ELEMENT",
    "END-EXEC",
    "ESCAPE",
    "EVERY",
    // <- moved over from functions
    "EXCEPT",
    "EXEC",
    "EXECUTE",
    "EXISTS",
    "EXTERNAL",
    "FALSE",
    "FETCH",
    "FILTER",
    "FLOAT",
    "FOR",
    "FOREIGN",
    "FREE",
    "FROM",
    "FULL",
    "FUNCTION",
    "GET",
    "GLOBAL",
    "GRANT",
    "GROUP",
    "HAVING",
    "HOLD",
    "HOUR",
    "IDENTITY",
    "IN",
    "INDICATOR",
    "INNER",
    "INOUT",
    "INSENSITIVE",
    "INSERT",
    "INT",
    "INTEGER",
    "INTERSECT",
    "INTERVAL",
    "INTO",
    "IS",
    "LANGUAGE",
    "LARGE",
    "LATERAL",
    "LEADING",
    "LEFT",
    "LIKE",
    "LIKE_REGEX",
    "LOCAL",
    "MATCH",
    "MEMBER",
    "MERGE",
    "METHOD",
    "MINUTE",
    "MODIFIES",
    "MODULE",
    "MONTH",
    "MULTISET",
    "NATIONAL",
    "NATURAL",
    "NCHAR",
    "NCLOB",
    "NEW",
    "NO",
    "NONE",
    "NOT",
    "NULL",
    "NULLIF",
    "NUMERIC",
    "OF",
    "OLD",
    "ON",
    "ONLY",
    "OPEN",
    "ORDER",
    "OUT",
    "OUTER",
    "OVER",
    "OVERLAPS",
    "PARAMETER",
    "PARTITION",
    "PRECISION",
    "PREPARE",
    "PRIMARY",
    "PROCEDURE",
    "RANGE",
    "READS",
    "REAL",
    "RECURSIVE",
    "REF",
    "REFERENCES",
    "REFERENCING",
    "RELEASE",
    "RESULT",
    "RETURN",
    "RETURNS",
    "REVOKE",
    "RIGHT",
    "ROLLBACK",
    "ROLLUP",
    "ROW",
    "ROWS",
    "SAVEPOINT",
    "SCOPE",
    "SCROLL",
    "SEARCH",
    "SECOND",
    "SELECT",
    "SENSITIVE",
    "SESSION_USER",
    "SET",
    "SIMILAR",
    "SMALLINT",
    "SOME",
    // <- moved over from functions
    "SPECIFIC",
    "SQL",
    "SQLEXCEPTION",
    "SQLSTATE",
    "SQLWARNING",
    "START",
    "STATIC",
    "SUBMULTISET",
    "SYMMETRIC",
    "SYSTEM",
    "SYSTEM_USER",
    "TABLE",
    "TABLESAMPLE",
    "THEN",
    "TIME",
    "TIMESTAMP",
    "TIMEZONE_HOUR",
    "TIMEZONE_MINUTE",
    "TO",
    "TRAILING",
    "TRANSLATION",
    "TREAT",
    "TRIGGER",
    "TRUE",
    "UESCAPE",
    "UNION",
    "UNIQUE",
    "UNKNOWN",
    "UNNEST",
    "UPDATE",
    "USER",
    "USING",
    "VALUE",
    "VALUES",
    "VARBINARY",
    "VARCHAR",
    "VARYING",
    "WHENEVER",
    "WINDOW",
    "WITHIN",
    "WITHOUT",
    "YEAR"
  ]
}), i5 = fe(["SELECT [ALL | DISTINCT]"]), s5 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [RECURSIVE] VIEW",
  "CREATE [GLOBAL TEMPORARY | LOCAL TEMPORARY] TABLE"
]), YC = fe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE",
  // - alter table:
  "ALTER TABLE",
  "ADD COLUMN",
  "DROP [COLUMN]",
  "RENAME COLUMN",
  "RENAME TO",
  "ALTER [COLUMN]",
  "{SET | DROP} DEFAULT",
  // for alter column
  "ADD SCOPE",
  // for alter column
  "DROP SCOPE {CASCADE | RESTRICT}",
  // for alter column
  "RESTART WITH",
  // for alter column
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "SET SCHEMA"
]), o5 = fe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), l5 = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), u5 = fe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE} BETWEEN"]), E5 = {
  tokenizerOptions: {
    reservedSelect: i5,
    reservedClauses: [...s5, ...YC],
    reservedSetOperations: o5,
    reservedJoins: l5,
    reservedPhrases: u5,
    reservedKeywords: a5,
    reservedFunctionNames: r5,
    stringTypes: [{
      quote: "''-qq-bs",
      prefixes: ["N", "U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X"],
      requirePrefix: !0
    }],
    identTypes: ['""-qq', "``"],
    paramTypes: {
      positional: !0
    },
    operators: ["||"]
  },
  formatOptions: {
    onelineClauses: YC
  }
}, c5 = ut({
  // https://github.com/trinodb/trino/tree/432d2897bdef99388c1a47188743a061c4ac1f34/docs/src/main/sphinx/functions
  // rg '^\.\. function::' ./docs/src/main/sphinx/functions | cut -d' ' -f 3 | cut -d '(' -f 1 | sort | uniq
  // rg '\* ' ./docs/src/main/sphinx/functions/list-by-topic.rst | grep    '\* :func:' | cut -d'`' -f 2
  // rg '\* ' ./docs/src/main/sphinx/functions/list-by-topic.rst | grep -v '\* :func:'
  // grep -e '^- ' ./docs/src/main/sphinx/functions/list.rst | grep  -e '^- :func:' | cut -d'`' -f2
  // grep -e '^- ' ./docs/src/main/sphinx/functions/list.rst | grep -ve '^- :func:'
  all: ["ABS", "ACOS", "ALL_MATCH", "ANY_MATCH", "APPROX_DISTINCT", "APPROX_MOST_FREQUENT", "APPROX_PERCENTILE", "APPROX_SET", "ARBITRARY", "ARRAYS_OVERLAP", "ARRAY_AGG", "ARRAY_DISTINCT", "ARRAY_EXCEPT", "ARRAY_INTERSECT", "ARRAY_JOIN", "ARRAY_MAX", "ARRAY_MIN", "ARRAY_POSITION", "ARRAY_REMOVE", "ARRAY_SORT", "ARRAY_UNION", "ASIN", "ATAN", "ATAN2", "AT_TIMEZONE", "AVG", "BAR", "BETA_CDF", "BING_TILE", "BING_TILES_AROUND", "BING_TILE_AT", "BING_TILE_COORDINATES", "BING_TILE_POLYGON", "BING_TILE_QUADKEY", "BING_TILE_ZOOM_LEVEL", "BITWISE_AND", "BITWISE_AND_AGG", "BITWISE_LEFT_SHIFT", "BITWISE_NOT", "BITWISE_OR", "BITWISE_OR_AGG", "BITWISE_RIGHT_SHIFT", "BITWISE_RIGHT_SHIFT_ARITHMETIC", "BITWISE_XOR", "BIT_COUNT", "BOOL_AND", "BOOL_OR", "CARDINALITY", "CAST", "CBRT", "CEIL", "CEILING", "CHAR2HEXINT", "CHECKSUM", "CHR", "CLASSIFY", "COALESCE", "CODEPOINT", "COLOR", "COMBINATIONS", "CONCAT", "CONCAT_WS", "CONTAINS", "CONTAINS_SEQUENCE", "CONVEX_HULL_AGG", "CORR", "COS", "COSH", "COSINE_SIMILARITY", "COUNT", "COUNT_IF", "COVAR_POP", "COVAR_SAMP", "CRC32", "CUME_DIST", "CURRENT_CATALOG", "CURRENT_DATE", "CURRENT_GROUPS", "CURRENT_SCHEMA", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "CURRENT_USER", "DATE", "DATE_ADD", "DATE_DIFF", "DATE_FORMAT", "DATE_PARSE", "DATE_TRUNC", "DAY", "DAY_OF_MONTH", "DAY_OF_WEEK", "DAY_OF_YEAR", "DEGREES", "DENSE_RANK", "DOW", "DOY", "E", "ELEMENT_AT", "EMPTY_APPROX_SET", "EVALUATE_CLASSIFIER_PREDICTIONS", "EVERY", "EXP", "EXTRACT", "FEATURES", "FILTER", "FIRST_VALUE", "FLATTEN", "FLOOR", "FORMAT", "FORMAT_DATETIME", "FORMAT_NUMBER", "FROM_BASE", "FROM_BASE32", "FROM_BASE64", "FROM_BASE64URL", "FROM_BIG_ENDIAN_32", "FROM_BIG_ENDIAN_64", "FROM_ENCODED_POLYLINE", "FROM_GEOJSON_GEOMETRY", "FROM_HEX", "FROM_IEEE754_32", "FROM_IEEE754_64", "FROM_ISO8601_DATE", "FROM_ISO8601_TIMESTAMP", "FROM_ISO8601_TIMESTAMP_NANOS", "FROM_UNIXTIME", "FROM_UNIXTIME_NANOS", "FROM_UTF8", "GEOMETRIC_MEAN", "GEOMETRY_FROM_HADOOP_SHAPE", "GEOMETRY_INVALID_REASON", "GEOMETRY_NEAREST_POINTS", "GEOMETRY_TO_BING_TILES", "GEOMETRY_UNION", "GEOMETRY_UNION_AGG", "GREATEST", "GREAT_CIRCLE_DISTANCE", "HAMMING_DISTANCE", "HASH_COUNTS", "HISTOGRAM", "HMAC_MD5", "HMAC_SHA1", "HMAC_SHA256", "HMAC_SHA512", "HOUR", "HUMAN_READABLE_SECONDS", "IF", "INDEX", "INFINITY", "INTERSECTION_CARDINALITY", "INVERSE_BETA_CDF", "INVERSE_NORMAL_CDF", "IS_FINITE", "IS_INFINITE", "IS_JSON_SCALAR", "IS_NAN", "JACCARD_INDEX", "JSON_ARRAY_CONTAINS", "JSON_ARRAY_GET", "JSON_ARRAY_LENGTH", "JSON_EXISTS", "JSON_EXTRACT", "JSON_EXTRACT_SCALAR", "JSON_FORMAT", "JSON_PARSE", "JSON_QUERY", "JSON_SIZE", "JSON_VALUE", "KURTOSIS", "LAG", "LAST_DAY_OF_MONTH", "LAST_VALUE", "LEAD", "LEARN_CLASSIFIER", "LEARN_LIBSVM_CLASSIFIER", "LEARN_LIBSVM_REGRESSOR", "LEARN_REGRESSOR", "LEAST", "LENGTH", "LEVENSHTEIN_DISTANCE", "LINE_INTERPOLATE_POINT", "LINE_INTERPOLATE_POINTS", "LINE_LOCATE_POINT", "LISTAGG", "LN", "LOCALTIME", "LOCALTIMESTAMP", "LOG", "LOG10", "LOG2", "LOWER", "LPAD", "LTRIM", "LUHN_CHECK", "MAKE_SET_DIGEST", "MAP", "MAP_AGG", "MAP_CONCAT", "MAP_ENTRIES", "MAP_FILTER", "MAP_FROM_ENTRIES", "MAP_KEYS", "MAP_UNION", "MAP_VALUES", "MAP_ZIP_WITH", "MAX", "MAX_BY", "MD5", "MERGE", "MERGE_SET_DIGEST", "MILLISECOND", "MIN", "MINUTE", "MIN_BY", "MOD", "MONTH", "MULTIMAP_AGG", "MULTIMAP_FROM_ENTRIES", "MURMUR3", "NAN", "NGRAMS", "NONE_MATCH", "NORMALIZE", "NORMAL_CDF", "NOW", "NTH_VALUE", "NTILE", "NULLIF", "NUMERIC_HISTOGRAM", "OBJECTID", "OBJECTID_TIMESTAMP", "PARSE_DATA_SIZE", "PARSE_DATETIME", "PARSE_DURATION", "PERCENT_RANK", "PI", "POSITION", "POW", "POWER", "QDIGEST_AGG", "QUARTER", "RADIANS", "RAND", "RANDOM", "RANK", "REDUCE", "REDUCE_AGG", "REGEXP_COUNT", "REGEXP_EXTRACT", "REGEXP_EXTRACT_ALL", "REGEXP_LIKE", "REGEXP_POSITION", "REGEXP_REPLACE", "REGEXP_SPLIT", "REGRESS", "REGR_INTERCEPT", "REGR_SLOPE", "RENDER", "REPEAT", "REPLACE", "REVERSE", "RGB", "ROUND", "ROW_NUMBER", "RPAD", "RTRIM", "SECOND", "SEQUENCE", "SHA1", "SHA256", "SHA512", "SHUFFLE", "SIGN", "SIMPLIFY_GEOMETRY", "SIN", "SKEWNESS", "SLICE", "SOUNDEX", "SPATIAL_PARTITIONING", "SPATIAL_PARTITIONS", "SPLIT", "SPLIT_PART", "SPLIT_TO_MAP", "SPLIT_TO_MULTIMAP", "SPOOKY_HASH_V2_32", "SPOOKY_HASH_V2_64", "SQRT", "STARTS_WITH", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "STRPOS", "ST_AREA", "ST_ASBINARY", "ST_ASTEXT", "ST_BOUNDARY", "ST_BUFFER", "ST_CENTROID", "ST_CONTAINS", "ST_CONVEXHULL", "ST_COORDDIM", "ST_CROSSES", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_ENDPOINT", "ST_ENVELOPE", "ST_ENVELOPEASPTS", "ST_EQUALS", "ST_EXTERIORRING", "ST_GEOMETRIES", "ST_GEOMETRYFROMTEXT", "ST_GEOMETRYN", "ST_GEOMETRYTYPE", "ST_GEOMFROMBINARY", "ST_INTERIORRINGN", "ST_INTERIORRINGS", "ST_INTERSECTION", "ST_INTERSECTS", "ST_ISCLOSED", "ST_ISEMPTY", "ST_ISRING", "ST_ISSIMPLE", "ST_ISVALID", "ST_LENGTH", "ST_LINEFROMTEXT", "ST_LINESTRING", "ST_MULTIPOINT", "ST_NUMGEOMETRIES", "ST_NUMINTERIORRING", "ST_NUMPOINTS", "ST_OVERLAPS", "ST_POINT", "ST_POINTN", "ST_POINTS", "ST_POLYGON", "ST_RELATE", "ST_STARTPOINT", "ST_SYMDIFFERENCE", "ST_TOUCHES", "ST_UNION", "ST_WITHIN", "ST_X", "ST_XMAX", "ST_XMIN", "ST_Y", "ST_YMAX", "ST_YMIN", "SUBSTR", "SUBSTRING", "SUM", "TAN", "TANH", "TDIGEST_AGG", "TIMESTAMP_OBJECTID", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO_BASE", "TO_BASE32", "TO_BASE64", "TO_BASE64URL", "TO_BIG_ENDIAN_32", "TO_BIG_ENDIAN_64", "TO_CHAR", "TO_DATE", "TO_ENCODED_POLYLINE", "TO_GEOJSON_GEOMETRY", "TO_GEOMETRY", "TO_HEX", "TO_IEEE754_32", "TO_IEEE754_64", "TO_ISO8601", "TO_MILLISECONDS", "TO_SPHERICAL_GEOGRAPHY", "TO_TIMESTAMP", "TO_UNIXTIME", "TO_UTF8", "TRANSFORM", "TRANSFORM_KEYS", "TRANSFORM_VALUES", "TRANSLATE", "TRIM", "TRIM_ARRAY", "TRUNCATE", "TRY", "TRY_CAST", "TYPEOF", "UPPER", "URL_DECODE", "URL_ENCODE", "URL_EXTRACT_FRAGMENT", "URL_EXTRACT_HOST", "URL_EXTRACT_PARAMETER", "URL_EXTRACT_PATH", "URL_EXTRACT_PORT", "URL_EXTRACT_PROTOCOL", "URL_EXTRACT_QUERY", "UUID", "VALUES_AT_QUANTILES", "VALUE_AT_QUANTILE", "VARIANCE", "VAR_POP", "VAR_SAMP", "VERSION", "WEEK", "WEEK_OF_YEAR", "WIDTH_BUCKET", "WILSON_INTERVAL_LOWER", "WILSON_INTERVAL_UPPER", "WITH_TIMEZONE", "WORD_STEM", "XXHASH64", "YEAR", "YEAR_OF_WEEK", "YOW", "ZIP", "ZIP_WITH"],
  // https://trino.io/docs/current/sql/match-recognize.html#row-pattern-recognition-expressions
  rowPattern: ["CLASSIFIER", "FIRST", "LAST", "MATCH_NUMBER", "NEXT", "PERMUTE", "PREV"]
}), f5 = ut({
  // https://github.com/trinodb/trino/blob/432d2897bdef99388c1a47188743a061c4ac1f34/core/trino-parser/src/main/antlr4/io/trino/sql/parser/SqlBase.g4#L858-L1128
  all: ["ABSENT", "ADD", "ADMIN", "AFTER", "ALL", "ALTER", "ANALYZE", "AND", "ANY", "ARRAY", "AS", "ASC", "AT", "AUTHORIZATION", "BERNOULLI", "BETWEEN", "BOTH", "BY", "CALL", "CASCADE", "CASE", "CATALOGS", "COLUMN", "COLUMNS", "COMMENT", "COMMIT", "COMMITTED", "CONDITIONAL", "CONSTRAINT", "COPARTITION", "CREATE", "CROSS", "CUBE", "CURRENT", "CURRENT_PATH", "CURRENT_ROLE", "DATA", "DEALLOCATE", "DEFAULT", "DEFINE", "DEFINER", "DELETE", "DENY", "DESC", "DESCRIBE", "DESCRIPTOR", "DISTINCT", "DISTRIBUTED", "DOUBLE", "DROP", "ELSE", "EMPTY", "ENCODING", "END", "ERROR", "ESCAPE", "EXCEPT", "EXCLUDING", "EXECUTE", "EXISTS", "EXPLAIN", "FALSE", "FETCH", "FINAL", "FIRST", "FOLLOWING", "FOR", "FROM", "FULL", "FUNCTIONS", "GRANT", "GRANTED", "GRANTS", "GRAPHVIZ", "GROUP", "GROUPING", "GROUPS", "HAVING", "IGNORE", "IN", "INCLUDING", "INITIAL", "INNER", "INPUT", "INSERT", "INTERSECT", "INTERVAL", "INTO", "INVOKER", "IO", "IS", "ISOLATION", "JOIN", "JSON", "JSON_ARRAY", "JSON_OBJECT", "KEEP", "KEY", "KEYS", "LAST", "LATERAL", "LEADING", "LEFT", "LEVEL", "LIKE", "LIMIT", "LOCAL", "LOGICAL", "MATCH", "MATCHED", "MATCHES", "MATCH_RECOGNIZE", "MATERIALIZED", "MEASURES", "NATURAL", "NEXT", "NFC", "NFD", "NFKC", "NFKD", "NO", "NONE", "NOT", "NULL", "NULLS", "OBJECT", "OF", "OFFSET", "OMIT", "ON", "ONE", "ONLY", "OPTION", "OR", "ORDER", "ORDINALITY", "OUTER", "OUTPUT", "OVER", "OVERFLOW", "PARTITION", "PARTITIONS", "PASSING", "PAST", "PATH", "PATTERN", "PER", "PERMUTE", "PRECEDING", "PRECISION", "PREPARE", "PRIVILEGES", "PROPERTIES", "PRUNE", "QUOTES", "RANGE", "READ", "RECURSIVE", "REFRESH", "RENAME", "REPEATABLE", "RESET", "RESPECT", "RESTRICT", "RETURNING", "REVOKE", "RIGHT", "ROLE", "ROLES", "ROLLBACK", "ROLLUP", "ROW", "ROWS", "RUNNING", "SCALAR", "SCHEMA", "SCHEMAS", "SECURITY", "SEEK", "SELECT", "SERIALIZABLE", "SESSION", "SET", "SETS", "SHOW", "SKIP", "SOME", "START", "STATS", "STRING", "SUBSET", "SYSTEM", "TABLE", "TABLES", "TABLESAMPLE", "TEXT", "THEN", "TIES", "TIME", "TIMESTAMP", "TO", "TRAILING", "TRANSACTION", "TRUE", "TYPE", "UESCAPE", "UNBOUNDED", "UNCOMMITTED", "UNCONDITIONAL", "UNION", "UNIQUE", "UNKNOWN", "UNMATCHED", "UNNEST", "UPDATE", "USE", "USER", "USING", "UTF16", "UTF32", "UTF8", "VALIDATE", "VALUE", "VALUES", "VERBOSE", "VIEW", "WHEN", "WHERE", "WINDOW", "WITH", "WITHIN", "WITHOUT", "WORK", "WRAPPER", "WRITE", "ZONE"],
  // https://github.com/trinodb/trino/blob/432d2897bdef99388c1a47188743a061c4ac1f34/core/trino-main/src/main/java/io/trino/metadata/TypeRegistry.java#L131-L168
  // or https://trino.io/docs/current/language/types.html
  types: ["BIGINT", "INT", "INTEGER", "SMALLINT", "TINYINT", "BOOLEAN", "DATE", "DECIMAL", "REAL", "DOUBLE", "HYPERLOGLOG", "QDIGEST", "TDIGEST", "P4HYPERLOGLOG", "INTERVAL", "TIMESTAMP", "TIME", "VARBINARY", "VARCHAR", "CHAR", "ROW", "ARRAY", "MAP", "JSON", "JSON2016", "IPADDRESS", "GEOMETRY", "UUID", "SETDIGEST", "JONIREGEXP", "RE2JREGEXP", "LIKEPATTERN", "COLOR", "CODEPOINTS", "FUNCTION", "JSONPATH"]
}), T5 = fe(["SELECT [ALL | DISTINCT]"]), d5 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY [ALL | DISTINCT]",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  "CREATE [OR REPLACE] [MATERIALIZED] VIEW",
  "CREATE TABLE [IF NOT EXISTS]",
  // MATCH_RECOGNIZE
  "MATCH_RECOGNIZE",
  "MEASURES",
  "ONE ROW PER MATCH",
  "ALL ROWS PER MATCH",
  "AFTER MATCH",
  "PATTERN",
  "SUBSET",
  "DEFINE"
]), VC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "ADD COLUMN [IF NOT EXISTS]",
  "DROP COLUMN [IF EXISTS]",
  "RENAME COLUMN [IF EXISTS]",
  "RENAME TO",
  "SET AUTHORIZATION [USER | ROLE]",
  "SET PROPERTIES",
  "EXECUTE",
  // - truncate:
  "TRUNCATE TABLE",
  // other
  "ALTER SCHEMA",
  "ALTER MATERIALIZED VIEW",
  "ALTER VIEW",
  "CREATE SCHEMA",
  "CREATE ROLE",
  "DROP SCHEMA",
  "DROP MATERIALIZED VIEW",
  "DROP VIEW",
  "DROP ROLE",
  // Auxiliary
  "EXPLAIN",
  "ANALYZE",
  "EXPLAIN ANALYZE",
  "EXPLAIN ANALYZE VERBOSE",
  "USE",
  "COMMENT ON TABLE",
  "COMMENT ON COLUMN",
  "DESCRIBE INPUT",
  "DESCRIBE OUTPUT",
  "REFRESH MATERIALIZED VIEW",
  "RESET SESSION",
  "SET SESSION",
  "SET PATH",
  "SET TIME ZONE",
  "SHOW GRANTS",
  "SHOW CREATE TABLE",
  "SHOW CREATE SCHEMA",
  "SHOW CREATE VIEW",
  "SHOW CREATE MATERIALIZED VIEW",
  "SHOW TABLES",
  "SHOW SCHEMAS",
  "SHOW CATALOGS",
  "SHOW COLUMNS",
  "SHOW STATS FOR",
  "SHOW ROLES",
  "SHOW CURRENT ROLES",
  "SHOW ROLE GRANTS",
  "SHOW FUNCTIONS",
  "SHOW SESSION"
]), A5 = fe(["UNION [ALL | DISTINCT]", "EXCEPT [ALL | DISTINCT]", "INTERSECT [ALL | DISTINCT]"]), R5 = fe(["JOIN", "{LEFT | RIGHT | FULL} [OUTER] JOIN", "{INNER | CROSS} JOIN", "NATURAL [INNER] JOIN", "NATURAL {LEFT | RIGHT | FULL} [OUTER] JOIN"]), p5 = fe([
  "{ROWS | RANGE | GROUPS} BETWEEN",
  // comparison operator
  "IS [NOT] DISTINCT FROM"
]), S5 = {
  tokenizerOptions: {
    reservedSelect: T5,
    reservedClauses: [...d5, ...VC],
    reservedSetOperations: A5,
    reservedJoins: R5,
    reservedPhrases: p5,
    reservedKeywords: f5,
    reservedFunctionNames: c5,
    // Trino also supports {- ... -} parenthesis.
    // The formatting of these currently works out as a result of { and -
    // not getting a space added in-between.
    // https://trino.io/docs/current/sql/match-recognize.html#row-pattern-syntax
    extraParens: ["[]", "{}"],
    // https://trino.io/docs/current/language/types.html#string
    // https://trino.io/docs/current/language/types.html#varbinary
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["U&"]
    }, {
      quote: "''-raw",
      prefixes: ["X"],
      requirePrefix: !0
    }],
    // https://trino.io/docs/current/language/reserved.html
    identTypes: ['""-qq'],
    paramTypes: {
      positional: !0
    },
    operators: [
      "%",
      "->",
      "=>",
      ":",
      "||",
      // Row pattern syntax
      "|",
      "^",
      "$"
      // '?', conflicts with positional placeholders
    ]
  },
  formatOptions: {
    onelineClauses: VC
  }
}, h5 = ut({
  // https://docs.microsoft.com/en-us/sql/t-sql/functions/functions?view=sql-server-ver15
  aggregate: ["APPROX_COUNT_DISTINCT", "AVG", "CHECKSUM_AGG", "COUNT", "COUNT_BIG", "GROUPING", "GROUPING_ID", "MAX", "MIN", "STDEV", "STDEVP", "SUM", "VAR", "VARP"],
  analytic: ["CUME_DIST", "FIRST_VALUE", "LAG", "LAST_VALUE", "LEAD", "PERCENTILE_CONT", "PERCENTILE_DISC", "PERCENT_RANK", "Collation - COLLATIONPROPERTY", "Collation - TERTIARY_WEIGHTS"],
  configuration: ["@@DBTS", "@@LANGID", "@@LANGUAGE", "@@LOCK_TIMEOUT", "@@MAX_CONNECTIONS", "@@MAX_PRECISION", "@@NESTLEVEL", "@@OPTIONS", "@@REMSERVER", "@@SERVERNAME", "@@SERVICENAME", "@@SPID", "@@TEXTSIZE", "@@VERSION"],
  conversion: ["CAST", "CONVERT", "PARSE", "TRY_CAST", "TRY_CONVERT", "TRY_PARSE"],
  cryptographic: ["ASYMKEY_ID", "ASYMKEYPROPERTY", "CERTPROPERTY", "CERT_ID", "CRYPT_GEN_RANDOM", "DECRYPTBYASYMKEY", "DECRYPTBYCERT", "DECRYPTBYKEY", "DECRYPTBYKEYAUTOASYMKEY", "DECRYPTBYKEYAUTOCERT", "DECRYPTBYPASSPHRASE", "ENCRYPTBYASYMKEY", "ENCRYPTBYCERT", "ENCRYPTBYKEY", "ENCRYPTBYPASSPHRASE", "HASHBYTES", "IS_OBJECTSIGNED", "KEY_GUID", "KEY_ID", "KEY_NAME", "SIGNBYASYMKEY", "SIGNBYCERT", "SYMKEYPROPERTY", "VERIFYSIGNEDBYCERT", "VERIFYSIGNEDBYASYMKEY"],
  cursor: ["@@CURSOR_ROWS", "@@FETCH_STATUS", "CURSOR_STATUS"],
  dataType: ["DATALENGTH", "IDENT_CURRENT", "IDENT_INCR", "IDENT_SEED", "IDENTITY", "SQL_VARIANT_PROPERTY"],
  datetime: ["@@DATEFIRST", "CURRENT_TIMESTAMP", "CURRENT_TIMEZONE", "CURRENT_TIMEZONE_ID", "DATEADD", "DATEDIFF", "DATEDIFF_BIG", "DATEFROMPARTS", "DATENAME", "DATEPART", "DATETIME2FROMPARTS", "DATETIMEFROMPARTS", "DATETIMEOFFSETFROMPARTS", "DAY", "EOMONTH", "GETDATE", "GETUTCDATE", "ISDATE", "MONTH", "SMALLDATETIMEFROMPARTS", "SWITCHOFFSET", "SYSDATETIME", "SYSDATETIMEOFFSET", "SYSUTCDATETIME", "TIMEFROMPARTS", "TODATETIMEOFFSET", "YEAR", "JSON", "ISJSON", "JSON_VALUE", "JSON_QUERY", "JSON_MODIFY"],
  mathematical: ["ABS", "ACOS", "ASIN", "ATAN", "ATN2", "CEILING", "COS", "COT", "DEGREES", "EXP", "FLOOR", "LOG", "LOG10", "PI", "POWER", "RADIANS", "RAND", "ROUND", "SIGN", "SIN", "SQRT", "SQUARE", "TAN", "CHOOSE", "GREATEST", "IIF", "LEAST"],
  metadata: ["@@PROCID", "APP_NAME", "APPLOCK_MODE", "APPLOCK_TEST", "ASSEMBLYPROPERTY", "COL_LENGTH", "COL_NAME", "COLUMNPROPERTY", "DATABASEPROPERTYEX", "DB_ID", "DB_NAME", "FILE_ID", "FILE_IDEX", "FILE_NAME", "FILEGROUP_ID", "FILEGROUP_NAME", "FILEGROUPPROPERTY", "FILEPROPERTY", "FILEPROPERTYEX", "FULLTEXTCATALOGPROPERTY", "FULLTEXTSERVICEPROPERTY", "INDEX_COL", "INDEXKEY_PROPERTY", "INDEXPROPERTY", "NEXT VALUE FOR", "OBJECT_DEFINITION", "OBJECT_ID", "OBJECT_NAME", "OBJECT_SCHEMA_NAME", "OBJECTPROPERTY", "OBJECTPROPERTYEX", "ORIGINAL_DB_NAME", "PARSENAME", "SCHEMA_ID", "SCHEMA_NAME", "SCOPE_IDENTITY", "SERVERPROPERTY", "STATS_DATE", "TYPE_ID", "TYPE_NAME", "TYPEPROPERTY"],
  ranking: ["DENSE_RANK", "NTILE", "RANK", "ROW_NUMBER", "PUBLISHINGSERVERNAME"],
  security: ["CERTENCODED", "CERTPRIVATEKEY", "CURRENT_USER", "DATABASE_PRINCIPAL_ID", "HAS_DBACCESS", "HAS_PERMS_BY_NAME", "IS_MEMBER", "IS_ROLEMEMBER", "IS_SRVROLEMEMBER", "LOGINPROPERTY", "ORIGINAL_LOGIN", "PERMISSIONS", "PWDENCRYPT", "PWDCOMPARE", "SESSION_USER", "SESSIONPROPERTY", "SUSER_ID", "SUSER_NAME", "SUSER_SID", "SUSER_SNAME", "SYSTEM_USER", "USER", "USER_ID", "USER_NAME"],
  string: ["ASCII", "CHAR", "CHARINDEX", "CONCAT", "CONCAT_WS", "DIFFERENCE", "FORMAT", "LEFT", "LEN", "LOWER", "LTRIM", "NCHAR", "PATINDEX", "QUOTENAME", "REPLACE", "REPLICATE", "REVERSE", "RIGHT", "RTRIM", "SOUNDEX", "SPACE", "STR", "STRING_AGG", "STRING_ESCAPE", "STUFF", "SUBSTRING", "TRANSLATE", "TRIM", "UNICODE", "UPPER"],
  system: ["$PARTITION", "@@ERROR", "@@IDENTITY", "@@PACK_RECEIVED", "@@ROWCOUNT", "@@TRANCOUNT", "BINARY_CHECKSUM", "CHECKSUM", "COMPRESS", "CONNECTIONPROPERTY", "CONTEXT_INFO", "CURRENT_REQUEST_ID", "CURRENT_TRANSACTION_ID", "DECOMPRESS", "ERROR_LINE", "ERROR_MESSAGE", "ERROR_NUMBER", "ERROR_PROCEDURE", "ERROR_SEVERITY", "ERROR_STATE", "FORMATMESSAGE", "GET_FILESTREAM_TRANSACTION_CONTEXT", "GETANSINULL", "HOST_ID", "HOST_NAME", "ISNULL", "ISNUMERIC", "MIN_ACTIVE_ROWVERSION", "NEWID", "NEWSEQUENTIALID", "ROWCOUNT_BIG", "SESSION_CONTEXT", "XACT_STATE"],
  statistical: ["@@CONNECTIONS", "@@CPU_BUSY", "@@IDLE", "@@IO_BUSY", "@@PACK_SENT", "@@PACKET_ERRORS", "@@TIMETICKS", "@@TOTAL_ERRORS", "@@TOTAL_READ", "@@TOTAL_WRITE", "TEXTPTR", "TEXTVALID"],
  trigger: ["COLUMNS_UPDATED", "EVENTDATA", "TRIGGER_NESTLEVEL", "UPDATE"],
  // Shorthand functions to use in place of CASE expression
  caseAbbrev: ["COALESCE", "NULLIF"],
  // Parameterized types
  // https://docs.microsoft.com/en-us/sql/t-sql/data-types/data-types-transact-sql?view=sql-server-ver15
  dataTypes: ["DECIMAL", "NUMERIC", "FLOAT", "REAL", "DATETIME2", "DATETIMEOFFSET", "TIME", "CHAR", "VARCHAR", "NCHAR", "NVARCHAR", "BINARY", "VARBINARY"]
}), N5 = ut({
  // https://docs.microsoft.com/en-us/sql/t-sql/language-elements/reserved-keywords-transact-sql?view=sql-server-ver15
  standard: ["ADD", "ALL", "ALTER", "AND", "ANY", "AS", "ASC", "AUTHORIZATION", "BACKUP", "BEGIN", "BETWEEN", "BREAK", "BROWSE", "BULK", "BY", "CASCADE", "CHECK", "CHECKPOINT", "CLOSE", "CLUSTERED", "COALESCE", "COLLATE", "COLUMN", "COMMIT", "COMPUTE", "CONSTRAINT", "CONTAINS", "CONTAINSTABLE", "CONTINUE", "CONVERT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "DATABASE", "DBCC", "DEALLOCATE", "DECLARE", "DEFAULT", "DELETE", "DENY", "DESC", "DISK", "DISTINCT", "DISTRIBUTED", "DOUBLE", "DROP", "DUMP", "ERRLVL", "ESCAPE", "EXEC", "EXECUTE", "EXISTS", "EXIT", "EXTERNAL", "FETCH", "FILE", "FILLFACTOR", "FOR", "FOREIGN", "FREETEXT", "FREETEXTTABLE", "FROM", "FULL", "FUNCTION", "GOTO", "GRANT", "GROUP", "HAVING", "HOLDLOCK", "IDENTITY", "IDENTITYCOL", "IDENTITY_INSERT", "IF", "IN", "INDEX", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "JOIN", "KEY", "KILL", "LEFT", "LIKE", "LINENO", "LOAD", "MERGE", "NATIONAL", "NOCHECK", "NONCLUSTERED", "NOT", "NULL", "NULLIF", "OF", "OFF", "OFFSETS", "ON", "OPEN", "OPENDATASOURCE", "OPENQUERY", "OPENROWSET", "OPENXML", "OPTION", "OR", "ORDER", "OUTER", "OVER", "PERCENT", "PIVOT", "PLAN", "PRECISION", "PRIMARY", "PRINT", "PROC", "PROCEDURE", "PUBLIC", "RAISERROR", "READ", "READTEXT", "RECONFIGURE", "REFERENCES", "REPLICATION", "RESTORE", "RESTRICT", "RETURN", "REVERT", "REVOKE", "RIGHT", "ROLLBACK", "ROWCOUNT", "ROWGUIDCOL", "RULE", "SAVE", "SCHEMA", "SECURITYAUDIT", "SELECT", "SEMANTICKEYPHRASETABLE", "SEMANTICSIMILARITYDETAILSTABLE", "SEMANTICSIMILARITYTABLE", "SESSION_USER", "SET", "SETUSER", "SHUTDOWN", "SOME", "STATISTICS", "SYSTEM_USER", "TABLE", "TABLESAMPLE", "TEXTSIZE", "THEN", "TO", "TOP", "TRAN", "TRANSACTION", "TRIGGER", "TRUNCATE", "TRY_CONVERT", "TSEQUAL", "UNION", "UNIQUE", "UNPIVOT", "UPDATE", "UPDATETEXT", "USE", "USER", "VALUES", "VARYING", "VIEW", "WAITFOR", "WHERE", "WHILE", "WITH", "WITHIN GROUP", "WRITETEXT"],
  odbc: ["ABSOLUTE", "ACTION", "ADA", "ADD", "ALL", "ALLOCATE", "ALTER", "AND", "ANY", "ARE", "AS", "ASC", "ASSERTION", "AT", "AUTHORIZATION", "AVG", "BEGIN", "BETWEEN", "BIT", "BIT_LENGTH", "BOTH", "BY", "CASCADE", "CASCADED", "CAST", "CATALOG", "CHAR", "CHARACTER", "CHARACTER_LENGTH", "CHAR_LENGTH", "CHECK", "CLOSE", "COALESCE", "COLLATE", "COLLATION", "COLUMN", "COMMIT", "CONNECT", "CONNECTION", "CONSTRAINT", "CONSTRAINTS", "CONTINUE", "CONVERT", "CORRESPONDING", "COUNT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "DATE", "DAY", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFERRABLE", "DEFERRED", "DELETE", "DESC", "DESCRIBE", "DESCRIPTOR", "DIAGNOSTICS", "DISCONNECT", "DISTINCT", "DOMAIN", "DOUBLE", "DROP", "END-EXEC", "ESCAPE", "EXCEPTION", "EXEC", "EXECUTE", "EXISTS", "EXTERNAL", "EXTRACT", "FALSE", "FETCH", "FIRST", "FLOAT", "FOR", "FOREIGN", "FORTRAN", "FOUND", "FROM", "FULL", "GET", "GLOBAL", "GO", "GOTO", "GRANT", "GROUP", "HAVING", "HOUR", "IDENTITY", "IMMEDIATE", "IN", "INCLUDE", "INDEX", "INDICATOR", "INITIALLY", "INNER", "INPUT", "INSENSITIVE", "INSERT", "INT", "INTEGER", "INTERSECT", "INTERVAL", "INTO", "IS", "ISOLATION", "JOIN", "KEY", "LANGUAGE", "LAST", "LEADING", "LEFT", "LEVEL", "LIKE", "LOCAL", "LOWER", "MATCH", "MAX", "MIN", "MINUTE", "MODULE", "MONTH", "NAMES", "NATIONAL", "NATURAL", "NCHAR", "NEXT", "NO", "NONE", "NOT", "NULL", "NULLIF", "NUMERIC", "OCTET_LENGTH", "OF", "ONLY", "OPEN", "OPTION", "OR", "ORDER", "OUTER", "OUTPUT", "OVERLAPS", "PAD", "PARTIAL", "PASCAL", "POSITION", "PRECISION", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURE", "PUBLIC", "READ", "REAL", "REFERENCES", "RELATIVE", "RESTRICT", "REVOKE", "RIGHT", "ROLLBACK", "ROWS", "SCHEMA", "SCROLL", "SECOND", "SECTION", "SELECT", "SESSION", "SESSION_USER", "SET", "SIZE", "SMALLINT", "SOME", "SPACE", "SQL", "SQLCA", "SQLCODE", "SQLERROR", "SQLSTATE", "SQLWARNING", "SUBSTRING", "SUM", "SYSTEM_USER", "TABLE", "TEMPORARY", "TIME", "TIMESTAMP", "TIMEZONE_HOUR", "TIMEZONE_MINUTE", "TO", "TRAILING", "TRANSACTION", "TRANSLATE", "TRANSLATION", "TRIM", "TRUE", "UNION", "UNIQUE", "UNKNOWN", "UPDATE", "UPPER", "USAGE", "USER", "VALUE", "VALUES", "VARCHAR", "VARYING", "VIEW", "WHENEVER", "WHERE", "WITH", "WORK", "WRITE", "YEAR", "ZONE"]
}), O5 = fe(["SELECT [ALL | DISTINCT]"]), I5 = fe([
  // queries
  "WITH",
  "INTO",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "WINDOW",
  "PARTITION BY",
  "ORDER BY",
  "OFFSET",
  "FETCH {FIRST | NEXT}",
  // Data manipulation
  // - insert:
  "INSERT [INTO]",
  "VALUES",
  // - update:
  "SET",
  // - merge:
  "MERGE [INTO]",
  "WHEN [NOT] MATCHED [BY TARGET | BY SOURCE] [THEN]",
  "UPDATE SET",
  // Data definition
  "CREATE [OR ALTER] [MATERIALIZED] VIEW",
  "CREATE TABLE",
  "CREATE [OR ALTER] {PROC | PROCEDURE}"
]), WC = fe([
  // - update:
  "UPDATE",
  "WHERE CURRENT OF",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE",
  "ADD",
  "DROP COLUMN [IF EXISTS]",
  "ALTER COLUMN",
  // - truncate:
  "TRUNCATE TABLE",
  // https://docs.microsoft.com/en-us/sql/t-sql/statements/statements?view=sql-server-ver15
  "ADD SENSITIVITY CLASSIFICATION",
  "ADD SIGNATURE",
  "AGGREGATE",
  "ANSI_DEFAULTS",
  "ANSI_NULLS",
  "ANSI_NULL_DFLT_OFF",
  "ANSI_NULL_DFLT_ON",
  "ANSI_PADDING",
  "ANSI_WARNINGS",
  "APPLICATION ROLE",
  "ARITHABORT",
  "ARITHIGNORE",
  "ASSEMBLY",
  "ASYMMETRIC KEY",
  "AUTHORIZATION",
  "AVAILABILITY GROUP",
  "BACKUP",
  "BACKUP CERTIFICATE",
  "BACKUP MASTER KEY",
  "BACKUP SERVICE MASTER KEY",
  "BEGIN CONVERSATION TIMER",
  "BEGIN DIALOG CONVERSATION",
  "BROKER PRIORITY",
  "BULK INSERT",
  "CERTIFICATE",
  "CLOSE MASTER KEY",
  "CLOSE SYMMETRIC KEY",
  "COLLATE",
  "COLUMN ENCRYPTION KEY",
  "COLUMN MASTER KEY",
  "COLUMNSTORE INDEX",
  "CONCAT_NULL_YIELDS_NULL",
  "CONTEXT_INFO",
  "CONTRACT",
  "CREDENTIAL",
  "CRYPTOGRAPHIC PROVIDER",
  "CURSOR_CLOSE_ON_COMMIT",
  "DATABASE",
  "DATABASE AUDIT SPECIFICATION",
  "DATABASE ENCRYPTION KEY",
  "DATABASE HADR",
  "DATABASE SCOPED CONFIGURATION",
  "DATABASE SCOPED CREDENTIAL",
  "DATABASE SET",
  "DATEFIRST",
  "DATEFORMAT",
  "DEADLOCK_PRIORITY",
  "DENY",
  "DENY XML",
  "DISABLE TRIGGER",
  "ENABLE TRIGGER",
  "END CONVERSATION",
  "ENDPOINT",
  "EVENT NOTIFICATION",
  "EVENT SESSION",
  "EXECUTE AS",
  "EXTERNAL DATA SOURCE",
  "EXTERNAL FILE FORMAT",
  "EXTERNAL LANGUAGE",
  "EXTERNAL LIBRARY",
  "EXTERNAL RESOURCE POOL",
  "EXTERNAL TABLE",
  "FIPS_FLAGGER",
  "FMTONLY",
  "FORCEPLAN",
  "FULLTEXT CATALOG",
  "FULLTEXT INDEX",
  "FULLTEXT STOPLIST",
  "FUNCTION",
  "GET CONVERSATION GROUP",
  "GET_TRANSMISSION_STATUS",
  "GRANT",
  "GRANT XML",
  "IDENTITY_INSERT",
  "IMPLICIT_TRANSACTIONS",
  "INDEX",
  "LANGUAGE",
  "LOCK_TIMEOUT",
  "LOGIN",
  "MASTER KEY",
  "MESSAGE TYPE",
  "MOVE CONVERSATION",
  "NOCOUNT",
  "NOEXEC",
  "NUMERIC_ROUNDABORT",
  "OFFSETS",
  "OPEN MASTER KEY",
  "OPEN SYMMETRIC KEY",
  "PARSEONLY",
  "PARTITION FUNCTION",
  "PARTITION SCHEME",
  "PROCEDURE",
  "QUERY_GOVERNOR_COST_LIMIT",
  "QUEUE",
  "QUOTED_IDENTIFIER",
  "RECEIVE",
  "REMOTE SERVICE BINDING",
  "REMOTE_PROC_TRANSACTIONS",
  "RESOURCE GOVERNOR",
  "RESOURCE POOL",
  "RESTORE",
  "RESTORE FILELISTONLY",
  "RESTORE HEADERONLY",
  "RESTORE LABELONLY",
  "RESTORE MASTER KEY",
  "RESTORE REWINDONLY",
  "RESTORE SERVICE MASTER KEY",
  "RESTORE VERIFYONLY",
  "REVERT",
  "REVOKE",
  "REVOKE XML",
  "ROLE",
  "ROUTE",
  "ROWCOUNT",
  "RULE",
  "SCHEMA",
  "SEARCH PROPERTY LIST",
  "SECURITY POLICY",
  "SELECTIVE XML INDEX",
  "SEND",
  "SENSITIVITY CLASSIFICATION",
  "SEQUENCE",
  "SERVER AUDIT",
  "SERVER AUDIT SPECIFICATION",
  "SERVER CONFIGURATION",
  "SERVER ROLE",
  "SERVICE",
  "SERVICE MASTER KEY",
  "SETUSER",
  "SHOWPLAN_ALL",
  "SHOWPLAN_TEXT",
  "SHOWPLAN_XML",
  "SIGNATURE",
  "SPATIAL INDEX",
  "STATISTICS",
  "STATISTICS IO",
  "STATISTICS PROFILE",
  "STATISTICS TIME",
  "STATISTICS XML",
  "SYMMETRIC KEY",
  "SYNONYM",
  "TABLE",
  "TABLE IDENTITY",
  "TEXTSIZE",
  "TRANSACTION ISOLATION LEVEL",
  "TRIGGER",
  "TYPE",
  "UPDATE STATISTICS",
  "USER",
  "WORKLOAD GROUP",
  "XACT_ABORT",
  "XML INDEX",
  "XML SCHEMA COLLECTION"
]), _5 = fe(["UNION [ALL]", "EXCEPT", "INTERSECT"]), C5 = fe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  // non-standard joins
  "{CROSS | OUTER} APPLY"
]), m5 = fe(["ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]", "{ROWS | RANGE} BETWEEN"]), v5 = {
  tokenizerOptions: {
    reservedSelect: O5,
    reservedClauses: [...I5, ...WC],
    reservedSetOperations: _5,
    reservedJoins: C5,
    reservedPhrases: m5,
    reservedKeywords: N5,
    reservedFunctionNames: h5,
    nestedBlockComments: !0,
    stringTypes: [{
      quote: "''-qq",
      prefixes: ["N"]
    }],
    identTypes: ['""-qq', "[]"],
    identChars: {
      first: "#@",
      rest: "#@$"
    },
    paramTypes: {
      named: ["@"],
      quoted: ["@"]
    },
    operators: ["%", "&", "|", "^", "~", "!<", "!>", "+=", "-=", "*=", "/=", "%=", "|=", "&=", "^=", "::"]
    // TODO: Support for money constants
  },
  formatOptions: {
    alwaysDenseOperators: ["::"],
    onelineClauses: WC
  }
}, L5 = ut({
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/restricted-keywords/list-of-restricted-keywords.html
  all: ["ABORT", "ABSOLUTE", "ACCESS", "ACCESSIBLE", "ACCOUNT", "ACTION", "ACTIVE", "ADD", "ADMIN", "AFTER", "AGAINST", "AGGREGATE", "AGGREGATES", "AGGREGATOR", "AGGREGATOR_ID", "AGGREGATOR_PLAN_HASH", "AGGREGATORS", "ALGORITHM", "ALL", "ALSO", "ALTER", "ALWAYS", "ANALYZE", "AND", "ANY", "ARGHISTORY", "ARRANGE", "ARRANGEMENT", "ARRAY", "AS", "ASC", "ASCII", "ASENSITIVE", "ASM", "ASSERTION", "ASSIGNMENT", "AST", "ASYMMETRIC", "ASYNC", "AT", "ATTACH", "ATTRIBUTE", "AUTHORIZATION", "AUTO", "AUTO_INCREMENT", "AUTO_REPROVISION", "AUTOSTATS", "AUTOSTATS_CARDINALITY_MODE", "AUTOSTATS_ENABLED", "AUTOSTATS_HISTOGRAM_MODE", "AUTOSTATS_SAMPLING", "AVAILABILITY", "AVG", "AVG_ROW_LENGTH", "AVRO", "AZURE", "BACKGROUND", "_BACKGROUND_THREADS_FOR_CLEANUP", "BACKUP", "BACKUP_HISTORY", "BACKUP_ID", "BACKWARD", "BATCH", "BATCHES", "BATCH_INTERVAL", "_BATCH_SIZE_LIMIT", "BEFORE", "BEGIN", "BETWEEN", "BIGINT", "BINARY", "_BINARY", "BIT", "BLOB", "BOOL", "BOOLEAN", "BOOTSTRAP", "BOTH", "_BT", "BTREE", "BUCKET_COUNT", "BUCKETS", "BY", "BYTE", "BYTE_LENGTH", "CACHE", "CALL", "CALL_FOR_PIPELINE", "CALLED", "CAPTURE", "CASCADE", "CASCADED", "CASE", "CATALOG", "CHAIN", "CHANGE", "CHAR", "CHARACTER", "CHARACTERISTICS", "CHARSET", "CHECK", "CHECKPOINT", "_CHECK_CAN_CONNECT", "_CHECK_CONSISTENCY", "CHECKSUM", "_CHECKSUM", "CLASS", "CLEAR", "CLIENT", "CLIENT_FOUND_ROWS", "CLOSE", "CLUSTER", "CLUSTERED", "CNF", "COALESCE", "COLLATE", "COLLATION", "COLUMN", "COLUMNAR", "COLUMNS", "COLUMNSTORE", "COLUMNSTORE_SEGMENT_ROWS", "COMMENT", "COMMENTS", "COMMIT", "COMMITTED", "_COMMIT_LOG_TAIL", "COMPACT", "COMPILE", "COMPRESSED", "COMPRESSION", "CONCURRENT", "CONCURRENTLY", "CONDITION", "CONFIGURATION", "CONNECTION", "CONNECTIONS", "CONFIG", "CONSTRAINT", "CONTAINS", "CONTENT", "CONTINUE", "_CONTINUE_REPLAY", "CONVERSION", "CONVERT", "COPY", "_CORE", "COST", "CREATE", "CREDENTIALS", "CROSS", "CUBE", "CSV", "CUME_DIST", "CURRENT", "CURRENT_CATALOG", "CURRENT_DATE", "CURRENT_SCHEMA", "CURRENT_SECURITY_GROUPS", "CURRENT_SECURITY_ROLES", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "CURSOR", "CYCLE", "DATA", "DATABASE", "DATABASES", "DATE", "DATETIME", "DAY", "DAY_HOUR", "DAY_MICROSECOND", "DAY_MINUTE", "DAY_SECOND", "DEALLOCATE", "DEC", "DECIMAL", "DECLARE", "DEFAULT", "DEFAULTS", "DEFERRABLE", "DEFERRED", "DEFINED", "DEFINER", "DELAYED", "DELAY_KEY_WRITE", "DELETE", "DELIMITER", "DELIMITERS", "DENSE_RANK", "DESC", "DESCRIBE", "DETACH", "DETERMINISTIC", "DICTIONARY", "DIFFERENTIAL", "DIRECTORY", "DISABLE", "DISCARD", "_DISCONNECT", "DISK", "DISTINCT", "DISTINCTROW", "DISTRIBUTED_JOINS", "DIV", "DO", "DOCUMENT", "DOMAIN", "DOUBLE", "DROP", "_DROP_PROFILE", "DUAL", "DUMP", "DUPLICATE", "DURABILITY", "DYNAMIC", "EARLIEST", "EACH", "ECHO", "ELECTION", "ELSE", "ELSEIF", "ENABLE", "ENCLOSED", "ENCODING", "ENCRYPTED", "END", "ENGINE", "ENGINES", "ENUM", "ERRORS", "ESCAPE", "ESCAPED", "ESTIMATE", "EVENT", "EVENTS", "EXCEPT", "EXCLUDE", "EXCLUDING", "EXCLUSIVE", "EXECUTE", "EXISTS", "EXIT", "EXPLAIN", "EXTENDED", "EXTENSION", "EXTERNAL", "EXTERNAL_HOST", "EXTERNAL_PORT", "EXTRACTOR", "EXTRACTORS", "EXTRA_JOIN", "_FAILOVER", "FAILED_LOGIN_ATTEMPTS", "FAILURE", "FALSE", "FAMILY", "FAULT", "FETCH", "FIELDS", "FILE", "FILES", "FILL", "FIX_ALTER", "FIXED", "FLOAT", "FLOAT4", "FLOAT8", "FLUSH", "FOLLOWING", "FOR", "FORCE", "FORCE_COMPILED_MODE", "FORCE_INTERPRETER_MODE", "FOREGROUND", "FOREIGN", "FORMAT", "FORWARD", "FREEZE", "FROM", "FS", "_FSYNC", "FULL", "FULLTEXT", "FUNCTION", "FUNCTIONS", "GC", "GCS", "GET_FORMAT", "_GC", "_GCX", "GENERATE", "GEOGRAPHY", "GEOGRAPHYPOINT", "GEOMETRY", "GEOMETRYPOINT", "GLOBAL", "_GLOBAL_VERSION_TIMESTAMP", "GRANT", "GRANTED", "GRANTS", "GROUP", "GROUPING", "GROUPS", "GZIP", "HANDLE", "HANDLER", "HARD_CPU_LIMIT_PERCENTAGE", "HASH", "HAS_TEMP_TABLES", "HAVING", "HDFS", "HEADER", "HEARTBEAT_NO_LOGGING", "HIGH_PRIORITY", "HISTOGRAM", "HOLD", "HOLDING", "HOST", "HOSTS", "HOUR", "HOUR_MICROSECOND", "HOUR_MINUTE", "HOUR_SECOND", "IDENTIFIED", "IDENTITY", "IF", "IGNORE", "ILIKE", "IMMEDIATE", "IMMUTABLE", "IMPLICIT", "IMPORT", "IN", "INCLUDING", "INCREMENT", "INCREMENTAL", "INDEX", "INDEXES", "INFILE", "INHERIT", "INHERITS", "_INIT_PROFILE", "INIT", "INITIALIZE", "INITIALLY", "INJECT", "INLINE", "INNER", "INOUT", "INPUT", "INSENSITIVE", "INSERT", "INSERT_METHOD", "INSTANCE", "INSTEAD", "IN", "INT", "INT1", "INT2", "INT3", "INT4", "INT8", "INTEGER", "_INTERNAL_DYNAMIC_TYPECAST", "INTERPRETER_MODE", "INTERSECT", "INTERVAL", "INTO", "INVOKER", "ISOLATION", "ITERATE", "JOIN", "JSON", "KAFKA", "KEY", "KEY_BLOCK_SIZE", "KEYS", "KILL", "KILLALL", "LABEL", "LAG", "LANGUAGE", "LARGE", "LAST", "LAST_VALUE", "LATERAL", "LATEST", "LC_COLLATE", "LC_CTYPE", "LEAD", "LEADING", "LEAF", "LEAKPROOF", "LEAVE", "LEAVES", "LEFT", "LEVEL", "LICENSE", "LIKE", "LIMIT", "LINES", "LISTEN", "LLVM", "LOADDATA_WHERE", "LOAD", "LOCAL", "LOCALTIME", "LOCALTIMESTAMP", "LOCATION", "LOCK", "LONG", "LONGBLOB", "LONGTEXT", "LOOP", "LOW_PRIORITY", "_LS", "LZ4", "MANAGEMENT", "_MANAGEMENT_THREAD", "MAPPING", "MASTER", "MATCH", "MATERIALIZED", "MAXVALUE", "MAX_CONCURRENCY", "MAX_ERRORS", "MAX_PARTITIONS_PER_BATCH", "MAX_QUEUE_DEPTH", "MAX_RETRIES_PER_BATCH_PARTITION", "MAX_ROWS", "MBC", "MPL", "MEDIUMBLOB", "MEDIUMINT", "MEDIUMTEXT", "MEMBER", "MEMORY", "MEMORY_PERCENTAGE", "_MEMSQL_TABLE_ID_LOOKUP", "MEMSQL", "MEMSQL_DESERIALIZE", "MEMSQL_IMITATING_KAFKA", "MEMSQL_SERIALIZE", "MERGE", "METADATA", "MICROSECOND", "MIDDLEINT", "MIN_ROWS", "MINUS", "MINUTE_MICROSECOND", "MINUTE_SECOND", "MINVALUE", "MOD", "MODE", "MODEL", "MODIFIES", "MODIFY", "MONTH", "MOVE", "MPL", "NAMES", "NAMED", "NAMESPACE", "NATIONAL", "NATURAL", "NCHAR", "NEXT", "NO", "NODE", "NONE", "NO_QUERY_REWRITE", "NOPARAM", "NOT", "NOTHING", "NOTIFY", "NOWAIT", "NO_WRITE_TO_BINLOG", "NO_QUERY_REWRITE", "NORELY", "NTH_VALUE", "NTILE", "NULL", "NULLCOLS", "NULLS", "NUMERIC", "NVARCHAR", "OBJECT", "OF", "OFF", "OFFLINE", "OFFSET", "OFFSETS", "OIDS", "ON", "ONLINE", "ONLY", "OPEN", "OPERATOR", "OPTIMIZATION", "OPTIMIZE", "OPTIMIZER", "OPTIMIZER_STATE", "OPTION", "OPTIONS", "OPTIONALLY", "OR", "ORDER", "ORDERED_SERIALIZE", "ORPHAN", "OUT", "OUT_OF_ORDER", "OUTER", "OUTFILE", "OVER", "OVERLAPS", "OVERLAY", "OWNED", "OWNER", "PACK_KEYS", "PAIRED", "PARSER", "PARQUET", "PARTIAL", "PARTITION", "PARTITION_ID", "PARTITIONING", "PARTITIONS", "PASSING", "PASSWORD", "PASSWORD_LOCK_TIME", "PAUSE", "_PAUSE_REPLAY", "PERIODIC", "PERSISTED", "PIPELINE", "PIPELINES", "PLACING", "PLAN", "PLANS", "PLANCACHE", "PLUGINS", "POOL", "POOLS", "PORT", "PRECEDING", "PRECISION", "PREPARE", "PRESERVE", "PRIMARY", "PRIOR", "PRIVILEGES", "PROCEDURAL", "PROCEDURE", "PROCEDURES", "PROCESS", "PROCESSLIST", "PROFILE", "PROFILES", "PROGRAM", "PROMOTE", "PROXY", "PURGE", "QUARTER", "QUERIES", "QUERY", "QUERY_TIMEOUT", "QUEUE", "RANGE", "RANK", "READ", "_READ", "READS", "REAL", "REASSIGN", "REBALANCE", "RECHECK", "RECORD", "RECURSIVE", "REDUNDANCY", "REDUNDANT", "REF", "REFERENCE", "REFERENCES", "REFRESH", "REGEXP", "REINDEX", "RELATIVE", "RELEASE", "RELOAD", "RELY", "REMOTE", "REMOVE", "RENAME", "REPAIR", "_REPAIR_TABLE", "REPEAT", "REPEATABLE", "_REPL", "_REPROVISIONING", "REPLACE", "REPLICA", "REPLICATE", "REPLICATING", "REPLICATION", "REQUIRE", "RESOURCE", "RESOURCE_POOL", "RESET", "RESTART", "RESTORE", "RESTRICT", "RESULT", "_RESURRECT", "RETRY", "RETURN", "RETURNING", "RETURNS", "REVERSE", "RG_POOL", "REVOKE", "RIGHT", "RIGHT_ANTI_JOIN", "RIGHT_SEMI_JOIN", "RIGHT_STRAIGHT_JOIN", "RLIKE", "ROLES", "ROLLBACK", "ROLLUP", "ROUTINE", "ROW", "ROW_COUNT", "ROW_FORMAT", "ROW_NUMBER", "ROWS", "ROWSTORE", "RULE", "_RPC", "RUNNING", "S3", "SAFE", "SAVE", "SAVEPOINT", "SCALAR", "SCHEMA", "SCHEMAS", "SCHEMA_BINDING", "SCROLL", "SEARCH", "SECOND", "SECOND_MICROSECOND", "SECURITY", "SELECT", "SEMI_JOIN", "_SEND_THREADS", "SENSITIVE", "SEPARATOR", "SEQUENCE", "SEQUENCES", "SERIAL", "SERIALIZABLE", "SERIES", "SERVICE_USER", "SERVER", "SESSION", "SESSION_USER", "SET", "SETOF", "SECURITY_LISTS_INTERSECT", "SHA", "SHARD", "SHARDED", "SHARDED_ID", "SHARE", "SHOW", "SHUTDOWN", "SIGNAL", "SIGNED", "SIMILAR", "SIMPLE", "SITE", "SKIP", "SKIPPED_BATCHES", "__SLEEP", "SMALLINT", "SNAPSHOT", "_SNAPSHOT", "_SNAPSHOTS", "SOFT_CPU_LIMIT_PERCENTAGE", "SOME", "SONAME", "SPARSE", "SPATIAL", "SPATIAL_CHECK_INDEX", "SPECIFIC", "SQL", "SQL_BIG_RESULT", "SQL_BUFFER_RESULT", "SQL_CACHE", "SQL_CALC_FOUND_ROWS", "SQLEXCEPTION", "SQL_MODE", "SQL_NO_CACHE", "SQL_NO_LOGGING", "SQL_SMALL_RESULT", "SQLSTATE", "SQLWARNING", "STDIN", "STDOUT", "STOP", "STORAGE", "STRAIGHT_JOIN", "STRICT", "STRING", "STRIP", "SUCCESS", "SUPER", "SYMMETRIC", "SYNC_SNAPSHOT", "SYNC", "_SYNC", "_SYNC2", "_SYNC_PARTITIONS", "_SYNC_SNAPSHOT", "SYNCHRONIZE", "SYSID", "SYSTEM", "TABLE", "TABLE_CHECKSUM", "TABLES", "TABLESPACE", "TAGS", "TARGET_SIZE", "TASK", "TEMP", "TEMPLATE", "TEMPORARY", "TEMPTABLE", "_TERM_BUMP", "TERMINATE", "TERMINATED", "TEXT", "THEN", "TIME", "TIMEOUT", "TIMESTAMP", "TIMESTAMPADD", "TIMESTAMPDIFF", "TIMEZONE", "TINYBLOB", "TINYINT", "TINYTEXT", "TO", "TRACELOGS", "TRADITIONAL", "TRAILING", "TRANSFORM", "TRANSACTION", "_TRANSACTIONS_EXPERIMENTAL", "TREAT", "TRIGGER", "TRIGGERS", "TRUE", "TRUNC", "TRUNCATE", "TRUSTED", "TWO_PHASE", "_TWOPCID", "TYPE", "TYPES", "UNBOUNDED", "UNCOMMITTED", "UNDEFINED", "UNDO", "UNENCRYPTED", "UNENFORCED", "UNHOLD", "UNICODE", "UNION", "UNIQUE", "_UNITTEST", "UNKNOWN", "UNLISTEN", "_UNLOAD", "UNLOCK", "UNLOGGED", "UNPIVOT", "UNSIGNED", "UNTIL", "UPDATE", "UPGRADE", "USAGE", "USE", "USER", "USERS", "USING", "UTC_DATE", "UTC_TIME", "UTC_TIMESTAMP", "_UTF8", "VACUUM", "VALID", "VALIDATE", "VALIDATOR", "VALUE", "VALUES", "VARBINARY", "VARCHAR", "VARCHARACTER", "VARIABLES", "VARIADIC", "VARYING", "VERBOSE", "VIEW", "VOID", "VOLATILE", "VOTING", "WAIT", "_WAKE", "WARNINGS", "WEEK", "WHEN", "WHERE", "WHILE", "WHITESPACE", "WINDOW", "WITH", "WITHOUT", "WITHIN", "_WM_HEARTBEAT", "WORK", "WORKLOAD", "WRAPPER", "WRITE", "XACT_ID", "XOR", "YEAR", "YEAR_MONTH", "YES", "ZEROFILL", "ZONE"]
}), y5 = ut({
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/vector-functions/vector-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/window-functions/window-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/string-functions/string-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/conditional-functions/conditional-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/numeric-functions/numeric-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/geospatial-functions/geospatial-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/json-functions/json-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/information-functions/information-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/aggregate-functions/aggregate-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/time-series-functions/time-series-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/identifier-generation-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/date-and-time-functions/date-and-time-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/distinct-count-estimation-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/full-text-search-functions/full-text-search-functions.html
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference/regular-expression-functions.html
  all: [
    "ABS",
    "ACOS",
    "ADDDATE",
    "ADDTIME",
    "AES_DECRYPT",
    "AES_ENCRYPT",
    "ANY_VALUE",
    "APPROX_COUNT_DISTINCT",
    "APPROX_COUNT_DISTINCT_ACCUMULATE",
    "APPROX_COUNT_DISTINCT_COMBINE",
    "APPROX_COUNT_DISTINCT_ESTIMATE",
    "APPROX_GEOGRAPHY_INTERSECTS",
    "APPROX_PERCENTILE",
    "ASCII",
    "ASIN",
    "ATAN",
    "ATAN2",
    "AVG",
    "BIN",
    "BINARY",
    "BIT_AND",
    "BIT_COUNT",
    "BIT_OR",
    "BIT_XOR",
    "CAST",
    "CEIL",
    "CEILING",
    "CHAR",
    "CHARACTER_LENGTH",
    "CHAR_LENGTH",
    "CHARSET",
    "COALESCE",
    "COERCIBILITY",
    "COLLATION",
    "COLLECT",
    "CONCAT",
    "CONCAT_WS",
    "CONNECTION_ID",
    "CONV",
    "CONVERT",
    "CONVERT_TZ",
    "COS",
    "COT",
    "COUNT",
    "CUME_DIST",
    "CURDATE",
    "CURRENT_DATE",
    "CURRENT_ROLE",
    "CURRENT_TIME",
    "CURRENT_TIMESTAMP",
    "CURRENT_USER",
    "CURTIME",
    "DATABASE",
    "DATE",
    "DATE_ADD",
    "DATEDIFF",
    "DATE_FORMAT",
    "DATE_SUB",
    "DATE_TRUNC",
    "DAY",
    "DAYNAME",
    "DAYOFMONTH",
    "DAYOFWEEK",
    "DAYOFYEAR",
    "DECODE",
    "DEFAULT",
    "DEGREES",
    "DENSE_RANK",
    "DIV",
    "DOT_PRODUCT",
    "ELT",
    "EUCLIDEAN_DISTANCE",
    "EXP",
    "EXTRACT",
    "FIELD",
    "FIRST",
    "FIRST_VALUE",
    "FLOOR",
    "FORMAT",
    "FOUND_ROWS",
    "FROM_BASE64",
    "FROM_DAYS",
    "FROM_UNIXTIME",
    "GEOGRAPHY_AREA",
    "GEOGRAPHY_CONTAINS",
    "GEOGRAPHY_DISTANCE",
    "GEOGRAPHY_INTERSECTS",
    "GEOGRAPHY_LATITUDE",
    "GEOGRAPHY_LENGTH",
    "GEOGRAPHY_LONGITUDE",
    "GEOGRAPHY_POINT",
    "GEOGRAPHY_WITHIN_DISTANCE",
    "GEOMETRY_AREA",
    "GEOMETRY_CONTAINS",
    "GEOMETRY_DISTANCE",
    "GEOMETRY_FILTER",
    "GEOMETRY_INTERSECTS",
    "GEOMETRY_LENGTH",
    "GEOMETRY_POINT",
    "GEOMETRY_WITHIN_DISTANCE",
    "GEOMETRY_X",
    "GEOMETRY_Y",
    "GREATEST",
    "GROUPING",
    "GROUP_CONCAT",
    "HEX",
    "HIGHLIGHT",
    "HOUR",
    "ICU_VERSION",
    "IF",
    "IFNULL",
    "INET_ATON",
    "INET_NTOA",
    "INET6_ATON",
    "INET6_NTOA",
    "INITCAP",
    "INSERT",
    "INSTR",
    "INTERVAL",
    "IS",
    "IS NULL",
    "JSON_AGG",
    "JSON_ARRAY_CONTAINS_DOUBLE",
    "JSON_ARRAY_CONTAINS_JSON",
    "JSON_ARRAY_CONTAINS_STRING",
    "JSON_ARRAY_PUSH_DOUBLE",
    "JSON_ARRAY_PUSH_JSON",
    "JSON_ARRAY_PUSH_STRING",
    "JSON_DELETE_KEY",
    "JSON_EXTRACT_DOUBLE",
    "JSON_EXTRACT_JSON",
    "JSON_EXTRACT_STRING",
    "JSON_EXTRACT_BIGINT",
    "JSON_GET_TYPE",
    "JSON_LENGTH",
    "JSON_SET_DOUBLE",
    "JSON_SET_JSON",
    "JSON_SET_STRING",
    "JSON_SPLICE_DOUBLE",
    "JSON_SPLICE_JSON",
    "JSON_SPLICE_STRING",
    "LAG",
    "LAST_DAY",
    "LAST_VALUE",
    "LCASE",
    "LEAD",
    "LEAST",
    "LEFT",
    "LENGTH",
    "LIKE",
    "LN",
    "LOCALTIME",
    "LOCALTIMESTAMP",
    "LOCATE",
    "LOG",
    "LOG10",
    "LOG2",
    "LPAD",
    "LTRIM",
    "MATCH",
    "MAX",
    "MD5",
    "MEDIAN",
    "MICROSECOND",
    "MIN",
    "MINUTE",
    "MOD",
    "MONTH",
    "MONTHNAME",
    "MONTHS_BETWEEN",
    "NOT",
    "NOW",
    "NTH_VALUE",
    "NTILE",
    "NULLIF",
    "OCTET_LENGTH",
    "PERCENT_RANK",
    "PERCENTILE_CONT",
    "PERCENTILE_DISC",
    "PI",
    "PIVOT",
    "POSITION",
    "POW",
    "POWER",
    "QUARTER",
    "QUOTE",
    "RADIANS",
    "RAND",
    "RANK",
    "REGEXP",
    "REPEAT",
    "REPLACE",
    "REVERSE",
    "RIGHT",
    "RLIKE",
    "ROUND",
    "ROW_COUNT",
    "ROW_NUMBER",
    "RPAD",
    "RTRIM",
    "SCALAR",
    "SCHEMA",
    "SEC_TO_TIME",
    "SHA1",
    "SHA2",
    "SIGMOID",
    "SIGN",
    "SIN",
    "SLEEP",
    "SPLIT",
    "SOUNDEX",
    "SOUNDS LIKE",
    "SOURCE_POS_WAIT",
    "SPACE",
    "SQRT",
    "STDDEV",
    "STDDEV_POP",
    "STDDEV_SAMP",
    "STR_TO_DATE",
    "SUBDATE",
    "SUBSTR",
    "SUBSTRING",
    "SUBSTRING_INDEX",
    "SUM",
    "SYS_GUID",
    "TAN",
    "TIME",
    "TIMEDIFF",
    "TIME_BUCKET",
    "TIME_FORMAT",
    "TIMESTAMP",
    "TIMESTAMPADD",
    "TIMESTAMPDIFF",
    "TIME_TO_SEC",
    "TO_BASE64",
    "TO_CHAR",
    "TO_DAYS",
    "TO_JSON",
    "TO_NUMBER",
    "TO_SECONDS",
    "TO_TIMESTAMP",
    "TRIM",
    "TRUNC",
    "TRUNCATE",
    "UCASE",
    "UNHEX",
    "UNIX_TIMESTAMP",
    "UPDATEXML",
    "UPPER",
    "USER",
    "UTC_DATE",
    "UTC_TIME",
    "UTC_TIMESTAMP",
    "UUID",
    "VALUES",
    "VARIANCE",
    "VAR_POP",
    "VAR_SAMP",
    "VECTOR_SUB",
    "VERSION",
    "WEEK",
    "WEEKDAY",
    "WEEKOFYEAR",
    "YEAR",
    // Data types with parameters
    // https://docs.singlestore.com/managed-service/en/reference/sql-reference/data-types.html
    "BIT",
    "TINYINT",
    "SMALLINT",
    "MEDIUMINT",
    "INT",
    "INTEGER",
    "BIGINT",
    "DECIMAL",
    "DEC",
    "NUMERIC",
    "FIXED",
    "FLOAT",
    "DOUBLE",
    "DOUBLE PRECISION",
    "REAL",
    "DATETIME",
    "TIMESTAMP",
    "TIME",
    "YEAR",
    "CHAR",
    "NATIONAL CHAR",
    "VARCHAR",
    "NATIONAL VARCHAR",
    "BINARY",
    "VARBINARY",
    "BLOB",
    "TEXT",
    "ENUM"
  ]
}), g5 = fe(["SELECT [ALL | DISTINCT | DISTINCTROW]"]), D5 = fe([
  // queries
  "WITH",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "LIMIT",
  "OFFSET",
  // Data manipulation
  // - insert:
  "INSERT [IGNORE] [INTO]",
  "VALUES",
  "REPLACE [INTO]",
  // - update:
  "SET",
  // Data definition
  "CREATE VIEW",
  "CREATE [ROWSTORE] [REFERENCE | TEMPORARY | GLOBAL TEMPORARY] TABLE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [TEMPORARY] PROCEDURE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [EXTERNAL] FUNCTION"
]), kC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE [FROM]",
  // - drop table:
  "DROP [TEMPORARY] TABLE [IF EXISTS]",
  // - alter table:
  "ALTER [ONLINE] TABLE",
  "ADD [COLUMN]",
  "ADD [UNIQUE] {INDEX | KEY}",
  "DROP [COLUMN]",
  "MODIFY [COLUMN]",
  "CHANGE",
  "RENAME [TO | AS]",
  // - truncate:
  "TRUNCATE [TABLE]",
  // https://docs.singlestore.com/managed-service/en/reference/sql-reference.html
  "ADD AGGREGATOR",
  "ADD LEAF",
  "AGGREGATOR SET AS MASTER",
  "ALTER DATABASE",
  "ALTER PIPELINE",
  "ALTER RESOURCE POOL",
  "ALTER USER",
  "ALTER VIEW",
  "ANALYZE TABLE",
  "ATTACH DATABASE",
  "ATTACH LEAF",
  "ATTACH LEAF ALL",
  "BACKUP DATABASE",
  "BINLOG",
  "BOOTSTRAP AGGREGATOR",
  "CACHE INDEX",
  "CALL",
  "CHANGE",
  "CHANGE MASTER TO",
  "CHANGE REPLICATION FILTER",
  "CHANGE REPLICATION SOURCE TO",
  "CHECK BLOB CHECKSUM",
  "CHECK TABLE",
  "CHECKSUM TABLE",
  "CLEAR ORPHAN DATABASES",
  "CLONE",
  "COMMIT",
  "CREATE DATABASE",
  "CREATE GROUP",
  "CREATE INDEX",
  "CREATE LINK",
  "CREATE MILESTONE",
  "CREATE PIPELINE",
  "CREATE RESOURCE POOL",
  "CREATE ROLE",
  "CREATE USER",
  "DEALLOCATE PREPARE",
  "DESCRIBE",
  "DETACH DATABASE",
  "DETACH PIPELINE",
  "DROP DATABASE",
  "DROP FUNCTION",
  "DROP INDEX",
  "DROP LINK",
  "DROP PIPELINE",
  "DROP PROCEDURE",
  "DROP RESOURCE POOL",
  "DROP ROLE",
  "DROP USER",
  "DROP VIEW",
  "EXECUTE",
  "EXPLAIN",
  "FLUSH",
  "FORCE",
  "GRANT",
  "HANDLER",
  "HELP",
  "KILL CONNECTION",
  "KILLALL QUERIES",
  "LOAD DATA",
  "LOAD INDEX INTO CACHE",
  "LOAD XML",
  "LOCK INSTANCE FOR BACKUP",
  "LOCK TABLES",
  "MASTER_POS_WAIT",
  "OPTIMIZE TABLE",
  "PREPARE",
  "PURGE BINARY LOGS",
  "REBALANCE PARTITIONS",
  "RELEASE SAVEPOINT",
  "REMOVE AGGREGATOR",
  "REMOVE LEAF",
  "REPAIR TABLE",
  "REPLACE",
  "REPLICATE DATABASE",
  "RESET",
  "RESET MASTER",
  "RESET PERSIST",
  "RESET REPLICA",
  "RESET SLAVE",
  "RESTART",
  "RESTORE DATABASE",
  "RESTORE REDUNDANCY",
  "REVOKE",
  "ROLLBACK",
  "ROLLBACK TO SAVEPOINT",
  "SAVEPOINT",
  "SET CHARACTER SET",
  "SET DEFAULT ROLE",
  "SET NAMES",
  "SET PASSWORD",
  "SET RESOURCE GROUP",
  "SET ROLE",
  "SET TRANSACTION",
  "SHOW",
  "SHOW CHARACTER SET",
  "SHOW COLLATION",
  "SHOW COLUMNS",
  "SHOW CREATE DATABASE",
  "SHOW CREATE FUNCTION",
  "SHOW CREATE PIPELINE",
  "SHOW CREATE PROCEDURE",
  "SHOW CREATE TABLE",
  "SHOW CREATE USER",
  "SHOW CREATE VIEW",
  "SHOW DATABASES",
  "SHOW ENGINE",
  "SHOW ENGINES",
  "SHOW ERRORS",
  "SHOW FUNCTION CODE",
  "SHOW FUNCTION STATUS",
  "SHOW GRANTS",
  "SHOW INDEX",
  "SHOW MASTER STATUS",
  "SHOW OPEN TABLES",
  "SHOW PLUGINS",
  "SHOW PRIVILEGES",
  "SHOW PROCEDURE CODE",
  "SHOW PROCEDURE STATUS",
  "SHOW PROCESSLIST",
  "SHOW PROFILE",
  "SHOW PROFILES",
  "SHOW RELAYLOG EVENTS",
  "SHOW REPLICA STATUS",
  "SHOW REPLICAS",
  "SHOW SLAVE",
  "SHOW SLAVE HOSTS",
  "SHOW STATUS",
  "SHOW TABLE STATUS",
  "SHOW TABLES",
  "SHOW VARIABLES",
  "SHOW WARNINGS",
  "SHUTDOWN",
  "SNAPSHOT DATABASE",
  "SOURCE_POS_WAIT",
  "START GROUP_REPLICATION",
  "START PIPELINE",
  "START REPLICA",
  "START SLAVE",
  "START TRANSACTION",
  "STOP GROUP_REPLICATION",
  "STOP PIPELINE",
  "STOP REPLICA",
  "STOP REPLICATING",
  "STOP SLAVE",
  "TEST PIPELINE",
  "UNLOCK INSTANCE",
  "UNLOCK TABLES",
  "USE",
  "XA",
  // flow control
  "ITERATE",
  "LEAVE",
  "LOOP",
  "REPEAT",
  "RETURN",
  "WHILE"
]), b5 = fe(["UNION [ALL | DISTINCT]", "EXCEPT", "INTERSECT", "MINUS"]), M5 = fe([
  "JOIN",
  "{LEFT | RIGHT | FULL} [OUTER] JOIN",
  "{INNER | CROSS} JOIN",
  "NATURAL {LEFT | RIGHT} [OUTER] JOIN",
  // non-standard joins
  "STRAIGHT_JOIN"
]), P5 = fe(["ON DELETE", "ON UPDATE", "CHARACTER SET", "{ROWS | RANGE} BETWEEN"]), U5 = {
  tokenizerOptions: {
    reservedSelect: g5,
    reservedClauses: [...D5, ...kC],
    reservedSetOperations: b5,
    reservedJoins: M5,
    reservedPhrases: P5,
    reservedKeywords: L5,
    reservedFunctionNames: y5,
    // TODO: support _binary"some string" prefix
    stringTypes: ['""-qq-bs', "''-qq-bs", {
      quote: "''-raw",
      prefixes: ["B", "X"],
      requirePrefix: !0
    }],
    identTypes: ["``"],
    identChars: {
      first: "$",
      rest: "$",
      allowFirstCharNumber: !0
    },
    variableTypes: [{
      regex: "@@?[A-Za-z0-9_$]+"
    }, {
      quote: "``",
      prefixes: ["@"],
      requirePrefix: !0
    }],
    lineCommentTypes: ["--", "#"],
    operators: [":=", "&", "|", "^", "~", "<<", ">>", "<=>", "&&", "||", "::", "::$", "::%", ":>", "!:>"],
    postProcess: x5
  },
  formatOptions: {
    alwaysDenseOperators: ["::", "::$", "::%"],
    onelineClauses: kC
  }
};
function x5(n) {
  return n.map((a, s) => {
    const o = n[s + 1] || ws;
    return ki.SET(a) && o.text === "(" ? {
      ...a,
      type: Ee.RESERVED_FUNCTION_NAME
    } : a;
  });
}
const w5 = ut({
  // https://docs.snowflake.com/en/sql-reference-functions.html
  //
  // https://docs.snowflake.com/en/sql-reference/functions-all.html
  // 1. run in console on this page: $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue)
  // 2. split all lines that contain ',' or '/' into multiple lines
  // 3. remove all '— Deprecated' parts from the strings
  // 4. delete all strings that end with '<object_type>', they are already covered in the list
  // 5. remove all strings that contain '[', they are operators not functions
  // 6. fix all values that contain '*'
  // 7. delete operatos ':', '::', '||'
  //
  // Steps 1-5 can be combined by the following script in the developer console:
  // $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue) // Step 1
  //   .map(x => x.split(x.includes(',') ? ',' : '/')).flat().map(x => x.trim()) // Step 2
  //   .map(x => x.replace('— Deprecated', '')) // Step 3
  //   .filter(x => !x.endsWith('<object_type>')) // Step 4
  //   .filter(x => !x.includes('[')) // Step 5
  all: ["ABS", "ACOS", "ACOSH", "ADD_MONTHS", "ALL_USER_NAMES", "ANY_VALUE", "APPROX_COUNT_DISTINCT", "APPROX_PERCENTILE", "APPROX_PERCENTILE_ACCUMULATE", "APPROX_PERCENTILE_COMBINE", "APPROX_PERCENTILE_ESTIMATE", "APPROX_TOP_K", "APPROX_TOP_K_ACCUMULATE", "APPROX_TOP_K_COMBINE", "APPROX_TOP_K_ESTIMATE", "APPROXIMATE_JACCARD_INDEX", "APPROXIMATE_SIMILARITY", "ARRAY_AGG", "ARRAY_APPEND", "ARRAY_CAT", "ARRAY_COMPACT", "ARRAY_CONSTRUCT", "ARRAY_CONSTRUCT_COMPACT", "ARRAY_CONTAINS", "ARRAY_INSERT", "ARRAY_INTERSECTION", "ARRAY_POSITION", "ARRAY_PREPEND", "ARRAY_SIZE", "ARRAY_SLICE", "ARRAY_TO_STRING", "ARRAY_UNION_AGG", "ARRAY_UNIQUE_AGG", "ARRAYS_OVERLAP", "AS_ARRAY", "AS_BINARY", "AS_BOOLEAN", "AS_CHAR", "AS_VARCHAR", "AS_DATE", "AS_DECIMAL", "AS_NUMBER", "AS_DOUBLE", "AS_REAL", "AS_INTEGER", "AS_OBJECT", "AS_TIME", "AS_TIMESTAMP_LTZ", "AS_TIMESTAMP_NTZ", "AS_TIMESTAMP_TZ", "ASCII", "ASIN", "ASINH", "ATAN", "ATAN2", "ATANH", "AUTO_REFRESH_REGISTRATION_HISTORY", "AUTOMATIC_CLUSTERING_HISTORY", "AVG", "BASE64_DECODE_BINARY", "BASE64_DECODE_STRING", "BASE64_ENCODE", "BIT_LENGTH", "BITAND", "BITAND_AGG", "BITMAP_BIT_POSITION", "BITMAP_BUCKET_NUMBER", "BITMAP_CONSTRUCT_AGG", "BITMAP_COUNT", "BITMAP_OR_AGG", "BITNOT", "BITOR", "BITOR_AGG", "BITSHIFTLEFT", "BITSHIFTRIGHT", "BITXOR", "BITXOR_AGG", "BOOLAND", "BOOLAND_AGG", "BOOLNOT", "BOOLOR", "BOOLOR_AGG", "BOOLXOR", "BOOLXOR_AGG", "BUILD_SCOPED_FILE_URL", "BUILD_STAGE_FILE_URL", "CASE", "CAST", "CBRT", "CEIL", "CHARINDEX", "CHECK_JSON", "CHECK_XML", "CHR", "CHAR", "COALESCE", "COLLATE", "COLLATION", "COMPLETE_TASK_GRAPHS", "COMPRESS", "CONCAT", "CONCAT_WS", "CONDITIONAL_CHANGE_EVENT", "CONDITIONAL_TRUE_EVENT", "CONTAINS", "CONVERT_TIMEZONE", "COPY_HISTORY", "CORR", "COS", "COSH", "COT", "COUNT", "COUNT_IF", "COVAR_POP", "COVAR_SAMP", "CUME_DIST", "CURRENT_ACCOUNT", "CURRENT_AVAILABLE_ROLES", "CURRENT_CLIENT", "CURRENT_DATABASE", "CURRENT_DATE", "CURRENT_IP_ADDRESS", "CURRENT_REGION", "CURRENT_ROLE", "CURRENT_SCHEMA", "CURRENT_SCHEMAS", "CURRENT_SECONDARY_ROLES", "CURRENT_SESSION", "CURRENT_STATEMENT", "CURRENT_TASK_GRAPHS", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_TRANSACTION", "CURRENT_USER", "CURRENT_VERSION", "CURRENT_WAREHOUSE", "DATA_TRANSFER_HISTORY", "DATABASE_REFRESH_HISTORY", "DATABASE_REFRESH_PROGRESS", "DATABASE_REFRESH_PROGRESS_BY_JOB", "DATABASE_STORAGE_USAGE_HISTORY", "DATE_FROM_PARTS", "DATE_PART", "DATE_TRUNC", "DATEADD", "DATEDIFF", "DAYNAME", "DECODE", "DECOMPRESS_BINARY", "DECOMPRESS_STRING", "DECRYPT", "DECRYPT_RAW", "DEGREES", "DENSE_RANK", "DIV0", "EDITDISTANCE", "ENCRYPT", "ENCRYPT_RAW", "ENDSWITH", "EQUAL_NULL", "EXP", "EXPLAIN_JSON", "EXTERNAL_FUNCTIONS_HISTORY", "EXTERNAL_TABLE_FILES", "EXTERNAL_TABLE_FILE_REGISTRATION_HISTORY", "EXTRACT", "EXTRACT_SEMANTIC_CATEGORIES", "FACTORIAL", "FIRST_VALUE", "FLATTEN", "FLOOR", "GENERATE_COLUMN_DESCRIPTION", "GENERATOR", "GET", "GET_ABSOLUTE_PATH", "GET_DDL", "GET_IGNORE_CASE", "GET_OBJECT_REFERENCES", "GET_PATH", "GET_PRESIGNED_URL", "GET_RELATIVE_PATH", "GET_STAGE_LOCATION", "GETBIT", "GREATEST", "GROUPING", "GROUPING_ID", "HASH", "HASH_AGG", "HAVERSINE", "HEX_DECODE_BINARY", "HEX_DECODE_STRING", "HEX_ENCODE", "HLL", "HLL_ACCUMULATE", "HLL_COMBINE", "HLL_ESTIMATE", "HLL_EXPORT", "HLL_IMPORT", "HOUR", "MINUTE", "SECOND", "IFF", "IFNULL", "ILIKE", "ILIKE ANY", "INFER_SCHEMA", "INITCAP", "INSERT", "INVOKER_ROLE", "INVOKER_SHARE", "IS_ARRAY", "IS_BINARY", "IS_BOOLEAN", "IS_CHAR", "IS_VARCHAR", "IS_DATE", "IS_DATE_VALUE", "IS_DECIMAL", "IS_DOUBLE", "IS_REAL", "IS_GRANTED_TO_INVOKER_ROLE", "IS_INTEGER", "IS_NULL_VALUE", "IS_OBJECT", "IS_ROLE_IN_SESSION", "IS_TIME", "IS_TIMESTAMP_LTZ", "IS_TIMESTAMP_NTZ", "IS_TIMESTAMP_TZ", "JAROWINKLER_SIMILARITY", "JSON_EXTRACT_PATH_TEXT", "KURTOSIS", "LAG", "LAST_DAY", "LAST_QUERY_ID", "LAST_TRANSACTION", "LAST_VALUE", "LEAD", "LEAST", "LEFT", "LENGTH", "LEN", "LIKE", "LIKE ALL", "LIKE ANY", "LISTAGG", "LN", "LOCALTIME", "LOCALTIMESTAMP", "LOG", "LOGIN_HISTORY", "LOGIN_HISTORY_BY_USER", "LOWER", "LPAD", "LTRIM", "MATERIALIZED_VIEW_REFRESH_HISTORY", "MD5", "MD5_HEX", "MD5_BINARY", "MD5_NUMBER — Obsoleted", "MD5_NUMBER_LOWER64", "MD5_NUMBER_UPPER64", "MEDIAN", "MIN", "MAX", "MINHASH", "MINHASH_COMBINE", "MOD", "MODE", "MONTHNAME", "MONTHS_BETWEEN", "NEXT_DAY", "NORMAL", "NTH_VALUE", "NTILE", "NULLIF", "NULLIFZERO", "NVL", "NVL2", "OBJECT_AGG", "OBJECT_CONSTRUCT", "OBJECT_CONSTRUCT_KEEP_NULL", "OBJECT_DELETE", "OBJECT_INSERT", "OBJECT_KEYS", "OBJECT_PICK", "OCTET_LENGTH", "PARSE_IP", "PARSE_JSON", "PARSE_URL", "PARSE_XML", "PERCENT_RANK", "PERCENTILE_CONT", "PERCENTILE_DISC", "PI", "PIPE_USAGE_HISTORY", "POLICY_CONTEXT", "POLICY_REFERENCES", "POSITION", "POW", "POWER", "PREVIOUS_DAY", "QUERY_ACCELERATION_HISTORY", "QUERY_HISTORY", "QUERY_HISTORY_BY_SESSION", "QUERY_HISTORY_BY_USER", "QUERY_HISTORY_BY_WAREHOUSE", "RADIANS", "RANDOM", "RANDSTR", "RANK", "RATIO_TO_REPORT", "REGEXP", "REGEXP_COUNT", "REGEXP_INSTR", "REGEXP_LIKE", "REGEXP_REPLACE", "REGEXP_SUBSTR", "REGEXP_SUBSTR_ALL", "REGR_AVGX", "REGR_AVGY", "REGR_COUNT", "REGR_INTERCEPT", "REGR_R2", "REGR_SLOPE", "REGR_SXX", "REGR_SXY", "REGR_SYY", "REGR_VALX", "REGR_VALY", "REPEAT", "REPLACE", "REPLICATION_GROUP_REFRESH_HISTORY", "REPLICATION_GROUP_REFRESH_PROGRESS", "REPLICATION_GROUP_REFRESH_PROGRESS_BY_JOB", "REPLICATION_GROUP_USAGE_HISTORY", "REPLICATION_USAGE_HISTORY", "REST_EVENT_HISTORY", "RESULT_SCAN", "REVERSE", "RIGHT", "RLIKE", "ROUND", "ROW_NUMBER", "RPAD", "RTRIM", "RTRIMMED_LENGTH", "SEARCH_OPTIMIZATION_HISTORY", "SEQ1", "SEQ2", "SEQ4", "SEQ8", "SERVERLESS_TASK_HISTORY", "SHA1", "SHA1_HEX", "SHA1_BINARY", "SHA2", "SHA2_HEX", "SHA2_BINARY", "SIGN", "SIN", "SINH", "SKEW", "SOUNDEX", "SPACE", "SPLIT", "SPLIT_PART", "SPLIT_TO_TABLE", "SQRT", "SQUARE", "ST_AREA", "ST_ASEWKB", "ST_ASEWKT", "ST_ASGEOJSON", "ST_ASWKB", "ST_ASBINARY", "ST_ASWKT", "ST_ASTEXT", "ST_AZIMUTH", "ST_CENTROID", "ST_COLLECT", "ST_CONTAINS", "ST_COVEREDBY", "ST_COVERS", "ST_DIFFERENCE", "ST_DIMENSION", "ST_DISJOINT", "ST_DISTANCE", "ST_DWITHIN", "ST_ENDPOINT", "ST_ENVELOPE", "ST_GEOGFROMGEOHASH", "ST_GEOGPOINTFROMGEOHASH", "ST_GEOGRAPHYFROMWKB", "ST_GEOGRAPHYFROMWKT", "ST_GEOHASH", "ST_GEOMETRYFROMWKB", "ST_GEOMETRYFROMWKT", "ST_HAUSDORFFDISTANCE", "ST_INTERSECTION", "ST_INTERSECTS", "ST_LENGTH", "ST_MAKEGEOMPOINT", "ST_GEOM_POINT", "ST_MAKELINE", "ST_MAKEPOINT", "ST_POINT", "ST_MAKEPOLYGON", "ST_POLYGON", "ST_NPOINTS", "ST_NUMPOINTS", "ST_PERIMETER", "ST_POINTN", "ST_SETSRID", "ST_SIMPLIFY", "ST_SRID", "ST_STARTPOINT", "ST_SYMDIFFERENCE", "ST_UNION", "ST_WITHIN", "ST_X", "ST_XMAX", "ST_XMIN", "ST_Y", "ST_YMAX", "ST_YMIN", "STAGE_DIRECTORY_FILE_REGISTRATION_HISTORY", "STAGE_STORAGE_USAGE_HISTORY", "STARTSWITH", "STDDEV", "STDDEV_POP", "STDDEV_SAMP", "STRIP_NULL_VALUE", "STRTOK", "STRTOK_SPLIT_TO_TABLE", "STRTOK_TO_ARRAY", "SUBSTR", "SUBSTRING", "SUM", "SYSDATE", "SYSTEM$ABORT_SESSION", "SYSTEM$ABORT_TRANSACTION", "SYSTEM$AUTHORIZE_PRIVATELINK", "SYSTEM$AUTHORIZE_STAGE_PRIVATELINK_ACCESS", "SYSTEM$BEHAVIOR_CHANGE_BUNDLE_STATUS", "SYSTEM$CANCEL_ALL_QUERIES", "SYSTEM$CANCEL_QUERY", "SYSTEM$CLUSTERING_DEPTH", "SYSTEM$CLUSTERING_INFORMATION", "SYSTEM$CLUSTERING_RATIO ", "SYSTEM$CURRENT_USER_TASK_NAME", "SYSTEM$DATABASE_REFRESH_HISTORY ", "SYSTEM$DATABASE_REFRESH_PROGRESS", "SYSTEM$DATABASE_REFRESH_PROGRESS_BY_JOB ", "SYSTEM$DISABLE_BEHAVIOR_CHANGE_BUNDLE", "SYSTEM$DISABLE_DATABASE_REPLICATION", "SYSTEM$ENABLE_BEHAVIOR_CHANGE_BUNDLE", "SYSTEM$ESTIMATE_QUERY_ACCELERATION", "SYSTEM$ESTIMATE_SEARCH_OPTIMIZATION_COSTS", "SYSTEM$EXPLAIN_JSON_TO_TEXT", "SYSTEM$EXPLAIN_PLAN_JSON", "SYSTEM$EXTERNAL_TABLE_PIPE_STATUS", "SYSTEM$GENERATE_SAML_CSR", "SYSTEM$GENERATE_SCIM_ACCESS_TOKEN", "SYSTEM$GET_AWS_SNS_IAM_POLICY", "SYSTEM$GET_PREDECESSOR_RETURN_VALUE", "SYSTEM$GET_PRIVATELINK", "SYSTEM$GET_PRIVATELINK_AUTHORIZED_ENDPOINTS", "SYSTEM$GET_PRIVATELINK_CONFIG", "SYSTEM$GET_SNOWFLAKE_PLATFORM_INFO", "SYSTEM$GET_TAG", "SYSTEM$GET_TAG_ALLOWED_VALUES", "SYSTEM$GET_TAG_ON_CURRENT_COLUMN", "SYSTEM$GET_TAG_ON_CURRENT_TABLE", "SYSTEM$GLOBAL_ACCOUNT_SET_PARAMETER", "SYSTEM$LAST_CHANGE_COMMIT_TIME", "SYSTEM$LINK_ACCOUNT_OBJECTS_BY_NAME", "SYSTEM$MIGRATE_SAML_IDP_REGISTRATION", "SYSTEM$PIPE_FORCE_RESUME", "SYSTEM$PIPE_STATUS", "SYSTEM$REVOKE_PRIVATELINK", "SYSTEM$REVOKE_STAGE_PRIVATELINK_ACCESS", "SYSTEM$SET_RETURN_VALUE", "SYSTEM$SHOW_OAUTH_CLIENT_SECRETS", "SYSTEM$STREAM_GET_TABLE_TIMESTAMP", "SYSTEM$STREAM_HAS_DATA", "SYSTEM$TASK_DEPENDENTS_ENABLE", "SYSTEM$TYPEOF", "SYSTEM$USER_TASK_CANCEL_ONGOING_EXECUTIONS", "SYSTEM$VERIFY_EXTERNAL_OAUTH_TOKEN", "SYSTEM$WAIT", "SYSTEM$WHITELIST", "SYSTEM$WHITELIST_PRIVATELINK", "TAG_REFERENCES", "TAG_REFERENCES_ALL_COLUMNS", "TAG_REFERENCES_WITH_LINEAGE", "TAN", "TANH", "TASK_DEPENDENTS", "TASK_HISTORY", "TIME_FROM_PARTS", "TIME_SLICE", "TIMEADD", "TIMEDIFF", "TIMESTAMP_FROM_PARTS", "TIMESTAMPADD", "TIMESTAMPDIFF", "TO_ARRAY", "TO_BINARY", "TO_BOOLEAN", "TO_CHAR", "TO_VARCHAR", "TO_DATE", "DATE", "TO_DECIMAL", "TO_NUMBER", "TO_NUMERIC", "TO_DOUBLE", "TO_GEOGRAPHY", "TO_GEOMETRY", "TO_JSON", "TO_OBJECT", "TO_TIME", "TIME", "TO_TIMESTAMP", "TO_TIMESTAMP_LTZ", "TO_TIMESTAMP_NTZ", "TO_TIMESTAMP_TZ", "TO_VARIANT", "TO_XML", "TRANSLATE", "TRIM", "TRUNCATE", "TRUNC", "TRUNC", "TRY_BASE64_DECODE_BINARY", "TRY_BASE64_DECODE_STRING", "TRY_CAST", "TRY_HEX_DECODE_BINARY", "TRY_HEX_DECODE_STRING", "TRY_PARSE_JSON", "TRY_TO_BINARY", "TRY_TO_BOOLEAN", "TRY_TO_DATE", "TRY_TO_DECIMAL", "TRY_TO_NUMBER", "TRY_TO_NUMERIC", "TRY_TO_DOUBLE", "TRY_TO_GEOGRAPHY", "TRY_TO_GEOMETRY", "TRY_TO_TIME", "TRY_TO_TIMESTAMP", "TRY_TO_TIMESTAMP_LTZ", "TRY_TO_TIMESTAMP_NTZ", "TRY_TO_TIMESTAMP_TZ", "TYPEOF", "UNICODE", "UNIFORM", "UPPER", "UUID_STRING", "VALIDATE", "VALIDATE_PIPE_LOAD", "VAR_POP", "VAR_SAMP", "VARIANCE", "VARIANCE_SAMP", "VARIANCE_POP", "WAREHOUSE_LOAD_HISTORY", "WAREHOUSE_METERING_HISTORY", "WIDTH_BUCKET", "XMLGET", "YEAR", "YEAROFWEEK", "YEAROFWEEKISO", "DAY", "DAYOFMONTH", "DAYOFWEEK", "DAYOFWEEKISO", "DAYOFYEAR", "WEEK", "WEEK", "WEEKOFYEAR", "WEEKISO", "MONTH", "QUARTER", "ZEROIFNULL", "ZIPF"]
}), G5 = ut({
  // https://docs.snowflake.com/en/sql-reference/reserved-keywords.html
  //
  // run in console on this page: $x('//tbody/tr/*[1]/p/text()').map(x => x.nodeValue)
  all: ["ACCOUNT", "ALL", "ALTER", "AND", "ANY", "AS", "BETWEEN", "BY", "CASE", "CAST", "CHECK", "COLUMN", "CONNECT", "CONNECTION", "CONSTRAINT", "CREATE", "CROSS", "CURRENT", "CURRENT_DATE", "CURRENT_TIME", "CURRENT_TIMESTAMP", "CURRENT_USER", "DATABASE", "DELETE", "DISTINCT", "DROP", "ELSE", "EXISTS", "FALSE", "FOLLOWING", "FOR", "FROM", "FULL", "GRANT", "GROUP", "GSCLUSTER", "HAVING", "ILIKE", "IN", "INCREMENT", "INNER", "INSERT", "INTERSECT", "INTO", "IS", "ISSUE", "JOIN", "LATERAL", "LEFT", "LIKE", "LOCALTIME", "LOCALTIMESTAMP", "MINUS", "NATURAL", "NOT", "NULL", "OF", "ON", "OR", "ORDER", "ORGANIZATION", "QUALIFY", "REGEXP", "REVOKE", "RIGHT", "RLIKE", "ROW", "ROWS", "SAMPLE", "SCHEMA", "SELECT", "SET", "SOME", "START", "TABLE", "TABLESAMPLE", "THEN", "TO", "TRIGGER", "TRUE", "TRY_CAST", "UNION", "UNIQUE", "UPDATE", "USING", "VALUES", "VIEW", "WHEN", "WHENEVER", "WHERE", "WITH"]
}), H5 = fe(["SELECT [ALL | DISTINCT]"]), B5 = fe([
  // queries
  "WITH [RECURSIVE]",
  "FROM",
  "WHERE",
  "GROUP BY",
  "HAVING",
  "PARTITION BY",
  "ORDER BY",
  "QUALIFY",
  "LIMIT",
  "OFFSET",
  "FETCH [FIRST | NEXT]",
  // Data manipulation
  // - insert:
  "INSERT [OVERWRITE] [ALL INTO | INTO | ALL | FIRST]",
  "{THEN | ELSE} INTO",
  "VALUES",
  // - update:
  "SET",
  // Data definition
  // - view
  "CREATE [OR REPLACE] [SECURE] [RECURSIVE] VIEW [IF NOT EXISTS]",
  // - create/drop/merge table
  "CREATE [OR REPLACE] [VOLATILE] TABLE [IF NOT EXISTS]",
  "CREATE [OR REPLACE] [LOCAL | GLOBAL] {TEMP|TEMPORARY} TABLE [IF NOT EXISTS]",
  "CLUSTER BY",
  "[WITH] {MASKING POLICY | TAG | ROW ACCESS POLICY}",
  "COPY GRANTS",
  "USING TEMPLATE",
  "MERGE INTO",
  "WHEN MATCHED [AND]",
  "THEN {UPDATE SET | DELETE}",
  "WHEN NOT MATCHED THEN INSERT"
]), XC = fe([
  // - update:
  "UPDATE",
  // - delete:
  "DELETE FROM",
  // - drop table:
  "DROP TABLE [IF EXISTS]",
  // - alter table:
  "ALTER TABLE [IF EXISTS]",
  "RENAME TO",
  "SWAP WITH",
  "[SUSPEND | RESUME] RECLUSTER",
  "DROP CLUSTERING KEY",
  "ADD [COLUMN]",
  "RENAME COLUMN",
  "{ALTER | MODIFY} [COLUMN]",
  "DROP [COLUMN]",
  "{ADD | ALTER | MODIFY | DROP} [CONSTRAINT]",
  "RENAME CONSTRAINT",
  "{ADD | DROP} SEARCH OPTIMIZATION",
  "{SET | UNSET} TAG",
  // Actually TAG is optional, but that conflicts with UPDATE..SET statement
  "{ADD | DROP} ROW ACCESS POLICY",
  "DROP ALL ROW ACCESS POLICIES",
  "{SET | DROP} DEFAULT",
  // for alter column
  "{SET | DROP} NOT NULL",
  // for alter column
  "[SET DATA] TYPE",
  // for alter column
  "[UNSET] COMMENT",
  // for alter column
  "{SET | UNSET} MASKING POLICY",
  // for alter column
  // - truncate:
  "TRUNCATE [TABLE] [IF EXISTS]",
  // other
  // https://docs.snowflake.com/en/sql-reference/sql-all.html
  //
  // 1. run in console on this page: $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue)
  // 2. delete all lines that contain a sting like '(.*)', they are already covered in the list
  // 3. delete all lines that contain a sting like '<.*>', they are already covered in the list
  // 4. delete all lines that contain '…', they are part of a regex statement that can't be covered here
  // 5. Manually add 'COPY INTO'
  // 6. Remove all lines that are already in `reservedClauses`
  //
  // Steps 1-4 can be combined by the following script in the developer console:
  // $x('//tbody/tr/*[1]//a/span/text()').map(x => x.nodeValue) // Step 1
  //   filter(x => !x.match(/\(.*\)/) && !x.match(/…/) && !x.match(/<.*>/)) // Step 2-4
  "ALTER ACCOUNT",
  "ALTER API INTEGRATION",
  "ALTER CONNECTION",
  "ALTER DATABASE",
  "ALTER EXTERNAL TABLE",
  "ALTER FAILOVER GROUP",
  "ALTER FILE FORMAT",
  "ALTER FUNCTION",
  "ALTER INTEGRATION",
  "ALTER MASKING POLICY",
  "ALTER MATERIALIZED VIEW",
  "ALTER NETWORK POLICY",
  "ALTER NOTIFICATION INTEGRATION",
  "ALTER PIPE",
  "ALTER PROCEDURE",
  "ALTER REPLICATION GROUP",
  "ALTER RESOURCE MONITOR",
  "ALTER ROLE",
  "ALTER ROW ACCESS POLICY",
  "ALTER SCHEMA",
  "ALTER SECURITY INTEGRATION",
  "ALTER SEQUENCE",
  "ALTER SESSION",
  "ALTER SESSION POLICY",
  "ALTER SHARE",
  "ALTER STAGE",
  "ALTER STORAGE INTEGRATION",
  "ALTER STREAM",
  "ALTER TAG",
  "ALTER TASK",
  "ALTER USER",
  "ALTER VIEW",
  "ALTER WAREHOUSE",
  "BEGIN",
  "CALL",
  "COMMIT",
  "COPY INTO",
  "CREATE ACCOUNT",
  "CREATE API INTEGRATION",
  "CREATE CONNECTION",
  "CREATE DATABASE",
  "CREATE EXTERNAL FUNCTION",
  "CREATE EXTERNAL TABLE",
  "CREATE FAILOVER GROUP",
  "CREATE FILE FORMAT",
  "CREATE FUNCTION",
  "CREATE INTEGRATION",
  "CREATE MANAGED ACCOUNT",
  "CREATE MASKING POLICY",
  "CREATE MATERIALIZED VIEW",
  "CREATE NETWORK POLICY",
  "CREATE NOTIFICATION INTEGRATION",
  "CREATE PIPE",
  "CREATE PROCEDURE",
  "CREATE REPLICATION GROUP",
  "CREATE RESOURCE MONITOR",
  "CREATE ROLE",
  "CREATE ROW ACCESS POLICY",
  "CREATE SCHEMA",
  "CREATE SECURITY INTEGRATION",
  "CREATE SEQUENCE",
  "CREATE SESSION POLICY",
  "CREATE SHARE",
  "CREATE STAGE",
  "CREATE STORAGE INTEGRATION",
  "CREATE STREAM",
  "CREATE TAG",
  "CREATE TASK",
  "CREATE USER",
  "CREATE WAREHOUSE",
  "DELETE",
  "DESCRIBE DATABASE",
  "DESCRIBE EXTERNAL TABLE",
  "DESCRIBE FILE FORMAT",
  "DESCRIBE FUNCTION",
  "DESCRIBE INTEGRATION",
  "DESCRIBE MASKING POLICY",
  "DESCRIBE MATERIALIZED VIEW",
  "DESCRIBE NETWORK POLICY",
  "DESCRIBE PIPE",
  "DESCRIBE PROCEDURE",
  "DESCRIBE RESULT",
  "DESCRIBE ROW ACCESS POLICY",
  "DESCRIBE SCHEMA",
  "DESCRIBE SEQUENCE",
  "DESCRIBE SESSION POLICY",
  "DESCRIBE SHARE",
  "DESCRIBE STAGE",
  "DESCRIBE STREAM",
  "DESCRIBE TABLE",
  "DESCRIBE TASK",
  "DESCRIBE TRANSACTION",
  "DESCRIBE USER",
  "DESCRIBE VIEW",
  "DESCRIBE WAREHOUSE",
  "DROP CONNECTION",
  "DROP DATABASE",
  "DROP EXTERNAL TABLE",
  "DROP FAILOVER GROUP",
  "DROP FILE FORMAT",
  "DROP FUNCTION",
  "DROP INTEGRATION",
  "DROP MANAGED ACCOUNT",
  "DROP MASKING POLICY",
  "DROP MATERIALIZED VIEW",
  "DROP NETWORK POLICY",
  "DROP PIPE",
  "DROP PROCEDURE",
  "DROP REPLICATION GROUP",
  "DROP RESOURCE MONITOR",
  "DROP ROLE",
  "DROP ROW ACCESS POLICY",
  "DROP SCHEMA",
  "DROP SEQUENCE",
  "DROP SESSION POLICY",
  "DROP SHARE",
  "DROP STAGE",
  "DROP STREAM",
  "DROP TAG",
  "DROP TASK",
  "DROP USER",
  "DROP VIEW",
  "DROP WAREHOUSE",
  "EXECUTE IMMEDIATE",
  "EXECUTE TASK",
  "EXPLAIN",
  "GET",
  "GRANT OWNERSHIP",
  "GRANT ROLE",
  "INSERT",
  "LIST",
  "MERGE",
  "PUT",
  "REMOVE",
  "REVOKE ROLE",
  "ROLLBACK",
  "SHOW COLUMNS",
  "SHOW CONNECTIONS",
  "SHOW DATABASES",
  "SHOW DATABASES IN FAILOVER GROUP",
  "SHOW DATABASES IN REPLICATION GROUP",
  "SHOW DELEGATED AUTHORIZATIONS",
  "SHOW EXTERNAL FUNCTIONS",
  "SHOW EXTERNAL TABLES",
  "SHOW FAILOVER GROUPS",
  "SHOW FILE FORMATS",
  "SHOW FUNCTIONS",
  "SHOW GLOBAL ACCOUNTS",
  "SHOW GRANTS",
  "SHOW INTEGRATIONS",
  "SHOW LOCKS",
  "SHOW MANAGED ACCOUNTS",
  "SHOW MASKING POLICIES",
  "SHOW MATERIALIZED VIEWS",
  "SHOW NETWORK POLICIES",
  "SHOW OBJECTS",
  "SHOW ORGANIZATION ACCOUNTS",
  "SHOW PARAMETERS",
  "SHOW PIPES",
  "SHOW PRIMARY KEYS",
  "SHOW PROCEDURES",
  "SHOW REGIONS",
  "SHOW REPLICATION ACCOUNTS",
  "SHOW REPLICATION DATABASES",
  "SHOW REPLICATION GROUPS",
  "SHOW RESOURCE MONITORS",
  "SHOW ROLES",
  "SHOW ROW ACCESS POLICIES",
  "SHOW SCHEMAS",
  "SHOW SEQUENCES",
  "SHOW SESSION POLICIES",
  "SHOW SHARES",
  "SHOW SHARES IN FAILOVER GROUP",
  "SHOW SHARES IN REPLICATION GROUP",
  "SHOW STAGES",
  "SHOW STREAMS",
  "SHOW TABLES",
  "SHOW TAGS",
  "SHOW TASKS",
  "SHOW TRANSACTIONS",
  "SHOW USER FUNCTIONS",
  "SHOW USERS",
  "SHOW VARIABLES",
  "SHOW VIEWS",
  "SHOW WAREHOUSES",
  "TRUNCATE MATERIALIZED VIEW",
  "UNDROP DATABASE",
  "UNDROP SCHEMA",
  "UNDROP TABLE",
  "UNDROP TAG",
  "UNSET",
  "USE DATABASE",
  "USE ROLE",
  "USE SCHEMA",
  "USE SECONDARY ROLES",
  "USE WAREHOUSE"
]), F5 = fe(["UNION [ALL]", "MINUS", "EXCEPT", "INTERSECT"]), Y5 = fe(["[INNER] JOIN", "[NATURAL] {LEFT | RIGHT | FULL} [OUTER] JOIN", "{CROSS | NATURAL} JOIN"]), V5 = fe(["{ROWS | RANGE} BETWEEN", "ON {UPDATE | DELETE} [SET NULL | SET DEFAULT]"]), W5 = {
  tokenizerOptions: {
    reservedSelect: H5,
    reservedClauses: [...B5, ...XC],
    reservedSetOperations: F5,
    reservedJoins: Y5,
    reservedPhrases: V5,
    reservedKeywords: G5,
    reservedFunctionNames: w5,
    stringTypes: ["$$", "''-qq-bs"],
    identTypes: ['""-qq'],
    variableTypes: [
      // for accessing columns at certain positons in the table
      {
        regex: "[$][1-9]\\d*"
      },
      // identifier style syntax
      {
        regex: "[$][_a-zA-Z][_a-zA-Z0-9$]*"
      }
    ],
    extraParens: ["[]"],
    identChars: {
      rest: "$"
    },
    lineCommentTypes: ["--", "//"],
    operators: [
      // Modulo
      "%",
      // Type cast
      "::",
      // String concat
      "||",
      // Get Path
      ":",
      // Generators: https://docs.snowflake.com/en/sql-reference/functions/generator.html#generator
      "=>"
    ]
  },
  formatOptions: {
    alwaysDenseOperators: [":", "::"],
    onelineClauses: XC
  }
}, k5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bigquery: IG,
  db2: UG,
  hive: VG,
  mariadb: ZG,
  mysql: i3,
  n1ql: d3,
  plsql: I3,
  postgresql: b3,
  redshift: B3,
  singlestoredb: U5,
  snowflake: W5,
  spark: K3,
  sql: E5,
  sqlite: n5,
  transactsql: v5,
  trino: S5
}, Symbol.toStringTag, { value: "Module" })), ia = (n) => n.replace(/[.*+?^${}()|[\]\\]/gu, "\\$&"), jC = /\s+/uy, Fs = (n) => new RegExp(`(?:${n})`, "uy"), X5 = (n) => n.split("").map((a) => / /gu.test(a) ? "\\s+" : `[${a.toUpperCase()}${a.toLowerCase()}]`).join(""), j5 = (n) => n + "(?:-" + n + ")*", K5 = ({
  prefixes: n,
  requirePrefix: a
}) => `(?:${n.map(X5).join("|")}${a ? "" : "|"})`, J5 = (n) => new RegExp(`(?:${n.map(ia).join("|")}).*?(?=\r
|\r|
|$)`, "uy"), KC = (n, a = []) => {
  const s = n === "open" ? 0 : 1, o = ["()", ...a].map((c) => c[s]);
  return Fs(o.map(ia).join("|"));
}, z5 = (n) => Fs(`${Hv(n).map(ia).join("|")}`), Z5 = ({
  rest: n,
  dashes: a
}) => n || a ? `(?![${n || ""}${a ? "-" : ""}])` : "", gs = (n, a = {}) => {
  if (n.length === 0)
    return /^\b$/u;
  const s = Z5(a), o = Hv(n).map(ia).join("|").replace(/ /gu, "\\s+");
  return new RegExp(`(?:${o})${s}\\b`, "iuy");
}, Bp = (n, a) => {
  if (!n.length)
    return;
  const s = n.map(ia).join("|");
  return Fs(`(?:${s})(?:${a})`);
}, q5 = () => {
  const n = {
    "<": ">",
    "[": "]",
    "(": ")",
    "{": "}"
  }, a = "{left}(?:(?!{right}').)*?{right}", s = Object.entries(n).map(([u, R]) => a.replace(/{left}/g, ia(u)).replace(/{right}/g, ia(R))), o = ia(Object.keys(n).join(""));
  return `[Qq]'(?:${String.raw`(?<tag>[^\s${o}])(?:(?!\k<tag>').)*?\k<tag>`}|${s.join("|")})'`;
}, JC = {
  // - backtick quoted (using `` to escape)
  "``": "(?:`[^`]*`)+",
  // - Transact-SQL square bracket quoted (using ]] to escape)
  "[]": String.raw`(?:\[[^\]]*\])(?:\][^\]]*\])*`,
  // double-quoted
  '""-qq': String.raw`(?:"[^"]*")+`,
  // with repeated quote escapes
  '""-bs': String.raw`(?:"[^"\\]*(?:\\.[^"\\]*)*")`,
  // with backslash escapes
  '""-qq-bs': String.raw`(?:"[^"\\]*(?:\\.[^"\\]*)*")+`,
  // with repeated quote or backslash escapes
  '""-raw': String.raw`(?:"[^"]*")`,
  // no escaping
  // single-quoted
  "''-qq": String.raw`(?:'[^']*')+`,
  // with repeated quote escapes
  "''-bs": String.raw`(?:'[^'\\]*(?:\\.[^'\\]*)*')`,
  // with backslash escapes
  "''-qq-bs": String.raw`(?:'[^'\\]*(?:\\.[^'\\]*)*')+`,
  // with repeated quote or backslash escapes
  "''-raw": String.raw`(?:'[^']*')`,
  // no escaping
  // PostgreSQL dollar-quoted
  $$: String.raw`(?<tag>\$\w*\$)[\s\S]*?\k<tag>`,
  // BigQuery '''triple-quoted''' (using \' to escape)
  "'''..'''": String.raw`'''[^\\]*?(?:\\.[^\\]*?)*?'''`,
  // BigQuery """triple-quoted""" (using \" to escape)
  '""".."""': String.raw`"""[^\\]*?(?:\\.[^\\]*?)*?"""`,
  // Hive and Spark variables: ${name}
  "{}": String.raw`(?:\{[^\}]*\})`,
  // Oracle q'' strings: q'<text>' q'|text|' ...
  "q''": q5()
}, Yv = (n) => typeof n == "string" ? JC[n] : "regex" in n ? n.regex : K5(n) + JC[n.quote], Q5 = (n) => Fs(n.map((a) => "regex" in a ? a.regex : Yv(a)).join("|")), Vv = (n) => n.map(Yv).join("|"), zC = (n) => Fs(Vv(n)), $5 = (n = {}) => Fs(Wv(n)), Wv = ({
  first: n,
  rest: a,
  dashes: s,
  allowFirstCharNumber: o
} = {}) => {
  const c = "\\p{Alphabetic}\\p{Mark}_", E = "\\p{Decimal_Number}", u = ia(n ?? ""), R = ia(a ?? ""), d = o ? `[${c}${E}${u}][${c}${E}${R}]*` : `[${c}${u}][${c}${E}${R}]*`;
  return s ? j5(d) : d;
};
function kv(n, a) {
  const s = n.slice(0, a).split(/\n/);
  return {
    line: s.length,
    col: s[s.length - 1].length + 1
  };
}
class e4 {
  // Current position in string
  constructor(a) {
    Ht(this, "input", "");
    // The input SQL string to {}
    Ht(this, "index", 0);
    this.rules = a;
  }
  /**
   * Takes a SQL string and breaks it into tokens.
   * Each token is an object with type and value.
   *
   * @param {string} input - The SQL string
   * @returns {Token[]} output token stream
   */
  tokenize(a) {
    this.input = a, this.index = 0;
    const s = [];
    let o;
    for (; this.index < this.input.length; ) {
      const c = this.getWhitespace();
      if (this.index < this.input.length) {
        if (o = this.getNextToken(), !o)
          throw this.createParseError();
        s.push({
          ...o,
          precedingWhitespace: c
        });
      }
    }
    return s;
  }
  createParseError() {
    const a = this.input.slice(this.index, this.index + 10), {
      line: s,
      col: o
    } = kv(this.input, this.index);
    return new Error(`Parse error: Unexpected "${a}" at line ${s} column ${o}`);
  }
  getWhitespace() {
    jC.lastIndex = this.index;
    const a = jC.exec(this.input);
    if (a)
      return this.index += a[0].length, a[0];
  }
  getNextToken() {
    for (const a of this.rules) {
      const s = this.match(a);
      if (s)
        return s;
    }
  }
  // Attempts to match token rule regex at current position in input
  match(a) {
    a.regex.lastIndex = this.index;
    const s = a.regex.exec(this.input);
    if (s) {
      const o = s[0], c = {
        type: a.type,
        raw: o,
        text: a.text ? a.text(o) : o,
        start: this.index
      };
      return a.key && (c.key = a.key(o)), this.index += o.length, c;
    }
  }
}
const ZC = /\/\*/uy, t4 = /([^/*]|\*[^/]|\/[^*])+/uy, n4 = /\*\//uy;
class r4 {
  constructor() {
    Ht(this, "lastIndex", 0);
  }
  exec(a) {
    let s = "", o, c = 0;
    if (o = this.matchSection(ZC, a))
      s += o, c++;
    else
      return null;
    for (; c > 0; )
      if (o = this.matchSection(ZC, a))
        s += o, c++;
      else if (o = this.matchSection(n4, a))
        s += o, c--;
      else if (o = this.matchSection(t4, a))
        s += o;
      else
        return null;
    return [s];
  }
  matchSection(a, s) {
    a.lastIndex = this.lastIndex;
    const o = a.exec(s);
    return o && (this.lastIndex += o[0].length), o ? o[0] : null;
  }
}
class a4 {
  constructor(a) {
    this.cfg = a, this.rulesBeforeParams = this.buildRulesBeforeParams(a), this.rulesAfterParams = this.buildRulesAfterParams(a);
  }
  tokenize(a, s) {
    const o = [...this.rulesBeforeParams, ...this.buildParamRules(this.cfg, s), ...this.rulesAfterParams], c = new e4(o).tokenize(a);
    return this.cfg.postProcess ? this.cfg.postProcess(c) : c;
  }
  // These rules can be cached as they only depend on
  // the Tokenizer config options specified for each SQL dialect
  buildRulesBeforeParams(a) {
    return this.validRules([
      {
        type: Ee.BLOCK_COMMENT,
        regex: a.nestedBlockComments ? new r4() : /(\/\*[^]*?\*\/)/uy
      },
      {
        type: Ee.LINE_COMMENT,
        regex: J5(a.lineCommentTypes ?? ["--"])
      },
      {
        type: Ee.QUOTED_IDENTIFIER,
        regex: zC(a.identTypes)
      },
      {
        type: Ee.NUMBER,
        regex: /(?:0x[0-9a-fA-F]+|0b[01]+|(?:-\s*)?[0-9]+(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+(?:\.[0-9]+)?)?)(?!\w)/uy
      },
      // RESERVED_PHRASE is matched before all other keyword tokens
      // to e.g. prioritize matching "TIMESTAMP WITH TIME ZONE" phrase over "WITH" clause.
      {
        type: Ee.RESERVED_PHRASE,
        regex: gs(a.reservedPhrases ?? [], a.identChars),
        text: Mn
      },
      {
        type: Ee.CASE,
        regex: /CASE\b/iuy,
        text: Mn
      },
      {
        type: Ee.END,
        regex: /END\b/iuy,
        text: Mn
      },
      {
        type: Ee.BETWEEN,
        regex: /BETWEEN\b/iuy,
        text: Mn
      },
      {
        type: Ee.LIMIT,
        regex: a.reservedClauses.includes("LIMIT") ? /LIMIT\b/iuy : void 0,
        text: Mn
      },
      {
        type: Ee.RESERVED_CLAUSE,
        regex: gs(a.reservedClauses, a.identChars),
        text: Mn
      },
      {
        type: Ee.RESERVED_SELECT,
        regex: gs(a.reservedSelect, a.identChars),
        text: Mn
      },
      {
        type: Ee.RESERVED_SET_OPERATION,
        regex: gs(a.reservedSetOperations, a.identChars),
        text: Mn
      },
      {
        type: Ee.WHEN,
        regex: /WHEN\b/iuy,
        text: Mn
      },
      {
        type: Ee.ELSE,
        regex: /ELSE\b/iuy,
        text: Mn
      },
      {
        type: Ee.THEN,
        regex: /THEN\b/iuy,
        text: Mn
      },
      {
        type: Ee.RESERVED_JOIN,
        regex: gs(a.reservedJoins, a.identChars),
        text: Mn
      },
      {
        type: Ee.AND,
        regex: /AND\b/iuy,
        text: Mn
      },
      {
        type: Ee.OR,
        regex: /OR\b/iuy,
        text: Mn
      },
      {
        type: Ee.XOR,
        regex: a.supportsXor ? /XOR\b/iuy : void 0,
        text: Mn
      },
      {
        type: Ee.RESERVED_FUNCTION_NAME,
        regex: gs(a.reservedFunctionNames, a.identChars),
        text: Mn
      },
      {
        type: Ee.RESERVED_KEYWORD,
        regex: gs(a.reservedKeywords, a.identChars),
        text: Mn
      }
    ]);
  }
  // These rules can also be cached as they only depend on
  // the Tokenizer config options specified for each SQL dialect
  buildRulesAfterParams(a) {
    return this.validRules([{
      type: Ee.VARIABLE,
      regex: a.variableTypes ? Q5(a.variableTypes) : void 0
    }, {
      type: Ee.STRING,
      regex: zC(a.stringTypes)
    }, {
      type: Ee.IDENTIFIER,
      regex: $5(a.identChars)
    }, {
      type: Ee.DELIMITER,
      regex: /[;]/uy
    }, {
      type: Ee.COMMA,
      regex: /[,]/y
    }, {
      type: Ee.OPEN_PAREN,
      regex: KC("open", a.extraParens)
    }, {
      type: Ee.CLOSE_PAREN,
      regex: KC("close", a.extraParens)
    }, {
      type: Ee.OPERATOR,
      regex: z5([
        // standard operators
        "+",
        "-",
        "/",
        ">",
        "<",
        "=",
        "<>",
        "<=",
        ">=",
        "!=",
        ...a.operators ?? []
      ])
    }, {
      type: Ee.ASTERISK,
      regex: /[*]/uy
    }, {
      type: Ee.DOT,
      regex: /[.]/uy
    }]);
  }
  // These rules can't be blindly cached as the paramTypesOverrides object
  // can differ on each invocation of the format() function.
  buildParamRules(a, s) {
    var o, c, E, u, R;
    const d = {
      named: (s == null ? void 0 : s.named) || ((o = a.paramTypes) === null || o === void 0 ? void 0 : o.named) || [],
      quoted: (s == null ? void 0 : s.quoted) || ((c = a.paramTypes) === null || c === void 0 ? void 0 : c.quoted) || [],
      numbered: (s == null ? void 0 : s.numbered) || ((E = a.paramTypes) === null || E === void 0 ? void 0 : E.numbered) || [],
      positional: typeof (s == null ? void 0 : s.positional) == "boolean" ? s.positional : (u = a.paramTypes) === null || u === void 0 ? void 0 : u.positional,
      custom: (s == null ? void 0 : s.custom) || ((R = a.paramTypes) === null || R === void 0 ? void 0 : R.custom) || []
    };
    return this.validRules([{
      type: Ee.NAMED_PARAMETER,
      regex: Bp(d.named, Wv(a.paramChars || a.identChars)),
      key: (T) => T.slice(1)
    }, {
      type: Ee.QUOTED_PARAMETER,
      regex: Bp(d.quoted, Vv(a.identTypes)),
      key: (T) => (({
        tokenKey: S,
        quoteChar: N
      }) => S.replace(new RegExp(ia("\\" + N), "gu"), N))({
        tokenKey: T.slice(2, -1),
        quoteChar: T.slice(-1)
      })
    }, {
      type: Ee.NUMBERED_PARAMETER,
      regex: Bp(d.numbered, "[0-9]+"),
      key: (T) => T.slice(1)
    }, {
      type: Ee.POSITIONAL_PARAMETER,
      regex: d.positional ? /[?]/y : void 0
    }, ...d.custom.map((T) => ({
      type: Ee.CUSTOM_PARAMETER,
      regex: Fs(T.regex),
      key: T.key ?? ((S) => S)
    }))]);
  }
  // filters out rules for token types whose regex is undefined
  validRules(a) {
    return a.filter((s) => !!s.regex);
  }
}
const Mn = (n) => Fv(n.toUpperCase()), qC = /* @__PURE__ */ new Map(), i4 = (n) => {
  let a = qC.get(n);
  return a || (a = s4(n), qC.set(n, a)), a;
}, s4 = (n) => ({
  tokenizer: new a4(n.tokenizerOptions),
  formatOptions: o4(n.formatOptions)
}), o4 = (n) => ({
  alwaysDenseOperators: n.alwaysDenseOperators || [],
  onelineClauses: Object.fromEntries(n.onelineClauses.map((a) => [a, !0]))
});
function QC(n) {
  return n.indentStyle === "tabularLeft" || n.indentStyle === "tabularRight" ? " ".repeat(10) : n.useTabs ? "	" : " ".repeat(n.tabWidth);
}
function Xu(n) {
  return n.indentStyle === "tabularLeft" || n.indentStyle === "tabularRight";
}
class l4 {
  constructor(a) {
    this.params = a, this.index = 0;
  }
  /**
   * Returns param value that matches given placeholder with param key.
   */
  get({
    key: a,
    text: s
  }) {
    return this.params ? a ? this.params[a] : this.params[this.index++] : s;
  }
  /**
   * Returns index of current positional parameter.
   */
  getPositionalParameterIndex() {
    return this.index;
  }
  /**
   * Sets index of current positional parameter.
   */
  setPositionalParameterIndex(a) {
    this.index = a;
  }
}
var Xv = { exports: {} };
(function(n) {
  (function(a, s) {
    n.exports ? n.exports = s() : a.nearley = s();
  })(Yt, function() {
    function a(T, S, N) {
      return this.id = ++a.highestId, this.name = T, this.symbols = S, this.postprocess = N, this;
    }
    a.highestId = 0, a.prototype.toString = function(T) {
      var S = typeof T > "u" ? this.symbols.map(d).join(" ") : this.symbols.slice(0, T).map(d).join(" ") + " ● " + this.symbols.slice(T).map(d).join(" ");
      return this.name + " → " + S;
    };
    function s(T, S, N, m) {
      this.rule = T, this.dot = S, this.reference = N, this.data = [], this.wantedBy = m, this.isComplete = this.dot === T.symbols.length;
    }
    s.prototype.toString = function() {
      return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
    }, s.prototype.nextState = function(T) {
      var S = new s(this.rule, this.dot + 1, this.reference, this.wantedBy);
      return S.left = this, S.right = T, S.isComplete && (S.data = S.build(), S.right = void 0), S;
    }, s.prototype.build = function() {
      var T = [], S = this;
      do
        T.push(S.right.data), S = S.left;
      while (S.left);
      return T.reverse(), T;
    }, s.prototype.finish = function() {
      this.rule.postprocess && (this.data = this.rule.postprocess(this.data, this.reference, u.fail));
    };
    function o(T, S) {
      this.grammar = T, this.index = S, this.states = [], this.wants = {}, this.scannable = [], this.completed = {};
    }
    o.prototype.process = function(T) {
      for (var S = this.states, N = this.wants, m = this.completed, v = 0; v < S.length; v++) {
        var M = S[v];
        if (M.isComplete) {
          if (M.finish(), M.data !== u.fail) {
            for (var w = M.wantedBy, y = w.length; y--; ) {
              var O = w[y];
              this.complete(O, M);
            }
            if (M.reference === this.index) {
              var g = M.rule.name;
              (this.completed[g] = this.completed[g] || []).push(M);
            }
          }
        } else {
          var g = M.rule.symbols[M.dot];
          if (typeof g != "string") {
            this.scannable.push(M);
            continue;
          }
          if (N[g]) {
            if (N[g].push(M), m.hasOwnProperty(g))
              for (var V = m[g], y = 0; y < V.length; y++) {
                var D = V[y];
                this.complete(M, D);
              }
          } else
            N[g] = [M], this.predict(g);
        }
      }
    }, o.prototype.predict = function(T) {
      for (var S = this.grammar.byName[T] || [], N = 0; N < S.length; N++) {
        var m = S[N], v = this.wants[T], M = new s(m, 0, this.index, v);
        this.states.push(M);
      }
    }, o.prototype.complete = function(T, S) {
      var N = T.nextState(S);
      this.states.push(N);
    };
    function c(T, S) {
      this.rules = T, this.start = S || this.rules[0].name;
      var N = this.byName = {};
      this.rules.forEach(function(m) {
        N.hasOwnProperty(m.name) || (N[m.name] = []), N[m.name].push(m);
      });
    }
    c.fromCompiled = function(m, S) {
      var N = m.Lexer;
      m.ParserStart && (S = m.ParserStart, m = m.ParserRules);
      var m = m.map(function(M) {
        return new a(M.name, M.symbols, M.postprocess);
      }), v = new c(m, S);
      return v.lexer = N, v;
    };
    function E() {
      this.reset("");
    }
    E.prototype.reset = function(T, S) {
      this.buffer = T, this.index = 0, this.line = S ? S.line : 1, this.lastLineBreak = S ? -S.col : 0;
    }, E.prototype.next = function() {
      if (this.index < this.buffer.length) {
        var T = this.buffer[this.index++];
        return T === `
` && (this.line += 1, this.lastLineBreak = this.index), { value: T };
      }
    }, E.prototype.save = function() {
      return {
        line: this.line,
        col: this.index - this.lastLineBreak
      };
    }, E.prototype.formatError = function(T, S) {
      var N = this.buffer;
      if (typeof N == "string") {
        var m = N.split(`
`).slice(
          Math.max(0, this.line - 5),
          this.line
        ), v = N.indexOf(`
`, this.index);
        v === -1 && (v = N.length);
        var M = this.index - this.lastLineBreak, w = String(this.line).length;
        return S += " at line " + this.line + " col " + M + `:

`, S += m.map(function(O, g) {
          return y(this.line - m.length + g + 1, w) + " " + O;
        }, this).join(`
`), S += `
` + y("", w + M) + `^
`, S;
      } else
        return S + " at index " + (this.index - 1);
      function y(O, g) {
        var V = String(O);
        return Array(g - V.length + 1).join(" ") + V;
      }
    };
    function u(T, S, N) {
      if (T instanceof c)
        var m = T, N = S;
      else
        var m = c.fromCompiled(T, S);
      this.grammar = m, this.options = {
        keepHistory: !1,
        lexer: m.lexer || new E()
      };
      for (var v in N || {})
        this.options[v] = N[v];
      this.lexer = this.options.lexer, this.lexerState = void 0;
      var M = new o(m, 0);
      this.table = [M], M.wants[m.start] = [], M.predict(m.start), M.process(), this.current = 0;
    }
    u.fail = {}, u.prototype.feed = function(T) {
      var S = this.lexer;
      S.reset(T, this.lexerState);
      for (var N; ; ) {
        try {
          if (N = S.next(), !N)
            break;
        } catch (U) {
          var w = new o(this.grammar, this.current + 1);
          this.table.push(w);
          var m = new Error(this.reportLexerError(U));
          throw m.offset = this.current, m.token = U.token, m;
        }
        var v = this.table[this.current];
        this.options.keepHistory || delete this.table[this.current - 1];
        var M = this.current + 1, w = new o(this.grammar, M);
        this.table.push(w);
        for (var y = N.text !== void 0 ? N.text : N.value, O = S.constructor === E ? N.value : N, g = v.scannable, V = g.length; V--; ) {
          var D = g[V], G = D.rule.symbols[D.dot];
          if (G.test ? G.test(O) : G.type ? G.type === N.type : G.literal === y) {
            var P = D.nextState({ data: O, token: N, isToken: !0, reference: M - 1 });
            w.states.push(P);
          }
        }
        if (w.process(), w.states.length === 0) {
          var m = new Error(this.reportError(N));
          throw m.offset = this.current, m.token = N, m;
        }
        this.options.keepHistory && (v.lexerState = S.save()), this.current++;
      }
      return v && (this.lexerState = S.save()), this.results = this.finish(), this;
    }, u.prototype.reportLexerError = function(T) {
      var S, N, m = T.token;
      return m ? (S = "input " + JSON.stringify(m.text[0]) + " (lexer error)", N = this.lexer.formatError(m, "Syntax error")) : (S = "input (lexer error)", N = T.message), this.reportErrorCommon(N, S);
    }, u.prototype.reportError = function(T) {
      var S = (T.type ? T.type + " token: " : "") + JSON.stringify(T.value !== void 0 ? T.value : T), N = this.lexer.formatError(T, "Syntax error");
      return this.reportErrorCommon(N, S);
    }, u.prototype.reportErrorCommon = function(T, S) {
      var N = [];
      N.push(T);
      var m = this.table.length - 2, v = this.table[m], M = v.states.filter(function(y) {
        var O = y.rule.symbols[y.dot];
        return O && typeof O != "string";
      });
      if (M.length === 0)
        N.push("Unexpected " + S + `. I did not expect any more input. Here is the state of my parse table:
`), this.displayStateStack(v.states, N);
      else {
        N.push("Unexpected " + S + `. Instead, I was expecting to see one of the following:
`);
        var w = M.map(function(y) {
          return this.buildFirstStateStack(y, []) || [y];
        }, this);
        w.forEach(function(y) {
          var O = y[0], g = O.rule.symbols[O.dot], V = this.getSymbolDisplay(g);
          N.push("A " + V + " based on:"), this.displayStateStack(y, N);
        }, this);
      }
      return N.push(""), N.join(`
`);
    }, u.prototype.displayStateStack = function(T, S) {
      for (var N, m = 0, v = 0; v < T.length; v++) {
        var M = T[v], w = M.rule.toString(M.dot);
        w === N ? m++ : (m > 0 && S.push("    ^ " + m + " more lines identical to this"), m = 0, S.push("    " + w)), N = w;
      }
    }, u.prototype.getSymbolDisplay = function(T) {
      return R(T);
    }, u.prototype.buildFirstStateStack = function(T, S) {
      if (S.indexOf(T) !== -1)
        return null;
      if (T.wantedBy.length === 0)
        return [T];
      var N = T.wantedBy[0], m = [T].concat(S), v = this.buildFirstStateStack(N, m);
      return v === null ? null : [T].concat(v);
    }, u.prototype.save = function() {
      var T = this.table[this.current];
      return T.lexerState = this.lexerState, T;
    }, u.prototype.restore = function(T) {
      var S = T.index;
      this.current = S, this.table[S] = T, this.table.splice(S + 1), this.lexerState = T.lexerState, this.results = this.finish();
    }, u.prototype.rewind = function(T) {
      if (!this.options.keepHistory)
        throw new Error("set option `keepHistory` to enable rewinding");
      this.restore(this.table[T]);
    }, u.prototype.finish = function() {
      var T = [], S = this.grammar.start, N = this.table[this.table.length - 1];
      return N.states.forEach(function(m) {
        m.rule.name === S && m.dot === m.rule.symbols.length && m.reference === 0 && m.data !== u.fail && T.push(m);
      }), T.map(function(m) {
        return m.data;
      });
    };
    function R(T) {
      var S = typeof T;
      if (S === "string")
        return T;
      if (S === "object") {
        if (T.literal)
          return JSON.stringify(T.literal);
        if (T instanceof RegExp)
          return "character matching " + T;
        if (T.type)
          return T.type + " token";
        if (T.test)
          return "token matching " + String(T.test);
        throw new Error("Unknown symbol type: " + T);
      }
    }
    function d(T) {
      var S = typeof T;
      if (S === "string")
        return T;
      if (S === "object") {
        if (T.literal)
          return JSON.stringify(T.literal);
        if (T instanceof RegExp)
          return T.toString();
        if (T.type)
          return "%" + T.type;
        if (T.test)
          return "<" + String(T.test) + ">";
        throw new Error("Unknown symbol type: " + T);
      }
    }
    return {
      Parser: u,
      Grammar: c,
      Rule: a
    };
  });
})(Xv);
var u4 = Xv.exports;
const E4 = /* @__PURE__ */ Xi(u4);
function c4(n) {
  return n.map(f4).map(T4).map(d4).map(A4);
}
const f4 = (n, a, s) => {
  if (wv(n.type)) {
    const o = R4(s, a);
    if (o && o.text === ".")
      return {
        ...n,
        type: Ee.IDENTIFIER,
        text: n.raw
      };
  }
  return n;
}, T4 = (n, a, s) => {
  if (n.type === Ee.RESERVED_FUNCTION_NAME) {
    const o = AT(s, a);
    if (!o || !p4(o))
      return {
        ...n,
        type: Ee.RESERVED_KEYWORD
      };
  }
  return n;
}, d4 = (n, a, s) => {
  if (n.type === Ee.IDENTIFIER) {
    const o = AT(s, a);
    if (o && jv(o))
      return {
        ...n,
        type: Ee.ARRAY_IDENTIFIER
      };
  }
  return n;
}, A4 = (n, a, s) => {
  if (n.type === Ee.RESERVED_KEYWORD) {
    const o = AT(s, a);
    if (o && jv(o))
      return {
        ...n,
        type: Ee.ARRAY_KEYWORD
      };
  }
  return n;
}, R4 = (n, a) => AT(n, a, -1), AT = (n, a, s = 1) => {
  let o = 1;
  for (; n[a + o * s] && S4(n[a + o * s]); )
    o++;
  return n[a + o * s];
}, p4 = (n) => n.type === Ee.OPEN_PAREN && n.text === "(", jv = (n) => n.type === Ee.OPEN_PAREN && n.text === "[", S4 = (n) => n.type === Ee.BLOCK_COMMENT || n.type === Ee.LINE_COMMENT;
class Kv {
  constructor(a) {
    Ht(this, "index", 0);
    Ht(this, "tokens", []);
    Ht(this, "input", "");
    this.tokenize = a;
  }
  reset(a, s) {
    this.input = a, this.index = 0, this.tokens = this.tokenize(a);
  }
  next() {
    return this.tokens[this.index++];
  }
  save() {
  }
  formatError(a) {
    const {
      line: s,
      col: o
    } = kv(this.input, a.start);
    return `Parse error at token: ${a.text} at line ${s} column ${o}`;
  }
  has(a) {
    return a in Ee;
  }
}
let De;
(function(n) {
  n.statement = "statement", n.clause = "clause", n.set_operation = "set_operation", n.function_call = "function_call", n.array_subscript = "array_subscript", n.property_access = "property_access", n.parenthesis = "parenthesis", n.between_predicate = "between_predicate", n.case_expression = "case_expression", n.case_when = "case_when", n.case_else = "case_else", n.limit_clause = "limit_clause", n.all_columns_asterisk = "all_columns_asterisk", n.literal = "literal", n.identifier = "identifier", n.keyword = "keyword", n.parameter = "parameter", n.operator = "operator", n.comma = "comma", n.line_comment = "line_comment", n.block_comment = "block_comment";
})(De || (De = {}));
function Fp(n) {
  return n[0];
}
const Be = new Kv((n) => []), Wo = ([[n]]) => n, In = (n) => ({
  type: De.keyword,
  tokenType: n.type,
  text: n.text,
  raw: n.raw
}), Pn = (n, {
  leading: a,
  trailing: s
}) => (a != null && a.length && (n = {
  ...n,
  leadingComments: a
}), s != null && s.length && (n = {
  ...n,
  trailingComments: s
}), n), h4 = (n, {
  leading: a,
  trailing: s
}) => {
  if (a != null && a.length) {
    const [o, ...c] = n;
    n = [Pn(o, {
      leading: a
    }), ...c];
  }
  if (s != null && s.length) {
    const o = n.slice(0, -1), c = n[n.length - 1];
    n = [...o, Pn(c, {
      trailing: s
    })];
  }
  return n;
}, N4 = {
  Lexer: Be,
  ParserRules: [{
    name: "main$ebnf$1",
    symbols: []
  }, {
    name: "main$ebnf$1",
    symbols: ["main$ebnf$1", "statement"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "main",
    symbols: ["main$ebnf$1"],
    postprocess: ([n]) => {
      const a = n[n.length - 1];
      return a && !a.hasSemicolon ? a.children.length > 0 ? n : n.slice(0, -1) : n;
    }
  }, {
    name: "statement$subexpression$1",
    symbols: [Be.has("DELIMITER") ? {
      type: "DELIMITER"
    } : DELIMITER]
  }, {
    name: "statement$subexpression$1",
    symbols: [Be.has("EOF") ? {
      type: "EOF"
    } : EOF]
  }, {
    name: "statement",
    symbols: ["expressions_or_clauses", "statement$subexpression$1"],
    postprocess: ([n, [a]]) => ({
      type: De.statement,
      children: n,
      hasSemicolon: a.type === Ee.DELIMITER
    })
  }, {
    name: "expressions_or_clauses$ebnf$1",
    symbols: []
  }, {
    name: "expressions_or_clauses$ebnf$1",
    symbols: ["expressions_or_clauses$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "expressions_or_clauses$ebnf$2",
    symbols: []
  }, {
    name: "expressions_or_clauses$ebnf$2",
    symbols: ["expressions_or_clauses$ebnf$2", "clause"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "expressions_or_clauses",
    symbols: ["expressions_or_clauses$ebnf$1", "expressions_or_clauses$ebnf$2"],
    postprocess: ([n, a]) => [...n, ...a]
  }, {
    name: "clause$subexpression$1",
    symbols: ["limit_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["select_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["other_clause"]
  }, {
    name: "clause$subexpression$1",
    symbols: ["set_operation"]
  }, {
    name: "clause",
    symbols: ["clause$subexpression$1"],
    postprocess: Wo
  }, {
    name: "limit_clause$ebnf$1$subexpression$1$ebnf$1",
    symbols: ["free_form_sql"]
  }, {
    name: "limit_clause$ebnf$1$subexpression$1$ebnf$1",
    symbols: ["limit_clause$ebnf$1$subexpression$1$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "limit_clause$ebnf$1$subexpression$1",
    symbols: [Be.has("COMMA") ? {
      type: "COMMA"
    } : COMMA, "limit_clause$ebnf$1$subexpression$1$ebnf$1"]
  }, {
    name: "limit_clause$ebnf$1",
    symbols: ["limit_clause$ebnf$1$subexpression$1"],
    postprocess: Fp
  }, {
    name: "limit_clause$ebnf$1",
    symbols: [],
    postprocess: () => null
  }, {
    name: "limit_clause",
    symbols: [Be.has("LIMIT") ? {
      type: "LIMIT"
    } : LIMIT, "_", "expression_chain_", "limit_clause$ebnf$1"],
    postprocess: ([n, a, s, o]) => {
      if (o) {
        const [c, E] = o;
        return {
          type: De.limit_clause,
          limitKw: Pn(In(n), {
            trailing: a
          }),
          offset: s,
          count: E
        };
      } else
        return {
          type: De.limit_clause,
          limitKw: Pn(In(n), {
            trailing: a
          }),
          count: s
        };
    }
  }, {
    name: "select_clause$subexpression$1$ebnf$1",
    symbols: []
  }, {
    name: "select_clause$subexpression$1$ebnf$1",
    symbols: ["select_clause$subexpression$1$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "select_clause$subexpression$1",
    symbols: ["all_columns_asterisk", "select_clause$subexpression$1$ebnf$1"]
  }, {
    name: "select_clause$subexpression$1$ebnf$2",
    symbols: []
  }, {
    name: "select_clause$subexpression$1$ebnf$2",
    symbols: ["select_clause$subexpression$1$ebnf$2", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "select_clause$subexpression$1",
    symbols: ["asteriskless_free_form_sql", "select_clause$subexpression$1$ebnf$2"]
  }, {
    name: "select_clause",
    symbols: [Be.has("RESERVED_SELECT") ? {
      type: "RESERVED_SELECT"
    } : RESERVED_SELECT, "select_clause$subexpression$1"],
    postprocess: ([n, [a, s]]) => ({
      type: De.clause,
      nameKw: In(n),
      children: [a, ...s]
    })
  }, {
    name: "select_clause",
    symbols: [Be.has("RESERVED_SELECT") ? {
      type: "RESERVED_SELECT"
    } : RESERVED_SELECT],
    postprocess: ([n]) => ({
      type: De.clause,
      nameKw: In(n),
      children: []
    })
  }, {
    name: "all_columns_asterisk",
    symbols: [Be.has("ASTERISK") ? {
      type: "ASTERISK"
    } : ASTERISK],
    postprocess: () => ({
      type: De.all_columns_asterisk
    })
  }, {
    name: "other_clause$ebnf$1",
    symbols: []
  }, {
    name: "other_clause$ebnf$1",
    symbols: ["other_clause$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "other_clause",
    symbols: [Be.has("RESERVED_CLAUSE") ? {
      type: "RESERVED_CLAUSE"
    } : RESERVED_CLAUSE, "other_clause$ebnf$1"],
    postprocess: ([n, a]) => ({
      type: De.clause,
      nameKw: In(n),
      children: a
    })
  }, {
    name: "set_operation$ebnf$1",
    symbols: []
  }, {
    name: "set_operation$ebnf$1",
    symbols: ["set_operation$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "set_operation",
    symbols: [Be.has("RESERVED_SET_OPERATION") ? {
      type: "RESERVED_SET_OPERATION"
    } : RESERVED_SET_OPERATION, "set_operation$ebnf$1"],
    postprocess: ([n, a]) => ({
      type: De.set_operation,
      nameKw: In(n),
      children: a
    })
  }, {
    name: "expression_chain_$ebnf$1",
    symbols: ["expression_with_comments_"]
  }, {
    name: "expression_chain_$ebnf$1",
    symbols: ["expression_chain_$ebnf$1", "expression_with_comments_"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "expression_chain_",
    symbols: ["expression_chain_$ebnf$1"],
    postprocess: Fp
  }, {
    name: "expression_chain$ebnf$1",
    symbols: []
  }, {
    name: "expression_chain$ebnf$1",
    symbols: ["expression_chain$ebnf$1", "_expression_with_comments"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "expression_chain",
    symbols: ["expression", "expression_chain$ebnf$1"],
    postprocess: ([n, a]) => [n, ...a]
  }, {
    name: "andless_expression_chain$ebnf$1",
    symbols: []
  }, {
    name: "andless_expression_chain$ebnf$1",
    symbols: ["andless_expression_chain$ebnf$1", "_andless_expression_with_comments"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "andless_expression_chain",
    symbols: ["andless_expression", "andless_expression_chain$ebnf$1"],
    postprocess: ([n, a]) => [n, ...a]
  }, {
    name: "expression_with_comments_",
    symbols: ["expression", "_"],
    postprocess: ([n, a]) => Pn(n, {
      trailing: a
    })
  }, {
    name: "_expression_with_comments",
    symbols: ["_", "expression"],
    postprocess: ([n, a]) => Pn(a, {
      leading: n
    })
  }, {
    name: "_andless_expression_with_comments",
    symbols: ["_", "andless_expression"],
    postprocess: ([n, a]) => Pn(a, {
      leading: n
    })
  }, {
    name: "free_form_sql$subexpression$1",
    symbols: ["asteriskless_free_form_sql"]
  }, {
    name: "free_form_sql$subexpression$1",
    symbols: ["asterisk"]
  }, {
    name: "free_form_sql",
    symbols: ["free_form_sql$subexpression$1"],
    postprocess: Wo
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["asteriskless_andless_expression"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["logic_operator"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["between_predicate"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["comma"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["comment"]
  }, {
    name: "asteriskless_free_form_sql$subexpression$1",
    symbols: ["other_keyword"]
  }, {
    name: "asteriskless_free_form_sql",
    symbols: ["asteriskless_free_form_sql$subexpression$1"],
    postprocess: Wo
  }, {
    name: "expression$subexpression$1",
    symbols: ["andless_expression"]
  }, {
    name: "expression$subexpression$1",
    symbols: ["logic_operator"]
  }, {
    name: "expression",
    symbols: ["expression$subexpression$1"],
    postprocess: Wo
  }, {
    name: "andless_expression$subexpression$1",
    symbols: ["asteriskless_andless_expression"]
  }, {
    name: "andless_expression$subexpression$1",
    symbols: ["asterisk"]
  }, {
    name: "andless_expression",
    symbols: ["andless_expression$subexpression$1"],
    postprocess: Wo
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["array_subscript"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["case_expression"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["function_call"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["property_access"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["parenthesis"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["curly_braces"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["square_brackets"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["operator"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["identifier"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["parameter"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["literal"]
  }, {
    name: "asteriskless_andless_expression$subexpression$1",
    symbols: ["keyword"]
  }, {
    name: "asteriskless_andless_expression",
    symbols: ["asteriskless_andless_expression$subexpression$1"],
    postprocess: Wo
  }, {
    name: "array_subscript",
    symbols: [Be.has("ARRAY_IDENTIFIER") ? {
      type: "ARRAY_IDENTIFIER"
    } : ARRAY_IDENTIFIER, "_", "square_brackets"],
    postprocess: ([n, a, s]) => ({
      type: De.array_subscript,
      array: Pn({
        type: De.identifier,
        text: n.text
      }, {
        trailing: a
      }),
      parenthesis: s
    })
  }, {
    name: "array_subscript",
    symbols: [Be.has("ARRAY_KEYWORD") ? {
      type: "ARRAY_KEYWORD"
    } : ARRAY_KEYWORD, "_", "square_brackets"],
    postprocess: ([n, a, s]) => ({
      type: De.array_subscript,
      array: Pn(In(n), {
        trailing: a
      }),
      parenthesis: s
    })
  }, {
    name: "function_call",
    symbols: [Be.has("RESERVED_FUNCTION_NAME") ? {
      type: "RESERVED_FUNCTION_NAME"
    } : RESERVED_FUNCTION_NAME, "_", "parenthesis"],
    postprocess: ([n, a, s]) => ({
      type: De.function_call,
      nameKw: Pn(In(n), {
        trailing: a
      }),
      parenthesis: s
    })
  }, {
    name: "parenthesis",
    symbols: [{
      literal: "("
    }, "expressions_or_clauses", {
      literal: ")"
    }],
    postprocess: ([n, a, s]) => ({
      type: De.parenthesis,
      children: a,
      openParen: "(",
      closeParen: ")"
    })
  }, {
    name: "curly_braces$ebnf$1",
    symbols: []
  }, {
    name: "curly_braces$ebnf$1",
    symbols: ["curly_braces$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "curly_braces",
    symbols: [{
      literal: "{"
    }, "curly_braces$ebnf$1", {
      literal: "}"
    }],
    postprocess: ([n, a, s]) => ({
      type: De.parenthesis,
      children: a,
      openParen: "{",
      closeParen: "}"
    })
  }, {
    name: "square_brackets$ebnf$1",
    symbols: []
  }, {
    name: "square_brackets$ebnf$1",
    symbols: ["square_brackets$ebnf$1", "free_form_sql"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "square_brackets",
    symbols: [{
      literal: "["
    }, "square_brackets$ebnf$1", {
      literal: "]"
    }],
    postprocess: ([n, a, s]) => ({
      type: De.parenthesis,
      children: a,
      openParen: "[",
      closeParen: "]"
    })
  }, {
    name: "property_access$subexpression$1",
    symbols: ["identifier"]
  }, {
    name: "property_access$subexpression$1",
    symbols: ["array_subscript"]
  }, {
    name: "property_access$subexpression$1",
    symbols: ["all_columns_asterisk"]
  }, {
    name: "property_access",
    symbols: ["expression", "_", Be.has("DOT") ? {
      type: "DOT"
    } : DOT, "_", "property_access$subexpression$1"],
    postprocess: (
      // Allowing property to be <array_subscript> is currently a hack.
      // A better way would be to allow <property_access> on the left side of array_subscript,
      // but we currently can't do that because of another hack that requires
      // %ARRAY_IDENTIFIER on the left side of <array_subscript>.
      ([n, a, s, o, [c]]) => ({
        type: De.property_access,
        object: Pn(n, {
          trailing: a
        }),
        property: Pn(c, {
          leading: o
        })
      })
    )
  }, {
    name: "between_predicate",
    symbols: [Be.has("BETWEEN") ? {
      type: "BETWEEN"
    } : BETWEEN, "_", "andless_expression_chain", "_", Be.has("AND") ? {
      type: "AND"
    } : AND, "_", "andless_expression"],
    postprocess: ([n, a, s, o, c, E, u]) => ({
      type: De.between_predicate,
      betweenKw: In(n),
      expr1: h4(s, {
        leading: a,
        trailing: o
      }),
      andKw: In(c),
      expr2: [Pn(u, {
        leading: E
      })]
    })
  }, {
    name: "case_expression$ebnf$1",
    symbols: ["expression_chain_"],
    postprocess: Fp
  }, {
    name: "case_expression$ebnf$1",
    symbols: [],
    postprocess: () => null
  }, {
    name: "case_expression$ebnf$2",
    symbols: []
  }, {
    name: "case_expression$ebnf$2",
    symbols: ["case_expression$ebnf$2", "case_clause"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "case_expression",
    symbols: [Be.has("CASE") ? {
      type: "CASE"
    } : CASE, "_", "case_expression$ebnf$1", "case_expression$ebnf$2", Be.has("END") ? {
      type: "END"
    } : END],
    postprocess: ([n, a, s, o, c]) => ({
      type: De.case_expression,
      caseKw: Pn(In(n), {
        trailing: a
      }),
      endKw: In(c),
      expr: s || [],
      clauses: o
    })
  }, {
    name: "case_clause",
    symbols: [Be.has("WHEN") ? {
      type: "WHEN"
    } : WHEN, "_", "expression_chain_", Be.has("THEN") ? {
      type: "THEN"
    } : THEN, "_", "expression_chain_"],
    postprocess: ([n, a, s, o, c, E]) => ({
      type: De.case_when,
      whenKw: Pn(In(n), {
        trailing: a
      }),
      thenKw: Pn(In(o), {
        trailing: c
      }),
      condition: s,
      result: E
    })
  }, {
    name: "case_clause",
    symbols: [Be.has("ELSE") ? {
      type: "ELSE"
    } : ELSE, "_", "expression_chain_"],
    postprocess: ([n, a, s]) => ({
      type: De.case_else,
      elseKw: Pn(In(n), {
        trailing: a
      }),
      result: s
    })
  }, {
    name: "comma$subexpression$1",
    symbols: [Be.has("COMMA") ? {
      type: "COMMA"
    } : COMMA]
  }, {
    name: "comma",
    symbols: ["comma$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.comma
    })
  }, {
    name: "asterisk$subexpression$1",
    symbols: [Be.has("ASTERISK") ? {
      type: "ASTERISK"
    } : ASTERISK]
  }, {
    name: "asterisk",
    symbols: ["asterisk$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.operator,
      text: n.text
    })
  }, {
    name: "operator$subexpression$1",
    symbols: [Be.has("OPERATOR") ? {
      type: "OPERATOR"
    } : OPERATOR]
  }, {
    name: "operator",
    symbols: ["operator$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.operator,
      text: n.text
    })
  }, {
    name: "identifier$subexpression$1",
    symbols: [Be.has("IDENTIFIER") ? {
      type: "IDENTIFIER"
    } : IDENTIFIER]
  }, {
    name: "identifier$subexpression$1",
    symbols: [Be.has("QUOTED_IDENTIFIER") ? {
      type: "QUOTED_IDENTIFIER"
    } : QUOTED_IDENTIFIER]
  }, {
    name: "identifier$subexpression$1",
    symbols: [Be.has("VARIABLE") ? {
      type: "VARIABLE"
    } : VARIABLE]
  }, {
    name: "identifier",
    symbols: ["identifier$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.identifier,
      text: n.text
    })
  }, {
    name: "parameter$subexpression$1",
    symbols: [Be.has("NAMED_PARAMETER") ? {
      type: "NAMED_PARAMETER"
    } : NAMED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [Be.has("QUOTED_PARAMETER") ? {
      type: "QUOTED_PARAMETER"
    } : QUOTED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [Be.has("NUMBERED_PARAMETER") ? {
      type: "NUMBERED_PARAMETER"
    } : NUMBERED_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [Be.has("POSITIONAL_PARAMETER") ? {
      type: "POSITIONAL_PARAMETER"
    } : POSITIONAL_PARAMETER]
  }, {
    name: "parameter$subexpression$1",
    symbols: [Be.has("CUSTOM_PARAMETER") ? {
      type: "CUSTOM_PARAMETER"
    } : CUSTOM_PARAMETER]
  }, {
    name: "parameter",
    symbols: ["parameter$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.parameter,
      key: n.key,
      text: n.text
    })
  }, {
    name: "literal$subexpression$1",
    symbols: [Be.has("NUMBER") ? {
      type: "NUMBER"
    } : NUMBER]
  }, {
    name: "literal$subexpression$1",
    symbols: [Be.has("STRING") ? {
      type: "STRING"
    } : STRING]
  }, {
    name: "literal",
    symbols: ["literal$subexpression$1"],
    postprocess: ([[n]]) => ({
      type: De.literal,
      text: n.text
    })
  }, {
    name: "keyword$subexpression$1",
    symbols: [Be.has("RESERVED_KEYWORD") ? {
      type: "RESERVED_KEYWORD"
    } : RESERVED_KEYWORD]
  }, {
    name: "keyword$subexpression$1",
    symbols: [Be.has("RESERVED_PHRASE") ? {
      type: "RESERVED_PHRASE"
    } : RESERVED_PHRASE]
  }, {
    name: "keyword$subexpression$1",
    symbols: [Be.has("RESERVED_JOIN") ? {
      type: "RESERVED_JOIN"
    } : RESERVED_JOIN]
  }, {
    name: "keyword",
    symbols: ["keyword$subexpression$1"],
    postprocess: ([[n]]) => In(n)
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [Be.has("AND") ? {
      type: "AND"
    } : AND]
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [Be.has("OR") ? {
      type: "OR"
    } : OR]
  }, {
    name: "logic_operator$subexpression$1",
    symbols: [Be.has("XOR") ? {
      type: "XOR"
    } : XOR]
  }, {
    name: "logic_operator",
    symbols: ["logic_operator$subexpression$1"],
    postprocess: ([[n]]) => In(n)
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [Be.has("WHEN") ? {
      type: "WHEN"
    } : WHEN]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [Be.has("THEN") ? {
      type: "THEN"
    } : THEN]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [Be.has("ELSE") ? {
      type: "ELSE"
    } : ELSE]
  }, {
    name: "other_keyword$subexpression$1",
    symbols: [Be.has("END") ? {
      type: "END"
    } : END]
  }, {
    name: "other_keyword",
    symbols: ["other_keyword$subexpression$1"],
    postprocess: ([[n]]) => In(n)
  }, {
    name: "_$ebnf$1",
    symbols: []
  }, {
    name: "_$ebnf$1",
    symbols: ["_$ebnf$1", "comment"],
    postprocess: (n) => n[0].concat([n[1]])
  }, {
    name: "_",
    symbols: ["_$ebnf$1"],
    postprocess: ([n]) => n
  }, {
    name: "comment",
    symbols: [Be.has("LINE_COMMENT") ? {
      type: "LINE_COMMENT"
    } : LINE_COMMENT],
    postprocess: ([n]) => ({
      type: De.line_comment,
      text: n.text,
      precedingWhitespace: n.precedingWhitespace
    })
  }, {
    name: "comment",
    symbols: [Be.has("BLOCK_COMMENT") ? {
      type: "BLOCK_COMMENT"
    } : BLOCK_COMMENT],
    postprocess: ([n]) => ({
      type: De.block_comment,
      text: n.text,
      precedingWhitespace: n.precedingWhitespace
    })
  }],
  ParserStart: "main"
}, O4 = N4, {
  Parser: I4,
  Grammar: _4
} = E4;
function C4(n) {
  let a = {};
  const s = new Kv((c) => [...c4(n.tokenize(c, a)), xv(c.length)]), o = new I4(_4.fromCompiled(O4), {
    lexer: s
  });
  return {
    parse: (c, E) => {
      a = E;
      const {
        results: u
      } = o.feed(c);
      if (u.length === 1)
        return u[0];
      throw u.length === 0 ? new Error("Parse error: Invalid SQL") : new Error(`Parse error: Ambiguous grammar
${JSON.stringify(u, void 0, 2)}`);
    }
  };
}
const m4 = /^\s+/u;
function v4(n, a, s) {
  return L4(n.split(`
`)).flatMap((o) => {
    if (o.length === 1)
      return o;
    if (a === "tabular")
      return y4(o);
    if (a === "before")
      return D4(o, s);
    throw new Error(`Unexpected commaPosition: ${a}`);
  }).join(`
`);
}
function L4(n) {
  const a = [];
  for (let s = 0; s < n.length; s++) {
    const o = [n[s]];
    for (; n[s].match(/.*,(\s*(--.*)?$)/); )
      s++, o.push(n[s]);
    a.push(o);
  }
  return a;
}
function y4(n) {
  const a = Bv(P4(n)) - 1;
  return n.map((s, o) => o === n.length - 1 ? s : g4(s, a));
}
function g4(n, a) {
  const [, s, o] = n.match(/^(.*?),(\s*--.*)?$/) || [], c = " ".repeat(a - s.length);
  return `${s}${c},${o ?? ""}`;
}
function D4(n, a) {
  return M4(n).map((s, o) => {
    if (o === 0)
      return s;
    const [c] = s.match(m4) || [""];
    return b4(c, a) + a.replace(/ {2}$/, ", ") + // add comma to the end of last indent
    s.trimStart();
  });
}
function b4(n, a) {
  return n.replace(new RegExp(a + "$"), "");
}
function M4(n) {
  return n.map((a) => a.replace(/,(\s*(--.*)?$)/, "$1"));
}
function P4(n) {
  return n.map((a) => a.replace(/\s*--.*/, ""));
}
function U4(n) {
  const a = n.split(`
`);
  let s = [];
  for (let o = 0; o < a.length; o++) {
    if (a[o].match(/^\s*SELECT/i)) {
      let c = [];
      if (a[o].match(/.*,$/))
        c = [a[o]];
      else {
        if (s.push(a[o]), a[o].match(/^\s*SELECT\s+.+(?!,$)/i))
          continue;
        c.push(a[++o]);
      }
      for (; a[o++].match(/.*,$/); )
        c.push(a[o]);
      const E = c.map((R) => ({
        line: R,
        matches: R.match(/(^.*?\S) (AS )?(\S+,?$)/i)
      })).map(({
        line: R,
        matches: d
      }) => d ? {
        precedingText: d[1],
        as: d[2],
        alias: d[3]
      } : {
        precedingText: R
      }), u = Bv(E.map(({
        precedingText: R
      }) => R.replace(/\s*,\s*$/, "")));
      c = E.map(({
        precedingText: R,
        as: d,
        alias: T
      }) => R + (T ? " ".repeat(u - R.length + 1) + (d ?? "") + T : "")), s = [...s, ...c];
    }
    s.push(a[o]);
  }
  return s.join(`
`);
}
let se;
(function(n) {
  n[n.SPACE = 0] = "SPACE", n[n.NO_SPACE = 1] = "NO_SPACE", n[n.NO_NEWLINE = 2] = "NO_NEWLINE", n[n.NEWLINE = 3] = "NEWLINE", n[n.MANDATORY_NEWLINE = 4] = "MANDATORY_NEWLINE", n[n.INDENT = 5] = "INDENT", n[n.SINGLE_INDENT = 6] = "SINGLE_INDENT";
})(se || (se = {}));
class Jv {
  constructor(a) {
    Ht(this, "items", []);
    this.indentation = a;
  }
  /**
   * Appends token strings and whitespace modifications to SQL string.
   */
  add(...a) {
    for (const s of a)
      switch (s) {
        case se.SPACE:
          this.items.push(se.SPACE);
          break;
        case se.NO_SPACE:
          this.trimHorizontalWhitespace();
          break;
        case se.NO_NEWLINE:
          this.trimWhitespace();
          break;
        case se.NEWLINE:
          this.trimHorizontalWhitespace(), this.addNewline(se.NEWLINE);
          break;
        case se.MANDATORY_NEWLINE:
          this.trimHorizontalWhitespace(), this.addNewline(se.MANDATORY_NEWLINE);
          break;
        case se.INDENT:
          this.addIndentation();
          break;
        case se.SINGLE_INDENT:
          this.items.push(se.SINGLE_INDENT);
          break;
        default:
          this.items.push(s);
      }
  }
  trimHorizontalWhitespace() {
    for (; x4(zu(this.items)); )
      this.items.pop();
  }
  trimWhitespace() {
    for (; w4(zu(this.items)); )
      this.items.pop();
  }
  addNewline(a) {
    if (this.items.length > 0)
      switch (zu(this.items)) {
        case se.NEWLINE:
          this.items.pop(), this.items.push(a);
          break;
        case se.MANDATORY_NEWLINE:
          break;
        default:
          this.items.push(a);
          break;
      }
  }
  addIndentation() {
    for (let a = 0; a < this.indentation.getLevel(); a++)
      this.items.push(se.SINGLE_INDENT);
  }
  /**
   * Returns the final SQL string.
   */
  toString() {
    return this.items.map((a) => this.itemToString(a)).join("");
  }
  /**
   * Returns the internal layout data
   */
  getLayoutItems() {
    return this.items;
  }
  itemToString(a) {
    switch (a) {
      case se.SPACE:
        return " ";
      case se.NEWLINE:
      case se.MANDATORY_NEWLINE:
        return `
`;
      case se.SINGLE_INDENT:
        return this.indentation.getSingleIndent();
      default:
        return a;
    }
  }
}
const x4 = (n) => n === se.SPACE || n === se.SINGLE_INDENT, w4 = (n) => n === se.SPACE || n === se.SINGLE_INDENT || n === se.NEWLINE;
function G4(n, a) {
  if (a === "standard")
    return n;
  let s = [];
  return n.length >= 10 && n.includes(" ") && ([n, ...s] = n.split(" ")), a === "tabularLeft" ? n = n.padEnd(9, " ") : n = n.padStart(9, " "), n + ["", ...s].join(" ");
}
function H4(n) {
  return cG(n) || n === Ee.RESERVED_CLAUSE || n === Ee.RESERVED_SELECT || n === Ee.RESERVED_SET_OPERATION || n === Ee.RESERVED_JOIN || n === Ee.LIMIT;
}
const Yp = "top-level", B4 = "block-level";
class zv {
  /**
   * @param {string} indent A string to indent with
   */
  constructor(a) {
    Ht(this, "indentTypes", []);
    this.indent = a;
  }
  /**
   * Returns indentation string for single indentation step.
   */
  getSingleIndent() {
    return this.indent;
  }
  /**
   * Returns current indentation level
   */
  getLevel() {
    return this.indentTypes.length;
  }
  /**
   * Increases indentation by one top-level indent.
   */
  increaseTopLevel() {
    this.indentTypes.push(Yp);
  }
  /**
   * Increases indentation by one block-level indent.
   */
  increaseBlockLevel() {
    this.indentTypes.push(B4);
  }
  /**
   * Decreases indentation by one top-level indent.
   * Does nothing when the previous indent is not top-level.
   */
  decreaseTopLevel() {
    this.indentTypes.length > 0 && zu(this.indentTypes) === Yp && this.indentTypes.pop();
  }
  /**
   * Decreases indentation by one block-level indent.
   * If there are top-level indents within the block-level indent,
   * throws away these as well.
   */
  decreaseBlockLevel() {
    for (; this.indentTypes.length > 0 && this.indentTypes.pop() === Yp; )
      ;
  }
}
class F4 extends Jv {
  constructor(s) {
    super(new zv(""));
    Ht(this, "length", 0);
    // Keeps track of the trailing whitespace,
    // so that we can decrease length when encountering WS.NO_SPACE,
    // but only when there actually is a space to remove.
    Ht(this, "trailingSpace", !1);
    this.expressionWidth = s;
  }
  add(...s) {
    if (s.forEach((o) => this.addToLength(o)), this.length > this.expressionWidth)
      throw new RS();
    super.add(...s);
  }
  addToLength(s) {
    if (typeof s == "string")
      this.length += s.length, this.trailingSpace = !1;
    else {
      if (s === se.MANDATORY_NEWLINE || s === se.NEWLINE)
        throw new RS();
      s === se.INDENT || s === se.SINGLE_INDENT || s === se.SPACE ? this.trailingSpace || (this.length++, this.trailingSpace = !0) : (s === se.NO_NEWLINE || s === se.NO_SPACE) && this.trailingSpace && (this.trailingSpace = !1, this.length--);
    }
  }
}
class RS extends Error {
}
class Qf {
  constructor({
    cfg: a,
    dialectCfg: s,
    params: o,
    layout: c,
    inline: E = !1
  }) {
    Ht(this, "inline", !1);
    Ht(this, "nodes", []);
    Ht(this, "index", -1);
    this.cfg = a, this.dialectCfg = s, this.inline = E, this.params = o, this.layout = c;
  }
  format(a) {
    for (this.nodes = a, this.index = 0; this.index < this.nodes.length; this.index++)
      this.formatNode(this.nodes[this.index]);
    return this.layout;
  }
  formatNode(a) {
    this.formatComments(a.leadingComments), this.formatNodeWithoutComments(a), this.formatComments(a.trailingComments);
  }
  formatNodeWithoutComments(a) {
    switch (a.type) {
      case De.function_call:
        return this.formatFunctionCall(a);
      case De.array_subscript:
        return this.formatArraySubscript(a);
      case De.property_access:
        return this.formatPropertyAccess(a);
      case De.parenthesis:
        return this.formatParenthesis(a);
      case De.between_predicate:
        return this.formatBetweenPredicate(a);
      case De.case_expression:
        return this.formatCaseExpression(a);
      case De.case_when:
        return this.formatCaseWhen(a);
      case De.case_else:
        return this.formatCaseElse(a);
      case De.clause:
        return this.formatClause(a);
      case De.set_operation:
        return this.formatSetOperation(a);
      case De.limit_clause:
        return this.formatLimitClause(a);
      case De.all_columns_asterisk:
        return this.formatAllColumnsAsterisk(a);
      case De.literal:
        return this.formatLiteral(a);
      case De.identifier:
        return this.formatIdentifier(a);
      case De.parameter:
        return this.formatParameter(a);
      case De.operator:
        return this.formatOperator(a);
      case De.comma:
        return this.formatComma(a);
      case De.line_comment:
        return this.formatLineComment(a);
      case De.block_comment:
        return this.formatBlockComment(a);
      case De.keyword:
        return this.formatKeywordNode(a);
    }
  }
  formatFunctionCall(a) {
    this.withComments(a.nameKw, () => {
      this.layout.add(this.showKw(a.nameKw));
    }), this.formatNode(a.parenthesis);
  }
  formatArraySubscript(a) {
    this.withComments(a.array, () => {
      this.layout.add(a.array.type === De.keyword ? this.showKw(a.array) : a.array.text);
    }), this.formatNode(a.parenthesis);
  }
  formatPropertyAccess(a) {
    this.formatNode(a.object), this.layout.add(se.NO_SPACE, "."), this.formatNode(a.property);
  }
  formatParenthesis(a) {
    const s = this.formatInlineExpression(a.children);
    s ? (this.layout.add(a.openParen), this.layout.add(...s.getLayoutItems()), this.layout.add(se.NO_SPACE, a.closeParen, se.SPACE)) : (this.layout.add(a.openParen, se.NEWLINE), Xu(this.cfg) ? (this.layout.add(se.INDENT), this.layout = this.formatSubExpression(a.children)) : (this.layout.indentation.increaseBlockLevel(), this.layout.add(se.INDENT), this.layout = this.formatSubExpression(a.children), this.layout.indentation.decreaseBlockLevel()), this.layout.add(se.NEWLINE, se.INDENT, a.closeParen, se.SPACE));
  }
  formatBetweenPredicate(a) {
    this.layout.add(this.showKw(a.betweenKw), se.SPACE), this.layout = this.formatSubExpression(a.expr1), this.layout.add(se.NO_SPACE, se.SPACE, this.showNonTabularKw(a.andKw), se.SPACE), this.layout = this.formatSubExpression(a.expr2), this.layout.add(se.SPACE);
  }
  formatCaseExpression(a) {
    this.formatNode(a.caseKw), this.layout.indentation.increaseBlockLevel(), this.layout = this.formatSubExpression(a.expr), this.layout = this.formatSubExpression(a.clauses), this.layout.indentation.decreaseBlockLevel(), this.layout.add(se.NEWLINE, se.INDENT), this.formatNode(a.endKw);
  }
  formatCaseWhen(a) {
    this.layout.add(se.NEWLINE, se.INDENT), this.formatNode(a.whenKw), this.layout = this.formatSubExpression(a.condition), this.formatNode(a.thenKw), this.layout = this.formatSubExpression(a.result);
  }
  formatCaseElse(a) {
    this.layout.add(se.NEWLINE, se.INDENT), this.formatNode(a.elseKw), this.layout = this.formatSubExpression(a.result);
  }
  formatClause(a) {
    this.isOnelineClause(a) ? this.formatClauseInOnelineStyle(a) : Xu(this.cfg) ? this.formatClauseInTabularStyle(a) : this.formatClauseInIndentedStyle(a);
  }
  isOnelineClause(a) {
    return this.dialectCfg.onelineClauses[a.nameKw.text];
  }
  formatClauseInIndentedStyle(a) {
    this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a.nameKw), se.NEWLINE), this.layout.indentation.increaseTopLevel(), this.layout.add(se.INDENT), this.layout = this.formatSubExpression(a.children), this.layout.indentation.decreaseTopLevel();
  }
  formatClauseInOnelineStyle(a) {
    this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a.nameKw), se.SPACE), this.layout = this.formatSubExpression(a.children);
  }
  formatClauseInTabularStyle(a) {
    this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a.nameKw), se.SPACE), this.layout.indentation.increaseTopLevel(), this.layout = this.formatSubExpression(a.children), this.layout.indentation.decreaseTopLevel();
  }
  formatSetOperation(a) {
    this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a.nameKw), se.NEWLINE), this.layout.add(se.INDENT), this.layout = this.formatSubExpression(a.children);
  }
  formatLimitClause(a) {
    this.withComments(a.limitKw, () => {
      this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a.limitKw));
    }), this.layout.indentation.increaseTopLevel(), Xu(this.cfg) ? this.layout.add(se.SPACE) : this.layout.add(se.NEWLINE, se.INDENT), a.offset ? (this.layout = this.formatSubExpression(a.offset), this.layout.add(se.NO_SPACE, ",", se.SPACE), this.layout = this.formatSubExpression(a.count)) : this.layout = this.formatSubExpression(a.count), this.layout.indentation.decreaseTopLevel();
  }
  formatAllColumnsAsterisk(a) {
    this.layout.add("*", se.SPACE);
  }
  formatLiteral(a) {
    this.layout.add(a.text, se.SPACE);
  }
  formatIdentifier(a) {
    this.layout.add(a.text, se.SPACE);
  }
  formatParameter(a) {
    this.layout.add(this.params.get(a), se.SPACE);
  }
  formatOperator({
    text: a
  }) {
    this.cfg.denseOperators || this.dialectCfg.alwaysDenseOperators.includes(a) ? this.layout.add(se.NO_SPACE, a) : a === ":" ? this.layout.add(se.NO_SPACE, a, se.SPACE) : this.layout.add(a, se.SPACE);
  }
  formatComma(a) {
    this.inline ? this.layout.add(se.NO_SPACE, ",", se.SPACE) : this.layout.add(se.NO_SPACE, ",", se.NEWLINE, se.INDENT);
  }
  withComments(a, s) {
    this.formatComments(a.leadingComments), s(), this.formatComments(a.trailingComments);
  }
  formatComments(a) {
    a && a.forEach((s) => {
      s.type === De.line_comment ? this.formatLineComment(s) : this.formatBlockComment(s);
    });
  }
  formatLineComment(a) {
    Hp(a.precedingWhitespace || "") ? this.layout.add(se.NEWLINE, se.INDENT, a.text, se.MANDATORY_NEWLINE, se.INDENT) : this.layout.getLayoutItems().length > 0 ? this.layout.add(se.NO_NEWLINE, se.SPACE, a.text, se.MANDATORY_NEWLINE, se.INDENT) : this.layout.add(a.text, se.MANDATORY_NEWLINE, se.INDENT);
  }
  formatBlockComment(a) {
    this.isMultilineBlockComment(a) ? (this.splitBlockComment(a.text).forEach((s) => {
      this.layout.add(se.NEWLINE, se.INDENT, s);
    }), this.layout.add(se.NEWLINE, se.INDENT)) : this.layout.add(a.text, se.SPACE);
  }
  isMultilineBlockComment(a) {
    return Hp(a.text) || Hp(a.precedingWhitespace || "");
  }
  isDocComment(a) {
    const s = a.split(/\n/);
    return (
      // first line starts with /* or /**
      /^\/\*\*?$/.test(s[0]) && // intermediate lines start with *
      s.slice(1, s.length - 1).every((o) => /^\s*\*/.test(o)) && // last line ends with */
      /^\s*\*\/$/.test(zu(s))
    );
  }
  // Breaks up block comment to multiple lines.
  // For example this doc-comment (dots representing leading whitespace):
  //
  //   ..../**
  //   .....* Some description here
  //   .....* and here too
  //   .....*/
  //
  // gets broken to this array (note the leading single spaces):
  //
  //   [ '/**',
  //     '.* Some description here',
  //     '.* and here too',
  //     '.*/' ]
  //
  // However, a normal comment (non-doc-comment) like this:
  //
  //   ..../*
  //   ....Some description here
  //   ....*/
  //
  // gets broken to this array (no leading spaces):
  //
  //   [ '/*',
  //     'Some description here',
  //     '*/' ]
  //
  splitBlockComment(a) {
    return this.isDocComment(a) ? a.split(/\n/).map((s) => /^\s*\*/.test(s) ? " " + s.replace(/^\s*/, "") : s) : a.split(/\n/).map((s) => s.replace(/^\s*/, ""));
  }
  formatSubExpression(a) {
    return new Qf({
      cfg: this.cfg,
      dialectCfg: this.dialectCfg,
      params: this.params,
      layout: this.layout,
      inline: this.inline
    }).format(a);
  }
  formatInlineExpression(a) {
    const s = this.params.getPositionalParameterIndex();
    try {
      return new Qf({
        cfg: this.cfg,
        dialectCfg: this.dialectCfg,
        params: this.params,
        layout: new F4(this.cfg.expressionWidth),
        inline: !0
      }).format(a);
    } catch (o) {
      if (o instanceof RS) {
        this.params.setPositionalParameterIndex(s);
        return;
      } else
        throw o;
    }
  }
  formatKeywordNode(a) {
    switch (a.tokenType) {
      case Ee.RESERVED_JOIN:
        return this.formatJoin(a);
      case Ee.AND:
      case Ee.OR:
      case Ee.XOR:
        return this.formatLogicalOperator(a);
      default:
        return this.formatKeyword(a);
    }
  }
  formatJoin(a) {
    Xu(this.cfg) ? (this.layout.indentation.decreaseTopLevel(), this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a), se.SPACE), this.layout.indentation.increaseTopLevel()) : this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a), se.SPACE);
  }
  formatKeyword(a) {
    this.layout.add(this.showKw(a), se.SPACE);
  }
  formatLogicalOperator(a) {
    this.cfg.logicalOperatorNewline === "before" ? Xu(this.cfg) ? (this.layout.indentation.decreaseTopLevel(), this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a), se.SPACE), this.layout.indentation.increaseTopLevel()) : this.layout.add(se.NEWLINE, se.INDENT, this.showKw(a), se.SPACE) : this.layout.add(this.showKw(a), se.NEWLINE, se.INDENT);
  }
  showKw(a) {
    return H4(a.tokenType) ? G4(this.showNonTabularKw(a), this.cfg.indentStyle) : this.showNonTabularKw(a);
  }
  // Like showKw(), but skips tabular formatting
  showNonTabularKw(a) {
    switch (this.cfg.keywordCase) {
      case "preserve":
        return Fv(a.raw);
      case "upper":
        return a.text;
      case "lower":
        return a.text.toLowerCase();
    }
  }
}
class Y4 {
  constructor(a, s) {
    this.dialect = a, this.cfg = s, this.params = new l4(this.cfg.params);
  }
  /**
   * Formats an SQL query.
   * @param {string} query - The SQL query string to be formatted
   * @return {string} The formatter query
   */
  format(a) {
    const s = this.parse(a), o = this.formatAst(s);
    return this.postFormat(o).trimEnd();
  }
  parse(a) {
    return C4(this.dialect.tokenizer).parse(a, this.cfg.paramTypes || {});
  }
  formatAst(a) {
    return a.map((s) => this.formatStatement(s)).join(`
`.repeat(this.cfg.linesBetweenQueries + 1));
  }
  formatStatement(a) {
    const s = new Qf({
      cfg: this.cfg,
      dialectCfg: this.dialect.formatOptions,
      params: this.params,
      layout: new Jv(new zv(QC(this.cfg)))
    }).format(a.children);
    return a.hasSemicolon && (this.cfg.newlineBeforeSemicolon ? s.add(se.NEWLINE, ";") : s.add(se.NO_NEWLINE, ";")), s.toString();
  }
  postFormat(a) {
    return this.cfg.tabulateAlias && (a = U4(a)), (this.cfg.commaPosition === "before" || this.cfg.commaPosition === "tabular") && (a = v4(a, this.cfg.commaPosition, QC(this.cfg))), a;
  }
}
class Ds extends Error {
}
function V4(n) {
  if ("multilineLists" in n)
    throw new Ds("multilineLists config is no more supported.");
  if ("newlineBeforeOpenParen" in n)
    throw new Ds("newlineBeforeOpenParen config is no more supported.");
  if ("newlineBeforeCloseParen" in n)
    throw new Ds("newlineBeforeCloseParen config is no more supported.");
  if ("aliasAs" in n)
    throw new Ds("aliasAs config is no more supported.");
  if (n.expressionWidth <= 0)
    throw new Ds(`expressionWidth config must be positive number. Received ${n.expressionWidth} instead.`);
  if (n.commaPosition === "before" && n.useTabs)
    throw new Ds("commaPosition: before does not work when tabs are used for indentation.");
  return n.params && !W4(n.params) && console.warn('WARNING: All "params" option values should be strings.'), n;
}
function W4(n) {
  return (n instanceof Array ? n : Object.values(n)).every((s) => typeof s == "string");
}
const Zv = {
  bigquery: "bigquery",
  db2: "db2",
  hive: "hive",
  mariadb: "mariadb",
  mysql: "mysql",
  n1ql: "n1ql",
  plsql: "plsql",
  postgresql: "postgresql",
  redshift: "redshift",
  spark: "spark",
  sqlite: "sqlite",
  sql: "sql",
  trino: "trino",
  transactsql: "transactsql",
  tsql: "transactsql",
  // alias for transactsq
  singlestoredb: "singlestoredb",
  snowflake: "snowflake"
}, k4 = Object.keys(Zv), X4 = {
  tabWidth: 2,
  useTabs: !1,
  keywordCase: "preserve",
  indentStyle: "standard",
  logicalOperatorNewline: "before",
  tabulateAlias: !1,
  commaPosition: "after",
  expressionWidth: 50,
  linesBetweenQueries: 1,
  denseOperators: !1,
  newlineBeforeSemicolon: !1
}, j4 = (n, a = {}) => {
  if (typeof a.language == "string" && !k4.includes(a.language))
    throw new Ds(`Unsupported SQL dialect: ${a.language}`);
  const s = Zv[a.language || "sql"];
  return K4(n, {
    ...a,
    dialect: k5[s]
  });
}, K4 = (n, {
  dialect: a,
  ...s
}) => {
  if (typeof n != "string")
    throw new Error("Invalid query argument. Expected string, instead got " + typeof n);
  const o = V4({
    ...X4,
    ...s
  });
  return new Y4(i4(a), o).format(n);
};
function J4({ handleResize: n, isResizing: a, setIsResizing: s, ...o }) {
  const [c, E] = x.useState(!1), u = (T) => {
    T.target instanceof HTMLDivElement && n(T);
  }, R = (T) => {
    T.preventDefault(), E(!0), s(!0), document.addEventListener("mousemove", u), document.addEventListener("mouseup", d);
  }, d = () => {
    s(!1), document.removeEventListener("mousemove", u), document.removeEventListener("mouseup", d);
  };
  return /* @__PURE__ */ p.jsx(
    "div",
    {
      className: $e(
        "resizer",
        "absolute left-0 top-0 h-full w-1 cursor-col-resize rounded-sm p-0.5 transition-colors",
        c || a ? "bg-primary-600 translate-x-[-2px] transform" : ""
      ),
      onClick: (T) => T.preventDefault(),
      onMouseEnter: () => E(!0),
      onMouseLeave: () => E(!1),
      onMouseOver: () => E(!0),
      onMouseDown: R,
      ...o
    }
  );
}
const z4 = ({
  span: n,
  startTimestamp: a,
  totalDuration: s,
  depth: o = 1,
  traceContext: c,
  totalTransactions: E = 0,
  spanNodeWidth: u,
  setSpanNodeWidth: R = () => {
  },
  query: d
}) => {
  var g, V;
  const { spanId: T } = Zo(), S = x.useRef(null), [N, m] = x.useState(
    n.transaction && E > 1 && o !== 1 || o >= 15
  ), [v, M] = x.useState(!1), w = Jo(n.start_timestamp, n.timestamp), y = (D) => {
    if (S.current) {
      const G = S.current.getBoundingClientRect(), U = (D.clientX - G.left) / G.width * 100;
      R(U);
    }
  }, O = d ? n.span_id.includes(d) || ((g = n.op) == null ? void 0 : g.includes(d)) || ((V = n.description) == null ? void 0 : V.includes(d)) : !1;
  return /* @__PURE__ */ p.jsxs("li", { className: "pl-4", ref: S, children: [
    /* @__PURE__ */ p.jsxs(
      fn,
      {
        className: $e(
          "hover:bg-primary-900 group flex text-sm",
          O ? "bg-primary-200 bg-opacity-20" : "",
          T === n.span_id ? "bg-primary-900" : ""
        ),
        style: {
          pointerEvents: v ? "none" : "auto"
        },
        to: `/traces/${n.trace_id}/${n.span_id}`,
        children: [
          /* @__PURE__ */ p.jsxs(
            "div",
            {
              className: $e(
                "node group-hover:bg-primary-900",
                O ? "bg-transparent" : "",
                n.status && n.status !== "ok" ? "text-red-400" : "",
                T === n.span_id ? "bg-primary-900" : "bg-primary-950"
              ),
              style: {
                width: `${u}%`
              },
              children: [
                (n.children || []).length > 0 && /* @__PURE__ */ p.jsxs(
                  "div",
                  {
                    className: "bg-primary-600 z-10 mr-1 flex items-center gap-1 rounded-lg px-1 text-xs font-bold text-white",
                    onClick: (D) => {
                      D.preventDefault(), m((G) => !G);
                    },
                    children: [
                      (n.children || []).length,
                      /* @__PURE__ */ p.jsx(
                        gv,
                        {
                          width: 12,
                          height: 12,
                          className: $e("transition", N ? "rotate-0" : "rotate-180")
                        }
                      )
                    ]
                  }
                ),
                n.transaction && /* @__PURE__ */ p.jsx(Vi, { size: 16, platform: n.transaction.platform }),
                n.op && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
                  /* @__PURE__ */ p.jsx("span", { className: "font-bold", children: n.op }),
                  /* @__PURE__ */ p.jsx("span", { className: "text-primary-400", children: "–" })
                ] }),
                /* @__PURE__ */ p.jsx("span", { className: "block truncate", title: n.description || n.span_id, children: n.description || n.span_id })
              ]
            }
          ),
          /* @__PURE__ */ p.jsxs(
            "div",
            {
              className: $e("waterfall", O ? "!bg-transparent" : ""),
              style: {
                left: `${u}%`
              },
              children: [
                /* @__PURE__ */ p.jsx(J4, { setIsResizing: M, isResizing: v, handleResize: y }),
                /* @__PURE__ */ p.jsx(
                  "div",
                  {
                    className: "bg-primary-900 absolute -m-0.5 w-full p-0.5",
                    style: {
                      left: `calc(min(${(n.start_timestamp - a) / s * 100}%, 95% - 1px) + 4px)`,
                      width: `max(1px, ${w / s * 95}%)`
                    },
                    children: /* @__PURE__ */ p.jsxs("span", { className: $e("whitespace-nowrap", Uw(w)), children: [
                      w.toLocaleString(),
                      " ms"
                    ] })
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    !N && /* @__PURE__ */ p.jsx(
      YS,
      {
        traceContext: c,
        tree: n.children || [],
        startTimestamp: a,
        totalDuration: s,
        depth: o + 1,
        totalTransactions: E,
        spanNodeWidth: u,
        setSpanNodeWidth: R,
        query: d
      }
    )
  ] }, n.span_id);
};
function YS({
  traceContext: n,
  tree: a,
  startTimestamp: s,
  totalDuration: o,
  depth: c = 1,
  totalTransactions: E,
  spanNodeWidth: u,
  setSpanNodeWidth: R,
  query: d
}) {
  return !a || !a.length ? null : /* @__PURE__ */ p.jsx("ul", { className: "tree", children: a.map((T) => /* @__PURE__ */ p.jsx(
    z4,
    {
      traceContext: n,
      depth: c,
      span: T,
      totalTransactions: E,
      startTimestamp: s,
      totalDuration: o,
      spanNodeWidth: u,
      setSpanNodeWidth: R,
      query: d
    },
    T.span_id
  )) });
}
function Z4(n) {
  if (n.match(/^(SELECT|INSERT|UPDATE|DELETE|TRUNCATE|ALTER) /i))
    try {
      return j4(n.replace(/([\s,(])(%[a-z])([\s,)])/gim, "$1?$3"));
    } catch (a) {
      console.error(a);
    }
  return n;
}
function q4(n, a) {
  return typeof a == "number" ? n.indexOf("size") !== -1 || n.indexOf("length") !== -1 ? bv(a) : a.toLocaleString() : a;
}
function Q4({
  traceContext: n,
  span: a,
  startTimestamp: s,
  totalDuration: o,
  totalTransactions: c
}) {
  var T, S;
  const [E, u] = x.useState(50), R = Jo(a.start_timestamp, a.timestamp), d = Ut.getEventsByTrace(a.trace_id).filter((N) => N.type !== "transaction" && "exception" in N);
  return /* @__PURE__ */ p.jsxs(xS, { backto: `/traces/${a.trace_id}`, children: [
    /* @__PURE__ */ p.jsx(
      US,
      {
        title: "Span Details",
        subtitle: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          a.op && /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
            a.op,
            " ",
            /* @__PURE__ */ p.jsx("span", { className: "text-primary-500", children: "—" }),
            " "
          ] }),
          a.span_id
        ] }),
        backto: `/traces/${a.trace_id}`
      }
    ),
    /* @__PURE__ */ p.jsxs("div", { className: "space-y-6", children: [
      /* @__PURE__ */ p.jsx("div", { children: /* @__PURE__ */ p.jsxs("div", { className: "flex flex-col space-y-4", children: [
        /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-1 items-center gap-x-1", children: [
          /* @__PURE__ */ p.jsx(FS, { date: a.start_timestamp }),
          /* @__PURE__ */ p.jsx("span", { children: "—" }),
          /* @__PURE__ */ p.jsxs("span", { children: [
            /* @__PURE__ */ p.jsxs("strong", { children: [
              Jo(s, a.start_timestamp),
              " ms"
            ] }),
            " into trace"
          ] })
        ] }),
        /* @__PURE__ */ p.jsx("div", { className: "flex-1", children: /* @__PURE__ */ p.jsx("div", { className: "border-primary-800 relative h-8 border py-1", children: /* @__PURE__ */ p.jsx(
          "div",
          {
            className: "bg-primary-800 absolute bottom-0 top-0 -m-0.5 flex w-full items-center p-0.5",
            style: {
              left: `min(${(a.start_timestamp - s) / o * 100}%, 100% - 1px)`,
              width: `max(1px, ${R / o * 100}%)`
            },
            children: /* @__PURE__ */ p.jsxs("span", { className: "whitespace-nowrap", children: [
              R,
              " ms"
            ] })
          }
        ) }) })
      ] }) }),
      !!d.length && /* @__PURE__ */ p.jsxs("div", { className: "flex flex-col items-start", children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Related Errors" }),
        d.map((N) => /* @__PURE__ */ p.jsx(fn, { className: "cursor-pointer underline", to: `/errors/${N.event_id}`, children: /* @__PURE__ */ p.jsx(mv, { event: N }) }, N.event_id))
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Description" }),
        a.description ? /* @__PURE__ */ p.jsx("pre", { className: "text-primary-300 whitespace-pre-wrap break-words font-mono text-sm", children: Z4(a.description) }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300", children: "No description recorded for this span." })
      ] }),
      a.op === "resource.img" && ((T = a.description) == null ? void 0 : T.indexOf("/")) === 0 && /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Preview" }),
        /* @__PURE__ */ p.jsx(
          "a",
          {
            href: a.description,
            className: "border-primary-950 hover:border-primary-700 -m-2 inline-block max-w-sm cursor-pointer rounded border p-1",
            children: /* @__PURE__ */ p.jsx("img", { src: a.description, alt: "preview", style: { maxHeight: 300 } })
          }
        )
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Tags" }),
        a.tags && Object.keys(a.tags).length ? /* @__PURE__ */ p.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ p.jsx("tbody", { children: Object.entries(a.tags).map(([N, m]) => /* @__PURE__ */ p.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ p.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: N }) }),
          /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: JSON.stringify(m, void 0, 2) }) })
        ] }, N)) }) }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300", children: "No tags recorded for this span." })
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Context" }),
        /* @__PURE__ */ p.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ p.jsx("tbody", { children: [
          ["status", a.status || ""],
          ["trace", a.trace_id],
          ["span", a.span_id],
          [
            "parent",
            a.parent_span_id ? /* @__PURE__ */ p.jsx(fn, { className: "underline", to: `/traces/${a.trace_id}/${a.parent_span_id}`, children: a.parent_span_id }) : ""
          ],
          ["op", a.op]
        ].map(([N, m]) => /* @__PURE__ */ p.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ p.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: N }) }),
          /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: m }) })
        ] }, N)) }) })
      ] }),
      a.data && /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Data" }),
        /* @__PURE__ */ p.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ p.jsx("tbody", { children: Object.entries(a.data).map(([N, m]) => /* @__PURE__ */ p.jsxs("tr", { className: "text-primary-300", children: [
          /* @__PURE__ */ p.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: N }) }),
          /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: q4(N, m) }) })
        ] }, N)) }) })
      ] }),
      !!((S = a.children) != null && S.length) && /* @__PURE__ */ p.jsxs("div", { children: [
        /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Sub-tree" }),
        /* @__PURE__ */ p.jsx(
          YS,
          {
            traceContext: n,
            tree: [a],
            startTimestamp: s,
            totalDuration: o,
            totalTransactions: c,
            spanNodeWidth: E,
            setSpanNodeWidth: u
          }
        )
      ] })
    ] })
  ] });
}
function $4({ trace: n }) {
  const a = n.trace_id;
  return /* @__PURE__ */ p.jsxs("div", { children: [
    /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "General" }),
    /* @__PURE__ */ p.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ p.jsx("tbody", { children: [
      ["Trace Id", a || "-"],
      ["Spans", n.spans.length || "-"],
      ["Transactions", n.transactions.length || "-"],
      ["Errors", n.errors || "-"],
      ["Start Timestamp", /* @__PURE__ */ p.jsx(FS, { date: n.start_timestamp }) || "-"],
      ["Total Duration", `${Jo(n.start_timestamp, n.timestamp).toLocaleString()} ms`]
    ].map(([s, o]) => /* @__PURE__ */ p.jsxs("tr", { className: "text-primary-300", children: [
      /* @__PURE__ */ p.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: s }) }),
      /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: o }) })
    ] }, s)) }) })
  ] });
}
function eH({ trace: n }) {
  const a = n.transactions.map((s) => s.tags).reduce((s, o) => ({ ...s, ...o }), {});
  return /* @__PURE__ */ p.jsxs("div", { children: [
    /* @__PURE__ */ p.jsx("h2", { className: "mb-2 font-bold uppercase", children: "Tags" }),
    a && Object.keys(a).length ? /* @__PURE__ */ p.jsx("table", { className: "w-full text-sm", children: /* @__PURE__ */ p.jsx("tbody", { children: Object.entries(a).map(([s, o]) => /* @__PURE__ */ p.jsxs("tr", { className: "text-primary-300", children: [
      /* @__PURE__ */ p.jsx("th", { className: " w-1/12 py-0.5 pr-4 text-left font-mono font-normal", children: /* @__PURE__ */ p.jsx("div", { className: "w-full truncate", children: s }) }),
      /* @__PURE__ */ p.jsx("td", { className: "py-0.5", children: /* @__PURE__ */ p.jsx("pre", { className: "whitespace-nowrap font-mono", children: JSON.stringify(o, void 0, 2) }) })
    ] }, s)) }) }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300", children: "No tags recorded for this Trace." })
  ] });
}
function tH({ traceContext: n }) {
  const a = n.trace_id, s = Ut.getTraceById(a);
  return /* @__PURE__ */ p.jsxs(xS, { backto: `/traces/${a}`, children: [
    /* @__PURE__ */ p.jsx(
      US,
      {
        title: "Trace Details",
        subtitle: /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
          "Trace Id ",
          /* @__PURE__ */ p.jsx("span", { className: "text-primary-500", children: "—" }),
          " ",
          a
        ] }),
        backto: `/traces/${a}`
      }
    ),
    /* @__PURE__ */ p.jsxs("div", { className: "space-y-6", children: [
      /* @__PURE__ */ p.jsx($4, { trace: s }),
      /* @__PURE__ */ p.jsx(eH, { trace: s })
    ] })
  ] });
}
function nH({ trace: n }) {
  return /* @__PURE__ */ p.jsxs("div", { className: "border-b-primary-700 bg-primary-950 flex items-center gap-x-2 border-b px-6 py-4", children: [
    /* @__PURE__ */ p.jsx(Uv, { trace: n }),
    /* @__PURE__ */ p.jsx("h1", { className: "max-w-full flex-1 truncate text-2xl", children: n.rootTransactionName }),
    /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 font-mono", children: [
      /* @__PURE__ */ p.jsxs("div", { children: [
        "T:",
        " ",
        /* @__PURE__ */ p.jsx(fn, { className: "underline", to: `/traces/${n.trace_id}/info`, children: n.trace_id })
      ] }),
      /* @__PURE__ */ p.jsxs("div", { children: [
        "S:",
        " ",
        /* @__PURE__ */ p.jsx(fn, { to: `/traces/${n.trace_id}/${n.span_id}`, className: "underline", children: n.span_id })
      ] })
    ] })
  ] });
}
function Vp() {
  const { traceId: n, spanId: a } = Zo(), { pathname: s } = ji(), [o, c] = x.useState(50);
  if (!n)
    return /* @__PURE__ */ p.jsx("p", { className: "text-primary-300 p-6", children: "Unknown trace id" });
  const E = Ut.getTraceById(n);
  if (!E)
    return /* @__PURE__ */ p.jsxs("p", { className: "text-primary-300 p-6", children: [
      "Trace not found. Check for more",
      " ",
      /* @__PURE__ */ p.jsx(fn, { to: "/traces", className: "underline", children: "traces" })
    ] });
  const u = a ? Ut.getSpanById(E.trace_id, a) : void 0, R = s === `/traces/${n}/info`, d = E.start_timestamp, T = E.timestamp - d;
  return /* @__PURE__ */ p.jsxs(p.Fragment, { children: [
    /* @__PURE__ */ p.jsx(nH, { trace: E }),
    /* @__PURE__ */ p.jsx("div", { className: "px-6 py-4", children: /* @__PURE__ */ p.jsxs("div", { className: "text-primary-300 flex flex-1 items-center gap-x-1", children: [
      /* @__PURE__ */ p.jsx("div", { className: "text-primary-200", children: /* @__PURE__ */ p.jsx(FS, { date: E.start_timestamp }) }),
      /* @__PURE__ */ p.jsx("span", { children: "—" }),
      /* @__PURE__ */ p.jsxs("span", { children: [
        /* @__PURE__ */ p.jsxs("strong", { className: "text-primary-200 font-bold", children: [
          Jo(E.start_timestamp, E.timestamp).toLocaleString(),
          " ms"
        ] }),
        " ",
        "recorded in",
        " ",
        /* @__PURE__ */ p.jsxs("strong", { className: "text-primary-200 font-bold", children: [
          E.spans.length.toLocaleString(),
          " spans"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ p.jsx("div", { className: "flex-1 px-2 pb-6", children: /* @__PURE__ */ p.jsx(
      YS,
      {
        traceContext: E,
        tree: E.spanTree,
        startTimestamp: d,
        totalDuration: T,
        totalTransactions: (E.transactions || []).length,
        spanNodeWidth: o,
        setSpanNodeWidth: c
      }
    ) }),
    u ? /* @__PURE__ */ p.jsx(
      Q4,
      {
        traceContext: E,
        startTimestamp: d,
        totalDuration: T,
        span: u,
        totalTransactions: (E.transactions || []).length
      }
    ) : null,
    R && /* @__PURE__ */ p.jsx(tH, { traceContext: E })
  ] });
}
function rH() {
  return /* @__PURE__ */ p.jsx(sE, { children: /* @__PURE__ */ p.jsxs(Ki, { children: [
    /* @__PURE__ */ p.jsx(jt, { path: "/:traceId/:spanId", element: /* @__PURE__ */ p.jsx(Vp, {}) }),
    /* @__PURE__ */ p.jsx(jt, { path: "/:traceId/info", element: /* @__PURE__ */ p.jsx(Vp, {}) }),
    /* @__PURE__ */ p.jsx(jt, { path: "/:traceId", element: /* @__PURE__ */ p.jsx(Vp, {}) }),
    /* @__PURE__ */ p.jsx(jt, { path: "/", element: /* @__PURE__ */ p.jsx(EG, {}) })
  ] }) });
}
const aH = "application/x-sentry-envelope";
function iH(n = {}) {
  return {
    name: "sentry",
    forwardedContentType: [aH],
    setup: ({ open: a }) => {
      n.retries == null && (n.retries = 3), n.sidecarUrl && Ut.setSidecarUrl(n.sidecarUrl), qv(n), n.openLastError && Ut.subscribe("event", (o) => {
        o.exception && setTimeout(() => a(`/errors/${o.event_id}`), 0);
      });
      const s = (o) => {
        vt("Sentry Event", o.detail.event_id), o.detail.event && Ut.pushEvent(o.detail.event).then(() => a(`/errors/${o.detail.event.event_id}`));
      };
      return sT("sentry:showError", s), () => {
        Qx("sentry:showError", s);
      };
    },
    processEvent: (a) => oH(a),
    tabs: () => {
      const a = Ut.getEvents().filter(
        (o) => {
          var c, E, u, R;
          return o.type != "transaction" && ((E = (c = o.contexts) == null ? void 0 : c.trace) != null && E.trace_id ? Ut.isTraceLocal((R = (u = o.contexts) == null ? void 0 : u.trace) == null ? void 0 : R.trace_id) : null) !== !1;
        }
      ).length, s = Ut.getTraces().filter((o) => Ut.isTraceLocal(o.trace_id) !== !1);
      return [
        {
          id: "errors",
          title: "Errors",
          notificationCount: {
            count: a,
            severe: a > 0
          },
          content: gw
        },
        {
          id: "traces",
          title: "Traces",
          notificationCount: {
            count: s.length
          },
          content: rH
        },
        {
          id: "performance",
          title: "Performance",
          content: aG
        },
        {
          id: "sdks",
          title: "SDKs",
          content: oG
        },
        {
          id: "devInfo",
          title: "Developer Info",
          content: aw
        }
      ];
    },
    reset: () => {
      Ut.resetData();
    }
  };
}
function sH(n) {
  let a = n.indexOf(10);
  return a === -1 && (a = n.length), a;
}
function Wp(n) {
  return JSON.parse(new TextDecoder().decode(n));
}
function oH(n) {
  const { data: a } = n;
  let s = typeof a == "string" ? new TextEncoder().encode(a) : a;
  function o(R) {
    const d = R ?? sH(s), T = s.subarray(0, d);
    return s = s.subarray(d + 1), T;
  }
  const c = Wp(o()), E = [];
  for (; s.length; ) {
    const R = Wp(o()), d = R.length;
    let T = o(d ?? void 0);
    try {
      T = Wp(T);
    } catch (S) {
      vt(S);
    }
    R.type && typeof T == "object" && (T.type = R.type), E.push([R, T]);
  }
  const u = [c, E];
  return Ut.pushEnvelope({ envelope: u, rawEnvelope: n }), {
    event: u,
    rawEvent: n
  };
}
function qv(n) {
  if (n.injectIntoSDK === !1)
    return;
  const a = window.__SENTRY__, s = a && lH(a);
  if (!s) {
    vt("Couldn't find a Sentry SDK client. Make sure you're using a Sentry SDK with version >=7.99.0 or 8.x"), n.retries && (vt(`Will retry ${n.retries} more time(s) at 100ms intervals...`), n.retries--, setTimeout(() => {
      qv(n);
    }, 100));
    return;
  }
  if (!s.getDsn()) {
    vt("Sentry SDK doesn't have a valid DSN. Enabling SDK integrations for just Spotlight.");
    try {
      const o = s.getOptions().integrations;
      for (const c of o)
        s.addIntegration(c);
    } catch (o) {
      TC("Failed to enable all SDK integrations for Spotlight", o), vt("Please open an issue with the error at: https://github.com/getsentry/spotlight/issues/new/choose");
    }
  }
  try {
    const o = P2({
      sidecarUrl: n == null ? void 0 : n.sidecarUrl
    });
    s.addIntegration(o);
  } catch (o) {
    TC("Failed to add Spotlight integration to Sentry", o), vt("Please open an issue with the error at: https://github.com/getsentry/spotlight/issues/new/choose");
  }
  vt("Added Spotlight integration to Sentry SDK");
}
function lH(n) {
  var a, s, o;
  if (n.version) {
    const c = n[n.version], E = typeof ((a = c == null ? void 0 : c.stack) == null ? void 0 : a.getScope) == "function" ? (o = (s = c == null ? void 0 : c.stack) == null ? void 0 : s.getScope) == null ? void 0 : o.call(s) : void 0;
    if (typeof (E == null ? void 0 : E.getClient) == "function")
      return E.getClient();
  }
  if (n.hub) {
    const c = n.hub;
    if (typeof c.getClient == "function")
      return c.getClient();
  }
}
var pS = {}, Qv = { exports: {} }, mr = {}, $v = { exports: {} }, eL = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(n) {
  (function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var a = !1, s = !1, o = 5;
    function c(pe, Le) {
      var ke = pe.length;
      pe.push(Le), R(pe, Le, ke);
    }
    function E(pe) {
      return pe.length === 0 ? null : pe[0];
    }
    function u(pe) {
      if (pe.length === 0)
        return null;
      var Le = pe[0], ke = pe.pop();
      return ke !== Le && (pe[0] = ke, d(pe, ke, 0)), Le;
    }
    function R(pe, Le, ke) {
      for (var dt = ke; dt > 0; ) {
        var At = dt - 1 >>> 1, nn = pe[At];
        if (T(nn, Le) > 0)
          pe[At] = Le, pe[dt] = nn, dt = At;
        else
          return;
      }
    }
    function d(pe, Le, ke) {
      for (var dt = ke, At = pe.length, nn = At >>> 1; dt < nn; ) {
        var kt = (dt + 1) * 2 - 1, ar = pe[kt], Nt = kt + 1, Rr = pe[Nt];
        if (T(ar, Le) < 0)
          Nt < At && T(Rr, ar) < 0 ? (pe[dt] = Rr, pe[Nt] = Le, dt = Nt) : (pe[dt] = ar, pe[kt] = Le, dt = kt);
        else if (Nt < At && T(Rr, Le) < 0)
          pe[dt] = Rr, pe[Nt] = Le, dt = Nt;
        else
          return;
      }
    }
    function T(pe, Le) {
      var ke = pe.sortIndex - Le.sortIndex;
      return ke !== 0 ? ke : pe.id - Le.id;
    }
    var S = 1, N = 2, m = 3, v = 4, M = 5;
    function w(pe, Le) {
    }
    var y = typeof performance == "object" && typeof performance.now == "function";
    if (y) {
      var O = performance;
      n.unstable_now = function() {
        return O.now();
      };
    } else {
      var g = Date, V = g.now();
      n.unstable_now = function() {
        return g.now() - V;
      };
    }
    var D = 1073741823, G = -1, P = 250, U = 5e3, Y = 1e4, X = D, _ = [], F = [], j = 1, z = null, Z = m, ee = !1, oe = !1, ne = !1, de = typeof setTimeout == "function" ? setTimeout : null, ve = typeof clearTimeout == "function" ? clearTimeout : null, Fe = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function et(pe) {
      for (var Le = E(F); Le !== null; ) {
        if (Le.callback === null)
          u(F);
        else if (Le.startTime <= pe)
          u(F), Le.sortIndex = Le.expirationTime, c(_, Le);
        else
          return;
        Le = E(F);
      }
    }
    function Ke(pe) {
      if (ne = !1, et(pe), !oe)
        if (E(_) !== null)
          oe = !0, Ar(Et);
        else {
          var Le = E(F);
          Le !== null && Wt(Ke, Le.startTime - pe);
        }
    }
    function Et(pe, Le) {
      oe = !1, ne && (ne = !1, Dr()), ee = !0;
      var ke = Z;
      try {
        var dt;
        if (!s)
          return Ct(pe, Le);
      } finally {
        z = null, Z = ke, ee = !1;
      }
    }
    function Ct(pe, Le) {
      var ke = Le;
      for (et(ke), z = E(_); z !== null && !a && !(z.expirationTime > ke && (!pe || Lr())); ) {
        var dt = z.callback;
        if (typeof dt == "function") {
          z.callback = null, Z = z.priorityLevel;
          var At = z.expirationTime <= ke, nn = dt(At);
          ke = n.unstable_now(), typeof nn == "function" ? z.callback = nn : z === E(_) && u(_), et(ke);
        } else
          u(_);
        z = E(_);
      }
      if (z !== null)
        return !0;
      var kt = E(F);
      return kt !== null && Wt(Ke, kt.startTime - ke), !1;
    }
    function xn(pe, Le) {
      switch (pe) {
        case S:
        case N:
        case m:
        case v:
        case M:
          break;
        default:
          pe = m;
      }
      var ke = Z;
      Z = pe;
      try {
        return Le();
      } finally {
        Z = ke;
      }
    }
    function Tn(pe) {
      var Le;
      switch (Z) {
        case S:
        case N:
        case m:
          Le = m;
          break;
        default:
          Le = Z;
          break;
      }
      var ke = Z;
      Z = Le;
      try {
        return pe();
      } finally {
        Z = ke;
      }
    }
    function _n(pe) {
      var Le = Z;
      return function() {
        var ke = Z;
        Z = Le;
        try {
          return pe.apply(this, arguments);
        } finally {
          Z = ke;
        }
      };
    }
    function Kt(pe, Le, ke) {
      var dt = n.unstable_now(), At;
      if (typeof ke == "object" && ke !== null) {
        var nn = ke.delay;
        typeof nn == "number" && nn > 0 ? At = dt + nn : At = dt;
      } else
        At = dt;
      var kt;
      switch (pe) {
        case S:
          kt = G;
          break;
        case N:
          kt = P;
          break;
        case M:
          kt = X;
          break;
        case v:
          kt = Y;
          break;
        case m:
        default:
          kt = U;
          break;
      }
      var ar = At + kt, Nt = {
        id: j++,
        callback: Le,
        priorityLevel: pe,
        startTime: At,
        expirationTime: ar,
        sortIndex: -1
      };
      return At > dt ? (Nt.sortIndex = At, c(F, Nt), E(_) === null && Nt === E(F) && (ne ? Dr() : ne = !0, Wt(Ke, At - dt))) : (Nt.sortIndex = ar, c(_, Nt), !oe && !ee && (oe = !0, Ar(Et))), Nt;
    }
    function ot() {
    }
    function xt() {
      !oe && !ee && (oe = !0, Ar(Et));
    }
    function en() {
      return E(_);
    }
    function dn(pe) {
      pe.callback = null;
    }
    function Jt() {
      return Z;
    }
    var wn = !1, An = null, Rn = -1, tn = o, dr = -1;
    function Lr() {
      var pe = n.unstable_now() - dr;
      return !(pe < tn);
    }
    function rr() {
    }
    function Vr(pe) {
      if (pe < 0 || pe > 125) {
        console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
        return;
      }
      pe > 0 ? tn = Math.floor(1e3 / pe) : tn = o;
    }
    var yr = function() {
      if (An !== null) {
        var pe = n.unstable_now();
        dr = pe;
        var Le = !0, ke = !0;
        try {
          ke = An(Le, pe);
        } finally {
          ke ? jn() : (wn = !1, An = null);
        }
      } else
        wn = !1;
    }, jn;
    if (typeof Fe == "function")
      jn = function() {
        Fe(yr);
      };
    else if (typeof MessageChannel < "u") {
      var gr = new MessageChannel(), Gn = gr.port2;
      gr.port1.onmessage = yr, jn = function() {
        Gn.postMessage(null);
      };
    } else
      jn = function() {
        de(yr, 0);
      };
    function Ar(pe) {
      An = pe, wn || (wn = !0, jn());
    }
    function Wt(pe, Le) {
      Rn = de(function() {
        pe(n.unstable_now());
      }, Le);
    }
    function Dr() {
      ve(Rn), Rn = -1;
    }
    var La = rr, ya = null;
    n.unstable_IdlePriority = M, n.unstable_ImmediatePriority = S, n.unstable_LowPriority = v, n.unstable_NormalPriority = m, n.unstable_Profiling = ya, n.unstable_UserBlockingPriority = N, n.unstable_cancelCallback = dn, n.unstable_continueExecution = xt, n.unstable_forceFrameRate = Vr, n.unstable_getCurrentPriorityLevel = Jt, n.unstable_getFirstCallbackNode = en, n.unstable_next = Tn, n.unstable_pauseExecution = ot, n.unstable_requestPaint = La, n.unstable_runWithPriority = xn, n.unstable_scheduleCallback = Kt, n.unstable_shouldYield = Lr, n.unstable_wrapCallback = _n, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  })();
})(eL);
$v.exports = eL;
var uH = $v.exports;
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function() {
  typeof { isDisabled: !0 } < "u" && typeof { isDisabled: !0 }.registerInternalModuleStart == "function" && { isDisabled: !0 }.registerInternalModuleStart(new Error());
  var n = x, a = uH, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, o = !1;
  function c(e) {
    o = e;
  }
  function E(e) {
    if (!o) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
        r[i - 1] = arguments[i];
      R("warn", e, r);
    }
  }
  function u(e) {
    if (!o) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
        r[i - 1] = arguments[i];
      R("error", e, r);
    }
  }
  function R(e, t, r) {
    {
      var i = s.ReactDebugCurrentFrame, l = i.getStackAddendum();
      l !== "" && (t += "%s", r = r.concat([l]));
      var f = r.map(function(A) {
        return String(A);
      });
      f.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, f);
    }
  }
  var d = 0, T = 1, S = 2, N = 3, m = 4, v = 5, M = 6, w = 7, y = 8, O = 9, g = 10, V = 11, D = 12, G = 13, P = 14, U = 15, Y = 16, X = 17, _ = 18, F = 19, j = 21, z = 22, Z = 23, ee = 24, oe = 25, ne = !0, de = !1, ve = !1, Fe = !1, et = !1, Ke = !0, Et = !1, Ct = !1, xn = !0, Tn = !0, _n = !0, Kt = /* @__PURE__ */ new Set(), ot = {}, xt = {};
  function en(e, t) {
    dn(e, t), dn(e + "Capture", t);
  }
  function dn(e, t) {
    ot[e] && u("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), ot[e] = t;
    {
      var r = e.toLowerCase();
      xt[r] = e, e === "onDoubleClick" && (xt.ondblclick = e);
    }
    for (var i = 0; i < t.length; i++)
      Kt.add(t[i]);
  }
  var Jt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", wn = Object.prototype.hasOwnProperty;
  function An(e) {
    {
      var t = typeof Symbol == "function" && Symbol.toStringTag, r = t && e[Symbol.toStringTag] || e.constructor.name || "Object";
      return r;
    }
  }
  function Rn(e) {
    try {
      return tn(e), !1;
    } catch {
      return !0;
    }
  }
  function tn(e) {
    return "" + e;
  }
  function dr(e, t) {
    if (Rn(e))
      return u("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", t, An(e)), tn(e);
  }
  function Lr(e) {
    if (Rn(e))
      return u("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", An(e)), tn(e);
  }
  function rr(e, t) {
    if (Rn(e))
      return u("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", t, An(e)), tn(e);
  }
  function Vr(e, t) {
    if (Rn(e))
      return u("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", t, An(e)), tn(e);
  }
  function yr(e) {
    if (Rn(e))
      return u("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", An(e)), tn(e);
  }
  function jn(e) {
    if (Rn(e))
      return u("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", An(e)), tn(e);
  }
  var gr = 0, Gn = 1, Ar = 2, Wt = 3, Dr = 4, La = 5, ya = 6, pe = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Le = pe + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ke = new RegExp("^[" + pe + "][" + Le + "]*$"), dt = {}, At = {};
  function nn(e) {
    return wn.call(At, e) ? !0 : wn.call(dt, e) ? !1 : ke.test(e) ? (At[e] = !0, !0) : (dt[e] = !0, u("Invalid attribute name: `%s`", e), !1);
  }
  function kt(e, t, r) {
    return t !== null ? t.type === gr : r ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
  }
  function ar(e, t, r, i) {
    if (r !== null && r.type === gr)
      return !1;
    switch (typeof t) {
      case "function":
      case "symbol":
        return !0;
      case "boolean": {
        if (i)
          return !1;
        if (r !== null)
          return !r.acceptsBooleans;
        var l = e.toLowerCase().slice(0, 5);
        return l !== "data-" && l !== "aria-";
      }
      default:
        return !1;
    }
  }
  function Nt(e, t, r, i) {
    if (t === null || typeof t > "u" || ar(e, t, r, i))
      return !0;
    if (i)
      return !1;
    if (r !== null)
      switch (r.type) {
        case Wt:
          return !t;
        case Dr:
          return t === !1;
        case La:
          return isNaN(t);
        case ya:
          return isNaN(t) || t < 1;
      }
    return !1;
  }
  function Rr(e) {
    return yt.hasOwnProperty(e) ? yt[e] : null;
  }
  function Lt(e, t, r, i, l, f, A) {
    this.acceptsBooleans = t === Ar || t === Wt || t === Dr, this.attributeName = i, this.attributeNamespace = l, this.mustUseProperty = r, this.propertyName = e, this.type = t, this.sanitizeURL = f, this.removeEmptyString = A;
  }
  var yt = {}, oa = [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
  ];
  oa.forEach(function(e) {
    yt[e] = new Lt(
      e,
      gr,
      !1,
      // mustUseProperty
      e,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
    var t = e[0], r = e[1];
    yt[t] = new Lt(
      t,
      Gn,
      !1,
      // mustUseProperty
      r,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Ar,
      !1,
      // mustUseProperty
      e.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Ar,
      !1,
      // mustUseProperty
      e,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
  ].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Wt,
      !1,
      // mustUseProperty
      e.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Wt,
      !0,
      // mustUseProperty
      e,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "capture",
    "download"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Dr,
      !1,
      // mustUseProperty
      e,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "cols",
    "rows",
    "size",
    "span"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    yt[e] = new Lt(
      e,
      ya,
      !1,
      // mustUseProperty
      e,
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), ["rowSpan", "start"].forEach(function(e) {
    yt[e] = new Lt(
      e,
      La,
      !1,
      // mustUseProperty
      e.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  });
  var Wr = /[\-\:]([a-z])/g, zi = function(e) {
    return e[1].toUpperCase();
  };
  [
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    var t = e.replace(Wr, zi);
    yt[t] = new Lt(
      t,
      Gn,
      !1,
      // mustUseProperty
      e,
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    var t = e.replace(Wr, zi);
    yt[t] = new Lt(
      t,
      Gn,
      !1,
      // mustUseProperty
      e,
      "http://www.w3.org/1999/xlink",
      !1,
      // sanitizeURL
      !1
    );
  }), [
    "xml:base",
    "xml:lang",
    "xml:space"
    // NOTE: if you add a camelCased prop to this list,
    // you'll need to set attributeName to name.toLowerCase()
    // instead in the assignment below.
  ].forEach(function(e) {
    var t = e.replace(Wr, zi);
    yt[t] = new Lt(
      t,
      Gn,
      !1,
      // mustUseProperty
      e,
      "http://www.w3.org/XML/1998/namespace",
      !1,
      // sanitizeURL
      !1
    );
  }), ["tabIndex", "crossOrigin"].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Gn,
      !1,
      // mustUseProperty
      e.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !1,
      // sanitizeURL
      !1
    );
  });
  var Vs = "xlinkHref";
  yt[Vs] = new Lt(
    "xlinkHref",
    Gn,
    !1,
    // mustUseProperty
    "xlink:href",
    "http://www.w3.org/1999/xlink",
    !0,
    // sanitizeURL
    !1
  ), ["src", "href", "action", "formAction"].forEach(function(e) {
    yt[e] = new Lt(
      e,
      Gn,
      !1,
      // mustUseProperty
      e.toLowerCase(),
      // attributeName
      null,
      // attributeNamespace
      !0,
      // sanitizeURL
      !0
    );
  });
  var el = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Zi = !1;
  function qi(e) {
    !Zi && el.test(e) && (Zi = !0, u("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
  }
  function ga(e, t, r, i) {
    if (i.mustUseProperty) {
      var l = i.propertyName;
      return e[l];
    } else {
      dr(r, t), i.sanitizeURL && qi("" + r);
      var f = i.attributeName, A = null;
      if (i.type === Dr) {
        if (e.hasAttribute(f)) {
          var h = e.getAttribute(f);
          return h === "" ? !0 : Nt(t, r, i, !1) ? h : h === "" + r ? r : h;
        }
      } else if (e.hasAttribute(f)) {
        if (Nt(t, r, i, !1))
          return e.getAttribute(f);
        if (i.type === Wt)
          return r;
        A = e.getAttribute(f);
      }
      return Nt(t, r, i, !1) ? A === null ? r : A : A === "" + r ? r : A;
    }
  }
  function ai(e, t, r, i) {
    {
      if (!nn(t))
        return;
      if (!e.hasAttribute(t))
        return r === void 0 ? void 0 : null;
      var l = e.getAttribute(t);
      return dr(r, t), l === "" + r ? r : l;
    }
  }
  function Da(e, t, r, i) {
    var l = Rr(t);
    if (!kt(t, l, i)) {
      if (Nt(t, r, l, i) && (r = null), i || l === null) {
        if (nn(t)) {
          var f = t;
          r === null ? e.removeAttribute(f) : (dr(r, t), e.setAttribute(f, "" + r));
        }
        return;
      }
      var A = l.mustUseProperty;
      if (A) {
        var h = l.propertyName;
        if (r === null) {
          var I = l.type;
          e[h] = I === Wt ? !1 : "";
        } else
          e[h] = r;
        return;
      }
      var L = l.attributeName, b = l.attributeNamespace;
      if (r === null)
        e.removeAttribute(L);
      else {
        var k = l.type, W;
        k === Wt || k === Dr && r === !0 ? W = "" : (dr(r, L), W = "" + r, l.sanitizeURL && qi(W.toString())), b ? e.setAttributeNS(b, L, W) : e.setAttribute(L, W);
      }
    }
  }
  var la = Symbol.for("react.element"), kr = Symbol.for("react.portal"), ua = Symbol.for("react.fragment"), Qi = Symbol.for("react.strict_mode"), B = Symbol.for("react.profiler"), ue = Symbol.for("react.provider"), Re = Symbol.for("react.context"), Ie = Symbol.for("react.forward_ref"), je = Symbol.for("react.suspense"), nt = Symbol.for("react.suspense_list"), Ve = Symbol.for("react.memo"), ge = Symbol.for("react.lazy"), rn = Symbol.for("react.scope"), gt = Symbol.for("react.debug_trace_mode"), Dt = Symbol.for("react.offscreen"), Hn = Symbol.for("react.legacy_hidden"), Ea = Symbol.for("react.cache"), Ws = Symbol.for("react.tracing_marker"), ir = Symbol.iterator, vT = "@@iterator";
  function ba(e) {
    if (e === null || typeof e != "object")
      return null;
    var t = ir && e[ir] || e[vT];
    return typeof t == "function" ? t : null;
  }
  var Je = Object.assign, $i = 0, ii, tl, nl, rl, al, il, sl;
  function ol() {
  }
  ol.__reactDisabledLog = !0;
  function AE() {
    {
      if ($i === 0) {
        ii = console.log, tl = console.info, nl = console.warn, rl = console.error, al = console.group, il = console.groupCollapsed, sl = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: ol,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      $i++;
    }
  }
  function LT() {
    {
      if ($i--, $i === 0) {
        var e = {
          configurable: !0,
          enumerable: !0,
          writable: !0
        };
        Object.defineProperties(console, {
          log: Je({}, e, {
            value: ii
          }),
          info: Je({}, e, {
            value: tl
          }),
          warn: Je({}, e, {
            value: nl
          }),
          error: Je({}, e, {
            value: rl
          }),
          group: Je({}, e, {
            value: al
          }),
          groupCollapsed: Je({}, e, {
            value: il
          }),
          groupEnd: Je({}, e, {
            value: sl
          })
        });
      }
      $i < 0 && u("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
  }
  var ll = s.ReactCurrentDispatcher, es;
  function br(e, t, r) {
    {
      if (es === void 0)
        try {
          throw Error();
        } catch (l) {
          var i = l.stack.trim().match(/\n( *(at )?)/);
          es = i && i[1] || "";
        }
      return `
` + es + e;
    }
  }
  var si = !1, oi;
  {
    var ks = typeof WeakMap == "function" ? WeakMap : Map;
    oi = new ks();
  }
  function ul(e, t) {
    if (!e || si)
      return "";
    {
      var r = oi.get(e);
      if (r !== void 0)
        return r;
    }
    var i;
    si = !0;
    var l = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    var f;
    f = ll.current, ll.current = null, AE();
    try {
      if (t) {
        var A = function() {
          throw Error();
        };
        if (Object.defineProperty(A.prototype, "props", {
          set: function() {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(A, []);
          } catch (Q) {
            i = Q;
          }
          Reflect.construct(e, [], A);
        } else {
          try {
            A.call();
          } catch (Q) {
            i = Q;
          }
          e.call(A.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (Q) {
          i = Q;
        }
        e();
      }
    } catch (Q) {
      if (Q && i && typeof Q.stack == "string") {
        for (var h = Q.stack.split(`
`), I = i.stack.split(`
`), L = h.length - 1, b = I.length - 1; L >= 1 && b >= 0 && h[L] !== I[b]; )
          b--;
        for (; L >= 1 && b >= 0; L--, b--)
          if (h[L] !== I[b]) {
            if (L !== 1 || b !== 1)
              do
                if (L--, b--, b < 0 || h[L] !== I[b]) {
                  var k = `
` + h[L].replace(" at new ", " at ");
                  return e.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", e.displayName)), typeof e == "function" && oi.set(e, k), k;
                }
              while (L >= 1 && b >= 0);
            break;
          }
      }
    } finally {
      si = !1, ll.current = f, LT(), Error.prepareStackTrace = l;
    }
    var W = e ? e.displayName || e.name : "", q = W ? br(W) : "";
    return typeof e == "function" && oi.set(e, q), q;
  }
  function RE(e, t, r) {
    return ul(e, !0);
  }
  function El(e, t, r) {
    return ul(e, !1);
  }
  function yT(e) {
    var t = e.prototype;
    return !!(t && t.isReactComponent);
  }
  function li(e, t, r) {
    if (e == null)
      return "";
    if (typeof e == "function")
      return ul(e, yT(e));
    if (typeof e == "string")
      return br(e);
    switch (e) {
      case je:
        return br("Suspense");
      case nt:
        return br("SuspenseList");
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Ie:
          return El(e.render);
        case Ve:
          return li(e.type, t, r);
        case ge: {
          var i = e, l = i._payload, f = i._init;
          try {
            return li(f(l), t, r);
          } catch {
          }
        }
      }
    return "";
  }
  function pE(e) {
    switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
      case v:
        return br(e.type);
      case Y:
        return br("Lazy");
      case G:
        return br("Suspense");
      case F:
        return br("SuspenseList");
      case d:
      case S:
      case U:
        return El(e.type);
      case V:
        return El(e.type.render);
      case T:
        return RE(e.type);
      default:
        return "";
    }
  }
  function cl(e) {
    try {
      var t = "", r = e;
      do
        t += pE(r), r = r.return;
      while (r);
      return t;
    } catch (i) {
      return `
Error generating stack: ` + i.message + `
` + i.stack;
    }
  }
  function Xs(e, t, r) {
    var i = e.displayName;
    if (i)
      return i;
    var l = t.displayName || t.name || "";
    return l !== "" ? r + "(" + l + ")" : r;
  }
  function SE(e) {
    return e.displayName || "Context";
  }
  function it(e) {
    if (e == null)
      return null;
    if (typeof e.tag == "number" && u("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
      return e.displayName || e.name || null;
    if (typeof e == "string")
      return e;
    switch (e) {
      case ua:
        return "Fragment";
      case kr:
        return "Portal";
      case B:
        return "Profiler";
      case Qi:
        return "StrictMode";
      case je:
        return "Suspense";
      case nt:
        return "SuspenseList";
    }
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Re:
          var t = e;
          return SE(t) + ".Consumer";
        case ue:
          var r = e;
          return SE(r._context) + ".Provider";
        case Ie:
          return Xs(e, e.render, "ForwardRef");
        case Ve:
          var i = e.displayName || null;
          return i !== null ? i : it(e.type) || "Memo";
        case ge: {
          var l = e, f = l._payload, A = l._init;
          try {
            return it(A(f));
          } catch {
            return null;
          }
        }
      }
    return null;
  }
  function fl(e, t, r) {
    var i = t.displayName || t.name || "";
    return e.displayName || (i !== "" ? r + "(" + i + ")" : r);
  }
  function Tl(e) {
    return e.displayName || "Context";
  }
  function Ye(e) {
    var t = e.tag, r = e.type;
    switch (t) {
      case ee:
        return "Cache";
      case O:
        var i = r;
        return Tl(i) + ".Consumer";
      case g:
        var l = r;
        return Tl(l._context) + ".Provider";
      case _:
        return "DehydratedFragment";
      case V:
        return fl(r, r.render, "ForwardRef");
      case w:
        return "Fragment";
      case v:
        return r;
      case m:
        return "Portal";
      case N:
        return "Root";
      case M:
        return "Text";
      case Y:
        return it(r);
      case y:
        return r === Qi ? "StrictMode" : "Mode";
      case z:
        return "Offscreen";
      case D:
        return "Profiler";
      case j:
        return "Scope";
      case G:
        return "Suspense";
      case F:
        return "SuspenseList";
      case oe:
        return "TracingMarker";
      case T:
      case d:
      case X:
      case S:
      case P:
      case U:
        if (typeof r == "function")
          return r.displayName || r.name || null;
        if (typeof r == "string")
          return r;
        break;
    }
    return null;
  }
  var hE = s.ReactDebugCurrentFrame, Bn = null, ts = !1;
  function ui() {
    {
      if (Bn === null)
        return null;
      var e = Bn._debugOwner;
      if (e !== null && typeof e < "u")
        return Ye(e);
    }
    return null;
  }
  function NE() {
    return Bn === null ? "" : cl(Bn);
  }
  function pn() {
    hE.getCurrentStack = null, Bn = null, ts = !1;
  }
  function wt(e) {
    hE.getCurrentStack = e === null ? null : NE, Bn = e, ts = !1;
  }
  function OE() {
    return Bn;
  }
  function pr(e) {
    ts = e;
  }
  function sr(e) {
    return "" + e;
  }
  function ca(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return e;
      case "object":
        return jn(e), e;
      default:
        return "";
    }
  }
  var gT = {
    button: !0,
    checkbox: !0,
    image: !0,
    hidden: !0,
    radio: !0,
    reset: !0,
    submit: !0
  };
  function js(e, t) {
    gT[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || u("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), t.onChange || t.readOnly || t.disabled || t.checked == null || u("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
  }
  function ns(e) {
    var t = e.type, r = e.nodeName;
    return r && r.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function IE(e) {
    return e._valueTracker;
  }
  function Ei(e) {
    e._valueTracker = null;
  }
  function _E(e) {
    var t = "";
    return e && (ns(e) ? t = e.checked ? "true" : "false" : t = e.value), t;
  }
  function DT(e) {
    var t = ns(e) ? "checked" : "value", r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
    jn(e[t]);
    var i = "" + e[t];
    if (!(e.hasOwnProperty(t) || typeof r > "u" || typeof r.get != "function" || typeof r.set != "function")) {
      var l = r.get, f = r.set;
      Object.defineProperty(e, t, {
        configurable: !0,
        get: function() {
          return l.call(this);
        },
        set: function(h) {
          jn(h), i = "" + h, f.call(this, h);
        }
      }), Object.defineProperty(e, t, {
        enumerable: r.enumerable
      });
      var A = {
        getValue: function() {
          return i;
        },
        setValue: function(h) {
          jn(h), i = "" + h;
        },
        stopTracking: function() {
          Ei(e), delete e[t];
        }
      };
      return A;
    }
  }
  function Ma(e) {
    IE(e) || (e._valueTracker = DT(e));
  }
  function Ks(e) {
    if (!e)
      return !1;
    var t = IE(e);
    if (!t)
      return !0;
    var r = t.getValue(), i = _E(e);
    return i !== r ? (t.setValue(i), !0) : !1;
  }
  function ci(e) {
    if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
      return null;
    try {
      return e.activeElement || e.body;
    } catch {
      return e.body;
    }
  }
  var Js = !1, CE = !1, mE = !1, vE = !1;
  function LE(e) {
    var t = e.type === "checkbox" || e.type === "radio";
    return t ? e.checked != null : e.value != null;
  }
  function C(e, t) {
    var r = e, i = t.checked, l = Je({}, t, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: i ?? r._wrapperState.initialChecked
    });
    return l;
  }
  function H(e, t) {
    js("input", t), t.checked !== void 0 && t.defaultChecked !== void 0 && !CE && (u("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ui() || "A component", t.type), CE = !0), t.value !== void 0 && t.defaultValue !== void 0 && !Js && (u("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", ui() || "A component", t.type), Js = !0);
    var r = e, i = t.defaultValue == null ? "" : t.defaultValue;
    r._wrapperState = {
      initialChecked: t.checked != null ? t.checked : t.defaultChecked,
      initialValue: ca(t.value != null ? t.value : i),
      controlled: LE(t)
    };
  }
  function $(e, t) {
    var r = e, i = t.checked;
    i != null && Da(r, "checked", i, !1);
  }
  function te(e, t) {
    var r = e;
    {
      var i = LE(t);
      !r._wrapperState.controlled && i && !vE && (u("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), vE = !0), r._wrapperState.controlled && !i && !mE && (u("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), mE = !0);
    }
    $(e, t);
    var l = ca(t.value), f = t.type;
    if (l != null)
      f === "number" ? (l === 0 && r.value === "" || // We explicitly want to coerce to number here if possible.
      // eslint-disable-next-line
      r.value != l) && (r.value = sr(l)) : r.value !== sr(l) && (r.value = sr(l));
    else if (f === "submit" || f === "reset") {
      r.removeAttribute("value");
      return;
    }
    t.hasOwnProperty("value") ? xe(r, t.type, l) : t.hasOwnProperty("defaultValue") && xe(r, t.type, ca(t.defaultValue)), t.checked == null && t.defaultChecked != null && (r.defaultChecked = !!t.defaultChecked);
  }
  function Te(e, t, r) {
    var i = e;
    if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
      var l = t.type, f = l === "submit" || l === "reset";
      if (f && (t.value === void 0 || t.value === null))
        return;
      var A = sr(i._wrapperState.initialValue);
      r || A !== i.value && (i.value = A), i.defaultValue = A;
    }
    var h = i.name;
    h !== "" && (i.name = ""), i.defaultChecked = !i.defaultChecked, i.defaultChecked = !!i._wrapperState.initialChecked, h !== "" && (i.name = h);
  }
  function Pe(e, t) {
    var r = e;
    te(r, t), Ce(r, t);
  }
  function Ce(e, t) {
    var r = t.name;
    if (t.type === "radio" && r != null) {
      for (var i = e; i.parentNode; )
        i = i.parentNode;
      dr(r, "name");
      for (var l = i.querySelectorAll("input[name=" + JSON.stringify("" + r) + '][type="radio"]'), f = 0; f < l.length; f++) {
        var A = l[f];
        if (!(A === e || A.form !== e.form)) {
          var h = Tc(A);
          if (!h)
            throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
          Ks(A), te(A, h);
        }
      }
    }
  }
  function xe(e, t, r) {
    // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
    (t !== "number" || ci(e.ownerDocument) !== e) && (r == null ? e.defaultValue = sr(e._wrapperState.initialValue) : e.defaultValue !== sr(r) && (e.defaultValue = sr(r)));
  }
  var ze = !1, Rt = !1, Ot = !1;
  function It(e, t) {
    t.value == null && (typeof t.children == "object" && t.children !== null ? n.Children.forEach(t.children, function(r) {
      r != null && (typeof r == "string" || typeof r == "number" || Rt || (Rt = !0, u("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
    }) : t.dangerouslySetInnerHTML != null && (Ot || (Ot = !0, u("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), t.selected != null && !ze && (u("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), ze = !0);
  }
  function bt(e, t) {
    t.value != null && e.setAttribute("value", sr(ca(t.value)));
  }
  var Bt = Array.isArray;
  function st(e) {
    return Bt(e);
  }
  var fi;
  fi = !1;
  function zs() {
    var e = ui();
    return e ? `

Check the render method of \`` + e + "`." : "";
  }
  var dl = ["value", "defaultValue"];
  function bT(e) {
    {
      js("select", e);
      for (var t = 0; t < dl.length; t++) {
        var r = dl[t];
        if (e[r] != null) {
          var i = st(e[r]);
          e.multiple && !i ? u("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", r, zs()) : !e.multiple && i && u("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", r, zs());
        }
      }
    }
  }
  function Pa(e, t, r, i) {
    var l = e.options;
    if (t) {
      for (var f = r, A = {}, h = 0; h < f.length; h++)
        A["$" + f[h]] = !0;
      for (var I = 0; I < l.length; I++) {
        var L = A.hasOwnProperty("$" + l[I].value);
        l[I].selected !== L && (l[I].selected = L), L && i && (l[I].defaultSelected = !0);
      }
    } else {
      for (var b = sr(ca(r)), k = null, W = 0; W < l.length; W++) {
        if (l[W].value === b) {
          l[W].selected = !0, i && (l[W].defaultSelected = !0);
          return;
        }
        k === null && !l[W].disabled && (k = l[W]);
      }
      k !== null && (k.selected = !0);
    }
  }
  function Al(e, t) {
    return Je({}, t, {
      value: void 0
    });
  }
  function Rl(e, t) {
    var r = e;
    bT(t), r._wrapperState = {
      wasMultiple: !!t.multiple
    }, t.value !== void 0 && t.defaultValue !== void 0 && !fi && (u("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), fi = !0);
  }
  function MT(e, t) {
    var r = e;
    r.multiple = !!t.multiple;
    var i = t.value;
    i != null ? Pa(r, !!t.multiple, i, !1) : t.defaultValue != null && Pa(r, !!t.multiple, t.defaultValue, !0);
  }
  function UL(e, t) {
    var r = e, i = r._wrapperState.wasMultiple;
    r._wrapperState.wasMultiple = !!t.multiple;
    var l = t.value;
    l != null ? Pa(r, !!t.multiple, l, !1) : i !== !!t.multiple && (t.defaultValue != null ? Pa(r, !!t.multiple, t.defaultValue, !0) : Pa(r, !!t.multiple, t.multiple ? [] : "", !1));
  }
  function xL(e, t) {
    var r = e, i = t.value;
    i != null && Pa(r, !!t.multiple, i, !1);
  }
  var ah = !1;
  function PT(e, t) {
    var r = e;
    if (t.dangerouslySetInnerHTML != null)
      throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
    var i = Je({}, t, {
      value: void 0,
      defaultValue: void 0,
      children: sr(r._wrapperState.initialValue)
    });
    return i;
  }
  function ih(e, t) {
    var r = e;
    js("textarea", t), t.value !== void 0 && t.defaultValue !== void 0 && !ah && (u("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", ui() || "A component"), ah = !0);
    var i = t.value;
    if (i == null) {
      var l = t.children, f = t.defaultValue;
      if (l != null) {
        u("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
        {
          if (f != null)
            throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
          if (st(l)) {
            if (l.length > 1)
              throw new Error("<textarea> can only have at most one child.");
            l = l[0];
          }
          f = l;
        }
      }
      f == null && (f = ""), i = f;
    }
    r._wrapperState = {
      initialValue: ca(i)
    };
  }
  function sh(e, t) {
    var r = e, i = ca(t.value), l = ca(t.defaultValue);
    if (i != null) {
      var f = sr(i);
      f !== r.value && (r.value = f), t.defaultValue == null && r.defaultValue !== f && (r.defaultValue = f);
    }
    l != null && (r.defaultValue = sr(l));
  }
  function oh(e, t) {
    var r = e, i = r.textContent;
    i === r._wrapperState.initialValue && i !== "" && i !== null && (r.value = i);
  }
  function wL(e, t) {
    sh(e, t);
  }
  var Ua = "http://www.w3.org/1999/xhtml", GL = "http://www.w3.org/1998/Math/MathML", UT = "http://www.w3.org/2000/svg";
  function xT(e) {
    switch (e) {
      case "svg":
        return UT;
      case "math":
        return GL;
      default:
        return Ua;
    }
  }
  function wT(e, t) {
    return e == null || e === Ua ? xT(t) : e === UT && t === "foreignObject" ? Ua : e;
  }
  var HL = function(e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(t, r, i, l) {
      MSApp.execUnsafeLocalFunction(function() {
        return e(t, r, i, l);
      });
    } : e;
  }, yE, lh = HL(function(e, t) {
    if (e.namespaceURI === UT && !("innerHTML" in e)) {
      yE = yE || document.createElement("div"), yE.innerHTML = "<svg>" + t.valueOf().toString() + "</svg>";
      for (var r = yE.firstChild; e.firstChild; )
        e.removeChild(e.firstChild);
      for (; r.firstChild; )
        e.appendChild(r.firstChild);
      return;
    }
    e.innerHTML = t;
  }), or = 1, xa = 3, zt = 8, wa = 9, GT = 11, gE = function(e, t) {
    if (t) {
      var r = e.firstChild;
      if (r && r === e.lastChild && r.nodeType === xa) {
        r.nodeValue = t;
        return;
      }
    }
    e.textContent = t;
  }, BL = {
    animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
    background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
    backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
    border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
    borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
    borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
    borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
    borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
    borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
    borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
    borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
    borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
    borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
    borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
    borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
    borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
    borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
    columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
    columns: ["columnCount", "columnWidth"],
    flex: ["flexBasis", "flexGrow", "flexShrink"],
    flexFlow: ["flexDirection", "flexWrap"],
    font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
    fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
    gap: ["columnGap", "rowGap"],
    grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
    gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
    gridColumn: ["gridColumnEnd", "gridColumnStart"],
    gridColumnGap: ["columnGap"],
    gridGap: ["columnGap", "rowGap"],
    gridRow: ["gridRowEnd", "gridRowStart"],
    gridRowGap: ["rowGap"],
    gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
    listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
    margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
    marker: ["markerEnd", "markerMid", "markerStart"],
    mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
    maskPosition: ["maskPositionX", "maskPositionY"],
    outline: ["outlineColor", "outlineStyle", "outlineWidth"],
    overflow: ["overflowX", "overflowY"],
    padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
    placeContent: ["alignContent", "justifyContent"],
    placeItems: ["alignItems", "justifyItems"],
    placeSelf: ["alignSelf", "justifySelf"],
    textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
    textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
    transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
    wordWrap: ["overflowWrap"]
  }, pl = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    // SVG-related properties
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  };
  function FL(e, t) {
    return e + t.charAt(0).toUpperCase() + t.substring(1);
  }
  var YL = ["Webkit", "ms", "Moz", "O"];
  Object.keys(pl).forEach(function(e) {
    YL.forEach(function(t) {
      pl[FL(t, e)] = pl[e];
    });
  });
  function HT(e, t, r) {
    var i = t == null || typeof t == "boolean" || t === "";
    return i ? "" : !r && typeof t == "number" && t !== 0 && !(pl.hasOwnProperty(e) && pl[e]) ? t + "px" : (Vr(t, e), ("" + t).trim());
  }
  var VL = /([A-Z])/g, WL = /^ms-/;
  function kL(e) {
    return e.replace(VL, "-$1").toLowerCase().replace(WL, "-ms-");
  }
  var uh = function() {
  };
  {
    var XL = /^(?:webkit|moz|o)[A-Z]/, jL = /^-ms-/, KL = /-(.)/g, Eh = /;\s*$/, Zs = {}, BT = {}, ch = !1, fh = !1, JL = function(e) {
      return e.replace(KL, function(t, r) {
        return r.toUpperCase();
      });
    }, zL = function(e) {
      Zs.hasOwnProperty(e) && Zs[e] || (Zs[e] = !0, u(
        "Unsupported style property %s. Did you mean %s?",
        e,
        // As Andi Smith suggests
        // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        JL(e.replace(jL, "ms-"))
      ));
    }, ZL = function(e) {
      Zs.hasOwnProperty(e) && Zs[e] || (Zs[e] = !0, u("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
    }, qL = function(e, t) {
      BT.hasOwnProperty(t) && BT[t] || (BT[t] = !0, u(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, t.replace(Eh, "")));
    }, QL = function(e, t) {
      ch || (ch = !0, u("`NaN` is an invalid value for the `%s` css style property.", e));
    }, $L = function(e, t) {
      fh || (fh = !0, u("`Infinity` is an invalid value for the `%s` css style property.", e));
    };
    uh = function(e, t) {
      e.indexOf("-") > -1 ? zL(e) : XL.test(e) ? ZL(e) : Eh.test(t) && qL(e, t), typeof t == "number" && (isNaN(t) ? QL(e, t) : isFinite(t) || $L(e, t));
    };
  }
  var e0 = uh;
  function t0(e) {
    {
      var t = "", r = "";
      for (var i in e)
        if (e.hasOwnProperty(i)) {
          var l = e[i];
          if (l != null) {
            var f = i.indexOf("--") === 0;
            t += r + (f ? i : kL(i)) + ":", t += HT(i, l, f), r = ";";
          }
        }
      return t || null;
    }
  }
  function Th(e, t) {
    var r = e.style;
    for (var i in t)
      if (t.hasOwnProperty(i)) {
        var l = i.indexOf("--") === 0;
        l || e0(i, t[i]);
        var f = HT(i, t[i], l);
        i === "float" && (i = "cssFloat"), l ? r.setProperty(i, f) : r[i] = f;
      }
  }
  function n0(e) {
    return e == null || typeof e == "boolean" || e === "";
  }
  function dh(e) {
    var t = {};
    for (var r in e)
      for (var i = BL[r] || [r], l = 0; l < i.length; l++)
        t[i[l]] = r;
    return t;
  }
  function r0(e, t) {
    {
      if (!t)
        return;
      var r = dh(e), i = dh(t), l = {};
      for (var f in r) {
        var A = r[f], h = i[f];
        if (h && A !== h) {
          var I = A + "," + h;
          if (l[I])
            continue;
          l[I] = !0, u("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", n0(e[A]) ? "Removing" : "Updating", A, h);
        }
      }
    }
  }
  var a0 = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
    // NOTE: menuitem's close tag should be omitted, but that causes problems.
  }, i0 = Je({
    menuitem: !0
  }, a0), s0 = "__html";
  function FT(e, t) {
    if (t) {
      if (i0[e] && (t.children != null || t.dangerouslySetInnerHTML != null))
        throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
      if (t.dangerouslySetInnerHTML != null) {
        if (t.children != null)
          throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
        if (typeof t.dangerouslySetInnerHTML != "object" || !(s0 in t.dangerouslySetInnerHTML))
          throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
      }
      if (!t.suppressContentEditableWarning && t.contentEditable && t.children != null && u("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), t.style != null && typeof t.style != "object")
        throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
  }
  function rs(e, t) {
    if (e.indexOf("-") === -1)
      return typeof t.is == "string";
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var DE = {
    // HTML
    accept: "accept",
    acceptcharset: "acceptCharset",
    "accept-charset": "acceptCharset",
    accesskey: "accessKey",
    action: "action",
    allowfullscreen: "allowFullScreen",
    alt: "alt",
    as: "as",
    async: "async",
    autocapitalize: "autoCapitalize",
    autocomplete: "autoComplete",
    autocorrect: "autoCorrect",
    autofocus: "autoFocus",
    autoplay: "autoPlay",
    autosave: "autoSave",
    capture: "capture",
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    challenge: "challenge",
    charset: "charSet",
    checked: "checked",
    children: "children",
    cite: "cite",
    class: "className",
    classid: "classID",
    classname: "className",
    cols: "cols",
    colspan: "colSpan",
    content: "content",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    controls: "controls",
    controlslist: "controlsList",
    coords: "coords",
    crossorigin: "crossOrigin",
    dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
    data: "data",
    datetime: "dateTime",
    default: "default",
    defaultchecked: "defaultChecked",
    defaultvalue: "defaultValue",
    defer: "defer",
    dir: "dir",
    disabled: "disabled",
    disablepictureinpicture: "disablePictureInPicture",
    disableremoteplayback: "disableRemotePlayback",
    download: "download",
    draggable: "draggable",
    enctype: "encType",
    enterkeyhint: "enterKeyHint",
    for: "htmlFor",
    form: "form",
    formmethod: "formMethod",
    formaction: "formAction",
    formenctype: "formEncType",
    formnovalidate: "formNoValidate",
    formtarget: "formTarget",
    frameborder: "frameBorder",
    headers: "headers",
    height: "height",
    hidden: "hidden",
    high: "high",
    href: "href",
    hreflang: "hrefLang",
    htmlfor: "htmlFor",
    httpequiv: "httpEquiv",
    "http-equiv": "httpEquiv",
    icon: "icon",
    id: "id",
    imagesizes: "imageSizes",
    imagesrcset: "imageSrcSet",
    innerhtml: "innerHTML",
    inputmode: "inputMode",
    integrity: "integrity",
    is: "is",
    itemid: "itemID",
    itemprop: "itemProp",
    itemref: "itemRef",
    itemscope: "itemScope",
    itemtype: "itemType",
    keyparams: "keyParams",
    keytype: "keyType",
    kind: "kind",
    label: "label",
    lang: "lang",
    list: "list",
    loop: "loop",
    low: "low",
    manifest: "manifest",
    marginwidth: "marginWidth",
    marginheight: "marginHeight",
    max: "max",
    maxlength: "maxLength",
    media: "media",
    mediagroup: "mediaGroup",
    method: "method",
    min: "min",
    minlength: "minLength",
    multiple: "multiple",
    muted: "muted",
    name: "name",
    nomodule: "noModule",
    nonce: "nonce",
    novalidate: "noValidate",
    open: "open",
    optimum: "optimum",
    pattern: "pattern",
    placeholder: "placeholder",
    playsinline: "playsInline",
    poster: "poster",
    preload: "preload",
    profile: "profile",
    radiogroup: "radioGroup",
    readonly: "readOnly",
    referrerpolicy: "referrerPolicy",
    rel: "rel",
    required: "required",
    reversed: "reversed",
    role: "role",
    rows: "rows",
    rowspan: "rowSpan",
    sandbox: "sandbox",
    scope: "scope",
    scoped: "scoped",
    scrolling: "scrolling",
    seamless: "seamless",
    selected: "selected",
    shape: "shape",
    size: "size",
    sizes: "sizes",
    span: "span",
    spellcheck: "spellCheck",
    src: "src",
    srcdoc: "srcDoc",
    srclang: "srcLang",
    srcset: "srcSet",
    start: "start",
    step: "step",
    style: "style",
    summary: "summary",
    tabindex: "tabIndex",
    target: "target",
    title: "title",
    type: "type",
    usemap: "useMap",
    value: "value",
    width: "width",
    wmode: "wmode",
    wrap: "wrap",
    // SVG
    about: "about",
    accentheight: "accentHeight",
    "accent-height": "accentHeight",
    accumulate: "accumulate",
    additive: "additive",
    alignmentbaseline: "alignmentBaseline",
    "alignment-baseline": "alignmentBaseline",
    allowreorder: "allowReorder",
    alphabetic: "alphabetic",
    amplitude: "amplitude",
    arabicform: "arabicForm",
    "arabic-form": "arabicForm",
    ascent: "ascent",
    attributename: "attributeName",
    attributetype: "attributeType",
    autoreverse: "autoReverse",
    azimuth: "azimuth",
    basefrequency: "baseFrequency",
    baselineshift: "baselineShift",
    "baseline-shift": "baselineShift",
    baseprofile: "baseProfile",
    bbox: "bbox",
    begin: "begin",
    bias: "bias",
    by: "by",
    calcmode: "calcMode",
    capheight: "capHeight",
    "cap-height": "capHeight",
    clip: "clip",
    clippath: "clipPath",
    "clip-path": "clipPath",
    clippathunits: "clipPathUnits",
    cliprule: "clipRule",
    "clip-rule": "clipRule",
    color: "color",
    colorinterpolation: "colorInterpolation",
    "color-interpolation": "colorInterpolation",
    colorinterpolationfilters: "colorInterpolationFilters",
    "color-interpolation-filters": "colorInterpolationFilters",
    colorprofile: "colorProfile",
    "color-profile": "colorProfile",
    colorrendering: "colorRendering",
    "color-rendering": "colorRendering",
    contentscripttype: "contentScriptType",
    contentstyletype: "contentStyleType",
    cursor: "cursor",
    cx: "cx",
    cy: "cy",
    d: "d",
    datatype: "datatype",
    decelerate: "decelerate",
    descent: "descent",
    diffuseconstant: "diffuseConstant",
    direction: "direction",
    display: "display",
    divisor: "divisor",
    dominantbaseline: "dominantBaseline",
    "dominant-baseline": "dominantBaseline",
    dur: "dur",
    dx: "dx",
    dy: "dy",
    edgemode: "edgeMode",
    elevation: "elevation",
    enablebackground: "enableBackground",
    "enable-background": "enableBackground",
    end: "end",
    exponent: "exponent",
    externalresourcesrequired: "externalResourcesRequired",
    fill: "fill",
    fillopacity: "fillOpacity",
    "fill-opacity": "fillOpacity",
    fillrule: "fillRule",
    "fill-rule": "fillRule",
    filter: "filter",
    filterres: "filterRes",
    filterunits: "filterUnits",
    floodopacity: "floodOpacity",
    "flood-opacity": "floodOpacity",
    floodcolor: "floodColor",
    "flood-color": "floodColor",
    focusable: "focusable",
    fontfamily: "fontFamily",
    "font-family": "fontFamily",
    fontsize: "fontSize",
    "font-size": "fontSize",
    fontsizeadjust: "fontSizeAdjust",
    "font-size-adjust": "fontSizeAdjust",
    fontstretch: "fontStretch",
    "font-stretch": "fontStretch",
    fontstyle: "fontStyle",
    "font-style": "fontStyle",
    fontvariant: "fontVariant",
    "font-variant": "fontVariant",
    fontweight: "fontWeight",
    "font-weight": "fontWeight",
    format: "format",
    from: "from",
    fx: "fx",
    fy: "fy",
    g1: "g1",
    g2: "g2",
    glyphname: "glyphName",
    "glyph-name": "glyphName",
    glyphorientationhorizontal: "glyphOrientationHorizontal",
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphorientationvertical: "glyphOrientationVertical",
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    hanging: "hanging",
    horizadvx: "horizAdvX",
    "horiz-adv-x": "horizAdvX",
    horizoriginx: "horizOriginX",
    "horiz-origin-x": "horizOriginX",
    ideographic: "ideographic",
    imagerendering: "imageRendering",
    "image-rendering": "imageRendering",
    in2: "in2",
    in: "in",
    inlist: "inlist",
    intercept: "intercept",
    k1: "k1",
    k2: "k2",
    k3: "k3",
    k4: "k4",
    k: "k",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    kerning: "kerning",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    letterspacing: "letterSpacing",
    "letter-spacing": "letterSpacing",
    lightingcolor: "lightingColor",
    "lighting-color": "lightingColor",
    limitingconeangle: "limitingConeAngle",
    local: "local",
    markerend: "markerEnd",
    "marker-end": "markerEnd",
    markerheight: "markerHeight",
    markermid: "markerMid",
    "marker-mid": "markerMid",
    markerstart: "markerStart",
    "marker-start": "markerStart",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    mask: "mask",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    mathematical: "mathematical",
    mode: "mode",
    numoctaves: "numOctaves",
    offset: "offset",
    opacity: "opacity",
    operator: "operator",
    order: "order",
    orient: "orient",
    orientation: "orientation",
    origin: "origin",
    overflow: "overflow",
    overlineposition: "overlinePosition",
    "overline-position": "overlinePosition",
    overlinethickness: "overlineThickness",
    "overline-thickness": "overlineThickness",
    paintorder: "paintOrder",
    "paint-order": "paintOrder",
    panose1: "panose1",
    "panose-1": "panose1",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointerevents: "pointerEvents",
    "pointer-events": "pointerEvents",
    points: "points",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    prefix: "prefix",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    property: "property",
    r: "r",
    radius: "radius",
    refx: "refX",
    refy: "refY",
    renderingintent: "renderingIntent",
    "rendering-intent": "renderingIntent",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    resource: "resource",
    restart: "restart",
    result: "result",
    results: "results",
    rotate: "rotate",
    rx: "rx",
    ry: "ry",
    scale: "scale",
    security: "security",
    seed: "seed",
    shaperendering: "shapeRendering",
    "shape-rendering": "shapeRendering",
    slope: "slope",
    spacing: "spacing",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    speed: "speed",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stemh: "stemh",
    stemv: "stemv",
    stitchtiles: "stitchTiles",
    stopcolor: "stopColor",
    "stop-color": "stopColor",
    stopopacity: "stopOpacity",
    "stop-opacity": "stopOpacity",
    strikethroughposition: "strikethroughPosition",
    "strikethrough-position": "strikethroughPosition",
    strikethroughthickness: "strikethroughThickness",
    "strikethrough-thickness": "strikethroughThickness",
    string: "string",
    stroke: "stroke",
    strokedasharray: "strokeDasharray",
    "stroke-dasharray": "strokeDasharray",
    strokedashoffset: "strokeDashoffset",
    "stroke-dashoffset": "strokeDashoffset",
    strokelinecap: "strokeLinecap",
    "stroke-linecap": "strokeLinecap",
    strokelinejoin: "strokeLinejoin",
    "stroke-linejoin": "strokeLinejoin",
    strokemiterlimit: "strokeMiterlimit",
    "stroke-miterlimit": "strokeMiterlimit",
    strokewidth: "strokeWidth",
    "stroke-width": "strokeWidth",
    strokeopacity: "strokeOpacity",
    "stroke-opacity": "strokeOpacity",
    suppresscontenteditablewarning: "suppressContentEditableWarning",
    suppresshydrationwarning: "suppressHydrationWarning",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textanchor: "textAnchor",
    "text-anchor": "textAnchor",
    textdecoration: "textDecoration",
    "text-decoration": "textDecoration",
    textlength: "textLength",
    textrendering: "textRendering",
    "text-rendering": "textRendering",
    to: "to",
    transform: "transform",
    typeof: "typeof",
    u1: "u1",
    u2: "u2",
    underlineposition: "underlinePosition",
    "underline-position": "underlinePosition",
    underlinethickness: "underlineThickness",
    "underline-thickness": "underlineThickness",
    unicode: "unicode",
    unicodebidi: "unicodeBidi",
    "unicode-bidi": "unicodeBidi",
    unicoderange: "unicodeRange",
    "unicode-range": "unicodeRange",
    unitsperem: "unitsPerEm",
    "units-per-em": "unitsPerEm",
    unselectable: "unselectable",
    valphabetic: "vAlphabetic",
    "v-alphabetic": "vAlphabetic",
    values: "values",
    vectoreffect: "vectorEffect",
    "vector-effect": "vectorEffect",
    version: "version",
    vertadvy: "vertAdvY",
    "vert-adv-y": "vertAdvY",
    vertoriginx: "vertOriginX",
    "vert-origin-x": "vertOriginX",
    vertoriginy: "vertOriginY",
    "vert-origin-y": "vertOriginY",
    vhanging: "vHanging",
    "v-hanging": "vHanging",
    videographic: "vIdeographic",
    "v-ideographic": "vIdeographic",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    visibility: "visibility",
    vmathematical: "vMathematical",
    "v-mathematical": "vMathematical",
    vocab: "vocab",
    widths: "widths",
    wordspacing: "wordSpacing",
    "word-spacing": "wordSpacing",
    writingmode: "writingMode",
    "writing-mode": "writingMode",
    x1: "x1",
    x2: "x2",
    x: "x",
    xchannelselector: "xChannelSelector",
    xheight: "xHeight",
    "x-height": "xHeight",
    xlinkactuate: "xlinkActuate",
    "xlink:actuate": "xlinkActuate",
    xlinkarcrole: "xlinkArcrole",
    "xlink:arcrole": "xlinkArcrole",
    xlinkhref: "xlinkHref",
    "xlink:href": "xlinkHref",
    xlinkrole: "xlinkRole",
    "xlink:role": "xlinkRole",
    xlinkshow: "xlinkShow",
    "xlink:show": "xlinkShow",
    xlinktitle: "xlinkTitle",
    "xlink:title": "xlinkTitle",
    xlinktype: "xlinkType",
    "xlink:type": "xlinkType",
    xmlbase: "xmlBase",
    "xml:base": "xmlBase",
    xmllang: "xmlLang",
    "xml:lang": "xmlLang",
    xmlns: "xmlns",
    "xml:space": "xmlSpace",
    xmlnsxlink: "xmlnsXlink",
    "xmlns:xlink": "xmlnsXlink",
    xmlspace: "xmlSpace",
    y1: "y1",
    y2: "y2",
    y: "y",
    ychannelselector: "yChannelSelector",
    z: "z",
    zoomandpan: "zoomAndPan"
  }, Ah = {
    "aria-current": 0,
    // state
    "aria-description": 0,
    "aria-details": 0,
    "aria-disabled": 0,
    // state
    "aria-hidden": 0,
    // state
    "aria-invalid": 0,
    // state
    "aria-keyshortcuts": 0,
    "aria-label": 0,
    "aria-roledescription": 0,
    // Widget Attributes
    "aria-autocomplete": 0,
    "aria-checked": 0,
    "aria-expanded": 0,
    "aria-haspopup": 0,
    "aria-level": 0,
    "aria-modal": 0,
    "aria-multiline": 0,
    "aria-multiselectable": 0,
    "aria-orientation": 0,
    "aria-placeholder": 0,
    "aria-pressed": 0,
    "aria-readonly": 0,
    "aria-required": 0,
    "aria-selected": 0,
    "aria-sort": 0,
    "aria-valuemax": 0,
    "aria-valuemin": 0,
    "aria-valuenow": 0,
    "aria-valuetext": 0,
    // Live Region Attributes
    "aria-atomic": 0,
    "aria-busy": 0,
    "aria-live": 0,
    "aria-relevant": 0,
    // Drag-and-Drop Attributes
    "aria-dropeffect": 0,
    "aria-grabbed": 0,
    // Relationship Attributes
    "aria-activedescendant": 0,
    "aria-colcount": 0,
    "aria-colindex": 0,
    "aria-colspan": 0,
    "aria-controls": 0,
    "aria-describedby": 0,
    "aria-errormessage": 0,
    "aria-flowto": 0,
    "aria-labelledby": 0,
    "aria-owns": 0,
    "aria-posinset": 0,
    "aria-rowcount": 0,
    "aria-rowindex": 0,
    "aria-rowspan": 0,
    "aria-setsize": 0
  }, qs = {}, o0 = new RegExp("^(aria)-[" + Le + "]*$"), l0 = new RegExp("^(aria)[A-Z][" + Le + "]*$");
  function u0(e, t) {
    {
      if (wn.call(qs, t) && qs[t])
        return !0;
      if (l0.test(t)) {
        var r = "aria-" + t.slice(4).toLowerCase(), i = Ah.hasOwnProperty(r) ? r : null;
        if (i == null)
          return u("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", t), qs[t] = !0, !0;
        if (t !== i)
          return u("Invalid ARIA attribute `%s`. Did you mean `%s`?", t, i), qs[t] = !0, !0;
      }
      if (o0.test(t)) {
        var l = t.toLowerCase(), f = Ah.hasOwnProperty(l) ? l : null;
        if (f == null)
          return qs[t] = !0, !1;
        if (t !== f)
          return u("Unknown ARIA attribute `%s`. Did you mean `%s`?", t, f), qs[t] = !0, !0;
      }
    }
    return !0;
  }
  function E0(e, t) {
    {
      var r = [];
      for (var i in t) {
        var l = u0(e, i);
        l || r.push(i);
      }
      var f = r.map(function(A) {
        return "`" + A + "`";
      }).join(", ");
      r.length === 1 ? u("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", f, e) : r.length > 1 && u("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", f, e);
    }
  }
  function c0(e, t) {
    rs(e, t) || E0(e, t);
  }
  var Rh = !1;
  function f0(e, t) {
    {
      if (e !== "input" && e !== "textarea" && e !== "select")
        return;
      t != null && t.value === null && !Rh && (Rh = !0, e === "select" && t.multiple ? u("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : u("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
    }
  }
  var ph = function() {
  };
  {
    var Kn = {}, Sh = /^on./, T0 = /^on[^A-Z]/, d0 = new RegExp("^(aria)-[" + Le + "]*$"), A0 = new RegExp("^(aria)[A-Z][" + Le + "]*$");
    ph = function(e, t, r, i) {
      if (wn.call(Kn, t) && Kn[t])
        return !0;
      var l = t.toLowerCase();
      if (l === "onfocusin" || l === "onfocusout")
        return u("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Kn[t] = !0, !0;
      if (i != null) {
        var f = i.registrationNameDependencies, A = i.possibleRegistrationNames;
        if (f.hasOwnProperty(t))
          return !0;
        var h = A.hasOwnProperty(l) ? A[l] : null;
        if (h != null)
          return u("Invalid event handler property `%s`. Did you mean `%s`?", t, h), Kn[t] = !0, !0;
        if (Sh.test(t))
          return u("Unknown event handler property `%s`. It will be ignored.", t), Kn[t] = !0, !0;
      } else if (Sh.test(t))
        return T0.test(t) && u("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", t), Kn[t] = !0, !0;
      if (d0.test(t) || A0.test(t))
        return !0;
      if (l === "innerhtml")
        return u("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Kn[t] = !0, !0;
      if (l === "aria")
        return u("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Kn[t] = !0, !0;
      if (l === "is" && r !== null && r !== void 0 && typeof r != "string")
        return u("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof r), Kn[t] = !0, !0;
      if (typeof r == "number" && isNaN(r))
        return u("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", t), Kn[t] = !0, !0;
      var I = Rr(t), L = I !== null && I.type === gr;
      if (DE.hasOwnProperty(l)) {
        var b = DE[l];
        if (b !== t)
          return u("Invalid DOM property `%s`. Did you mean `%s`?", t, b), Kn[t] = !0, !0;
      } else if (!L && t !== l)
        return u("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", t, l), Kn[t] = !0, !0;
      return typeof r == "boolean" && ar(t, r, I, !1) ? (r ? u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', r, t, t, r, t) : u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', r, t, t, r, t, t, t), Kn[t] = !0, !0) : L ? !0 : ar(t, r, I, !1) ? (Kn[t] = !0, !1) : ((r === "false" || r === "true") && I !== null && I.type === Wt && (u("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", r, t, r === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', t, r), Kn[t] = !0), !0);
    };
  }
  var R0 = function(e, t, r) {
    {
      var i = [];
      for (var l in t) {
        var f = ph(e, l, t[l], r);
        f || i.push(l);
      }
      var A = i.map(function(h) {
        return "`" + h + "`";
      }).join(", ");
      i.length === 1 ? u("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", A, e) : i.length > 1 && u("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", A, e);
    }
  };
  function p0(e, t, r) {
    rs(e, t) || R0(e, t, r);
  }
  var hh = 1, YT = 2, Sl = 4, S0 = hh | YT | Sl, hl = null;
  function h0(e) {
    hl !== null && u("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), hl = e;
  }
  function N0() {
    hl === null && u("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), hl = null;
  }
  function O0(e) {
    return e === hl;
  }
  function VT(e) {
    var t = e.target || e.srcElement || window;
    return t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === xa ? t.parentNode : t;
  }
  var WT = null, Qs = null, $s = null;
  function Nh(e) {
    var t = _i(e);
    if (t) {
      if (typeof WT != "function")
        throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
      var r = t.stateNode;
      if (r) {
        var i = Tc(r);
        WT(t.stateNode, t.type, i);
      }
    }
  }
  function I0(e) {
    WT = e;
  }
  function Oh(e) {
    Qs ? $s ? $s.push(e) : $s = [e] : Qs = e;
  }
  function _0() {
    return Qs !== null || $s !== null;
  }
  function Ih() {
    if (Qs) {
      var e = Qs, t = $s;
      if (Qs = null, $s = null, Nh(e), t)
        for (var r = 0; r < t.length; r++)
          Nh(t[r]);
    }
  }
  var _h = function(e, t) {
    return e(t);
  }, Ch = function() {
  }, kT = !1;
  function C0() {
    var e = _0();
    e && (Ch(), Ih());
  }
  function mh(e, t, r) {
    if (kT)
      return e(t, r);
    kT = !0;
    try {
      return _h(e, t, r);
    } finally {
      kT = !1, C0();
    }
  }
  function m0(e, t, r) {
    _h = e, Ch = r;
  }
  function v0(e) {
    return e === "button" || e === "input" || e === "select" || e === "textarea";
  }
  function L0(e, t, r) {
    switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        return !!(r.disabled && v0(t));
      default:
        return !1;
    }
  }
  function Nl(e, t) {
    var r = e.stateNode;
    if (r === null)
      return null;
    var i = Tc(r);
    if (i === null)
      return null;
    var l = i[t];
    if (L0(t, e.type, i))
      return null;
    if (l && typeof l != "function")
      throw new Error("Expected `" + t + "` listener to be a function, instead got a value of `" + typeof l + "` type.");
    return l;
  }
  var XT = !1;
  if (Jt)
    try {
      var Ol = {};
      Object.defineProperty(Ol, "passive", {
        get: function() {
          XT = !0;
        }
      }), window.addEventListener("test", Ol, Ol), window.removeEventListener("test", Ol, Ol);
    } catch {
      XT = !1;
    }
  function vh(e, t, r, i, l, f, A, h, I) {
    var L = Array.prototype.slice.call(arguments, 3);
    try {
      t.apply(r, L);
    } catch (b) {
      this.onError(b);
    }
  }
  var Lh = vh;
  if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
    var jT = document.createElement("react");
    Lh = function(t, r, i, l, f, A, h, I, L) {
      if (typeof document > "u" || document === null)
        throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
      var b = document.createEvent("Event"), k = !1, W = !0, q = window.event, Q = Object.getOwnPropertyDescriptor(window, "event");
      function re() {
        jT.removeEventListener(ae, ye, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = q);
      }
      var Ne = Array.prototype.slice.call(arguments, 3);
      function ye() {
        k = !0, re(), r.apply(i, Ne), W = !1;
      }
      var me, Qe = !1, Xe = !1;
      function K(J) {
        if (me = J.error, Qe = !0, me === null && J.colno === 0 && J.lineno === 0 && (Xe = !0), J.defaultPrevented && me != null && typeof me == "object")
          try {
            me._suppressLogging = !0;
          } catch {
          }
      }
      var ae = "react-" + (t || "invokeguardedcallback");
      if (window.addEventListener("error", K), jT.addEventListener(ae, ye, !1), b.initEvent(ae, !1, !1), jT.dispatchEvent(b), Q && Object.defineProperty(window, "event", Q), k && W && (Qe ? Xe && (me = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : me = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(me)), window.removeEventListener("error", K), !k)
        return re(), vh.apply(this, arguments);
    };
  }
  var y0 = Lh, eo = !1, bE = null, ME = !1, KT = null, g0 = {
    onError: function(e) {
      eo = !0, bE = e;
    }
  };
  function JT(e, t, r, i, l, f, A, h, I) {
    eo = !1, bE = null, y0.apply(g0, arguments);
  }
  function D0(e, t, r, i, l, f, A, h, I) {
    if (JT.apply(this, arguments), eo) {
      var L = zT();
      ME || (ME = !0, KT = L);
    }
  }
  function b0() {
    if (ME) {
      var e = KT;
      throw ME = !1, KT = null, e;
    }
  }
  function M0() {
    return eo;
  }
  function zT() {
    if (eo) {
      var e = bE;
      return eo = !1, bE = null, e;
    } else
      throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
  }
  function to(e) {
    return e._reactInternals;
  }
  function P0(e) {
    return e._reactInternals !== void 0;
  }
  function U0(e, t) {
    e._reactInternals = t;
  }
  var be = (
    /*                      */
    0
  ), no = (
    /*                */
    1
  ), Zt = (
    /*                    */
    2
  ), tt = (
    /*                       */
    4
  ), as = (
    /*                */
    16
  ), Il = (
    /*                 */
    32
  ), ZT = (
    /*                     */
    64
  ), ct = (
    /*                   */
    128
  ), Ga = (
    /*            */
    256
  ), Ti = (
    /*                          */
    512
  ), is = (
    /*                     */
    1024
  ), Xr = (
    /*                      */
    2048
  ), Ha = (
    /*                    */
    4096
  ), ss = (
    /*                   */
    8192
  ), PE = (
    /*             */
    16384
  ), x0 = Xr | tt | ZT | Ti | is | PE, w0 = (
    /*               */
    32767
  ), _l = (
    /*                   */
    32768
  ), Jn = (
    /*                */
    65536
  ), qT = (
    /* */
    131072
  ), yh = (
    /*                       */
    1048576
  ), QT = (
    /*                    */
    2097152
  ), os = (
    /*                 */
    4194304
  ), $T = (
    /*                */
    8388608
  ), Ba = (
    /*               */
    16777216
  ), UE = (
    /*              */
    33554432
  ), ed = (
    // TODO: Remove Update flag from before mutation phase by re-landing Visibility
    // flag logic (see #20043)
    tt | is | 0
  ), td = Zt | tt | as | Il | Ti | Ha | ss, Cl = tt | ZT | Ti | ss, ro = Xr | as, Fa = os | $T | QT, G0 = s.ReactCurrentOwner;
  function ls(e) {
    var t = e, r = e;
    if (e.alternate)
      for (; t.return; )
        t = t.return;
    else {
      var i = t;
      do
        t = i, (t.flags & (Zt | Ha)) !== be && (r = t.return), i = t.return;
      while (i);
    }
    return t.tag === N ? r : null;
  }
  function gh(e) {
    if (e.tag === G) {
      var t = e.memoizedState;
      if (t === null) {
        var r = e.alternate;
        r !== null && (t = r.memoizedState);
      }
      if (t !== null)
        return t.dehydrated;
    }
    return null;
  }
  function Dh(e) {
    return e.tag === N ? e.stateNode.containerInfo : null;
  }
  function H0(e) {
    return ls(e) === e;
  }
  function B0(e) {
    {
      var t = G0.current;
      if (t !== null && t.tag === T) {
        var r = t, i = r.stateNode;
        i._warnedAboutRefsInRender || u("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", Ye(r) || "A component"), i._warnedAboutRefsInRender = !0;
      }
    }
    var l = to(e);
    return l ? ls(l) === l : !1;
  }
  function bh(e) {
    if (ls(e) !== e)
      throw new Error("Unable to find node on an unmounted component.");
  }
  function Mh(e) {
    var t = e.alternate;
    if (!t) {
      var r = ls(e);
      if (r === null)
        throw new Error("Unable to find node on an unmounted component.");
      return r !== e ? null : e;
    }
    for (var i = e, l = t; ; ) {
      var f = i.return;
      if (f === null)
        break;
      var A = f.alternate;
      if (A === null) {
        var h = f.return;
        if (h !== null) {
          i = l = h;
          continue;
        }
        break;
      }
      if (f.child === A.child) {
        for (var I = f.child; I; ) {
          if (I === i)
            return bh(f), e;
          if (I === l)
            return bh(f), t;
          I = I.sibling;
        }
        throw new Error("Unable to find node on an unmounted component.");
      }
      if (i.return !== l.return)
        i = f, l = A;
      else {
        for (var L = !1, b = f.child; b; ) {
          if (b === i) {
            L = !0, i = f, l = A;
            break;
          }
          if (b === l) {
            L = !0, l = f, i = A;
            break;
          }
          b = b.sibling;
        }
        if (!L) {
          for (b = A.child; b; ) {
            if (b === i) {
              L = !0, i = A, l = f;
              break;
            }
            if (b === l) {
              L = !0, l = A, i = f;
              break;
            }
            b = b.sibling;
          }
          if (!L)
            throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
        }
      }
      if (i.alternate !== l)
        throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
    }
    if (i.tag !== N)
      throw new Error("Unable to find node on an unmounted component.");
    return i.stateNode.current === i ? e : t;
  }
  function Ph(e) {
    var t = Mh(e);
    return t !== null ? Uh(t) : null;
  }
  function Uh(e) {
    if (e.tag === v || e.tag === M)
      return e;
    for (var t = e.child; t !== null; ) {
      var r = Uh(t);
      if (r !== null)
        return r;
      t = t.sibling;
    }
    return null;
  }
  function F0(e) {
    var t = Mh(e);
    return t !== null ? xh(t) : null;
  }
  function xh(e) {
    if (e.tag === v || e.tag === M)
      return e;
    for (var t = e.child; t !== null; ) {
      if (t.tag !== m) {
        var r = xh(t);
        if (r !== null)
          return r;
      }
      t = t.sibling;
    }
    return null;
  }
  var wh = a.unstable_scheduleCallback, Y0 = a.unstable_cancelCallback, V0 = a.unstable_shouldYield, W0 = a.unstable_requestPaint, Sn = a.unstable_now, k0 = a.unstable_getCurrentPriorityLevel, nd = a.unstable_ImmediatePriority, Gh = a.unstable_UserBlockingPriority, ml = a.unstable_NormalPriority, X0 = a.unstable_LowPriority, Hh = a.unstable_IdlePriority, j0 = a.unstable_yieldValue, K0 = a.unstable_setDisableYieldValue, jr = typeof { isDisabled: !0 } < "u";
  function J0(e) {
    return !(typeof { isDisabled: !0 } > "u");
  }
  function zB(e, t) {
  }
  function hn(e) {
    typeof j0 == "function" && (K0(e), c(e));
  }
  function ZB() {
  }
  function qB(e, t, r) {
  }
  function QB(e, t, r) {
  }
  var Me = (
    /*                         */
    0
  ), Ze = (
    /*                 */
    1
  ), pt = (
    /*                    */
    2
  ), qt = (
    /*               */
    8
  ), fa = (
    /*              */
    16
  ), Bh = Math.clz32 ? Math.clz32 : q0, z0 = Math.log, Z0 = Math.LN2;
  function q0(e) {
    var t = e >>> 0;
    return t === 0 ? 32 : 31 - (z0(t) / Z0 | 0) | 0;
  }
  var Fh = 31, le = (
    /*                        */
    0
  ), Nn = (
    /*                          */
    0
  ), Ge = (
    /*                        */
    1
  ), vl = (
    /*    */
    2
  ), di = (
    /*             */
    4
  ), ao = (
    /*            */
    8
  ), Ya = (
    /*                     */
    16
  ), xE = (
    /*                */
    32
  ), Ll = (
    /*                       */
    4194240
  ), yl = (
    /*                        */
    64
  ), rd = (
    /*                        */
    128
  ), ad = (
    /*                        */
    256
  ), id = (
    /*                        */
    512
  ), sd = (
    /*                        */
    1024
  ), od = (
    /*                        */
    2048
  ), ld = (
    /*                        */
    4096
  ), ud = (
    /*                        */
    8192
  ), Ed = (
    /*                        */
    16384
  ), cd = (
    /*                       */
    32768
  ), fd = (
    /*                       */
    65536
  ), Td = (
    /*                       */
    131072
  ), dd = (
    /*                       */
    262144
  ), Ad = (
    /*                       */
    524288
  ), Rd = (
    /*                       */
    1048576
  ), pd = (
    /*                       */
    2097152
  ), Sd = (
    /*                            */
    130023424
  ), io = (
    /*                             */
    4194304
  ), hd = (
    /*                             */
    8388608
  ), Nd = (
    /*                             */
    16777216
  ), Od = (
    /*                             */
    33554432
  ), Id = (
    /*                             */
    67108864
  ), Yh = io, wE = (
    /*          */
    134217728
  ), Vh = (
    /*                          */
    268435455
  ), GE = (
    /*               */
    268435456
  ), so = (
    /*                        */
    536870912
  ), Mr = (
    /*                   */
    1073741824
  ), mt = -1, HE = yl, BE = io;
  function gl(e) {
    switch (us(e)) {
      case Ge:
        return Ge;
      case vl:
        return vl;
      case di:
        return di;
      case ao:
        return ao;
      case Ya:
        return Ya;
      case xE:
        return xE;
      case yl:
      case rd:
      case ad:
      case id:
      case sd:
      case od:
      case ld:
      case ud:
      case Ed:
      case cd:
      case fd:
      case Td:
      case dd:
      case Ad:
      case Rd:
      case pd:
        return e & Ll;
      case io:
      case hd:
      case Nd:
      case Od:
      case Id:
        return e & Sd;
      case wE:
        return wE;
      case GE:
        return GE;
      case so:
        return so;
      case Mr:
        return Mr;
      default:
        return u("Should have found matching lanes. This is a bug in React."), e;
    }
  }
  function FE(e, t) {
    var r = e.pendingLanes;
    if (r === le)
      return le;
    var i = le, l = e.suspendedLanes, f = e.pingedLanes, A = r & Vh;
    if (A !== le) {
      var h = A & ~l;
      if (h !== le)
        i = gl(h);
      else {
        var I = A & f;
        I !== le && (i = gl(I));
      }
    } else {
      var L = r & ~l;
      L !== le ? i = gl(L) : f !== le && (i = gl(f));
    }
    if (i === le)
      return le;
    if (t !== le && t !== i && // If we already suspended with a delay, then interrupting is fine. Don't
    // bother waiting until the root is complete.
    (t & l) === le) {
      var b = us(i), k = us(t);
      if (
        // Tests whether the next lane is equal or lower priority than the wip
        // one. This works because the bits decrease in priority as you go left.
        b >= k || // Default priority updates should not interrupt transition updates. The
        // only difference between default updates and transition updates is that
        // default updates do not support refresh transitions.
        b === Ya && (k & Ll) !== le
      )
        return t;
    }
    (i & di) !== le && (i |= r & Ya);
    var W = e.entangledLanes;
    if (W !== le)
      for (var q = e.entanglements, Q = i & W; Q > 0; ) {
        var re = Es(Q), Ne = 1 << re;
        i |= q[re], Q &= ~Ne;
      }
    return i;
  }
  function Q0(e, t) {
    for (var r = e.eventTimes, i = mt; t > 0; ) {
      var l = Es(t), f = 1 << l, A = r[l];
      A > i && (i = A), t &= ~f;
    }
    return i;
  }
  function $0(e, t) {
    switch (e) {
      case Ge:
      case vl:
      case di:
        return t + 250;
      case ao:
      case Ya:
      case xE:
      case yl:
      case rd:
      case ad:
      case id:
      case sd:
      case od:
      case ld:
      case ud:
      case Ed:
      case cd:
      case fd:
      case Td:
      case dd:
      case Ad:
      case Rd:
      case pd:
        return t + 5e3;
      case io:
      case hd:
      case Nd:
      case Od:
      case Id:
        return mt;
      case wE:
      case GE:
      case so:
      case Mr:
        return mt;
      default:
        return u("Should have found matching lanes. This is a bug in React."), mt;
    }
  }
  function e1(e, t) {
    for (var r = e.pendingLanes, i = e.suspendedLanes, l = e.pingedLanes, f = e.expirationTimes, A = r; A > 0; ) {
      var h = Es(A), I = 1 << h, L = f[h];
      L === mt ? ((I & i) === le || (I & l) !== le) && (f[h] = $0(I, t)) : L <= t && (e.expiredLanes |= I), A &= ~I;
    }
  }
  function t1(e) {
    return gl(e.pendingLanes);
  }
  function _d(e) {
    var t = e.pendingLanes & ~Mr;
    return t !== le ? t : t & Mr ? Mr : le;
  }
  function n1(e) {
    return (e & Ge) !== le;
  }
  function Cd(e) {
    return (e & Vh) !== le;
  }
  function Wh(e) {
    return (e & Sd) === e;
  }
  function r1(e) {
    var t = Ge | di | Ya;
    return (e & t) === le;
  }
  function a1(e) {
    return (e & Ll) === e;
  }
  function YE(e, t) {
    var r = vl | di | ao | Ya;
    return (t & r) !== le;
  }
  function i1(e, t) {
    return (t & e.expiredLanes) !== le;
  }
  function kh(e) {
    return (e & Ll) !== le;
  }
  function Xh() {
    var e = HE;
    return HE <<= 1, (HE & Ll) === le && (HE = yl), e;
  }
  function s1() {
    var e = BE;
    return BE <<= 1, (BE & Sd) === le && (BE = io), e;
  }
  function us(e) {
    return e & -e;
  }
  function Dl(e) {
    return us(e);
  }
  function Es(e) {
    return 31 - Bh(e);
  }
  function md(e) {
    return Es(e);
  }
  function Sr(e, t) {
    return (e & t) !== le;
  }
  function oo(e, t) {
    return (e & t) === t;
  }
  function We(e, t) {
    return e | t;
  }
  function VE(e, t) {
    return e & ~t;
  }
  function jh(e, t) {
    return e & t;
  }
  function $B(e) {
    return e;
  }
  function o1(e, t) {
    return e !== Nn && e < t ? e : t;
  }
  function vd(e) {
    for (var t = [], r = 0; r < Fh; r++)
      t.push(e);
    return t;
  }
  function bl(e, t, r) {
    e.pendingLanes |= t, t !== so && (e.suspendedLanes = le, e.pingedLanes = le);
    var i = e.eventTimes, l = md(t);
    i[l] = r;
  }
  function l1(e, t) {
    e.suspendedLanes |= t, e.pingedLanes &= ~t;
    for (var r = e.expirationTimes, i = t; i > 0; ) {
      var l = Es(i), f = 1 << l;
      r[l] = mt, i &= ~f;
    }
  }
  function Kh(e, t, r) {
    e.pingedLanes |= e.suspendedLanes & t;
  }
  function u1(e, t) {
    var r = e.pendingLanes & ~t;
    e.pendingLanes = t, e.suspendedLanes = le, e.pingedLanes = le, e.expiredLanes &= t, e.mutableReadLanes &= t, e.entangledLanes &= t;
    for (var i = e.entanglements, l = e.eventTimes, f = e.expirationTimes, A = r; A > 0; ) {
      var h = Es(A), I = 1 << h;
      i[h] = le, l[h] = mt, f[h] = mt, A &= ~I;
    }
  }
  function Ld(e, t) {
    for (var r = e.entangledLanes |= t, i = e.entanglements, l = r; l; ) {
      var f = Es(l), A = 1 << f;
      // Is this one of the newly entangled lanes?
      A & t | // Is this lane transitively entangled with the newly entangled lanes?
      i[f] & t && (i[f] |= t), l &= ~A;
    }
  }
  function E1(e, t) {
    var r = us(t), i;
    switch (r) {
      case di:
        i = vl;
        break;
      case Ya:
        i = ao;
        break;
      case yl:
      case rd:
      case ad:
      case id:
      case sd:
      case od:
      case ld:
      case ud:
      case Ed:
      case cd:
      case fd:
      case Td:
      case dd:
      case Ad:
      case Rd:
      case pd:
      case io:
      case hd:
      case Nd:
      case Od:
      case Id:
        i = xE;
        break;
      case so:
        i = GE;
        break;
      default:
        i = Nn;
        break;
    }
    return (i & (e.suspendedLanes | t)) !== Nn ? Nn : i;
  }
  function Jh(e, t, r) {
    if (jr)
      for (var i = e.pendingUpdatersLaneMap; r > 0; ) {
        var l = md(r), f = 1 << l, A = i[l];
        A.add(t), r &= ~f;
      }
  }
  function zh(e, t) {
    if (jr)
      for (var r = e.pendingUpdatersLaneMap, i = e.memoizedUpdaters; t > 0; ) {
        var l = md(t), f = 1 << l, A = r[l];
        A.size > 0 && (A.forEach(function(h) {
          var I = h.alternate;
          (I === null || !i.has(I)) && i.add(h);
        }), A.clear()), t &= ~f;
      }
  }
  function Zh(e, t) {
    return null;
  }
  var Pr = Ge, Ai = di, Ri = Ya, yd = so, Ml = Nn;
  function Kr() {
    return Ml;
  }
  function On(e) {
    Ml = e;
  }
  function c1(e, t) {
    var r = Ml;
    try {
      return Ml = e, t();
    } finally {
      Ml = r;
    }
  }
  function f1(e, t) {
    return e !== 0 && e < t ? e : t;
  }
  function T1(e, t) {
    return e === 0 || e > t ? e : t;
  }
  function gd(e, t) {
    return e !== 0 && e < t;
  }
  function qh(e) {
    var t = us(e);
    return gd(Pr, t) ? gd(Ai, t) ? Cd(t) ? Ri : yd : Ai : Pr;
  }
  function WE(e) {
    var t = e.current.memoizedState;
    return t.isDehydrated;
  }
  var Qh;
  function d1(e) {
    Qh = e;
  }
  function A1(e) {
    Qh(e);
  }
  var Dd;
  function R1(e) {
    Dd = e;
  }
  var $h;
  function p1(e) {
    $h = e;
  }
  var eN;
  function S1(e) {
    eN = e;
  }
  var tN;
  function h1(e) {
    tN = e;
  }
  var bd = !1, kE = [], pi = null, Si = null, hi = null, Pl = /* @__PURE__ */ new Map(), Ul = /* @__PURE__ */ new Map(), Ni = [], N1 = [
    "mousedown",
    "mouseup",
    "touchcancel",
    "touchend",
    "touchstart",
    "auxclick",
    "dblclick",
    "pointercancel",
    "pointerdown",
    "pointerup",
    "dragend",
    "dragstart",
    "drop",
    "compositionend",
    "compositionstart",
    "keydown",
    "keypress",
    "keyup",
    "input",
    "textInput",
    // Intentionally camelCase
    "copy",
    "cut",
    "paste",
    "click",
    "change",
    "contextmenu",
    "reset",
    "submit"
  ];
  function O1(e) {
    return N1.indexOf(e) > -1;
  }
  function I1(e, t, r, i, l) {
    return {
      blockedOn: e,
      domEventName: t,
      eventSystemFlags: r,
      nativeEvent: l,
      targetContainers: [i]
    };
  }
  function nN(e, t) {
    switch (e) {
      case "focusin":
      case "focusout":
        pi = null;
        break;
      case "dragenter":
      case "dragleave":
        Si = null;
        break;
      case "mouseover":
      case "mouseout":
        hi = null;
        break;
      case "pointerover":
      case "pointerout": {
        var r = t.pointerId;
        Pl.delete(r);
        break;
      }
      case "gotpointercapture":
      case "lostpointercapture": {
        var i = t.pointerId;
        Ul.delete(i);
        break;
      }
    }
  }
  function xl(e, t, r, i, l, f) {
    if (e === null || e.nativeEvent !== f) {
      var A = I1(t, r, i, l, f);
      if (t !== null) {
        var h = _i(t);
        h !== null && Dd(h);
      }
      return A;
    }
    e.eventSystemFlags |= i;
    var I = e.targetContainers;
    return l !== null && I.indexOf(l) === -1 && I.push(l), e;
  }
  function _1(e, t, r, i, l) {
    switch (t) {
      case "focusin": {
        var f = l;
        return pi = xl(pi, e, t, r, i, f), !0;
      }
      case "dragenter": {
        var A = l;
        return Si = xl(Si, e, t, r, i, A), !0;
      }
      case "mouseover": {
        var h = l;
        return hi = xl(hi, e, t, r, i, h), !0;
      }
      case "pointerover": {
        var I = l, L = I.pointerId;
        return Pl.set(L, xl(Pl.get(L) || null, e, t, r, i, I)), !0;
      }
      case "gotpointercapture": {
        var b = l, k = b.pointerId;
        return Ul.set(k, xl(Ul.get(k) || null, e, t, r, i, b)), !0;
      }
    }
    return !1;
  }
  function rN(e) {
    var t = Ts(e.target);
    if (t !== null) {
      var r = ls(t);
      if (r !== null) {
        var i = r.tag;
        if (i === G) {
          var l = gh(r);
          if (l !== null) {
            e.blockedOn = l, tN(e.priority, function() {
              $h(r);
            });
            return;
          }
        } else if (i === N) {
          var f = r.stateNode;
          if (WE(f)) {
            e.blockedOn = Dh(r);
            return;
          }
        }
      }
    }
    e.blockedOn = null;
  }
  function C1(e) {
    for (var t = eN(), r = {
      blockedOn: null,
      target: e,
      priority: t
    }, i = 0; i < Ni.length && gd(t, Ni[i].priority); i++)
      ;
    Ni.splice(i, 0, r), i === 0 && rN(r);
  }
  function XE(e) {
    if (e.blockedOn !== null)
      return !1;
    for (var t = e.targetContainers; t.length > 0; ) {
      var r = t[0], i = Ud(e.domEventName, e.eventSystemFlags, r, e.nativeEvent);
      if (i === null) {
        var l = e.nativeEvent, f = new l.constructor(l.type, l);
        h0(f), l.target.dispatchEvent(f), N0();
      } else {
        var A = _i(i);
        return A !== null && Dd(A), e.blockedOn = i, !1;
      }
      t.shift();
    }
    return !0;
  }
  function aN(e, t, r) {
    XE(e) && r.delete(t);
  }
  function m1() {
    bd = !1, pi !== null && XE(pi) && (pi = null), Si !== null && XE(Si) && (Si = null), hi !== null && XE(hi) && (hi = null), Pl.forEach(aN), Ul.forEach(aN);
  }
  function wl(e, t) {
    e.blockedOn === t && (e.blockedOn = null, bd || (bd = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, m1)));
  }
  function Gl(e) {
    if (kE.length > 0) {
      wl(kE[0], e);
      for (var t = 1; t < kE.length; t++) {
        var r = kE[t];
        r.blockedOn === e && (r.blockedOn = null);
      }
    }
    pi !== null && wl(pi, e), Si !== null && wl(Si, e), hi !== null && wl(hi, e);
    var i = function(h) {
      return wl(h, e);
    };
    Pl.forEach(i), Ul.forEach(i);
    for (var l = 0; l < Ni.length; l++) {
      var f = Ni[l];
      f.blockedOn === e && (f.blockedOn = null);
    }
    for (; Ni.length > 0; ) {
      var A = Ni[0];
      if (A.blockedOn !== null)
        break;
      rN(A), A.blockedOn === null && Ni.shift();
    }
  }
  var lo = s.ReactCurrentBatchConfig, Md = !0;
  function iN(e) {
    Md = !!e;
  }
  function v1() {
    return Md;
  }
  function L1(e, t, r) {
    var i = sN(t), l;
    switch (i) {
      case Pr:
        l = y1;
        break;
      case Ai:
        l = g1;
        break;
      case Ri:
      default:
        l = Pd;
        break;
    }
    return l.bind(null, t, r, e);
  }
  function y1(e, t, r, i) {
    var l = Kr(), f = lo.transition;
    lo.transition = null;
    try {
      On(Pr), Pd(e, t, r, i);
    } finally {
      On(l), lo.transition = f;
    }
  }
  function g1(e, t, r, i) {
    var l = Kr(), f = lo.transition;
    lo.transition = null;
    try {
      On(Ai), Pd(e, t, r, i);
    } finally {
      On(l), lo.transition = f;
    }
  }
  function Pd(e, t, r, i) {
    Md && D1(e, t, r, i);
  }
  function D1(e, t, r, i) {
    var l = Ud(e, t, r, i);
    if (l === null) {
      Jd(e, t, i, jE, r), nN(e, i);
      return;
    }
    if (_1(l, e, t, r, i)) {
      i.stopPropagation();
      return;
    }
    if (nN(e, i), t & Sl && O1(e)) {
      for (; l !== null; ) {
        var f = _i(l);
        f !== null && A1(f);
        var A = Ud(e, t, r, i);
        if (A === null && Jd(e, t, i, jE, r), A === l)
          break;
        l = A;
      }
      l !== null && i.stopPropagation();
      return;
    }
    Jd(e, t, i, null, r);
  }
  var jE = null;
  function Ud(e, t, r, i) {
    jE = null;
    var l = VT(i), f = Ts(l);
    if (f !== null) {
      var A = ls(f);
      if (A === null)
        f = null;
      else {
        var h = A.tag;
        if (h === G) {
          var I = gh(A);
          if (I !== null)
            return I;
          f = null;
        } else if (h === N) {
          var L = A.stateNode;
          if (WE(L))
            return Dh(A);
          f = null;
        } else
          A !== f && (f = null);
      }
    }
    return jE = f, null;
  }
  function sN(e) {
    switch (e) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return Pr;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return Ai;
      case "message": {
        var t = k0();
        switch (t) {
          case nd:
            return Pr;
          case Gh:
            return Ai;
          case ml:
          case X0:
            return Ri;
          case Hh:
            return yd;
          default:
            return Ri;
        }
      }
      default:
        return Ri;
    }
  }
  function b1(e, t, r) {
    return e.addEventListener(t, r, !1), r;
  }
  function M1(e, t, r) {
    return e.addEventListener(t, r, !0), r;
  }
  function P1(e, t, r, i) {
    return e.addEventListener(t, r, {
      capture: !0,
      passive: i
    }), r;
  }
  function U1(e, t, r, i) {
    return e.addEventListener(t, r, {
      passive: i
    }), r;
  }
  var Hl = null, xd = null, Bl = null;
  function x1(e) {
    return Hl = e, xd = lN(), !0;
  }
  function w1() {
    Hl = null, xd = null, Bl = null;
  }
  function oN() {
    if (Bl)
      return Bl;
    var e, t = xd, r = t.length, i, l = lN(), f = l.length;
    for (e = 0; e < r && t[e] === l[e]; e++)
      ;
    var A = r - e;
    for (i = 1; i <= A && t[r - i] === l[f - i]; i++)
      ;
    var h = i > 1 ? 1 - i : void 0;
    return Bl = l.slice(e, h), Bl;
  }
  function lN() {
    return "value" in Hl ? Hl.value : Hl.textContent;
  }
  function KE(e) {
    var t, r = e.keyCode;
    return "charCode" in e ? (t = e.charCode, t === 0 && r === 13 && (t = 13)) : t = r, t === 10 && (t = 13), t >= 32 || t === 13 ? t : 0;
  }
  function JE() {
    return !0;
  }
  function uN() {
    return !1;
  }
  function hr(e) {
    function t(r, i, l, f, A) {
      this._reactName = r, this._targetInst = l, this.type = i, this.nativeEvent = f, this.target = A, this.currentTarget = null;
      for (var h in e)
        if (e.hasOwnProperty(h)) {
          var I = e[h];
          I ? this[h] = I(f) : this[h] = f[h];
        }
      var L = f.defaultPrevented != null ? f.defaultPrevented : f.returnValue === !1;
      return L ? this.isDefaultPrevented = JE : this.isDefaultPrevented = uN, this.isPropagationStopped = uN, this;
    }
    return Je(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var r = this.nativeEvent;
        r && (r.preventDefault ? r.preventDefault() : typeof r.returnValue != "unknown" && (r.returnValue = !1), this.isDefaultPrevented = JE);
      },
      stopPropagation: function() {
        var r = this.nativeEvent;
        r && (r.stopPropagation ? r.stopPropagation() : typeof r.cancelBubble != "unknown" && (r.cancelBubble = !0), this.isPropagationStopped = JE);
      },
      /**
       * We release all dispatched `SyntheticEvent`s after each event loop, adding
       * them back into the pool. This allows a way to hold onto a reference that
       * won't be added back into the pool.
       */
      persist: function() {
      },
      /**
       * Checks if this event should be released back into the pool.
       *
       * @return {boolean} True if this should not be released, false otherwise.
       */
      isPersistent: JE
    }), t;
  }
  var uo = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, wd = hr(uo), Fl = Je({}, uo, {
    view: 0,
    detail: 0
  }), G1 = hr(Fl), Gd, Hd, Yl;
  function H1(e) {
    e !== Yl && (Yl && e.type === "mousemove" ? (Gd = e.screenX - Yl.screenX, Hd = e.screenY - Yl.screenY) : (Gd = 0, Hd = 0), Yl = e);
  }
  var zE = Je({}, Fl, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Fd,
    button: 0,
    buttons: 0,
    relatedTarget: function(e) {
      return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
    },
    movementX: function(e) {
      return "movementX" in e ? e.movementX : (H1(e), Gd);
    },
    movementY: function(e) {
      return "movementY" in e ? e.movementY : Hd;
    }
  }), EN = hr(zE), B1 = Je({}, zE, {
    dataTransfer: 0
  }), F1 = hr(B1), Y1 = Je({}, Fl, {
    relatedTarget: 0
  }), Bd = hr(Y1), V1 = Je({}, uo, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), W1 = hr(V1), k1 = Je({}, uo, {
    clipboardData: function(e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    }
  }), X1 = hr(k1), j1 = Je({}, uo, {
    data: 0
  }), cN = hr(j1), K1 = cN, J1 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, z1 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  };
  function Z1(e) {
    if (e.key) {
      var t = J1[e.key] || e.key;
      if (t !== "Unidentified")
        return t;
    }
    if (e.type === "keypress") {
      var r = KE(e);
      return r === 13 ? "Enter" : String.fromCharCode(r);
    }
    return e.type === "keydown" || e.type === "keyup" ? z1[e.keyCode] || "Unidentified" : "";
  }
  var q1 = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Q1(e) {
    var t = this, r = t.nativeEvent;
    if (r.getModifierState)
      return r.getModifierState(e);
    var i = q1[e];
    return i ? !!r[i] : !1;
  }
  function Fd(e) {
    return Q1;
  }
  var $1 = Je({}, Fl, {
    key: Z1,
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Fd,
    // Legacy Interface
    charCode: function(e) {
      return e.type === "keypress" ? KE(e) : 0;
    },
    keyCode: function(e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function(e) {
      return e.type === "keypress" ? KE(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    }
  }), ey = hr($1), ty = Je({}, zE, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), fN = hr(ty), ny = Je({}, Fl, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Fd
  }), ry = hr(ny), ay = Je({}, uo, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), iy = hr(ay), sy = Je({}, zE, {
    deltaX: function(e) {
      return "deltaX" in e ? e.deltaX : (
        // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
        "wheelDeltaX" in e ? -e.wheelDeltaX : 0
      );
    },
    deltaY: function(e) {
      return "deltaY" in e ? e.deltaY : (
        // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
        "wheelDeltaY" in e ? -e.wheelDeltaY : (
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          "wheelDelta" in e ? -e.wheelDelta : 0
        )
      );
    },
    deltaZ: 0,
    // Browsers without "deltaMode" is reporting in raw wheel delta where one
    // notch on the scroll is always +/- 120, roughly equivalent to pixels.
    // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
    // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
    deltaMode: 0
  }), oy = hr(sy), ly = [9, 13, 27, 32], TN = 229, Yd = Jt && "CompositionEvent" in window, Vl = null;
  Jt && "documentMode" in document && (Vl = document.documentMode);
  var uy = Jt && "TextEvent" in window && !Vl, dN = Jt && (!Yd || Vl && Vl > 8 && Vl <= 11), AN = 32, RN = String.fromCharCode(AN);
  function Ey() {
    en("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), en("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), en("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), en("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
  }
  var pN = !1;
  function cy(e) {
    return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
    !(e.ctrlKey && e.altKey);
  }
  function fy(e) {
    switch (e) {
      case "compositionstart":
        return "onCompositionStart";
      case "compositionend":
        return "onCompositionEnd";
      case "compositionupdate":
        return "onCompositionUpdate";
    }
  }
  function Ty(e, t) {
    return e === "keydown" && t.keyCode === TN;
  }
  function SN(e, t) {
    switch (e) {
      case "keyup":
        return ly.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== TN;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function hN(e) {
    var t = e.detail;
    return typeof t == "object" && "data" in t ? t.data : null;
  }
  function NN(e) {
    return e.locale === "ko";
  }
  var Eo = !1;
  function dy(e, t, r, i, l) {
    var f, A;
    if (Yd ? f = fy(t) : Eo ? SN(t, i) && (f = "onCompositionEnd") : Ty(t, i) && (f = "onCompositionStart"), !f)
      return null;
    dN && !NN(i) && (!Eo && f === "onCompositionStart" ? Eo = x1(l) : f === "onCompositionEnd" && Eo && (A = oN()));
    var h = ec(r, f);
    if (h.length > 0) {
      var I = new cN(f, t, null, i, l);
      if (e.push({
        event: I,
        listeners: h
      }), A)
        I.data = A;
      else {
        var L = hN(i);
        L !== null && (I.data = L);
      }
    }
  }
  function Ay(e, t) {
    switch (e) {
      case "compositionend":
        return hN(t);
      case "keypress":
        var r = t.which;
        return r !== AN ? null : (pN = !0, RN);
      case "textInput":
        var i = t.data;
        return i === RN && pN ? null : i;
      default:
        return null;
    }
  }
  function Ry(e, t) {
    if (Eo) {
      if (e === "compositionend" || !Yd && SN(e, t)) {
        var r = oN();
        return w1(), Eo = !1, r;
      }
      return null;
    }
    switch (e) {
      case "paste":
        return null;
      case "keypress":
        if (!cy(t)) {
          if (t.char && t.char.length > 1)
            return t.char;
          if (t.which)
            return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return dN && !NN(t) ? null : t.data;
      default:
        return null;
    }
  }
  function py(e, t, r, i, l) {
    var f;
    if (uy ? f = Ay(t, i) : f = Ry(t, i), !f)
      return null;
    var A = ec(r, "onBeforeInput");
    if (A.length > 0) {
      var h = new K1("onBeforeInput", "beforeinput", null, i, l);
      e.push({
        event: h,
        listeners: A
      }), h.data = f;
    }
  }
  function Sy(e, t, r, i, l, f, A) {
    dy(e, t, r, i, l), py(e, t, r, i, l);
  }
  var hy = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function ON(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t === "input" ? !!hy[e.type] : t === "textarea";
  }
  /**
   * Checks if an event is supported in the current execution environment.
   *
   * NOTE: This will not work correctly for non-generic events such as `change`,
   * `reset`, `load`, `error`, and `select`.
   *
   * Borrows from Modernizr.
   *
   * @param {string} eventNameSuffix Event name, e.g. "click".
   * @return {boolean} True if the event is supported.
   * @internal
   * @license Modernizr 3.0.0pre (Custom Build) | MIT
   */
  function Ny(e) {
    if (!Jt)
      return !1;
    var t = "on" + e, r = t in document;
    if (!r) {
      var i = document.createElement("div");
      i.setAttribute(t, "return;"), r = typeof i[t] == "function";
    }
    return r;
  }
  function Oy() {
    en("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
  }
  function IN(e, t, r, i) {
    Oh(i);
    var l = ec(t, "onChange");
    if (l.length > 0) {
      var f = new wd("onChange", "change", null, r, i);
      e.push({
        event: f,
        listeners: l
      });
    }
  }
  var Wl = null, kl = null;
  function Iy(e) {
    var t = e.nodeName && e.nodeName.toLowerCase();
    return t === "select" || t === "input" && e.type === "file";
  }
  function _y(e) {
    var t = [];
    IN(t, kl, e, VT(e)), mh(Cy, t);
  }
  function Cy(e) {
    FN(e, 0);
  }
  function ZE(e) {
    var t = po(e);
    if (Ks(t))
      return e;
  }
  function my(e, t) {
    if (e === "change")
      return t;
  }
  var _N = !1;
  Jt && (_N = Ny("input") && (!document.documentMode || document.documentMode > 9));
  function vy(e, t) {
    Wl = e, kl = t, Wl.attachEvent("onpropertychange", mN);
  }
  function CN() {
    Wl && (Wl.detachEvent("onpropertychange", mN), Wl = null, kl = null);
  }
  function mN(e) {
    e.propertyName === "value" && ZE(kl) && _y(e);
  }
  function Ly(e, t, r) {
    e === "focusin" ? (CN(), vy(t, r)) : e === "focusout" && CN();
  }
  function yy(e, t) {
    if (e === "selectionchange" || e === "keyup" || e === "keydown")
      return ZE(kl);
  }
  function gy(e) {
    var t = e.nodeName;
    return t && t.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
  }
  function Dy(e, t) {
    if (e === "click")
      return ZE(t);
  }
  function by(e, t) {
    if (e === "input" || e === "change")
      return ZE(t);
  }
  function My(e) {
    var t = e._wrapperState;
    !t || !t.controlled || e.type !== "number" || xe(e, "number", e.value);
  }
  function Py(e, t, r, i, l, f, A) {
    var h = r ? po(r) : window, I, L;
    if (Iy(h) ? I = my : ON(h) ? _N ? I = by : (I = yy, L = Ly) : gy(h) && (I = Dy), I) {
      var b = I(t, r);
      if (b) {
        IN(e, b, i, l);
        return;
      }
    }
    L && L(t, h, r), t === "focusout" && My(h);
  }
  function Uy() {
    dn("onMouseEnter", ["mouseout", "mouseover"]), dn("onMouseLeave", ["mouseout", "mouseover"]), dn("onPointerEnter", ["pointerout", "pointerover"]), dn("onPointerLeave", ["pointerout", "pointerover"]);
  }
  function xy(e, t, r, i, l, f, A) {
    var h = t === "mouseover" || t === "pointerover", I = t === "mouseout" || t === "pointerout";
    if (h && !O0(i)) {
      var L = i.relatedTarget || i.fromElement;
      if (L && (Ts(L) || iu(L)))
        return;
    }
    if (!(!I && !h)) {
      var b;
      if (l.window === l)
        b = l;
      else {
        var k = l.ownerDocument;
        k ? b = k.defaultView || k.parentWindow : b = window;
      }
      var W, q;
      if (I) {
        var Q = i.relatedTarget || i.toElement;
        if (W = r, q = Q ? Ts(Q) : null, q !== null) {
          var re = ls(q);
          (q !== re || q.tag !== v && q.tag !== M) && (q = null);
        }
      } else
        W = null, q = r;
      if (W !== q) {
        var Ne = EN, ye = "onMouseLeave", me = "onMouseEnter", Qe = "mouse";
        (t === "pointerout" || t === "pointerover") && (Ne = fN, ye = "onPointerLeave", me = "onPointerEnter", Qe = "pointer");
        var Xe = W == null ? b : po(W), K = q == null ? b : po(q), ae = new Ne(ye, Qe + "leave", W, i, l);
        ae.target = Xe, ae.relatedTarget = K;
        var J = null, ce = Ts(l);
        if (ce === r) {
          var Oe = new Ne(me, Qe + "enter", q, i, l);
          Oe.target = K, Oe.relatedTarget = Xe, J = Oe;
        }
        ig(e, ae, J, W, q);
      }
    }
  }
  function wy(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
  }
  var Nr = typeof Object.is == "function" ? Object.is : wy;
  function Xl(e, t) {
    if (Nr(e, t))
      return !0;
    if (typeof e != "object" || e === null || typeof t != "object" || t === null)
      return !1;
    var r = Object.keys(e), i = Object.keys(t);
    if (r.length !== i.length)
      return !1;
    for (var l = 0; l < r.length; l++) {
      var f = r[l];
      if (!wn.call(t, f) || !Nr(e[f], t[f]))
        return !1;
    }
    return !0;
  }
  function vN(e) {
    for (; e && e.firstChild; )
      e = e.firstChild;
    return e;
  }
  function Gy(e) {
    for (; e; ) {
      if (e.nextSibling)
        return e.nextSibling;
      e = e.parentNode;
    }
  }
  function LN(e, t) {
    for (var r = vN(e), i = 0, l = 0; r; ) {
      if (r.nodeType === xa) {
        if (l = i + r.textContent.length, i <= t && l >= t)
          return {
            node: r,
            offset: t - i
          };
        i = l;
      }
      r = vN(Gy(r));
    }
  }
  function Hy(e) {
    var t = e.ownerDocument, r = t && t.defaultView || window, i = r.getSelection && r.getSelection();
    if (!i || i.rangeCount === 0)
      return null;
    var l = i.anchorNode, f = i.anchorOffset, A = i.focusNode, h = i.focusOffset;
    try {
      l.nodeType, A.nodeType;
    } catch {
      return null;
    }
    return By(e, l, f, A, h);
  }
  function By(e, t, r, i, l) {
    var f = 0, A = -1, h = -1, I = 0, L = 0, b = e, k = null;
    e:
      for (; ; ) {
        for (var W = null; b === t && (r === 0 || b.nodeType === xa) && (A = f + r), b === i && (l === 0 || b.nodeType === xa) && (h = f + l), b.nodeType === xa && (f += b.nodeValue.length), (W = b.firstChild) !== null; )
          k = b, b = W;
        for (; ; ) {
          if (b === e)
            break e;
          if (k === t && ++I === r && (A = f), k === i && ++L === l && (h = f), (W = b.nextSibling) !== null)
            break;
          b = k, k = b.parentNode;
        }
        b = W;
      }
    return A === -1 || h === -1 ? null : {
      start: A,
      end: h
    };
  }
  function Fy(e, t) {
    var r = e.ownerDocument || document, i = r && r.defaultView || window;
    if (i.getSelection) {
      var l = i.getSelection(), f = e.textContent.length, A = Math.min(t.start, f), h = t.end === void 0 ? A : Math.min(t.end, f);
      if (!l.extend && A > h) {
        var I = h;
        h = A, A = I;
      }
      var L = LN(e, A), b = LN(e, h);
      if (L && b) {
        if (l.rangeCount === 1 && l.anchorNode === L.node && l.anchorOffset === L.offset && l.focusNode === b.node && l.focusOffset === b.offset)
          return;
        var k = r.createRange();
        k.setStart(L.node, L.offset), l.removeAllRanges(), A > h ? (l.addRange(k), l.extend(b.node, b.offset)) : (k.setEnd(b.node, b.offset), l.addRange(k));
      }
    }
  }
  function yN(e) {
    return e && e.nodeType === xa;
  }
  function gN(e, t) {
    return !e || !t ? !1 : e === t ? !0 : yN(e) ? !1 : yN(t) ? gN(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1;
  }
  function Yy(e) {
    return e && e.ownerDocument && gN(e.ownerDocument.documentElement, e);
  }
  function Vy(e) {
    try {
      return typeof e.contentWindow.location.href == "string";
    } catch {
      return !1;
    }
  }
  function DN() {
    for (var e = window, t = ci(); t instanceof e.HTMLIFrameElement; ) {
      if (Vy(t))
        e = t.contentWindow;
      else
        return t;
      t = ci(e.document);
    }
    return t;
  }
  function Vd(e) {
    var t = e && e.nodeName && e.nodeName.toLowerCase();
    return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
  }
  function Wy() {
    var e = DN();
    return {
      focusedElem: e,
      selectionRange: Vd(e) ? Xy(e) : null
    };
  }
  function ky(e) {
    var t = DN(), r = e.focusedElem, i = e.selectionRange;
    if (t !== r && Yy(r)) {
      i !== null && Vd(r) && jy(r, i);
      for (var l = [], f = r; f = f.parentNode; )
        f.nodeType === or && l.push({
          element: f,
          left: f.scrollLeft,
          top: f.scrollTop
        });
      typeof r.focus == "function" && r.focus();
      for (var A = 0; A < l.length; A++) {
        var h = l[A];
        h.element.scrollLeft = h.left, h.element.scrollTop = h.top;
      }
    }
  }
  function Xy(e) {
    var t;
    return "selectionStart" in e ? t = {
      start: e.selectionStart,
      end: e.selectionEnd
    } : t = Hy(e), t || {
      start: 0,
      end: 0
    };
  }
  function jy(e, t) {
    var r = t.start, i = t.end;
    i === void 0 && (i = r), "selectionStart" in e ? (e.selectionStart = r, e.selectionEnd = Math.min(i, e.value.length)) : Fy(e, t);
  }
  var Ky = Jt && "documentMode" in document && document.documentMode <= 11;
  function Jy() {
    en("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
  }
  var co = null, Wd = null, jl = null, kd = !1;
  function zy(e) {
    if ("selectionStart" in e && Vd(e))
      return {
        start: e.selectionStart,
        end: e.selectionEnd
      };
    var t = e.ownerDocument && e.ownerDocument.defaultView || window, r = t.getSelection();
    return {
      anchorNode: r.anchorNode,
      anchorOffset: r.anchorOffset,
      focusNode: r.focusNode,
      focusOffset: r.focusOffset
    };
  }
  function Zy(e) {
    return e.window === e ? e.document : e.nodeType === wa ? e : e.ownerDocument;
  }
  function bN(e, t, r) {
    var i = Zy(r);
    if (!(kd || co == null || co !== ci(i))) {
      var l = zy(co);
      if (!jl || !Xl(jl, l)) {
        jl = l;
        var f = ec(Wd, "onSelect");
        if (f.length > 0) {
          var A = new wd("onSelect", "select", null, t, r);
          e.push({
            event: A,
            listeners: f
          }), A.target = co;
        }
      }
    }
  }
  function qy(e, t, r, i, l, f, A) {
    var h = r ? po(r) : window;
    switch (t) {
      case "focusin":
        (ON(h) || h.contentEditable === "true") && (co = h, Wd = r, jl = null);
        break;
      case "focusout":
        co = null, Wd = null, jl = null;
        break;
      case "mousedown":
        kd = !0;
        break;
      case "contextmenu":
      case "mouseup":
      case "dragend":
        kd = !1, bN(e, i, l);
        break;
      case "selectionchange":
        if (Ky)
          break;
      case "keydown":
      case "keyup":
        bN(e, i, l);
    }
  }
  function qE(e, t) {
    var r = {};
    return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit" + e] = "webkit" + t, r["Moz" + e] = "moz" + t, r;
  }
  var fo = {
    animationend: qE("Animation", "AnimationEnd"),
    animationiteration: qE("Animation", "AnimationIteration"),
    animationstart: qE("Animation", "AnimationStart"),
    transitionend: qE("Transition", "TransitionEnd")
  }, Xd = {}, MN = {};
  Jt && (MN = document.createElement("div").style, "AnimationEvent" in window || (delete fo.animationend.animation, delete fo.animationiteration.animation, delete fo.animationstart.animation), "TransitionEvent" in window || delete fo.transitionend.transition);
  function QE(e) {
    if (Xd[e])
      return Xd[e];
    if (!fo[e])
      return e;
    var t = fo[e];
    for (var r in t)
      if (t.hasOwnProperty(r) && r in MN)
        return Xd[e] = t[r];
    return e;
  }
  var PN = QE("animationend"), UN = QE("animationiteration"), xN = QE("animationstart"), wN = QE("transitionend"), GN = /* @__PURE__ */ new Map(), HN = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
  function Oi(e, t) {
    GN.set(e, t), en(t, [e]);
  }
  function Qy() {
    for (var e = 0; e < HN.length; e++) {
      var t = HN[e], r = t.toLowerCase(), i = t[0].toUpperCase() + t.slice(1);
      Oi(r, "on" + i);
    }
    Oi(PN, "onAnimationEnd"), Oi(UN, "onAnimationIteration"), Oi(xN, "onAnimationStart"), Oi("dblclick", "onDoubleClick"), Oi("focusin", "onFocus"), Oi("focusout", "onBlur"), Oi(wN, "onTransitionEnd");
  }
  function $y(e, t, r, i, l, f, A) {
    var h = GN.get(t);
    if (h !== void 0) {
      var I = wd, L = t;
      switch (t) {
        case "keypress":
          if (KE(i) === 0)
            return;
        case "keydown":
        case "keyup":
          I = ey;
          break;
        case "focusin":
          L = "focus", I = Bd;
          break;
        case "focusout":
          L = "blur", I = Bd;
          break;
        case "beforeblur":
        case "afterblur":
          I = Bd;
          break;
        case "click":
          if (i.button === 2)
            return;
        case "auxclick":
        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          I = EN;
          break;
        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          I = F1;
          break;
        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          I = ry;
          break;
        case PN:
        case UN:
        case xN:
          I = W1;
          break;
        case wN:
          I = iy;
          break;
        case "scroll":
          I = G1;
          break;
        case "wheel":
          I = oy;
          break;
        case "copy":
        case "cut":
        case "paste":
          I = X1;
          break;
        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          I = fN;
          break;
      }
      var b = (f & Sl) !== 0;
      {
        var k = !b && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        t === "scroll", W = rg(r, h, i.type, b, k);
        if (W.length > 0) {
          var q = new I(h, L, null, i, l);
          e.push({
            event: q,
            listeners: W
          });
        }
      }
    }
  }
  Qy(), Uy(), Oy(), Jy(), Ey();
  function eg(e, t, r, i, l, f, A) {
    $y(e, t, r, i, l, f);
    var h = (f & S0) === 0;
    h && (xy(e, t, r, i, l), Py(e, t, r, i, l), qy(e, t, r, i, l), Sy(e, t, r, i, l));
  }
  var Kl = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], jd = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(Kl));
  function BN(e, t, r) {
    var i = e.type || "unknown-event";
    e.currentTarget = r, D0(i, t, void 0, e), e.currentTarget = null;
  }
  function tg(e, t, r) {
    var i;
    if (r)
      for (var l = t.length - 1; l >= 0; l--) {
        var f = t[l], A = f.instance, h = f.currentTarget, I = f.listener;
        if (A !== i && e.isPropagationStopped())
          return;
        BN(e, I, h), i = A;
      }
    else
      for (var L = 0; L < t.length; L++) {
        var b = t[L], k = b.instance, W = b.currentTarget, q = b.listener;
        if (k !== i && e.isPropagationStopped())
          return;
        BN(e, q, W), i = k;
      }
  }
  function FN(e, t) {
    for (var r = (t & Sl) !== 0, i = 0; i < e.length; i++) {
      var l = e[i], f = l.event, A = l.listeners;
      tg(f, A, r);
    }
    b0();
  }
  function ng(e, t, r, i, l) {
    var f = VT(r), A = [];
    eg(A, e, i, r, f, t), FN(A, t);
  }
  function Mt(e, t) {
    jd.has(e) || u('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
    var r = !1, i = MD(t), l = sg(e, r);
    i.has(l) || (YN(t, e, YT, r), i.add(l));
  }
  function Kd(e, t, r) {
    jd.has(e) && !t && u('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
    var i = 0;
    t && (i |= Sl), YN(r, e, i, t);
  }
  var $E = "_reactListening" + Math.random().toString(36).slice(2);
  function Jl(e) {
    if (!e[$E]) {
      e[$E] = !0, Kt.forEach(function(r) {
        r !== "selectionchange" && (jd.has(r) || Kd(r, !1, e), Kd(r, !0, e));
      });
      var t = e.nodeType === wa ? e : e.ownerDocument;
      t !== null && (t[$E] || (t[$E] = !0, Kd("selectionchange", !1, t)));
    }
  }
  function YN(e, t, r, i, l) {
    var f = L1(e, t, r), A = void 0;
    XT && (t === "touchstart" || t === "touchmove" || t === "wheel") && (A = !0), e = e, i ? A !== void 0 ? P1(e, t, f, A) : M1(e, t, f) : A !== void 0 ? U1(e, t, f, A) : b1(e, t, f);
  }
  function VN(e, t) {
    return e === t || e.nodeType === zt && e.parentNode === t;
  }
  function Jd(e, t, r, i, l) {
    var f = i;
    if (!(t & hh) && !(t & YT)) {
      var A = l;
      if (i !== null) {
        var h = i;
        e:
          for (; ; ) {
            if (h === null)
              return;
            var I = h.tag;
            if (I === N || I === m) {
              var L = h.stateNode.containerInfo;
              if (VN(L, A))
                break;
              if (I === m)
                for (var b = h.return; b !== null; ) {
                  var k = b.tag;
                  if (k === N || k === m) {
                    var W = b.stateNode.containerInfo;
                    if (VN(W, A))
                      return;
                  }
                  b = b.return;
                }
              for (; L !== null; ) {
                var q = Ts(L);
                if (q === null)
                  return;
                var Q = q.tag;
                if (Q === v || Q === M) {
                  h = f = q;
                  continue e;
                }
                L = L.parentNode;
              }
            }
            h = h.return;
          }
      }
    }
    mh(function() {
      return ng(e, t, r, f);
    });
  }
  function zl(e, t, r) {
    return {
      instance: e,
      listener: t,
      currentTarget: r
    };
  }
  function rg(e, t, r, i, l, f) {
    for (var A = t !== null ? t + "Capture" : null, h = i ? A : t, I = [], L = e, b = null; L !== null; ) {
      var k = L, W = k.stateNode, q = k.tag;
      if (q === v && W !== null && (b = W, h !== null)) {
        var Q = Nl(L, h);
        Q != null && I.push(zl(L, Q, b));
      }
      if (l)
        break;
      L = L.return;
    }
    return I;
  }
  function ec(e, t) {
    for (var r = t + "Capture", i = [], l = e; l !== null; ) {
      var f = l, A = f.stateNode, h = f.tag;
      if (h === v && A !== null) {
        var I = A, L = Nl(l, r);
        L != null && i.unshift(zl(l, L, I));
        var b = Nl(l, t);
        b != null && i.push(zl(l, b, I));
      }
      l = l.return;
    }
    return i;
  }
  function To(e) {
    if (e === null)
      return null;
    do
      e = e.return;
    while (e && e.tag !== v);
    return e || null;
  }
  function ag(e, t) {
    for (var r = e, i = t, l = 0, f = r; f; f = To(f))
      l++;
    for (var A = 0, h = i; h; h = To(h))
      A++;
    for (; l - A > 0; )
      r = To(r), l--;
    for (; A - l > 0; )
      i = To(i), A--;
    for (var I = l; I--; ) {
      if (r === i || i !== null && r === i.alternate)
        return r;
      r = To(r), i = To(i);
    }
    return null;
  }
  function WN(e, t, r, i, l) {
    for (var f = t._reactName, A = [], h = r; h !== null && h !== i; ) {
      var I = h, L = I.alternate, b = I.stateNode, k = I.tag;
      if (L !== null && L === i)
        break;
      if (k === v && b !== null) {
        var W = b;
        if (l) {
          var q = Nl(h, f);
          q != null && A.unshift(zl(h, q, W));
        } else if (!l) {
          var Q = Nl(h, f);
          Q != null && A.push(zl(h, Q, W));
        }
      }
      h = h.return;
    }
    A.length !== 0 && e.push({
      event: t,
      listeners: A
    });
  }
  function ig(e, t, r, i, l) {
    var f = i && l ? ag(i, l) : null;
    i !== null && WN(e, t, i, f, !1), l !== null && r !== null && WN(e, r, l, f, !0);
  }
  function sg(e, t) {
    return e + "__" + (t ? "capture" : "bubble");
  }
  var lr = !1, Zl = "dangerouslySetInnerHTML", tc = "suppressContentEditableWarning", Ii = "suppressHydrationWarning", kN = "autoFocus", cs = "children", fs = "style", nc = "__html", zd, rc, ql, XN, ac, jN, KN;
  zd = {
    // There are working polyfills for <dialog>. Let people use it.
    dialog: !0,
    // Electron ships a custom <webview> tag to display external web content in
    // an isolated frame and {}.
    // This tag is not present in non Electron environments such as JSDom which
    // is often used for testing purposes.
    // @see https://electronjs.org/docs/api/webview-tag
    webview: !0
  }, rc = function(e, t) {
    c0(e, t), f0(e, t), p0(e, t, {
      registrationNameDependencies: ot,
      possibleRegistrationNames: xt
    });
  }, jN = Jt && !document.documentMode, ql = function(e, t, r) {
    if (!lr) {
      var i = ic(r), l = ic(t);
      l !== i && (lr = !0, u("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(l), JSON.stringify(i)));
    }
  }, XN = function(e) {
    if (!lr) {
      lr = !0;
      var t = [];
      e.forEach(function(r) {
        t.push(r);
      }), u("Extra attributes from the server: %s", t);
    }
  }, ac = function(e, t) {
    t === !1 ? u("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : u("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof t);
  }, KN = function(e, t) {
    var r = e.namespaceURI === Ua ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
    return r.innerHTML = t, r.innerHTML;
  };
  var og = /\r\n?/g, lg = /\u0000|\uFFFD/g;
  function ic(e) {
    yr(e);
    var t = typeof e == "string" ? e : "" + e;
    return t.replace(og, `
`).replace(lg, "");
  }
  function sc(e, t, r, i) {
    var l = ic(t), f = ic(e);
    if (f !== l && (i && (lr || (lr = !0, u('Text content did not match. Server: "%s" Client: "%s"', f, l))), r && ne))
      throw new Error("Text content does not match server-rendered HTML.");
  }
  function JN(e) {
    return e.nodeType === wa ? e : e.ownerDocument;
  }
  function ug() {
  }
  function oc(e) {
    e.onclick = ug;
  }
  function Eg(e, t, r, i, l) {
    for (var f in i)
      if (i.hasOwnProperty(f)) {
        var A = i[f];
        if (f === fs)
          A && Object.freeze(A), Th(t, A);
        else if (f === Zl) {
          var h = A ? A[nc] : void 0;
          h != null && lh(t, h);
        } else if (f === cs)
          if (typeof A == "string") {
            var I = e !== "textarea" || A !== "";
            I && gE(t, A);
          } else
            typeof A == "number" && gE(t, "" + A);
        else
          f === tc || f === Ii || f === kN || (ot.hasOwnProperty(f) ? A != null && (typeof A != "function" && ac(f, A), f === "onScroll" && Mt("scroll", t)) : A != null && Da(t, f, A, l));
      }
  }
  function cg(e, t, r, i) {
    for (var l = 0; l < t.length; l += 2) {
      var f = t[l], A = t[l + 1];
      f === fs ? Th(e, A) : f === Zl ? lh(e, A) : f === cs ? gE(e, A) : Da(e, f, A, i);
    }
  }
  function fg(e, t, r, i) {
    var l, f = JN(r), A, h = i;
    if (h === Ua && (h = xT(e)), h === Ua) {
      if (l = rs(e, t), !l && e !== e.toLowerCase() && u("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
        var I = f.createElement("div");
        I.innerHTML = "<script><\/script>";
        var L = I.firstChild;
        A = I.removeChild(L);
      } else if (typeof t.is == "string")
        A = f.createElement(e, {
          is: t.is
        });
      else if (A = f.createElement(e), e === "select") {
        var b = A;
        t.multiple ? b.multiple = !0 : t.size && (b.size = t.size);
      }
    } else
      A = f.createElementNS(h, e);
    return h === Ua && !l && Object.prototype.toString.call(A) === "[object HTMLUnknownElement]" && !wn.call(zd, e) && (zd[e] = !0, u("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), A;
  }
  function Tg(e, t) {
    return JN(t).createTextNode(e);
  }
  function dg(e, t, r, i) {
    var l = rs(t, r);
    rc(t, r);
    var f;
    switch (t) {
      case "dialog":
        Mt("cancel", e), Mt("close", e), f = r;
        break;
      case "iframe":
      case "object":
      case "embed":
        Mt("load", e), f = r;
        break;
      case "video":
      case "audio":
        for (var A = 0; A < Kl.length; A++)
          Mt(Kl[A], e);
        f = r;
        break;
      case "source":
        Mt("error", e), f = r;
        break;
      case "img":
      case "image":
      case "link":
        Mt("error", e), Mt("load", e), f = r;
        break;
      case "details":
        Mt("toggle", e), f = r;
        break;
      case "input":
        H(e, r), f = C(e, r), Mt("invalid", e);
        break;
      case "option":
        It(e, r), f = r;
        break;
      case "select":
        Rl(e, r), f = Al(e, r), Mt("invalid", e);
        break;
      case "textarea":
        ih(e, r), f = PT(e, r), Mt("invalid", e);
        break;
      default:
        f = r;
    }
    switch (FT(t, f), Eg(t, e, i, f, l), t) {
      case "input":
        Ma(e), Te(e, r, !1);
        break;
      case "textarea":
        Ma(e), oh(e);
        break;
      case "option":
        bt(e, r);
        break;
      case "select":
        MT(e, r);
        break;
      default:
        typeof f.onClick == "function" && oc(e);
        break;
    }
  }
  function Ag(e, t, r, i, l) {
    rc(t, i);
    var f = null, A, h;
    switch (t) {
      case "input":
        A = C(e, r), h = C(e, i), f = [];
        break;
      case "select":
        A = Al(e, r), h = Al(e, i), f = [];
        break;
      case "textarea":
        A = PT(e, r), h = PT(e, i), f = [];
        break;
      default:
        A = r, h = i, typeof A.onClick != "function" && typeof h.onClick == "function" && oc(e);
        break;
    }
    FT(t, h);
    var I, L, b = null;
    for (I in A)
      if (!(h.hasOwnProperty(I) || !A.hasOwnProperty(I) || A[I] == null))
        if (I === fs) {
          var k = A[I];
          for (L in k)
            k.hasOwnProperty(L) && (b || (b = {}), b[L] = "");
        } else
          I === Zl || I === cs || I === tc || I === Ii || I === kN || (ot.hasOwnProperty(I) ? f || (f = []) : (f = f || []).push(I, null));
    for (I in h) {
      var W = h[I], q = A != null ? A[I] : void 0;
      if (!(!h.hasOwnProperty(I) || W === q || W == null && q == null))
        if (I === fs)
          if (W && Object.freeze(W), q) {
            for (L in q)
              q.hasOwnProperty(L) && (!W || !W.hasOwnProperty(L)) && (b || (b = {}), b[L] = "");
            for (L in W)
              W.hasOwnProperty(L) && q[L] !== W[L] && (b || (b = {}), b[L] = W[L]);
          } else
            b || (f || (f = []), f.push(I, b)), b = W;
        else if (I === Zl) {
          var Q = W ? W[nc] : void 0, re = q ? q[nc] : void 0;
          Q != null && re !== Q && (f = f || []).push(I, Q);
        } else
          I === cs ? (typeof W == "string" || typeof W == "number") && (f = f || []).push(I, "" + W) : I === tc || I === Ii || (ot.hasOwnProperty(I) ? (W != null && (typeof W != "function" && ac(I, W), I === "onScroll" && Mt("scroll", e)), !f && q !== W && (f = [])) : (f = f || []).push(I, W));
    }
    return b && (r0(b, h[fs]), (f = f || []).push(fs, b)), f;
  }
  function Rg(e, t, r, i, l) {
    r === "input" && l.type === "radio" && l.name != null && $(e, l);
    var f = rs(r, i), A = rs(r, l);
    switch (cg(e, t, f, A), r) {
      case "input":
        te(e, l);
        break;
      case "textarea":
        sh(e, l);
        break;
      case "select":
        UL(e, l);
        break;
    }
  }
  function pg(e) {
    {
      var t = e.toLowerCase();
      return DE.hasOwnProperty(t) && DE[t] || null;
    }
  }
  function Sg(e, t, r, i, l, f, A) {
    var h, I;
    switch (h = rs(t, r), rc(t, r), t) {
      case "dialog":
        Mt("cancel", e), Mt("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        Mt("load", e);
        break;
      case "video":
      case "audio":
        for (var L = 0; L < Kl.length; L++)
          Mt(Kl[L], e);
        break;
      case "source":
        Mt("error", e);
        break;
      case "img":
      case "image":
      case "link":
        Mt("error", e), Mt("load", e);
        break;
      case "details":
        Mt("toggle", e);
        break;
      case "input":
        H(e, r), Mt("invalid", e);
        break;
      case "option":
        It(e, r);
        break;
      case "select":
        Rl(e, r), Mt("invalid", e);
        break;
      case "textarea":
        ih(e, r), Mt("invalid", e);
        break;
    }
    FT(t, r);
    {
      I = /* @__PURE__ */ new Set();
      for (var b = e.attributes, k = 0; k < b.length; k++) {
        var W = b[k].name.toLowerCase();
        switch (W) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            I.add(b[k].name);
        }
      }
    }
    var q = null;
    for (var Q in r)
      if (r.hasOwnProperty(Q)) {
        var re = r[Q];
        if (Q === cs)
          typeof re == "string" ? e.textContent !== re && (r[Ii] !== !0 && sc(e.textContent, re, f, A), q = [cs, re]) : typeof re == "number" && e.textContent !== "" + re && (r[Ii] !== !0 && sc(e.textContent, re, f, A), q = [cs, "" + re]);
        else if (ot.hasOwnProperty(Q))
          re != null && (typeof re != "function" && ac(Q, re), Q === "onScroll" && Mt("scroll", e));
        else if (A && // Convince Flow we've calculated it (it's DEV-only in this method.)
        typeof h == "boolean") {
          var Ne = void 0, ye = h && Et ? null : Rr(Q);
          if (r[Ii] !== !0) {
            if (!(Q === tc || Q === Ii || // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            Q === "value" || Q === "checked" || Q === "selected")) {
              if (Q === Zl) {
                var me = e.innerHTML, Qe = re ? re[nc] : void 0;
                if (Qe != null) {
                  var Xe = KN(e, Qe);
                  Xe !== me && ql(Q, me, Xe);
                }
              } else if (Q === fs) {
                if (I.delete(Q), jN) {
                  var K = t0(re);
                  Ne = e.getAttribute("style"), K !== Ne && ql(Q, Ne, K);
                }
              } else if (h && !Et)
                I.delete(Q.toLowerCase()), Ne = ai(e, Q, re), re !== Ne && ql(Q, Ne, re);
              else if (!kt(Q, ye, h) && !Nt(Q, re, ye, h)) {
                var ae = !1;
                if (ye !== null)
                  I.delete(ye.attributeName), Ne = ga(e, Q, re, ye);
                else {
                  var J = i;
                  if (J === Ua && (J = xT(t)), J === Ua)
                    I.delete(Q.toLowerCase());
                  else {
                    var ce = pg(Q);
                    ce !== null && ce !== Q && (ae = !0, I.delete(ce)), I.delete(Q);
                  }
                  Ne = ai(e, Q, re);
                }
                var Oe = Et;
                !Oe && re !== Ne && !ae && ql(Q, Ne, re);
              }
            }
          }
        }
      }
    switch (A && // $FlowFixMe - Should be inferred as not undefined.
    I.size > 0 && r[Ii] !== !0 && XN(I), t) {
      case "input":
        Ma(e), Te(e, r, !0);
        break;
      case "textarea":
        Ma(e), oh(e);
        break;
      case "select":
      case "option":
        break;
      default:
        typeof r.onClick == "function" && oc(e);
        break;
    }
    return q;
  }
  function hg(e, t, r) {
    var i = e.nodeValue !== t;
    return i;
  }
  function Zd(e, t) {
    {
      if (lr)
        return;
      lr = !0, u("Did not expect server HTML to contain a <%s> in <%s>.", t.nodeName.toLowerCase(), e.nodeName.toLowerCase());
    }
  }
  function qd(e, t) {
    {
      if (lr)
        return;
      lr = !0, u('Did not expect server HTML to contain the text node "%s" in <%s>.', t.nodeValue, e.nodeName.toLowerCase());
    }
  }
  function Qd(e, t, r) {
    {
      if (lr)
        return;
      lr = !0, u("Expected server HTML to contain a matching <%s> in <%s>.", t, e.nodeName.toLowerCase());
    }
  }
  function $d(e, t) {
    {
      if (t === "" || lr)
        return;
      lr = !0, u('Expected server HTML to contain a matching text node for "%s" in <%s>.', t, e.nodeName.toLowerCase());
    }
  }
  function Ng(e, t, r) {
    switch (t) {
      case "input":
        Pe(e, r);
        return;
      case "textarea":
        wL(e, r);
        return;
      case "select":
        xL(e, r);
        return;
    }
  }
  var Ql = function() {
  }, $l = function() {
  };
  {
    var Og = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], zN = [
      "applet",
      "caption",
      "html",
      "table",
      "td",
      "th",
      "marquee",
      "object",
      "template",
      // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
      // TODO: Distinguish by namespace here -- for <title>, including it here
      // errs on the side of fewer warnings
      "foreignObject",
      "desc",
      "title"
    ], Ig = zN.concat(["button"]), _g = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], ZN = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null
    };
    $l = function(e, t) {
      var r = Je({}, e || ZN), i = {
        tag: t
      };
      return zN.indexOf(t) !== -1 && (r.aTagInScope = null, r.buttonTagInScope = null, r.nobrTagInScope = null), Ig.indexOf(t) !== -1 && (r.pTagInButtonScope = null), Og.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (r.listItemTagAutoclosing = null, r.dlItemTagAutoclosing = null), r.current = i, t === "form" && (r.formTag = i), t === "a" && (r.aTagInScope = i), t === "button" && (r.buttonTagInScope = i), t === "nobr" && (r.nobrTagInScope = i), t === "p" && (r.pTagInButtonScope = i), t === "li" && (r.listItemTagAutoclosing = i), (t === "dd" || t === "dt") && (r.dlItemTagAutoclosing = i), r;
    };
    var Cg = function(e, t) {
      switch (t) {
        case "select":
          return e === "option" || e === "optgroup" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
        case "rp":
        case "rt":
          return _g.indexOf(t) === -1;
        case "body":
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "head":
        case "html":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return t == null;
      }
      return !0;
    }, mg = function(e, t) {
      switch (e) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t.pTagInButtonScope;
        case "form":
          return t.formTag || t.pTagInButtonScope;
        case "li":
          return t.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return t.dlItemTagAutoclosing;
        case "button":
          return t.buttonTagInScope;
        case "a":
          return t.aTagInScope;
        case "nobr":
          return t.nobrTagInScope;
      }
      return null;
    }, qN = {};
    Ql = function(e, t, r) {
      r = r || ZN;
      var i = r.current, l = i && i.tag;
      t != null && (e != null && u("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
      var f = Cg(e, l) ? null : i, A = f ? null : mg(e, r), h = f || A;
      if (h) {
        var I = h.tag, L = !!f + "|" + e + "|" + I;
        if (!qN[L]) {
          qN[L] = !0;
          var b = e, k = "";
          if (e === "#text" ? /\S/.test(t) ? b = "Text nodes" : (b = "Whitespace text nodes", k = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : b = "<" + e + ">", f) {
            var W = "";
            I === "table" && e === "tr" && (W += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), u("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", b, I, k, W);
          } else
            u("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", b, I);
        }
      }
    };
  }
  var lc = "suppressHydrationWarning", uc = "$", Ec = "/$", eu = "$?", tu = "$!", vg = "style", eA = null, tA = null;
  function Lg(e) {
    var t, r, i = e.nodeType;
    switch (i) {
      case wa:
      case GT: {
        t = i === wa ? "#document" : "#fragment";
        var l = e.documentElement;
        r = l ? l.namespaceURI : wT(null, "");
        break;
      }
      default: {
        var f = i === zt ? e.parentNode : e, A = f.namespaceURI || null;
        t = f.tagName, r = wT(A, t);
        break;
      }
    }
    {
      var h = t.toLowerCase(), I = $l(null, h);
      return {
        namespace: r,
        ancestorInfo: I
      };
    }
  }
  function yg(e, t, r) {
    {
      var i = e, l = wT(i.namespace, t), f = $l(i.ancestorInfo, t);
      return {
        namespace: l,
        ancestorInfo: f
      };
    }
  }
  function e8(e) {
    return e;
  }
  function gg(e) {
    eA = v1(), tA = Wy();
    var t = null;
    return iN(!1), t;
  }
  function Dg(e) {
    ky(tA), iN(eA), eA = null, tA = null;
  }
  function bg(e, t, r, i, l) {
    var f;
    {
      var A = i;
      if (Ql(e, null, A.ancestorInfo), typeof t.children == "string" || typeof t.children == "number") {
        var h = "" + t.children, I = $l(A.ancestorInfo, e);
        Ql(null, h, I);
      }
      f = A.namespace;
    }
    var L = fg(e, t, r, f);
    return au(l, L), uA(L, t), L;
  }
  function Mg(e, t) {
    e.appendChild(t);
  }
  function Pg(e, t, r, i, l) {
    switch (dg(e, t, r, i), t) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!r.autoFocus;
      case "img":
        return !0;
      default:
        return !1;
    }
  }
  function Ug(e, t, r, i, l, f) {
    {
      var A = f;
      if (typeof i.children != typeof r.children && (typeof i.children == "string" || typeof i.children == "number")) {
        var h = "" + i.children, I = $l(A.ancestorInfo, t);
        Ql(null, h, I);
      }
    }
    return Ag(e, t, r, i);
  }
  function nA(e, t) {
    return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  function xg(e, t, r, i) {
    {
      var l = r;
      Ql(null, e, l.ancestorInfo);
    }
    var f = Tg(e, t);
    return au(i, f), f;
  }
  function wg() {
    var e = window.event;
    return e === void 0 ? Ri : sN(e.type);
  }
  var rA = typeof setTimeout == "function" ? setTimeout : void 0, Gg = typeof clearTimeout == "function" ? clearTimeout : void 0, aA = -1, QN = typeof Promise == "function" ? Promise : void 0, Hg = typeof queueMicrotask == "function" ? queueMicrotask : typeof QN < "u" ? function(e) {
    return QN.resolve(null).then(e).catch(Bg);
  } : rA;
  function Bg(e) {
    setTimeout(function() {
      throw e;
    });
  }
  function Fg(e, t, r, i) {
    switch (t) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        r.autoFocus && e.focus();
        return;
      case "img": {
        r.src && (e.src = r.src);
        return;
      }
    }
  }
  function Yg(e, t, r, i, l, f) {
    Rg(e, t, r, i, l), uA(e, l);
  }
  function $N(e) {
    gE(e, "");
  }
  function Vg(e, t, r) {
    e.nodeValue = r;
  }
  function Wg(e, t) {
    e.appendChild(t);
  }
  function kg(e, t) {
    var r;
    e.nodeType === zt ? (r = e.parentNode, r.insertBefore(t, e)) : (r = e, r.appendChild(t));
    var i = e._reactRootContainer;
    i == null && r.onclick === null && oc(r);
  }
  function Xg(e, t, r) {
    e.insertBefore(t, r);
  }
  function jg(e, t, r) {
    e.nodeType === zt ? e.parentNode.insertBefore(t, r) : e.insertBefore(t, r);
  }
  function Kg(e, t) {
    e.removeChild(t);
  }
  function Jg(e, t) {
    e.nodeType === zt ? e.parentNode.removeChild(t) : e.removeChild(t);
  }
  function iA(e, t) {
    var r = t, i = 0;
    do {
      var l = r.nextSibling;
      if (e.removeChild(r), l && l.nodeType === zt) {
        var f = l.data;
        if (f === Ec)
          if (i === 0) {
            e.removeChild(l), Gl(t);
            return;
          } else
            i--;
        else
          (f === uc || f === eu || f === tu) && i++;
      }
      r = l;
    } while (r);
    Gl(t);
  }
  function zg(e, t) {
    e.nodeType === zt ? iA(e.parentNode, t) : e.nodeType === or && iA(e, t), Gl(e);
  }
  function Zg(e) {
    e = e;
    var t = e.style;
    typeof t.setProperty == "function" ? t.setProperty("display", "none", "important") : t.display = "none";
  }
  function qg(e) {
    e.nodeValue = "";
  }
  function Qg(e, t) {
    e = e;
    var r = t[vg], i = r != null && r.hasOwnProperty("display") ? r.display : null;
    e.style.display = HT("display", i);
  }
  function $g(e, t) {
    e.nodeValue = t;
  }
  function eD(e) {
    e.nodeType === or ? e.textContent = "" : e.nodeType === wa && e.documentElement && e.removeChild(e.documentElement);
  }
  function tD(e, t, r) {
    return e.nodeType !== or || t.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
  }
  function nD(e, t) {
    return t === "" || e.nodeType !== xa ? null : e;
  }
  function rD(e) {
    return e.nodeType !== zt ? null : e;
  }
  function eO(e) {
    return e.data === eu;
  }
  function sA(e) {
    return e.data === tu;
  }
  function aD(e) {
    var t = e.nextSibling && e.nextSibling.dataset, r, i, l;
    return t && (r = t.dgst, i = t.msg, l = t.stck), {
      message: i,
      digest: r,
      stack: l
    };
  }
  function iD(e, t) {
    e._reactRetry = t;
  }
  function cc(e) {
    for (; e != null; e = e.nextSibling) {
      var t = e.nodeType;
      if (t === or || t === xa)
        break;
      if (t === zt) {
        var r = e.data;
        if (r === uc || r === tu || r === eu)
          break;
        if (r === Ec)
          return null;
      }
    }
    return e;
  }
  function nu(e) {
    return cc(e.nextSibling);
  }
  function sD(e) {
    return cc(e.firstChild);
  }
  function oD(e) {
    return cc(e.firstChild);
  }
  function lD(e) {
    return cc(e.nextSibling);
  }
  function uD(e, t, r, i, l, f, A) {
    au(f, e), uA(e, r);
    var h;
    {
      var I = l;
      h = I.namespace;
    }
    var L = (f.mode & Ze) !== Me;
    return Sg(e, t, r, h, i, L, A);
  }
  function ED(e, t, r, i) {
    return au(r, e), r.mode & Ze, hg(e, t);
  }
  function cD(e, t) {
    au(t, e);
  }
  function fD(e) {
    for (var t = e.nextSibling, r = 0; t; ) {
      if (t.nodeType === zt) {
        var i = t.data;
        if (i === Ec) {
          if (r === 0)
            return nu(t);
          r--;
        } else
          (i === uc || i === tu || i === eu) && r++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function tO(e) {
    for (var t = e.previousSibling, r = 0; t; ) {
      if (t.nodeType === zt) {
        var i = t.data;
        if (i === uc || i === tu || i === eu) {
          if (r === 0)
            return t;
          r--;
        } else
          i === Ec && r++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function TD(e) {
    Gl(e);
  }
  function dD(e) {
    Gl(e);
  }
  function AD(e) {
    return e !== "head" && e !== "body";
  }
  function RD(e, t, r, i) {
    var l = !0;
    sc(t.nodeValue, r, i, l);
  }
  function pD(e, t, r, i, l, f) {
    if (t[lc] !== !0) {
      var A = !0;
      sc(i.nodeValue, l, f, A);
    }
  }
  function SD(e, t) {
    t.nodeType === or ? Zd(e, t) : t.nodeType === zt || qd(e, t);
  }
  function hD(e, t) {
    {
      var r = e.parentNode;
      r !== null && (t.nodeType === or ? Zd(r, t) : t.nodeType === zt || qd(r, t));
    }
  }
  function ND(e, t, r, i, l) {
    (l || t[lc] !== !0) && (i.nodeType === or ? Zd(r, i) : i.nodeType === zt || qd(r, i));
  }
  function OD(e, t, r) {
    Qd(e, t);
  }
  function ID(e, t) {
    $d(e, t);
  }
  function _D(e, t, r) {
    {
      var i = e.parentNode;
      i !== null && Qd(i, t);
    }
  }
  function CD(e, t) {
    {
      var r = e.parentNode;
      r !== null && $d(r, t);
    }
  }
  function mD(e, t, r, i, l, f) {
    (f || t[lc] !== !0) && Qd(r, i);
  }
  function vD(e, t, r, i, l) {
    (l || t[lc] !== !0) && $d(r, i);
  }
  function LD(e) {
    u("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
  }
  function yD(e) {
    Jl(e);
  }
  var Ao = Math.random().toString(36).slice(2), Ro = "__reactFiber$" + Ao, oA = "__reactProps$" + Ao, ru = "__reactContainer$" + Ao, lA = "__reactEvents$" + Ao, gD = "__reactListeners$" + Ao, DD = "__reactHandles$" + Ao;
  function bD(e) {
    delete e[Ro], delete e[oA], delete e[lA], delete e[gD], delete e[DD];
  }
  function au(e, t) {
    t[Ro] = e;
  }
  function fc(e, t) {
    t[ru] = e;
  }
  function nO(e) {
    e[ru] = null;
  }
  function iu(e) {
    return !!e[ru];
  }
  function Ts(e) {
    var t = e[Ro];
    if (t)
      return t;
    for (var r = e.parentNode; r; ) {
      if (t = r[ru] || r[Ro], t) {
        var i = t.alternate;
        if (t.child !== null || i !== null && i.child !== null)
          for (var l = tO(e); l !== null; ) {
            var f = l[Ro];
            if (f)
              return f;
            l = tO(l);
          }
        return t;
      }
      e = r, r = e.parentNode;
    }
    return null;
  }
  function _i(e) {
    var t = e[Ro] || e[ru];
    return t && (t.tag === v || t.tag === M || t.tag === G || t.tag === N) ? t : null;
  }
  function po(e) {
    if (e.tag === v || e.tag === M)
      return e.stateNode;
    throw new Error("getNodeFromInstance: Invalid argument.");
  }
  function Tc(e) {
    return e[oA] || null;
  }
  function uA(e, t) {
    e[oA] = t;
  }
  function MD(e) {
    var t = e[lA];
    return t === void 0 && (t = e[lA] = /* @__PURE__ */ new Set()), t;
  }
  var rO = {}, aO = s.ReactDebugCurrentFrame;
  function dc(e) {
    if (e) {
      var t = e._owner, r = li(e.type, e._source, t ? t.type : null);
      aO.setExtraStackFrame(r);
    } else
      aO.setExtraStackFrame(null);
  }
  function Jr(e, t, r, i, l) {
    {
      var f = Function.call.bind(wn);
      for (var A in e)
        if (f(e, A)) {
          var h = void 0;
          try {
            if (typeof e[A] != "function") {
              var I = Error((i || "React class") + ": " + r + " type `" + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[A] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw I.name = "Invariant Violation", I;
            }
            h = e[A](t, A, i, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (L) {
            h = L;
          }
          h && !(h instanceof Error) && (dc(l), u("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", r, A, typeof h), dc(null)), h instanceof Error && !(h.message in rO) && (rO[h.message] = !0, dc(l), u("Failed %s type: %s", r, h.message), dc(null));
        }
    }
  }
  var EA = [], Ac;
  Ac = [];
  var Va = -1;
  function Ci(e) {
    return {
      current: e
    };
  }
  function Fn(e, t) {
    if (Va < 0) {
      u("Unexpected pop.");
      return;
    }
    t !== Ac[Va] && u("Unexpected Fiber popped."), e.current = EA[Va], EA[Va] = null, Ac[Va] = null, Va--;
  }
  function Yn(e, t, r) {
    Va++, EA[Va] = e.current, Ac[Va] = r, e.current = t;
  }
  var cA;
  cA = {};
  var Or = {};
  Object.freeze(Or);
  var Wa = Ci(Or), Ta = Ci(!1), fA = Or;
  function So(e, t, r) {
    return r && da(t) ? fA : Wa.current;
  }
  function iO(e, t, r) {
    {
      var i = e.stateNode;
      i.__reactInternalMemoizedUnmaskedChildContext = t, i.__reactInternalMemoizedMaskedChildContext = r;
    }
  }
  function ho(e, t) {
    {
      var r = e.type, i = r.contextTypes;
      if (!i)
        return Or;
      var l = e.stateNode;
      if (l && l.__reactInternalMemoizedUnmaskedChildContext === t)
        return l.__reactInternalMemoizedMaskedChildContext;
      var f = {};
      for (var A in i)
        f[A] = t[A];
      {
        var h = Ye(e) || "Unknown";
        Jr(i, f, "context", h);
      }
      return l && iO(e, t, f), f;
    }
  }
  function Rc() {
    return Ta.current;
  }
  function da(e) {
    {
      var t = e.childContextTypes;
      return t != null;
    }
  }
  function pc(e) {
    Fn(Ta, e), Fn(Wa, e);
  }
  function TA(e) {
    Fn(Ta, e), Fn(Wa, e);
  }
  function sO(e, t, r) {
    {
      if (Wa.current !== Or)
        throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
      Yn(Wa, t, e), Yn(Ta, r, e);
    }
  }
  function oO(e, t, r) {
    {
      var i = e.stateNode, l = t.childContextTypes;
      if (typeof i.getChildContext != "function") {
        {
          var f = Ye(e) || "Unknown";
          cA[f] || (cA[f] = !0, u("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", f, f));
        }
        return r;
      }
      var A = i.getChildContext();
      for (var h in A)
        if (!(h in l))
          throw new Error((Ye(e) || "Unknown") + '.getChildContext(): key "' + h + '" is not defined in childContextTypes.');
      {
        var I = Ye(e) || "Unknown";
        Jr(l, A, "child context", I);
      }
      return Je({}, r, A);
    }
  }
  function Sc(e) {
    {
      var t = e.stateNode, r = t && t.__reactInternalMemoizedMergedChildContext || Or;
      return fA = Wa.current, Yn(Wa, r, e), Yn(Ta, Ta.current, e), !0;
    }
  }
  function lO(e, t, r) {
    {
      var i = e.stateNode;
      if (!i)
        throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
      if (r) {
        var l = oO(e, t, fA);
        i.__reactInternalMemoizedMergedChildContext = l, Fn(Ta, e), Fn(Wa, e), Yn(Wa, l, e), Yn(Ta, r, e);
      } else
        Fn(Ta, e), Yn(Ta, r, e);
    }
  }
  function PD(e) {
    {
      if (!H0(e) || e.tag !== T)
        throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
      var t = e;
      do {
        switch (t.tag) {
          case N:
            return t.stateNode.context;
          case T: {
            var r = t.type;
            if (da(r))
              return t.stateNode.__reactInternalMemoizedMergedChildContext;
            break;
          }
        }
        t = t.return;
      } while (t !== null);
      throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
  }
  var mi = 0, hc = 1, ka = null, dA = !1, AA = !1;
  function uO(e) {
    ka === null ? ka = [e] : ka.push(e);
  }
  function UD(e) {
    dA = !0, uO(e);
  }
  function EO() {
    dA && vi();
  }
  function vi() {
    if (!AA && ka !== null) {
      AA = !0;
      var e = 0, t = Kr();
      try {
        var r = !0, i = ka;
        for (On(Pr); e < i.length; e++) {
          var l = i[e];
          do
            l = l(r);
          while (l !== null);
        }
        ka = null, dA = !1;
      } catch (f) {
        throw ka !== null && (ka = ka.slice(e + 1)), wh(nd, vi), f;
      } finally {
        On(t), AA = !1;
      }
    }
    return null;
  }
  var No = [], Oo = 0, Nc = null, Oc = 0, Ur = [], xr = 0, ds = null, Xa = 1, ja = "";
  function xD(e) {
    return Rs(), (e.flags & yh) !== be;
  }
  function wD(e) {
    return Rs(), Oc;
  }
  function GD() {
    var e = ja, t = Xa, r = t & ~HD(t);
    return r.toString(32) + e;
  }
  function As(e, t) {
    Rs(), No[Oo++] = Oc, No[Oo++] = Nc, Nc = e, Oc = t;
  }
  function cO(e, t, r) {
    Rs(), Ur[xr++] = Xa, Ur[xr++] = ja, Ur[xr++] = ds, ds = e;
    var i = Xa, l = ja, f = Ic(i) - 1, A = i & ~(1 << f), h = r + 1, I = Ic(t) + f;
    if (I > 30) {
      var L = f - f % 5, b = (1 << L) - 1, k = (A & b).toString(32), W = A >> L, q = f - L, Q = Ic(t) + q, re = h << q, Ne = re | W, ye = k + l;
      Xa = 1 << Q | Ne, ja = ye;
    } else {
      var me = h << f, Qe = me | A, Xe = l;
      Xa = 1 << I | Qe, ja = Xe;
    }
  }
  function RA(e) {
    Rs();
    var t = e.return;
    if (t !== null) {
      var r = 1, i = 0;
      As(e, r), cO(e, r, i);
    }
  }
  function Ic(e) {
    return 32 - Bh(e);
  }
  function HD(e) {
    return 1 << Ic(e) - 1;
  }
  function pA(e) {
    for (; e === Nc; )
      Nc = No[--Oo], No[Oo] = null, Oc = No[--Oo], No[Oo] = null;
    for (; e === ds; )
      ds = Ur[--xr], Ur[xr] = null, ja = Ur[--xr], Ur[xr] = null, Xa = Ur[--xr], Ur[xr] = null;
  }
  function BD() {
    return Rs(), ds !== null ? {
      id: Xa,
      overflow: ja
    } : null;
  }
  function FD(e, t) {
    Rs(), Ur[xr++] = Xa, Ur[xr++] = ja, Ur[xr++] = ds, Xa = t.id, ja = t.overflow, ds = e;
  }
  function Rs() {
    mn() || u("Expected to be hydrating. This is a bug in React. Please file an issue.");
  }
  var Cn = null, wr = null, zr = !1, ps = !1, Li = null;
  function YD() {
    zr && u("We should not be hydrating here. This is a bug in React. Please file a bug.");
  }
  function fO() {
    ps = !0;
  }
  function VD() {
    return ps;
  }
  function WD(e) {
    var t = e.stateNode.containerInfo;
    return wr = oD(t), Cn = e, zr = !0, Li = null, ps = !1, !0;
  }
  function kD(e, t, r) {
    return wr = lD(t), Cn = e, zr = !0, Li = null, ps = !1, r !== null && FD(e, r), !0;
  }
  function TO(e, t) {
    switch (e.tag) {
      case N: {
        SD(e.stateNode.containerInfo, t);
        break;
      }
      case v: {
        var r = (e.mode & Ze) !== Me;
        ND(
          e.type,
          e.memoizedProps,
          e.stateNode,
          t,
          // TODO: Delete this argument when we remove the legacy root API.
          r
        );
        break;
      }
      case G: {
        var i = e.memoizedState;
        i.dehydrated !== null && hD(i.dehydrated, t);
        break;
      }
    }
  }
  function dO(e, t) {
    TO(e, t);
    var r = KP();
    r.stateNode = t, r.return = e;
    var i = e.deletions;
    i === null ? (e.deletions = [r], e.flags |= as) : i.push(r);
  }
  function SA(e, t) {
    {
      if (ps)
        return;
      switch (e.tag) {
        case N: {
          var r = e.stateNode.containerInfo;
          switch (t.tag) {
            case v:
              var i = t.type;
              t.pendingProps, OD(r, i);
              break;
            case M:
              var l = t.pendingProps;
              ID(r, l);
              break;
          }
          break;
        }
        case v: {
          var f = e.type, A = e.memoizedProps, h = e.stateNode;
          switch (t.tag) {
            case v: {
              var I = t.type, L = t.pendingProps, b = (e.mode & Ze) !== Me;
              mD(
                f,
                A,
                h,
                I,
                L,
                // TODO: Delete this argument when we remove the legacy root API.
                b
              );
              break;
            }
            case M: {
              var k = t.pendingProps, W = (e.mode & Ze) !== Me;
              vD(
                f,
                A,
                h,
                k,
                // TODO: Delete this argument when we remove the legacy root API.
                W
              );
              break;
            }
          }
          break;
        }
        case G: {
          var q = e.memoizedState, Q = q.dehydrated;
          if (Q !== null)
            switch (t.tag) {
              case v:
                var re = t.type;
                t.pendingProps, _D(Q, re);
                break;
              case M:
                var Ne = t.pendingProps;
                CD(Q, Ne);
                break;
            }
          break;
        }
        default:
          return;
      }
    }
  }
  function AO(e, t) {
    t.flags = t.flags & ~Ha | Zt, SA(e, t);
  }
  function RO(e, t) {
    switch (e.tag) {
      case v: {
        var r = e.type;
        e.pendingProps;
        var i = tD(t, r);
        return i !== null ? (e.stateNode = i, Cn = e, wr = sD(i), !0) : !1;
      }
      case M: {
        var l = e.pendingProps, f = nD(t, l);
        return f !== null ? (e.stateNode = f, Cn = e, wr = null, !0) : !1;
      }
      case G: {
        var A = rD(t);
        if (A !== null) {
          var h = {
            dehydrated: A,
            treeContext: BD(),
            retryLane: Mr
          };
          e.memoizedState = h;
          var I = JP(A);
          return I.return = e, e.child = I, Cn = e, wr = null, !0;
        }
        return !1;
      }
      default:
        return !1;
    }
  }
  function hA(e) {
    return (e.mode & Ze) !== Me && (e.flags & ct) === be;
  }
  function NA(e) {
    throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
  }
  function OA(e) {
    if (zr) {
      var t = wr;
      if (!t) {
        hA(e) && (SA(Cn, e), NA()), AO(Cn, e), zr = !1, Cn = e;
        return;
      }
      var r = t;
      if (!RO(e, t)) {
        hA(e) && (SA(Cn, e), NA()), t = nu(r);
        var i = Cn;
        if (!t || !RO(e, t)) {
          AO(Cn, e), zr = !1, Cn = e;
          return;
        }
        dO(i, r);
      }
    }
  }
  function XD(e, t, r) {
    var i = e.stateNode, l = !ps, f = uD(i, e.type, e.memoizedProps, t, r, e, l);
    return e.updateQueue = f, f !== null;
  }
  function jD(e) {
    var t = e.stateNode, r = e.memoizedProps, i = ED(t, r, e);
    if (i) {
      var l = Cn;
      if (l !== null)
        switch (l.tag) {
          case N: {
            var f = l.stateNode.containerInfo, A = (l.mode & Ze) !== Me;
            RD(
              f,
              t,
              r,
              // TODO: Delete this argument when we remove the legacy root API.
              A
            );
            break;
          }
          case v: {
            var h = l.type, I = l.memoizedProps, L = l.stateNode, b = (l.mode & Ze) !== Me;
            pD(
              h,
              I,
              L,
              t,
              r,
              // TODO: Delete this argument when we remove the legacy root API.
              b
            );
            break;
          }
        }
    }
    return i;
  }
  function KD(e) {
    var t = e.memoizedState, r = t !== null ? t.dehydrated : null;
    if (!r)
      throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
    cD(r, e);
  }
  function JD(e) {
    var t = e.memoizedState, r = t !== null ? t.dehydrated : null;
    if (!r)
      throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
    return fD(r);
  }
  function pO(e) {
    for (var t = e.return; t !== null && t.tag !== v && t.tag !== N && t.tag !== G; )
      t = t.return;
    Cn = t;
  }
  function _c(e) {
    if (e !== Cn)
      return !1;
    if (!zr)
      return pO(e), zr = !0, !1;
    if (e.tag !== N && (e.tag !== v || AD(e.type) && !nA(e.type, e.memoizedProps))) {
      var t = wr;
      if (t)
        if (hA(e))
          SO(e), NA();
        else
          for (; t; )
            dO(e, t), t = nu(t);
    }
    return pO(e), e.tag === G ? wr = JD(e) : wr = Cn ? nu(e.stateNode) : null, !0;
  }
  function zD() {
    return zr && wr !== null;
  }
  function SO(e) {
    for (var t = wr; t; )
      TO(e, t), t = nu(t);
  }
  function Io() {
    Cn = null, wr = null, zr = !1, ps = !1;
  }
  function hO() {
    Li !== null && (f_(Li), Li = null);
  }
  function mn() {
    return zr;
  }
  function IA(e) {
    Li === null ? Li = [e] : Li.push(e);
  }
  var ZD = s.ReactCurrentBatchConfig, qD = null;
  function QD() {
    return ZD.transition;
  }
  var Zr = {
    recordUnsafeLifecycleWarnings: function(e, t) {
    },
    flushPendingUnsafeLifecycleWarnings: function() {
    },
    recordLegacyContextWarning: function(e, t) {
    },
    flushLegacyContextWarning: function() {
    },
    discardPendingWarnings: function() {
    }
  };
  {
    var $D = function(e) {
      for (var t = null, r = e; r !== null; )
        r.mode & qt && (t = r), r = r.return;
      return t;
    }, Ss = function(e) {
      var t = [];
      return e.forEach(function(r) {
        t.push(r);
      }), t.sort().join(", ");
    }, su = [], ou = [], lu = [], uu = [], Eu = [], cu = [], hs = /* @__PURE__ */ new Set();
    Zr.recordUnsafeLifecycleWarnings = function(e, t) {
      hs.has(e.type) || (typeof t.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
      t.componentWillMount.__suppressDeprecationWarning !== !0 && su.push(e), e.mode & qt && typeof t.UNSAFE_componentWillMount == "function" && ou.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && lu.push(e), e.mode & qt && typeof t.UNSAFE_componentWillReceiveProps == "function" && uu.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && Eu.push(e), e.mode & qt && typeof t.UNSAFE_componentWillUpdate == "function" && cu.push(e));
    }, Zr.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      su.length > 0 && (su.forEach(function(W) {
        e.add(Ye(W) || "Component"), hs.add(W.type);
      }), su = []);
      var t = /* @__PURE__ */ new Set();
      ou.length > 0 && (ou.forEach(function(W) {
        t.add(Ye(W) || "Component"), hs.add(W.type);
      }), ou = []);
      var r = /* @__PURE__ */ new Set();
      lu.length > 0 && (lu.forEach(function(W) {
        r.add(Ye(W) || "Component"), hs.add(W.type);
      }), lu = []);
      var i = /* @__PURE__ */ new Set();
      uu.length > 0 && (uu.forEach(function(W) {
        i.add(Ye(W) || "Component"), hs.add(W.type);
      }), uu = []);
      var l = /* @__PURE__ */ new Set();
      Eu.length > 0 && (Eu.forEach(function(W) {
        l.add(Ye(W) || "Component"), hs.add(W.type);
      }), Eu = []);
      var f = /* @__PURE__ */ new Set();
      if (cu.length > 0 && (cu.forEach(function(W) {
        f.add(Ye(W) || "Component"), hs.add(W.type);
      }), cu = []), t.size > 0) {
        var A = Ss(t);
        u(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, A);
      }
      if (i.size > 0) {
        var h = Ss(i);
        u(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, h);
      }
      if (f.size > 0) {
        var I = Ss(f);
        u(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, I);
      }
      if (e.size > 0) {
        var L = Ss(e);
        E(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, L);
      }
      if (r.size > 0) {
        var b = Ss(r);
        E(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, b);
      }
      if (l.size > 0) {
        var k = Ss(l);
        E(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, k);
      }
    };
    var Cc = /* @__PURE__ */ new Map(), NO = /* @__PURE__ */ new Set();
    Zr.recordLegacyContextWarning = function(e, t) {
      var r = $D(e);
      if (r === null) {
        u("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      if (!NO.has(e.type)) {
        var i = Cc.get(r);
        (e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (i === void 0 && (i = [], Cc.set(r, i)), i.push(e));
      }
    }, Zr.flushLegacyContextWarning = function() {
      Cc.forEach(function(e, t) {
        if (e.length !== 0) {
          var r = e[0], i = /* @__PURE__ */ new Set();
          e.forEach(function(f) {
            i.add(Ye(f) || "Component"), NO.add(f.type);
          });
          var l = Ss(i);
          try {
            wt(r), u(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, l);
          } finally {
            pn();
          }
        }
      });
    }, Zr.discardPendingWarnings = function() {
      su = [], ou = [], lu = [], uu = [], Eu = [], cu = [], Cc = /* @__PURE__ */ new Map();
    };
  }
  function qr(e, t) {
    if (e && e.defaultProps) {
      var r = Je({}, t), i = e.defaultProps;
      for (var l in i)
        r[l] === void 0 && (r[l] = i[l]);
      return r;
    }
    return t;
  }
  var _A = Ci(null), CA;
  CA = {};
  var mc = null, _o = null, mA = null, vc = !1;
  function Lc() {
    mc = null, _o = null, mA = null, vc = !1;
  }
  function OO() {
    vc = !0;
  }
  function IO() {
    vc = !1;
  }
  function _O(e, t, r) {
    Yn(_A, t._currentValue, e), t._currentValue = r, t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== CA && u("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), t._currentRenderer = CA;
  }
  function vA(e, t) {
    var r = _A.current;
    Fn(_A, t), e._currentValue = r;
  }
  function LA(e, t, r) {
    for (var i = e; i !== null; ) {
      var l = i.alternate;
      if (oo(i.childLanes, t) ? l !== null && !oo(l.childLanes, t) && (l.childLanes = We(l.childLanes, t)) : (i.childLanes = We(i.childLanes, t), l !== null && (l.childLanes = We(l.childLanes, t))), i === r)
        break;
      i = i.return;
    }
    i !== r && u("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
  }
  function eb(e, t, r) {
    tb(e, t, r);
  }
  function tb(e, t, r) {
    var i = e.child;
    for (i !== null && (i.return = e); i !== null; ) {
      var l = void 0, f = i.dependencies;
      if (f !== null) {
        l = i.child;
        for (var A = f.firstContext; A !== null; ) {
          if (A.context === t) {
            if (i.tag === T) {
              var h = Dl(r), I = Ka(mt, h);
              I.tag = gc;
              var L = i.updateQueue;
              if (L !== null) {
                var b = L.shared, k = b.pending;
                k === null ? I.next = I : (I.next = k.next, k.next = I), b.pending = I;
              }
            }
            i.lanes = We(i.lanes, r);
            var W = i.alternate;
            W !== null && (W.lanes = We(W.lanes, r)), LA(i.return, r, e), f.lanes = We(f.lanes, r);
            break;
          }
          A = A.next;
        }
      } else if (i.tag === g)
        l = i.type === e.type ? null : i.child;
      else if (i.tag === _) {
        var q = i.return;
        if (q === null)
          throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
        q.lanes = We(q.lanes, r);
        var Q = q.alternate;
        Q !== null && (Q.lanes = We(Q.lanes, r)), LA(q, r, e), l = i.sibling;
      } else
        l = i.child;
      if (l !== null)
        l.return = i;
      else
        for (l = i; l !== null; ) {
          if (l === e) {
            l = null;
            break;
          }
          var re = l.sibling;
          if (re !== null) {
            re.return = l.return, l = re;
            break;
          }
          l = l.return;
        }
      i = l;
    }
  }
  function Co(e, t) {
    mc = e, _o = null, mA = null;
    var r = e.dependencies;
    if (r !== null) {
      var i = r.firstContext;
      i !== null && (Sr(r.lanes, t) && mu(), r.firstContext = null);
    }
  }
  function Qt(e) {
    vc && u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    var t = e._currentValue;
    if (mA !== e) {
      var r = {
        context: e,
        memoizedValue: t,
        next: null
      };
      if (_o === null) {
        if (mc === null)
          throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        _o = r, mc.dependencies = {
          lanes: le,
          firstContext: r
        };
      } else
        _o = _o.next = r;
    }
    return t;
  }
  var Ns = null;
  function yA(e) {
    Ns === null ? Ns = [e] : Ns.push(e);
  }
  function nb() {
    if (Ns !== null) {
      for (var e = 0; e < Ns.length; e++) {
        var t = Ns[e], r = t.interleaved;
        if (r !== null) {
          t.interleaved = null;
          var i = r.next, l = t.pending;
          if (l !== null) {
            var f = l.next;
            l.next = i, r.next = f;
          }
          t.pending = r;
        }
      }
      Ns = null;
    }
  }
  function CO(e, t, r, i) {
    var l = t.interleaved;
    return l === null ? (r.next = r, yA(t)) : (r.next = l.next, l.next = r), t.interleaved = r, yc(e, i);
  }
  function rb(e, t, r, i) {
    var l = t.interleaved;
    l === null ? (r.next = r, yA(t)) : (r.next = l.next, l.next = r), t.interleaved = r;
  }
  function ab(e, t, r, i) {
    var l = t.interleaved;
    return l === null ? (r.next = r, yA(t)) : (r.next = l.next, l.next = r), t.interleaved = r, yc(e, i);
  }
  function ur(e, t) {
    return yc(e, t);
  }
  var ib = yc;
  function yc(e, t) {
    e.lanes = We(e.lanes, t);
    var r = e.alternate;
    r !== null && (r.lanes = We(r.lanes, t)), r === null && (e.flags & (Zt | Ha)) !== be && C_(e);
    for (var i = e, l = e.return; l !== null; )
      l.childLanes = We(l.childLanes, t), r = l.alternate, r !== null ? r.childLanes = We(r.childLanes, t) : (l.flags & (Zt | Ha)) !== be && C_(e), i = l, l = l.return;
    if (i.tag === N) {
      var f = i.stateNode;
      return f;
    } else
      return null;
  }
  var mO = 0, vO = 1, gc = 2, gA = 3, Dc = !1, DA, bc;
  DA = !1, bc = null;
  function bA(e) {
    var t = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        interleaved: null,
        lanes: le
      },
      effects: null
    };
    e.updateQueue = t;
  }
  function LO(e, t) {
    var r = t.updateQueue, i = e.updateQueue;
    if (r === i) {
      var l = {
        baseState: i.baseState,
        firstBaseUpdate: i.firstBaseUpdate,
        lastBaseUpdate: i.lastBaseUpdate,
        shared: i.shared,
        effects: i.effects
      };
      t.updateQueue = l;
    }
  }
  function Ka(e, t) {
    var r = {
      eventTime: e,
      lane: t,
      tag: mO,
      payload: null,
      callback: null,
      next: null
    };
    return r;
  }
  function yi(e, t, r) {
    var i = e.updateQueue;
    if (i === null)
      return null;
    var l = i.shared;
    if (bc === l && !DA && (u("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), DA = !0), iP()) {
      var f = l.pending;
      return f === null ? t.next = t : (t.next = f.next, f.next = t), l.pending = t, ib(e, r);
    } else
      return ab(e, l, t, r);
  }
  function Mc(e, t, r) {
    var i = t.updateQueue;
    if (i !== null) {
      var l = i.shared;
      if (kh(r)) {
        var f = l.lanes;
        f = jh(f, e.pendingLanes);
        var A = We(f, r);
        l.lanes = A, Ld(e, A);
      }
    }
  }
  function MA(e, t) {
    var r = e.updateQueue, i = e.alternate;
    if (i !== null) {
      var l = i.updateQueue;
      if (r === l) {
        var f = null, A = null, h = r.firstBaseUpdate;
        if (h !== null) {
          var I = h;
          do {
            var L = {
              eventTime: I.eventTime,
              lane: I.lane,
              tag: I.tag,
              payload: I.payload,
              callback: I.callback,
              next: null
            };
            A === null ? f = A = L : (A.next = L, A = L), I = I.next;
          } while (I !== null);
          A === null ? f = A = t : (A.next = t, A = t);
        } else
          f = A = t;
        r = {
          baseState: l.baseState,
          firstBaseUpdate: f,
          lastBaseUpdate: A,
          shared: l.shared,
          effects: l.effects
        }, e.updateQueue = r;
        return;
      }
    }
    var b = r.lastBaseUpdate;
    b === null ? r.firstBaseUpdate = t : b.next = t, r.lastBaseUpdate = t;
  }
  function sb(e, t, r, i, l, f) {
    switch (r.tag) {
      case vO: {
        var A = r.payload;
        if (typeof A == "function") {
          OO();
          var h = A.call(f, i, l);
          {
            if (e.mode & qt) {
              hn(!0);
              try {
                A.call(f, i, l);
              } finally {
                hn(!1);
              }
            }
            IO();
          }
          return h;
        }
        return A;
      }
      case gA:
        e.flags = e.flags & ~Jn | ct;
      case mO: {
        var I = r.payload, L;
        if (typeof I == "function") {
          OO(), L = I.call(f, i, l);
          {
            if (e.mode & qt) {
              hn(!0);
              try {
                I.call(f, i, l);
              } finally {
                hn(!1);
              }
            }
            IO();
          }
        } else
          L = I;
        return L == null ? i : Je({}, i, L);
      }
      case gc:
        return Dc = !0, i;
    }
    return i;
  }
  function Pc(e, t, r, i) {
    var l = e.updateQueue;
    Dc = !1, bc = l.shared;
    var f = l.firstBaseUpdate, A = l.lastBaseUpdate, h = l.shared.pending;
    if (h !== null) {
      l.shared.pending = null;
      var I = h, L = I.next;
      I.next = null, A === null ? f = L : A.next = L, A = I;
      var b = e.alternate;
      if (b !== null) {
        var k = b.updateQueue, W = k.lastBaseUpdate;
        W !== A && (W === null ? k.firstBaseUpdate = L : W.next = L, k.lastBaseUpdate = I);
      }
    }
    if (f !== null) {
      var q = l.baseState, Q = le, re = null, Ne = null, ye = null, me = f;
      do {
        var Qe = me.lane, Xe = me.eventTime;
        if (oo(i, Qe)) {
          if (ye !== null) {
            var ae = {
              eventTime: Xe,
              // This update is going to be committed so we never want uncommit
              // it. Using NoLane works because 0 is a subset of all bitmasks, so
              // this will never be skipped by the check above.
              lane: Nn,
              tag: me.tag,
              payload: me.payload,
              callback: me.callback,
              next: null
            };
            ye = ye.next = ae;
          }
          q = sb(e, l, me, q, t, r);
          var J = me.callback;
          if (J !== null && // If the update was already committed, we should not queue its
          // callback again.
          me.lane !== Nn) {
            e.flags |= ZT;
            var ce = l.effects;
            ce === null ? l.effects = [me] : ce.push(me);
          }
        } else {
          var K = {
            eventTime: Xe,
            lane: Qe,
            tag: me.tag,
            payload: me.payload,
            callback: me.callback,
            next: null
          };
          ye === null ? (Ne = ye = K, re = q) : ye = ye.next = K, Q = We(Q, Qe);
        }
        if (me = me.next, me === null) {
          if (h = l.shared.pending, h === null)
            break;
          var Oe = h, Se = Oe.next;
          Oe.next = null, me = Se, l.lastBaseUpdate = Oe, l.shared.pending = null;
        }
      } while (!0);
      ye === null && (re = q), l.baseState = re, l.firstBaseUpdate = Ne, l.lastBaseUpdate = ye;
      var Ue = l.shared.interleaved;
      if (Ue !== null) {
        var He = Ue;
        do
          Q = We(Q, He.lane), He = He.next;
        while (He !== Ue);
      } else
        f === null && (l.shared.lanes = le);
      Gu(Q), e.lanes = Q, e.memoizedState = q;
    }
    bc = null;
  }
  function ob(e, t) {
    if (typeof e != "function")
      throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
    e.call(t);
  }
  function yO() {
    Dc = !1;
  }
  function Uc() {
    return Dc;
  }
  function gO(e, t, r) {
    var i = t.effects;
    if (t.effects = null, i !== null)
      for (var l = 0; l < i.length; l++) {
        var f = i[l], A = f.callback;
        A !== null && (f.callback = null, ob(A, r));
      }
  }
  var PA = {}, DO = new n.Component().refs, UA, xA, wA, GA, HA, bO, xc, BA, FA, YA;
  {
    UA = /* @__PURE__ */ new Set(), xA = /* @__PURE__ */ new Set(), wA = /* @__PURE__ */ new Set(), GA = /* @__PURE__ */ new Set(), BA = /* @__PURE__ */ new Set(), HA = /* @__PURE__ */ new Set(), FA = /* @__PURE__ */ new Set(), YA = /* @__PURE__ */ new Set();
    var MO = /* @__PURE__ */ new Set();
    xc = function(e, t) {
      if (!(e === null || typeof e == "function")) {
        var r = t + "_" + e;
        MO.has(r) || (MO.add(r), u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e));
      }
    }, bO = function(e, t) {
      if (t === void 0) {
        var r = it(e) || "Component";
        HA.has(r) || (HA.add(r), u("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", r));
      }
    }, Object.defineProperty(PA, "_processChildContext", {
      enumerable: !1,
      value: function() {
        throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
      }
    }), Object.freeze(PA);
  }
  function VA(e, t, r, i) {
    var l = e.memoizedState, f = r(i, l);
    {
      if (e.mode & qt) {
        hn(!0);
        try {
          f = r(i, l);
        } finally {
          hn(!1);
        }
      }
      bO(t, f);
    }
    var A = f == null ? l : Je({}, l, f);
    if (e.memoizedState = A, e.lanes === le) {
      var h = e.updateQueue;
      h.baseState = A;
    }
  }
  var WA = {
    isMounted: B0,
    enqueueSetState: function(e, t, r) {
      var i = to(e), l = Qn(), f = wi(i), A = Ka(l, f);
      A.payload = t, r != null && (xc(r, "setState"), A.callback = r);
      var h = yi(i, A, f);
      h !== null && (cn(h, i, f, l), Mc(h, i, f));
    },
    enqueueReplaceState: function(e, t, r) {
      var i = to(e), l = Qn(), f = wi(i), A = Ka(l, f);
      A.tag = vO, A.payload = t, r != null && (xc(r, "replaceState"), A.callback = r);
      var h = yi(i, A, f);
      h !== null && (cn(h, i, f, l), Mc(h, i, f));
    },
    enqueueForceUpdate: function(e, t) {
      var r = to(e), i = Qn(), l = wi(r), f = Ka(i, l);
      f.tag = gc, t != null && (xc(t, "forceUpdate"), f.callback = t);
      var A = yi(r, f, l);
      A !== null && (cn(A, r, l, i), Mc(A, r, l));
    }
  };
  function PO(e, t, r, i, l, f, A) {
    var h = e.stateNode;
    if (typeof h.shouldComponentUpdate == "function") {
      var I = h.shouldComponentUpdate(i, f, A);
      {
        if (e.mode & qt) {
          hn(!0);
          try {
            I = h.shouldComponentUpdate(i, f, A);
          } finally {
            hn(!1);
          }
        }
        I === void 0 && u("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", it(t) || "Component");
      }
      return I;
    }
    return t.prototype && t.prototype.isPureReactComponent ? !Xl(r, i) || !Xl(l, f) : !0;
  }
  function lb(e, t, r) {
    var i = e.stateNode;
    {
      var l = it(t) || "Component", f = i.render;
      f || (t.prototype && typeof t.prototype.render == "function" ? u("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", l) : u("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", l)), i.getInitialState && !i.getInitialState.isReactClassApproved && !i.state && u("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", l), i.getDefaultProps && !i.getDefaultProps.isReactClassApproved && u("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", l), i.propTypes && u("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", l), i.contextType && u("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", l), i.contextTypes && u("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", l), t.contextType && t.contextTypes && !FA.has(t) && (FA.add(t), u("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", l)), typeof i.componentShouldUpdate == "function" && u("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", l), t.prototype && t.prototype.isPureReactComponent && typeof i.shouldComponentUpdate < "u" && u("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", it(t) || "A pure component"), typeof i.componentDidUnmount == "function" && u("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", l), typeof i.componentDidReceiveProps == "function" && u("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", l), typeof i.componentWillRecieveProps == "function" && u("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", l), typeof i.UNSAFE_componentWillRecieveProps == "function" && u("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", l);
      var A = i.props !== r;
      i.props !== void 0 && A && u("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", l, l), i.defaultProps && u("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", l, l), typeof i.getSnapshotBeforeUpdate == "function" && typeof i.componentDidUpdate != "function" && !wA.has(t) && (wA.add(t), u("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", it(t))), typeof i.getDerivedStateFromProps == "function" && u("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", l), typeof i.getDerivedStateFromError == "function" && u("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", l), typeof t.getSnapshotBeforeUpdate == "function" && u("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", l);
      var h = i.state;
      h && (typeof h != "object" || st(h)) && u("%s.state: must be set to an object or null", l), typeof i.getChildContext == "function" && typeof t.childContextTypes != "object" && u("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", l);
    }
  }
  function UO(e, t) {
    t.updater = WA, e.stateNode = t, U0(t, e), t._reactInternalInstance = PA;
  }
  function xO(e, t, r) {
    var i = !1, l = Or, f = Or, A = t.contextType;
    if ("contextType" in t) {
      var h = (
        // Allow null for conditional declaration
        A === null || A !== void 0 && A.$$typeof === Re && A._context === void 0
      );
      if (!h && !YA.has(t)) {
        YA.add(t);
        var I = "";
        A === void 0 ? I = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof A != "object" ? I = " However, it is set to a " + typeof A + "." : A.$$typeof === ue ? I = " Did you accidentally pass the Context.Provider instead?" : A._context !== void 0 ? I = " Did you accidentally pass the Context.Consumer instead?" : I = " However, it is set to an object with keys {" + Object.keys(A).join(", ") + "}.", u("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", it(t) || "Component", I);
      }
    }
    if (typeof A == "object" && A !== null)
      f = Qt(A);
    else {
      l = So(e, t, !0);
      var L = t.contextTypes;
      i = L != null, f = i ? ho(e, l) : Or;
    }
    var b = new t(r, f);
    if (e.mode & qt) {
      hn(!0);
      try {
        b = new t(r, f);
      } finally {
        hn(!1);
      }
    }
    var k = e.memoizedState = b.state !== null && b.state !== void 0 ? b.state : null;
    UO(e, b);
    {
      if (typeof t.getDerivedStateFromProps == "function" && k === null) {
        var W = it(t) || "Component";
        xA.has(W) || (xA.add(W), u("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", W, b.state === null ? "null" : "undefined", W));
      }
      if (typeof t.getDerivedStateFromProps == "function" || typeof b.getSnapshotBeforeUpdate == "function") {
        var q = null, Q = null, re = null;
        if (typeof b.componentWillMount == "function" && b.componentWillMount.__suppressDeprecationWarning !== !0 ? q = "componentWillMount" : typeof b.UNSAFE_componentWillMount == "function" && (q = "UNSAFE_componentWillMount"), typeof b.componentWillReceiveProps == "function" && b.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Q = "componentWillReceiveProps" : typeof b.UNSAFE_componentWillReceiveProps == "function" && (Q = "UNSAFE_componentWillReceiveProps"), typeof b.componentWillUpdate == "function" && b.componentWillUpdate.__suppressDeprecationWarning !== !0 ? re = "componentWillUpdate" : typeof b.UNSAFE_componentWillUpdate == "function" && (re = "UNSAFE_componentWillUpdate"), q !== null || Q !== null || re !== null) {
          var Ne = it(t) || "Component", ye = typeof t.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
          GA.has(Ne) || (GA.add(Ne), u(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ne, ye, q !== null ? `
  ` + q : "", Q !== null ? `
  ` + Q : "", re !== null ? `
  ` + re : ""));
        }
      }
    }
    return i && iO(e, l, f), b;
  }
  function ub(e, t) {
    var r = t.state;
    typeof t.componentWillMount == "function" && t.componentWillMount(), typeof t.UNSAFE_componentWillMount == "function" && t.UNSAFE_componentWillMount(), r !== t.state && (u("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", Ye(e) || "Component"), WA.enqueueReplaceState(t, t.state, null));
  }
  function wO(e, t, r, i) {
    var l = t.state;
    if (typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(r, i), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(r, i), t.state !== l) {
      {
        var f = Ye(e) || "Component";
        UA.has(f) || (UA.add(f), u("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", f));
      }
      WA.enqueueReplaceState(t, t.state, null);
    }
  }
  function kA(e, t, r, i) {
    lb(e, t, r);
    var l = e.stateNode;
    l.props = r, l.state = e.memoizedState, l.refs = DO, bA(e);
    var f = t.contextType;
    if (typeof f == "object" && f !== null)
      l.context = Qt(f);
    else {
      var A = So(e, t, !0);
      l.context = ho(e, A);
    }
    {
      if (l.state === r) {
        var h = it(t) || "Component";
        BA.has(h) || (BA.add(h), u("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", h));
      }
      e.mode & qt && Zr.recordLegacyContextWarning(e, l), Zr.recordUnsafeLifecycleWarnings(e, l);
    }
    l.state = e.memoizedState;
    var I = t.getDerivedStateFromProps;
    if (typeof I == "function" && (VA(e, t, I, r), l.state = e.memoizedState), typeof t.getDerivedStateFromProps != "function" && typeof l.getSnapshotBeforeUpdate != "function" && (typeof l.UNSAFE_componentWillMount == "function" || typeof l.componentWillMount == "function") && (ub(e, l), Pc(e, r, l, i), l.state = e.memoizedState), typeof l.componentDidMount == "function") {
      var L = tt;
      L |= os, (e.mode & fa) !== Me && (L |= Ba), e.flags |= L;
    }
  }
  function Eb(e, t, r, i) {
    var l = e.stateNode, f = e.memoizedProps;
    l.props = f;
    var A = l.context, h = t.contextType, I = Or;
    if (typeof h == "object" && h !== null)
      I = Qt(h);
    else {
      var L = So(e, t, !0);
      I = ho(e, L);
    }
    var b = t.getDerivedStateFromProps, k = typeof b == "function" || typeof l.getSnapshotBeforeUpdate == "function";
    !k && (typeof l.UNSAFE_componentWillReceiveProps == "function" || typeof l.componentWillReceiveProps == "function") && (f !== r || A !== I) && wO(e, l, r, I), yO();
    var W = e.memoizedState, q = l.state = W;
    if (Pc(e, r, l, i), q = e.memoizedState, f === r && W === q && !Rc() && !Uc()) {
      if (typeof l.componentDidMount == "function") {
        var Q = tt;
        Q |= os, (e.mode & fa) !== Me && (Q |= Ba), e.flags |= Q;
      }
      return !1;
    }
    typeof b == "function" && (VA(e, t, b, r), q = e.memoizedState);
    var re = Uc() || PO(e, t, f, r, W, q, I);
    if (re) {
      if (!k && (typeof l.UNSAFE_componentWillMount == "function" || typeof l.componentWillMount == "function") && (typeof l.componentWillMount == "function" && l.componentWillMount(), typeof l.UNSAFE_componentWillMount == "function" && l.UNSAFE_componentWillMount()), typeof l.componentDidMount == "function") {
        var Ne = tt;
        Ne |= os, (e.mode & fa) !== Me && (Ne |= Ba), e.flags |= Ne;
      }
    } else {
      if (typeof l.componentDidMount == "function") {
        var ye = tt;
        ye |= os, (e.mode & fa) !== Me && (ye |= Ba), e.flags |= ye;
      }
      e.memoizedProps = r, e.memoizedState = q;
    }
    return l.props = r, l.state = q, l.context = I, re;
  }
  function cb(e, t, r, i, l) {
    var f = t.stateNode;
    LO(e, t);
    var A = t.memoizedProps, h = t.type === t.elementType ? A : qr(t.type, A);
    f.props = h;
    var I = t.pendingProps, L = f.context, b = r.contextType, k = Or;
    if (typeof b == "object" && b !== null)
      k = Qt(b);
    else {
      var W = So(t, r, !0);
      k = ho(t, W);
    }
    var q = r.getDerivedStateFromProps, Q = typeof q == "function" || typeof f.getSnapshotBeforeUpdate == "function";
    !Q && (typeof f.UNSAFE_componentWillReceiveProps == "function" || typeof f.componentWillReceiveProps == "function") && (A !== I || L !== k) && wO(t, f, i, k), yO();
    var re = t.memoizedState, Ne = f.state = re;
    if (Pc(t, i, f, l), Ne = t.memoizedState, A === I && re === Ne && !Rc() && !Uc() && !ve)
      return typeof f.componentDidUpdate == "function" && (A !== e.memoizedProps || re !== e.memoizedState) && (t.flags |= tt), typeof f.getSnapshotBeforeUpdate == "function" && (A !== e.memoizedProps || re !== e.memoizedState) && (t.flags |= is), !1;
    typeof q == "function" && (VA(t, r, q, i), Ne = t.memoizedState);
    var ye = Uc() || PO(t, r, h, i, re, Ne, k) || // TODO: In some cases, we'll end up checking if context has changed twice,
    // both before and after `shouldComponentUpdate` has been called. Not ideal,
    // but I'm loath to refactor this function. This only happens for memoized
    // components so it's not that common.
    ve;
    return ye ? (!Q && (typeof f.UNSAFE_componentWillUpdate == "function" || typeof f.componentWillUpdate == "function") && (typeof f.componentWillUpdate == "function" && f.componentWillUpdate(i, Ne, k), typeof f.UNSAFE_componentWillUpdate == "function" && f.UNSAFE_componentWillUpdate(i, Ne, k)), typeof f.componentDidUpdate == "function" && (t.flags |= tt), typeof f.getSnapshotBeforeUpdate == "function" && (t.flags |= is)) : (typeof f.componentDidUpdate == "function" && (A !== e.memoizedProps || re !== e.memoizedState) && (t.flags |= tt), typeof f.getSnapshotBeforeUpdate == "function" && (A !== e.memoizedProps || re !== e.memoizedState) && (t.flags |= is), t.memoizedProps = i, t.memoizedState = Ne), f.props = i, f.state = Ne, f.context = k, ye;
  }
  var XA, jA, KA, JA, zA, GO = function(e, t) {
  };
  XA = !1, jA = !1, KA = {}, JA = {}, zA = {}, GO = function(e, t) {
    if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
      if (typeof e._store != "object")
        throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
      e._store.validated = !0;
      var r = Ye(t) || "Component";
      JA[r] || (JA[r] = !0, u('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
    }
  };
  function fu(e, t, r) {
    var i = r.ref;
    if (i !== null && typeof i != "function" && typeof i != "object") {
      if ((e.mode & qt || Ct) && // We warn in ReactElement.js if owner and self are equal for string refs
      // because these cannot be automatically converted to an arrow function
      // using a codemod. Therefore, we don't have to warn about string refs again.
      !(r._owner && r._self && r._owner.stateNode !== r._self)) {
        var l = Ye(e) || "Component";
        KA[l] || (u('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', i), KA[l] = !0);
      }
      if (r._owner) {
        var f = r._owner, A;
        if (f) {
          var h = f;
          if (h.tag !== T)
            throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
          A = h.stateNode;
        }
        if (!A)
          throw new Error("Missing owner for string ref " + i + ". This error is likely caused by a bug in React. Please file an issue.");
        var I = A;
        rr(i, "ref");
        var L = "" + i;
        if (t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === L)
          return t.ref;
        var b = function(k) {
          var W = I.refs;
          W === DO && (W = I.refs = {}), k === null ? delete W[L] : W[L] = k;
        };
        return b._stringRef = L, b;
      } else {
        if (typeof i != "string")
          throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
        if (!r._owner)
          throw new Error("Element ref was specified as a string (" + i + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
      }
    }
    return i;
  }
  function wc(e, t) {
    var r = Object.prototype.toString.call(t);
    throw new Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
  }
  function Gc(e) {
    {
      var t = Ye(e) || "Component";
      if (zA[t])
        return;
      zA[t] = !0, u("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
  }
  function HO(e) {
    var t = e._payload, r = e._init;
    return r(t);
  }
  function BO(e) {
    function t(K, ae) {
      if (e) {
        var J = K.deletions;
        J === null ? (K.deletions = [ae], K.flags |= as) : J.push(ae);
      }
    }
    function r(K, ae) {
      if (!e)
        return null;
      for (var J = ae; J !== null; )
        t(K, J), J = J.sibling;
      return null;
    }
    function i(K, ae) {
      for (var J = /* @__PURE__ */ new Map(), ce = ae; ce !== null; )
        ce.key !== null ? J.set(ce.key, ce) : J.set(ce.index, ce), ce = ce.sibling;
      return J;
    }
    function l(K, ae) {
      var J = ys(K, ae);
      return J.index = 0, J.sibling = null, J;
    }
    function f(K, ae, J) {
      if (K.index = J, !e)
        return K.flags |= yh, ae;
      var ce = K.alternate;
      if (ce !== null) {
        var Oe = ce.index;
        return Oe < ae ? (K.flags |= Zt, ae) : Oe;
      } else
        return K.flags |= Zt, ae;
    }
    function A(K) {
      return e && K.alternate === null && (K.flags |= Zt), K;
    }
    function h(K, ae, J, ce) {
      if (ae === null || ae.tag !== M) {
        var Oe = _p(J, K.mode, ce);
        return Oe.return = K, Oe;
      } else {
        var Se = l(ae, J);
        return Se.return = K, Se;
      }
    }
    function I(K, ae, J, ce) {
      var Oe = J.type;
      if (Oe === ua)
        return b(K, ae, J.props.children, ce, J.key);
      if (ae !== null && (ae.elementType === Oe || // Keep this check inline so it only runs on the false path:
      y_(ae, J) || // Lazy types should reconcile their resolved type.
      // We need to do this after the Hot Reloading check above,
      // because hot reloading has different semantics than prod because
      // it doesn't resuspend. So we can't let the call below suspend.
      typeof Oe == "object" && Oe !== null && Oe.$$typeof === ge && HO(Oe) === ae.type)) {
        var Se = l(ae, J.props);
        return Se.ref = fu(K, ae, J), Se.return = K, Se._debugSource = J._source, Se._debugOwner = J._owner, Se;
      }
      var Ue = Ip(J, K.mode, ce);
      return Ue.ref = fu(K, ae, J), Ue.return = K, Ue;
    }
    function L(K, ae, J, ce) {
      if (ae === null || ae.tag !== m || ae.stateNode.containerInfo !== J.containerInfo || ae.stateNode.implementation !== J.implementation) {
        var Oe = Cp(J, K.mode, ce);
        return Oe.return = K, Oe;
      } else {
        var Se = l(ae, J.children || []);
        return Se.return = K, Se;
      }
    }
    function b(K, ae, J, ce, Oe) {
      if (ae === null || ae.tag !== w) {
        var Se = Hi(J, K.mode, ce, Oe);
        return Se.return = K, Se;
      } else {
        var Ue = l(ae, J);
        return Ue.return = K, Ue;
      }
    }
    function k(K, ae, J) {
      if (typeof ae == "string" && ae !== "" || typeof ae == "number") {
        var ce = _p("" + ae, K.mode, J);
        return ce.return = K, ce;
      }
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case la: {
            var Oe = Ip(ae, K.mode, J);
            return Oe.ref = fu(K, null, ae), Oe.return = K, Oe;
          }
          case kr: {
            var Se = Cp(ae, K.mode, J);
            return Se.return = K, Se;
          }
          case ge: {
            var Ue = ae._payload, He = ae._init;
            return k(K, He(Ue), J);
          }
        }
        if (st(ae) || ba(ae)) {
          var ht = Hi(ae, K.mode, J, null);
          return ht.return = K, ht;
        }
        wc(K, ae);
      }
      return typeof ae == "function" && Gc(K), null;
    }
    function W(K, ae, J, ce) {
      var Oe = ae !== null ? ae.key : null;
      if (typeof J == "string" && J !== "" || typeof J == "number")
        return Oe !== null ? null : h(K, ae, "" + J, ce);
      if (typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case la:
            return J.key === Oe ? I(K, ae, J, ce) : null;
          case kr:
            return J.key === Oe ? L(K, ae, J, ce) : null;
          case ge: {
            var Se = J._payload, Ue = J._init;
            return W(K, ae, Ue(Se), ce);
          }
        }
        if (st(J) || ba(J))
          return Oe !== null ? null : b(K, ae, J, ce, null);
        wc(K, J);
      }
      return typeof J == "function" && Gc(K), null;
    }
    function q(K, ae, J, ce, Oe) {
      if (typeof ce == "string" && ce !== "" || typeof ce == "number") {
        var Se = K.get(J) || null;
        return h(ae, Se, "" + ce, Oe);
      }
      if (typeof ce == "object" && ce !== null) {
        switch (ce.$$typeof) {
          case la: {
            var Ue = K.get(ce.key === null ? J : ce.key) || null;
            return I(ae, Ue, ce, Oe);
          }
          case kr: {
            var He = K.get(ce.key === null ? J : ce.key) || null;
            return L(ae, He, ce, Oe);
          }
          case ge:
            var ht = ce._payload, rt = ce._init;
            return q(K, ae, J, rt(ht), Oe);
        }
        if (st(ce) || ba(ce)) {
          var Xt = K.get(J) || null;
          return b(ae, Xt, ce, Oe, null);
        }
        wc(ae, ce);
      }
      return typeof ce == "function" && Gc(ae), null;
    }
    function Q(K, ae, J) {
      {
        if (typeof K != "object" || K === null)
          return ae;
        switch (K.$$typeof) {
          case la:
          case kr:
            GO(K, J);
            var ce = K.key;
            if (typeof ce != "string")
              break;
            if (ae === null) {
              ae = /* @__PURE__ */ new Set(), ae.add(ce);
              break;
            }
            if (!ae.has(ce)) {
              ae.add(ce);
              break;
            }
            u("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", ce);
            break;
          case ge:
            var Oe = K._payload, Se = K._init;
            Q(Se(Oe), ae, J);
            break;
        }
      }
      return ae;
    }
    function re(K, ae, J, ce) {
      for (var Oe = null, Se = 0; Se < J.length; Se++) {
        var Ue = J[Se];
        Oe = Q(Ue, Oe, K);
      }
      for (var He = null, ht = null, rt = ae, Xt = 0, at = 0, Ft = null; rt !== null && at < J.length; at++) {
        rt.index > at ? (Ft = rt, rt = null) : Ft = rt.sibling;
        var Wn = W(K, rt, J[at], ce);
        if (Wn === null) {
          rt === null && (rt = Ft);
          break;
        }
        e && rt && Wn.alternate === null && t(K, rt), Xt = f(Wn, Xt, at), ht === null ? He = Wn : ht.sibling = Wn, ht = Wn, rt = Ft;
      }
      if (at === J.length) {
        if (r(K, rt), mn()) {
          var bn = at;
          As(K, bn);
        }
        return He;
      }
      if (rt === null) {
        for (; at < J.length; at++) {
          var Cr = k(K, J[at], ce);
          Cr !== null && (Xt = f(Cr, Xt, at), ht === null ? He = Cr : ht.sibling = Cr, ht = Cr);
        }
        if (mn()) {
          var $n = at;
          As(K, $n);
        }
        return He;
      }
      for (var er = i(K, rt); at < J.length; at++) {
        var kn = q(er, K, at, J[at], ce);
        kn !== null && (e && kn.alternate !== null && er.delete(kn.key === null ? at : kn.key), Xt = f(kn, Xt, at), ht === null ? He = kn : ht.sibling = kn, ht = kn);
      }
      if (e && er.forEach(function(Vo) {
        return t(K, Vo);
      }), mn()) {
        var $a = at;
        As(K, $a);
      }
      return He;
    }
    function Ne(K, ae, J, ce) {
      var Oe = ba(J);
      if (typeof Oe != "function")
        throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
      {
        typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
        J[Symbol.toStringTag] === "Generator" && (jA || u("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), jA = !0), J.entries === Oe && (XA || u("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), XA = !0);
        var Se = Oe.call(J);
        if (Se)
          for (var Ue = null, He = Se.next(); !He.done; He = Se.next()) {
            var ht = He.value;
            Ue = Q(ht, Ue, K);
          }
      }
      var rt = Oe.call(J);
      if (rt == null)
        throw new Error("An iterable object provided no iterator.");
      for (var Xt = null, at = null, Ft = ae, Wn = 0, bn = 0, Cr = null, $n = rt.next(); Ft !== null && !$n.done; bn++, $n = rt.next()) {
        Ft.index > bn ? (Cr = Ft, Ft = null) : Cr = Ft.sibling;
        var er = W(K, Ft, $n.value, ce);
        if (er === null) {
          Ft === null && (Ft = Cr);
          break;
        }
        e && Ft && er.alternate === null && t(K, Ft), Wn = f(er, Wn, bn), at === null ? Xt = er : at.sibling = er, at = er, Ft = Cr;
      }
      if ($n.done) {
        if (r(K, Ft), mn()) {
          var kn = bn;
          As(K, kn);
        }
        return Xt;
      }
      if (Ft === null) {
        for (; !$n.done; bn++, $n = rt.next()) {
          var $a = k(K, $n.value, ce);
          $a !== null && (Wn = f($a, Wn, bn), at === null ? Xt = $a : at.sibling = $a, at = $a);
        }
        if (mn()) {
          var Vo = bn;
          As(K, Vo);
        }
        return Xt;
      }
      for (var Vu = i(K, Ft); !$n.done; bn++, $n = rt.next()) {
        var Ia = q(Vu, K, bn, $n.value, ce);
        Ia !== null && (e && Ia.alternate !== null && Vu.delete(Ia.key === null ? bn : Ia.key), Wn = f(Ia, Wn, bn), at === null ? Xt = Ia : at.sibling = Ia, at = Ia);
      }
      if (e && Vu.forEach(function(mU) {
        return t(K, mU);
      }), mn()) {
        var CU = bn;
        As(K, CU);
      }
      return Xt;
    }
    function ye(K, ae, J, ce) {
      if (ae !== null && ae.tag === M) {
        r(K, ae.sibling);
        var Oe = l(ae, J);
        return Oe.return = K, Oe;
      }
      r(K, ae);
      var Se = _p(J, K.mode, ce);
      return Se.return = K, Se;
    }
    function me(K, ae, J, ce) {
      for (var Oe = J.key, Se = ae; Se !== null; ) {
        if (Se.key === Oe) {
          var Ue = J.type;
          if (Ue === ua) {
            if (Se.tag === w) {
              r(K, Se.sibling);
              var He = l(Se, J.props.children);
              return He.return = K, He._debugSource = J._source, He._debugOwner = J._owner, He;
            }
          } else if (Se.elementType === Ue || // Keep this check inline so it only runs on the false path:
          y_(Se, J) || // Lazy types should reconcile their resolved type.
          // We need to do this after the Hot Reloading check above,
          // because hot reloading has different semantics than prod because
          // it doesn't resuspend. So we can't let the call below suspend.
          typeof Ue == "object" && Ue !== null && Ue.$$typeof === ge && HO(Ue) === Se.type) {
            r(K, Se.sibling);
            var ht = l(Se, J.props);
            return ht.ref = fu(K, Se, J), ht.return = K, ht._debugSource = J._source, ht._debugOwner = J._owner, ht;
          }
          r(K, Se);
          break;
        } else
          t(K, Se);
        Se = Se.sibling;
      }
      if (J.type === ua) {
        var rt = Hi(J.props.children, K.mode, ce, J.key);
        return rt.return = K, rt;
      } else {
        var Xt = Ip(J, K.mode, ce);
        return Xt.ref = fu(K, ae, J), Xt.return = K, Xt;
      }
    }
    function Qe(K, ae, J, ce) {
      for (var Oe = J.key, Se = ae; Se !== null; ) {
        if (Se.key === Oe)
          if (Se.tag === m && Se.stateNode.containerInfo === J.containerInfo && Se.stateNode.implementation === J.implementation) {
            r(K, Se.sibling);
            var Ue = l(Se, J.children || []);
            return Ue.return = K, Ue;
          } else {
            r(K, Se);
            break;
          }
        else
          t(K, Se);
        Se = Se.sibling;
      }
      var He = Cp(J, K.mode, ce);
      return He.return = K, He;
    }
    function Xe(K, ae, J, ce) {
      var Oe = typeof J == "object" && J !== null && J.type === ua && J.key === null;
      if (Oe && (J = J.props.children), typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case la:
            return A(me(K, ae, J, ce));
          case kr:
            return A(Qe(K, ae, J, ce));
          case ge:
            var Se = J._payload, Ue = J._init;
            return Xe(K, ae, Ue(Se), ce);
        }
        if (st(J))
          return re(K, ae, J, ce);
        if (ba(J))
          return Ne(K, ae, J, ce);
        wc(K, J);
      }
      return typeof J == "string" && J !== "" || typeof J == "number" ? A(ye(K, ae, "" + J, ce)) : (typeof J == "function" && Gc(K), r(K, ae));
    }
    return Xe;
  }
  var mo = BO(!0), FO = BO(!1);
  function fb(e, t) {
    if (e !== null && t.child !== e.child)
      throw new Error("Resuming work not yet implemented.");
    if (t.child !== null) {
      var r = t.child, i = ys(r, r.pendingProps);
      for (t.child = i, i.return = t; r.sibling !== null; )
        r = r.sibling, i = i.sibling = ys(r, r.pendingProps), i.return = t;
      i.sibling = null;
    }
  }
  function Tb(e, t) {
    for (var r = e.child; r !== null; )
      VP(r, t), r = r.sibling;
  }
  var Tu = {}, gi = Ci(Tu), du = Ci(Tu), Hc = Ci(Tu);
  function Bc(e) {
    if (e === Tu)
      throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
    return e;
  }
  function YO() {
    var e = Bc(Hc.current);
    return e;
  }
  function ZA(e, t) {
    Yn(Hc, t, e), Yn(du, e, e), Yn(gi, Tu, e);
    var r = Lg(t);
    Fn(gi, e), Yn(gi, r, e);
  }
  function vo(e) {
    Fn(gi, e), Fn(du, e), Fn(Hc, e);
  }
  function qA() {
    var e = Bc(gi.current);
    return e;
  }
  function VO(e) {
    Bc(Hc.current);
    var t = Bc(gi.current), r = yg(t, e.type);
    t !== r && (Yn(du, e, e), Yn(gi, r, e));
  }
  function QA(e) {
    du.current === e && (Fn(gi, e), Fn(du, e));
  }
  var db = 0, WO = 1, kO = 1, Au = 2, Qr = Ci(db);
  function $A(e, t) {
    return (e & t) !== 0;
  }
  function Lo(e) {
    return e & WO;
  }
  function eR(e, t) {
    return e & WO | t;
  }
  function Ab(e, t) {
    return e | t;
  }
  function Di(e, t) {
    Yn(Qr, t, e);
  }
  function yo(e) {
    Fn(Qr, e);
  }
  function Rb(e, t) {
    var r = e.memoizedState;
    return r !== null ? r.dehydrated !== null : (e.memoizedProps, !0);
  }
  function Fc(e) {
    for (var t = e; t !== null; ) {
      if (t.tag === G) {
        var r = t.memoizedState;
        if (r !== null) {
          var i = r.dehydrated;
          if (i === null || eO(i) || sA(i))
            return t;
        }
      } else if (t.tag === F && // revealOrder undefined can't be trusted because it don't
      // keep track of whether it suspended or not.
      t.memoizedProps.revealOrder !== void 0) {
        var l = (t.flags & ct) !== be;
        if (l)
          return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === e)
        return null;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e)
          return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var go = (
    /*   */
    0
  ), an = (
    /* */
    1
  ), Aa = (
    /*  */
    2
  ), zn = (
    /*    */
    4
  ), Ir = (
    /*   */
    8
  ), tR = [];
  function nR() {
    for (var e = 0; e < tR.length; e++) {
      var t = tR[e];
      t._workInProgressVersionPrimary = null;
    }
    tR.length = 0;
  }
  function pb(e, t) {
    var r = t._getVersion, i = r(t._source);
    e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [t, i] : e.mutableSourceEagerHydrationData.push(t, i);
  }
  var he = s.ReactCurrentDispatcher, Ru = s.ReactCurrentBatchConfig, rR, Do;
  rR = /* @__PURE__ */ new Set();
  var Os = le, St = null, sn = null, on = null, Yc = !1, pu = !1, Su = 0, Sb = 0, hb = 25, ie = null, Gr = null, bi = -1, aR = !1;
  function lt() {
    {
      var e = ie;
      Gr === null ? Gr = [e] : Gr.push(e);
    }
  }
  function Ae() {
    {
      var e = ie;
      Gr !== null && (bi++, Gr[bi] !== e && Nb(e));
    }
  }
  function bo(e) {
    e != null && !st(e) && u("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", ie, typeof e);
  }
  function Nb(e) {
    {
      var t = Ye(St);
      if (!rR.has(t) && (rR.add(t), Gr !== null)) {
        for (var r = "", i = 30, l = 0; l <= bi; l++) {
          for (var f = Gr[l], A = l === bi ? e : f, h = l + 1 + ". " + f; h.length < i; )
            h += " ";
          h += A + `
`, r += h;
        }
        u(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, t, r);
      }
    }
  }
  function Vn() {
    throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
  }
  function iR(e, t) {
    if (aR)
      return !1;
    if (t === null)
      return u("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", ie), !1;
    e.length !== t.length && u(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, ie, "[" + t.join(", ") + "]", "[" + e.join(", ") + "]");
    for (var r = 0; r < t.length && r < e.length; r++)
      if (!Nr(e[r], t[r]))
        return !1;
    return !0;
  }
  function Mo(e, t, r, i, l, f) {
    Os = f, St = t, Gr = e !== null ? e._debugHookTypes : null, bi = -1, aR = e !== null && e.type !== t.type, t.memoizedState = null, t.updateQueue = null, t.lanes = le, e !== null && e.memoizedState !== null ? he.current = cI : Gr !== null ? he.current = EI : he.current = uI;
    var A = r(i, l);
    if (pu) {
      var h = 0;
      do {
        if (pu = !1, Su = 0, h >= hb)
          throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        h += 1, aR = !1, sn = null, on = null, t.updateQueue = null, bi = -1, he.current = fI, A = r(i, l);
      } while (pu);
    }
    he.current = ef, t._debugHookTypes = Gr;
    var I = sn !== null && sn.next !== null;
    if (Os = le, St = null, sn = null, on = null, ie = null, Gr = null, bi = -1, e !== null && (e.flags & Fa) !== (t.flags & Fa) && // Disable this warning in legacy mode, because legacy Suspense is weird
    // and creates false positives. To make this work in legacy mode, we'd
    // need to mark fibers that commit in an incomplete state, somehow. For
    // now I'll disable the warning that most of the bugs that would trigger
    // it are either exclusive to concurrent mode or exist in both.
    (e.mode & Ze) !== Me && u("Internal React error: Expected static flag was missing. Please notify the React team."), Yc = !1, I)
      throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
    return A;
  }
  function Po() {
    var e = Su !== 0;
    return Su = 0, e;
  }
  function XO(e, t, r) {
    t.updateQueue = e.updateQueue, (t.mode & fa) !== Me ? t.flags &= ~(UE | Ba | Xr | tt) : t.flags &= ~(Xr | tt), e.lanes = VE(e.lanes, r);
  }
  function jO() {
    if (he.current = ef, Yc) {
      for (var e = St.memoizedState; e !== null; ) {
        var t = e.queue;
        t !== null && (t.pending = null), e = e.next;
      }
      Yc = !1;
    }
    Os = le, St = null, sn = null, on = null, Gr = null, bi = -1, ie = null, iI = !1, pu = !1, Su = 0;
  }
  function Ra() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return on === null ? St.memoizedState = on = e : on = on.next = e, on;
  }
  function Hr() {
    var e;
    if (sn === null) {
      var t = St.alternate;
      t !== null ? e = t.memoizedState : e = null;
    } else
      e = sn.next;
    var r;
    if (on === null ? r = St.memoizedState : r = on.next, r !== null)
      on = r, r = on.next, sn = e;
    else {
      if (e === null)
        throw new Error("Rendered more hooks than during the previous render.");
      sn = e;
      var i = {
        memoizedState: sn.memoizedState,
        baseState: sn.baseState,
        baseQueue: sn.baseQueue,
        queue: sn.queue,
        next: null
      };
      on === null ? St.memoizedState = on = i : on = on.next = i;
    }
    return on;
  }
  function KO() {
    return {
      lastEffect: null,
      stores: null
    };
  }
  function sR(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  function oR(e, t, r) {
    var i = Ra(), l;
    r !== void 0 ? l = r(t) : l = t, i.memoizedState = i.baseState = l;
    var f = {
      pending: null,
      interleaved: null,
      lanes: le,
      dispatch: null,
      lastRenderedReducer: e,
      lastRenderedState: l
    };
    i.queue = f;
    var A = f.dispatch = Cb.bind(null, St, f);
    return [i.memoizedState, A];
  }
  function lR(e, t, r) {
    var i = Hr(), l = i.queue;
    if (l === null)
      throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
    l.lastRenderedReducer = e;
    var f = sn, A = f.baseQueue, h = l.pending;
    if (h !== null) {
      if (A !== null) {
        var I = A.next, L = h.next;
        A.next = L, h.next = I;
      }
      f.baseQueue !== A && u("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), f.baseQueue = A = h, l.pending = null;
    }
    if (A !== null) {
      var b = A.next, k = f.baseState, W = null, q = null, Q = null, re = b;
      do {
        var Ne = re.lane;
        if (oo(Os, Ne)) {
          if (Q !== null) {
            var me = {
              // This update is going to be committed so we never want uncommit
              // it. Using NoLane works because 0 is a subset of all bitmasks, so
              // this will never be skipped by the check above.
              lane: Nn,
              action: re.action,
              hasEagerState: re.hasEagerState,
              eagerState: re.eagerState,
              next: null
            };
            Q = Q.next = me;
          }
          if (re.hasEagerState)
            k = re.eagerState;
          else {
            var Qe = re.action;
            k = e(k, Qe);
          }
        } else {
          var ye = {
            lane: Ne,
            action: re.action,
            hasEagerState: re.hasEagerState,
            eagerState: re.eagerState,
            next: null
          };
          Q === null ? (q = Q = ye, W = k) : Q = Q.next = ye, St.lanes = We(St.lanes, Ne), Gu(Ne);
        }
        re = re.next;
      } while (re !== null && re !== b);
      Q === null ? W = k : Q.next = q, Nr(k, i.memoizedState) || mu(), i.memoizedState = k, i.baseState = W, i.baseQueue = Q, l.lastRenderedState = k;
    }
    var Xe = l.interleaved;
    if (Xe !== null) {
      var K = Xe;
      do {
        var ae = K.lane;
        St.lanes = We(St.lanes, ae), Gu(ae), K = K.next;
      } while (K !== Xe);
    } else
      A === null && (l.lanes = le);
    var J = l.dispatch;
    return [i.memoizedState, J];
  }
  function uR(e, t, r) {
    var i = Hr(), l = i.queue;
    if (l === null)
      throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
    l.lastRenderedReducer = e;
    var f = l.dispatch, A = l.pending, h = i.memoizedState;
    if (A !== null) {
      l.pending = null;
      var I = A.next, L = I;
      do {
        var b = L.action;
        h = e(h, b), L = L.next;
      } while (L !== I);
      Nr(h, i.memoizedState) || mu(), i.memoizedState = h, i.baseQueue === null && (i.baseState = h), l.lastRenderedState = h;
    }
    return [h, f];
  }
  function t8(e, t, r) {
  }
  function n8(e, t, r) {
  }
  function ER(e, t, r) {
    var i = St, l = Ra(), f, A = mn();
    if (A) {
      if (r === void 0)
        throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
      f = r(), Do || f !== r() && (u("The result of getServerSnapshot should be cached to avoid an infinite loop"), Do = !0);
    } else {
      if (f = t(), !Do) {
        var h = t();
        Nr(f, h) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), Do = !0);
      }
      var I = hf();
      if (I === null)
        throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
      YE(I, Os) || JO(i, t, f);
    }
    l.memoizedState = f;
    var L = {
      value: f,
      getSnapshot: t
    };
    return l.queue = L, jc(ZO.bind(null, i, L, e), [e]), i.flags |= Xr, hu(an | Ir, zO.bind(null, i, L, f, t), void 0, null), f;
  }
  function Vc(e, t, r) {
    var i = St, l = Hr(), f = t();
    if (!Do) {
      var A = t();
      Nr(f, A) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), Do = !0);
    }
    var h = l.memoizedState, I = !Nr(h, f);
    I && (l.memoizedState = f, mu());
    var L = l.queue;
    if (Ou(ZO.bind(null, i, L, e), [e]), L.getSnapshot !== t || I || // Check if the susbcribe function changed. We can save some memory by
    // checking whether we scheduled a subscription effect above.
    on !== null && on.memoizedState.tag & an) {
      i.flags |= Xr, hu(an | Ir, zO.bind(null, i, L, f, t), void 0, null);
      var b = hf();
      if (b === null)
        throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
      YE(b, Os) || JO(i, t, f);
    }
    return f;
  }
  function JO(e, t, r) {
    e.flags |= PE;
    var i = {
      getSnapshot: t,
      value: r
    }, l = St.updateQueue;
    if (l === null)
      l = KO(), St.updateQueue = l, l.stores = [i];
    else {
      var f = l.stores;
      f === null ? l.stores = [i] : f.push(i);
    }
  }
  function zO(e, t, r, i) {
    t.value = r, t.getSnapshot = i, qO(t) && QO(e);
  }
  function ZO(e, t, r) {
    var i = function() {
      qO(t) && QO(e);
    };
    return r(i);
  }
  function qO(e) {
    var t = e.getSnapshot, r = e.value;
    try {
      var i = t();
      return !Nr(r, i);
    } catch {
      return !0;
    }
  }
  function QO(e) {
    var t = ur(e, Ge);
    t !== null && cn(t, e, Ge, mt);
  }
  function Wc(e) {
    var t = Ra();
    typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e;
    var r = {
      pending: null,
      interleaved: null,
      lanes: le,
      dispatch: null,
      lastRenderedReducer: sR,
      lastRenderedState: e
    };
    t.queue = r;
    var i = r.dispatch = mb.bind(null, St, r);
    return [t.memoizedState, i];
  }
  function cR(e) {
    return lR(sR);
  }
  function fR(e) {
    return uR(sR);
  }
  function hu(e, t, r, i) {
    var l = {
      tag: e,
      create: t,
      destroy: r,
      deps: i,
      // Circular
      next: null
    }, f = St.updateQueue;
    if (f === null)
      f = KO(), St.updateQueue = f, f.lastEffect = l.next = l;
    else {
      var A = f.lastEffect;
      if (A === null)
        f.lastEffect = l.next = l;
      else {
        var h = A.next;
        A.next = l, l.next = h, f.lastEffect = l;
      }
    }
    return l;
  }
  function TR(e) {
    var t = Ra();
    {
      var r = {
        current: e
      };
      return t.memoizedState = r, r;
    }
  }
  function kc(e) {
    var t = Hr();
    return t.memoizedState;
  }
  function Nu(e, t, r, i) {
    var l = Ra(), f = i === void 0 ? null : i;
    St.flags |= e, l.memoizedState = hu(an | t, r, void 0, f);
  }
  function Xc(e, t, r, i) {
    var l = Hr(), f = i === void 0 ? null : i, A = void 0;
    if (sn !== null) {
      var h = sn.memoizedState;
      if (A = h.destroy, f !== null) {
        var I = h.deps;
        if (iR(f, I)) {
          l.memoizedState = hu(t, r, A, f);
          return;
        }
      }
    }
    St.flags |= e, l.memoizedState = hu(an | t, r, A, f);
  }
  function jc(e, t) {
    return (St.mode & fa) !== Me ? Nu(UE | Xr | $T, Ir, e, t) : Nu(Xr | $T, Ir, e, t);
  }
  function Ou(e, t) {
    return Xc(Xr, Ir, e, t);
  }
  function dR(e, t) {
    return Nu(tt, Aa, e, t);
  }
  function Kc(e, t) {
    return Xc(tt, Aa, e, t);
  }
  function AR(e, t) {
    var r = tt;
    return r |= os, (St.mode & fa) !== Me && (r |= Ba), Nu(r, zn, e, t);
  }
  function Jc(e, t) {
    return Xc(tt, zn, e, t);
  }
  function $O(e, t) {
    if (typeof t == "function") {
      var r = t, i = e();
      return r(i), function() {
        r(null);
      };
    } else if (t != null) {
      var l = t;
      l.hasOwnProperty("current") || u("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(l).join(", ") + "}");
      var f = e();
      return l.current = f, function() {
        l.current = null;
      };
    }
  }
  function RR(e, t, r) {
    typeof t != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
    var i = r != null ? r.concat([e]) : null, l = tt;
    return l |= os, (St.mode & fa) !== Me && (l |= Ba), Nu(l, zn, $O.bind(null, t, e), i);
  }
  function zc(e, t, r) {
    typeof t != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", t !== null ? typeof t : "null");
    var i = r != null ? r.concat([e]) : null;
    return Xc(tt, zn, $O.bind(null, t, e), i);
  }
  function Ob(e, t) {
  }
  var Zc = Ob;
  function pR(e, t) {
    var r = Ra(), i = t === void 0 ? null : t;
    return r.memoizedState = [e, i], e;
  }
  function qc(e, t) {
    var r = Hr(), i = t === void 0 ? null : t, l = r.memoizedState;
    if (l !== null && i !== null) {
      var f = l[1];
      if (iR(i, f))
        return l[0];
    }
    return r.memoizedState = [e, i], e;
  }
  function SR(e, t) {
    var r = Ra(), i = t === void 0 ? null : t, l = e();
    return r.memoizedState = [l, i], l;
  }
  function Qc(e, t) {
    var r = Hr(), i = t === void 0 ? null : t, l = r.memoizedState;
    if (l !== null && i !== null) {
      var f = l[1];
      if (iR(i, f))
        return l[0];
    }
    var A = e();
    return r.memoizedState = [A, i], A;
  }
  function hR(e) {
    var t = Ra();
    return t.memoizedState = e, e;
  }
  function eI(e) {
    var t = Hr(), r = sn, i = r.memoizedState;
    return nI(t, i, e);
  }
  function tI(e) {
    var t = Hr();
    if (sn === null)
      return t.memoizedState = e, e;
    var r = sn.memoizedState;
    return nI(t, r, e);
  }
  function nI(e, t, r) {
    var i = !r1(Os);
    if (i) {
      if (!Nr(r, t)) {
        var l = Xh();
        St.lanes = We(St.lanes, l), Gu(l), e.baseState = !0;
      }
      return t;
    } else
      return e.baseState && (e.baseState = !1, mu()), e.memoizedState = r, r;
  }
  function Ib(e, t, r) {
    var i = Kr();
    On(f1(i, Ai)), e(!0);
    var l = Ru.transition;
    Ru.transition = {};
    var f = Ru.transition;
    Ru.transition._updatedFibers = /* @__PURE__ */ new Set();
    try {
      e(!1), t();
    } finally {
      if (On(i), Ru.transition = l, l === null && f._updatedFibers) {
        var A = f._updatedFibers.size;
        A > 10 && E("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), f._updatedFibers.clear();
      }
    }
  }
  function NR() {
    var e = Wc(!1), t = e[0], r = e[1], i = Ib.bind(null, r), l = Ra();
    return l.memoizedState = i, [t, i];
  }
  function rI() {
    var e = cR(), t = e[0], r = Hr(), i = r.memoizedState;
    return [t, i];
  }
  function aI() {
    var e = fR(), t = e[0], r = Hr(), i = r.memoizedState;
    return [t, i];
  }
  var iI = !1;
  function _b() {
    return iI;
  }
  function IR() {
    var e = Ra(), t = hf(), r = t.identifierPrefix, i;
    if (mn()) {
      var l = GD();
      i = ":" + r + "R" + l;
      var f = Su++;
      f > 0 && (i += "H" + f.toString(32)), i += ":";
    } else {
      var A = Sb++;
      i = ":" + r + "r" + A.toString(32) + ":";
    }
    return e.memoizedState = i, i;
  }
  function $c() {
    var e = Hr(), t = e.memoizedState;
    return t;
  }
  function Cb(e, t, r) {
    typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
    var i = wi(e), l = {
      lane: i,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (sI(e))
      oI(t, l);
    else {
      var f = CO(e, t, l, i);
      if (f !== null) {
        var A = Qn();
        cn(f, e, i, A), lI(f, t, i);
      }
    }
  }
  function mb(e, t, r) {
    typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
    var i = wi(e), l = {
      lane: i,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (sI(e))
      oI(t, l);
    else {
      var f = e.alternate;
      if (e.lanes === le && (f === null || f.lanes === le)) {
        var A = t.lastRenderedReducer;
        if (A !== null) {
          var h;
          h = he.current, he.current = $r;
          try {
            var I = t.lastRenderedState, L = A(I, r);
            if (l.hasEagerState = !0, l.eagerState = L, Nr(L, I)) {
              rb(e, t, l, i);
              return;
            }
          } catch {
          } finally {
            he.current = h;
          }
        }
      }
      var b = CO(e, t, l, i);
      if (b !== null) {
        var k = Qn();
        cn(b, e, i, k), lI(b, t, i);
      }
    }
  }
  function sI(e) {
    var t = e.alternate;
    return e === St || t !== null && t === St;
  }
  function oI(e, t) {
    pu = Yc = !0;
    var r = e.pending;
    r === null ? t.next = t : (t.next = r.next, r.next = t), e.pending = t;
  }
  function lI(e, t, r) {
    if (kh(r)) {
      var i = t.lanes;
      i = jh(i, e.pendingLanes);
      var l = We(i, r);
      t.lanes = l, Ld(e, l);
    }
  }
  var ef = {
    readContext: Qt,
    useCallback: Vn,
    useContext: Vn,
    useEffect: Vn,
    useImperativeHandle: Vn,
    useInsertionEffect: Vn,
    useLayoutEffect: Vn,
    useMemo: Vn,
    useReducer: Vn,
    useRef: Vn,
    useState: Vn,
    useDebugValue: Vn,
    useDeferredValue: Vn,
    useTransition: Vn,
    useMutableSource: Vn,
    useSyncExternalStore: Vn,
    useId: Vn,
    unstable_isNewReconciler: de
  }, uI = null, EI = null, cI = null, fI = null, pa = null, $r = null, tf = null;
  {
    var _R = function() {
      u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }, we = function() {
      u("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    uI = {
      readContext: function(e) {
        return Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", lt(), bo(t), pR(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", lt(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", lt(), bo(t), jc(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", lt(), bo(r), RR(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", lt(), bo(t), dR(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", lt(), bo(t), AR(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", lt(), bo(t);
        var r = he.current;
        he.current = pa;
        try {
          return SR(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", lt();
        var i = he.current;
        he.current = pa;
        try {
          return oR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", lt(), TR(e);
      },
      useState: function(e) {
        ie = "useState", lt();
        var t = he.current;
        he.current = pa;
        try {
          return Wc(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", lt(), void 0;
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", lt(), hR(e);
      },
      useTransition: function() {
        return ie = "useTransition", lt(), NR();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", lt(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", lt(), ER(e, t, r);
      },
      useId: function() {
        return ie = "useId", lt(), IR();
      },
      unstable_isNewReconciler: de
    }, EI = {
      readContext: function(e) {
        return Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", Ae(), pR(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", Ae(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", Ae(), jc(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", Ae(), RR(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", Ae(), dR(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", Ae(), AR(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", Ae();
        var r = he.current;
        he.current = pa;
        try {
          return SR(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", Ae();
        var i = he.current;
        he.current = pa;
        try {
          return oR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", Ae(), TR(e);
      },
      useState: function(e) {
        ie = "useState", Ae();
        var t = he.current;
        he.current = pa;
        try {
          return Wc(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", Ae(), void 0;
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", Ae(), hR(e);
      },
      useTransition: function() {
        return ie = "useTransition", Ae(), NR();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", Ae(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", Ae(), ER(e, t, r);
      },
      useId: function() {
        return ie = "useId", Ae(), IR();
      },
      unstable_isNewReconciler: de
    }, cI = {
      readContext: function(e) {
        return Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", Ae(), qc(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", Ae(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", Ae(), Ou(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", Ae(), zc(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", Ae(), Kc(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", Ae(), Jc(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", Ae();
        var r = he.current;
        he.current = $r;
        try {
          return Qc(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", Ae();
        var i = he.current;
        he.current = $r;
        try {
          return lR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", Ae(), kc();
      },
      useState: function(e) {
        ie = "useState", Ae();
        var t = he.current;
        he.current = $r;
        try {
          return cR(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", Ae(), Zc();
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", Ae(), eI(e);
      },
      useTransition: function() {
        return ie = "useTransition", Ae(), rI();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", Ae(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", Ae(), Vc(e, t);
      },
      useId: function() {
        return ie = "useId", Ae(), $c();
      },
      unstable_isNewReconciler: de
    }, fI = {
      readContext: function(e) {
        return Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", Ae(), qc(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", Ae(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", Ae(), Ou(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", Ae(), zc(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", Ae(), Kc(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", Ae(), Jc(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", Ae();
        var r = he.current;
        he.current = tf;
        try {
          return Qc(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", Ae();
        var i = he.current;
        he.current = tf;
        try {
          return uR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", Ae(), kc();
      },
      useState: function(e) {
        ie = "useState", Ae();
        var t = he.current;
        he.current = tf;
        try {
          return fR(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", Ae(), Zc();
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", Ae(), tI(e);
      },
      useTransition: function() {
        return ie = "useTransition", Ae(), aI();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", Ae(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", Ae(), Vc(e, t);
      },
      useId: function() {
        return ie = "useId", Ae(), $c();
      },
      unstable_isNewReconciler: de
    }, pa = {
      readContext: function(e) {
        return _R(), Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", we(), lt(), pR(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", we(), lt(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", we(), lt(), jc(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", we(), lt(), RR(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", we(), lt(), dR(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", we(), lt(), AR(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", we(), lt();
        var r = he.current;
        he.current = pa;
        try {
          return SR(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", we(), lt();
        var i = he.current;
        he.current = pa;
        try {
          return oR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", we(), lt(), TR(e);
      },
      useState: function(e) {
        ie = "useState", we(), lt();
        var t = he.current;
        he.current = pa;
        try {
          return Wc(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", we(), lt(), void 0;
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", we(), lt(), hR(e);
      },
      useTransition: function() {
        return ie = "useTransition", we(), lt(), NR();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", we(), lt(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", we(), lt(), ER(e, t, r);
      },
      useId: function() {
        return ie = "useId", we(), lt(), IR();
      },
      unstable_isNewReconciler: de
    }, $r = {
      readContext: function(e) {
        return _R(), Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", we(), Ae(), qc(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", we(), Ae(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", we(), Ae(), Ou(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", we(), Ae(), zc(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", we(), Ae(), Kc(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", we(), Ae(), Jc(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", we(), Ae();
        var r = he.current;
        he.current = $r;
        try {
          return Qc(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", we(), Ae();
        var i = he.current;
        he.current = $r;
        try {
          return lR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", we(), Ae(), kc();
      },
      useState: function(e) {
        ie = "useState", we(), Ae();
        var t = he.current;
        he.current = $r;
        try {
          return cR(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", we(), Ae(), Zc();
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", we(), Ae(), eI(e);
      },
      useTransition: function() {
        return ie = "useTransition", we(), Ae(), rI();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", we(), Ae(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", we(), Ae(), Vc(e, t);
      },
      useId: function() {
        return ie = "useId", we(), Ae(), $c();
      },
      unstable_isNewReconciler: de
    }, tf = {
      readContext: function(e) {
        return _R(), Qt(e);
      },
      useCallback: function(e, t) {
        return ie = "useCallback", we(), Ae(), qc(e, t);
      },
      useContext: function(e) {
        return ie = "useContext", we(), Ae(), Qt(e);
      },
      useEffect: function(e, t) {
        return ie = "useEffect", we(), Ae(), Ou(e, t);
      },
      useImperativeHandle: function(e, t, r) {
        return ie = "useImperativeHandle", we(), Ae(), zc(e, t, r);
      },
      useInsertionEffect: function(e, t) {
        return ie = "useInsertionEffect", we(), Ae(), Kc(e, t);
      },
      useLayoutEffect: function(e, t) {
        return ie = "useLayoutEffect", we(), Ae(), Jc(e, t);
      },
      useMemo: function(e, t) {
        ie = "useMemo", we(), Ae();
        var r = he.current;
        he.current = $r;
        try {
          return Qc(e, t);
        } finally {
          he.current = r;
        }
      },
      useReducer: function(e, t, r) {
        ie = "useReducer", we(), Ae();
        var i = he.current;
        he.current = $r;
        try {
          return uR(e, t, r);
        } finally {
          he.current = i;
        }
      },
      useRef: function(e) {
        return ie = "useRef", we(), Ae(), kc();
      },
      useState: function(e) {
        ie = "useState", we(), Ae();
        var t = he.current;
        he.current = $r;
        try {
          return fR(e);
        } finally {
          he.current = t;
        }
      },
      useDebugValue: function(e, t) {
        return ie = "useDebugValue", we(), Ae(), Zc();
      },
      useDeferredValue: function(e) {
        return ie = "useDeferredValue", we(), Ae(), tI(e);
      },
      useTransition: function() {
        return ie = "useTransition", we(), Ae(), aI();
      },
      useMutableSource: function(e, t, r) {
        return ie = "useMutableSource", we(), Ae(), void 0;
      },
      useSyncExternalStore: function(e, t, r) {
        return ie = "useSyncExternalStore", we(), Ae(), Vc(e, t);
      },
      useId: function() {
        return ie = "useId", we(), Ae(), $c();
      },
      unstable_isNewReconciler: de
    };
  }
  var Mi = a.unstable_now, TI = 0, nf = -1, Iu = -1, rf = -1, CR = !1, af = !1;
  function dI() {
    return CR;
  }
  function vb() {
    af = !0;
  }
  function Lb() {
    CR = !1, af = !1;
  }
  function yb() {
    CR = af, af = !1;
  }
  function AI() {
    return TI;
  }
  function RI() {
    TI = Mi();
  }
  function mR(e) {
    Iu = Mi(), e.actualStartTime < 0 && (e.actualStartTime = Mi());
  }
  function pI(e) {
    Iu = -1;
  }
  function sf(e, t) {
    if (Iu >= 0) {
      var r = Mi() - Iu;
      e.actualDuration += r, t && (e.selfBaseDuration = r), Iu = -1;
    }
  }
  function Sa(e) {
    if (nf >= 0) {
      var t = Mi() - nf;
      nf = -1;
      for (var r = e.return; r !== null; ) {
        switch (r.tag) {
          case N:
            var i = r.stateNode;
            i.effectDuration += t;
            return;
          case D:
            var l = r.stateNode;
            l.effectDuration += t;
            return;
        }
        r = r.return;
      }
    }
  }
  function vR(e) {
    if (rf >= 0) {
      var t = Mi() - rf;
      rf = -1;
      for (var r = e.return; r !== null; ) {
        switch (r.tag) {
          case N:
            var i = r.stateNode;
            i !== null && (i.passiveEffectDuration += t);
            return;
          case D:
            var l = r.stateNode;
            l !== null && (l.passiveEffectDuration += t);
            return;
        }
        r = r.return;
      }
    }
  }
  function ha() {
    nf = Mi();
  }
  function LR() {
    rf = Mi();
  }
  function yR(e) {
    for (var t = e.child; t; )
      e.actualDuration += t.actualDuration, t = t.sibling;
  }
  function Is(e, t) {
    return {
      value: e,
      source: t,
      stack: cl(t),
      digest: null
    };
  }
  function gR(e, t, r) {
    return {
      value: e,
      source: null,
      stack: r ?? null,
      digest: t ?? null
    };
  }
  function gb(e, t) {
    return !0;
  }
  function DR(e, t) {
    try {
      var r = gb(e, t);
      if (r === !1)
        return;
      var i = t.value, l = t.source, f = t.stack, A = f !== null ? f : "";
      if (i != null && i._suppressLogging) {
        if (e.tag === T)
          return;
        console.error(i);
      }
      var h = l ? Ye(l) : null, I = h ? "The above error occurred in the <" + h + "> component:" : "The above error occurred in one of your React components:", L;
      if (e.tag === N)
        L = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
      else {
        var b = Ye(e) || "Anonymous";
        L = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + b + ".");
      }
      var k = I + `
` + A + `

` + ("" + L);
      console.error(k);
    } catch (W) {
      setTimeout(function() {
        throw W;
      });
    }
  }
  var Db = typeof WeakMap == "function" ? WeakMap : Map;
  function SI(e, t, r) {
    var i = Ka(mt, r);
    i.tag = gA, i.payload = {
      element: null
    };
    var l = t.value;
    return i.callback = function() {
      IP(l), DR(e, t);
    }, i;
  }
  function bR(e, t, r) {
    var i = Ka(mt, r);
    i.tag = gA;
    var l = e.type.getDerivedStateFromError;
    if (typeof l == "function") {
      var f = t.value;
      i.payload = function() {
        return l(f);
      }, i.callback = function() {
        g_(e), DR(e, t);
      };
    }
    var A = e.stateNode;
    return A !== null && typeof A.componentDidCatch == "function" && (i.callback = function() {
      g_(e), DR(e, t), typeof l != "function" && NP(this);
      var I = t.value, L = t.stack;
      this.componentDidCatch(I, {
        componentStack: L !== null ? L : ""
      }), typeof l != "function" && (Sr(e.lanes, Ge) || u("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", Ye(e) || "Unknown"));
    }), i;
  }
  function hI(e, t, r) {
    var i = e.pingCache, l;
    if (i === null ? (i = e.pingCache = new Db(), l = /* @__PURE__ */ new Set(), i.set(t, l)) : (l = i.get(t), l === void 0 && (l = /* @__PURE__ */ new Set(), i.set(t, l))), !l.has(r)) {
      l.add(r);
      var f = _P.bind(null, e, t, r);
      jr && Hu(e, r), t.then(f, f);
    }
  }
  function bb(e, t, r, i) {
    var l = e.updateQueue;
    if (l === null) {
      var f = /* @__PURE__ */ new Set();
      f.add(r), e.updateQueue = f;
    } else
      l.add(r);
  }
  function Mb(e, t) {
    var r = e.tag;
    if ((e.mode & Ze) === Me && (r === d || r === V || r === U)) {
      var i = e.alternate;
      i ? (e.updateQueue = i.updateQueue, e.memoizedState = i.memoizedState, e.lanes = i.lanes) : (e.updateQueue = null, e.memoizedState = null);
    }
  }
  function NI(e) {
    var t = e;
    do {
      if (t.tag === G && Rb(t))
        return t;
      t = t.return;
    } while (t !== null);
    return null;
  }
  function OI(e, t, r, i, l) {
    if ((e.mode & Ze) === Me) {
      if (e === t)
        e.flags |= Jn;
      else {
        if (e.flags |= ct, r.flags |= qT, r.flags &= ~(x0 | _l), r.tag === T) {
          var f = r.alternate;
          if (f === null)
            r.tag = X;
          else {
            var A = Ka(mt, Ge);
            A.tag = gc, yi(r, A, Ge);
          }
        }
        r.lanes = We(r.lanes, Ge);
      }
      return e;
    }
    return e.flags |= Jn, e.lanes = l, e;
  }
  function Pb(e, t, r, i, l) {
    if (r.flags |= _l, jr && Hu(e, l), i !== null && typeof i == "object" && typeof i.then == "function") {
      var f = i;
      Mb(r), mn() && r.mode & Ze && fO();
      var A = NI(t);
      if (A !== null) {
        A.flags &= ~Ga, OI(A, t, r, e, l), A.mode & Ze && hI(e, f, l), bb(A, e, f);
        return;
      } else {
        if (!n1(l)) {
          hI(e, f, l), Ep();
          return;
        }
        var h = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
        i = h;
      }
    } else if (mn() && r.mode & Ze) {
      fO();
      var I = NI(t);
      if (I !== null) {
        (I.flags & Jn) === be && (I.flags |= Ga), OI(I, t, r, e, l), IA(Is(i, r));
        return;
      }
    }
    i = Is(i, r), fP(i);
    var L = t;
    do {
      switch (L.tag) {
        case N: {
          var b = i;
          L.flags |= Jn;
          var k = Dl(l);
          L.lanes = We(L.lanes, k);
          var W = SI(L, b, k);
          MA(L, W);
          return;
        }
        case T:
          var q = i, Q = L.type, re = L.stateNode;
          if ((L.flags & ct) === be && (typeof Q.getDerivedStateFromError == "function" || re !== null && typeof re.componentDidCatch == "function" && !N_(re))) {
            L.flags |= Jn;
            var Ne = Dl(l);
            L.lanes = We(L.lanes, Ne);
            var ye = bR(L, q, Ne);
            MA(L, ye);
            return;
          }
          break;
      }
      L = L.return;
    } while (L !== null);
  }
  function Ub() {
    return null;
  }
  var _u = s.ReactCurrentOwner, ea = !1, MR, Cu, PR, UR, xR, _s, wR, of;
  MR = {}, Cu = {}, PR = {}, UR = {}, xR = {}, _s = !1, wR = {}, of = {};
  function Zn(e, t, r, i) {
    e === null ? t.child = FO(t, null, r, i) : t.child = mo(t, e.child, r, i);
  }
  function xb(e, t, r, i) {
    t.child = mo(t, e.child, null, i), t.child = mo(t, null, r, i);
  }
  function II(e, t, r, i, l) {
    if (t.type !== t.elementType) {
      var f = r.propTypes;
      f && Jr(
        f,
        i,
        // Resolved props
        "prop",
        it(r)
      );
    }
    var A = r.render, h = t.ref, I, L;
    Co(t, l);
    {
      if (_u.current = t, pr(!0), I = Mo(e, t, A, i, h, l), L = Po(), t.mode & qt) {
        hn(!0);
        try {
          I = Mo(e, t, A, i, h, l), L = Po();
        } finally {
          hn(!1);
        }
      }
      pr(!1);
    }
    return e !== null && !ea ? (XO(e, t, l), Ja(e, t, l)) : (mn() && L && RA(t), t.flags |= no, Zn(e, t, I, l), t.child);
  }
  function _I(e, t, r, i, l) {
    if (e === null) {
      var f = r.type;
      if (FP(f) && r.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
      r.defaultProps === void 0) {
        var A = f;
        return A = Yo(f), t.tag = U, t.type = A, BR(t, f), CI(e, t, A, i, l);
      }
      {
        var h = f.propTypes;
        h && Jr(
          h,
          i,
          // Resolved props
          "prop",
          it(f)
        );
      }
      var I = Op(r.type, null, i, t, t.mode, l);
      return I.ref = t.ref, I.return = t, t.child = I, I;
    }
    {
      var L = r.type, b = L.propTypes;
      b && Jr(
        b,
        i,
        // Resolved props
        "prop",
        it(L)
      );
    }
    var k = e.child, W = XR(e, l);
    if (!W) {
      var q = k.memoizedProps, Q = r.compare;
      if (Q = Q !== null ? Q : Xl, Q(q, i) && e.ref === t.ref)
        return Ja(e, t, l);
    }
    t.flags |= no;
    var re = ys(k, i);
    return re.ref = t.ref, re.return = t, t.child = re, re;
  }
  function CI(e, t, r, i, l) {
    if (t.type !== t.elementType) {
      var f = t.elementType;
      if (f.$$typeof === ge) {
        var A = f, h = A._payload, I = A._init;
        try {
          f = I(h);
        } catch {
          f = null;
        }
        var L = f && f.propTypes;
        L && Jr(
          L,
          i,
          // Resolved (SimpleMemoComponent has no defaultProps)
          "prop",
          it(f)
        );
      }
    }
    if (e !== null) {
      var b = e.memoizedProps;
      if (Xl(b, i) && e.ref === t.ref && // Prevent bailout if the implementation changed due to hot reload.
      t.type === e.type)
        if (ea = !1, t.pendingProps = i = b, XR(e, l))
          (e.flags & qT) !== be && (ea = !0);
        else
          return t.lanes = e.lanes, Ja(e, t, l);
    }
    return GR(e, t, r, i, l);
  }
  function mI(e, t, r) {
    var i = t.pendingProps, l = i.children, f = e !== null ? e.memoizedState : null;
    if (i.mode === "hidden" || Fe)
      if ((t.mode & Ze) === Me) {
        var A = {
          baseLanes: le,
          cachePool: null,
          transitions: null
        };
        t.memoizedState = A, Nf(t, r);
      } else if (Sr(r, Mr)) {
        var k = {
          baseLanes: le,
          cachePool: null,
          transitions: null
        };
        t.memoizedState = k;
        var W = f !== null ? f.baseLanes : r;
        Nf(t, W);
      } else {
        var h = null, I;
        if (f !== null) {
          var L = f.baseLanes;
          I = We(L, r);
        } else
          I = r;
        t.lanes = t.childLanes = Mr;
        var b = {
          baseLanes: I,
          cachePool: h,
          transitions: null
        };
        return t.memoizedState = b, t.updateQueue = null, Nf(t, I), null;
      }
    else {
      var q;
      f !== null ? (q = We(f.baseLanes, r), t.memoizedState = null) : q = r, Nf(t, q);
    }
    return Zn(e, t, l, r), t.child;
  }
  function wb(e, t, r) {
    var i = t.pendingProps;
    return Zn(e, t, i, r), t.child;
  }
  function Gb(e, t, r) {
    var i = t.pendingProps.children;
    return Zn(e, t, i, r), t.child;
  }
  function Hb(e, t, r) {
    {
      t.flags |= tt;
      {
        var i = t.stateNode;
        i.effectDuration = 0, i.passiveEffectDuration = 0;
      }
    }
    var l = t.pendingProps, f = l.children;
    return Zn(e, t, f, r), t.child;
  }
  function vI(e, t) {
    var r = t.ref;
    (e === null && r !== null || e !== null && e.ref !== r) && (t.flags |= Ti, t.flags |= QT);
  }
  function GR(e, t, r, i, l) {
    if (t.type !== t.elementType) {
      var f = r.propTypes;
      f && Jr(
        f,
        i,
        // Resolved props
        "prop",
        it(r)
      );
    }
    var A;
    {
      var h = So(t, r, !0);
      A = ho(t, h);
    }
    var I, L;
    Co(t, l);
    {
      if (_u.current = t, pr(!0), I = Mo(e, t, r, i, A, l), L = Po(), t.mode & qt) {
        hn(!0);
        try {
          I = Mo(e, t, r, i, A, l), L = Po();
        } finally {
          hn(!1);
        }
      }
      pr(!1);
    }
    return e !== null && !ea ? (XO(e, t, l), Ja(e, t, l)) : (mn() && L && RA(t), t.flags |= no, Zn(e, t, I, l), t.child);
  }
  function LI(e, t, r, i, l) {
    {
      switch (tU(t)) {
        case !1: {
          var f = t.stateNode, A = t.type, h = new A(t.memoizedProps, f.context), I = h.state;
          f.updater.enqueueSetState(f, I, null);
          break;
        }
        case !0: {
          t.flags |= ct, t.flags |= Jn;
          var L = new Error("Simulated error coming from DevTools"), b = Dl(l);
          t.lanes = We(t.lanes, b);
          var k = bR(t, Is(L, t), b);
          MA(t, k);
          break;
        }
      }
      if (t.type !== t.elementType) {
        var W = r.propTypes;
        W && Jr(
          W,
          i,
          // Resolved props
          "prop",
          it(r)
        );
      }
    }
    var q;
    da(r) ? (q = !0, Sc(t)) : q = !1, Co(t, l);
    var Q = t.stateNode, re;
    Q === null ? (uf(e, t), xO(t, r, i), kA(t, r, i, l), re = !0) : e === null ? re = Eb(t, r, i, l) : re = cb(e, t, r, i, l);
    var Ne = HR(e, t, r, re, q, l);
    {
      var ye = t.stateNode;
      re && ye.props !== i && (_s || u("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", Ye(t) || "a component"), _s = !0);
    }
    return Ne;
  }
  function HR(e, t, r, i, l, f) {
    vI(e, t);
    var A = (t.flags & ct) !== be;
    if (!i && !A)
      return l && lO(t, r, !1), Ja(e, t, f);
    var h = t.stateNode;
    _u.current = t;
    var I;
    if (A && typeof r.getDerivedStateFromError != "function")
      I = null, pI();
    else {
      if (pr(!0), I = h.render(), t.mode & qt) {
        hn(!0);
        try {
          h.render();
        } finally {
          hn(!1);
        }
      }
      pr(!1);
    }
    return t.flags |= no, e !== null && A ? xb(e, t, I, f) : Zn(e, t, I, f), t.memoizedState = h.state, l && lO(t, r, !0), t.child;
  }
  function yI(e) {
    var t = e.stateNode;
    t.pendingContext ? sO(e, t.pendingContext, t.pendingContext !== t.context) : t.context && sO(e, t.context, !1), ZA(e, t.containerInfo);
  }
  function Bb(e, t, r) {
    if (yI(t), e === null)
      throw new Error("Should have a current fiber. This is a bug in React.");
    var i = t.pendingProps, l = t.memoizedState, f = l.element;
    LO(e, t), Pc(t, i, null, r);
    var A = t.memoizedState;
    t.stateNode;
    var h = A.element;
    if (l.isDehydrated) {
      var I = {
        element: h,
        isDehydrated: !1,
        cache: A.cache,
        pendingSuspenseBoundaries: A.pendingSuspenseBoundaries,
        transitions: A.transitions
      }, L = t.updateQueue;
      if (L.baseState = I, t.memoizedState = I, t.flags & Ga) {
        var b = Is(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), t);
        return gI(e, t, h, r, b);
      } else if (h !== f) {
        var k = Is(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), t);
        return gI(e, t, h, r, k);
      } else {
        WD(t);
        var W = FO(t, null, h, r);
        t.child = W;
        for (var q = W; q; )
          q.flags = q.flags & ~Zt | Ha, q = q.sibling;
      }
    } else {
      if (Io(), h === f)
        return Ja(e, t, r);
      Zn(e, t, h, r);
    }
    return t.child;
  }
  function gI(e, t, r, i, l) {
    return Io(), IA(l), t.flags |= Ga, Zn(e, t, r, i), t.child;
  }
  function Fb(e, t, r) {
    VO(t), e === null && OA(t);
    var i = t.type, l = t.pendingProps, f = e !== null ? e.memoizedProps : null, A = l.children, h = nA(i, l);
    return h ? A = null : f !== null && nA(i, f) && (t.flags |= Il), vI(e, t), Zn(e, t, A, r), t.child;
  }
  function Yb(e, t) {
    return e === null && OA(t), null;
  }
  function Vb(e, t, r, i) {
    uf(e, t);
    var l = t.pendingProps, f = r, A = f._payload, h = f._init, I = h(A);
    t.type = I;
    var L = t.tag = YP(I), b = qr(I, l), k;
    switch (L) {
      case d:
        return BR(t, I), t.type = I = Yo(I), k = GR(null, t, I, b, i), k;
      case T:
        return t.type = I = Ap(I), k = LI(null, t, I, b, i), k;
      case V:
        return t.type = I = Rp(I), k = II(null, t, I, b, i), k;
      case P: {
        if (t.type !== t.elementType) {
          var W = I.propTypes;
          W && Jr(
            W,
            b,
            // Resolved for outer only
            "prop",
            it(I)
          );
        }
        return k = _I(
          null,
          t,
          I,
          qr(I.type, b),
          // The inner type can have defaults too
          i
        ), k;
      }
    }
    var q = "";
    throw I !== null && typeof I == "object" && I.$$typeof === ge && (q = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + I + ". " + ("Lazy element type must resolve to a class or function." + q));
  }
  function Wb(e, t, r, i, l) {
    uf(e, t), t.tag = T;
    var f;
    return da(r) ? (f = !0, Sc(t)) : f = !1, Co(t, l), xO(t, r, i), kA(t, r, i, l), HR(null, t, r, !0, f, l);
  }
  function kb(e, t, r, i) {
    uf(e, t);
    var l = t.pendingProps, f;
    {
      var A = So(t, r, !1);
      f = ho(t, A);
    }
    Co(t, i);
    var h, I;
    {
      if (r.prototype && typeof r.prototype.render == "function") {
        var L = it(r) || "Unknown";
        MR[L] || (u("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", L, L), MR[L] = !0);
      }
      t.mode & qt && Zr.recordLegacyContextWarning(t, null), pr(!0), _u.current = t, h = Mo(null, t, r, l, f, i), I = Po(), pr(!1);
    }
    if (t.flags |= no, typeof h == "object" && h !== null && typeof h.render == "function" && h.$$typeof === void 0) {
      var b = it(r) || "Unknown";
      Cu[b] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", b, b, b), Cu[b] = !0);
    }
    if (
      // Run these checks in production only if the flag is off.
      // Eventually we'll delete this branch altogether.
      typeof h == "object" && h !== null && typeof h.render == "function" && h.$$typeof === void 0
    ) {
      {
        var k = it(r) || "Unknown";
        Cu[k] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", k, k, k), Cu[k] = !0);
      }
      t.tag = T, t.memoizedState = null, t.updateQueue = null;
      var W = !1;
      return da(r) ? (W = !0, Sc(t)) : W = !1, t.memoizedState = h.state !== null && h.state !== void 0 ? h.state : null, bA(t), UO(t, h), kA(t, r, l, i), HR(null, t, r, !0, W, i);
    } else {
      if (t.tag = d, t.mode & qt) {
        hn(!0);
        try {
          h = Mo(null, t, r, l, f, i), I = Po();
        } finally {
          hn(!1);
        }
      }
      return mn() && I && RA(t), Zn(null, t, h, i), BR(t, r), t.child;
    }
  }
  function BR(e, t) {
    {
      if (t && t.childContextTypes && u("%s(...): childContextTypes cannot be defined on a function component.", t.displayName || t.name || "Component"), e.ref !== null) {
        var r = "", i = ui();
        i && (r += `

Check the render method of \`` + i + "`.");
        var l = i || "", f = e._debugSource;
        f && (l = f.fileName + ":" + f.lineNumber), xR[l] || (xR[l] = !0, u("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", r));
      }
      if (typeof t.getDerivedStateFromProps == "function") {
        var A = it(t) || "Unknown";
        UR[A] || (u("%s: Function components do not support getDerivedStateFromProps.", A), UR[A] = !0);
      }
      if (typeof t.contextType == "object" && t.contextType !== null) {
        var h = it(t) || "Unknown";
        PR[h] || (u("%s: Function components do not support contextType.", h), PR[h] = !0);
      }
    }
  }
  var FR = {
    dehydrated: null,
    treeContext: null,
    retryLane: Nn
  };
  function YR(e) {
    return {
      baseLanes: e,
      cachePool: Ub(),
      transitions: null
    };
  }
  function Xb(e, t) {
    var r = null;
    return {
      baseLanes: We(e.baseLanes, t),
      cachePool: r,
      transitions: e.transitions
    };
  }
  function jb(e, t, r, i) {
    if (t !== null) {
      var l = t.memoizedState;
      if (l === null)
        return !1;
    }
    return $A(e, Au);
  }
  function Kb(e, t) {
    return VE(e.childLanes, t);
  }
  function DI(e, t, r) {
    var i = t.pendingProps;
    nU(t) && (t.flags |= ct);
    var l = Qr.current, f = !1, A = (t.flags & ct) !== be;
    if (A || jb(l, e) ? (f = !0, t.flags &= ~ct) : (e === null || e.memoizedState !== null) && (l = Ab(l, kO)), l = Lo(l), Di(t, l), e === null) {
      OA(t);
      var h = t.memoizedState;
      if (h !== null) {
        var I = h.dehydrated;
        if (I !== null)
          return Qb(t, I);
      }
      var L = i.children, b = i.fallback;
      if (f) {
        var k = Jb(t, L, b, r), W = t.child;
        return W.memoizedState = YR(r), t.memoizedState = FR, k;
      } else
        return VR(t, L);
    } else {
      var q = e.memoizedState;
      if (q !== null) {
        var Q = q.dehydrated;
        if (Q !== null)
          return $b(e, t, A, i, Q, q, r);
      }
      if (f) {
        var re = i.fallback, Ne = i.children, ye = Zb(e, t, Ne, re, r), me = t.child, Qe = e.child.memoizedState;
        return me.memoizedState = Qe === null ? YR(r) : Xb(Qe, r), me.childLanes = Kb(e, r), t.memoizedState = FR, ye;
      } else {
        var Xe = i.children, K = zb(e, t, Xe, r);
        return t.memoizedState = null, K;
      }
    }
  }
  function VR(e, t, r) {
    var i = e.mode, l = {
      mode: "visible",
      children: t
    }, f = WR(l, i);
    return f.return = e, e.child = f, f;
  }
  function Jb(e, t, r, i) {
    var l = e.mode, f = e.child, A = {
      mode: "hidden",
      children: t
    }, h, I;
    return (l & Ze) === Me && f !== null ? (h = f, h.childLanes = le, h.pendingProps = A, e.mode & pt && (h.actualDuration = 0, h.actualStartTime = -1, h.selfBaseDuration = 0, h.treeBaseDuration = 0), I = Hi(r, l, i, null)) : (h = WR(A, l), I = Hi(r, l, i, null)), h.return = e, I.return = e, h.sibling = I, e.child = h, I;
  }
  function WR(e, t, r) {
    return b_(e, t, le, null);
  }
  function bI(e, t) {
    return ys(e, t);
  }
  function zb(e, t, r, i) {
    var l = e.child, f = l.sibling, A = bI(l, {
      mode: "visible",
      children: r
    });
    if ((t.mode & Ze) === Me && (A.lanes = i), A.return = t, A.sibling = null, f !== null) {
      var h = t.deletions;
      h === null ? (t.deletions = [f], t.flags |= as) : h.push(f);
    }
    return t.child = A, A;
  }
  function Zb(e, t, r, i, l) {
    var f = t.mode, A = e.child, h = A.sibling, I = {
      mode: "hidden",
      children: r
    }, L;
    if (
      // In legacy mode, we commit the primary tree as if it successfully
      // completed, even though it's in an inconsistent state.
      (f & Ze) === Me && // Make sure we're on the second pass, i.e. the primary child fragment was
      // already cloned. In legacy mode, the only case where this isn't true is
      // when DevTools forces us to display a fallback; we skip the first render
      // pass entirely and go straight to rendering the fallback. (In Concurrent
      // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
      // only codepath.)
      t.child !== A
    ) {
      var b = t.child;
      L = b, L.childLanes = le, L.pendingProps = I, t.mode & pt && (L.actualDuration = 0, L.actualStartTime = -1, L.selfBaseDuration = A.selfBaseDuration, L.treeBaseDuration = A.treeBaseDuration), t.deletions = null;
    } else
      L = bI(A, I), L.subtreeFlags = A.subtreeFlags & Fa;
    var k;
    return h !== null ? k = ys(h, i) : (k = Hi(i, f, l, null), k.flags |= Zt), k.return = t, L.return = t, L.sibling = k, t.child = L, k;
  }
  function lf(e, t, r, i) {
    i !== null && IA(i), mo(t, e.child, null, r);
    var l = t.pendingProps, f = l.children, A = VR(t, f);
    return A.flags |= Zt, t.memoizedState = null, A;
  }
  function qb(e, t, r, i, l) {
    var f = t.mode, A = {
      mode: "visible",
      children: r
    }, h = WR(A, f), I = Hi(i, f, l, null);
    return I.flags |= Zt, h.return = t, I.return = t, h.sibling = I, t.child = h, (t.mode & Ze) !== Me && mo(t, e.child, null, l), I;
  }
  function Qb(e, t, r) {
    return (e.mode & Ze) === Me ? (u("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = Ge) : sA(t) ? e.lanes = ao : e.lanes = Mr, null;
  }
  function $b(e, t, r, i, l, f, A) {
    if (r)
      if (t.flags & Ga) {
        t.flags &= ~Ga;
        var K = gR(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
        return lf(e, t, A, K);
      } else {
        if (t.memoizedState !== null)
          return t.child = e.child, t.flags |= ct, null;
        var ae = i.children, J = i.fallback, ce = qb(e, t, ae, J, A), Oe = t.child;
        return Oe.memoizedState = YR(A), t.memoizedState = FR, ce;
      }
    else {
      if (YD(), (t.mode & Ze) === Me)
        return lf(
          e,
          t,
          A,
          // TODO: When we delete legacy mode, we should make this error argument
          // required — every concurrent mode path that causes hydration to
          // de-opt to client rendering should have an error message.
          null
        );
      if (sA(l)) {
        var h, I, L;
        {
          var b = aD(l);
          h = b.digest, I = b.message, L = b.stack;
        }
        var k;
        I ? k = new Error(I) : k = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
        var W = gR(k, h, L);
        return lf(e, t, A, W);
      }
      var q = Sr(A, e.childLanes);
      if (ea || q) {
        var Q = hf();
        if (Q !== null) {
          var re = E1(Q, A);
          if (re !== Nn && re !== f.retryLane) {
            f.retryLane = re;
            var Ne = mt;
            ur(e, re), cn(Q, e, re, Ne);
          }
        }
        Ep();
        var ye = gR(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
        return lf(e, t, A, ye);
      } else if (eO(l)) {
        t.flags |= ct, t.child = e.child;
        var me = CP.bind(null, e);
        return iD(l, me), null;
      } else {
        kD(t, l, f.treeContext);
        var Qe = i.children, Xe = VR(t, Qe);
        return Xe.flags |= Ha, Xe;
      }
    }
  }
  function MI(e, t, r) {
    e.lanes = We(e.lanes, t);
    var i = e.alternate;
    i !== null && (i.lanes = We(i.lanes, t)), LA(e.return, t, r);
  }
  function eM(e, t, r) {
    for (var i = t; i !== null; ) {
      if (i.tag === G) {
        var l = i.memoizedState;
        l !== null && MI(i, r, e);
      } else if (i.tag === F)
        MI(i, r, e);
      else if (i.child !== null) {
        i.child.return = i, i = i.child;
        continue;
      }
      if (i === e)
        return;
      for (; i.sibling === null; ) {
        if (i.return === null || i.return === e)
          return;
        i = i.return;
      }
      i.sibling.return = i.return, i = i.sibling;
    }
  }
  function tM(e) {
    for (var t = e, r = null; t !== null; ) {
      var i = t.alternate;
      i !== null && Fc(i) === null && (r = t), t = t.sibling;
    }
    return r;
  }
  function nM(e) {
    if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !wR[e])
      if (wR[e] = !0, typeof e == "string")
        switch (e.toLowerCase()) {
          case "together":
          case "forwards":
          case "backwards": {
            u('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
            break;
          }
          case "forward":
          case "backward": {
            u('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
            break;
          }
          default:
            u('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
            break;
        }
      else
        u('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
  }
  function rM(e, t) {
    e !== void 0 && !of[e] && (e !== "collapsed" && e !== "hidden" ? (of[e] = !0, u('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : t !== "forwards" && t !== "backwards" && (of[e] = !0, u('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
  }
  function PI(e, t) {
    {
      var r = st(e), i = !r && typeof ba(e) == "function";
      if (r || i) {
        var l = r ? "array" : "iterable";
        return u("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", l, t, l), !1;
      }
    }
    return !0;
  }
  function aM(e, t) {
    if ((t === "forwards" || t === "backwards") && e !== void 0 && e !== null && e !== !1)
      if (st(e)) {
        for (var r = 0; r < e.length; r++)
          if (!PI(e[r], r))
            return;
      } else {
        var i = ba(e);
        if (typeof i == "function") {
          var l = i.call(e);
          if (l)
            for (var f = l.next(), A = 0; !f.done; f = l.next()) {
              if (!PI(f.value, A))
                return;
              A++;
            }
        } else
          u('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', t);
      }
  }
  function kR(e, t, r, i, l) {
    var f = e.memoizedState;
    f === null ? e.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: i,
      tail: r,
      tailMode: l
    } : (f.isBackwards = t, f.rendering = null, f.renderingStartTime = 0, f.last = i, f.tail = r, f.tailMode = l);
  }
  function UI(e, t, r) {
    var i = t.pendingProps, l = i.revealOrder, f = i.tail, A = i.children;
    nM(l), rM(f, l), aM(A, l), Zn(e, t, A, r);
    var h = Qr.current, I = $A(h, Au);
    if (I)
      h = eR(h, Au), t.flags |= ct;
    else {
      var L = e !== null && (e.flags & ct) !== be;
      L && eM(t, t.child, r), h = Lo(h);
    }
    if (Di(t, h), (t.mode & Ze) === Me)
      t.memoizedState = null;
    else
      switch (l) {
        case "forwards": {
          var b = tM(t.child), k;
          b === null ? (k = t.child, t.child = null) : (k = b.sibling, b.sibling = null), kR(
            t,
            !1,
            // isBackwards
            k,
            b,
            f
          );
          break;
        }
        case "backwards": {
          var W = null, q = t.child;
          for (t.child = null; q !== null; ) {
            var Q = q.alternate;
            if (Q !== null && Fc(Q) === null) {
              t.child = q;
              break;
            }
            var re = q.sibling;
            q.sibling = W, W = q, q = re;
          }
          kR(
            t,
            !0,
            // isBackwards
            W,
            null,
            // last
            f
          );
          break;
        }
        case "together": {
          kR(
            t,
            !1,
            // isBackwards
            null,
            // tail
            null,
            // last
            void 0
          );
          break;
        }
        default:
          t.memoizedState = null;
      }
    return t.child;
  }
  function iM(e, t, r) {
    ZA(t, t.stateNode.containerInfo);
    var i = t.pendingProps;
    return e === null ? t.child = mo(t, null, i, r) : Zn(e, t, i, r), t.child;
  }
  var xI = !1;
  function sM(e, t, r) {
    var i = t.type, l = i._context, f = t.pendingProps, A = t.memoizedProps, h = f.value;
    {
      "value" in f || xI || (xI = !0, u("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
      var I = t.type.propTypes;
      I && Jr(I, f, "prop", "Context.Provider");
    }
    if (_O(t, l, h), A !== null) {
      var L = A.value;
      if (Nr(L, h)) {
        if (A.children === f.children && !Rc())
          return Ja(e, t, r);
      } else
        eb(t, l, r);
    }
    var b = f.children;
    return Zn(e, t, b, r), t.child;
  }
  var wI = !1;
  function oM(e, t, r) {
    var i = t.type;
    i._context === void 0 ? i !== i.Consumer && (wI || (wI = !0, u("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : i = i._context;
    var l = t.pendingProps, f = l.children;
    typeof f != "function" && u("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Co(t, r);
    var A = Qt(i), h;
    return _u.current = t, pr(!0), h = f(A), pr(!1), t.flags |= no, Zn(e, t, h, r), t.child;
  }
  function mu() {
    ea = !0;
  }
  function uf(e, t) {
    (t.mode & Ze) === Me && e !== null && (e.alternate = null, t.alternate = null, t.flags |= Zt);
  }
  function Ja(e, t, r) {
    return e !== null && (t.dependencies = e.dependencies), pI(), Gu(t.lanes), Sr(r, t.childLanes) ? (fb(e, t), t.child) : null;
  }
  function lM(e, t, r) {
    {
      var i = t.return;
      if (i === null)
        throw new Error("Cannot swap the root fiber.");
      if (e.alternate = null, t.alternate = null, r.index = t.index, r.sibling = t.sibling, r.return = t.return, r.ref = t.ref, t === i.child)
        i.child = r;
      else {
        var l = i.child;
        if (l === null)
          throw new Error("Expected parent to have a child.");
        for (; l.sibling !== t; )
          if (l = l.sibling, l === null)
            throw new Error("Expected to find the previous sibling.");
        l.sibling = r;
      }
      var f = i.deletions;
      return f === null ? (i.deletions = [e], i.flags |= as) : f.push(e), r.flags |= Zt, r;
    }
  }
  function XR(e, t) {
    var r = e.lanes;
    return !!Sr(r, t);
  }
  function uM(e, t, r) {
    switch (t.tag) {
      case N:
        yI(t), t.stateNode, Io();
        break;
      case v:
        VO(t);
        break;
      case T: {
        var i = t.type;
        da(i) && Sc(t);
        break;
      }
      case m:
        ZA(t, t.stateNode.containerInfo);
        break;
      case g: {
        var l = t.memoizedProps.value, f = t.type._context;
        _O(t, f, l);
        break;
      }
      case D:
        {
          var A = Sr(r, t.childLanes);
          A && (t.flags |= tt);
          {
            var h = t.stateNode;
            h.effectDuration = 0, h.passiveEffectDuration = 0;
          }
        }
        break;
      case G: {
        var I = t.memoizedState;
        if (I !== null) {
          if (I.dehydrated !== null)
            return Di(t, Lo(Qr.current)), t.flags |= ct, null;
          var L = t.child, b = L.childLanes;
          if (Sr(r, b))
            return DI(e, t, r);
          Di(t, Lo(Qr.current));
          var k = Ja(e, t, r);
          return k !== null ? k.sibling : null;
        } else
          Di(t, Lo(Qr.current));
        break;
      }
      case F: {
        var W = (e.flags & ct) !== be, q = Sr(r, t.childLanes);
        if (W) {
          if (q)
            return UI(e, t, r);
          t.flags |= ct;
        }
        var Q = t.memoizedState;
        if (Q !== null && (Q.rendering = null, Q.tail = null, Q.lastEffect = null), Di(t, Qr.current), q)
          break;
        return null;
      }
      case z:
      case Z:
        return t.lanes = le, mI(e, t, r);
    }
    return Ja(e, t, r);
  }
  function GI(e, t, r) {
    if (t._debugNeedsRemount && e !== null)
      return lM(e, t, Op(t.type, t.key, t.pendingProps, t._debugOwner || null, t.mode, t.lanes));
    if (e !== null) {
      var i = e.memoizedProps, l = t.pendingProps;
      if (i !== l || Rc() || // Force a re-render if the implementation changed due to hot reload:
      t.type !== e.type)
        ea = !0;
      else {
        var f = XR(e, r);
        if (!f && // If this is the second pass of an error or suspense boundary, there
        // may not be work scheduled on `current`, so we check for this flag.
        (t.flags & ct) === be)
          return ea = !1, uM(e, t, r);
        (e.flags & qT) !== be ? ea = !0 : ea = !1;
      }
    } else if (ea = !1, mn() && xD(t)) {
      var A = t.index, h = wD();
      cO(t, h, A);
    }
    switch (t.lanes = le, t.tag) {
      case S:
        return kb(e, t, t.type, r);
      case Y: {
        var I = t.elementType;
        return Vb(e, t, I, r);
      }
      case d: {
        var L = t.type, b = t.pendingProps, k = t.elementType === L ? b : qr(L, b);
        return GR(e, t, L, k, r);
      }
      case T: {
        var W = t.type, q = t.pendingProps, Q = t.elementType === W ? q : qr(W, q);
        return LI(e, t, W, Q, r);
      }
      case N:
        return Bb(e, t, r);
      case v:
        return Fb(e, t, r);
      case M:
        return Yb(e, t);
      case G:
        return DI(e, t, r);
      case m:
        return iM(e, t, r);
      case V: {
        var re = t.type, Ne = t.pendingProps, ye = t.elementType === re ? Ne : qr(re, Ne);
        return II(e, t, re, ye, r);
      }
      case w:
        return wb(e, t, r);
      case y:
        return Gb(e, t, r);
      case D:
        return Hb(e, t, r);
      case g:
        return sM(e, t, r);
      case O:
        return oM(e, t, r);
      case P: {
        var me = t.type, Qe = t.pendingProps, Xe = qr(me, Qe);
        if (t.type !== t.elementType) {
          var K = me.propTypes;
          K && Jr(
            K,
            Xe,
            // Resolved for outer only
            "prop",
            it(me)
          );
        }
        return Xe = qr(me.type, Xe), _I(e, t, me, Xe, r);
      }
      case U:
        return CI(e, t, t.type, t.pendingProps, r);
      case X: {
        var ae = t.type, J = t.pendingProps, ce = t.elementType === ae ? J : qr(ae, J);
        return Wb(e, t, ae, ce, r);
      }
      case F:
        return UI(e, t, r);
      case j:
        break;
      case z:
        return mI(e, t, r);
    }
    throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
  }
  function Uo(e) {
    e.flags |= tt;
  }
  function HI(e) {
    e.flags |= Ti, e.flags |= QT;
  }
  var BI, jR, FI, YI;
  BI = function(e, t, r, i) {
    for (var l = t.child; l !== null; ) {
      if (l.tag === v || l.tag === M)
        Mg(e, l.stateNode);
      else if (l.tag !== m) {
        if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
      }
      if (l === t)
        return;
      for (; l.sibling === null; ) {
        if (l.return === null || l.return === t)
          return;
        l = l.return;
      }
      l.sibling.return = l.return, l = l.sibling;
    }
  }, jR = function(e, t) {
  }, FI = function(e, t, r, i, l) {
    var f = e.memoizedProps;
    if (f !== i) {
      var A = t.stateNode, h = qA(), I = Ug(A, r, f, i, l, h);
      t.updateQueue = I, I && Uo(t);
    }
  }, YI = function(e, t, r, i) {
    r !== i && Uo(t);
  };
  function vu(e, t) {
    if (!mn())
      switch (e.tailMode) {
        case "hidden": {
          for (var r = e.tail, i = null; r !== null; )
            r.alternate !== null && (i = r), r = r.sibling;
          i === null ? e.tail = null : i.sibling = null;
          break;
        }
        case "collapsed": {
          for (var l = e.tail, f = null; l !== null; )
            l.alternate !== null && (f = l), l = l.sibling;
          f === null ? !t && e.tail !== null ? e.tail.sibling = null : e.tail = null : f.sibling = null;
          break;
        }
      }
  }
  function vn(e) {
    var t = e.alternate !== null && e.alternate.child === e.child, r = le, i = be;
    if (t) {
      if ((e.mode & pt) !== Me) {
        for (var I = e.selfBaseDuration, L = e.child; L !== null; )
          r = We(r, We(L.lanes, L.childLanes)), i |= L.subtreeFlags & Fa, i |= L.flags & Fa, I += L.treeBaseDuration, L = L.sibling;
        e.treeBaseDuration = I;
      } else
        for (var b = e.child; b !== null; )
          r = We(r, We(b.lanes, b.childLanes)), i |= b.subtreeFlags & Fa, i |= b.flags & Fa, b.return = e, b = b.sibling;
      e.subtreeFlags |= i;
    } else {
      if ((e.mode & pt) !== Me) {
        for (var l = e.actualDuration, f = e.selfBaseDuration, A = e.child; A !== null; )
          r = We(r, We(A.lanes, A.childLanes)), i |= A.subtreeFlags, i |= A.flags, l += A.actualDuration, f += A.treeBaseDuration, A = A.sibling;
        e.actualDuration = l, e.treeBaseDuration = f;
      } else
        for (var h = e.child; h !== null; )
          r = We(r, We(h.lanes, h.childLanes)), i |= h.subtreeFlags, i |= h.flags, h.return = e, h = h.sibling;
      e.subtreeFlags |= i;
    }
    return e.childLanes = r, t;
  }
  function EM(e, t, r) {
    if (zD() && (t.mode & Ze) !== Me && (t.flags & ct) === be)
      return SO(t), Io(), t.flags |= Ga | _l | Jn, !1;
    var i = _c(t);
    if (r !== null && r.dehydrated !== null)
      if (e === null) {
        if (!i)
          throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
        if (KD(t), vn(t), (t.mode & pt) !== Me) {
          var l = r !== null;
          if (l) {
            var f = t.child;
            f !== null && (t.treeBaseDuration -= f.treeBaseDuration);
          }
        }
        return !1;
      } else {
        if (Io(), (t.flags & ct) === be && (t.memoizedState = null), t.flags |= tt, vn(t), (t.mode & pt) !== Me) {
          var A = r !== null;
          if (A) {
            var h = t.child;
            h !== null && (t.treeBaseDuration -= h.treeBaseDuration);
          }
        }
        return !1;
      }
    else
      return hO(), !0;
  }
  function VI(e, t, r) {
    var i = t.pendingProps;
    switch (pA(t), t.tag) {
      case S:
      case Y:
      case U:
      case d:
      case V:
      case w:
      case y:
      case D:
      case O:
      case P:
        return vn(t), null;
      case T: {
        var l = t.type;
        return da(l) && pc(t), vn(t), null;
      }
      case N: {
        var f = t.stateNode;
        if (vo(t), TA(t), nR(), f.pendingContext && (f.context = f.pendingContext, f.pendingContext = null), e === null || e.child === null) {
          var A = _c(t);
          if (A)
            Uo(t);
          else if (e !== null) {
            var h = e.memoizedState;
            // Check if this is a client root
            (!h.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
            (t.flags & Ga) !== be) && (t.flags |= is, hO());
          }
        }
        return jR(e, t), vn(t), null;
      }
      case v: {
        QA(t);
        var I = YO(), L = t.type;
        if (e !== null && t.stateNode != null)
          FI(e, t, L, i, I), e.ref !== t.ref && HI(t);
        else {
          if (!i) {
            if (t.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            return vn(t), null;
          }
          var b = qA(), k = _c(t);
          if (k)
            XD(t, I, b) && Uo(t);
          else {
            var W = bg(L, i, I, b, t);
            BI(W, t, !1, !1), t.stateNode = W, Pg(W, L, i, I) && Uo(t);
          }
          t.ref !== null && HI(t);
        }
        return vn(t), null;
      }
      case M: {
        var q = i;
        if (e && t.stateNode != null) {
          var Q = e.memoizedProps;
          YI(e, t, Q, q);
        } else {
          if (typeof q != "string" && t.stateNode === null)
            throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
          var re = YO(), Ne = qA(), ye = _c(t);
          ye ? jD(t) && Uo(t) : t.stateNode = xg(q, re, Ne, t);
        }
        return vn(t), null;
      }
      case G: {
        yo(t);
        var me = t.memoizedState;
        if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
          var Qe = EM(e, t, me);
          if (!Qe)
            return t.flags & Jn ? t : null;
        }
        if ((t.flags & ct) !== be)
          return t.lanes = r, (t.mode & pt) !== Me && yR(t), t;
        var Xe = me !== null, K = e !== null && e.memoizedState !== null;
        if (Xe !== K && Xe) {
          var ae = t.child;
          if (ae.flags |= ss, (t.mode & Ze) !== Me) {
            var J = e === null && (t.memoizedProps.unstable_avoidThisFallback !== !0 || !et);
            J || $A(Qr.current, kO) ? cP() : Ep();
          }
        }
        var ce = t.updateQueue;
        if (ce !== null && (t.flags |= tt), vn(t), (t.mode & pt) !== Me && Xe) {
          var Oe = t.child;
          Oe !== null && (t.treeBaseDuration -= Oe.treeBaseDuration);
        }
        return null;
      }
      case m:
        return vo(t), jR(e, t), e === null && yD(t.stateNode.containerInfo), vn(t), null;
      case g:
        var Se = t.type._context;
        return vA(Se, t), vn(t), null;
      case X: {
        var Ue = t.type;
        return da(Ue) && pc(t), vn(t), null;
      }
      case F: {
        yo(t);
        var He = t.memoizedState;
        if (He === null)
          return vn(t), null;
        var ht = (t.flags & ct) !== be, rt = He.rendering;
        if (rt === null)
          if (ht)
            vu(He, !1);
          else {
            var Xt = TP() && (e === null || (e.flags & ct) === be);
            if (!Xt)
              for (var at = t.child; at !== null; ) {
                var Ft = Fc(at);
                if (Ft !== null) {
                  ht = !0, t.flags |= ct, vu(He, !1);
                  var Wn = Ft.updateQueue;
                  return Wn !== null && (t.updateQueue = Wn, t.flags |= tt), t.subtreeFlags = be, Tb(t, r), Di(t, eR(Qr.current, Au)), t.child;
                }
                at = at.sibling;
              }
            He.tail !== null && Sn() > u_() && (t.flags |= ct, ht = !0, vu(He, !1), t.lanes = Yh);
          }
        else {
          if (!ht) {
            var bn = Fc(rt);
            if (bn !== null) {
              t.flags |= ct, ht = !0;
              var Cr = bn.updateQueue;
              if (Cr !== null && (t.updateQueue = Cr, t.flags |= tt), vu(He, !0), He.tail === null && He.tailMode === "hidden" && !rt.alternate && !mn())
                return vn(t), null;
            } else
              // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Sn() * 2 - He.renderingStartTime > u_() && r !== Mr && (t.flags |= ct, ht = !0, vu(He, !1), t.lanes = Yh);
          }
          if (He.isBackwards)
            rt.sibling = t.child, t.child = rt;
          else {
            var $n = He.last;
            $n !== null ? $n.sibling = rt : t.child = rt, He.last = rt;
          }
        }
        if (He.tail !== null) {
          var er = He.tail;
          He.rendering = er, He.tail = er.sibling, He.renderingStartTime = Sn(), er.sibling = null;
          var kn = Qr.current;
          return ht ? kn = eR(kn, Au) : kn = Lo(kn), Di(t, kn), er;
        }
        return vn(t), null;
      }
      case j:
        break;
      case z:
      case Z: {
        up(t);
        var $a = t.memoizedState, Vo = $a !== null;
        if (e !== null) {
          var Vu = e.memoizedState, Ia = Vu !== null;
          Ia !== Vo && // LegacyHidden doesn't do any hiding — it only pre-renders.
          !Fe && (t.flags |= ss);
        }
        return !Vo || (t.mode & Ze) === Me ? vn(t) : Sr(Oa, Mr) && (vn(t), t.subtreeFlags & (Zt | tt) && (t.flags |= ss)), null;
      }
      case ee:
        return null;
      case oe:
        return null;
    }
    throw new Error("Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue.");
  }
  function cM(e, t, r) {
    switch (pA(t), t.tag) {
      case T: {
        var i = t.type;
        da(i) && pc(t);
        var l = t.flags;
        return l & Jn ? (t.flags = l & ~Jn | ct, (t.mode & pt) !== Me && yR(t), t) : null;
      }
      case N: {
        t.stateNode, vo(t), TA(t), nR();
        var f = t.flags;
        return (f & Jn) !== be && (f & ct) === be ? (t.flags = f & ~Jn | ct, t) : null;
      }
      case v:
        return QA(t), null;
      case G: {
        yo(t);
        var A = t.memoizedState;
        if (A !== null && A.dehydrated !== null) {
          if (t.alternate === null)
            throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
          Io();
        }
        var h = t.flags;
        return h & Jn ? (t.flags = h & ~Jn | ct, (t.mode & pt) !== Me && yR(t), t) : null;
      }
      case F:
        return yo(t), null;
      case m:
        return vo(t), null;
      case g:
        var I = t.type._context;
        return vA(I, t), null;
      case z:
      case Z:
        return up(t), null;
      case ee:
        return null;
      default:
        return null;
    }
  }
  function WI(e, t, r) {
    switch (pA(t), t.tag) {
      case T: {
        var i = t.type.childContextTypes;
        i != null && pc(t);
        break;
      }
      case N: {
        t.stateNode, vo(t), TA(t), nR();
        break;
      }
      case v: {
        QA(t);
        break;
      }
      case m:
        vo(t);
        break;
      case G:
        yo(t);
        break;
      case F:
        yo(t);
        break;
      case g:
        var l = t.type._context;
        vA(l, t);
        break;
      case z:
      case Z:
        up(t);
        break;
    }
  }
  var kI = null;
  kI = /* @__PURE__ */ new Set();
  var Ef = !1, Ln = !1, fM = typeof WeakSet == "function" ? WeakSet : Set, _e = null, xo = null, wo = null;
  function TM(e) {
    JT(null, function() {
      throw e;
    }), zT();
  }
  var dM = function(e, t) {
    if (t.props = e.memoizedProps, t.state = e.memoizedState, e.mode & pt)
      try {
        ha(), t.componentWillUnmount();
      } finally {
        Sa(e);
      }
    else
      t.componentWillUnmount();
  };
  function XI(e, t) {
    try {
      Pi(zn, e);
    } catch (r) {
      _t(e, t, r);
    }
  }
  function KR(e, t, r) {
    try {
      dM(e, r);
    } catch (i) {
      _t(e, t, i);
    }
  }
  function AM(e, t, r) {
    try {
      r.componentDidMount();
    } catch (i) {
      _t(e, t, i);
    }
  }
  function jI(e, t) {
    try {
      JI(e);
    } catch (r) {
      _t(e, t, r);
    }
  }
  function Go(e, t) {
    var r = e.ref;
    if (r !== null)
      if (typeof r == "function") {
        var i;
        try {
          if (Tn && _n && e.mode & pt)
            try {
              ha(), i = r(null);
            } finally {
              Sa(e);
            }
          else
            i = r(null);
        } catch (l) {
          _t(e, t, l);
        }
        typeof i == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Ye(e));
      } else
        r.current = null;
  }
  function cf(e, t, r) {
    try {
      r();
    } catch (i) {
      _t(e, t, i);
    }
  }
  var KI = !1;
  function RM(e, t) {
    gg(e.containerInfo), _e = t, pM();
    var r = KI;
    return KI = !1, r;
  }
  function pM() {
    for (; _e !== null; ) {
      var e = _e, t = e.child;
      (e.subtreeFlags & ed) !== be && t !== null ? (t.return = e, _e = t) : SM();
    }
  }
  function SM() {
    for (; _e !== null; ) {
      var e = _e;
      wt(e);
      try {
        hM(e);
      } catch (r) {
        _t(e, e.return, r);
      }
      pn();
      var t = e.sibling;
      if (t !== null) {
        t.return = e.return, _e = t;
        return;
      }
      _e = e.return;
    }
  }
  function hM(e) {
    var t = e.alternate, r = e.flags;
    if ((r & is) !== be) {
      switch (wt(e), e.tag) {
        case d:
        case V:
        case U:
          break;
        case T: {
          if (t !== null) {
            var i = t.memoizedProps, l = t.memoizedState, f = e.stateNode;
            e.type === e.elementType && !_s && (f.props !== e.memoizedProps && u("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ye(e) || "instance"), f.state !== e.memoizedState && u("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ye(e) || "instance"));
            var A = f.getSnapshotBeforeUpdate(e.elementType === e.type ? i : qr(e.type, i), l);
            {
              var h = kI;
              A === void 0 && !h.has(e.type) && (h.add(e.type), u("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", Ye(e)));
            }
            f.__reactInternalSnapshotBeforeUpdate = A;
          }
          break;
        }
        case N: {
          {
            var I = e.stateNode;
            eD(I.containerInfo);
          }
          break;
        }
        case v:
        case M:
        case m:
        case X:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      pn();
    }
  }
  function ta(e, t, r) {
    var i = t.updateQueue, l = i !== null ? i.lastEffect : null;
    if (l !== null) {
      var f = l.next, A = f;
      do {
        if ((A.tag & e) === e) {
          var h = A.destroy;
          A.destroy = void 0, h !== void 0 && ((e & Aa) !== go && Bu(!0), cf(t, r, h), (e & Aa) !== go && Bu(!1));
        }
        A = A.next;
      } while (A !== f);
    }
  }
  function Pi(e, t) {
    var r = t.updateQueue, i = r !== null ? r.lastEffect : null;
    if (i !== null) {
      var l = i.next, f = l;
      do {
        if ((f.tag & e) === e) {
          var A = f.create;
          (e & Aa) !== go && Bu(!0), f.destroy = A(), (e & Aa) !== go && Bu(!1);
          {
            var h = f.destroy;
            if (h !== void 0 && typeof h != "function") {
              var I = void 0;
              (f.tag & zn) !== be ? I = "useLayoutEffect" : (f.tag & Aa) !== be ? I = "useInsertionEffect" : I = "useEffect";
              var L = void 0;
              h === null ? L = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof h.then == "function" ? L = `

It looks like you wrote ` + I + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + I + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : L = " You returned: " + h, u("%s must not return anything besides a function, which is used for clean-up.%s", I, L);
            }
          }
        }
        f = f.next;
      } while (f !== l);
    }
  }
  function NM(e, t) {
    if ((t.flags & tt) !== be)
      switch (t.tag) {
        case D: {
          var r = t.stateNode.passiveEffectDuration, i = t.memoizedProps, l = i.id, f = i.onPostCommit, A = AI(), h = t.alternate === null ? "mount" : "update";
          dI() && (h = "nested-update"), typeof f == "function" && f(l, h, r, A);
          var I = t.return;
          e:
            for (; I !== null; ) {
              switch (I.tag) {
                case N:
                  var L = I.stateNode;
                  L.passiveEffectDuration += r;
                  break e;
                case D:
                  var b = I.stateNode;
                  b.passiveEffectDuration += r;
                  break e;
              }
              I = I.return;
            }
          break;
        }
      }
  }
  function OM(e, t, r, i) {
    if ((r.flags & Cl) !== be)
      switch (r.tag) {
        case d:
        case V:
        case U: {
          if (!Ln)
            if (r.mode & pt)
              try {
                ha(), Pi(zn | an, r);
              } finally {
                Sa(r);
              }
            else
              Pi(zn | an, r);
          break;
        }
        case T: {
          var l = r.stateNode;
          if (r.flags & tt && !Ln)
            if (t === null)
              if (r.type === r.elementType && !_s && (l.props !== r.memoizedProps && u("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ye(r) || "instance"), l.state !== r.memoizedState && u("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ye(r) || "instance")), r.mode & pt)
                try {
                  ha(), l.componentDidMount();
                } finally {
                  Sa(r);
                }
              else
                l.componentDidMount();
            else {
              var f = r.elementType === r.type ? t.memoizedProps : qr(r.type, t.memoizedProps), A = t.memoizedState;
              if (r.type === r.elementType && !_s && (l.props !== r.memoizedProps && u("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ye(r) || "instance"), l.state !== r.memoizedState && u("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ye(r) || "instance")), r.mode & pt)
                try {
                  ha(), l.componentDidUpdate(f, A, l.__reactInternalSnapshotBeforeUpdate);
                } finally {
                  Sa(r);
                }
              else
                l.componentDidUpdate(f, A, l.__reactInternalSnapshotBeforeUpdate);
            }
          var h = r.updateQueue;
          h !== null && (r.type === r.elementType && !_s && (l.props !== r.memoizedProps && u("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", Ye(r) || "instance"), l.state !== r.memoizedState && u("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", Ye(r) || "instance")), gO(r, h, l));
          break;
        }
        case N: {
          var I = r.updateQueue;
          if (I !== null) {
            var L = null;
            if (r.child !== null)
              switch (r.child.tag) {
                case v:
                  L = r.child.stateNode;
                  break;
                case T:
                  L = r.child.stateNode;
                  break;
              }
            gO(r, I, L);
          }
          break;
        }
        case v: {
          var b = r.stateNode;
          if (t === null && r.flags & tt) {
            var k = r.type, W = r.memoizedProps;
            Fg(b, k, W);
          }
          break;
        }
        case M:
          break;
        case m:
          break;
        case D: {
          {
            var q = r.memoizedProps, Q = q.onCommit, re = q.onRender, Ne = r.stateNode.effectDuration, ye = AI(), me = t === null ? "mount" : "update";
            dI() && (me = "nested-update"), typeof re == "function" && re(r.memoizedProps.id, me, r.actualDuration, r.treeBaseDuration, r.actualStartTime, ye);
            {
              typeof Q == "function" && Q(r.memoizedProps.id, me, Ne, ye), SP(r);
              var Qe = r.return;
              e:
                for (; Qe !== null; ) {
                  switch (Qe.tag) {
                    case N:
                      var Xe = Qe.stateNode;
                      Xe.effectDuration += Ne;
                      break e;
                    case D:
                      var K = Qe.stateNode;
                      K.effectDuration += Ne;
                      break e;
                  }
                  Qe = Qe.return;
                }
            }
          }
          break;
        }
        case G: {
          gM(e, r);
          break;
        }
        case F:
        case X:
        case j:
        case z:
        case Z:
        case oe:
          break;
        default:
          throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
    Ln || r.flags & Ti && JI(r);
  }
  function IM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        if (e.mode & pt)
          try {
            ha(), XI(e, e.return);
          } finally {
            Sa(e);
          }
        else
          XI(e, e.return);
        break;
      }
      case T: {
        var t = e.stateNode;
        typeof t.componentDidMount == "function" && AM(e, e.return, t), jI(e, e.return);
        break;
      }
      case v: {
        jI(e, e.return);
        break;
      }
    }
  }
  function _M(e, t) {
    for (var r = null, i = e; ; ) {
      if (i.tag === v) {
        if (r === null) {
          r = i;
          try {
            var l = i.stateNode;
            t ? Zg(l) : Qg(i.stateNode, i.memoizedProps);
          } catch (A) {
            _t(e, e.return, A);
          }
        }
      } else if (i.tag === M) {
        if (r === null)
          try {
            var f = i.stateNode;
            t ? qg(f) : $g(f, i.memoizedProps);
          } catch (A) {
            _t(e, e.return, A);
          }
      } else if (!((i.tag === z || i.tag === Z) && i.memoizedState !== null && i !== e)) {
        if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
      }
      if (i === e)
        return;
      for (; i.sibling === null; ) {
        if (i.return === null || i.return === e)
          return;
        r === i && (r = null), i = i.return;
      }
      r === i && (r = null), i.sibling.return = i.return, i = i.sibling;
    }
  }
  function JI(e) {
    var t = e.ref;
    if (t !== null) {
      var r = e.stateNode, i;
      switch (e.tag) {
        case v:
          i = r;
          break;
        default:
          i = r;
      }
      if (typeof t == "function") {
        var l;
        if (e.mode & pt)
          try {
            ha(), l = t(i);
          } finally {
            Sa(e);
          }
        else
          l = t(i);
        typeof l == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", Ye(e));
      } else
        t.hasOwnProperty("current") || u("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", Ye(e)), t.current = i;
    }
  }
  function CM(e) {
    var t = e.alternate;
    t !== null && (t.return = null), e.return = null;
  }
  function zI(e) {
    var t = e.alternate;
    t !== null && (e.alternate = null, zI(t));
    {
      if (e.child = null, e.deletions = null, e.sibling = null, e.tag === v) {
        var r = e.stateNode;
        r !== null && bD(r);
      }
      e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
  }
  function mM(e) {
    for (var t = e.return; t !== null; ) {
      if (ZI(t))
        return t;
      t = t.return;
    }
    throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
  }
  function ZI(e) {
    return e.tag === v || e.tag === N || e.tag === m;
  }
  function qI(e) {
    var t = e;
    e:
      for (; ; ) {
        for (; t.sibling === null; ) {
          if (t.return === null || ZI(t.return))
            return null;
          t = t.return;
        }
        for (t.sibling.return = t.return, t = t.sibling; t.tag !== v && t.tag !== M && t.tag !== _; ) {
          if (t.flags & Zt || t.child === null || t.tag === m)
            continue e;
          t.child.return = t, t = t.child;
        }
        if (!(t.flags & Zt))
          return t.stateNode;
      }
  }
  function vM(e) {
    var t = mM(e);
    switch (t.tag) {
      case v: {
        var r = t.stateNode;
        t.flags & Il && ($N(r), t.flags &= ~Il);
        var i = qI(e);
        zR(e, i, r);
        break;
      }
      case N:
      case m: {
        var l = t.stateNode.containerInfo, f = qI(e);
        JR(e, f, l);
        break;
      }
      default:
        throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
    }
  }
  function JR(e, t, r) {
    var i = e.tag, l = i === v || i === M;
    if (l) {
      var f = e.stateNode;
      t ? jg(r, f, t) : kg(r, f);
    } else if (i !== m) {
      var A = e.child;
      if (A !== null) {
        JR(A, t, r);
        for (var h = A.sibling; h !== null; )
          JR(h, t, r), h = h.sibling;
      }
    }
  }
  function zR(e, t, r) {
    var i = e.tag, l = i === v || i === M;
    if (l) {
      var f = e.stateNode;
      t ? Xg(r, f, t) : Wg(r, f);
    } else if (i !== m) {
      var A = e.child;
      if (A !== null) {
        zR(A, t, r);
        for (var h = A.sibling; h !== null; )
          zR(h, t, r), h = h.sibling;
      }
    }
  }
  var yn = null, na = !1;
  function LM(e, t, r) {
    {
      var i = t;
      e:
        for (; i !== null; ) {
          switch (i.tag) {
            case v: {
              yn = i.stateNode, na = !1;
              break e;
            }
            case N: {
              yn = i.stateNode.containerInfo, na = !0;
              break e;
            }
            case m: {
              yn = i.stateNode.containerInfo, na = !0;
              break e;
            }
          }
          i = i.return;
        }
      if (yn === null)
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
      QI(e, t, r), yn = null, na = !1;
    }
    CM(r);
  }
  function Ui(e, t, r) {
    for (var i = r.child; i !== null; )
      QI(e, t, i), i = i.sibling;
  }
  function QI(e, t, r) {
    switch (r.tag) {
      case v:
        Ln || Go(r, t);
      case M: {
        {
          var i = yn, l = na;
          yn = null, Ui(e, t, r), yn = i, na = l, yn !== null && (na ? Jg(yn, r.stateNode) : Kg(yn, r.stateNode));
        }
        return;
      }
      case _: {
        yn !== null && (na ? zg(yn, r.stateNode) : iA(yn, r.stateNode));
        return;
      }
      case m: {
        {
          var f = yn, A = na;
          yn = r.stateNode.containerInfo, na = !0, Ui(e, t, r), yn = f, na = A;
        }
        return;
      }
      case d:
      case V:
      case P:
      case U: {
        if (!Ln) {
          var h = r.updateQueue;
          if (h !== null) {
            var I = h.lastEffect;
            if (I !== null) {
              var L = I.next, b = L;
              do {
                var k = b, W = k.destroy, q = k.tag;
                W !== void 0 && ((q & Aa) !== go ? cf(r, t, W) : (q & zn) !== go && (r.mode & pt ? (ha(), cf(r, t, W), Sa(r)) : cf(r, t, W))), b = b.next;
              } while (b !== L);
            }
          }
        }
        Ui(e, t, r);
        return;
      }
      case T: {
        if (!Ln) {
          Go(r, t);
          var Q = r.stateNode;
          typeof Q.componentWillUnmount == "function" && KR(r, t, Q);
        }
        Ui(e, t, r);
        return;
      }
      case j: {
        Ui(e, t, r);
        return;
      }
      case z: {
        if (
          // TODO: Remove this dead flag
          r.mode & Ze
        ) {
          var re = Ln;
          Ln = re || r.memoizedState !== null, Ui(e, t, r), Ln = re;
        } else
          Ui(e, t, r);
        break;
      }
      default: {
        Ui(e, t, r);
        return;
      }
    }
  }
  function yM(e) {
    e.memoizedState;
  }
  function gM(e, t) {
    var r = t.memoizedState;
    if (r === null) {
      var i = t.alternate;
      if (i !== null) {
        var l = i.memoizedState;
        if (l !== null) {
          var f = l.dehydrated;
          f !== null && dD(f);
        }
      }
    }
  }
  function $I(e) {
    var t = e.updateQueue;
    if (t !== null) {
      e.updateQueue = null;
      var r = e.stateNode;
      r === null && (r = e.stateNode = new fM()), t.forEach(function(i) {
        var l = mP.bind(null, e, i);
        if (!r.has(i)) {
          if (r.add(i), jr)
            if (xo !== null && wo !== null)
              Hu(wo, xo);
            else
              throw Error("Expected finished root and lanes to be set. This is a bug in React.");
          i.then(l, l);
        }
      });
    }
  }
  function DM(e, t, r) {
    xo = r, wo = e, wt(t), e_(t, e), wt(t), xo = null, wo = null;
  }
  function ra(e, t, r) {
    var i = t.deletions;
    if (i !== null)
      for (var l = 0; l < i.length; l++) {
        var f = i[l];
        try {
          LM(e, t, f);
        } catch (I) {
          _t(f, t, I);
        }
      }
    var A = OE();
    if (t.subtreeFlags & td)
      for (var h = t.child; h !== null; )
        wt(h), e_(h, e), h = h.sibling;
    wt(A);
  }
  function e_(e, t, r) {
    var i = e.alternate, l = e.flags;
    switch (e.tag) {
      case d:
      case V:
      case P:
      case U: {
        if (ra(t, e), Na(e), l & tt) {
          try {
            ta(Aa | an, e, e.return), Pi(Aa | an, e);
          } catch (Ue) {
            _t(e, e.return, Ue);
          }
          if (e.mode & pt) {
            try {
              ha(), ta(zn | an, e, e.return);
            } catch (Ue) {
              _t(e, e.return, Ue);
            }
            Sa(e);
          } else
            try {
              ta(zn | an, e, e.return);
            } catch (Ue) {
              _t(e, e.return, Ue);
            }
        }
        return;
      }
      case T: {
        ra(t, e), Na(e), l & Ti && i !== null && Go(i, i.return);
        return;
      }
      case v: {
        ra(t, e), Na(e), l & Ti && i !== null && Go(i, i.return);
        {
          if (e.flags & Il) {
            var f = e.stateNode;
            try {
              $N(f);
            } catch (Ue) {
              _t(e, e.return, Ue);
            }
          }
          if (l & tt) {
            var A = e.stateNode;
            if (A != null) {
              var h = e.memoizedProps, I = i !== null ? i.memoizedProps : h, L = e.type, b = e.updateQueue;
              if (e.updateQueue = null, b !== null)
                try {
                  Yg(A, b, L, I, h, e);
                } catch (Ue) {
                  _t(e, e.return, Ue);
                }
            }
          }
        }
        return;
      }
      case M: {
        if (ra(t, e), Na(e), l & tt) {
          if (e.stateNode === null)
            throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
          var k = e.stateNode, W = e.memoizedProps, q = i !== null ? i.memoizedProps : W;
          try {
            Vg(k, q, W);
          } catch (Ue) {
            _t(e, e.return, Ue);
          }
        }
        return;
      }
      case N: {
        if (ra(t, e), Na(e), l & tt && i !== null) {
          var Q = i.memoizedState;
          if (Q.isDehydrated)
            try {
              TD(t.containerInfo);
            } catch (Ue) {
              _t(e, e.return, Ue);
            }
        }
        return;
      }
      case m: {
        ra(t, e), Na(e);
        return;
      }
      case G: {
        ra(t, e), Na(e);
        var re = e.child;
        if (re.flags & ss) {
          var Ne = re.stateNode, ye = re.memoizedState, me = ye !== null;
          if (Ne.isHidden = me, me) {
            var Qe = re.alternate !== null && re.alternate.memoizedState !== null;
            Qe || EP();
          }
        }
        if (l & tt) {
          try {
            yM(e);
          } catch (Ue) {
            _t(e, e.return, Ue);
          }
          $I(e);
        }
        return;
      }
      case z: {
        var Xe = i !== null && i.memoizedState !== null;
        if (
          // TODO: Remove this dead flag
          e.mode & Ze
        ) {
          var K = Ln;
          Ln = K || Xe, ra(t, e), Ln = K;
        } else
          ra(t, e);
        if (Na(e), l & ss) {
          var ae = e.stateNode, J = e.memoizedState, ce = J !== null, Oe = e;
          if (ae.isHidden = ce, ce && !Xe && (Oe.mode & Ze) !== Me) {
            _e = Oe;
            for (var Se = Oe.child; Se !== null; )
              _e = Se, MM(Se), Se = Se.sibling;
          }
          _M(Oe, ce);
        }
        return;
      }
      case F: {
        ra(t, e), Na(e), l & tt && $I(e);
        return;
      }
      case j:
        return;
      default: {
        ra(t, e), Na(e);
        return;
      }
    }
  }
  function Na(e) {
    var t = e.flags;
    if (t & Zt) {
      try {
        vM(e);
      } catch (r) {
        _t(e, e.return, r);
      }
      e.flags &= ~Zt;
    }
    t & Ha && (e.flags &= ~Ha);
  }
  function bM(e, t, r) {
    xo = r, wo = t, _e = e, t_(e, t, r), xo = null, wo = null;
  }
  function t_(e, t, r) {
    for (var i = (e.mode & Ze) !== Me; _e !== null; ) {
      var l = _e, f = l.child;
      if (l.tag === z && i) {
        var A = l.memoizedState !== null, h = A || Ef;
        if (h) {
          ZR(e, t, r);
          continue;
        } else {
          var I = l.alternate, L = I !== null && I.memoizedState !== null, b = L || Ln, k = Ef, W = Ln;
          Ef = h, Ln = b, Ln && !W && (_e = l, PM(l));
          for (var q = f; q !== null; )
            _e = q, t_(
              q,
              // New root; bubble back up to here and stop.
              t,
              r
            ), q = q.sibling;
          _e = l, Ef = k, Ln = W, ZR(e, t, r);
          continue;
        }
      }
      (l.subtreeFlags & Cl) !== be && f !== null ? (f.return = l, _e = f) : ZR(e, t, r);
    }
  }
  function ZR(e, t, r) {
    for (; _e !== null; ) {
      var i = _e;
      if ((i.flags & Cl) !== be) {
        var l = i.alternate;
        wt(i);
        try {
          OM(t, l, i, r);
        } catch (A) {
          _t(i, i.return, A);
        }
        pn();
      }
      if (i === e) {
        _e = null;
        return;
      }
      var f = i.sibling;
      if (f !== null) {
        f.return = i.return, _e = f;
        return;
      }
      _e = i.return;
    }
  }
  function MM(e) {
    for (; _e !== null; ) {
      var t = _e, r = t.child;
      switch (t.tag) {
        case d:
        case V:
        case P:
        case U: {
          if (t.mode & pt)
            try {
              ha(), ta(zn, t, t.return);
            } finally {
              Sa(t);
            }
          else
            ta(zn, t, t.return);
          break;
        }
        case T: {
          Go(t, t.return);
          var i = t.stateNode;
          typeof i.componentWillUnmount == "function" && KR(t, t.return, i);
          break;
        }
        case v: {
          Go(t, t.return);
          break;
        }
        case z: {
          var l = t.memoizedState !== null;
          if (l) {
            n_(e);
            continue;
          }
          break;
        }
      }
      r !== null ? (r.return = t, _e = r) : n_(e);
    }
  }
  function n_(e) {
    for (; _e !== null; ) {
      var t = _e;
      if (t === e) {
        _e = null;
        return;
      }
      var r = t.sibling;
      if (r !== null) {
        r.return = t.return, _e = r;
        return;
      }
      _e = t.return;
    }
  }
  function PM(e) {
    for (; _e !== null; ) {
      var t = _e, r = t.child;
      if (t.tag === z) {
        var i = t.memoizedState !== null;
        if (i) {
          r_(e);
          continue;
        }
      }
      r !== null ? (r.return = t, _e = r) : r_(e);
    }
  }
  function r_(e) {
    for (; _e !== null; ) {
      var t = _e;
      wt(t);
      try {
        IM(t);
      } catch (i) {
        _t(t, t.return, i);
      }
      if (pn(), t === e) {
        _e = null;
        return;
      }
      var r = t.sibling;
      if (r !== null) {
        r.return = t.return, _e = r;
        return;
      }
      _e = t.return;
    }
  }
  function UM(e, t, r, i) {
    _e = t, xM(t, e, r, i);
  }
  function xM(e, t, r, i) {
    for (; _e !== null; ) {
      var l = _e, f = l.child;
      (l.subtreeFlags & ro) !== be && f !== null ? (f.return = l, _e = f) : wM(e, t, r, i);
    }
  }
  function wM(e, t, r, i) {
    for (; _e !== null; ) {
      var l = _e;
      if ((l.flags & Xr) !== be) {
        wt(l);
        try {
          GM(t, l, r, i);
        } catch (A) {
          _t(l, l.return, A);
        }
        pn();
      }
      if (l === e) {
        _e = null;
        return;
      }
      var f = l.sibling;
      if (f !== null) {
        f.return = l.return, _e = f;
        return;
      }
      _e = l.return;
    }
  }
  function GM(e, t, r, i) {
    switch (t.tag) {
      case d:
      case V:
      case U: {
        if (t.mode & pt) {
          LR();
          try {
            Pi(Ir | an, t);
          } finally {
            vR(t);
          }
        } else
          Pi(Ir | an, t);
        break;
      }
    }
  }
  function HM(e) {
    _e = e, BM();
  }
  function BM() {
    for (; _e !== null; ) {
      var e = _e, t = e.child;
      if ((_e.flags & as) !== be) {
        var r = e.deletions;
        if (r !== null) {
          for (var i = 0; i < r.length; i++) {
            var l = r[i];
            _e = l, VM(l, e);
          }
          {
            var f = e.alternate;
            if (f !== null) {
              var A = f.child;
              if (A !== null) {
                f.child = null;
                do {
                  var h = A.sibling;
                  A.sibling = null, A = h;
                } while (A !== null);
              }
            }
          }
          _e = e;
        }
      }
      (e.subtreeFlags & ro) !== be && t !== null ? (t.return = e, _e = t) : FM();
    }
  }
  function FM() {
    for (; _e !== null; ) {
      var e = _e;
      (e.flags & Xr) !== be && (wt(e), YM(e), pn());
      var t = e.sibling;
      if (t !== null) {
        t.return = e.return, _e = t;
        return;
      }
      _e = e.return;
    }
  }
  function YM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        e.mode & pt ? (LR(), ta(Ir | an, e, e.return), vR(e)) : ta(Ir | an, e, e.return);
        break;
      }
    }
  }
  function VM(e, t) {
    for (; _e !== null; ) {
      var r = _e;
      wt(r), kM(r, t), pn();
      var i = r.child;
      i !== null ? (i.return = r, _e = i) : WM(e);
    }
  }
  function WM(e) {
    for (; _e !== null; ) {
      var t = _e, r = t.sibling, i = t.return;
      if (zI(t), t === e) {
        _e = null;
        return;
      }
      if (r !== null) {
        r.return = i, _e = r;
        return;
      }
      _e = i;
    }
  }
  function kM(e, t) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        e.mode & pt ? (LR(), ta(Ir, e, t), vR(e)) : ta(Ir, e, t);
        break;
      }
    }
  }
  function XM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        try {
          Pi(zn | an, e);
        } catch (r) {
          _t(e, e.return, r);
        }
        break;
      }
      case T: {
        var t = e.stateNode;
        try {
          t.componentDidMount();
        } catch (r) {
          _t(e, e.return, r);
        }
        break;
      }
    }
  }
  function jM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        try {
          Pi(Ir | an, e);
        } catch (t) {
          _t(e, e.return, t);
        }
        break;
      }
    }
  }
  function KM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U: {
        try {
          ta(zn | an, e, e.return);
        } catch (r) {
          _t(e, e.return, r);
        }
        break;
      }
      case T: {
        var t = e.stateNode;
        typeof t.componentWillUnmount == "function" && KR(e, e.return, t);
        break;
      }
    }
  }
  function JM(e) {
    switch (e.tag) {
      case d:
      case V:
      case U:
        try {
          ta(Ir | an, e, e.return);
        } catch (t) {
          _t(e, e.return, t);
        }
    }
  }
  if (typeof Symbol == "function" && Symbol.for) {
    var Lu = Symbol.for;
    Lu("selector.component"), Lu("selector.has_pseudo_class"), Lu("selector.role"), Lu("selector.test_id"), Lu("selector.text");
  }
  var zM = [];
  function ZM() {
    zM.forEach(function(e) {
      return e();
    });
  }
  var qM = s.ReactCurrentActQueue;
  function QM(e) {
    {
      var t = (
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
      ), r = typeof jest < "u";
      return r && t !== !1;
    }
  }
  function a_() {
    {
      var e = (
        // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
        typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
      );
      return !e && qM.current !== null && u("The current testing environment is not configured to support act(...)"), e;
    }
  }
  var $M = Math.ceil, qR = s.ReactCurrentDispatcher, QR = s.ReactCurrentOwner, gn = s.ReactCurrentBatchConfig, aa = s.ReactCurrentActQueue, ln = (
    /*             */
    0
  ), i_ = (
    /*               */
    1
  ), Dn = (
    /*                */
    2
  ), Br = (
    /*                */
    4
  ), za = 0, yu = 1, Cs = 2, ff = 3, gu = 4, s_ = 5, $R = 6, qe = ln, qn = null, Gt = null, un = le, Oa = le, ep = Ci(le), En = za, Du = null, Tf = le, bu = le, df = le, Mu = null, Er = null, tp = 0, o_ = 500, l_ = 1 / 0, eP = 500, Za = null;
  function Pu() {
    l_ = Sn() + eP;
  }
  function u_() {
    return l_;
  }
  var Af = !1, np = null, Ho = null, ms = !1, xi = null, Uu = le, rp = [], ap = null, tP = 50, xu = 0, ip = null, sp = !1, Rf = !1, nP = 50, Bo = 0, pf = null, wu = mt, Sf = le, E_ = !1;
  function hf() {
    return qn;
  }
  function Qn() {
    return (qe & (Dn | Br)) !== ln ? Sn() : (wu !== mt || (wu = Sn()), wu);
  }
  function wi(e) {
    var t = e.mode;
    if ((t & Ze) === Me)
      return Ge;
    if ((qe & Dn) !== ln && un !== le)
      return Dl(un);
    var r = QD() !== qD;
    if (r) {
      if (gn.transition !== null) {
        var i = gn.transition;
        i._updatedFibers || (i._updatedFibers = /* @__PURE__ */ new Set()), i._updatedFibers.add(e);
      }
      return Sf === Nn && (Sf = Xh()), Sf;
    }
    var l = Kr();
    if (l !== Nn)
      return l;
    var f = wg();
    return f;
  }
  function rP(e) {
    var t = e.mode;
    return (t & Ze) === Me ? Ge : s1();
  }
  function cn(e, t, r, i) {
    LP(), E_ && u("useInsertionEffect must not schedule updates."), sp && (Rf = !0), bl(e, r, i), (qe & Dn) !== le && e === qn ? DP(t) : (jr && Jh(e, t, r), bP(t), e === qn && ((qe & Dn) === ln && (bu = We(bu, r)), En === gu && Gi(e, un)), cr(e, i), r === Ge && qe === ln && (t.mode & Ze) === Me && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
    !aa.isBatchingLegacy && (Pu(), EO()));
  }
  function aP(e, t, r) {
    var i = e.current;
    i.lanes = t, bl(e, t, r), cr(e, r);
  }
  function iP(e) {
    return (
      // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
      // decided not to enable it.
      (qe & Dn) !== ln
    );
  }
  function cr(e, t) {
    var r = e.callbackNode;
    e1(e, t);
    var i = FE(e, e === qn ? un : le);
    if (i === le) {
      r !== null && v_(r), e.callbackNode = null, e.callbackPriority = Nn;
      return;
    }
    var l = us(i), f = e.callbackPriority;
    if (f === l && // Special case related to `act`. If the currently scheduled task is a
    // Scheduler task, rather than an `act` task, cancel it and re-scheduled
    // on the `act` queue.
    !(aa.current !== null && r !== Tp)) {
      r == null && f !== Ge && u("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
      return;
    }
    r != null && v_(r);
    var A;
    if (l === Ge)
      e.tag === mi ? (aa.isBatchingLegacy !== null && (aa.didScheduleLegacyUpdate = !0), UD(T_.bind(null, e))) : uO(T_.bind(null, e)), aa.current !== null ? aa.current.push(vi) : Hg(function() {
        (qe & (Dn | Br)) === ln && vi();
      }), A = null;
    else {
      var h;
      switch (qh(i)) {
        case Pr:
          h = nd;
          break;
        case Ai:
          h = Gh;
          break;
        case Ri:
          h = ml;
          break;
        case yd:
          h = Hh;
          break;
        default:
          h = ml;
          break;
      }
      A = dp(h, c_.bind(null, e));
    }
    e.callbackPriority = l, e.callbackNode = A;
  }
  function c_(e, t) {
    if (Lb(), wu = mt, Sf = le, (qe & (Dn | Br)) !== ln)
      throw new Error("Should not already be working.");
    var r = e.callbackNode, i = Qa();
    if (i && e.callbackNode !== r)
      return null;
    var l = FE(e, e === qn ? un : le);
    if (l === le)
      return null;
    var f = !YE(e, l) && !i1(e, l) && !t, A = f ? AP(e, l) : Of(e, l);
    if (A !== za) {
      if (A === Cs) {
        var h = _d(e);
        h !== le && (l = h, A = op(e, h));
      }
      if (A === yu) {
        var I = Du;
        throw vs(e, le), Gi(e, l), cr(e, Sn()), I;
      }
      if (A === $R)
        Gi(e, l);
      else {
        var L = !YE(e, l), b = e.current.alternate;
        if (L && !oP(b)) {
          if (A = Of(e, l), A === Cs) {
            var k = _d(e);
            k !== le && (l = k, A = op(e, k));
          }
          if (A === yu) {
            var W = Du;
            throw vs(e, le), Gi(e, l), cr(e, Sn()), W;
          }
        }
        e.finishedWork = b, e.finishedLanes = l, sP(e, A, l);
      }
    }
    return cr(e, Sn()), e.callbackNode === r ? c_.bind(null, e) : null;
  }
  function op(e, t) {
    var r = Mu;
    if (WE(e)) {
      var i = vs(e, t);
      i.flags |= Ga, LD(e.containerInfo);
    }
    var l = Of(e, t);
    if (l !== Cs) {
      var f = Er;
      Er = r, f !== null && f_(f);
    }
    return l;
  }
  function f_(e) {
    Er === null ? Er = e : Er.push.apply(Er, e);
  }
  function sP(e, t, r) {
    switch (t) {
      case za:
      case yu:
        throw new Error("Root did not complete. This is a bug in React.");
      case Cs: {
        Ls(e, Er, Za);
        break;
      }
      case ff: {
        if (Gi(e, r), Wh(r) && // do not delay if we're inside an act() scope
        !L_()) {
          var i = tp + o_ - Sn();
          if (i > 10) {
            var l = FE(e, le);
            if (l !== le)
              break;
            var f = e.suspendedLanes;
            if (!oo(f, r)) {
              Qn(), Kh(e, f);
              break;
            }
            e.timeoutHandle = rA(Ls.bind(null, e, Er, Za), i);
            break;
          }
        }
        Ls(e, Er, Za);
        break;
      }
      case gu: {
        if (Gi(e, r), a1(r))
          break;
        if (!L_()) {
          var A = Q0(e, r), h = A, I = Sn() - h, L = vP(I) - I;
          if (L > 10) {
            e.timeoutHandle = rA(Ls.bind(null, e, Er, Za), L);
            break;
          }
        }
        Ls(e, Er, Za);
        break;
      }
      case s_: {
        Ls(e, Er, Za);
        break;
      }
      default:
        throw new Error("Unknown root exit status.");
    }
  }
  function oP(e) {
    for (var t = e; ; ) {
      if (t.flags & PE) {
        var r = t.updateQueue;
        if (r !== null) {
          var i = r.stores;
          if (i !== null)
            for (var l = 0; l < i.length; l++) {
              var f = i[l], A = f.getSnapshot, h = f.value;
              try {
                if (!Nr(A(), h))
                  return !1;
              } catch {
                return !1;
              }
            }
        }
      }
      var I = t.child;
      if (t.subtreeFlags & PE && I !== null) {
        I.return = t, t = I;
        continue;
      }
      if (t === e)
        return !0;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e)
          return !0;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return !0;
  }
  function Gi(e, t) {
    t = VE(t, df), t = VE(t, bu), l1(e, t);
  }
  function T_(e) {
    if (yb(), (qe & (Dn | Br)) !== ln)
      throw new Error("Should not already be working.");
    Qa();
    var t = FE(e, le);
    if (!Sr(t, Ge))
      return cr(e, Sn()), null;
    var r = Of(e, t);
    if (e.tag !== mi && r === Cs) {
      var i = _d(e);
      i !== le && (t = i, r = op(e, i));
    }
    if (r === yu) {
      var l = Du;
      throw vs(e, le), Gi(e, t), cr(e, Sn()), l;
    }
    if (r === $R)
      throw new Error("Root did not complete. This is a bug in React.");
    var f = e.current.alternate;
    return e.finishedWork = f, e.finishedLanes = t, Ls(e, Er, Za), cr(e, Sn()), null;
  }
  function lP(e, t) {
    t !== le && (Ld(e, We(t, Ge)), cr(e, Sn()), (qe & (Dn | Br)) === ln && (Pu(), vi()));
  }
  function lp(e, t) {
    var r = qe;
    qe |= i_;
    try {
      return e(t);
    } finally {
      qe = r, qe === ln && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !aa.isBatchingLegacy && (Pu(), EO());
    }
  }
  function uP(e, t, r, i, l) {
    var f = Kr(), A = gn.transition;
    try {
      return gn.transition = null, On(Pr), e(t, r, i, l);
    } finally {
      On(f), gn.transition = A, qe === ln && Pu();
    }
  }
  function qa(e) {
    xi !== null && xi.tag === mi && (qe & (Dn | Br)) === ln && Qa();
    var t = qe;
    qe |= i_;
    var r = gn.transition, i = Kr();
    try {
      return gn.transition = null, On(Pr), e ? e() : void 0;
    } finally {
      On(i), gn.transition = r, qe = t, (qe & (Dn | Br)) === ln && vi();
    }
  }
  function d_() {
    return (qe & (Dn | Br)) !== ln;
  }
  function Nf(e, t) {
    Yn(ep, Oa, e), Oa = We(Oa, t);
  }
  function up(e) {
    Oa = ep.current, Fn(ep, e);
  }
  function vs(e, t) {
    e.finishedWork = null, e.finishedLanes = le;
    var r = e.timeoutHandle;
    if (r !== aA && (e.timeoutHandle = aA, Gg(r)), Gt !== null)
      for (var i = Gt.return; i !== null; ) {
        var l = i.alternate;
        WI(l, i), i = i.return;
      }
    qn = e;
    var f = ys(e.current, null);
    return Gt = f, un = Oa = t, En = za, Du = null, Tf = le, bu = le, df = le, Mu = null, Er = null, nb(), Zr.discardPendingWarnings(), f;
  }
  function A_(e, t) {
    do {
      var r = Gt;
      try {
        if (Lc(), jO(), pn(), QR.current = null, r === null || r.return === null) {
          En = yu, Du = t, Gt = null;
          return;
        }
        if (Tn && r.mode & pt && sf(r, !0), xn)
          if (t !== null && typeof t == "object" && typeof t.then == "function") {
            var i = t;
          }
        Pb(e, r.return, r, t, un), h_(r);
      } catch (l) {
        t = l, Gt === r && r !== null ? (r = r.return, Gt = r) : r = Gt;
        continue;
      }
      return;
    } while (!0);
  }
  function R_() {
    var e = qR.current;
    return qR.current = ef, e === null ? ef : e;
  }
  function p_(e) {
    qR.current = e;
  }
  function EP() {
    tp = Sn();
  }
  function Gu(e) {
    Tf = We(e, Tf);
  }
  function cP() {
    En === za && (En = ff);
  }
  function Ep() {
    (En === za || En === ff || En === Cs) && (En = gu), qn !== null && (Cd(Tf) || Cd(bu)) && Gi(qn, un);
  }
  function fP(e) {
    En !== gu && (En = Cs), Mu === null ? Mu = [e] : Mu.push(e);
  }
  function TP() {
    return En === za;
  }
  function Of(e, t) {
    var r = qe;
    qe |= Dn;
    var i = R_();
    if (qn !== e || un !== t) {
      if (jr) {
        var l = e.memoizedUpdaters;
        l.size > 0 && (Hu(e, un), l.clear()), zh(e, t);
      }
      Za = Zh(), vs(e, t);
    }
    do
      try {
        dP();
        break;
      } catch (f) {
        A_(e, f);
      }
    while (!0);
    if (Lc(), qe = r, p_(i), Gt !== null)
      throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
    return qn = null, un = le, En;
  }
  function dP() {
    for (; Gt !== null; )
      S_(Gt);
  }
  function AP(e, t) {
    var r = qe;
    qe |= Dn;
    var i = R_();
    if (qn !== e || un !== t) {
      if (jr) {
        var l = e.memoizedUpdaters;
        l.size > 0 && (Hu(e, un), l.clear()), zh(e, t);
      }
      Za = Zh(), Pu(), vs(e, t);
    }
    do
      try {
        RP();
        break;
      } catch (f) {
        A_(e, f);
      }
    while (!0);
    return Lc(), p_(i), qe = r, Gt !== null ? za : (qn = null, un = le, En);
  }
  function RP() {
    for (; Gt !== null && !V0(); )
      S_(Gt);
  }
  function S_(e) {
    var t = e.alternate;
    wt(e);
    var r;
    (e.mode & pt) !== Me ? (mR(e), r = cp(t, e, Oa), sf(e, !0)) : r = cp(t, e, Oa), pn(), e.memoizedProps = e.pendingProps, r === null ? h_(e) : Gt = r, QR.current = null;
  }
  function h_(e) {
    var t = e;
    do {
      var r = t.alternate, i = t.return;
      if ((t.flags & _l) === be) {
        wt(t);
        var l = void 0;
        if ((t.mode & pt) === Me ? l = VI(r, t, Oa) : (mR(t), l = VI(r, t, Oa), sf(t, !1)), pn(), l !== null) {
          Gt = l;
          return;
        }
      } else {
        var f = cM(r, t);
        if (f !== null) {
          f.flags &= w0, Gt = f;
          return;
        }
        if ((t.mode & pt) !== Me) {
          sf(t, !1);
          for (var A = t.actualDuration, h = t.child; h !== null; )
            A += h.actualDuration, h = h.sibling;
          t.actualDuration = A;
        }
        if (i !== null)
          i.flags |= _l, i.subtreeFlags = be, i.deletions = null;
        else {
          En = $R, Gt = null;
          return;
        }
      }
      var I = t.sibling;
      if (I !== null) {
        Gt = I;
        return;
      }
      t = i, Gt = t;
    } while (t !== null);
    En === za && (En = s_);
  }
  function Ls(e, t, r) {
    var i = Kr(), l = gn.transition;
    try {
      gn.transition = null, On(Pr), pP(e, t, r, i);
    } finally {
      gn.transition = l, On(i);
    }
    return null;
  }
  function pP(e, t, r, i) {
    do
      Qa();
    while (xi !== null);
    if (yP(), (qe & (Dn | Br)) !== ln)
      throw new Error("Should not already be working.");
    var l = e.finishedWork, f = e.finishedLanes;
    if (l === null)
      return null;
    if (f === le && u("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = le, l === e.current)
      throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
    e.callbackNode = null, e.callbackPriority = Nn;
    var A = We(l.lanes, l.childLanes);
    u1(e, A), e === qn && (qn = null, Gt = null, un = le), ((l.subtreeFlags & ro) !== be || (l.flags & ro) !== be) && (ms || (ms = !0, ap = r, dp(ml, function() {
      return Qa(), null;
    })));
    var h = (l.subtreeFlags & (ed | td | Cl | ro)) !== be, I = (l.flags & (ed | td | Cl | ro)) !== be;
    if (h || I) {
      var L = gn.transition;
      gn.transition = null;
      var b = Kr();
      On(Pr);
      var k = qe;
      qe |= Br, QR.current = null, RM(e, l), RI(), DM(e, l, f), Dg(e.containerInfo), e.current = l, bM(l, e, f), W0(), qe = k, On(b), gn.transition = L;
    } else
      e.current = l, RI();
    var W = ms;
    if (ms ? (ms = !1, xi = e, Uu = f) : (Bo = 0, pf = null), A = e.pendingLanes, A === le && (Ho = null), W || __(e.current, !1), l.stateNode, jr && e.memoizedUpdaters.clear(), ZM(), cr(e, Sn()), t !== null)
      for (var q = e.onRecoverableError, Q = 0; Q < t.length; Q++) {
        var re = t[Q], Ne = re.stack, ye = re.digest;
        q(re.value, {
          componentStack: Ne,
          digest: ye
        });
      }
    if (Af) {
      Af = !1;
      var me = np;
      throw np = null, me;
    }
    return Sr(Uu, Ge) && e.tag !== mi && Qa(), A = e.pendingLanes, Sr(A, Ge) ? (vb(), e === ip ? xu++ : (xu = 0, ip = e)) : xu = 0, vi(), null;
  }
  function Qa() {
    if (xi !== null) {
      var e = qh(Uu), t = T1(Ri, e), r = gn.transition, i = Kr();
      try {
        return gn.transition = null, On(t), hP();
      } finally {
        On(i), gn.transition = r;
      }
    }
    return !1;
  }
  function SP(e) {
    rp.push(e), ms || (ms = !0, dp(ml, function() {
      return Qa(), null;
    }));
  }
  function hP() {
    if (xi === null)
      return !1;
    var e = ap;
    ap = null;
    var t = xi, r = Uu;
    if (xi = null, Uu = le, (qe & (Dn | Br)) !== ln)
      throw new Error("Cannot flush passive effects while already rendering.");
    sp = !0, Rf = !1;
    var i = qe;
    qe |= Br, HM(t.current), UM(t, t.current, r, e);
    {
      var l = rp;
      rp = [];
      for (var f = 0; f < l.length; f++) {
        var A = l[f];
        NM(t, A);
      }
    }
    __(t.current, !0), qe = i, vi(), Rf ? t === pf ? Bo++ : (Bo = 0, pf = t) : Bo = 0, sp = !1, Rf = !1;
    {
      var h = t.current.stateNode;
      h.effectDuration = 0, h.passiveEffectDuration = 0;
    }
    return !0;
  }
  function N_(e) {
    return Ho !== null && Ho.has(e);
  }
  function NP(e) {
    Ho === null ? Ho = /* @__PURE__ */ new Set([e]) : Ho.add(e);
  }
  function OP(e) {
    Af || (Af = !0, np = e);
  }
  var IP = OP;
  function O_(e, t, r) {
    var i = Is(r, t), l = SI(e, i, Ge), f = yi(e, l, Ge), A = Qn();
    f !== null && (bl(f, Ge, A), cr(f, A));
  }
  function _t(e, t, r) {
    if (TM(r), Bu(!1), e.tag === N) {
      O_(e, e, r);
      return;
    }
    var i = null;
    for (i = t; i !== null; ) {
      if (i.tag === N) {
        O_(i, e, r);
        return;
      } else if (i.tag === T) {
        var l = i.type, f = i.stateNode;
        if (typeof l.getDerivedStateFromError == "function" || typeof f.componentDidCatch == "function" && !N_(f)) {
          var A = Is(r, e), h = bR(i, A, Ge), I = yi(i, h, Ge), L = Qn();
          I !== null && (bl(I, Ge, L), cr(I, L));
          return;
        }
      }
      i = i.return;
    }
    u(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, r);
  }
  function _P(e, t, r) {
    var i = e.pingCache;
    i !== null && i.delete(t);
    var l = Qn();
    Kh(e, r), MP(e), qn === e && oo(un, r) && (En === gu || En === ff && Wh(un) && Sn() - tp < o_ ? vs(e, le) : df = We(df, r)), cr(e, l);
  }
  function I_(e, t) {
    t === Nn && (t = rP(e));
    var r = Qn(), i = ur(e, t);
    i !== null && (bl(i, t, r), cr(i, r));
  }
  function CP(e) {
    var t = e.memoizedState, r = Nn;
    t !== null && (r = t.retryLane), I_(e, r);
  }
  function mP(e, t) {
    var r = Nn, i;
    switch (e.tag) {
      case G:
        i = e.stateNode;
        var l = e.memoizedState;
        l !== null && (r = l.retryLane);
        break;
      case F:
        i = e.stateNode;
        break;
      default:
        throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
    }
    i !== null && i.delete(t), I_(e, r);
  }
  function vP(e) {
    return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : $M(e / 1960) * 1960;
  }
  function LP() {
    if (xu > tP)
      throw xu = 0, ip = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
    Bo > nP && (Bo = 0, pf = null, u("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
  }
  function yP() {
    Zr.flushLegacyContextWarning(), Zr.flushPendingUnsafeLifecycleWarnings();
  }
  function __(e, t) {
    wt(e), If(e, Ba, KM), t && If(e, UE, JM), If(e, Ba, XM), t && If(e, UE, jM), pn();
  }
  function If(e, t, r) {
    for (var i = e, l = null; i !== null; ) {
      var f = i.subtreeFlags & t;
      i !== l && i.child !== null && f !== be ? i = i.child : ((i.flags & t) !== be && r(i), i.sibling !== null ? i = i.sibling : i = l = i.return);
    }
  }
  var _f = null;
  function C_(e) {
    {
      if ((qe & Dn) !== ln || !(e.mode & Ze))
        return;
      var t = e.tag;
      if (t !== S && t !== N && t !== T && t !== d && t !== V && t !== P && t !== U)
        return;
      var r = Ye(e) || "ReactComponent";
      if (_f !== null) {
        if (_f.has(r))
          return;
        _f.add(r);
      } else
        _f = /* @__PURE__ */ new Set([r]);
      var i = Bn;
      try {
        wt(e), u("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
      } finally {
        i ? wt(e) : pn();
      }
    }
  }
  var cp;
  {
    var gP = null;
    cp = function(e, t, r) {
      var i = M_(gP, t);
      try {
        return GI(e, t, r);
      } catch (f) {
        if (VD() || f !== null && typeof f == "object" && typeof f.then == "function")
          throw f;
        if (Lc(), jO(), WI(e, t), M_(t, i), t.mode & pt && mR(t), JT(null, GI, null, e, t, r), M0()) {
          var l = zT();
          typeof l == "object" && l !== null && l._suppressLogging && typeof f == "object" && f !== null && !f._suppressLogging && (f._suppressLogging = !0);
        }
        throw f;
      }
    };
  }
  var m_ = !1, fp;
  fp = /* @__PURE__ */ new Set();
  function DP(e) {
    if (ts && !_b())
      switch (e.tag) {
        case d:
        case V:
        case U: {
          var t = Gt && Ye(Gt) || "Unknown", r = t;
          if (!fp.has(r)) {
            fp.add(r);
            var i = Ye(e) || "Unknown";
            u("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", i, t, t);
          }
          break;
        }
        case T: {
          m_ || (u("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), m_ = !0);
          break;
        }
      }
  }
  function Hu(e, t) {
    if (jr) {
      var r = e.memoizedUpdaters;
      r.forEach(function(i) {
        Jh(e, i, t);
      });
    }
  }
  var Tp = {};
  function dp(e, t) {
    {
      var r = aa.current;
      return r !== null ? (r.push(t), Tp) : wh(e, t);
    }
  }
  function v_(e) {
    if (e !== Tp)
      return Y0(e);
  }
  function L_() {
    return aa.current !== null;
  }
  function bP(e) {
    {
      if (e.mode & Ze) {
        if (!a_())
          return;
      } else if (!QM() || qe !== ln || e.tag !== d && e.tag !== V && e.tag !== U)
        return;
      if (aa.current === null) {
        var t = Bn;
        try {
          wt(e), u(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, Ye(e));
        } finally {
          t ? wt(e) : pn();
        }
      }
    }
  }
  function MP(e) {
    e.tag !== mi && a_() && aa.current === null && u(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
  }
  function Bu(e) {
    E_ = e;
  }
  var Fr = null, Fo = null, PP = function(e) {
    Fr = e;
  };
  function Yo(e) {
    {
      if (Fr === null)
        return e;
      var t = Fr(e);
      return t === void 0 ? e : t.current;
    }
  }
  function Ap(e) {
    return Yo(e);
  }
  function Rp(e) {
    {
      if (Fr === null)
        return e;
      var t = Fr(e);
      if (t === void 0) {
        if (e != null && typeof e.render == "function") {
          var r = Yo(e.render);
          if (e.render !== r) {
            var i = {
              $$typeof: Ie,
              render: r
            };
            return e.displayName !== void 0 && (i.displayName = e.displayName), i;
          }
        }
        return e;
      }
      return t.current;
    }
  }
  function y_(e, t) {
    {
      if (Fr === null)
        return !1;
      var r = e.elementType, i = t.type, l = !1, f = typeof i == "object" && i !== null ? i.$$typeof : null;
      switch (e.tag) {
        case T: {
          typeof i == "function" && (l = !0);
          break;
        }
        case d: {
          (typeof i == "function" || f === ge) && (l = !0);
          break;
        }
        case V: {
          (f === Ie || f === ge) && (l = !0);
          break;
        }
        case P:
        case U: {
          (f === Ve || f === ge) && (l = !0);
          break;
        }
        default:
          return !1;
      }
      if (l) {
        var A = Fr(r);
        if (A !== void 0 && A === Fr(i))
          return !0;
      }
      return !1;
    }
  }
  function g_(e) {
    {
      if (Fr === null || typeof WeakSet != "function")
        return;
      Fo === null && (Fo = /* @__PURE__ */ new WeakSet()), Fo.add(e);
    }
  }
  var UP = function(e, t) {
    {
      if (Fr === null)
        return;
      var r = t.staleFamilies, i = t.updatedFamilies;
      Qa(), qa(function() {
        pp(e.current, i, r);
      });
    }
  }, xP = function(e, t) {
    {
      if (e.context !== Or)
        return;
      Qa(), qa(function() {
        Fu(t, e, null, null);
      });
    }
  };
  function pp(e, t, r) {
    {
      var i = e.alternate, l = e.child, f = e.sibling, A = e.tag, h = e.type, I = null;
      switch (A) {
        case d:
        case U:
        case T:
          I = h;
          break;
        case V:
          I = h.render;
          break;
      }
      if (Fr === null)
        throw new Error("Expected resolveFamily to be set during hot reload.");
      var L = !1, b = !1;
      if (I !== null) {
        var k = Fr(I);
        k !== void 0 && (r.has(k) ? b = !0 : t.has(k) && (A === T ? b = !0 : L = !0));
      }
      if (Fo !== null && (Fo.has(e) || i !== null && Fo.has(i)) && (b = !0), b && (e._debugNeedsRemount = !0), b || L) {
        var W = ur(e, Ge);
        W !== null && cn(W, e, Ge, mt);
      }
      l !== null && !b && pp(l, t, r), f !== null && pp(f, t, r);
    }
  }
  var wP = function(e, t) {
    {
      var r = /* @__PURE__ */ new Set(), i = new Set(t.map(function(l) {
        return l.current;
      }));
      return Sp(e.current, i, r), r;
    }
  };
  function Sp(e, t, r) {
    {
      var i = e.child, l = e.sibling, f = e.tag, A = e.type, h = null;
      switch (f) {
        case d:
        case U:
        case T:
          h = A;
          break;
        case V:
          h = A.render;
          break;
      }
      var I = !1;
      h !== null && t.has(h) && (I = !0), I ? GP(e, r) : i !== null && Sp(i, t, r), l !== null && Sp(l, t, r);
    }
  }
  function GP(e, t) {
    {
      var r = HP(e, t);
      if (r)
        return;
      for (var i = e; ; ) {
        switch (i.tag) {
          case v:
            t.add(i.stateNode);
            return;
          case m:
            t.add(i.stateNode.containerInfo);
            return;
          case N:
            t.add(i.stateNode.containerInfo);
            return;
        }
        if (i.return === null)
          throw new Error("Expected to reach root first.");
        i = i.return;
      }
    }
  }
  function HP(e, t) {
    for (var r = e, i = !1; ; ) {
      if (r.tag === v)
        i = !0, t.add(r.stateNode);
      else if (r.child !== null) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === e)
        return i;
      for (; r.sibling === null; ) {
        if (r.return === null || r.return === e)
          return i;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return !1;
  }
  var hp;
  {
    hp = !1;
    try {
      var D_ = Object.preventExtensions({});
    } catch {
      hp = !0;
    }
  }
  function BP(e, t, r, i) {
    this.tag = e, this.key = r, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = t, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = i, this.flags = be, this.subtreeFlags = be, this.deletions = null, this.lanes = le, this.childLanes = le, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !hp && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
  }
  var _r = function(e, t, r, i) {
    return new BP(e, t, r, i);
  };
  function Np(e) {
    var t = e.prototype;
    return !!(t && t.isReactComponent);
  }
  function FP(e) {
    return typeof e == "function" && !Np(e) && e.defaultProps === void 0;
  }
  function YP(e) {
    if (typeof e == "function")
      return Np(e) ? T : d;
    if (e != null) {
      var t = e.$$typeof;
      if (t === Ie)
        return V;
      if (t === Ve)
        return P;
    }
    return S;
  }
  function ys(e, t) {
    var r = e.alternate;
    r === null ? (r = _r(e.tag, t, e.key, e.mode), r.elementType = e.elementType, r.type = e.type, r.stateNode = e.stateNode, r._debugSource = e._debugSource, r._debugOwner = e._debugOwner, r._debugHookTypes = e._debugHookTypes, r.alternate = e, e.alternate = r) : (r.pendingProps = t, r.type = e.type, r.flags = be, r.subtreeFlags = be, r.deletions = null, r.actualDuration = 0, r.actualStartTime = -1), r.flags = e.flags & Fa, r.childLanes = e.childLanes, r.lanes = e.lanes, r.child = e.child, r.memoizedProps = e.memoizedProps, r.memoizedState = e.memoizedState, r.updateQueue = e.updateQueue;
    var i = e.dependencies;
    switch (r.dependencies = i === null ? null : {
      lanes: i.lanes,
      firstContext: i.firstContext
    }, r.sibling = e.sibling, r.index = e.index, r.ref = e.ref, r.selfBaseDuration = e.selfBaseDuration, r.treeBaseDuration = e.treeBaseDuration, r._debugNeedsRemount = e._debugNeedsRemount, r.tag) {
      case S:
      case d:
      case U:
        r.type = Yo(e.type);
        break;
      case T:
        r.type = Ap(e.type);
        break;
      case V:
        r.type = Rp(e.type);
        break;
    }
    return r;
  }
  function VP(e, t) {
    e.flags &= Fa | Zt;
    var r = e.alternate;
    if (r === null)
      e.childLanes = le, e.lanes = t, e.child = null, e.subtreeFlags = be, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
    else {
      e.childLanes = r.childLanes, e.lanes = r.lanes, e.child = r.child, e.subtreeFlags = be, e.deletions = null, e.memoizedProps = r.memoizedProps, e.memoizedState = r.memoizedState, e.updateQueue = r.updateQueue, e.type = r.type;
      var i = r.dependencies;
      e.dependencies = i === null ? null : {
        lanes: i.lanes,
        firstContext: i.firstContext
      }, e.selfBaseDuration = r.selfBaseDuration, e.treeBaseDuration = r.treeBaseDuration;
    }
    return e;
  }
  function WP(e, t, r) {
    var i;
    return e === hc ? (i = Ze, t === !0 && (i |= qt, i |= fa)) : i = Me, jr && (i |= pt), _r(N, null, null, i);
  }
  function Op(e, t, r, i, l, f) {
    var A = S, h = e;
    if (typeof e == "function")
      Np(e) ? (A = T, h = Ap(h)) : h = Yo(h);
    else if (typeof e == "string")
      A = v;
    else
      e:
        switch (e) {
          case ua:
            return Hi(r.children, l, f, t);
          case Qi:
            A = y, l |= qt, (l & Ze) !== Me && (l |= fa);
            break;
          case B:
            return kP(r, l, f, t);
          case je:
            return XP(r, l, f, t);
          case nt:
            return jP(r, l, f, t);
          case Dt:
            return b_(r, l, f, t);
          case Hn:
          case rn:
          case Ea:
          case Ws:
          case gt:
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case ue:
                  A = g;
                  break e;
                case Re:
                  A = O;
                  break e;
                case Ie:
                  A = V, h = Rp(h);
                  break e;
                case Ve:
                  A = P;
                  break e;
                case ge:
                  A = Y, h = null;
                  break e;
              }
            var I = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (I += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var L = i ? Ye(i) : null;
              L && (I += `

Check the render method of \`` + L + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + I));
          }
        }
    var b = _r(A, r, t, l);
    return b.elementType = e, b.type = h, b.lanes = f, b._debugOwner = i, b;
  }
  function Ip(e, t, r) {
    var i = null;
    i = e._owner;
    var l = e.type, f = e.key, A = e.props, h = Op(l, f, A, i, t, r);
    return h._debugSource = e._source, h._debugOwner = e._owner, h;
  }
  function Hi(e, t, r, i) {
    var l = _r(w, e, i, t);
    return l.lanes = r, l;
  }
  function kP(e, t, r, i) {
    typeof e.id != "string" && u('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
    var l = _r(D, e, i, t | pt);
    return l.elementType = B, l.lanes = r, l.stateNode = {
      effectDuration: 0,
      passiveEffectDuration: 0
    }, l;
  }
  function XP(e, t, r, i) {
    var l = _r(G, e, i, t);
    return l.elementType = je, l.lanes = r, l;
  }
  function jP(e, t, r, i) {
    var l = _r(F, e, i, t);
    return l.elementType = nt, l.lanes = r, l;
  }
  function b_(e, t, r, i) {
    var l = _r(z, e, i, t);
    l.elementType = Dt, l.lanes = r;
    var f = {
      isHidden: !1
    };
    return l.stateNode = f, l;
  }
  function _p(e, t, r) {
    var i = _r(M, e, null, t);
    return i.lanes = r, i;
  }
  function KP() {
    var e = _r(v, null, null, Me);
    return e.elementType = "DELETED", e;
  }
  function JP(e) {
    var t = _r(_, null, null, Me);
    return t.stateNode = e, t;
  }
  function Cp(e, t, r) {
    var i = e.children !== null ? e.children : [], l = _r(m, i, e.key, t);
    return l.lanes = r, l.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      // Used by persistent updates
      implementation: e.implementation
    }, l;
  }
  function M_(e, t) {
    return e === null && (e = _r(S, null, null, Me)), e.tag = t.tag, e.key = t.key, e.elementType = t.elementType, e.type = t.type, e.stateNode = t.stateNode, e.return = t.return, e.child = t.child, e.sibling = t.sibling, e.index = t.index, e.ref = t.ref, e.pendingProps = t.pendingProps, e.memoizedProps = t.memoizedProps, e.updateQueue = t.updateQueue, e.memoizedState = t.memoizedState, e.dependencies = t.dependencies, e.mode = t.mode, e.flags = t.flags, e.subtreeFlags = t.subtreeFlags, e.deletions = t.deletions, e.lanes = t.lanes, e.childLanes = t.childLanes, e.alternate = t.alternate, e.actualDuration = t.actualDuration, e.actualStartTime = t.actualStartTime, e.selfBaseDuration = t.selfBaseDuration, e.treeBaseDuration = t.treeBaseDuration, e._debugSource = t._debugSource, e._debugOwner = t._debugOwner, e._debugNeedsRemount = t._debugNeedsRemount, e._debugHookTypes = t._debugHookTypes, e;
  }
  function zP(e, t, r, i, l) {
    this.tag = t, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = aA, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Nn, this.eventTimes = vd(le), this.expirationTimes = vd(mt), this.pendingLanes = le, this.suspendedLanes = le, this.pingedLanes = le, this.expiredLanes = le, this.mutableReadLanes = le, this.finishedLanes = le, this.entangledLanes = le, this.entanglements = vd(le), this.identifierPrefix = i, this.onRecoverableError = l, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
    {
      this.memoizedUpdaters = /* @__PURE__ */ new Set();
      for (var f = this.pendingUpdatersLaneMap = [], A = 0; A < Fh; A++)
        f.push(/* @__PURE__ */ new Set());
    }
    switch (t) {
      case hc:
        this._debugRootType = r ? "hydrateRoot()" : "createRoot()";
        break;
      case mi:
        this._debugRootType = r ? "hydrate()" : "render()";
        break;
    }
  }
  function P_(e, t, r, i, l, f, A, h, I, L) {
    var b = new zP(e, t, r, h, I), k = WP(t, f);
    b.current = k, k.stateNode = b;
    {
      var W = {
        element: i,
        isDehydrated: r,
        cache: null,
        // not enabled yet
        transitions: null,
        pendingSuspenseBoundaries: null
      };
      k.memoizedState = W;
    }
    return bA(k), b;
  }
  var mp = "18.2.0";
  function ZP(e, t, r) {
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return Lr(i), {
      // This tag allow us to uniquely identify this as a React Portal
      $$typeof: kr,
      key: i == null ? null : "" + i,
      children: e,
      containerInfo: t,
      implementation: r
    };
  }
  var vp, Lp;
  vp = !1, Lp = {};
  function U_(e) {
    if (!e)
      return Or;
    var t = to(e), r = PD(t);
    if (t.tag === T) {
      var i = t.type;
      if (da(i))
        return oO(t, i, r);
    }
    return r;
  }
  function qP(e, t) {
    {
      var r = to(e);
      if (r === void 0) {
        if (typeof e.render == "function")
          throw new Error("Unable to find node on an unmounted component.");
        var i = Object.keys(e).join(",");
        throw new Error("Argument appears to not be a ReactComponent. Keys: " + i);
      }
      var l = Ph(r);
      if (l === null)
        return null;
      if (l.mode & qt) {
        var f = Ye(r) || "Component";
        if (!Lp[f]) {
          Lp[f] = !0;
          var A = Bn;
          try {
            wt(l), r.mode & qt ? u("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, f) : u("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", t, t, f);
          } finally {
            A ? wt(A) : pn();
          }
        }
      }
      return l.stateNode;
    }
  }
  function x_(e, t, r, i, l, f, A, h) {
    var I = !1, L = null;
    return P_(e, t, I, L, r, i, l, f, A);
  }
  function w_(e, t, r, i, l, f, A, h, I, L) {
    var b = !0, k = P_(r, i, b, e, l, f, A, h, I);
    k.context = U_(null);
    var W = k.current, q = Qn(), Q = wi(W), re = Ka(q, Q);
    return re.callback = t ?? null, yi(W, re, Q), aP(k, Q, q), k;
  }
  function Fu(e, t, r, i) {
    var l = t.current, f = Qn(), A = wi(l), h = U_(r);
    t.context === null ? t.context = h : t.pendingContext = h, ts && Bn !== null && !vp && (vp = !0, u(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, Ye(Bn) || "Unknown"));
    var I = Ka(f, A);
    I.payload = {
      element: e
    }, i = i === void 0 ? null : i, i !== null && (typeof i != "function" && u("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", i), I.callback = i);
    var L = yi(l, I, A);
    return L !== null && (cn(L, l, A, f), Mc(L, l, A)), A;
  }
  function Cf(e) {
    var t = e.current;
    if (!t.child)
      return null;
    switch (t.child.tag) {
      case v:
        return t.child.stateNode;
      default:
        return t.child.stateNode;
    }
  }
  function QP(e) {
    switch (e.tag) {
      case N: {
        var t = e.stateNode;
        if (WE(t)) {
          var r = t1(t);
          lP(t, r);
        }
        break;
      }
      case G: {
        qa(function() {
          var l = ur(e, Ge);
          if (l !== null) {
            var f = Qn();
            cn(l, e, Ge, f);
          }
        });
        var i = Ge;
        yp(e, i);
        break;
      }
    }
  }
  function G_(e, t) {
    var r = e.memoizedState;
    r !== null && r.dehydrated !== null && (r.retryLane = o1(r.retryLane, t));
  }
  function yp(e, t) {
    G_(e, t);
    var r = e.alternate;
    r && G_(r, t);
  }
  function $P(e) {
    if (e.tag === G) {
      var t = wE, r = ur(e, t);
      if (r !== null) {
        var i = Qn();
        cn(r, e, t, i);
      }
      yp(e, t);
    }
  }
  function eU(e) {
    if (e.tag === G) {
      var t = wi(e), r = ur(e, t);
      if (r !== null) {
        var i = Qn();
        cn(r, e, t, i);
      }
      yp(e, t);
    }
  }
  function H_(e) {
    var t = F0(e);
    return t === null ? null : t.stateNode;
  }
  var B_ = function(e) {
    return null;
  };
  function tU(e) {
    return B_(e);
  }
  var F_ = function(e) {
    return !1;
  };
  function nU(e) {
    return F_(e);
  }
  var Y_ = null, V_ = null, W_ = null, k_ = null, X_ = null, j_ = null, K_ = null, J_ = null, z_ = null;
  {
    var Z_ = function(e, t, r) {
      var i = t[r], l = st(e) ? e.slice() : Je({}, e);
      return r + 1 === t.length ? (st(l) ? l.splice(i, 1) : delete l[i], l) : (l[i] = Z_(e[i], t, r + 1), l);
    }, q_ = function(e, t) {
      return Z_(e, t, 0);
    }, Q_ = function(e, t, r, i) {
      var l = t[i], f = st(e) ? e.slice() : Je({}, e);
      if (i + 1 === t.length) {
        var A = r[i];
        f[A] = f[l], st(f) ? f.splice(l, 1) : delete f[l];
      } else
        f[l] = Q_(
          // $FlowFixMe number or string is fine here
          e[l],
          t,
          r,
          i + 1
        );
      return f;
    }, $_ = function(e, t, r) {
      if (t.length !== r.length) {
        E("copyWithRename() expects paths of the same length");
        return;
      } else
        for (var i = 0; i < r.length - 1; i++)
          if (t[i] !== r[i]) {
            E("copyWithRename() expects paths to be the same except for the deepest key");
            return;
          }
      return Q_(e, t, r, 0);
    }, eC = function(e, t, r, i) {
      if (r >= t.length)
        return i;
      var l = t[r], f = st(e) ? e.slice() : Je({}, e);
      return f[l] = eC(e[l], t, r + 1, i), f;
    }, tC = function(e, t, r) {
      return eC(e, t, 0, r);
    }, gp = function(e, t) {
      for (var r = e.memoizedState; r !== null && t > 0; )
        r = r.next, t--;
      return r;
    };
    Y_ = function(e, t, r, i) {
      var l = gp(e, t);
      if (l !== null) {
        var f = tC(l.memoizedState, r, i);
        l.memoizedState = f, l.baseState = f, e.memoizedProps = Je({}, e.memoizedProps);
        var A = ur(e, Ge);
        A !== null && cn(A, e, Ge, mt);
      }
    }, V_ = function(e, t, r) {
      var i = gp(e, t);
      if (i !== null) {
        var l = q_(i.memoizedState, r);
        i.memoizedState = l, i.baseState = l, e.memoizedProps = Je({}, e.memoizedProps);
        var f = ur(e, Ge);
        f !== null && cn(f, e, Ge, mt);
      }
    }, W_ = function(e, t, r, i) {
      var l = gp(e, t);
      if (l !== null) {
        var f = $_(l.memoizedState, r, i);
        l.memoizedState = f, l.baseState = f, e.memoizedProps = Je({}, e.memoizedProps);
        var A = ur(e, Ge);
        A !== null && cn(A, e, Ge, mt);
      }
    }, k_ = function(e, t, r) {
      e.pendingProps = tC(e.memoizedProps, t, r), e.alternate && (e.alternate.pendingProps = e.pendingProps);
      var i = ur(e, Ge);
      i !== null && cn(i, e, Ge, mt);
    }, X_ = function(e, t) {
      e.pendingProps = q_(e.memoizedProps, t), e.alternate && (e.alternate.pendingProps = e.pendingProps);
      var r = ur(e, Ge);
      r !== null && cn(r, e, Ge, mt);
    }, j_ = function(e, t, r) {
      e.pendingProps = $_(e.memoizedProps, t, r), e.alternate && (e.alternate.pendingProps = e.pendingProps);
      var i = ur(e, Ge);
      i !== null && cn(i, e, Ge, mt);
    }, K_ = function(e) {
      var t = ur(e, Ge);
      t !== null && cn(t, e, Ge, mt);
    }, J_ = function(e) {
      B_ = e;
    }, z_ = function(e) {
      F_ = e;
    };
  }
  function rU(e) {
    var t = Ph(e);
    return t === null ? null : t.stateNode;
  }
  function aU(e) {
    return null;
  }
  function iU() {
    return Bn;
  }
  function sU(e) {
    var t = e.findFiberByHostInstance, r = s.ReactCurrentDispatcher;
    return J0({
      bundleType: e.bundleType,
      version: e.version,
      rendererPackageName: e.rendererPackageName,
      rendererConfig: e.rendererConfig,
      overrideHookState: Y_,
      overrideHookStateDeletePath: V_,
      overrideHookStateRenamePath: W_,
      overrideProps: k_,
      overridePropsDeletePath: X_,
      overridePropsRenamePath: j_,
      setErrorHandler: J_,
      setSuspenseHandler: z_,
      scheduleUpdate: K_,
      currentDispatcherRef: r,
      findHostInstanceByFiber: rU,
      findFiberByHostInstance: t || aU,
      // React Refresh
      findHostInstancesForRefresh: wP,
      scheduleRefresh: UP,
      scheduleRoot: xP,
      setRefreshHandler: PP,
      // Enables DevTools to append owner stacks to error messages in DEV mode.
      getCurrentFiber: iU,
      // Enables DevTools to detect reconciler version rather than renderer version
      // which may not match for third party renderers.
      reconcilerVersion: mp
    });
  }
  var nC = typeof reportError == "function" ? (
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError
  ) : function(e) {
    console.error(e);
  };
  function Dp(e) {
    this._internalRoot = e;
  }
  mf.prototype.render = Dp.prototype.render = function(e) {
    var t = this._internalRoot;
    if (t === null)
      throw new Error("Cannot update an unmounted root.");
    {
      typeof arguments[1] == "function" ? u("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : vf(arguments[1]) ? u("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && u("You passed a second argument to root.render(...) but it only accepts one argument.");
      var r = t.containerInfo;
      if (r.nodeType !== zt) {
        var i = H_(t.current);
        i && i.parentNode !== r && u("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
      }
    }
    Fu(e, t, null, null);
  }, mf.prototype.unmount = Dp.prototype.unmount = function() {
    typeof arguments[0] == "function" && u("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
    var e = this._internalRoot;
    if (e !== null) {
      this._internalRoot = null;
      var t = e.containerInfo;
      d_() && u("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), qa(function() {
        Fu(null, e, null, null);
      }), nO(t);
    }
  };
  function oU(e, t) {
    if (!vf(e))
      throw new Error("createRoot(...): Target container is not a DOM element.");
    rC(e);
    var r = !1, i = !1, l = "", f = nC;
    t != null && (t.hydrate ? E("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof t == "object" && t !== null && t.$$typeof === la && u(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), t.unstable_strictMode === !0 && (r = !0), t.identifierPrefix !== void 0 && (l = t.identifierPrefix), t.onRecoverableError !== void 0 && (f = t.onRecoverableError), t.transitionCallbacks !== void 0 && t.transitionCallbacks);
    var A = x_(e, hc, null, r, i, l, f);
    fc(A.current, e);
    var h = e.nodeType === zt ? e.parentNode : e;
    return Jl(h), new Dp(A);
  }
  function mf(e) {
    this._internalRoot = e;
  }
  function lU(e) {
    e && C1(e);
  }
  mf.prototype.unstable_scheduleHydration = lU;
  function uU(e, t, r) {
    if (!vf(e))
      throw new Error("hydrateRoot(...): Target container is not a DOM element.");
    rC(e), t === void 0 && u("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
    var i = r ?? null, l = r != null && r.hydratedSources || null, f = !1, A = !1, h = "", I = nC;
    r != null && (r.unstable_strictMode === !0 && (f = !0), r.identifierPrefix !== void 0 && (h = r.identifierPrefix), r.onRecoverableError !== void 0 && (I = r.onRecoverableError));
    var L = w_(t, null, e, hc, i, f, A, h, I);
    if (fc(L.current, e), Jl(e), l)
      for (var b = 0; b < l.length; b++) {
        var k = l[b];
        pb(L, k);
      }
    return new mf(L);
  }
  function vf(e) {
    return !!(e && (e.nodeType === or || e.nodeType === wa || e.nodeType === GT || !Ke));
  }
  function Yu(e) {
    return !!(e && (e.nodeType === or || e.nodeType === wa || e.nodeType === GT || e.nodeType === zt && e.nodeValue === " react-mount-point-unstable "));
  }
  function rC(e) {
    e.nodeType === or && e.tagName && e.tagName.toUpperCase() === "BODY" && u("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), iu(e) && (e._reactRootContainer ? u("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : u("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
  }
  var EU = s.ReactCurrentOwner, aC;
  aC = function(e) {
    if (e._reactRootContainer && e.nodeType !== zt) {
      var t = H_(e._reactRootContainer.current);
      t && t.parentNode !== e && u("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
    }
    var r = !!e._reactRootContainer, i = bp(e), l = !!(i && _i(i));
    l && !r && u("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === or && e.tagName && e.tagName.toUpperCase() === "BODY" && u("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
  };
  function bp(e) {
    return e ? e.nodeType === wa ? e.documentElement : e.firstChild : null;
  }
  function iC() {
  }
  function cU(e, t, r, i, l) {
    if (l) {
      if (typeof i == "function") {
        var f = i;
        i = function() {
          var W = Cf(A);
          f.call(W);
        };
      }
      var A = w_(
        t,
        i,
        e,
        mi,
        null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        iC
      );
      e._reactRootContainer = A, fc(A.current, e);
      var h = e.nodeType === zt ? e.parentNode : e;
      return Jl(h), qa(), A;
    } else {
      for (var I; I = e.lastChild; )
        e.removeChild(I);
      if (typeof i == "function") {
        var L = i;
        i = function() {
          var W = Cf(b);
          L.call(W);
        };
      }
      var b = x_(
        e,
        mi,
        null,
        // hydrationCallbacks
        !1,
        // isStrictMode
        !1,
        // concurrentUpdatesByDefaultOverride,
        "",
        // identifierPrefix
        iC
      );
      e._reactRootContainer = b, fc(b.current, e);
      var k = e.nodeType === zt ? e.parentNode : e;
      return Jl(k), qa(function() {
        Fu(t, b, r, i);
      }), b;
    }
  }
  function fU(e, t) {
    e !== null && typeof e != "function" && u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", t, e);
  }
  function Lf(e, t, r, i, l) {
    aC(r), fU(l === void 0 ? null : l, "render");
    var f = r._reactRootContainer, A;
    if (!f)
      A = cU(r, t, e, l, i);
    else {
      if (A = f, typeof l == "function") {
        var h = l;
        l = function() {
          var I = Cf(A);
          h.call(I);
        };
      }
      Fu(t, A, e, l);
    }
    return Cf(A);
  }
  function TU(e) {
    {
      var t = EU.current;
      if (t !== null && t.stateNode !== null) {
        var r = t.stateNode._warnedAboutRefsInRender;
        r || u("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", it(t.type) || "A component"), t.stateNode._warnedAboutRefsInRender = !0;
      }
    }
    return e == null ? null : e.nodeType === or ? e : qP(e, "findDOMNode");
  }
  function dU(e, t, r) {
    if (u("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Yu(t))
      throw new Error("Target container is not a DOM element.");
    {
      var i = iu(t) && t._reactRootContainer === void 0;
      i && u("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
    }
    return Lf(null, e, t, !0, r);
  }
  function AU(e, t, r) {
    if (u("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Yu(t))
      throw new Error("Target container is not a DOM element.");
    {
      var i = iu(t) && t._reactRootContainer === void 0;
      i && u("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
    }
    return Lf(null, e, t, !1, r);
  }
  function RU(e, t, r, i) {
    if (u("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Yu(r))
      throw new Error("Target container is not a DOM element.");
    if (e == null || !P0(e))
      throw new Error("parentComponent must be a valid React Component");
    return Lf(e, t, r, !1, i);
  }
  function pU(e) {
    if (!Yu(e))
      throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
    {
      var t = iu(e) && e._reactRootContainer === void 0;
      t && u("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
    }
    if (e._reactRootContainer) {
      {
        var r = bp(e), i = r && !_i(r);
        i && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
      }
      return qa(function() {
        Lf(null, null, e, !1, function() {
          e._reactRootContainer = null, nO(e);
        });
      }), !0;
    } else {
      {
        var l = bp(e), f = !!(l && _i(l)), A = e.nodeType === or && Yu(e.parentNode) && !!e.parentNode._reactRootContainer;
        f && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", A ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
      }
      return !1;
    }
  }
  d1(QP), R1($P), p1(eU), S1(Kr), h1(c1), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
  Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
  Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && u("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), I0(Ng), m0(lp, uP, qa);
  function SU(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!vf(t))
      throw new Error("Target container is not a DOM element.");
    return ZP(e, t, null, r);
  }
  function hU(e, t, r, i) {
    return RU(e, t, r, i);
  }
  var Mp = {
    usingClientEntryPoint: !1,
    // Keep in sync with ReactTestUtils.js.
    // This is an array for better minification.
    Events: [_i, po, Tc, Oh, Ih, lp]
  };
  function NU(e, t) {
    return Mp.usingClientEntryPoint || u('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), oU(e, t);
  }
  function OU(e, t, r) {
    return Mp.usingClientEntryPoint || u('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), uU(e, t, r);
  }
  function IU(e) {
    return d_() && u("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), qa(e);
  }
  var _U = sU({
    findFiberByHostInstance: Ts,
    bundleType: 1,
    version: mp,
    rendererPackageName: "react-dom"
  });
  if (!_U && Jt && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
    var sC = window.location.protocol;
    /^(https?|file):$/.test(sC) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (sC === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
  }
  mr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Mp, mr.createPortal = SU, mr.createRoot = NU, mr.findDOMNode = TU, mr.flushSync = IU, mr.hydrate = dU, mr.hydrateRoot = OU, mr.render = AU, mr.unmountComponentAtNode = pU, mr.unstable_batchedUpdates = lp, mr.unstable_renderSubtreeIntoContainer = hU, mr.version = mp, typeof { isDisabled: !0 } < "u" && typeof { isDisabled: !0 }.registerInternalModuleStop == "function" && { isDisabled: !0 }.registerInternalModuleStop(new Error());
})();
Qv.exports = mr;
var EH = Qv.exports, kp = EH;
{
  var Df = kp.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  pS.createRoot = function(n, a) {
    Df.usingClientEntryPoint = !0;
    try {
      return kp.createRoot(n, a);
    } finally {
      Df.usingClientEntryPoint = !1;
    }
  }, pS.hydrateRoot = function(n, a, s) {
    Df.usingClientEntryPoint = !0;
    try {
      return kp.hydrateRoot(n, a, s);
    } finally {
      Df.usingClientEntryPoint = !1;
    }
  };
}
function cH({ processedEvents: n }) {
  const a = n || [];
  return /* @__PURE__ */ p.jsxs("div", { className: "divide-primary-900 bg-primary-950 divide-y p-4", children: [
    /* @__PURE__ */ p.jsx("h1", { className: "mb-2 text-xl", children: "Console Logs" }),
    /* @__PURE__ */ p.jsx("div", { className: "flex flex-col gap-2", children: a.map((s, o) => /* @__PURE__ */ p.jsxs("div", { className: "bg-primary-500 py-4 pl-4", children: [
      /* @__PURE__ */ p.jsx("span", { className: "bg-primary-600 p-2 font-bold", children: s.type.toUpperCase() }),
      /* @__PURE__ */ p.jsx("span", { className: "ml-4 font-mono", children: s.msg })
    ] }, o)) })
  ] });
}
const tL = "application/x-spotlight-console", fH = 8969;
function a8() {
  const n = window.crypto.randomUUID();
  return {
    name: "console",
    forwardedContentType: [tL],
    tabs: ({ processedEvents: a }) => [
      {
        id: "console",
        title: "Browser Console Logs",
        notificationCount: { count: a.length },
        content: cH
      }
    ],
    setup: () => {
      Xp("log", n), Xp("warn", n), Xp("error", n);
    },
    processEvent({ data: a }) {
      return {
        event: JSON.parse(a.toString())
      };
    }
  };
}
function Xp(n, a) {
  const s = window.console[n];
  window.console[n] = (...o) => {
    const c = TH(o);
    if (c.find((E) => E.toLowerCase().includes("spotlight")))
      return s(...o);
    try {
      fetch(`http://localhost:${fH}/stream`, {
        method: "POST",
        body: JSON.stringify({
          type: n,
          args: c,
          msg: c.join(" "),
          sessionId: a
        }),
        headers: {
          "Content-Type": tL
        },
        mode: "cors"
      }).catch(() => {
      });
    } catch {
    }
    return s(...o);
  };
}
function TH(n) {
  return n.map((a) => a === null ? "null" : a === void 0 ? "undefined" : typeof a == "string" ? a : dH(a));
}
function dH(n) {
  try {
    return JSON.stringify(n);
  } catch {
    return "[serialization error]";
  }
}
var nL = { exports: {} }, ju = {}, bf = { exports: {} }, jp = {}, Kp = {}, $C;
function VS() {
  if ($C)
    return Kp;
  $C = 1;
  function n(o) {
    this.__parent = o, this.__character_count = 0, this.__indent_count = -1, this.__alignment_count = 0, this.__wrap_point_index = 0, this.__wrap_point_character_count = 0, this.__wrap_point_indent_count = -1, this.__wrap_point_alignment_count = 0, this.__items = [];
  }
  n.prototype.clone_empty = function() {
    var o = new n(this.__parent);
    return o.set_indent(this.__indent_count, this.__alignment_count), o;
  }, n.prototype.item = function(o) {
    return o < 0 ? this.__items[this.__items.length + o] : this.__items[o];
  }, n.prototype.has_match = function(o) {
    for (var c = this.__items.length - 1; c >= 0; c--)
      if (this.__items[c].match(o))
        return !0;
    return !1;
  }, n.prototype.set_indent = function(o, c) {
    this.is_empty() && (this.__indent_count = o || 0, this.__alignment_count = c || 0, this.__character_count = this.__parent.get_indent_size(this.__indent_count, this.__alignment_count));
  }, n.prototype._set_wrap_point = function() {
    this.__parent.wrap_line_length && (this.__wrap_point_index = this.__items.length, this.__wrap_point_character_count = this.__character_count, this.__wrap_point_indent_count = this.__parent.next_line.__indent_count, this.__wrap_point_alignment_count = this.__parent.next_line.__alignment_count);
  }, n.prototype._should_wrap = function() {
    return this.__wrap_point_index && this.__character_count > this.__parent.wrap_line_length && this.__wrap_point_character_count > this.__parent.next_line.__character_count;
  }, n.prototype._allow_wrap = function() {
    if (this._should_wrap()) {
      this.__parent.add_new_line();
      var o = this.__parent.current_line;
      return o.set_indent(this.__wrap_point_indent_count, this.__wrap_point_alignment_count), o.__items = this.__items.slice(this.__wrap_point_index), this.__items = this.__items.slice(0, this.__wrap_point_index), o.__character_count += this.__character_count - this.__wrap_point_character_count, this.__character_count = this.__wrap_point_character_count, o.__items[0] === " " && (o.__items.splice(0, 1), o.__character_count -= 1), !0;
    }
    return !1;
  }, n.prototype.is_empty = function() {
    return this.__items.length === 0;
  }, n.prototype.last = function() {
    return this.is_empty() ? null : this.__items[this.__items.length - 1];
  }, n.prototype.push = function(o) {
    this.__items.push(o);
    var c = o.lastIndexOf(`
`);
    c !== -1 ? this.__character_count = o.length - c : this.__character_count += o.length;
  }, n.prototype.pop = function() {
    var o = null;
    return this.is_empty() || (o = this.__items.pop(), this.__character_count -= o.length), o;
  }, n.prototype._remove_indent = function() {
    this.__indent_count > 0 && (this.__indent_count -= 1, this.__character_count -= this.__parent.indent_size);
  }, n.prototype._remove_wrap_indent = function() {
    this.__wrap_point_indent_count > 0 && (this.__wrap_point_indent_count -= 1);
  }, n.prototype.trim = function() {
    for (; this.last() === " "; )
      this.__items.pop(), this.__character_count -= 1;
  }, n.prototype.toString = function() {
    var o = "";
    return this.is_empty() ? this.__parent.indent_empty_lines && (o = this.__parent.get_indent_string(this.__indent_count)) : (o = this.__parent.get_indent_string(this.__indent_count, this.__alignment_count), o += this.__items.join("")), o;
  };
  function a(o, c) {
    this.__cache = [""], this.__indent_size = o.indent_size, this.__indent_string = o.indent_char, o.indent_with_tabs || (this.__indent_string = new Array(o.indent_size + 1).join(o.indent_char)), c = c || "", o.indent_level > 0 && (c = new Array(o.indent_level + 1).join(this.__indent_string)), this.__base_string = c, this.__base_string_length = c.length;
  }
  a.prototype.get_indent_size = function(o, c) {
    var E = this.__base_string_length;
    return c = c || 0, o < 0 && (E = 0), E += o * this.__indent_size, E += c, E;
  }, a.prototype.get_indent_string = function(o, c) {
    var E = this.__base_string;
    return c = c || 0, o < 0 && (o = 0, E = ""), c += o * this.__indent_size, this.__ensure_cache(c), E += this.__cache[c], E;
  }, a.prototype.__ensure_cache = function(o) {
    for (; o >= this.__cache.length; )
      this.__add_column();
  }, a.prototype.__add_column = function() {
    var o = this.__cache.length, c = 0, E = "";
    this.__indent_size && o >= this.__indent_size && (c = Math.floor(o / this.__indent_size), o -= c * this.__indent_size, E = new Array(c + 1).join(this.__indent_string)), o && (E += new Array(o + 1).join(" ")), this.__cache.push(E);
  };
  function s(o, c) {
    this.__indent_cache = new a(o, c), this.raw = !1, this._end_with_newline = o.end_with_newline, this.indent_size = o.indent_size, this.wrap_line_length = o.wrap_line_length, this.indent_empty_lines = o.indent_empty_lines, this.__lines = [], this.previous_line = null, this.current_line = null, this.next_line = new n(this), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1, this.__add_outputline();
  }
  return s.prototype.__add_outputline = function() {
    this.previous_line = this.current_line, this.current_line = this.next_line.clone_empty(), this.__lines.push(this.current_line);
  }, s.prototype.get_line_number = function() {
    return this.__lines.length;
  }, s.prototype.get_indent_string = function(o, c) {
    return this.__indent_cache.get_indent_string(o, c);
  }, s.prototype.get_indent_size = function(o, c) {
    return this.__indent_cache.get_indent_size(o, c);
  }, s.prototype.is_empty = function() {
    return !this.previous_line && this.current_line.is_empty();
  }, s.prototype.add_new_line = function(o) {
    return this.is_empty() || !o && this.just_added_newline() ? !1 : (this.raw || this.__add_outputline(), !0);
  }, s.prototype.get_code = function(o) {
    this.trim(!0);
    var c = this.current_line.pop();
    c && (c[c.length - 1] === `
` && (c = c.replace(/\n+$/g, "")), this.current_line.push(c)), this._end_with_newline && this.__add_outputline();
    var E = this.__lines.join(`
`);
    return o !== `
` && (E = E.replace(/[\n]/g, o)), E;
  }, s.prototype.set_wrap_point = function() {
    this.current_line._set_wrap_point();
  }, s.prototype.set_indent = function(o, c) {
    return o = o || 0, c = c || 0, this.next_line.set_indent(o, c), this.__lines.length > 1 ? (this.current_line.set_indent(o, c), !0) : (this.current_line.set_indent(), !1);
  }, s.prototype.add_raw_token = function(o) {
    for (var c = 0; c < o.newlines; c++)
      this.__add_outputline();
    this.current_line.set_indent(-1), this.current_line.push(o.whitespace_before), this.current_line.push(o.text), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = !1;
  }, s.prototype.add_token = function(o) {
    this.__add_space_before_token(), this.current_line.push(o), this.space_before_token = !1, this.non_breaking_space = !1, this.previous_token_wrapped = this.current_line._allow_wrap();
  }, s.prototype.__add_space_before_token = function() {
    this.space_before_token && !this.just_added_newline() && (this.non_breaking_space || this.set_wrap_point(), this.current_line.push(" "));
  }, s.prototype.remove_indent = function(o) {
    for (var c = this.__lines.length; o < c; )
      this.__lines[o]._remove_indent(), o++;
    this.current_line._remove_wrap_indent();
  }, s.prototype.trim = function(o) {
    for (o = o === void 0 ? !1 : o, this.current_line.trim(); o && this.__lines.length > 1 && this.current_line.is_empty(); )
      this.__lines.pop(), this.current_line = this.__lines[this.__lines.length - 1], this.current_line.trim();
    this.previous_line = this.__lines.length > 1 ? this.__lines[this.__lines.length - 2] : null;
  }, s.prototype.just_added_newline = function() {
    return this.current_line.is_empty();
  }, s.prototype.just_added_blankline = function() {
    return this.is_empty() || this.current_line.is_empty() && this.previous_line.is_empty();
  }, s.prototype.ensure_empty_line_above = function(o, c) {
    for (var E = this.__lines.length - 2; E >= 0; ) {
      var u = this.__lines[E];
      if (u.is_empty())
        break;
      if (u.item(0).indexOf(o) !== 0 && u.item(-1) !== c) {
        this.__lines.splice(E + 1, 0, new n(this)), this.previous_line = this.__lines[this.__lines.length - 2];
        break;
      }
      E--;
    }
  }, Kp.Output = s, Kp;
}
var Jp = {}, em;
function rL() {
  if (em)
    return Jp;
  em = 1;
  function n(a, s, o, c) {
    this.type = a, this.text = s, this.comments_before = null, this.newlines = o || 0, this.whitespace_before = c || "", this.parent = null, this.next = null, this.previous = null, this.opened = null, this.closed = null, this.directives = null;
  }
  return Jp.Token = n, Jp;
}
var zp = {}, tm;
function aL() {
  return tm || (tm = 1, function(n) {
    var a = "\\x23\\x24\\x40\\x41-\\x5a\\x5f\\x61-\\x7a", s = "\\x24\\x30-\\x39\\x41-\\x5a\\x5f\\x61-\\x7a", o = "\\xaa\\xb5\\xba\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u02c1\\u02c6-\\u02d1\\u02e0-\\u02e4\\u02ec\\u02ee\\u0370-\\u0374\\u0376\\u0377\\u037a-\\u037d\\u0386\\u0388-\\u038a\\u038c\\u038e-\\u03a1\\u03a3-\\u03f5\\u03f7-\\u0481\\u048a-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05d0-\\u05ea\\u05f0-\\u05f2\\u0620-\\u064a\\u066e\\u066f\\u0671-\\u06d3\\u06d5\\u06e5\\u06e6\\u06ee\\u06ef\\u06fa-\\u06fc\\u06ff\\u0710\\u0712-\\u072f\\u074d-\\u07a5\\u07b1\\u07ca-\\u07ea\\u07f4\\u07f5\\u07fa\\u0800-\\u0815\\u081a\\u0824\\u0828\\u0840-\\u0858\\u08a0\\u08a2-\\u08ac\\u0904-\\u0939\\u093d\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097f\\u0985-\\u098c\\u098f\\u0990\\u0993-\\u09a8\\u09aa-\\u09b0\\u09b2\\u09b6-\\u09b9\\u09bd\\u09ce\\u09dc\\u09dd\\u09df-\\u09e1\\u09f0\\u09f1\\u0a05-\\u0a0a\\u0a0f\\u0a10\\u0a13-\\u0a28\\u0a2a-\\u0a30\\u0a32\\u0a33\\u0a35\\u0a36\\u0a38\\u0a39\\u0a59-\\u0a5c\\u0a5e\\u0a72-\\u0a74\\u0a85-\\u0a8d\\u0a8f-\\u0a91\\u0a93-\\u0aa8\\u0aaa-\\u0ab0\\u0ab2\\u0ab3\\u0ab5-\\u0ab9\\u0abd\\u0ad0\\u0ae0\\u0ae1\\u0b05-\\u0b0c\\u0b0f\\u0b10\\u0b13-\\u0b28\\u0b2a-\\u0b30\\u0b32\\u0b33\\u0b35-\\u0b39\\u0b3d\\u0b5c\\u0b5d\\u0b5f-\\u0b61\\u0b71\\u0b83\\u0b85-\\u0b8a\\u0b8e-\\u0b90\\u0b92-\\u0b95\\u0b99\\u0b9a\\u0b9c\\u0b9e\\u0b9f\\u0ba3\\u0ba4\\u0ba8-\\u0baa\\u0bae-\\u0bb9\\u0bd0\\u0c05-\\u0c0c\\u0c0e-\\u0c10\\u0c12-\\u0c28\\u0c2a-\\u0c33\\u0c35-\\u0c39\\u0c3d\\u0c58\\u0c59\\u0c60\\u0c61\\u0c85-\\u0c8c\\u0c8e-\\u0c90\\u0c92-\\u0ca8\\u0caa-\\u0cb3\\u0cb5-\\u0cb9\\u0cbd\\u0cde\\u0ce0\\u0ce1\\u0cf1\\u0cf2\\u0d05-\\u0d0c\\u0d0e-\\u0d10\\u0d12-\\u0d3a\\u0d3d\\u0d4e\\u0d60\\u0d61\\u0d7a-\\u0d7f\\u0d85-\\u0d96\\u0d9a-\\u0db1\\u0db3-\\u0dbb\\u0dbd\\u0dc0-\\u0dc6\\u0e01-\\u0e30\\u0e32\\u0e33\\u0e40-\\u0e46\\u0e81\\u0e82\\u0e84\\u0e87\\u0e88\\u0e8a\\u0e8d\\u0e94-\\u0e97\\u0e99-\\u0e9f\\u0ea1-\\u0ea3\\u0ea5\\u0ea7\\u0eaa\\u0eab\\u0ead-\\u0eb0\\u0eb2\\u0eb3\\u0ebd\\u0ec0-\\u0ec4\\u0ec6\\u0edc-\\u0edf\\u0f00\\u0f40-\\u0f47\\u0f49-\\u0f6c\\u0f88-\\u0f8c\\u1000-\\u102a\\u103f\\u1050-\\u1055\\u105a-\\u105d\\u1061\\u1065\\u1066\\u106e-\\u1070\\u1075-\\u1081\\u108e\\u10a0-\\u10c5\\u10c7\\u10cd\\u10d0-\\u10fa\\u10fc-\\u1248\\u124a-\\u124d\\u1250-\\u1256\\u1258\\u125a-\\u125d\\u1260-\\u1288\\u128a-\\u128d\\u1290-\\u12b0\\u12b2-\\u12b5\\u12b8-\\u12be\\u12c0\\u12c2-\\u12c5\\u12c8-\\u12d6\\u12d8-\\u1310\\u1312-\\u1315\\u1318-\\u135a\\u1380-\\u138f\\u13a0-\\u13f4\\u1401-\\u166c\\u166f-\\u167f\\u1681-\\u169a\\u16a0-\\u16ea\\u16ee-\\u16f0\\u1700-\\u170c\\u170e-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176c\\u176e-\\u1770\\u1780-\\u17b3\\u17d7\\u17dc\\u1820-\\u1877\\u1880-\\u18a8\\u18aa\\u18b0-\\u18f5\\u1900-\\u191c\\u1950-\\u196d\\u1970-\\u1974\\u1980-\\u19ab\\u19c1-\\u19c7\\u1a00-\\u1a16\\u1a20-\\u1a54\\u1aa7\\u1b05-\\u1b33\\u1b45-\\u1b4b\\u1b83-\\u1ba0\\u1bae\\u1baf\\u1bba-\\u1be5\\u1c00-\\u1c23\\u1c4d-\\u1c4f\\u1c5a-\\u1c7d\\u1ce9-\\u1cec\\u1cee-\\u1cf1\\u1cf5\\u1cf6\\u1d00-\\u1dbf\\u1e00-\\u1f15\\u1f18-\\u1f1d\\u1f20-\\u1f45\\u1f48-\\u1f4d\\u1f50-\\u1f57\\u1f59\\u1f5b\\u1f5d\\u1f5f-\\u1f7d\\u1f80-\\u1fb4\\u1fb6-\\u1fbc\\u1fbe\\u1fc2-\\u1fc4\\u1fc6-\\u1fcc\\u1fd0-\\u1fd3\\u1fd6-\\u1fdb\\u1fe0-\\u1fec\\u1ff2-\\u1ff4\\u1ff6-\\u1ffc\\u2071\\u207f\\u2090-\\u209c\\u2102\\u2107\\u210a-\\u2113\\u2115\\u2119-\\u211d\\u2124\\u2126\\u2128\\u212a-\\u212d\\u212f-\\u2139\\u213c-\\u213f\\u2145-\\u2149\\u214e\\u2160-\\u2188\\u2c00-\\u2c2e\\u2c30-\\u2c5e\\u2c60-\\u2ce4\\u2ceb-\\u2cee\\u2cf2\\u2cf3\\u2d00-\\u2d25\\u2d27\\u2d2d\\u2d30-\\u2d67\\u2d6f\\u2d80-\\u2d96\\u2da0-\\u2da6\\u2da8-\\u2dae\\u2db0-\\u2db6\\u2db8-\\u2dbe\\u2dc0-\\u2dc6\\u2dc8-\\u2dce\\u2dd0-\\u2dd6\\u2dd8-\\u2dde\\u2e2f\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303c\\u3041-\\u3096\\u309d-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312d\\u3131-\\u318e\\u31a0-\\u31ba\\u31f0-\\u31ff\\u3400-\\u4db5\\u4e00-\\u9fcc\\ua000-\\ua48c\\ua4d0-\\ua4fd\\ua500-\\ua60c\\ua610-\\ua61f\\ua62a\\ua62b\\ua640-\\ua66e\\ua67f-\\ua697\\ua6a0-\\ua6ef\\ua717-\\ua71f\\ua722-\\ua788\\ua78b-\\ua78e\\ua790-\\ua793\\ua7a0-\\ua7aa\\ua7f8-\\ua801\\ua803-\\ua805\\ua807-\\ua80a\\ua80c-\\ua822\\ua840-\\ua873\\ua882-\\ua8b3\\ua8f2-\\ua8f7\\ua8fb\\ua90a-\\ua925\\ua930-\\ua946\\ua960-\\ua97c\\ua984-\\ua9b2\\ua9cf\\uaa00-\\uaa28\\uaa40-\\uaa42\\uaa44-\\uaa4b\\uaa60-\\uaa76\\uaa7a\\uaa80-\\uaaaf\\uaab1\\uaab5\\uaab6\\uaab9-\\uaabd\\uaac0\\uaac2\\uaadb-\\uaadd\\uaae0-\\uaaea\\uaaf2-\\uaaf4\\uab01-\\uab06\\uab09-\\uab0e\\uab11-\\uab16\\uab20-\\uab26\\uab28-\\uab2e\\uabc0-\\uabe2\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufb00-\\ufb06\\ufb13-\\ufb17\\ufb1d\\ufb1f-\\ufb28\\ufb2a-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40\\ufb41\\ufb43\\ufb44\\ufb46-\\ufbb1\\ufbd3-\\ufd3d\\ufd50-\\ufd8f\\ufd92-\\ufdc7\\ufdf0-\\ufdfb\\ufe70-\\ufe74\\ufe76-\\ufefc\\uff21-\\uff3a\\uff41-\\uff5a\\uff66-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc", c = "\\u0300-\\u036f\\u0483-\\u0487\\u0591-\\u05bd\\u05bf\\u05c1\\u05c2\\u05c4\\u05c5\\u05c7\\u0610-\\u061a\\u0620-\\u0649\\u0672-\\u06d3\\u06e7-\\u06e8\\u06fb-\\u06fc\\u0730-\\u074a\\u0800-\\u0814\\u081b-\\u0823\\u0825-\\u0827\\u0829-\\u082d\\u0840-\\u0857\\u08e4-\\u08fe\\u0900-\\u0903\\u093a-\\u093c\\u093e-\\u094f\\u0951-\\u0957\\u0962-\\u0963\\u0966-\\u096f\\u0981-\\u0983\\u09bc\\u09be-\\u09c4\\u09c7\\u09c8\\u09d7\\u09df-\\u09e0\\u0a01-\\u0a03\\u0a3c\\u0a3e-\\u0a42\\u0a47\\u0a48\\u0a4b-\\u0a4d\\u0a51\\u0a66-\\u0a71\\u0a75\\u0a81-\\u0a83\\u0abc\\u0abe-\\u0ac5\\u0ac7-\\u0ac9\\u0acb-\\u0acd\\u0ae2-\\u0ae3\\u0ae6-\\u0aef\\u0b01-\\u0b03\\u0b3c\\u0b3e-\\u0b44\\u0b47\\u0b48\\u0b4b-\\u0b4d\\u0b56\\u0b57\\u0b5f-\\u0b60\\u0b66-\\u0b6f\\u0b82\\u0bbe-\\u0bc2\\u0bc6-\\u0bc8\\u0bca-\\u0bcd\\u0bd7\\u0be6-\\u0bef\\u0c01-\\u0c03\\u0c46-\\u0c48\\u0c4a-\\u0c4d\\u0c55\\u0c56\\u0c62-\\u0c63\\u0c66-\\u0c6f\\u0c82\\u0c83\\u0cbc\\u0cbe-\\u0cc4\\u0cc6-\\u0cc8\\u0cca-\\u0ccd\\u0cd5\\u0cd6\\u0ce2-\\u0ce3\\u0ce6-\\u0cef\\u0d02\\u0d03\\u0d46-\\u0d48\\u0d57\\u0d62-\\u0d63\\u0d66-\\u0d6f\\u0d82\\u0d83\\u0dca\\u0dcf-\\u0dd4\\u0dd6\\u0dd8-\\u0ddf\\u0df2\\u0df3\\u0e34-\\u0e3a\\u0e40-\\u0e45\\u0e50-\\u0e59\\u0eb4-\\u0eb9\\u0ec8-\\u0ecd\\u0ed0-\\u0ed9\\u0f18\\u0f19\\u0f20-\\u0f29\\u0f35\\u0f37\\u0f39\\u0f41-\\u0f47\\u0f71-\\u0f84\\u0f86-\\u0f87\\u0f8d-\\u0f97\\u0f99-\\u0fbc\\u0fc6\\u1000-\\u1029\\u1040-\\u1049\\u1067-\\u106d\\u1071-\\u1074\\u1082-\\u108d\\u108f-\\u109d\\u135d-\\u135f\\u170e-\\u1710\\u1720-\\u1730\\u1740-\\u1750\\u1772\\u1773\\u1780-\\u17b2\\u17dd\\u17e0-\\u17e9\\u180b-\\u180d\\u1810-\\u1819\\u1920-\\u192b\\u1930-\\u193b\\u1951-\\u196d\\u19b0-\\u19c0\\u19c8-\\u19c9\\u19d0-\\u19d9\\u1a00-\\u1a15\\u1a20-\\u1a53\\u1a60-\\u1a7c\\u1a7f-\\u1a89\\u1a90-\\u1a99\\u1b46-\\u1b4b\\u1b50-\\u1b59\\u1b6b-\\u1b73\\u1bb0-\\u1bb9\\u1be6-\\u1bf3\\u1c00-\\u1c22\\u1c40-\\u1c49\\u1c5b-\\u1c7d\\u1cd0-\\u1cd2\\u1d00-\\u1dbe\\u1e01-\\u1f15\\u200c\\u200d\\u203f\\u2040\\u2054\\u20d0-\\u20dc\\u20e1\\u20e5-\\u20f0\\u2d81-\\u2d96\\u2de0-\\u2dff\\u3021-\\u3028\\u3099\\u309a\\ua640-\\ua66d\\ua674-\\ua67d\\ua69f\\ua6f0-\\ua6f1\\ua7f8-\\ua800\\ua806\\ua80b\\ua823-\\ua827\\ua880-\\ua881\\ua8b4-\\ua8c4\\ua8d0-\\ua8d9\\ua8f3-\\ua8f7\\ua900-\\ua909\\ua926-\\ua92d\\ua930-\\ua945\\ua980-\\ua983\\ua9b3-\\ua9c0\\uaa00-\\uaa27\\uaa40-\\uaa41\\uaa4c-\\uaa4d\\uaa50-\\uaa59\\uaa7b\\uaae0-\\uaae9\\uaaf2-\\uaaf3\\uabc0-\\uabe1\\uabec\\uabed\\uabf0-\\uabf9\\ufb20-\\ufb28\\ufe00-\\ufe0f\\ufe20-\\ufe26\\ufe33\\ufe34\\ufe4d-\\ufe4f\\uff10-\\uff19\\uff3f", E = "\\\\u[0-9a-fA-F]{4}|\\\\u\\{[0-9a-fA-F]+\\}", u = "(?:" + E + "|[" + a + o + "])", R = "(?:" + E + "|[" + s + o + c + "])*";
    n.identifier = new RegExp(u + R, "g"), n.identifierStart = new RegExp(u), n.identifierMatch = new RegExp("(?:" + E + "|[" + s + o + c + "])+"), n.newline = /[\n\r\u2028\u2029]/, n.lineBreak = new RegExp(`\r
|` + n.newline.source), n.allLineBreaks = new RegExp(n.lineBreak.source, "g");
  }(zp)), zp;
}
var Zp = {}, Ku = {}, nm;
function WS() {
  if (nm)
    return Ku;
  nm = 1;
  function n(o, c) {
    this.raw_options = a(o, c), this.disabled = this._get_boolean("disabled"), this.eol = this._get_characters("eol", "auto"), this.end_with_newline = this._get_boolean("end_with_newline"), this.indent_size = this._get_number("indent_size", 4), this.indent_char = this._get_characters("indent_char", " "), this.indent_level = this._get_number("indent_level"), this.preserve_newlines = this._get_boolean("preserve_newlines", !0), this.max_preserve_newlines = this._get_number("max_preserve_newlines", 32786), this.preserve_newlines || (this.max_preserve_newlines = 0), this.indent_with_tabs = this._get_boolean("indent_with_tabs", this.indent_char === "	"), this.indent_with_tabs && (this.indent_char = "	", this.indent_size === 1 && (this.indent_size = 4)), this.wrap_line_length = this._get_number("wrap_line_length", this._get_number("max_char")), this.indent_empty_lines = this._get_boolean("indent_empty_lines"), this.templating = this._get_selection_list("templating", ["auto", "none", "django", "erb", "handlebars", "php", "smarty"], ["auto"]);
  }
  n.prototype._get_array = function(o, c) {
    var E = this.raw_options[o], u = c || [];
    return typeof E == "object" ? E !== null && typeof E.concat == "function" && (u = E.concat()) : typeof E == "string" && (u = E.split(/[^a-zA-Z0-9_\/\-]+/)), u;
  }, n.prototype._get_boolean = function(o, c) {
    var E = this.raw_options[o], u = E === void 0 ? !!c : !!E;
    return u;
  }, n.prototype._get_characters = function(o, c) {
    var E = this.raw_options[o], u = c || "";
    return typeof E == "string" && (u = E.replace(/\\r/, "\r").replace(/\\n/, `
`).replace(/\\t/, "	")), u;
  }, n.prototype._get_number = function(o, c) {
    var E = this.raw_options[o];
    c = parseInt(c, 10), isNaN(c) && (c = 0);
    var u = parseInt(E, 10);
    return isNaN(u) && (u = c), u;
  }, n.prototype._get_selection = function(o, c, E) {
    var u = this._get_selection_list(o, c, E);
    if (u.length !== 1)
      throw new Error(
        "Invalid Option Value: The option '" + o + `' can only be one of the following values:
` + c + `
You passed in: '` + this.raw_options[o] + "'"
      );
    return u[0];
  }, n.prototype._get_selection_list = function(o, c, E) {
    if (!c || c.length === 0)
      throw new Error("Selection list cannot be empty.");
    if (E = E || [c[0]], !this._is_valid_selection(E, c))
      throw new Error("Invalid Default Value!");
    var u = this._get_array(o, E);
    if (!this._is_valid_selection(u, c))
      throw new Error(
        "Invalid Option Value: The option '" + o + `' can contain only the following values:
` + c + `
You passed in: '` + this.raw_options[o] + "'"
      );
    return u;
  }, n.prototype._is_valid_selection = function(o, c) {
    return o.length && c.length && !o.some(function(E) {
      return c.indexOf(E) === -1;
    });
  };
  function a(o, c) {
    var E = {};
    o = s(o);
    var u;
    for (u in o)
      u !== c && (E[u] = o[u]);
    if (c && o[c])
      for (u in o[c])
        E[u] = o[c][u];
    return E;
  }
  function s(o) {
    var c = {}, E;
    for (E in o) {
      var u = E.replace(/-/g, "_");
      c[u] = o[E];
    }
    return c;
  }
  return Ku.Options = n, Ku.normalizeOpts = s, Ku.mergeOpts = a, Ku;
}
var rm;
function iL() {
  if (rm)
    return Zp;
  rm = 1;
  var n = WS().Options, a = ["before-newline", "after-newline", "preserve-newline"];
  function s(o) {
    n.call(this, o, "js");
    var c = this.raw_options.brace_style || null;
    c === "expand-strict" ? this.raw_options.brace_style = "expand" : c === "collapse-preserve-inline" ? this.raw_options.brace_style = "collapse,preserve-inline" : this.raw_options.braces_on_own_line !== void 0 && (this.raw_options.brace_style = this.raw_options.braces_on_own_line ? "expand" : "collapse");
    var E = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_preserve_inline = !1, this.brace_style = "collapse";
    for (var u = 0; u < E.length; u++)
      E[u] === "preserve-inline" ? this.brace_preserve_inline = !0 : this.brace_style = E[u];
    this.unindent_chained_methods = this._get_boolean("unindent_chained_methods"), this.break_chained_methods = this._get_boolean("break_chained_methods"), this.space_in_paren = this._get_boolean("space_in_paren"), this.space_in_empty_paren = this._get_boolean("space_in_empty_paren"), this.jslint_happy = this._get_boolean("jslint_happy"), this.space_after_anon_function = this._get_boolean("space_after_anon_function"), this.space_after_named_function = this._get_boolean("space_after_named_function"), this.keep_array_indentation = this._get_boolean("keep_array_indentation"), this.space_before_conditional = this._get_boolean("space_before_conditional", !0), this.unescape_strings = this._get_boolean("unescape_strings"), this.e4x = this._get_boolean("e4x"), this.comma_first = this._get_boolean("comma_first"), this.operator_position = this._get_selection("operator_position", a), this.test_output_raw = this._get_boolean("test_output_raw"), this.jslint_happy && (this.space_after_anon_function = !0);
  }
  return s.prototype = new n(), Zp.Options = s, Zp;
}
var ko = {}, qp = {}, am;
function kS() {
  if (am)
    return qp;
  am = 1;
  var n = RegExp.prototype.hasOwnProperty("sticky");
  function a(s) {
    this.__input = s || "", this.__input_length = this.__input.length, this.__position = 0;
  }
  return a.prototype.restart = function() {
    this.__position = 0;
  }, a.prototype.back = function() {
    this.__position > 0 && (this.__position -= 1);
  }, a.prototype.hasNext = function() {
    return this.__position < this.__input_length;
  }, a.prototype.next = function() {
    var s = null;
    return this.hasNext() && (s = this.__input.charAt(this.__position), this.__position += 1), s;
  }, a.prototype.peek = function(s) {
    var o = null;
    return s = s || 0, s += this.__position, s >= 0 && s < this.__input_length && (o = this.__input.charAt(s)), o;
  }, a.prototype.__match = function(s, o) {
    s.lastIndex = o;
    var c = s.exec(this.__input);
    return c && !(n && s.sticky) && c.index !== o && (c = null), c;
  }, a.prototype.test = function(s, o) {
    return o = o || 0, o += this.__position, o >= 0 && o < this.__input_length ? !!this.__match(s, o) : !1;
  }, a.prototype.testChar = function(s, o) {
    var c = this.peek(o);
    return s.lastIndex = 0, c !== null && s.test(c);
  }, a.prototype.match = function(s) {
    var o = this.__match(s, this.__position);
    return o ? this.__position += o[0].length : o = null, o;
  }, a.prototype.read = function(s, o, c) {
    var E = "", u;
    return s && (u = this.match(s), u && (E += u[0])), o && (u || !s) && (E += this.readUntil(o, c)), E;
  }, a.prototype.readUntil = function(s, o) {
    var c = "", E = this.__position;
    s.lastIndex = this.__position;
    var u = s.exec(this.__input);
    return u ? (E = u.index, o && (E += u[0].length)) : E = this.__input_length, c = this.__input.substring(this.__position, E), this.__position = E, c;
  }, a.prototype.readUntilAfter = function(s) {
    return this.readUntil(s, !0);
  }, a.prototype.get_regexp = function(s, o) {
    var c = null, E = "g";
    return o && n && (E = "y"), typeof s == "string" && s !== "" ? c = new RegExp(s, E) : s && (c = new RegExp(s.source, E)), c;
  }, a.prototype.get_literal_regexp = function(s) {
    return RegExp(s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"));
  }, a.prototype.peekUntilAfter = function(s) {
    var o = this.__position, c = this.readUntilAfter(s);
    return this.__position = o, c;
  }, a.prototype.lookBack = function(s) {
    var o = this.__position - 1;
    return o >= s.length && this.__input.substring(o - s.length, o).toLowerCase() === s;
  }, qp.InputScanner = a, qp;
}
var Mf = {}, Qp = {}, im;
function AH() {
  if (im)
    return Qp;
  im = 1;
  function n(a) {
    this.__tokens = [], this.__tokens_length = this.__tokens.length, this.__position = 0, this.__parent_token = a;
  }
  return n.prototype.restart = function() {
    this.__position = 0;
  }, n.prototype.isEmpty = function() {
    return this.__tokens_length === 0;
  }, n.prototype.hasNext = function() {
    return this.__position < this.__tokens_length;
  }, n.prototype.next = function() {
    var a = null;
    return this.hasNext() && (a = this.__tokens[this.__position], this.__position += 1), a;
  }, n.prototype.peek = function(a) {
    var s = null;
    return a = a || 0, a += this.__position, a >= 0 && a < this.__tokens_length && (s = this.__tokens[a]), s;
  }, n.prototype.add = function(a) {
    this.__parent_token && (a.parent = this.__parent_token), this.__tokens.push(a), this.__tokens_length += 1;
  }, Qp.TokenStream = n, Qp;
}
var $p = {}, eS = {}, sm;
function RT() {
  if (sm)
    return eS;
  sm = 1;
  function n(a, s) {
    this._input = a, this._starting_pattern = null, this._match_pattern = null, this._until_pattern = null, this._until_after = !1, s && (this._starting_pattern = this._input.get_regexp(s._starting_pattern, !0), this._match_pattern = this._input.get_regexp(s._match_pattern, !0), this._until_pattern = this._input.get_regexp(s._until_pattern), this._until_after = s._until_after);
  }
  return n.prototype.read = function() {
    var a = this._input.read(this._starting_pattern);
    return (!this._starting_pattern || a) && (a += this._input.read(this._match_pattern, this._until_pattern, this._until_after)), a;
  }, n.prototype.read_match = function() {
    return this._input.match(this._match_pattern);
  }, n.prototype.until_after = function(a) {
    var s = this._create();
    return s._until_after = !0, s._until_pattern = this._input.get_regexp(a), s._update(), s;
  }, n.prototype.until = function(a) {
    var s = this._create();
    return s._until_after = !1, s._until_pattern = this._input.get_regexp(a), s._update(), s;
  }, n.prototype.starting_with = function(a) {
    var s = this._create();
    return s._starting_pattern = this._input.get_regexp(a, !0), s._update(), s;
  }, n.prototype.matching = function(a) {
    var s = this._create();
    return s._match_pattern = this._input.get_regexp(a, !0), s._update(), s;
  }, n.prototype._create = function() {
    return new n(this._input, this);
  }, n.prototype._update = function() {
  }, eS.Pattern = n, eS;
}
var om;
function RH() {
  if (om)
    return $p;
  om = 1;
  var n = RT().Pattern;
  function a(s, o) {
    n.call(this, s, o), o ? this._line_regexp = this._input.get_regexp(o._line_regexp) : this.__set_whitespace_patterns("", ""), this.newline_count = 0, this.whitespace_before_token = "";
  }
  return a.prototype = new n(), a.prototype.__set_whitespace_patterns = function(s, o) {
    s += "\\t ", o += "\\n\\r", this._match_pattern = this._input.get_regexp(
      "[" + s + o + "]+",
      !0
    ), this._newline_regexp = this._input.get_regexp(
      "\\r\\n|[" + o + "]"
    );
  }, a.prototype.read = function() {
    this.newline_count = 0, this.whitespace_before_token = "";
    var s = this._input.read(this._match_pattern);
    if (s === " ")
      this.whitespace_before_token = " ";
    else if (s) {
      var o = this.__split(this._newline_regexp, s);
      this.newline_count = o.length - 1, this.whitespace_before_token = o[this.newline_count];
    }
    return s;
  }, a.prototype.matching = function(s, o) {
    var c = this._create();
    return c.__set_whitespace_patterns(s, o), c._update(), c;
  }, a.prototype._create = function() {
    return new a(this._input, this);
  }, a.prototype.__split = function(s, o) {
    s.lastIndex = 0;
    for (var c = 0, E = [], u = s.exec(o); u; )
      E.push(o.substring(c, u.index)), c = u.index + u[0].length, u = s.exec(o);
    return c < o.length ? E.push(o.substring(c, o.length)) : E.push(""), E;
  }, $p.WhitespacePattern = a, $p;
}
var lm;
function $f() {
  if (lm)
    return Mf;
  lm = 1;
  var n = kS().InputScanner, a = rL().Token, s = AH().TokenStream, o = RH().WhitespacePattern, c = {
    START: "TK_START",
    RAW: "TK_RAW",
    EOF: "TK_EOF"
  }, E = function(u, R) {
    this._input = new n(u), this._options = R || {}, this.__tokens = null, this._patterns = {}, this._patterns.whitespace = new o(this._input);
  };
  return E.prototype.tokenize = function() {
    this._input.restart(), this.__tokens = new s(), this._reset();
    for (var u, R = new a(c.START, ""), d = null, T = [], S = new s(); R.type !== c.EOF; ) {
      for (u = this._get_next_token(R, d); this._is_comment(u); )
        S.add(u), u = this._get_next_token(R, d);
      S.isEmpty() || (u.comments_before = S, S = new s()), u.parent = d, this._is_opening(u) ? (T.push(d), d = u) : d && this._is_closing(u, d) && (u.opened = d, d.closed = u, d = T.pop(), u.parent = d), u.previous = R, R.next = u, this.__tokens.add(u), R = u;
    }
    return this.__tokens;
  }, E.prototype._is_first_token = function() {
    return this.__tokens.isEmpty();
  }, E.prototype._reset = function() {
  }, E.prototype._get_next_token = function(u, R) {
    this._readWhitespace();
    var d = this._input.read(/.+/g);
    return d ? this._create_token(c.RAW, d) : this._create_token(c.EOF, "");
  }, E.prototype._is_comment = function(u) {
    return !1;
  }, E.prototype._is_opening = function(u) {
    return !1;
  }, E.prototype._is_closing = function(u, R) {
    return !1;
  }, E.prototype._create_token = function(u, R) {
    var d = new a(
      u,
      R,
      this._patterns.whitespace.newline_count,
      this._patterns.whitespace.whitespace_before_token
    );
    return d;
  }, E.prototype._readWhitespace = function() {
    return this._patterns.whitespace.read();
  }, Mf.Tokenizer = E, Mf.TOKEN = c, Mf;
}
var tS = {}, um;
function XS() {
  if (um)
    return tS;
  um = 1;
  function n(a, s) {
    a = typeof a == "string" ? a : a.source, s = typeof s == "string" ? s : s.source, this.__directives_block_pattern = new RegExp(a + / beautify( \w+[:]\w+)+ /.source + s, "g"), this.__directive_pattern = / (\w+)[:](\w+)/g, this.__directives_end_ignore_pattern = new RegExp(a + /\sbeautify\signore:end\s/.source + s, "g");
  }
  return n.prototype.get_directives = function(a) {
    if (!a.match(this.__directives_block_pattern))
      return null;
    var s = {};
    this.__directive_pattern.lastIndex = 0;
    for (var o = this.__directive_pattern.exec(a); o; )
      s[o[1]] = o[2], o = this.__directive_pattern.exec(a);
    return s;
  }, n.prototype.readIgnored = function(a) {
    return a.readUntilAfter(this.__directives_end_ignore_pattern);
  }, tS.Directives = n, tS;
}
var nS = {}, Em;
function sL() {
  if (Em)
    return nS;
  Em = 1;
  var n = RT().Pattern, a = {
    django: !1,
    erb: !1,
    handlebars: !1,
    php: !1,
    smarty: !1
  };
  function s(o, c) {
    n.call(this, o, c), this.__template_pattern = null, this._disabled = Object.assign({}, a), this._excluded = Object.assign({}, a), c && (this.__template_pattern = this._input.get_regexp(c.__template_pattern), this._excluded = Object.assign(this._excluded, c._excluded), this._disabled = Object.assign(this._disabled, c._disabled));
    var E = new n(o);
    this.__patterns = {
      handlebars_comment: E.starting_with(/{{!--/).until_after(/--}}/),
      handlebars_unescaped: E.starting_with(/{{{/).until_after(/}}}/),
      handlebars: E.starting_with(/{{/).until_after(/}}/),
      php: E.starting_with(/<\?(?:[= ]|php)/).until_after(/\?>/),
      erb: E.starting_with(/<%[^%]/).until_after(/[^%]%>/),
      // django coflicts with handlebars a bit.
      django: E.starting_with(/{%/).until_after(/%}/),
      django_value: E.starting_with(/{{/).until_after(/}}/),
      django_comment: E.starting_with(/{#/).until_after(/#}/),
      smarty: E.starting_with(/{(?=[^}{\s\n])/).until_after(/[^\s\n]}/),
      smarty_comment: E.starting_with(/{\*/).until_after(/\*}/),
      smarty_literal: E.starting_with(/{literal}/).until_after(/{\/literal}/)
    };
  }
  return s.prototype = new n(), s.prototype._create = function() {
    return new s(this._input, this);
  }, s.prototype._update = function() {
    this.__set_templated_pattern();
  }, s.prototype.disable = function(o) {
    var c = this._create();
    return c._disabled[o] = !0, c._update(), c;
  }, s.prototype.read_options = function(o) {
    var c = this._create();
    for (var E in a)
      c._disabled[E] = o.templating.indexOf(E) === -1;
    return c._update(), c;
  }, s.prototype.exclude = function(o) {
    var c = this._create();
    return c._excluded[o] = !0, c._update(), c;
  }, s.prototype.read = function() {
    var o = "";
    this._match_pattern ? o = this._input.read(this._starting_pattern) : o = this._input.read(this._starting_pattern, this.__template_pattern);
    for (var c = this._read_template(); c; )
      this._match_pattern ? c += this._input.read(this._match_pattern) : c += this._input.readUntil(this.__template_pattern), o += c, c = this._read_template();
    return this._until_after && (o += this._input.readUntilAfter(this._until_pattern)), o;
  }, s.prototype.__set_templated_pattern = function() {
    var o = [];
    this._disabled.php || o.push(this.__patterns.php._starting_pattern.source), this._disabled.handlebars || o.push(this.__patterns.handlebars._starting_pattern.source), this._disabled.erb || o.push(this.__patterns.erb._starting_pattern.source), this._disabled.django || (o.push(this.__patterns.django._starting_pattern.source), o.push(this.__patterns.django_value._starting_pattern.source), o.push(this.__patterns.django_comment._starting_pattern.source)), this._disabled.smarty || o.push(this.__patterns.smarty._starting_pattern.source), this._until_pattern && o.push(this._until_pattern.source), this.__template_pattern = this._input.get_regexp("(?:" + o.join("|") + ")");
  }, s.prototype._read_template = function() {
    var o = "", c = this._input.peek();
    if (c === "<") {
      var E = this._input.peek(1);
      !this._disabled.php && !this._excluded.php && E === "?" && (o = o || this.__patterns.php.read()), !this._disabled.erb && !this._excluded.erb && E === "%" && (o = o || this.__patterns.erb.read());
    } else
      c === "{" && (!this._disabled.handlebars && !this._excluded.handlebars && (o = o || this.__patterns.handlebars_comment.read(), o = o || this.__patterns.handlebars_unescaped.read(), o = o || this.__patterns.handlebars.read()), this._disabled.django || (!this._excluded.django && !this._excluded.handlebars && (o = o || this.__patterns.django_value.read()), this._excluded.django || (o = o || this.__patterns.django_comment.read(), o = o || this.__patterns.django.read())), this._disabled.smarty || this._disabled.django && this._disabled.handlebars && (o = o || this.__patterns.smarty_comment.read(), o = o || this.__patterns.smarty_literal.read(), o = o || this.__patterns.smarty.read()));
    return o;
  }, nS.TemplatablePattern = s, nS;
}
var cm;
function Pf() {
  if (cm)
    return ko;
  cm = 1;
  var n = kS().InputScanner, a = $f().Tokenizer, s = $f().TOKEN, o = XS().Directives, c = aL(), E = RT().Pattern, u = sL().TemplatablePattern;
  function R(P, U) {
    return U.indexOf(P) !== -1;
  }
  var d = {
    START_EXPR: "TK_START_EXPR",
    END_EXPR: "TK_END_EXPR",
    START_BLOCK: "TK_START_BLOCK",
    END_BLOCK: "TK_END_BLOCK",
    WORD: "TK_WORD",
    RESERVED: "TK_RESERVED",
    SEMICOLON: "TK_SEMICOLON",
    STRING: "TK_STRING",
    EQUALS: "TK_EQUALS",
    OPERATOR: "TK_OPERATOR",
    COMMA: "TK_COMMA",
    BLOCK_COMMENT: "TK_BLOCK_COMMENT",
    COMMENT: "TK_COMMENT",
    DOT: "TK_DOT",
    UNKNOWN: "TK_UNKNOWN",
    START: s.START,
    RAW: s.RAW,
    EOF: s.EOF
  }, T = new o(/\/\*/, /\*\//), S = /0[xX][0123456789abcdefABCDEF_]*n?|0[oO][01234567_]*n?|0[bB][01_]*n?|\d[\d_]*n|(?:\.\d[\d_]*|\d[\d_]*\.?[\d_]*)(?:[eE][+-]?[\d_]+)?/, N = /[0-9]/, m = /[^\d\.]/, v = ">>> === !== &&= ??= ||= << && >= ** != == <= >> || ?? |> < / - + > : & % ? ^ | *".split(" "), M = ">>>= ... >>= <<= === >>> !== **= &&= ??= ||= => ^= :: /= << <= == && -= >= >> != -- += ** || ?? ++ %= &= *= |= |> = ! ? > < : / ^ - + * & % ~ |";
  M = M.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"), M = "\\?\\.(?!\\d) " + M, M = M.replace(/ /g, "|");
  var w = new RegExp(M), y = "continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(","), O = y.concat(["do", "in", "of", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await", "from", "as", "class", "extends"]), g = new RegExp("^(?:" + O.join("|") + ")$"), V, D = function(P, U) {
    a.call(this, P, U), this._patterns.whitespace = this._patterns.whitespace.matching(
      /\u00A0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff/.source,
      /\u2028\u2029/.source
    );
    var Y = new E(this._input), X = new u(this._input).read_options(this._options);
    this.__patterns = {
      template: X,
      identifier: X.starting_with(c.identifier).matching(c.identifierMatch),
      number: Y.matching(S),
      punct: Y.matching(w),
      // comment ends just before nearest linefeed or end of file
      comment: Y.starting_with(/\/\//).until(/[\n\r\u2028\u2029]/),
      //  /* ... */ comment ends with nearest */ or end of file
      block_comment: Y.starting_with(/\/\*/).until_after(/\*\//),
      html_comment_start: Y.matching(/<!--/),
      html_comment_end: Y.matching(/-->/),
      include: Y.starting_with(/#include/).until_after(c.lineBreak),
      shebang: Y.starting_with(/#!/).until_after(c.lineBreak),
      xml: Y.matching(/[\s\S]*?<(\/?)([-a-zA-Z:0-9_.]+|{[^}]+?}|!\[CDATA\[[^\]]*?\]\]|)(\s*{[^}]+?}|\s+[-a-zA-Z:0-9_.]+|\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{([^{}]|{[^}]+?})+?}))*\s*(\/?)\s*>/),
      single_quote: X.until(/['\\\n\r\u2028\u2029]/),
      double_quote: X.until(/["\\\n\r\u2028\u2029]/),
      template_text: X.until(/[`\\$]/),
      template_expression: X.until(/[`}\\]/)
    };
  };
  D.prototype = new a(), D.prototype._is_comment = function(P) {
    return P.type === d.COMMENT || P.type === d.BLOCK_COMMENT || P.type === d.UNKNOWN;
  }, D.prototype._is_opening = function(P) {
    return P.type === d.START_BLOCK || P.type === d.START_EXPR;
  }, D.prototype._is_closing = function(P, U) {
    return (P.type === d.END_BLOCK || P.type === d.END_EXPR) && U && (P.text === "]" && U.text === "[" || P.text === ")" && U.text === "(" || P.text === "}" && U.text === "{");
  }, D.prototype._reset = function() {
    V = !1;
  }, D.prototype._get_next_token = function(P, U) {
    var Y = null;
    this._readWhitespace();
    var X = this._input.peek();
    return X === null ? this._create_token(d.EOF, "") : (Y = Y || this._read_non_javascript(X), Y = Y || this._read_string(X), Y = Y || this._read_pair(X, this._input.peek(1)), Y = Y || this._read_word(P), Y = Y || this._read_singles(X), Y = Y || this._read_comment(X), Y = Y || this._read_regexp(X, P), Y = Y || this._read_xml(X, P), Y = Y || this._read_punctuation(), Y = Y || this._create_token(d.UNKNOWN, this._input.next()), Y);
  }, D.prototype._read_word = function(P) {
    var U;
    if (U = this.__patterns.identifier.read(), U !== "")
      return U = U.replace(c.allLineBreaks, `
`), !(P.type === d.DOT || P.type === d.RESERVED && (P.text === "set" || P.text === "get")) && g.test(U) ? (U === "in" || U === "of") && (P.type === d.WORD || P.type === d.STRING) ? this._create_token(d.OPERATOR, U) : this._create_token(d.RESERVED, U) : this._create_token(d.WORD, U);
    if (U = this.__patterns.number.read(), U !== "")
      return this._create_token(d.WORD, U);
  }, D.prototype._read_singles = function(P) {
    var U = null;
    return P === "(" || P === "[" ? U = this._create_token(d.START_EXPR, P) : P === ")" || P === "]" ? U = this._create_token(d.END_EXPR, P) : P === "{" ? U = this._create_token(d.START_BLOCK, P) : P === "}" ? U = this._create_token(d.END_BLOCK, P) : P === ";" ? U = this._create_token(d.SEMICOLON, P) : P === "." && m.test(this._input.peek(1)) ? U = this._create_token(d.DOT, P) : P === "," && (U = this._create_token(d.COMMA, P)), U && this._input.next(), U;
  }, D.prototype._read_pair = function(P, U) {
    var Y = null;
    return P === "#" && U === "{" && (Y = this._create_token(d.START_BLOCK, P + U)), Y && (this._input.next(), this._input.next()), Y;
  }, D.prototype._read_punctuation = function() {
    var P = this.__patterns.punct.read();
    if (P !== "")
      return P === "=" ? this._create_token(d.EQUALS, P) : P === "?." ? this._create_token(d.DOT, P) : this._create_token(d.OPERATOR, P);
  }, D.prototype._read_non_javascript = function(P) {
    var U = "";
    if (P === "#") {
      if (this._is_first_token() && (U = this.__patterns.shebang.read(), U))
        return this._create_token(d.UNKNOWN, U.trim() + `
`);
      if (U = this.__patterns.include.read(), U)
        return this._create_token(d.UNKNOWN, U.trim() + `
`);
      P = this._input.next();
      var Y = "#";
      if (this._input.hasNext() && this._input.testChar(N)) {
        do
          P = this._input.next(), Y += P;
        while (this._input.hasNext() && P !== "#" && P !== "=");
        return P === "#" || (this._input.peek() === "[" && this._input.peek(1) === "]" ? (Y += "[]", this._input.next(), this._input.next()) : this._input.peek() === "{" && this._input.peek(1) === "}" && (Y += "{}", this._input.next(), this._input.next())), this._create_token(d.WORD, Y);
      }
      this._input.back();
    } else if (P === "<" && this._is_first_token()) {
      if (U = this.__patterns.html_comment_start.read(), U) {
        for (; this._input.hasNext() && !this._input.testChar(c.newline); )
          U += this._input.next();
        return V = !0, this._create_token(d.COMMENT, U);
      }
    } else if (V && P === "-" && (U = this.__patterns.html_comment_end.read(), U))
      return V = !1, this._create_token(d.COMMENT, U);
    return null;
  }, D.prototype._read_comment = function(P) {
    var U = null;
    if (P === "/") {
      var Y = "";
      if (this._input.peek(1) === "*") {
        Y = this.__patterns.block_comment.read();
        var X = T.get_directives(Y);
        X && X.ignore === "start" && (Y += T.readIgnored(this._input)), Y = Y.replace(c.allLineBreaks, `
`), U = this._create_token(d.BLOCK_COMMENT, Y), U.directives = X;
      } else
        this._input.peek(1) === "/" && (Y = this.__patterns.comment.read(), U = this._create_token(d.COMMENT, Y));
    }
    return U;
  }, D.prototype._read_string = function(P) {
    if (P === "`" || P === "'" || P === '"') {
      var U = this._input.next();
      return this.has_char_escapes = !1, P === "`" ? U += this._read_string_recursive("`", !0, "${") : U += this._read_string_recursive(P), this.has_char_escapes && this._options.unescape_strings && (U = G(U)), this._input.peek() === P && (U += this._input.next()), U = U.replace(c.allLineBreaks, `
`), this._create_token(d.STRING, U);
    }
    return null;
  }, D.prototype._allow_regexp_or_xml = function(P) {
    return P.type === d.RESERVED && R(P.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || P.type === d.END_EXPR && P.text === ")" && P.opened.previous.type === d.RESERVED && R(P.opened.previous.text, ["if", "while", "for"]) || R(P.type, [
      d.COMMENT,
      d.START_EXPR,
      d.START_BLOCK,
      d.START,
      d.END_BLOCK,
      d.OPERATOR,
      d.EQUALS,
      d.EOF,
      d.SEMICOLON,
      d.COMMA
    ]);
  }, D.prototype._read_regexp = function(P, U) {
    if (P === "/" && this._allow_regexp_or_xml(U)) {
      for (var Y = this._input.next(), X = !1, _ = !1; this._input.hasNext() && (X || _ || this._input.peek() !== P) && !this._input.testChar(c.newline); )
        Y += this._input.peek(), X ? X = !1 : (X = this._input.peek() === "\\", this._input.peek() === "[" ? _ = !0 : this._input.peek() === "]" && (_ = !1)), this._input.next();
      return this._input.peek() === P && (Y += this._input.next(), Y += this._input.read(c.identifier)), this._create_token(d.STRING, Y);
    }
    return null;
  }, D.prototype._read_xml = function(P, U) {
    if (this._options.e4x && P === "<" && this._allow_regexp_or_xml(U)) {
      var Y = "", X = this.__patterns.xml.read_match();
      if (X) {
        for (var _ = X[2].replace(/^{\s+/, "{").replace(/\s+}$/, "}"), F = _.indexOf("{") === 0, j = 0; X; ) {
          var z = !!X[1], Z = X[2], ee = !!X[X.length - 1] || Z.slice(0, 8) === "![CDATA[";
          if (!ee && (Z === _ || F && Z.replace(/^{\s+/, "{").replace(/\s+}$/, "}")) && (z ? --j : ++j), Y += X[0], j <= 0)
            break;
          X = this.__patterns.xml.read_match();
        }
        return X || (Y += this._input.match(/[\s\S]*/g)[0]), Y = Y.replace(c.allLineBreaks, `
`), this._create_token(d.STRING, Y);
      }
    }
    return null;
  };
  function G(P) {
    for (var U = "", Y = 0, X = new n(P), _ = null; X.hasNext(); )
      if (_ = X.match(/([\s]|[^\\]|\\\\)+/g), _ && (U += _[0]), X.peek() === "\\") {
        if (X.next(), X.peek() === "x")
          _ = X.match(/x([0-9A-Fa-f]{2})/g);
        else if (X.peek() === "u")
          _ = X.match(/u([0-9A-Fa-f]{4})/g), _ || (_ = X.match(/u\{([0-9A-Fa-f]+)\}/g));
        else {
          U += "\\", X.hasNext() && (U += X.next());
          continue;
        }
        if (!_ || (Y = parseInt(_[1], 16), Y > 126 && Y <= 255 && _[0].indexOf("x") === 0))
          return P;
        Y >= 0 && Y < 32 || Y > 1114111 ? U += "\\" + _[0] : Y === 34 || Y === 39 || Y === 92 ? U += "\\" + String.fromCharCode(Y) : U += String.fromCharCode(Y);
      }
    return U;
  }
  return D.prototype._read_string_recursive = function(P, U, Y) {
    var X, _;
    P === "'" ? _ = this.__patterns.single_quote : P === '"' ? _ = this.__patterns.double_quote : P === "`" ? _ = this.__patterns.template_text : P === "}" && (_ = this.__patterns.template_expression);
    for (var F = _.read(), j = ""; this._input.hasNext(); ) {
      if (j = this._input.next(), j === P || !U && c.newline.test(j)) {
        this._input.back();
        break;
      } else
        j === "\\" && this._input.hasNext() ? (X = this._input.peek(), X === "x" || X === "u" ? this.has_char_escapes = !0 : X === "\r" && this._input.peek(1) === `
` && this._input.next(), j += this._input.next()) : Y && (Y === "${" && j === "$" && this._input.peek() === "{" && (j += this._input.next()), Y === j && (P === "`" ? j += this._read_string_recursive("}", U, "`") : j += this._read_string_recursive("`", U, "${"), this._input.hasNext() && (j += this._input.next())));
      j += _.read(), F += j;
    }
    return F;
  }, ko.Tokenizer = D, ko.TOKEN = d, ko.positionable_operators = v.slice(), ko.line_starters = y.slice(), ko;
}
var fm;
function pH() {
  if (fm)
    return jp;
  fm = 1;
  var n = VS().Output, a = rL().Token, s = aL(), o = iL().Options, c = Pf().Tokenizer, E = Pf().line_starters, u = Pf().positionable_operators, R = Pf().TOKEN;
  function d(_, F) {
    return F.indexOf(_) !== -1;
  }
  function T(_) {
    return _.replace(/^\s+/g, "");
  }
  function S(_) {
    for (var F = {}, j = 0; j < _.length; j++)
      F[_[j].replace(/-/g, "_")] = _[j];
    return F;
  }
  function N(_, F) {
    return _ && _.type === R.RESERVED && _.text === F;
  }
  function m(_, F) {
    return _ && _.type === R.RESERVED && d(_.text, F);
  }
  var v = ["case", "return", "do", "if", "throw", "else", "await", "break", "continue", "async"], M = ["before-newline", "after-newline", "preserve-newline"], w = S(M), y = [w.before_newline, w.preserve_newline], O = {
    BlockStatement: "BlockStatement",
    // 'BLOCK'
    Statement: "Statement",
    // 'STATEMENT'
    ObjectLiteral: "ObjectLiteral",
    // 'OBJECT',
    ArrayLiteral: "ArrayLiteral",
    //'[EXPRESSION]',
    ForInitializer: "ForInitializer",
    //'(FOR-EXPRESSION)',
    Conditional: "Conditional",
    //'(COND-EXPRESSION)',
    Expression: "Expression"
    //'(EXPRESSION)'
  };
  function g(_, F) {
    F.multiline_frame || F.mode === O.ForInitializer || F.mode === O.Conditional || _.remove_indent(F.start_line_index);
  }
  function V(_) {
    _ = _.replace(s.allLineBreaks, `
`);
    for (var F = [], j = _.indexOf(`
`); j !== -1; )
      F.push(_.substring(0, j)), _ = _.substring(j + 1), j = _.indexOf(`
`);
    return _.length && F.push(_), F;
  }
  function D(_) {
    return _ === O.ArrayLiteral;
  }
  function G(_) {
    return d(_, [O.Expression, O.ForInitializer, O.Conditional]);
  }
  function P(_, F) {
    for (var j = 0; j < _.length; j++) {
      var z = _[j].trim();
      if (z.charAt(0) !== F)
        return !1;
    }
    return !0;
  }
  function U(_, F) {
    for (var j = 0, z = _.length, Z; j < z; j++)
      if (Z = _[j], Z && Z.indexOf(F) !== 0)
        return !1;
    return !0;
  }
  function Y(_, F) {
    F = F || {}, this._source_text = _ || "", this._output = null, this._tokens = null, this._last_last_text = null, this._flags = null, this._previous_flags = null, this._flag_store = null, this._options = new o(F);
  }
  Y.prototype.create_flags = function(_, F) {
    var j = 0;
    _ && (j = _.indentation_level, !this._output.just_added_newline() && _.line_indent_level > j && (j = _.line_indent_level));
    var z = {
      mode: F,
      parent: _,
      last_token: _ ? _.last_token : new a(R.START_BLOCK, ""),
      // last token text
      last_word: _ ? _.last_word : "",
      // last TOKEN.WORD passed
      declaration_statement: !1,
      declaration_assignment: !1,
      multiline_frame: !1,
      inline_frame: !1,
      if_block: !1,
      else_block: !1,
      class_start_block: !1,
      // class A { INSIDE HERE } or class B extends C { INSIDE HERE }
      do_block: !1,
      do_while: !1,
      import_block: !1,
      in_case_statement: !1,
      // switch(..){ INSIDE HERE }
      in_case: !1,
      // we're on the exact line with "case 0:"
      case_body: !1,
      // the indented case-action block
      case_block: !1,
      // the indented case-action block is wrapped with {}
      indentation_level: j,
      alignment: 0,
      line_indent_level: _ ? _.line_indent_level : j,
      start_line_index: this._output.get_line_number(),
      ternary_depth: 0
    };
    return z;
  }, Y.prototype._reset = function(_) {
    var F = _.match(/^[\t ]*/)[0];
    this._last_last_text = "", this._output = new n(this._options, F), this._output.raw = this._options.test_output_raw, this._flag_store = [], this.set_mode(O.BlockStatement);
    var j = new c(_, this._options);
    return this._tokens = j.tokenize(), _;
  }, Y.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var _, F = this._reset(this._source_text), j = this._options.eol;
    this._options.eol === "auto" && (j = `
`, F && s.lineBreak.test(F || "") && (j = F.match(s.lineBreak)[0]));
    for (var z = this._tokens.next(); z; )
      this.handle_token(z), this._last_last_text = this._flags.last_token.text, this._flags.last_token = z, z = this._tokens.next();
    return _ = this._output.get_code(j), _;
  }, Y.prototype.handle_token = function(_, F) {
    _.type === R.START_EXPR ? this.handle_start_expr(_) : _.type === R.END_EXPR ? this.handle_end_expr(_) : _.type === R.START_BLOCK ? this.handle_start_block(_) : _.type === R.END_BLOCK ? this.handle_end_block(_) : _.type === R.WORD ? this.handle_word(_) : _.type === R.RESERVED ? this.handle_word(_) : _.type === R.SEMICOLON ? this.handle_semicolon(_) : _.type === R.STRING ? this.handle_string(_) : _.type === R.EQUALS ? this.handle_equals(_) : _.type === R.OPERATOR ? this.handle_operator(_) : _.type === R.COMMA ? this.handle_comma(_) : _.type === R.BLOCK_COMMENT ? this.handle_block_comment(_, F) : _.type === R.COMMENT ? this.handle_comment(_, F) : _.type === R.DOT ? this.handle_dot(_) : _.type === R.EOF ? this.handle_eof(_) : _.type === R.UNKNOWN ? this.handle_unknown(_, F) : this.handle_unknown(_, F);
  }, Y.prototype.handle_whitespace_and_comments = function(_, F) {
    var j = _.newlines, z = this._options.keep_array_indentation && D(this._flags.mode);
    if (_.comments_before)
      for (var Z = _.comments_before.next(); Z; )
        this.handle_whitespace_and_comments(Z, F), this.handle_token(Z, F), Z = _.comments_before.next();
    if (z)
      for (var ee = 0; ee < j; ee += 1)
        this.print_newline(ee > 0, F);
    else if (this._options.max_preserve_newlines && j > this._options.max_preserve_newlines && (j = this._options.max_preserve_newlines), this._options.preserve_newlines && j > 1) {
      this.print_newline(!1, F);
      for (var oe = 1; oe < j; oe += 1)
        this.print_newline(!0, F);
    }
  };
  var X = ["async", "break", "continue", "return", "throw", "yield"];
  return Y.prototype.allow_wrap_or_preserved_newline = function(_, F) {
    if (F = F === void 0 ? !1 : F, !this._output.just_added_newline()) {
      var j = this._options.preserve_newlines && _.newlines || F, z = d(this._flags.last_token.text, u) || d(_.text, u);
      if (z) {
        var Z = d(this._flags.last_token.text, u) && d(this._options.operator_position, y) || d(_.text, u);
        j = j && Z;
      }
      if (j)
        this.print_newline(!1, !0);
      else if (this._options.wrap_line_length) {
        if (m(this._flags.last_token, X))
          return;
        this._output.set_wrap_point();
      }
    }
  }, Y.prototype.print_newline = function(_, F) {
    if (!F && this._flags.last_token.text !== ";" && this._flags.last_token.text !== "," && this._flags.last_token.text !== "=" && (this._flags.last_token.type !== R.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++"))
      for (var j = this._tokens.peek(); this._flags.mode === O.Statement && !(this._flags.if_block && N(j, "else")) && !this._flags.do_block; )
        this.restore_mode();
    this._output.add_new_line(_) && (this._flags.multiline_frame = !0);
  }, Y.prototype.print_token_line_indentation = function(_) {
    this._output.just_added_newline() && (this._options.keep_array_indentation && _.newlines && (_.text === "[" || D(this._flags.mode)) ? (this._output.current_line.set_indent(-1), this._output.current_line.push(_.whitespace_before), this._output.space_before_token = !1) : this._output.set_indent(this._flags.indentation_level, this._flags.alignment) && (this._flags.line_indent_level = this._flags.indentation_level));
  }, Y.prototype.print_token = function(_) {
    if (this._output.raw) {
      this._output.add_raw_token(_);
      return;
    }
    if (this._options.comma_first && _.previous && _.previous.type === R.COMMA && this._output.just_added_newline() && this._output.previous_line.last() === ",") {
      var F = this._output.previous_line.pop();
      this._output.previous_line.is_empty() && (this._output.previous_line.push(F), this._output.trim(!0), this._output.current_line.pop(), this._output.trim()), this.print_token_line_indentation(_), this._output.add_token(","), this._output.space_before_token = !0;
    }
    this.print_token_line_indentation(_), this._output.non_breaking_space = !0, this._output.add_token(_.text), this._output.previous_token_wrapped && (this._flags.multiline_frame = !0);
  }, Y.prototype.indent = function() {
    this._flags.indentation_level += 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, Y.prototype.deindent = function() {
    this._flags.indentation_level > 0 && (!this._flags.parent || this._flags.indentation_level > this._flags.parent.indentation_level) && (this._flags.indentation_level -= 1, this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, Y.prototype.set_mode = function(_) {
    this._flags ? (this._flag_store.push(this._flags), this._previous_flags = this._flags) : this._previous_flags = this.create_flags(null, _), this._flags = this.create_flags(this._previous_flags, _), this._output.set_indent(this._flags.indentation_level, this._flags.alignment);
  }, Y.prototype.restore_mode = function() {
    this._flag_store.length > 0 && (this._previous_flags = this._flags, this._flags = this._flag_store.pop(), this._previous_flags.mode === O.Statement && g(this._output, this._previous_flags), this._output.set_indent(this._flags.indentation_level, this._flags.alignment));
  }, Y.prototype.start_of_object_property = function() {
    return this._flags.parent.mode === O.ObjectLiteral && this._flags.mode === O.Statement && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || m(this._flags.last_token, ["get", "set"]));
  }, Y.prototype.start_of_statement = function(_) {
    var F = !1;
    return F = F || m(this._flags.last_token, ["var", "let", "const"]) && _.type === R.WORD, F = F || N(this._flags.last_token, "do"), F = F || !(this._flags.parent.mode === O.ObjectLiteral && this._flags.mode === O.Statement) && m(this._flags.last_token, X) && !_.newlines, F = F || N(this._flags.last_token, "else") && !(N(_, "if") && !_.comments_before), F = F || this._flags.last_token.type === R.END_EXPR && (this._previous_flags.mode === O.ForInitializer || this._previous_flags.mode === O.Conditional), F = F || this._flags.last_token.type === R.WORD && this._flags.mode === O.BlockStatement && !this._flags.in_case && !(_.text === "--" || _.text === "++") && this._last_last_text !== "function" && _.type !== R.WORD && _.type !== R.RESERVED, F = F || this._flags.mode === O.ObjectLiteral && (this._flags.last_token.text === ":" && this._flags.ternary_depth === 0 || m(this._flags.last_token, ["get", "set"])), F ? (this.set_mode(O.Statement), this.indent(), this.handle_whitespace_and_comments(_, !0), this.start_of_object_property() || this.allow_wrap_or_preserved_newline(
      _,
      m(_, ["do", "for", "if", "while"])
    ), !0) : !1;
  }, Y.prototype.handle_start_expr = function(_) {
    this.start_of_statement(_) || this.handle_whitespace_and_comments(_);
    var F = O.Expression;
    if (_.text === "[") {
      if (this._flags.last_token.type === R.WORD || this._flags.last_token.text === ")") {
        m(this._flags.last_token, E) && (this._output.space_before_token = !0), this.print_token(_), this.set_mode(F), this.indent(), this._options.space_in_paren && (this._output.space_before_token = !0);
        return;
      }
      F = O.ArrayLiteral, D(this._flags.mode) && (this._flags.last_token.text === "[" || this._flags.last_token.text === "," && (this._last_last_text === "]" || this._last_last_text === "}")) && (this._options.keep_array_indentation || this.print_newline()), d(this._flags.last_token.type, [R.START_EXPR, R.END_EXPR, R.WORD, R.OPERATOR, R.DOT]) || (this._output.space_before_token = !0);
    } else {
      if (this._flags.last_token.type === R.RESERVED)
        this._flags.last_token.text === "for" ? (this._output.space_before_token = this._options.space_before_conditional, F = O.ForInitializer) : d(this._flags.last_token.text, ["if", "while", "switch"]) ? (this._output.space_before_token = this._options.space_before_conditional, F = O.Conditional) : d(this._flags.last_word, ["await", "async"]) ? this._output.space_before_token = !0 : this._flags.last_token.text === "import" && _.whitespace_before === "" ? this._output.space_before_token = !1 : (d(this._flags.last_token.text, E) || this._flags.last_token.text === "catch") && (this._output.space_before_token = !0);
      else if (this._flags.last_token.type === R.EQUALS || this._flags.last_token.type === R.OPERATOR)
        this.start_of_object_property() || this.allow_wrap_or_preserved_newline(_);
      else if (this._flags.last_token.type === R.WORD) {
        this._output.space_before_token = !1;
        var j = this._tokens.peek(-3);
        if (this._options.space_after_named_function && j) {
          var z = this._tokens.peek(-4);
          m(j, ["async", "function"]) || j.text === "*" && m(z, ["async", "function"]) ? this._output.space_before_token = !0 : this._flags.mode === O.ObjectLiteral ? (j.text === "{" || j.text === "," || j.text === "*" && (z.text === "{" || z.text === ",")) && (this._output.space_before_token = !0) : this._flags.parent && this._flags.parent.class_start_block && (this._output.space_before_token = !0);
        }
      } else
        this.allow_wrap_or_preserved_newline(_);
      (this._flags.last_token.type === R.RESERVED && (this._flags.last_word === "function" || this._flags.last_word === "typeof") || this._flags.last_token.text === "*" && (d(this._last_last_text, ["function", "yield"]) || this._flags.mode === O.ObjectLiteral && d(this._last_last_text, ["{", ","]))) && (this._output.space_before_token = this._options.space_after_anon_function);
    }
    this._flags.last_token.text === ";" || this._flags.last_token.type === R.START_BLOCK ? this.print_newline() : (this._flags.last_token.type === R.END_EXPR || this._flags.last_token.type === R.START_EXPR || this._flags.last_token.type === R.END_BLOCK || this._flags.last_token.text === "." || this._flags.last_token.type === R.COMMA) && this.allow_wrap_or_preserved_newline(_, _.newlines), this.print_token(_), this.set_mode(F), this._options.space_in_paren && (this._output.space_before_token = !0), this.indent();
  }, Y.prototype.handle_end_expr = function(_) {
    for (; this._flags.mode === O.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(_), this._flags.multiline_frame && this.allow_wrap_or_preserved_newline(
      _,
      _.text === "]" && D(this._flags.mode) && !this._options.keep_array_indentation
    ), this._options.space_in_paren && (this._flags.last_token.type === R.START_EXPR && !this._options.space_in_empty_paren ? (this._output.trim(), this._output.space_before_token = !1) : this._output.space_before_token = !0), this.deindent(), this.print_token(_), this.restore_mode(), g(this._output, this._previous_flags), this._flags.do_while && this._previous_flags.mode === O.Conditional && (this._previous_flags.mode = O.Expression, this._flags.do_block = !1, this._flags.do_while = !1);
  }, Y.prototype.handle_start_block = function(_) {
    this.handle_whitespace_and_comments(_);
    var F = this._tokens.peek(), j = this._tokens.peek(1);
    this._flags.last_word === "switch" && this._flags.last_token.type === R.END_EXPR ? (this.set_mode(O.BlockStatement), this._flags.in_case_statement = !0) : this._flags.case_body ? this.set_mode(O.BlockStatement) : j && (d(j.text, [":", ","]) && d(F.type, [R.STRING, R.WORD, R.RESERVED]) || d(F.text, ["get", "set", "..."]) && d(j.type, [R.WORD, R.RESERVED])) ? d(this._last_last_text, ["class", "interface"]) && !d(j.text, [":", ","]) ? this.set_mode(O.BlockStatement) : this.set_mode(O.ObjectLiteral) : this._flags.last_token.type === R.OPERATOR && this._flags.last_token.text === "=>" ? this.set_mode(O.BlockStatement) : d(this._flags.last_token.type, [R.EQUALS, R.START_EXPR, R.COMMA, R.OPERATOR]) || m(this._flags.last_token, ["return", "throw", "import", "default"]) ? this.set_mode(O.ObjectLiteral) : this.set_mode(O.BlockStatement), this._flags.last_token && m(this._flags.last_token.previous, ["class", "extends"]) && (this._flags.class_start_block = !0);
    var z = !F.comments_before && F.text === "}", Z = z && this._flags.last_word === "function" && this._flags.last_token.type === R.END_EXPR;
    if (this._options.brace_preserve_inline) {
      var ee = 0, oe = null;
      this._flags.inline_frame = !0;
      do
        if (ee += 1, oe = this._tokens.peek(ee - 1), oe.newlines) {
          this._flags.inline_frame = !1;
          break;
        }
      while (oe.type !== R.EOF && !(oe.type === R.END_BLOCK && oe.opened === _));
    }
    (this._options.brace_style === "expand" || this._options.brace_style === "none" && _.newlines) && !this._flags.inline_frame ? this._flags.last_token.type !== R.OPERATOR && (Z || this._flags.last_token.type === R.EQUALS || m(this._flags.last_token, v) && this._flags.last_token.text !== "else") ? this._output.space_before_token = !0 : this.print_newline(!1, !0) : (D(this._previous_flags.mode) && (this._flags.last_token.type === R.START_EXPR || this._flags.last_token.type === R.COMMA) && ((this._flags.last_token.type === R.COMMA || this._options.space_in_paren) && (this._output.space_before_token = !0), (this._flags.last_token.type === R.COMMA || this._flags.last_token.type === R.START_EXPR && this._flags.inline_frame) && (this.allow_wrap_or_preserved_newline(_), this._previous_flags.multiline_frame = this._previous_flags.multiline_frame || this._flags.multiline_frame, this._flags.multiline_frame = !1)), this._flags.last_token.type !== R.OPERATOR && this._flags.last_token.type !== R.START_EXPR && (d(this._flags.last_token.type, [R.START_BLOCK, R.SEMICOLON]) && !this._flags.inline_frame ? this.print_newline() : this._output.space_before_token = !0)), this.print_token(_), this.indent(), !z && !(this._options.brace_preserve_inline && this._flags.inline_frame) && this.print_newline();
  }, Y.prototype.handle_end_block = function(_) {
    for (this.handle_whitespace_and_comments(_); this._flags.mode === O.Statement; )
      this.restore_mode();
    var F = this._flags.last_token.type === R.START_BLOCK;
    this._flags.inline_frame && !F ? this._output.space_before_token = !0 : this._options.brace_style === "expand" ? F || this.print_newline() : F || (D(this._flags.mode) && this._options.keep_array_indentation ? (this._options.keep_array_indentation = !1, this.print_newline(), this._options.keep_array_indentation = !0) : this.print_newline()), this.restore_mode(), this.print_token(_);
  }, Y.prototype.handle_word = function(_) {
    if (_.type === R.RESERVED) {
      if (d(_.text, ["set", "get"]) && this._flags.mode !== O.ObjectLiteral)
        _.type = R.WORD;
      else if (_.text === "import" && d(this._tokens.peek().text, ["(", "."]))
        _.type = R.WORD;
      else if (d(_.text, ["as", "from"]) && !this._flags.import_block)
        _.type = R.WORD;
      else if (this._flags.mode === O.ObjectLiteral) {
        var F = this._tokens.peek();
        F.text === ":" && (_.type = R.WORD);
      }
    }
    if (this.start_of_statement(_) ? m(this._flags.last_token, ["var", "let", "const"]) && _.type === R.WORD && (this._flags.declaration_statement = !0) : _.newlines && !G(this._flags.mode) && (this._flags.last_token.type !== R.OPERATOR || this._flags.last_token.text === "--" || this._flags.last_token.text === "++") && this._flags.last_token.type !== R.EQUALS && (this._options.preserve_newlines || !m(this._flags.last_token, ["var", "let", "const", "set", "get"])) ? (this.handle_whitespace_and_comments(_), this.print_newline()) : this.handle_whitespace_and_comments(_), this._flags.do_block && !this._flags.do_while)
      if (N(_, "while")) {
        this._output.space_before_token = !0, this.print_token(_), this._output.space_before_token = !0, this._flags.do_while = !0;
        return;
      } else
        this.print_newline(), this._flags.do_block = !1;
    if (this._flags.if_block)
      if (!this._flags.else_block && N(_, "else"))
        this._flags.else_block = !0;
      else {
        for (; this._flags.mode === O.Statement; )
          this.restore_mode();
        this._flags.if_block = !1, this._flags.else_block = !1;
      }
    if (this._flags.in_case_statement && m(_, ["case", "default"])) {
      this.print_newline(), !this._flags.case_block && (this._flags.case_body || this._options.jslint_happy) && this.deindent(), this._flags.case_body = !1, this.print_token(_), this._flags.in_case = !0;
      return;
    }
    if ((this._flags.last_token.type === R.COMMA || this._flags.last_token.type === R.START_EXPR || this._flags.last_token.type === R.EQUALS || this._flags.last_token.type === R.OPERATOR) && !this.start_of_object_property() && !// start of object property is different for numeric values with +/- prefix operators
    (d(this._flags.last_token.text, ["+", "-"]) && this._last_last_text === ":" && this._flags.parent.mode === O.ObjectLiteral) && this.allow_wrap_or_preserved_newline(_), N(_, "function")) {
      (d(this._flags.last_token.text, ["}", ";"]) || this._output.just_added_newline() && !(d(this._flags.last_token.text, ["(", "[", "{", ":", "=", ","]) || this._flags.last_token.type === R.OPERATOR)) && !this._output.just_added_blankline() && !_.comments_before && (this.print_newline(), this.print_newline(!0)), this._flags.last_token.type === R.RESERVED || this._flags.last_token.type === R.WORD ? m(this._flags.last_token, ["get", "set", "new", "export"]) || m(this._flags.last_token, X) ? this._output.space_before_token = !0 : N(this._flags.last_token, "default") && this._last_last_text === "export" ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" ? this._output.space_before_token = !0 : this.print_newline() : this._flags.last_token.type === R.OPERATOR || this._flags.last_token.text === "=" ? this._output.space_before_token = !0 : !this._flags.multiline_frame && (G(this._flags.mode) || D(this._flags.mode)) || this.print_newline(), this.print_token(_), this._flags.last_word = _.text;
      return;
    }
    var j = "NONE";
    if (this._flags.last_token.type === R.END_BLOCK ? this._previous_flags.inline_frame ? j = "SPACE" : m(_, ["else", "catch", "finally", "from"]) ? this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && _.newlines ? j = "NEWLINE" : (j = "SPACE", this._output.space_before_token = !0) : j = "NEWLINE" : this._flags.last_token.type === R.SEMICOLON && this._flags.mode === O.BlockStatement ? j = "NEWLINE" : this._flags.last_token.type === R.SEMICOLON && G(this._flags.mode) ? j = "SPACE" : this._flags.last_token.type === R.STRING ? j = "NEWLINE" : this._flags.last_token.type === R.RESERVED || this._flags.last_token.type === R.WORD || this._flags.last_token.text === "*" && (d(this._last_last_text, ["function", "yield"]) || this._flags.mode === O.ObjectLiteral && d(this._last_last_text, ["{", ","])) ? j = "SPACE" : this._flags.last_token.type === R.START_BLOCK ? this._flags.inline_frame ? j = "SPACE" : j = "NEWLINE" : this._flags.last_token.type === R.END_EXPR && (this._output.space_before_token = !0, j = "NEWLINE"), m(_, E) && this._flags.last_token.text !== ")" && (this._flags.inline_frame || this._flags.last_token.text === "else" || this._flags.last_token.text === "export" ? j = "SPACE" : j = "NEWLINE"), m(_, ["else", "catch", "finally"]))
      if ((!(this._flags.last_token.type === R.END_BLOCK && this._previous_flags.mode === O.BlockStatement) || this._options.brace_style === "expand" || this._options.brace_style === "end-expand" || this._options.brace_style === "none" && _.newlines) && !this._flags.inline_frame)
        this.print_newline();
      else {
        this._output.trim(!0);
        var z = this._output.current_line;
        z.last() !== "}" && this.print_newline(), this._output.space_before_token = !0;
      }
    else
      j === "NEWLINE" ? m(this._flags.last_token, v) ? this._output.space_before_token = !0 : this._flags.last_token.text === "declare" && m(_, ["var", "let", "const"]) ? this._output.space_before_token = !0 : this._flags.last_token.type !== R.END_EXPR ? (this._flags.last_token.type !== R.START_EXPR || !m(_, ["var", "let", "const"])) && this._flags.last_token.text !== ":" && (N(_, "if") && N(_.previous, "else") ? this._output.space_before_token = !0 : this.print_newline()) : m(_, E) && this._flags.last_token.text !== ")" && this.print_newline() : this._flags.multiline_frame && D(this._flags.mode) && this._flags.last_token.text === "," && this._last_last_text === "}" ? this.print_newline() : j === "SPACE" && (this._output.space_before_token = !0);
    _.previous && (_.previous.type === R.WORD || _.previous.type === R.RESERVED) && (this._output.space_before_token = !0), this.print_token(_), this._flags.last_word = _.text, _.type === R.RESERVED && (_.text === "do" ? this._flags.do_block = !0 : _.text === "if" ? this._flags.if_block = !0 : _.text === "import" ? this._flags.import_block = !0 : this._flags.import_block && N(_, "from") && (this._flags.import_block = !1));
  }, Y.prototype.handle_semicolon = function(_) {
    this.start_of_statement(_) ? this._output.space_before_token = !1 : this.handle_whitespace_and_comments(_);
    for (var F = this._tokens.peek(); this._flags.mode === O.Statement && !(this._flags.if_block && N(F, "else")) && !this._flags.do_block; )
      this.restore_mode();
    this._flags.import_block && (this._flags.import_block = !1), this.print_token(_);
  }, Y.prototype.handle_string = function(_) {
    _.text.startsWith("`") && _.newlines === 0 && _.whitespace_before === "" && (_.previous.text === ")" || this._flags.last_token.type === R.WORD) || (this.start_of_statement(_) ? this._output.space_before_token = !0 : (this.handle_whitespace_and_comments(_), this._flags.last_token.type === R.RESERVED || this._flags.last_token.type === R.WORD || this._flags.inline_frame ? this._output.space_before_token = !0 : this._flags.last_token.type === R.COMMA || this._flags.last_token.type === R.START_EXPR || this._flags.last_token.type === R.EQUALS || this._flags.last_token.type === R.OPERATOR ? this.start_of_object_property() || this.allow_wrap_or_preserved_newline(_) : _.text.startsWith("`") && this._flags.last_token.type === R.END_EXPR && (_.previous.text === "]" || _.previous.text === ")") && _.newlines === 0 ? this._output.space_before_token = !0 : this.print_newline())), this.print_token(_);
  }, Y.prototype.handle_equals = function(_) {
    this.start_of_statement(_) || this.handle_whitespace_and_comments(_), this._flags.declaration_statement && (this._flags.declaration_assignment = !0), this._output.space_before_token = !0, this.print_token(_), this._output.space_before_token = !0;
  }, Y.prototype.handle_comma = function(_) {
    this.handle_whitespace_and_comments(_, !0), this.print_token(_), this._output.space_before_token = !0, this._flags.declaration_statement ? (G(this._flags.parent.mode) && (this._flags.declaration_assignment = !1), this._flags.declaration_assignment ? (this._flags.declaration_assignment = !1, this.print_newline(!1, !0)) : this._options.comma_first && this.allow_wrap_or_preserved_newline(_)) : this._flags.mode === O.ObjectLiteral || this._flags.mode === O.Statement && this._flags.parent.mode === O.ObjectLiteral ? (this._flags.mode === O.Statement && this.restore_mode(), this._flags.inline_frame || this.print_newline()) : this._options.comma_first && this.allow_wrap_or_preserved_newline(_);
  }, Y.prototype.handle_operator = function(_) {
    var F = _.text === "*" && (m(this._flags.last_token, ["function", "yield"]) || d(this._flags.last_token.type, [R.START_BLOCK, R.COMMA, R.END_BLOCK, R.SEMICOLON])), j = d(_.text, ["-", "+"]) && (d(this._flags.last_token.type, [R.START_BLOCK, R.START_EXPR, R.EQUALS, R.OPERATOR]) || d(this._flags.last_token.text, E) || this._flags.last_token.text === ",");
    if (!this.start_of_statement(_)) {
      var z = !F;
      this.handle_whitespace_and_comments(_, z);
    }
    if (_.text === "*" && this._flags.last_token.type === R.DOT) {
      this.print_token(_);
      return;
    }
    if (_.text === "::") {
      this.print_token(_);
      return;
    }
    if (d(_.text, ["-", "+"]) && this.start_of_object_property()) {
      this.print_token(_);
      return;
    }
    if (this._flags.last_token.type === R.OPERATOR && d(this._options.operator_position, y) && this.allow_wrap_or_preserved_newline(_), _.text === ":" && this._flags.in_case) {
      this.print_token(_), this._flags.in_case = !1, this._flags.case_body = !0, this._tokens.peek().type !== R.START_BLOCK ? (this.indent(), this.print_newline(), this._flags.case_block = !1) : (this._flags.case_block = !0, this._output.space_before_token = !0);
      return;
    }
    var Z = !0, ee = !0, oe = !1;
    if (_.text === ":" ? this._flags.ternary_depth === 0 ? Z = !1 : (this._flags.ternary_depth -= 1, oe = !0) : _.text === "?" && (this._flags.ternary_depth += 1), !j && !F && this._options.preserve_newlines && d(_.text, u)) {
      var ne = _.text === ":", de = ne && oe, ve = ne && !oe;
      switch (this._options.operator_position) {
        case w.before_newline:
          this._output.space_before_token = !ve, this.print_token(_), (!ne || de) && this.allow_wrap_or_preserved_newline(_), this._output.space_before_token = !0;
          return;
        case w.after_newline:
          this._output.space_before_token = !0, !ne || de ? this._tokens.peek().newlines ? this.print_newline(!1, !0) : this.allow_wrap_or_preserved_newline(_) : this._output.space_before_token = !1, this.print_token(_), this._output.space_before_token = !0;
          return;
        case w.preserve_newline:
          ve || this.allow_wrap_or_preserved_newline(_), Z = !(this._output.just_added_newline() || ve), this._output.space_before_token = Z, this.print_token(_), this._output.space_before_token = !0;
          return;
      }
    }
    if (F) {
      this.allow_wrap_or_preserved_newline(_), Z = !1;
      var Fe = this._tokens.peek();
      ee = Fe && d(Fe.type, [R.WORD, R.RESERVED]);
    } else if (_.text === "...")
      this.allow_wrap_or_preserved_newline(_), Z = this._flags.last_token.type === R.START_BLOCK, ee = !1;
    else if (d(_.text, ["--", "++", "!", "~"]) || j) {
      if ((this._flags.last_token.type === R.COMMA || this._flags.last_token.type === R.START_EXPR) && this.allow_wrap_or_preserved_newline(_), Z = !1, ee = !1, _.newlines && (_.text === "--" || _.text === "++" || _.text === "~")) {
        var et = m(this._flags.last_token, v) && _.newlines;
        et && (this._previous_flags.if_block || this._previous_flags.else_block) && this.restore_mode(), this.print_newline(et, !0);
      }
      this._flags.last_token.text === ";" && G(this._flags.mode) && (Z = !0), this._flags.last_token.type === R.RESERVED ? Z = !0 : this._flags.last_token.type === R.END_EXPR ? Z = !(this._flags.last_token.text === "]" && (_.text === "--" || _.text === "++")) : this._flags.last_token.type === R.OPERATOR && (Z = d(_.text, ["--", "-", "++", "+"]) && d(this._flags.last_token.text, ["--", "-", "++", "+"]), d(_.text, ["+", "-"]) && d(this._flags.last_token.text, ["--", "++"]) && (ee = !0)), (this._flags.mode === O.BlockStatement && !this._flags.inline_frame || this._flags.mode === O.Statement) && (this._flags.last_token.text === "{" || this._flags.last_token.text === ";") && this.print_newline();
    }
    this._output.space_before_token = this._output.space_before_token || Z, this.print_token(_), this._output.space_before_token = ee;
  }, Y.prototype.handle_block_comment = function(_, F) {
    if (this._output.raw) {
      this._output.add_raw_token(_), _.directives && _.directives.preserve === "end" && (this._output.raw = this._options.test_output_raw);
      return;
    }
    if (_.directives) {
      this.print_newline(!1, F), this.print_token(_), _.directives.preserve === "start" && (this._output.raw = !0), this.print_newline(!1, !0);
      return;
    }
    if (!s.newline.test(_.text) && !_.newlines) {
      this._output.space_before_token = !0, this.print_token(_), this._output.space_before_token = !0;
      return;
    } else
      this.print_block_commment(_, F);
  }, Y.prototype.print_block_commment = function(_, F) {
    var j = V(_.text), z, Z = !1, ee = !1, oe = _.whitespace_before, ne = oe.length;
    if (this.print_newline(!1, F), this.print_token_line_indentation(_), this._output.add_token(j[0]), this.print_newline(!1, F), j.length > 1) {
      for (j = j.slice(1), Z = P(j, "*"), ee = U(j, oe), Z && (this._flags.alignment = 1), z = 0; z < j.length; z++)
        Z ? (this.print_token_line_indentation(_), this._output.add_token(T(j[z]))) : ee && j[z] ? (this.print_token_line_indentation(_), this._output.add_token(j[z].substring(ne))) : (this._output.current_line.set_indent(-1), this._output.add_token(j[z])), this.print_newline(!1, F);
      this._flags.alignment = 0;
    }
  }, Y.prototype.handle_comment = function(_, F) {
    _.newlines ? this.print_newline(!1, F) : this._output.trim(!0), this._output.space_before_token = !0, this.print_token(_), this.print_newline(!1, F);
  }, Y.prototype.handle_dot = function(_) {
    this.start_of_statement(_) || this.handle_whitespace_and_comments(_, !0), this._flags.last_token.text.match("^[0-9]+$") && (this._output.space_before_token = !0), m(this._flags.last_token, v) ? this._output.space_before_token = !1 : this.allow_wrap_or_preserved_newline(
      _,
      this._flags.last_token.text === ")" && this._options.break_chained_methods
    ), this._options.unindent_chained_methods && this._output.just_added_newline() && this.deindent(), this.print_token(_);
  }, Y.prototype.handle_unknown = function(_, F) {
    this.print_token(_), _.text[_.text.length - 1] === `
` && this.print_newline(!1, F);
  }, Y.prototype.handle_eof = function(_) {
    for (; this._flags.mode === O.Statement; )
      this.restore_mode();
    this.handle_whitespace_and_comments(_);
  }, jp.Beautifier = Y, jp;
}
var Tm;
function SH() {
  if (Tm)
    return bf.exports;
  Tm = 1;
  var n = pH().Beautifier, a = iL().Options;
  function s(o, c) {
    var E = new n(o, c);
    return E.beautify();
  }
  return bf.exports = s, bf.exports.defaultOptions = function() {
    return new a();
  }, bf.exports;
}
var Uf = { exports: {} }, rS = {}, aS = {}, dm;
function oL() {
  if (dm)
    return aS;
  dm = 1;
  var n = WS().Options;
  function a(s) {
    n.call(this, s, "css"), this.selector_separator_newline = this._get_boolean("selector_separator_newline", !0), this.newline_between_rules = this._get_boolean("newline_between_rules", !0);
    var o = this._get_boolean("space_around_selector_separator");
    this.space_around_combinator = this._get_boolean("space_around_combinator") || o;
    var c = this._get_selection_list("brace_style", ["collapse", "expand", "end-expand", "none", "preserve-inline"]);
    this.brace_style = "collapse";
    for (var E = 0; E < c.length; E++)
      c[E] !== "expand" ? this.brace_style = "collapse" : this.brace_style = c[E];
  }
  return a.prototype = new n(), aS.Options = a, aS;
}
var Am;
function hH() {
  if (Am)
    return rS;
  Am = 1;
  var n = oL().Options, a = VS().Output, s = kS().InputScanner, o = XS().Directives, c = new o(/\/\*/, /\*\//), E = /\r\n|[\r\n]/, u = /\r\n|[\r\n]/g, R = /\s/, d = /(?:\s|\n)+/g, T = /\/\*(?:[\s\S]*?)((?:\*\/)|$)/g, S = /\/\/(?:[^\n\r\u2028\u2029]*)/g;
  function N(m, v) {
    this._source_text = m || "", this._options = new n(v), this._ch = null, this._input = null, this.NESTED_AT_RULE = {
      page: !0,
      "font-face": !0,
      keyframes: !0,
      // also in CONDITIONAL_GROUP_RULE below
      media: !0,
      supports: !0,
      document: !0
    }, this.CONDITIONAL_GROUP_RULE = {
      media: !0,
      supports: !0,
      document: !0
    }, this.NON_SEMICOLON_NEWLINE_PROPERTY = [
      "grid-template-areas",
      "grid-template"
    ];
  }
  return N.prototype.eatString = function(m) {
    var v = "";
    for (this._ch = this._input.next(); this._ch; ) {
      if (v += this._ch, this._ch === "\\")
        v += this._input.next();
      else if (m.indexOf(this._ch) !== -1 || this._ch === `
`)
        break;
      this._ch = this._input.next();
    }
    return v;
  }, N.prototype.eatWhitespace = function(m) {
    for (var v = R.test(this._input.peek()), M = 0; R.test(this._input.peek()); )
      this._ch = this._input.next(), m && this._ch === `
` && (M === 0 || M < this._options.max_preserve_newlines) && (M++, this._output.add_new_line(!0));
    return v;
  }, N.prototype.foundNestedPseudoClass = function() {
    for (var m = 0, v = 1, M = this._input.peek(v); M; ) {
      if (M === "{")
        return !0;
      if (M === "(")
        m += 1;
      else if (M === ")") {
        if (m === 0)
          return !1;
        m -= 1;
      } else if (M === ";" || M === "}")
        return !1;
      v++, M = this._input.peek(v);
    }
    return !1;
  }, N.prototype.print_string = function(m) {
    this._output.set_indent(this._indentLevel), this._output.non_breaking_space = !0, this._output.add_token(m);
  }, N.prototype.preserveSingleSpace = function(m) {
    m && (this._output.space_before_token = !0);
  }, N.prototype.indent = function() {
    this._indentLevel++;
  }, N.prototype.outdent = function() {
    this._indentLevel > 0 && this._indentLevel--;
  }, N.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var m = this._source_text, v = this._options.eol;
    v === "auto" && (v = `
`, m && E.test(m || "") && (v = m.match(E)[0])), m = m.replace(u, `
`);
    var M = m.match(/^[\t ]*/)[0];
    this._output = new a(this._options, M), this._input = new s(m), this._indentLevel = 0, this._nestedLevel = 0, this._ch = null;
    for (var w = 0, y = !1, O = !1, g = !1, V = !1, D = !1, G = this._ch, P = !1, U, Y, X; U = this._input.read(d), Y = U !== "", X = G, this._ch = this._input.next(), this._ch === "\\" && this._input.hasNext() && (this._ch += this._input.next()), G = this._ch, this._ch; )
      if (this._ch === "/" && this._input.peek() === "*") {
        this._output.add_new_line(), this._input.back();
        var _ = this._input.read(T), F = c.get_directives(_);
        F && F.ignore === "start" && (_ += c.readIgnored(this._input)), this.print_string(_), this.eatWhitespace(!0), this._output.add_new_line();
      } else if (this._ch === "/" && this._input.peek() === "/")
        this._output.space_before_token = !0, this._input.back(), this.print_string(this._input.read(S)), this.eatWhitespace(!0);
      else if (this._ch === "$") {
        this.preserveSingleSpace(Y), this.print_string(this._ch);
        var j = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
        j.match(/[ :]$/) && (j = this.eatString(": ").replace(/\s+$/, ""), this.print_string(j), this._output.space_before_token = !0), w === 0 && j.indexOf(":") !== -1 && (O = !0, this.indent());
      } else if (this._ch === "@")
        if (this.preserveSingleSpace(Y), this._input.peek() === "{")
          this.print_string(this._ch + this.eatString("}"));
        else {
          this.print_string(this._ch);
          var z = this._input.peekUntilAfter(/[: ,;{}()[\]\/='"]/g);
          z.match(/[ :]$/) && (z = this.eatString(": ").replace(/\s+$/, ""), this.print_string(z), this._output.space_before_token = !0), w === 0 && z.indexOf(":") !== -1 ? (O = !0, this.indent()) : z in this.NESTED_AT_RULE ? (this._nestedLevel += 1, z in this.CONDITIONAL_GROUP_RULE && (g = !0)) : w === 0 && !O && (V = !0);
        }
      else if (this._ch === "#" && this._input.peek() === "{")
        this.preserveSingleSpace(Y), this.print_string(this._ch + this.eatString("}"));
      else if (this._ch === "{")
        O && (O = !1, this.outdent()), V = !1, g ? (g = !1, y = this._indentLevel >= this._nestedLevel) : y = this._indentLevel >= this._nestedLevel - 1, this._options.newline_between_rules && y && this._output.previous_line && this._output.previous_line.item(-1) !== "{" && this._output.ensure_empty_line_above("/", ","), this._output.space_before_token = !0, this._options.brace_style === "expand" ? (this._output.add_new_line(), this.print_string(this._ch), this.indent(), this._output.set_indent(this._indentLevel)) : (X === "(" ? this._output.space_before_token = !1 : X !== "," && this.indent(), this.print_string(this._ch)), this.eatWhitespace(!0), this._output.add_new_line();
      else if (this._ch === "}")
        this.outdent(), this._output.add_new_line(), X === "{" && this._output.trim(!0), O && (this.outdent(), O = !1), this.print_string(this._ch), y = !1, this._nestedLevel && this._nestedLevel--, this.eatWhitespace(!0), this._output.add_new_line(), this._options.newline_between_rules && !this._output.just_added_blankline() && this._input.peek() !== "}" && this._output.add_new_line(!0), this._input.peek() === ")" && (this._output.trim(!0), this._options.brace_style === "expand" && this._output.add_new_line(!0));
      else if (this._ch === ":") {
        for (var Z = 0; Z < this.NON_SEMICOLON_NEWLINE_PROPERTY.length; Z++)
          if (this._input.lookBack(this.NON_SEMICOLON_NEWLINE_PROPERTY[Z])) {
            P = !0;
            break;
          }
        (y || g) && !(this._input.lookBack("&") || this.foundNestedPseudoClass()) && !this._input.lookBack("(") && !V && w === 0 ? (this.print_string(":"), O || (O = !0, this._output.space_before_token = !0, this.eatWhitespace(!0), this.indent())) : (this._input.lookBack(" ") && (this._output.space_before_token = !0), this._input.peek() === ":" ? (this._ch = this._input.next(), this.print_string("::")) : this.print_string(":"));
      } else if (this._ch === '"' || this._ch === "'") {
        var ee = X === '"' || X === "'";
        this.preserveSingleSpace(ee || Y), this.print_string(this._ch + this.eatString(this._ch)), this.eatWhitespace(!0);
      } else if (this._ch === ";")
        P = !1, w === 0 ? (O && (this.outdent(), O = !1), V = !1, this.print_string(this._ch), this.eatWhitespace(!0), this._input.peek() !== "/" && this._output.add_new_line()) : (this.print_string(this._ch), this.eatWhitespace(!0), this._output.space_before_token = !0);
      else if (this._ch === "(")
        if (this._input.lookBack("url"))
          this.print_string(this._ch), this.eatWhitespace(), w++, this.indent(), this._ch = this._input.next(), this._ch === ")" || this._ch === '"' || this._ch === "'" ? this._input.back() : this._ch && (this.print_string(this._ch + this.eatString(")")), w && (w--, this.outdent()));
        else {
          var oe = !1;
          this._input.lookBack("with") && (oe = !0), this.preserveSingleSpace(Y || oe), this.print_string(this._ch), O && X === "$" && this._options.selector_separator_newline ? (this._output.add_new_line(), D = !0) : (this.eatWhitespace(), w++, this.indent());
        }
      else if (this._ch === ")")
        w && (w--, this.outdent()), D && this._input.peek() === ";" && this._options.selector_separator_newline && (D = !1, this.outdent(), this._output.add_new_line()), this.print_string(this._ch);
      else if (this._ch === ",")
        this.print_string(this._ch), this.eatWhitespace(!0), this._options.selector_separator_newline && (!O || D) && w === 0 && !V ? this._output.add_new_line() : this._output.space_before_token = !0;
      else if ((this._ch === ">" || this._ch === "+" || this._ch === "~") && !O && w === 0)
        this._options.space_around_combinator ? (this._output.space_before_token = !0, this.print_string(this._ch), this._output.space_before_token = !0) : (this.print_string(this._ch), this.eatWhitespace(), this._ch && R.test(this._ch) && (this._ch = ""));
      else if (this._ch === "]")
        this.print_string(this._ch);
      else if (this._ch === "[")
        this.preserveSingleSpace(Y), this.print_string(this._ch);
      else if (this._ch === "=")
        this.eatWhitespace(), this.print_string("="), R.test(this._ch) && (this._ch = "");
      else if (this._ch === "!" && !this._input.lookBack("\\"))
        this._output.space_before_token = !0, this.print_string(this._ch);
      else {
        var ne = X === '"' || X === "'";
        this.preserveSingleSpace(ne || Y), this.print_string(this._ch), !this._output.just_added_newline() && this._input.peek() === `
` && P && this._output.add_new_line();
      }
    var de = this._output.get_code(v);
    return de;
  }, rS.Beautifier = N, rS;
}
var Rm;
function NH() {
  if (Rm)
    return Uf.exports;
  Rm = 1;
  var n = hH().Beautifier, a = oL().Options;
  function s(o, c) {
    var E = new n(o, c);
    return E.beautify();
  }
  return Uf.exports = s, Uf.exports.defaultOptions = function() {
    return new a();
  }, Uf.exports;
}
var xf = { exports: {} }, iS = {}, sS = {}, pm;
function lL() {
  if (pm)
    return sS;
  pm = 1;
  var n = WS().Options;
  function a(s) {
    n.call(this, s, "html"), this.templating.length === 1 && this.templating[0] === "auto" && (this.templating = ["django", "erb", "handlebars", "php"]), this.indent_inner_html = this._get_boolean("indent_inner_html"), this.indent_body_inner_html = this._get_boolean("indent_body_inner_html", !0), this.indent_head_inner_html = this._get_boolean("indent_head_inner_html", !0), this.indent_handlebars = this._get_boolean("indent_handlebars", !0), this.wrap_attributes = this._get_selection(
      "wrap_attributes",
      ["auto", "force", "force-aligned", "force-expand-multiline", "aligned-multiple", "preserve", "preserve-aligned"]
    ), this.wrap_attributes_min_attrs = this._get_number("wrap_attributes_min_attrs", 2), this.wrap_attributes_indent_size = this._get_number("wrap_attributes_indent_size", this.indent_size), this.extra_liners = this._get_array("extra_liners", ["head", "body", "/html"]), this.inline = this._get_array("inline", [
      "a",
      "abbr",
      "area",
      "audio",
      "b",
      "bdi",
      "bdo",
      "br",
      "button",
      "canvas",
      "cite",
      "code",
      "data",
      "datalist",
      "del",
      "dfn",
      "em",
      "embed",
      "i",
      "iframe",
      "img",
      "input",
      "ins",
      "kbd",
      "keygen",
      "label",
      "map",
      "mark",
      "math",
      "meter",
      "noscript",
      "object",
      "output",
      "progress",
      "q",
      "ruby",
      "s",
      "samp",
      /* 'script', */
      "select",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "svg",
      "template",
      "textarea",
      "time",
      "u",
      "var",
      "video",
      "wbr",
      "text",
      // obsolete inline tags
      "acronym",
      "big",
      "strike",
      "tt"
    ]), this.inline_custom_elements = this._get_boolean("inline_custom_elements", !0), this.void_elements = this._get_array("void_elements", [
      // HTLM void elements - aka self-closing tags - aka singletons
      // https://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
      "area",
      "base",
      "br",
      "col",
      "embed",
      "hr",
      "img",
      "input",
      "keygen",
      "link",
      "menuitem",
      "meta",
      "param",
      "source",
      "track",
      "wbr",
      // NOTE: Optional tags are too complex for a simple list
      // they are hard coded in _do_optional_end_element
      // Doctype and xml elements
      "!doctype",
      "?xml",
      // obsolete tags
      // basefont: https://www.computerhope.com/jargon/h/html-basefont-tag.htm
      // isndex: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/isindex
      "basefont",
      "isindex"
    ]), this.unformatted = this._get_array("unformatted", []), this.content_unformatted = this._get_array("content_unformatted", [
      "pre",
      "textarea"
    ]), this.unformatted_content_delimiter = this._get_characters("unformatted_content_delimiter"), this.indent_scripts = this._get_selection("indent_scripts", ["normal", "keep", "separate"]);
  }
  return a.prototype = new n(), sS.Options = a, sS;
}
var wf = {}, Sm;
function hm() {
  if (Sm)
    return wf;
  Sm = 1;
  var n = $f().Tokenizer, a = $f().TOKEN, s = XS().Directives, o = sL().TemplatablePattern, c = RT().Pattern, E = {
    TAG_OPEN: "TK_TAG_OPEN",
    TAG_CLOSE: "TK_TAG_CLOSE",
    ATTRIBUTE: "TK_ATTRIBUTE",
    EQUALS: "TK_EQUALS",
    VALUE: "TK_VALUE",
    COMMENT: "TK_COMMENT",
    TEXT: "TK_TEXT",
    UNKNOWN: "TK_UNKNOWN",
    START: a.START,
    RAW: a.RAW,
    EOF: a.EOF
  }, u = new s(/<\!--/, /-->/), R = function(d, T) {
    n.call(this, d, T), this._current_tag_name = "";
    var S = new o(this._input).read_options(this._options), N = new c(this._input);
    if (this.__patterns = {
      word: S.until(/[\n\r\t <]/),
      single_quote: S.until_after(/'/),
      double_quote: S.until_after(/"/),
      attribute: S.until(/[\n\r\t =>]|\/>/),
      element_name: S.until(/[\n\r\t >\/]/),
      handlebars_comment: N.starting_with(/{{!--/).until_after(/--}}/),
      handlebars: N.starting_with(/{{/).until_after(/}}/),
      handlebars_open: N.until(/[\n\r\t }]/),
      handlebars_raw_close: N.until(/}}/),
      comment: N.starting_with(/<!--/).until_after(/-->/),
      cdata: N.starting_with(/<!\[CDATA\[/).until_after(/]]>/),
      // https://en.wikipedia.org/wiki/Conditional_comment
      conditional_comment: N.starting_with(/<!\[/).until_after(/]>/),
      processing: N.starting_with(/<\?/).until_after(/\?>/)
    }, this._options.indent_handlebars && (this.__patterns.word = this.__patterns.word.exclude("handlebars")), this._unformatted_content_delimiter = null, this._options.unformatted_content_delimiter) {
      var m = this._input.get_literal_regexp(this._options.unformatted_content_delimiter);
      this.__patterns.unformatted_content_delimiter = N.matching(m).until_after(m);
    }
  };
  return R.prototype = new n(), R.prototype._is_comment = function(d) {
    return !1;
  }, R.prototype._is_opening = function(d) {
    return d.type === E.TAG_OPEN;
  }, R.prototype._is_closing = function(d, T) {
    return d.type === E.TAG_CLOSE && T && ((d.text === ">" || d.text === "/>") && T.text[0] === "<" || d.text === "}}" && T.text[0] === "{" && T.text[1] === "{");
  }, R.prototype._reset = function() {
    this._current_tag_name = "";
  }, R.prototype._get_next_token = function(d, T) {
    var S = null;
    this._readWhitespace();
    var N = this._input.peek();
    return N === null ? this._create_token(E.EOF, "") : (S = S || this._read_open_handlebars(N, T), S = S || this._read_attribute(N, d, T), S = S || this._read_close(N, T), S = S || this._read_raw_content(N, d, T), S = S || this._read_content_word(N), S = S || this._read_comment_or_cdata(N), S = S || this._read_processing(N), S = S || this._read_open(N, T), S = S || this._create_token(E.UNKNOWN, this._input.next()), S);
  }, R.prototype._read_comment_or_cdata = function(d) {
    var T = null, S = null, N = null;
    if (d === "<") {
      var m = this._input.peek(1);
      m === "!" && (S = this.__patterns.comment.read(), S ? (N = u.get_directives(S), N && N.ignore === "start" && (S += u.readIgnored(this._input))) : S = this.__patterns.cdata.read()), S && (T = this._create_token(E.COMMENT, S), T.directives = N);
    }
    return T;
  }, R.prototype._read_processing = function(d) {
    var T = null, S = null, N = null;
    if (d === "<") {
      var m = this._input.peek(1);
      (m === "!" || m === "?") && (S = this.__patterns.conditional_comment.read(), S = S || this.__patterns.processing.read()), S && (T = this._create_token(E.COMMENT, S), T.directives = N);
    }
    return T;
  }, R.prototype._read_open = function(d, T) {
    var S = null, N = null;
    return T || d === "<" && (S = this._input.next(), this._input.peek() === "/" && (S += this._input.next()), S += this.__patterns.element_name.read(), N = this._create_token(E.TAG_OPEN, S)), N;
  }, R.prototype._read_open_handlebars = function(d, T) {
    var S = null, N = null;
    return T || this._options.indent_handlebars && d === "{" && this._input.peek(1) === "{" && (this._input.peek(2) === "!" ? (S = this.__patterns.handlebars_comment.read(), S = S || this.__patterns.handlebars.read(), N = this._create_token(E.COMMENT, S)) : (S = this.__patterns.handlebars_open.read(), N = this._create_token(E.TAG_OPEN, S))), N;
  }, R.prototype._read_close = function(d, T) {
    var S = null, N = null;
    return T && (T.text[0] === "<" && (d === ">" || d === "/" && this._input.peek(1) === ">") ? (S = this._input.next(), d === "/" && (S += this._input.next()), N = this._create_token(E.TAG_CLOSE, S)) : T.text[0] === "{" && d === "}" && this._input.peek(1) === "}" && (this._input.next(), this._input.next(), N = this._create_token(E.TAG_CLOSE, "}}"))), N;
  }, R.prototype._read_attribute = function(d, T, S) {
    var N = null, m = "";
    if (S && S.text[0] === "<")
      if (d === "=")
        N = this._create_token(E.EQUALS, this._input.next());
      else if (d === '"' || d === "'") {
        var v = this._input.next();
        d === '"' ? v += this.__patterns.double_quote.read() : v += this.__patterns.single_quote.read(), N = this._create_token(E.VALUE, v);
      } else
        m = this.__patterns.attribute.read(), m && (T.type === E.EQUALS ? N = this._create_token(E.VALUE, m) : N = this._create_token(E.ATTRIBUTE, m));
    return N;
  }, R.prototype._is_content_unformatted = function(d) {
    return this._options.void_elements.indexOf(d) === -1 && (this._options.content_unformatted.indexOf(d) !== -1 || this._options.unformatted.indexOf(d) !== -1);
  }, R.prototype._read_raw_content = function(d, T, S) {
    var N = "";
    if (S && S.text[0] === "{")
      N = this.__patterns.handlebars_raw_close.read();
    else if (T.type === E.TAG_CLOSE && T.opened.text[0] === "<" && T.text[0] !== "/") {
      var m = T.opened.text.substr(1).toLowerCase();
      if (m === "script" || m === "style") {
        var v = this._read_comment_or_cdata(d);
        if (v)
          return v.type = E.TEXT, v;
        N = this._input.readUntil(new RegExp("</" + m + "[\\n\\r\\t ]*?>", "ig"));
      } else
        this._is_content_unformatted(m) && (N = this._input.readUntil(new RegExp("</" + m + "[\\n\\r\\t ]*?>", "ig")));
    }
    return N ? this._create_token(E.TEXT, N) : null;
  }, R.prototype._read_content_word = function(d) {
    var T = "";
    if (this._options.unformatted_content_delimiter && d === this._options.unformatted_content_delimiter[0] && (T = this.__patterns.unformatted_content_delimiter.read()), T || (T = this.__patterns.word.read()), T)
      return this._create_token(E.TEXT, T);
  }, wf.Tokenizer = R, wf.TOKEN = E, wf;
}
var Nm;
function OH() {
  if (Nm)
    return iS;
  Nm = 1;
  var n = lL().Options, a = VS().Output, s = hm().Tokenizer, o = hm().TOKEN, c = /\r\n|[\r\n]/, E = /\r\n|[\r\n]/g, u = function(y, O) {
    this.indent_level = 0, this.alignment_size = 0, this.max_preserve_newlines = y.max_preserve_newlines, this.preserve_newlines = y.preserve_newlines, this._output = new a(y, O);
  };
  u.prototype.current_line_has_match = function(y) {
    return this._output.current_line.has_match(y);
  }, u.prototype.set_space_before_token = function(y, O) {
    this._output.space_before_token = y, this._output.non_breaking_space = O;
  }, u.prototype.set_wrap_point = function() {
    this._output.set_indent(this.indent_level, this.alignment_size), this._output.set_wrap_point();
  }, u.prototype.add_raw_token = function(y) {
    this._output.add_raw_token(y);
  }, u.prototype.print_preserved_newlines = function(y) {
    var O = 0;
    y.type !== o.TEXT && y.previous.type !== o.TEXT && (O = y.newlines ? 1 : 0), this.preserve_newlines && (O = y.newlines < this.max_preserve_newlines + 1 ? y.newlines : this.max_preserve_newlines + 1);
    for (var g = 0; g < O; g++)
      this.print_newline(g > 0);
    return O !== 0;
  }, u.prototype.traverse_whitespace = function(y) {
    return y.whitespace_before || y.newlines ? (this.print_preserved_newlines(y) || (this._output.space_before_token = !0), !0) : !1;
  }, u.prototype.previous_token_wrapped = function() {
    return this._output.previous_token_wrapped;
  }, u.prototype.print_newline = function(y) {
    this._output.add_new_line(y);
  }, u.prototype.print_token = function(y) {
    y.text && (this._output.set_indent(this.indent_level, this.alignment_size), this._output.add_token(y.text));
  }, u.prototype.indent = function() {
    this.indent_level++;
  }, u.prototype.get_full_indent = function(y) {
    return y = this.indent_level + (y || 0), y < 1 ? "" : this._output.get_indent_string(y);
  };
  var R = function(y) {
    for (var O = null, g = y.next; g.type !== o.EOF && y.closed !== g; ) {
      if (g.type === o.ATTRIBUTE && g.text === "type") {
        g.next && g.next.type === o.EQUALS && g.next.next && g.next.next.type === o.VALUE && (O = g.next.next.text);
        break;
      }
      g = g.next;
    }
    return O;
  }, d = function(y, O) {
    var g = null, V = null;
    return O.closed ? (y === "script" ? g = "text/javascript" : y === "style" && (g = "text/css"), g = R(O) || g, g.search("text/css") > -1 ? V = "css" : g.search(/module|((text|application|dojo)\/(x-)?(javascript|ecmascript|jscript|livescript|(ld\+)?json|method|aspect))/) > -1 ? V = "javascript" : g.search(/(text|application|dojo)\/(x-)?(html)/) > -1 ? V = "html" : g.search(/test\/null/) > -1 && (V = "null"), V) : null;
  };
  function T(y, O) {
    return O.indexOf(y) !== -1;
  }
  function S(y, O, g) {
    this.parent = y || null, this.tag = O ? O.tag_name : "", this.indent_level = g || 0, this.parser_token = O || null;
  }
  function N(y) {
    this._printer = y, this._current_frame = null;
  }
  N.prototype.get_parser_token = function() {
    return this._current_frame ? this._current_frame.parser_token : null;
  }, N.prototype.record_tag = function(y) {
    var O = new S(this._current_frame, y, this._printer.indent_level);
    this._current_frame = O;
  }, N.prototype._try_pop_frame = function(y) {
    var O = null;
    return y && (O = y.parser_token, this._printer.indent_level = y.indent_level, this._current_frame = y.parent), O;
  }, N.prototype._get_frame = function(y, O) {
    for (var g = this._current_frame; g && y.indexOf(g.tag) === -1; ) {
      if (O && O.indexOf(g.tag) !== -1) {
        g = null;
        break;
      }
      g = g.parent;
    }
    return g;
  }, N.prototype.try_pop = function(y, O) {
    var g = this._get_frame([y], O);
    return this._try_pop_frame(g);
  }, N.prototype.indent_to_tag = function(y) {
    var O = this._get_frame(y);
    O && (this._printer.indent_level = O.indent_level);
  };
  function m(y, O, g, V) {
    this._source_text = y || "", O = O || {}, this._js_beautify = g, this._css_beautify = V, this._tag_stack = null;
    var D = new n(O, "html");
    this._options = D, this._is_wrap_attributes_force = this._options.wrap_attributes.substr(0, 5) === "force", this._is_wrap_attributes_force_expand_multiline = this._options.wrap_attributes === "force-expand-multiline", this._is_wrap_attributes_force_aligned = this._options.wrap_attributes === "force-aligned", this._is_wrap_attributes_aligned_multiple = this._options.wrap_attributes === "aligned-multiple", this._is_wrap_attributes_preserve = this._options.wrap_attributes.substr(0, 8) === "preserve", this._is_wrap_attributes_preserve_aligned = this._options.wrap_attributes === "preserve-aligned";
  }
  m.prototype.beautify = function() {
    if (this._options.disabled)
      return this._source_text;
    var y = this._source_text, O = this._options.eol;
    this._options.eol === "auto" && (O = `
`, y && c.test(y) && (O = y.match(c)[0])), y = y.replace(E, `
`);
    var g = y.match(/^[\t ]*/)[0], V = {
      text: "",
      type: ""
    }, D = new v(), G = new u(this._options, g), P = new s(y, this._options).tokenize();
    this._tag_stack = new N(G);
    for (var U = null, Y = P.next(); Y.type !== o.EOF; )
      Y.type === o.TAG_OPEN || Y.type === o.COMMENT ? (U = this._handle_tag_open(G, Y, D, V, P), D = U) : Y.type === o.ATTRIBUTE || Y.type === o.EQUALS || Y.type === o.VALUE || Y.type === o.TEXT && !D.tag_complete ? U = this._handle_inside_tag(G, Y, D, V) : Y.type === o.TAG_CLOSE ? U = this._handle_tag_close(G, Y, D) : Y.type === o.TEXT ? U = this._handle_text(G, Y, D) : G.add_raw_token(Y), V = U, Y = P.next();
    var X = G._output.get_code(O);
    return X;
  }, m.prototype._handle_tag_close = function(y, O, g) {
    var V = {
      text: O.text,
      type: O.type
    };
    return y.alignment_size = 0, g.tag_complete = !0, y.set_space_before_token(O.newlines || O.whitespace_before !== "", !0), g.is_unformatted ? y.add_raw_token(O) : (g.tag_start_char === "<" && (y.set_space_before_token(O.text[0] === "/", !0), this._is_wrap_attributes_force_expand_multiline && g.has_wrapped_attrs && y.print_newline(!1)), y.print_token(O)), g.indent_content && !(g.is_unformatted || g.is_content_unformatted) && (y.indent(), g.indent_content = !1), !g.is_inline_element && !(g.is_unformatted || g.is_content_unformatted) && y.set_wrap_point(), V;
  }, m.prototype._handle_inside_tag = function(y, O, g, V) {
    var D = g.has_wrapped_attrs, G = {
      text: O.text,
      type: O.type
    };
    return y.set_space_before_token(O.newlines || O.whitespace_before !== "", !0), g.is_unformatted ? y.add_raw_token(O) : g.tag_start_char === "{" && O.type === o.TEXT ? y.print_preserved_newlines(O) ? (O.newlines = 0, y.add_raw_token(O)) : y.print_token(O) : (O.type === o.ATTRIBUTE ? y.set_space_before_token(!0) : (O.type === o.EQUALS || O.type === o.VALUE && O.previous.type === o.EQUALS) && y.set_space_before_token(!1), O.type === o.ATTRIBUTE && g.tag_start_char === "<" && ((this._is_wrap_attributes_preserve || this._is_wrap_attributes_preserve_aligned) && (y.traverse_whitespace(O), D = D || O.newlines !== 0), this._is_wrap_attributes_force && g.attr_count >= this._options.wrap_attributes_min_attrs && (V.type !== o.TAG_OPEN || // ie. second attribute and beyond
    this._is_wrap_attributes_force_expand_multiline) && (y.print_newline(!1), D = !0)), y.print_token(O), D = D || y.previous_token_wrapped(), g.has_wrapped_attrs = D), G;
  }, m.prototype._handle_text = function(y, O, g) {
    var V = {
      text: O.text,
      type: "TK_CONTENT"
    };
    return g.custom_beautifier_name ? this._print_custom_beatifier_text(y, O, g) : g.is_unformatted || g.is_content_unformatted ? y.add_raw_token(O) : (y.traverse_whitespace(O), y.print_token(O)), V;
  }, m.prototype._print_custom_beatifier_text = function(y, O, g) {
    var V = this;
    if (O.text !== "") {
      var D = O.text, G, P = 1, U = "", Y = "";
      g.custom_beautifier_name === "javascript" && typeof this._js_beautify == "function" ? G = this._js_beautify : g.custom_beautifier_name === "css" && typeof this._css_beautify == "function" ? G = this._css_beautify : g.custom_beautifier_name === "html" && (G = function(Z, ee) {
        var oe = new m(Z, ee, V._js_beautify, V._css_beautify);
        return oe.beautify();
      }), this._options.indent_scripts === "keep" ? P = 0 : this._options.indent_scripts === "separate" && (P = -y.indent_level);
      var X = y.get_full_indent(P);
      if (D = D.replace(/\n[ \t]*$/, ""), g.custom_beautifier_name !== "html" && D[0] === "<" && D.match(/^(<!--|<!\[CDATA\[)/)) {
        var _ = /^(<!--[^\n]*|<!\[CDATA\[)(\n?)([ \t\n]*)([\s\S]*)(-->|]]>)$/.exec(D);
        if (!_) {
          y.add_raw_token(O);
          return;
        }
        U = X + _[1] + `
`, D = _[4], _[5] && (Y = X + _[5]), D = D.replace(/\n[ \t]*$/, ""), (_[2] || _[3].indexOf(`
`) !== -1) && (_ = _[3].match(/[ \t]+$/), _ && (O.whitespace_before = _[0]));
      }
      if (D)
        if (G) {
          var F = function() {
            this.eol = `
`;
          };
          F.prototype = this._options.raw_options;
          var j = new F();
          D = G(X + D, j);
        } else {
          var z = O.whitespace_before;
          z && (D = D.replace(new RegExp(`
(` + z + ")?", "g"), `
`)), D = X + D.replace(/\n/g, `
` + X);
        }
      U && (D ? D = U + D + `
` + Y : D = U + Y), y.print_newline(!1), D && (O.text = D, O.whitespace_before = "", O.newlines = 0, y.add_raw_token(O), y.print_newline(!0));
    }
  }, m.prototype._handle_tag_open = function(y, O, g, V, D) {
    var G = this._get_tag_open_token(O);
    if ((g.is_unformatted || g.is_content_unformatted) && !g.is_empty_element && O.type === o.TAG_OPEN && !G.is_start_tag ? (y.add_raw_token(O), G.start_tag_token = this._tag_stack.try_pop(G.tag_name)) : (y.traverse_whitespace(O), this._set_tag_position(y, O, G, g, V), G.is_inline_element || y.set_wrap_point(), y.print_token(O)), G.is_start_tag && this._is_wrap_attributes_force) {
      var P = 0, U;
      do
        U = D.peek(P), U.type === o.ATTRIBUTE && (G.attr_count += 1), P += 1;
      while (U.type !== o.EOF && U.type !== o.TAG_CLOSE);
    }
    return (this._is_wrap_attributes_force_aligned || this._is_wrap_attributes_aligned_multiple || this._is_wrap_attributes_preserve_aligned) && (G.alignment_size = O.text.length + 1), !G.tag_complete && !G.is_unformatted && (y.alignment_size = G.alignment_size), G;
  };
  var v = function(y, O) {
    if (this.parent = y || null, this.text = "", this.type = "TK_TAG_OPEN", this.tag_name = "", this.is_inline_element = !1, this.is_unformatted = !1, this.is_content_unformatted = !1, this.is_empty_element = !1, this.is_start_tag = !1, this.is_end_tag = !1, this.indent_content = !1, this.multiline_content = !1, this.custom_beautifier_name = null, this.start_tag_token = null, this.attr_count = 0, this.has_wrapped_attrs = !1, this.alignment_size = 0, this.tag_complete = !1, this.tag_start_char = "", this.tag_check = "", !O)
      this.tag_complete = !0;
    else {
      var g;
      this.tag_start_char = O.text[0], this.text = O.text, this.tag_start_char === "<" ? (g = O.text.match(/^<([^\s>]*)/), this.tag_check = g ? g[1] : "") : (g = O.text.match(/^{{~?(?:[\^]|#\*?)?([^\s}]+)/), this.tag_check = g ? g[1] : "", (O.text.startsWith("{{#>") || O.text.startsWith("{{~#>")) && this.tag_check[0] === ">" && (this.tag_check === ">" && O.next !== null ? this.tag_check = O.next.text.split(" ")[0] : this.tag_check = O.text.split(">")[1])), this.tag_check = this.tag_check.toLowerCase(), O.type === o.COMMENT && (this.tag_complete = !0), this.is_start_tag = this.tag_check.charAt(0) !== "/", this.tag_name = this.is_start_tag ? this.tag_check : this.tag_check.substr(1), this.is_end_tag = !this.is_start_tag || O.closed && O.closed.text === "/>";
      var V = 2;
      this.tag_start_char === "{" && this.text.length >= 3 && this.text.charAt(2) === "~" && (V = 3), this.is_end_tag = this.is_end_tag || this.tag_start_char === "{" && (this.text.length < 3 || /[^#\^]/.test(this.text.charAt(V)));
    }
  };
  m.prototype._get_tag_open_token = function(y) {
    var O = new v(this._tag_stack.get_parser_token(), y);
    return O.alignment_size = this._options.wrap_attributes_indent_size, O.is_end_tag = O.is_end_tag || T(O.tag_check, this._options.void_elements), O.is_empty_element = O.tag_complete || O.is_start_tag && O.is_end_tag, O.is_unformatted = !O.tag_complete && T(O.tag_check, this._options.unformatted), O.is_content_unformatted = !O.is_empty_element && T(O.tag_check, this._options.content_unformatted), O.is_inline_element = T(O.tag_name, this._options.inline) || this._options.inline_custom_elements && O.tag_name.includes("-") || O.tag_start_char === "{", O;
  }, m.prototype._set_tag_position = function(y, O, g, V, D) {
    if (g.is_empty_element || (g.is_end_tag ? g.start_tag_token = this._tag_stack.try_pop(g.tag_name) : (this._do_optional_end_element(g) && (g.is_inline_element || y.print_newline(!1)), this._tag_stack.record_tag(g), (g.tag_name === "script" || g.tag_name === "style") && !(g.is_unformatted || g.is_content_unformatted) && (g.custom_beautifier_name = d(g.tag_check, O)))), T(g.tag_check, this._options.extra_liners) && (y.print_newline(!1), y._output.just_added_blankline() || y.print_newline(!0)), g.is_empty_element) {
      if (g.tag_start_char === "{" && g.tag_check === "else") {
        this._tag_stack.indent_to_tag(["if", "unless", "each"]), g.indent_content = !0;
        var G = y.current_line_has_match(/{{#if/);
        G || y.print_newline(!1);
      }
      g.tag_name === "!--" && D.type === o.TAG_CLOSE && V.is_end_tag && g.text.indexOf(`
`) === -1 || (g.is_inline_element || g.is_unformatted || y.print_newline(!1), this._calcluate_parent_multiline(y, g));
    } else if (g.is_end_tag) {
      var P = !1;
      P = g.start_tag_token && g.start_tag_token.multiline_content, P = P || !g.is_inline_element && !(V.is_inline_element || V.is_unformatted) && !(D.type === o.TAG_CLOSE && g.start_tag_token === V) && D.type !== "TK_CONTENT", (g.is_content_unformatted || g.is_unformatted) && (P = !1), P && y.print_newline(!1);
    } else
      g.indent_content = !g.custom_beautifier_name, g.tag_start_char === "<" && (g.tag_name === "html" ? g.indent_content = this._options.indent_inner_html : g.tag_name === "head" ? g.indent_content = this._options.indent_head_inner_html : g.tag_name === "body" && (g.indent_content = this._options.indent_body_inner_html)), !(g.is_inline_element || g.is_unformatted) && (D.type !== "TK_CONTENT" || g.is_content_unformatted) && y.print_newline(!1), this._calcluate_parent_multiline(y, g);
  }, m.prototype._calcluate_parent_multiline = function(y, O) {
    O.parent && y._output.just_added_newline() && !((O.is_inline_element || O.is_unformatted) && O.parent.is_inline_element) && (O.parent.multiline_content = !0);
  };
  var M = ["address", "article", "aside", "blockquote", "details", "div", "dl", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hr", "main", "menu", "nav", "ol", "p", "pre", "section", "table", "ul"], w = ["a", "audio", "del", "ins", "map", "noscript", "video"];
  return m.prototype._do_optional_end_element = function(y) {
    var O = null;
    if (!(y.is_empty_element || !y.is_start_tag || !y.parent)) {
      if (y.tag_name === "body")
        O = O || this._tag_stack.try_pop("head");
      else if (y.tag_name === "li")
        O = O || this._tag_stack.try_pop("li", ["ol", "ul", "menu"]);
      else if (y.tag_name === "dd" || y.tag_name === "dt")
        O = O || this._tag_stack.try_pop("dt", ["dl"]), O = O || this._tag_stack.try_pop("dd", ["dl"]);
      else if (y.parent.tag_name === "p" && M.indexOf(y.tag_name) !== -1) {
        var g = y.parent.parent;
        (!g || w.indexOf(g.tag_name) === -1) && (O = O || this._tag_stack.try_pop("p"));
      } else
        y.tag_name === "rp" || y.tag_name === "rt" ? (O = O || this._tag_stack.try_pop("rt", ["ruby", "rtc"]), O = O || this._tag_stack.try_pop("rp", ["ruby", "rtc"])) : y.tag_name === "optgroup" ? O = O || this._tag_stack.try_pop("optgroup", ["select"]) : y.tag_name === "option" ? O = O || this._tag_stack.try_pop("option", ["select", "datalist", "optgroup"]) : y.tag_name === "colgroup" ? O = O || this._tag_stack.try_pop("caption", ["table"]) : y.tag_name === "thead" ? (O = O || this._tag_stack.try_pop("caption", ["table"]), O = O || this._tag_stack.try_pop("colgroup", ["table"])) : y.tag_name === "tbody" || y.tag_name === "tfoot" ? (O = O || this._tag_stack.try_pop("caption", ["table"]), O = O || this._tag_stack.try_pop("colgroup", ["table"]), O = O || this._tag_stack.try_pop("thead", ["table"]), O = O || this._tag_stack.try_pop("tbody", ["table"])) : y.tag_name === "tr" ? (O = O || this._tag_stack.try_pop("caption", ["table"]), O = O || this._tag_stack.try_pop("colgroup", ["table"]), O = O || this._tag_stack.try_pop("tr", ["table", "thead", "tbody", "tfoot"])) : (y.tag_name === "th" || y.tag_name === "td") && (O = O || this._tag_stack.try_pop("td", ["table", "thead", "tbody", "tfoot", "tr"]), O = O || this._tag_stack.try_pop("th", ["table", "thead", "tbody", "tfoot", "tr"]));
      return y.parent = this._tag_stack.get_parser_token(), O;
    }
  }, iS.Beautifier = m, iS;
}
var Om;
function IH() {
  if (Om)
    return xf.exports;
  Om = 1;
  var n = OH().Beautifier, a = lL().Options;
  function s(o, c, E, u) {
    var R = new n(o, c, E, u);
    return R.beautify();
  }
  return xf.exports = s, xf.exports.defaultOptions = function() {
    return new a();
  }, xf.exports;
}
var Im;
function _H() {
  if (Im)
    return ju;
  Im = 1;
  var n = SH(), a = NH(), s = IH();
  function o(c, E, u, R) {
    return u = u || n, R = R || a, s(c, E, u, R);
  }
  return o.defaultOptions = s.defaultOptions, ju.js = n, ju.css = a, ju.html = o, ju;
}
(function(n) {
  function a(s, o, c) {
    var E = function(u, R) {
      return s.js_beautify(u, R);
    };
    return E.js = s.js_beautify, E.css = o.css_beautify, E.html = c.html_beautify, E.js_beautify = s.js_beautify, E.css_beautify = o.css_beautify, E.html_beautify = c.html_beautify, E;
  }
  (function(s) {
    var o = _H();
    o.js_beautify = o.js, o.css_beautify = o.css, o.html_beautify = o.html, s.exports = a(o, o, o);
  })(n);
})(nL);
var CH = nL.exports, uL = { exports: {} };
(function(n, a) {
  (function() {
    function s(o, c) {
      var E, u = 0, R = o.length, d, T = "", S, N, m, v, M, w, y, O, g = !0, V = !1, D;
      E = arguments.length > 1 ? c : {}, typeof E.indent > "u" && (E.indent = "    "), typeof E.openbrace == "string" && (g = E.openbrace === "end-of-line"), typeof E.autosemicolon == "boolean" && (V = E.autosemicolon);
      function G(F) {
        return F === " " || F === `
` || F === "	" || F === "\r" || F === "\f";
      }
      function P(F) {
        return F === "'" || F === '"';
      }
      function U(F) {
        return S >= "a" && S <= "z" || S >= "A" && S <= "Z" || S >= "0" && S <= "9" || "-_*.:#[]".indexOf(F) >= 0;
      }
      function Y() {
        var F;
        for (F = w; F > 0; F -= 1)
          T += E.indent;
      }
      function X() {
        T = D(T), g ? T += " {" : (T += `
`, Y(), T += "{"), N !== `
` && (T += `
`), w += 1;
      }
      function _() {
        var F;
        w -= 1, T = D(T), T.length > 0 && V && (F = T.charAt(T.length - 1), F !== ";" && F !== "{" && (T += ";")), T += `
`, Y(), T += "}", d.push(T), T = "";
      }
      for (String.prototype.trimRight ? D = function(F) {
        return F.trimRight();
      } : D = function(F) {
        return F.replace(/\s+$/, "");
      }, M = {
        Start: 0,
        AtRule: 1,
        Block: 2,
        Selector: 3,
        Ruleset: 4,
        Property: 5,
        Separator: 6,
        Expression: 7,
        URL: 8
      }, w = 0, v = M.Start, O = !1, d = [], o = o.replace(/\r\n/g, `
`); u < R; ) {
        if (S = o.charAt(u), N = o.charAt(u + 1), u += 1, P(y)) {
          T += S, S === y && (y = null), S === "\\" && N === y && (T += N, u += 1);
          continue;
        }
        if (P(S)) {
          T += S, y = S;
          continue;
        }
        if (O) {
          T += S, S === "*" && N === "/" && (O = !1, T += N, u += 1);
          continue;
        }
        if (S === "/" && N === "*") {
          O = !0, T += S, T += N, u += 1;
          continue;
        }
        if (v === M.Start) {
          if (d.length === 0 && G(S) && T.length === 0)
            continue;
          if (S <= " " || S.charCodeAt(0) >= 128) {
            v = M.Start, T += S;
            continue;
          }
          if (U(S) || S === "@") {
            if (m = D(T), m.length === 0)
              d.length > 0 && (T = `

`);
            else if (m.charAt(m.length - 1) === "}" || m.charAt(m.length - 1) === ";")
              T = m + `

`;
            else
              for (; N = T.charAt(T.length - 1), !(N !== " " && N.charCodeAt(0) !== 9); )
                T = T.substr(0, T.length - 1);
            T += S, v = S === "@" ? M.AtRule : M.Selector;
            continue;
          }
        }
        if (v === M.AtRule) {
          if (S === ";") {
            T += S, v = M.Start;
            continue;
          }
          if (S === "{") {
            m = D(T), X(), v = m === "@font-face" ? M.Ruleset : M.Block;
            continue;
          }
          T += S;
          continue;
        }
        if (v === M.Block) {
          if (U(S)) {
            if (m = D(T), m.length === 0)
              d.length > 0 && (T = `

`);
            else if (m.charAt(m.length - 1) === "}")
              T = m + `

`;
            else
              for (; N = T.charAt(T.length - 1), !(N !== " " && N.charCodeAt(0) !== 9); )
                T = T.substr(0, T.length - 1);
            Y(), T += S, v = M.Selector;
            continue;
          }
          if (S === "}") {
            _(), v = M.Start;
            continue;
          }
          T += S;
          continue;
        }
        if (v === M.Selector) {
          if (S === "{") {
            X(), v = M.Ruleset;
            continue;
          }
          if (S === "}") {
            _(), v = M.Start;
            continue;
          }
          T += S;
          continue;
        }
        if (v === M.Ruleset) {
          if (S === "}") {
            _(), v = M.Start, w > 0 && (v = M.Block);
            continue;
          }
          if (S === `
`) {
            T = D(T), T += `
`;
            continue;
          }
          if (!G(S)) {
            T = D(T), T += `
`, Y(), T += S, v = M.Property;
            continue;
          }
          T += S;
          continue;
        }
        if (v === M.Property) {
          if (S === ":") {
            T = D(T), T += ": ", v = M.Expression, G(N) && (v = M.Separator);
            continue;
          }
          if (S === "}") {
            _(), v = M.Start, w > 0 && (v = M.Block);
            continue;
          }
          T += S;
          continue;
        }
        if (v === M.Separator) {
          if (!G(S)) {
            T += S, v = M.Expression;
            continue;
          }
          P(N) && (v = M.Expression);
          continue;
        }
        if (v === M.Expression) {
          if (S === "}") {
            _(), v = M.Start, w > 0 && (v = M.Block);
            continue;
          }
          if (S === ";") {
            T = D(T), T += `;
`, v = M.Ruleset;
            continue;
          }
          if (T += S, S === "(" && T.charAt(T.length - 2) === "l" && T.charAt(T.length - 3) === "r" && T.charAt(T.length - 4) === "u") {
            v = M.URL;
            continue;
          }
          continue;
        }
        if (v === M.URL && S === ")" && T.charAt(T.length - 1 !== "\\")) {
          T += S, v = M.Expression;
          continue;
        }
        T += S;
      }
      return T = d.join("") + T, T;
    }
    n.exports = s;
  })();
})(uL);
var mH = uL.exports;
function vH(n, a) {
  var s, o, c, E, u, R;
  a = a || {}, o = a.indent_size || 4, c = a.indent_char || " ", u = a.brace_style || "collapse", E = a.max_char == 0 ? 1 / 0 : a.max_char || 70, R = a.unformatted || ["a", "span", "bdo", "em", "strong", "dfn", "code", "samp", "kbd", "var", "cite", "abbr", "acronym", "q", "sub", "sup", "tt", "i", "b", "big", "small", "u", "s", "strike", "font", "ins", "del", "pre", "address", "dt", "h1", "h2", "h3", "h4", "h5", "h6"];
  function d() {
    return this.pos = 0, this.token = "", this.current_mode = "CONTENT", this.tags = {
      //An object to hold tags, their position, and their parent-tags, initiated with default values
      parent: "parent1",
      parentcount: 1,
      parent1: ""
    }, this.tag_type = "", this.token_text = this.last_token = this.last_text = this.token_type = "", this.Utils = {
      //Uilities made available to the various functions
      whitespace: `
\r	 `.split(""),
      single_token: "br,input,link,meta,!doctype,basefont,base,area,hr,wbr,param,img,isindex,?xml,embed,?php,?,?=".split(","),
      //all the single tags for HTML
      extra_liners: "head,body,/html".split(","),
      //for tags that need a line of whitespace before them
      in_array: function(D, G) {
        for (var P = 0; P < G.length; P++)
          if (D === G[P])
            return !0;
        return !1;
      }
    }, this.get_content = function() {
      for (var D = "", G = [], P = !1; this.input.charAt(this.pos) !== "<"; ) {
        if (this.pos >= this.input.length)
          return G.length ? G.join("") : ["", "TK_EOF"];
        if (D = this.input.charAt(this.pos), this.pos++, this.line_char_count++, this.Utils.in_array(D, this.Utils.whitespace)) {
          G.length && (P = !0), this.line_char_count--;
          continue;
        } else if (P) {
          if (this.line_char_count >= this.max_char) {
            G.push(`
`);
            for (var U = 0; U < this.indent_level; U++)
              G.push(this.indent_string);
            this.line_char_count = 0;
          } else
            G.push(" "), this.line_char_count++;
          P = !1;
        }
        G.push(D);
      }
      return G.length ? G.join("") : "";
    }, this.get_contents_to = function(D) {
      if (this.pos == this.input.length)
        return ["", "TK_EOF"];
      var G = "", P = new RegExp("</" + D + "\\s*>", "igm");
      P.lastIndex = this.pos;
      var U = P.exec(this.input), Y = U ? U.index : this.input.length;
      return this.pos < Y && (G = this.input.substring(this.pos, Y), this.pos = Y), G;
    }, this.record_tag = function(D) {
      this.tags[D + "count"] ? (this.tags[D + "count"]++, this.tags[D + this.tags[D + "count"]] = this.indent_level) : (this.tags[D + "count"] = 1, this.tags[D + this.tags[D + "count"]] = this.indent_level), this.tags[D + this.tags[D + "count"] + "parent"] = this.tags.parent, this.tags.parent = D + this.tags[D + "count"];
    }, this.retrieve_tag = function(D) {
      if (this.tags[D + "count"]) {
        for (var G = this.tags.parent; G && D + this.tags[D + "count"] !== G; )
          G = this.tags[G + "parent"];
        G && (this.indent_level = this.tags[D + this.tags[D + "count"]], this.tags.parent = this.tags[G + "parent"]), delete this.tags[D + this.tags[D + "count"] + "parent"], delete this.tags[D + this.tags[D + "count"]], this.tags[D + "count"] == 1 ? delete this.tags[D + "count"] : this.tags[D + "count"]--;
      }
    }, this.get_tag = function() {
      var D = "", G = [], P = !1, U, Y;
      do {
        if (this.pos >= this.input.length)
          return G.length ? G.join("") : ["", "TK_EOF"];
        if (D = this.input.charAt(this.pos), this.pos++, this.line_char_count++, this.Utils.in_array(D, this.Utils.whitespace)) {
          P = !0, this.line_char_count--;
          continue;
        }
        (D === "'" || D === '"') && (!G[1] || G[1] !== "!") && (D += this.get_unformatted(D), P = !0), D === "=" && (P = !1), G.length && G[G.length - 1] !== "=" && D !== ">" && P && (this.line_char_count >= this.max_char ? (this.print_newline(!1, G), this.line_char_count = 0) : (G.push(" "), this.line_char_count++), P = !1), D === "<" && (U = this.pos - 1), G.push(D);
      } while (D !== ">");
      var X = G.join(""), _;
      X.indexOf(" ") != -1 ? _ = X.indexOf(" ") : _ = X.indexOf(">");
      var F = X.substring(1, _).toLowerCase();
      if (X.charAt(X.length - 2) === "/" || this.Utils.in_array(F, this.Utils.single_token))
        this.tag_type = "SINGLE";
      else if (F === "script")
        this.record_tag(F), this.tag_type = "SCRIPT";
      else if (F === "style")
        this.record_tag(F), this.tag_type = "STYLE";
      else if (this.Utils.in_array(F, R)) {
        var j = this.get_unformatted("</" + F + ">", X);
        G.push(j), U > 0 && this.Utils.in_array(this.input.charAt(U - 1), this.Utils.whitespace) && G.splice(0, 0, this.input.charAt(U - 1)), Y = this.pos - 1, this.Utils.in_array(this.input.charAt(Y + 1), this.Utils.whitespace) && G.push(this.input.charAt(Y + 1)), this.tag_type = "SINGLE";
      } else if (F.charAt(0) === "!")
        if (F.indexOf("[if") != -1) {
          if (X.indexOf("!IE") != -1) {
            var j = this.get_unformatted("-->", X);
            G.push(j);
          }
          this.tag_type = "START";
        } else if (F.indexOf("[endif") != -1)
          this.tag_type = "END", this.unindent();
        else if (F.indexOf("[cdata[") != -1) {
          var j = this.get_unformatted("]]>", X);
          G.push(j), this.tag_type = "SINGLE";
        } else {
          var j = this.get_unformatted("-->", X);
          G.push(j), this.tag_type = "SINGLE";
        }
      else
        F.charAt(0) === "/" ? (this.retrieve_tag(F.substring(1)), this.tag_type = "END") : (this.record_tag(F), this.tag_type = "START"), this.Utils.in_array(F, this.Utils.extra_liners) && this.print_newline(!0, this.output);
      return G.join("");
    }, this.get_unformatted = function(D, G) {
      if (G && G.toLowerCase().indexOf(D) != -1)
        return "";
      var P = "", U = "", Y = !0;
      do {
        if (this.pos >= this.input.length)
          return U;
        if (P = this.input.charAt(this.pos), this.pos++, this.Utils.in_array(P, this.Utils.whitespace)) {
          if (!Y) {
            this.line_char_count--;
            continue;
          }
          if (P === `
` || P === "\r") {
            U += `
`, this.line_char_count = 0;
            continue;
          }
        }
        U += P, this.line_char_count++, Y = !0;
      } while (U.toLowerCase().indexOf(D) == -1);
      return U;
    }, this.get_token = function() {
      var D;
      if (this.last_token === "TK_TAG_SCRIPT" || this.last_token === "TK_TAG_STYLE") {
        var G = this.last_token.substr(7);
        return D = this.get_contents_to(G), typeof D != "string" ? D : [D, "TK_" + G];
      }
      if (this.current_mode === "CONTENT")
        return D = this.get_content(), typeof D != "string" ? D : [D, "TK_CONTENT"];
      if (this.current_mode === "TAG") {
        if (D = this.get_tag(), typeof D != "string")
          return D;
        var P = "TK_TAG_" + this.tag_type;
        return [D, P];
      }
    }, this.get_full_indent = function(D) {
      return D = this.indent_level + D || 0, D < 1 ? "" : Array(D + 1).join(this.indent_string);
    }, this.printer = function(D, G, P, U, Y) {
      this.input = D || "", this.output = [], this.indent_character = G, this.indent_string = "", this.indent_size = P, this.brace_style = Y, this.indent_level = 0, this.max_char = U, this.line_char_count = 0;
      for (var X = 0; X < this.indent_size; X++)
        this.indent_string += this.indent_character;
      this.print_newline = function(_, F) {
        if (this.line_char_count = 0, !(!F || !F.length)) {
          if (!_)
            for (; this.Utils.in_array(F[F.length - 1], this.Utils.whitespace); )
              F.pop();
          F.push(`
`);
          for (var j = 0; j < this.indent_level; j++)
            F.push(this.indent_string);
        }
      }, this.print_token = function(_) {
        this.output.push(_);
      }, this.indent = function() {
        this.indent_level++;
      }, this.unindent = function() {
        this.indent_level > 0 && this.indent_level--;
      };
    }, this;
  }
  for (s = new d(), s.printer(n, c, o, E, u); ; ) {
    var T = s.get_token();
    if (s.token_text = T[0], s.token_type = T[1], s.token_type === "TK_EOF")
      break;
    switch (s.token_type) {
      case "TK_TAG_START":
        s.print_newline(!1, s.output), s.print_token(s.token_text), s.indent(), s.current_mode = "CONTENT";
        break;
      case "TK_TAG_STYLE":
      case "TK_TAG_SCRIPT":
        s.print_newline(!1, s.output), s.print_token(s.token_text), s.current_mode = "CONTENT";
        break;
      case "TK_TAG_END":
        if (s.last_token === "TK_CONTENT" && s.last_text === "") {
          var S = s.token_text.match(/\w+/)[0], N = s.output[s.output.length - 1].match(/<\s*(\w+)/);
          (N === null || N[1] !== S) && s.print_newline(!0, s.output);
        }
        s.print_token(s.token_text), s.current_mode = "CONTENT";
        break;
      case "TK_TAG_SINGLE":
        var m = s.token_text.match(/^\s*<([a-z]+)/i);
        (!m || !s.Utils.in_array(m[1], R)) && s.print_newline(!1, s.output), s.print_token(s.token_text), s.current_mode = "CONTENT";
        break;
      case "TK_CONTENT":
        s.token_text !== "" && s.print_token(s.token_text), s.current_mode = "TAG";
        break;
      case "TK_STYLE":
      case "TK_SCRIPT":
        if (s.token_text !== "") {
          s.output.push(`
`);
          var v = s.token_text;
          if (s.token_type == "TK_SCRIPT")
            var M = typeof js_beautify == "function" && js_beautify;
          else if (s.token_type == "TK_STYLE")
            var M = typeof css_beautify == "function" && css_beautify;
          if (a.indent_scripts == "keep")
            var w = 0;
          else if (a.indent_scripts == "separate")
            var w = -s.indent_level;
          else
            var w = 1;
          var y = s.get_full_indent(w);
          if (M)
            v = M(v.replace(/^\s*/, y), a);
          else {
            var O = v.match(/^\s*/)[0], g = O.match(/[^\n\r]*$/)[0].split(s.indent_string).length - 1, V = s.get_full_indent(w - g);
            v = v.replace(/^\s*/, y).replace(/\r\n|\r|\n/g, `
` + V).replace(/\s*$/, "");
          }
          v && (s.print_token(v), s.print_newline(!0, s.output));
        }
        s.current_mode = "TAG";
        break;
    }
    s.last_token = s.token_type, s.last_text = s.token_text;
  }
  return s.output.join("");
}
var LH = {
  prettyPrint: vH
};
const yH = CH.js_beautify, gH = mH, DH = LH.prettyPrint;
let bH = (n) => ~['"', "'"].indexOf(n[0]) && ~['"', "'"].indexOf(n[n.length - 1]) && n[0] === n[n.length - 1] ? n.substring(1, n.length - 1) : n, MH = (n, a) => {
  if (!n || !n.length)
    return "";
  switch (n = bH(n.trim()), a.format) {
    case "css":
      return gH(n, {
        indent: "    ",
        autosemicolon: !0
      });
    case "json":
    case "js":
      return yH(n, {
        indent_size: 4
      });
    case "html":
    case "xml":
      return DH(n);
  }
};
var PH = MH;
const _m = /* @__PURE__ */ Xi(PH);
var jS = {}, EL = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var a = {}.hasOwnProperty;
    function s() {
      for (var E = "", u = 0; u < arguments.length; u++) {
        var R = arguments[u];
        R && (E = c(E, o(R)));
      }
      return E;
    }
    function o(E) {
      if (typeof E == "string" || typeof E == "number")
        return E;
      if (typeof E != "object")
        return "";
      if (Array.isArray(E))
        return s.apply(null, E);
      if (E.toString !== Object.prototype.toString && !E.toString.toString().includes("[native code]"))
        return E.toString();
      var u = "";
      for (var R in E)
        a.call(E, R) && E[R] && (u = c(u, R));
      return u;
    }
    function c(E, u) {
      return u ? E ? E + " " + u : E + u : E;
    }
    n.exports ? (s.default = s, n.exports = s) : window.classNames = s;
  })();
})(EL);
var UH = EL.exports, Wi = {}, cL = {}, ri = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a() {
  }
  a.prototype = {
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    diff: function(E, u) {
      var R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, d = R.callback;
      typeof R == "function" && (d = R, R = {}), this.options = R;
      var T = this;
      function S(V) {
        return d ? (setTimeout(function() {
          d(void 0, V);
        }, 0), !0) : V;
      }
      E = this.castInput(E), u = this.castInput(u), E = this.removeEmpty(this.tokenize(E)), u = this.removeEmpty(this.tokenize(u));
      var N = u.length, m = E.length, v = 1, M = N + m;
      R.maxEditLength && (M = Math.min(M, R.maxEditLength));
      var w = [{
        newPos: -1,
        components: []
      }], y = this.extractCommon(w[0], u, E, 0);
      if (w[0].newPos + 1 >= N && y + 1 >= m)
        return S([{
          value: this.join(u),
          count: u.length
        }]);
      function O() {
        for (var V = -1 * v; V <= v; V += 2) {
          var D = (
            /*istanbul ignore start*/
            void 0
          ), G = w[V - 1], P = w[V + 1], U = (P ? P.newPos : 0) - V;
          G && (w[V - 1] = void 0);
          var Y = G && G.newPos + 1 < N, X = P && 0 <= U && U < m;
          if (!Y && !X) {
            w[V] = void 0;
            continue;
          }
          if (!Y || X && G.newPos < P.newPos ? (D = o(P), T.pushComponent(D.components, void 0, !0)) : (D = G, D.newPos++, T.pushComponent(D.components, !0, void 0)), U = T.extractCommon(D, u, E, V), D.newPos + 1 >= N && U + 1 >= m)
            return S(s(T, D.components, u, E, T.useLongestToken));
          w[V] = D;
        }
        v++;
      }
      if (d)
        (function V() {
          setTimeout(function() {
            if (v > M)
              return d();
            O() || V();
          }, 0);
        })();
      else
        for (; v <= M; ) {
          var g = O();
          if (g)
            return g;
        }
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    pushComponent: function(E, u, R) {
      var d = E[E.length - 1];
      d && d.added === u && d.removed === R ? E[E.length - 1] = {
        count: d.count + 1,
        added: u,
        removed: R
      } : E.push({
        count: 1,
        added: u,
        removed: R
      });
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    extractCommon: function(E, u, R, d) {
      for (var T = u.length, S = R.length, N = E.newPos, m = N - d, v = 0; N + 1 < T && m + 1 < S && this.equals(u[N + 1], R[m + 1]); )
        N++, m++, v++;
      return v && E.components.push({
        count: v
      }), E.newPos = N, m;
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    equals: function(E, u) {
      return this.options.comparator ? this.options.comparator(E, u) : E === u || this.options.ignoreCase && E.toLowerCase() === u.toLowerCase();
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    removeEmpty: function(E) {
      for (var u = [], R = 0; R < E.length; R++)
        E[R] && u.push(E[R]);
      return u;
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    castInput: function(E) {
      return E;
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    tokenize: function(E) {
      return E.split("");
    },
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    join: function(E) {
      return E.join("");
    }
  };
  function s(c, E, u, R, d) {
    for (var T = 0, S = E.length, N = 0, m = 0; T < S; T++) {
      var v = E[T];
      if (v.removed) {
        if (v.value = c.join(R.slice(m, m + v.count)), m += v.count, T && E[T - 1].added) {
          var w = E[T - 1];
          E[T - 1] = E[T], E[T] = w;
        }
      } else {
        if (!v.added && d) {
          var M = u.slice(N, N + v.count);
          M = M.map(function(O, g) {
            var V = R[m + g];
            return V.length > O.length ? V : O;
          }), v.value = c.join(M);
        } else
          v.value = c.join(u.slice(N, N + v.count));
        N += v.count, v.added || (m += v.count);
      }
    }
    var y = E[S - 1];
    return S > 1 && typeof y.value == "string" && (y.added || y.removed) && c.equals("", y.value) && (E[S - 2].value += y.value, E.pop()), E;
  }
  function o(c) {
    return {
      newPos: c.newPos,
      components: c.components.slice(0)
    };
  }
})(ri);
var lE = {};
Object.defineProperty(lE, "__esModule", {
  value: !0
});
lE.diffChars = GH;
lE.characterDiff = void 0;
var xH = wH(ri);
function wH(n) {
  return n && n.__esModule ? n : { default: n };
}
var fL = new /*istanbul ignore start*/
xH.default();
lE.characterDiff = fL;
function GH(n, a, s) {
  return fL.diff(n, a, s);
}
var qo = {}, pT = {};
Object.defineProperty(pT, "__esModule", {
  value: !0
});
pT.generateOptions = HH;
function HH(n, a) {
  if (typeof n == "function")
    a.callback = n;
  else if (n)
    for (var s in n)
      n.hasOwnProperty(s) && (a[s] = n[s]);
  return a;
}
Object.defineProperty(qo, "__esModule", {
  value: !0
});
qo.diffWords = VH;
qo.diffWordsWithSpace = WH;
qo.wordDiff = void 0;
var BH = YH(ri), FH = pT;
function YH(n) {
  return n && n.__esModule ? n : { default: n };
}
var Cm = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, mm = /\S/, uE = new /*istanbul ignore start*/
BH.default();
qo.wordDiff = uE;
uE.equals = function(n, a) {
  return this.options.ignoreCase && (n = n.toLowerCase(), a = a.toLowerCase()), n === a || this.options.ignoreWhitespace && !mm.test(n) && !mm.test(a);
};
uE.tokenize = function(n) {
  for (var a = n.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), s = 0; s < a.length - 1; s++)
    !a[s + 1] && a[s + 2] && Cm.test(a[s]) && Cm.test(a[s + 2]) && (a[s] += a[s + 2], a.splice(s + 1, 2), s--);
  return a;
};
function VH(n, a, s) {
  return s = /*istanbul ignore start*/
  /*istanbul ignore end*/
  /*istanbul ignore start*/
  (0, FH.generateOptions)(s, {
    ignoreWhitespace: !0
  }), uE.diff(n, a, s);
}
function WH(n, a, s) {
  return uE.diff(n, a, s);
}
var Ji = {};
Object.defineProperty(Ji, "__esModule", {
  value: !0
});
Ji.diffLines = KH;
Ji.diffTrimmedLines = JH;
Ji.lineDiff = void 0;
var kH = jH(ri), XH = pT;
function jH(n) {
  return n && n.__esModule ? n : { default: n };
}
var ST = new /*istanbul ignore start*/
kH.default();
Ji.lineDiff = ST;
ST.tokenize = function(n) {
  var a = [], s = n.split(/(\n|\r\n)/);
  s[s.length - 1] || s.pop();
  for (var o = 0; o < s.length; o++) {
    var c = s[o];
    o % 2 && !this.options.newlineIsToken ? a[a.length - 1] += c : (this.options.ignoreWhitespace && (c = c.trim()), a.push(c));
  }
  return a;
};
function KH(n, a, s) {
  return ST.diff(n, a, s);
}
function JH(n, a, s) {
  var o = (
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    /*istanbul ignore start*/
    (0, XH.generateOptions)(s, {
      ignoreWhitespace: !0
    })
  );
  return ST.diff(n, a, o);
}
var EE = {};
Object.defineProperty(EE, "__esModule", {
  value: !0
});
EE.diffSentences = qH;
EE.sentenceDiff = void 0;
var zH = ZH(ri);
function ZH(n) {
  return n && n.__esModule ? n : { default: n };
}
var KS = new /*istanbul ignore start*/
zH.default();
EE.sentenceDiff = KS;
KS.tokenize = function(n) {
  return n.split(/(\S.+?[.!?])(?=\s+|$)/);
};
function qH(n, a, s) {
  return KS.diff(n, a, s);
}
var cE = {};
Object.defineProperty(cE, "__esModule", {
  value: !0
});
cE.diffCss = e6;
cE.cssDiff = void 0;
var QH = $H(ri);
function $H(n) {
  return n && n.__esModule ? n : { default: n };
}
var JS = new /*istanbul ignore start*/
QH.default();
cE.cssDiff = JS;
JS.tokenize = function(n) {
  return n.split(/([{}:;,]|\s+)/);
};
function e6(n, a, s) {
  return JS.diff(n, a, s);
}
var Qo = {};
Object.defineProperty(Qo, "__esModule", {
  value: !0
});
Qo.diffJson = a6;
Qo.canonicalize = eT;
Qo.jsonDiff = void 0;
var TL = n6(ri), t6 = Ji;
function n6(n) {
  return n && n.__esModule ? n : { default: n };
}
function Wf(n) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Wf = function(s) {
    return typeof s;
  } : Wf = function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, Wf(n);
}
var r6 = Object.prototype.toString, Gs = new /*istanbul ignore start*/
TL.default();
Qo.jsonDiff = Gs;
Gs.useLongestToken = !0;
Gs.tokenize = /*istanbul ignore start*/
t6.lineDiff.tokenize;
Gs.castInput = function(n) {
  var a = (
    /*istanbul ignore end*/
    this.options
  ), s = a.undefinedReplacement, o = a.stringifyReplacer, c = o === void 0 ? function(E, u) {
    return (
      /*istanbul ignore end*/
      typeof u > "u" ? s : u
    );
  } : o;
  return typeof n == "string" ? n : JSON.stringify(eT(n, null, null, c), c, "  ");
};
Gs.equals = function(n, a) {
  return (
    /*istanbul ignore start*/
    TL.default.prototype.equals.call(Gs, n.replace(/,([\r\n])/g, "$1"), a.replace(/,([\r\n])/g, "$1"))
  );
};
function a6(n, a, s) {
  return Gs.diff(n, a, s);
}
function eT(n, a, s, o, c) {
  a = a || [], s = s || [], o && (n = o(c, n));
  var E;
  for (E = 0; E < a.length; E += 1)
    if (a[E] === n)
      return s[E];
  var u;
  if (r6.call(n) === "[object Array]") {
    for (a.push(n), u = new Array(n.length), s.push(u), E = 0; E < n.length; E += 1)
      u[E] = eT(n[E], a, s, o, c);
    return a.pop(), s.pop(), u;
  }
  if (n && n.toJSON && (n = n.toJSON()), /*istanbul ignore start*/
  Wf(
    /*istanbul ignore end*/
    n
  ) === "object" && n !== null) {
    a.push(n), u = {}, s.push(u);
    var R = [], d;
    for (d in n)
      n.hasOwnProperty(d) && R.push(d);
    for (R.sort(), E = 0; E < R.length; E += 1)
      d = R[E], u[d] = eT(n[d], a, s, o, d);
    a.pop(), s.pop();
  } else
    u = n;
  return u;
}
var fE = {};
Object.defineProperty(fE, "__esModule", {
  value: !0
});
fE.diffArrays = o6;
fE.arrayDiff = void 0;
var i6 = s6(ri);
function s6(n) {
  return n && n.__esModule ? n : { default: n };
}
var qu = new /*istanbul ignore start*/
i6.default();
fE.arrayDiff = qu;
qu.tokenize = function(n) {
  return n.slice();
};
qu.join = qu.removeEmpty = function(n) {
  return n;
};
function o6(n, a, s) {
  return qu.diff(n, a, s);
}
var hT = {}, TE = {};
Object.defineProperty(TE, "__esModule", {
  value: !0
});
TE.parsePatch = l6;
function l6(n) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.split(/\r\n|[\n\v\f\r\x85]/), o = n.match(/\r\n|[\n\v\f\r\x85]/g) || [], c = [], E = 0;
  function u() {
    var T = {};
    for (c.push(T); E < s.length; ) {
      var S = s[E];
      if (/^(\-\-\-|\+\+\+|@@)\s/.test(S))
        break;
      var N = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(S);
      N && (T.index = N[1]), E++;
    }
    for (R(T), R(T), T.hunks = []; E < s.length; ) {
      var m = s[E];
      if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(m))
        break;
      if (/^@@/.test(m))
        T.hunks.push(d());
      else {
        if (m && a.strict)
          throw new Error("Unknown line " + (E + 1) + " " + JSON.stringify(m));
        E++;
      }
    }
  }
  function R(T) {
    var S = /^(---|\+\+\+)\s+(.*)$/.exec(s[E]);
    if (S) {
      var N = S[1] === "---" ? "old" : "new", m = S[2].split("	", 2), v = m[0].replace(/\\\\/g, "\\");
      /^".*"$/.test(v) && (v = v.substr(1, v.length - 2)), T[N + "FileName"] = v, T[N + "Header"] = (m[1] || "").trim(), E++;
    }
  }
  function d() {
    var T = E, S = s[E++], N = S.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/), m = {
      oldStart: +N[1],
      oldLines: typeof N[2] > "u" ? 1 : +N[2],
      newStart: +N[3],
      newLines: typeof N[4] > "u" ? 1 : +N[4],
      lines: [],
      linedelimiters: []
    };
    m.oldLines === 0 && (m.oldStart += 1), m.newLines === 0 && (m.newStart += 1);
    for (var v = 0, M = 0; E < s.length && !(s[E].indexOf("--- ") === 0 && E + 2 < s.length && s[E + 1].indexOf("+++ ") === 0 && s[E + 2].indexOf("@@") === 0); E++) {
      var w = s[E].length == 0 && E != s.length - 1 ? " " : s[E][0];
      if (w === "+" || w === "-" || w === " " || w === "\\")
        m.lines.push(s[E]), m.linedelimiters.push(o[E] || `
`), w === "+" ? v++ : w === "-" ? M++ : w === " " && (v++, M++);
      else
        break;
    }
    if (!v && m.newLines === 1 && (m.newLines = 0), !M && m.oldLines === 1 && (m.oldLines = 0), a.strict) {
      if (v !== m.newLines)
        throw new Error("Added line count did not match for hunk at line " + (T + 1));
      if (M !== m.oldLines)
        throw new Error("Removed line count did not match for hunk at line " + (T + 1));
    }
    return m;
  }
  for (; E < s.length; )
    u();
  return c;
}
var dL = {};
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a(s, o, c) {
    var E = !0, u = !1, R = !1, d = 1;
    return function T() {
      if (E && !R) {
        if (u ? d++ : E = !1, s + d <= c)
          return d;
        R = !0;
      }
      if (!u)
        return R || (E = !0), o <= s - d ? -d++ : (u = !0, T());
    };
  }
})(dL);
Object.defineProperty(hT, "__esModule", {
  value: !0
});
hT.applyPatch = RL;
hT.applyPatches = c6;
var AL = TE, u6 = E6(dL);
function E6(n) {
  return n && n.__esModule ? n : { default: n };
}
function RL(n, a) {
  var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof a == "string" && (a = /*istanbul ignore start*/
  /*istanbul ignore end*/
  /*istanbul ignore start*/
  (0, AL.parsePatch)(a)), Array.isArray(a)) {
    if (a.length > 1)
      throw new Error("applyPatch only works with a single input.");
    a = a[0];
  }
  var o = n.split(/\r\n|[\n\v\f\r\x85]/), c = n.match(/\r\n|[\n\v\f\r\x85]/g) || [], E = a.hunks, u = s.compareLine || function(ee, oe, ne, de) {
    return (
      /*istanbul ignore end*/
      oe === de
    );
  }, R = 0, d = s.fuzzFactor || 0, T = 0, S = 0, N, m;
  function v(ee, oe) {
    for (var ne = 0; ne < ee.lines.length; ne++) {
      var de = ee.lines[ne], ve = de.length > 0 ? de[0] : " ", Fe = de.length > 0 ? de.substr(1) : de;
      if (ve === " " || ve === "-") {
        if (!u(oe + 1, o[oe], ve, Fe) && (R++, R > d))
          return !1;
        oe++;
      }
    }
    return !0;
  }
  for (var M = 0; M < E.length; M++) {
    for (var w = E[M], y = o.length - w.oldLines, O = 0, g = S + w.oldStart - 1, V = (
      /*istanbul ignore start*/
      /*istanbul ignore end*/
      /*istanbul ignore start*/
      (0, u6.default)(g, T, y)
    ); O !== void 0; O = V())
      if (v(w, g + O)) {
        w.offset = S += O;
        break;
      }
    if (O === void 0)
      return !1;
    T = w.offset + w.oldStart + w.oldLines;
  }
  for (var D = 0, G = 0; G < E.length; G++) {
    var P = E[G], U = P.oldStart + P.offset + D - 1;
    D += P.newLines - P.oldLines;
    for (var Y = 0; Y < P.lines.length; Y++) {
      var X = P.lines[Y], _ = X.length > 0 ? X[0] : " ", F = X.length > 0 ? X.substr(1) : X, j = P.linedelimiters[Y];
      if (_ === " ")
        U++;
      else if (_ === "-")
        o.splice(U, 1), c.splice(U, 1);
      else if (_ === "+")
        o.splice(U, 0, F), c.splice(U, 0, j), U++;
      else if (_ === "\\") {
        var z = P.lines[Y - 1] ? P.lines[Y - 1][0] : null;
        z === "+" ? N = !0 : z === "-" && (m = !0);
      }
    }
  }
  if (N)
    for (; !o[o.length - 1]; )
      o.pop(), c.pop();
  else
    m && (o.push(""), c.push(`
`));
  for (var Z = 0; Z < o.length - 1; Z++)
    o[Z] = o[Z] + c[Z];
  return o.join("");
}
function c6(n, a) {
  typeof n == "string" && (n = /*istanbul ignore start*/
  /*istanbul ignore end*/
  /*istanbul ignore start*/
  (0, AL.parsePatch)(n));
  var s = 0;
  function o() {
    var c = n[s++];
    if (!c)
      return a.complete();
    a.loadFile(c, function(E, u) {
      if (E)
        return a.complete(E);
      var R = RL(u, c, a);
      a.patched(c, R, function(d) {
        if (d)
          return a.complete(d);
        o();
      });
    });
  }
  o();
}
var NT = {}, Ys = {};
Object.defineProperty(Ys, "__esModule", {
  value: !0
});
Ys.structuredPatch = pL;
Ys.formatPatch = SL;
Ys.createTwoFilesPatch = hL;
Ys.createPatch = p6;
var f6 = Ji;
function oS(n) {
  return R6(n) || A6(n) || d6(n) || T6();
}
function T6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function d6(n, a) {
  if (n) {
    if (typeof n == "string")
      return SS(n, a);
    var s = Object.prototype.toString.call(n).slice(8, -1);
    if (s === "Object" && n.constructor && (s = n.constructor.name), s === "Map" || s === "Set")
      return Array.from(n);
    if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
      return SS(n, a);
  }
}
function A6(n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(n))
    return Array.from(n);
}
function R6(n) {
  if (Array.isArray(n))
    return SS(n);
}
function SS(n, a) {
  (a == null || a > n.length) && (a = n.length);
  for (var s = 0, o = new Array(a); s < a; s++)
    o[s] = n[s];
  return o;
}
function pL(n, a, s, o, c, E, u) {
  u || (u = {}), typeof u.context > "u" && (u.context = 4);
  var R = (
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    /*istanbul ignore start*/
    (0, f6.diffLines)(s, o, u)
  );
  if (!R)
    return;
  R.push({
    value: "",
    lines: []
  });
  function d(O) {
    return O.map(function(g) {
      return " " + g;
    });
  }
  for (var T = [], S = 0, N = 0, m = [], v = 1, M = 1, w = function(g) {
    var V = R[g], D = V.lines || V.value.replace(/\n$/, "").split(`
`);
    if (V.lines = D, V.added || V.removed) {
      var G;
      if (!S) {
        var P = R[g - 1];
        S = v, N = M, P && (m = u.context > 0 ? d(P.lines.slice(-u.context)) : [], S -= m.length, N -= m.length);
      }
      (G = /*istanbul ignore end*/
      m).push.apply(
        /*istanbul ignore start*/
        G,
        /*istanbul ignore start*/
        oS(
          /*istanbul ignore end*/
          D.map(function(Z) {
            return (V.added ? "+" : "-") + Z;
          })
        )
      ), V.added ? M += D.length : v += D.length;
    } else {
      if (S)
        if (D.length <= u.context * 2 && g < R.length - 2) {
          var U;
          (U = /*istanbul ignore end*/
          m).push.apply(
            /*istanbul ignore start*/
            U,
            /*istanbul ignore start*/
            oS(
              /*istanbul ignore end*/
              d(D)
            )
          );
        } else {
          var Y, X = Math.min(D.length, u.context);
          (Y = /*istanbul ignore end*/
          m).push.apply(
            /*istanbul ignore start*/
            Y,
            /*istanbul ignore start*/
            oS(
              /*istanbul ignore end*/
              d(D.slice(0, X))
            )
          );
          var _ = {
            oldStart: S,
            oldLines: v - S + X,
            newStart: N,
            newLines: M - N + X,
            lines: m
          };
          if (g >= R.length - 2 && D.length <= u.context) {
            var F = /\n$/.test(s), j = /\n$/.test(o), z = D.length == 0 && m.length > _.oldLines;
            !F && z && s.length > 0 && m.splice(_.oldLines, 0, "\\ No newline at end of file"), (!F && !z || !j) && m.push("\\ No newline at end of file");
          }
          T.push(_), S = 0, N = 0, m = [];
        }
      v += D.length, M += D.length;
    }
  }, y = 0; y < R.length; y++)
    w(
      /*istanbul ignore end*/
      y
    );
  return {
    oldFileName: n,
    newFileName: a,
    oldHeader: c,
    newHeader: E,
    hunks: T
  };
}
function SL(n) {
  var a = [];
  n.oldFileName == n.newFileName && a.push("Index: " + n.oldFileName), a.push("==================================================================="), a.push("--- " + n.oldFileName + (typeof n.oldHeader > "u" ? "" : "	" + n.oldHeader)), a.push("+++ " + n.newFileName + (typeof n.newHeader > "u" ? "" : "	" + n.newHeader));
  for (var s = 0; s < n.hunks.length; s++) {
    var o = n.hunks[s];
    o.oldLines === 0 && (o.oldStart -= 1), o.newLines === 0 && (o.newStart -= 1), a.push("@@ -" + o.oldStart + "," + o.oldLines + " +" + o.newStart + "," + o.newLines + " @@"), a.push.apply(a, o.lines);
  }
  return a.join(`
`) + `
`;
}
function hL(n, a, s, o, c, E, u) {
  return SL(pL(n, a, s, o, c, E, u));
}
function p6(n, a, s, o, c, E) {
  return hL(n, n, a, s, o, c, E);
}
var OT = {};
Object.defineProperty(OT, "__esModule", {
  value: !0
});
OT.arrayEqual = S6;
OT.arrayStartsWith = NL;
function S6(n, a) {
  return n.length !== a.length ? !1 : NL(n, a);
}
function NL(n, a) {
  if (a.length > n.length)
    return !1;
  for (var s = 0; s < a.length; s++)
    if (a[s] !== n[s])
      return !1;
  return !0;
}
Object.defineProperty(NT, "__esModule", {
  value: !0
});
NT.calcLineCount = OL;
NT.merge = m6;
var h6 = Ys, N6 = TE, lS = OT;
function Xo(n) {
  return C6(n) || _6(n) || I6(n) || O6();
}
function O6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function I6(n, a) {
  if (n) {
    if (typeof n == "string")
      return hS(n, a);
    var s = Object.prototype.toString.call(n).slice(8, -1);
    if (s === "Object" && n.constructor && (s = n.constructor.name), s === "Map" || s === "Set")
      return Array.from(n);
    if (s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s))
      return hS(n, a);
  }
}
function _6(n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(n))
    return Array.from(n);
}
function C6(n) {
  if (Array.isArray(n))
    return hS(n);
}
function hS(n, a) {
  (a == null || a > n.length) && (a = n.length);
  for (var s = 0, o = new Array(a); s < a; s++)
    o[s] = n[s];
  return o;
}
function OL(n) {
  var a = (
    /*istanbul ignore end*/
    NS(n.lines)
  ), s = a.oldLines, o = a.newLines;
  s !== void 0 ? n.oldLines = s : delete n.oldLines, o !== void 0 ? n.newLines = o : delete n.newLines;
}
function m6(n, a, s) {
  n = vm(n, s), a = vm(a, s);
  var o = {};
  (n.index || a.index) && (o.index = n.index || a.index), (n.newFileName || a.newFileName) && (Lm(n) ? Lm(a) ? (o.oldFileName = Gf(o, n.oldFileName, a.oldFileName), o.newFileName = Gf(o, n.newFileName, a.newFileName), o.oldHeader = Gf(o, n.oldHeader, a.oldHeader), o.newHeader = Gf(o, n.newHeader, a.newHeader)) : (o.oldFileName = n.oldFileName, o.newFileName = n.newFileName, o.oldHeader = n.oldHeader, o.newHeader = n.newHeader) : (o.oldFileName = a.oldFileName || n.oldFileName, o.newFileName = a.newFileName || n.newFileName, o.oldHeader = a.oldHeader || n.oldHeader, o.newHeader = a.newHeader || n.newHeader)), o.hunks = [];
  for (var c = 0, E = 0, u = 0, R = 0; c < n.hunks.length || E < a.hunks.length; ) {
    var d = n.hunks[c] || {
      oldStart: 1 / 0
    }, T = a.hunks[E] || {
      oldStart: 1 / 0
    };
    if (ym(d, T))
      o.hunks.push(gm(d, u)), c++, R += d.newLines - d.oldLines;
    else if (ym(T, d))
      o.hunks.push(gm(T, R)), E++, u += T.newLines - T.oldLines;
    else {
      var S = {
        oldStart: Math.min(d.oldStart, T.oldStart),
        oldLines: 0,
        newStart: Math.min(d.newStart + u, T.oldStart + R),
        newLines: 0,
        lines: []
      };
      v6(S, d.oldStart, d.lines, T.oldStart, T.lines), E++, c++, o.hunks.push(S);
    }
  }
  return o;
}
function vm(n, a) {
  if (typeof n == "string") {
    if (/^@@/m.test(n) || /^Index:/m.test(n))
      return (
        /*istanbul ignore start*/
        /*istanbul ignore end*/
        /*istanbul ignore start*/
        (0, N6.parsePatch)(n)[0]
      );
    if (!a)
      throw new Error("Must provide a base reference or pass in a patch");
    return (
      /*istanbul ignore start*/
      /*istanbul ignore end*/
      /*istanbul ignore start*/
      (0, h6.structuredPatch)(void 0, void 0, a, n)
    );
  }
  return n;
}
function Lm(n) {
  return n.newFileName && n.newFileName !== n.oldFileName;
}
function Gf(n, a, s) {
  return a === s ? a : (n.conflict = !0, {
    mine: a,
    theirs: s
  });
}
function ym(n, a) {
  return n.oldStart < a.oldStart && n.oldStart + n.oldLines < a.oldStart;
}
function gm(n, a) {
  return {
    oldStart: n.oldStart,
    oldLines: n.oldLines,
    newStart: n.newStart + a,
    newLines: n.newLines,
    lines: n.lines
  };
}
function v6(n, a, s, o, c) {
  var E = {
    offset: a,
    lines: s,
    index: 0
  }, u = {
    offset: o,
    lines: c,
    index: 0
  };
  for (bm(n, E, u), bm(n, u, E); E.index < E.lines.length && u.index < u.lines.length; ) {
    var R = E.lines[E.index], d = u.lines[u.index];
    if ((R[0] === "-" || R[0] === "+") && (d[0] === "-" || d[0] === "+"))
      L6(n, E, u);
    else if (R[0] === "+" && d[0] === " ") {
      var T;
      (T = /*istanbul ignore end*/
      n.lines).push.apply(
        /*istanbul ignore start*/
        T,
        /*istanbul ignore start*/
        Xo(
          /*istanbul ignore end*/
          Ps(E)
        )
      );
    } else if (d[0] === "+" && R[0] === " ") {
      var S;
      (S = /*istanbul ignore end*/
      n.lines).push.apply(
        /*istanbul ignore start*/
        S,
        /*istanbul ignore start*/
        Xo(
          /*istanbul ignore end*/
          Ps(u)
        )
      );
    } else
      R[0] === "-" && d[0] === " " ? Dm(n, E, u) : d[0] === "-" && R[0] === " " ? Dm(n, u, E, !0) : R === d ? (n.lines.push(R), E.index++, u.index++) : zS(n, Ps(E), Ps(u));
  }
  Mm(n, E), Mm(n, u), OL(n);
}
function L6(n, a, s) {
  var o = Ps(a), c = Ps(s);
  if (Pm(o) && Pm(c)) {
    if (
      /*istanbul ignore start*/
      /*istanbul ignore end*/
      /*istanbul ignore start*/
      (0, lS.arrayStartsWith)(o, c) && Um(s, o, o.length - c.length)
    ) {
      var E;
      (E = /*istanbul ignore end*/
      n.lines).push.apply(
        /*istanbul ignore start*/
        E,
        /*istanbul ignore start*/
        Xo(
          /*istanbul ignore end*/
          o
        )
      );
      return;
    } else if (
      /*istanbul ignore start*/
      /*istanbul ignore end*/
      /*istanbul ignore start*/
      (0, lS.arrayStartsWith)(c, o) && Um(a, c, c.length - o.length)
    ) {
      var u;
      (u = /*istanbul ignore end*/
      n.lines).push.apply(
        /*istanbul ignore start*/
        u,
        /*istanbul ignore start*/
        Xo(
          /*istanbul ignore end*/
          c
        )
      );
      return;
    }
  } else if (
    /*istanbul ignore start*/
    /*istanbul ignore end*/
    /*istanbul ignore start*/
    (0, lS.arrayEqual)(o, c)
  ) {
    var R;
    (R = /*istanbul ignore end*/
    n.lines).push.apply(
      /*istanbul ignore start*/
      R,
      /*istanbul ignore start*/
      Xo(
        /*istanbul ignore end*/
        o
      )
    );
    return;
  }
  zS(n, o, c);
}
function Dm(n, a, s, o) {
  var c = Ps(a), E = y6(s, c);
  if (E.merged) {
    var u;
    (u = /*istanbul ignore end*/
    n.lines).push.apply(
      /*istanbul ignore start*/
      u,
      /*istanbul ignore start*/
      Xo(
        /*istanbul ignore end*/
        E.merged
      )
    );
  } else
    zS(n, o ? E : c, o ? c : E);
}
function zS(n, a, s) {
  n.conflict = !0, n.lines.push({
    conflict: !0,
    mine: a,
    theirs: s
  });
}
function bm(n, a, s) {
  for (; a.offset < s.offset && a.index < a.lines.length; ) {
    var o = a.lines[a.index++];
    n.lines.push(o), a.offset++;
  }
}
function Mm(n, a) {
  for (; a.index < a.lines.length; ) {
    var s = a.lines[a.index++];
    n.lines.push(s);
  }
}
function Ps(n) {
  for (var a = [], s = n.lines[n.index][0]; n.index < n.lines.length; ) {
    var o = n.lines[n.index];
    if (s === "-" && o[0] === "+" && (s = "+"), s === o[0])
      a.push(o), n.index++;
    else
      break;
  }
  return a;
}
function y6(n, a) {
  for (var s = [], o = [], c = 0, E = !1, u = !1; c < a.length && n.index < n.lines.length; ) {
    var R = n.lines[n.index], d = a[c];
    if (d[0] === "+")
      break;
    if (E = E || R[0] !== " ", o.push(d), c++, R[0] === "+")
      for (u = !0; R[0] === "+"; )
        s.push(R), R = n.lines[++n.index];
    d.substr(1) === R.substr(1) ? (s.push(R), n.index++) : u = !0;
  }
  if ((a[c] || "")[0] === "+" && E && (u = !0), u)
    return s;
  for (; c < a.length; )
    o.push(a[c++]);
  return {
    merged: o,
    changes: s
  };
}
function Pm(n) {
  return n.reduce(function(a, s) {
    return a && s[0] === "-";
  }, !0);
}
function Um(n, a, s) {
  for (var o = 0; o < s; o++) {
    var c = a[a.length - s + o].substr(1);
    if (n.lines[n.index + o] !== " " + c)
      return !1;
  }
  return n.index += s, !0;
}
function NS(n) {
  var a = 0, s = 0;
  return n.forEach(function(o) {
    if (typeof o != "string") {
      var c = NS(o.mine), E = NS(o.theirs);
      a !== void 0 && (c.oldLines === E.oldLines ? a += c.oldLines : a = void 0), s !== void 0 && (c.newLines === E.newLines ? s += c.newLines : s = void 0);
    } else
      s !== void 0 && (o[0] === "+" || o[0] === " ") && s++, a !== void 0 && (o[0] === "-" || o[0] === " ") && a++;
  }), {
    oldLines: a,
    newLines: s
  };
}
var ZS = {};
Object.defineProperty(ZS, "__esModule", {
  value: !0
});
ZS.convertChangesToDMP = g6;
function g6(n) {
  for (var a = [], s, o, c = 0; c < n.length; c++)
    s = n[c], s.added ? o = 1 : s.removed ? o = -1 : o = 0, a.push([o, s.value]);
  return a;
}
var qS = {};
Object.defineProperty(qS, "__esModule", {
  value: !0
});
qS.convertChangesToXML = D6;
function D6(n) {
  for (var a = [], s = 0; s < n.length; s++) {
    var o = n[s];
    o.added ? a.push("<ins>") : o.removed && a.push("<del>"), a.push(b6(o.value)), o.added ? a.push("</ins>") : o.removed && a.push("</del>");
  }
  return a.join("");
}
function b6(n) {
  var a = n;
  return a = a.replace(/&/g, "&amp;"), a = a.replace(/</g, "&lt;"), a = a.replace(/>/g, "&gt;"), a = a.replace(/"/g, "&quot;"), a;
}
(function(n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "Diff", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(n, "diffChars", {
    enumerable: !0,
    get: function() {
      return s.diffChars;
    }
  }), Object.defineProperty(n, "diffWords", {
    enumerable: !0,
    get: function() {
      return o.diffWords;
    }
  }), Object.defineProperty(n, "diffWordsWithSpace", {
    enumerable: !0,
    get: function() {
      return o.diffWordsWithSpace;
    }
  }), Object.defineProperty(n, "diffLines", {
    enumerable: !0,
    get: function() {
      return c.diffLines;
    }
  }), Object.defineProperty(n, "diffTrimmedLines", {
    enumerable: !0,
    get: function() {
      return c.diffTrimmedLines;
    }
  }), Object.defineProperty(n, "diffSentences", {
    enumerable: !0,
    get: function() {
      return E.diffSentences;
    }
  }), Object.defineProperty(n, "diffCss", {
    enumerable: !0,
    get: function() {
      return u.diffCss;
    }
  }), Object.defineProperty(n, "diffJson", {
    enumerable: !0,
    get: function() {
      return R.diffJson;
    }
  }), Object.defineProperty(n, "canonicalize", {
    enumerable: !0,
    get: function() {
      return R.canonicalize;
    }
  }), Object.defineProperty(n, "diffArrays", {
    enumerable: !0,
    get: function() {
      return d.diffArrays;
    }
  }), Object.defineProperty(n, "applyPatch", {
    enumerable: !0,
    get: function() {
      return T.applyPatch;
    }
  }), Object.defineProperty(n, "applyPatches", {
    enumerable: !0,
    get: function() {
      return T.applyPatches;
    }
  }), Object.defineProperty(n, "parsePatch", {
    enumerable: !0,
    get: function() {
      return S.parsePatch;
    }
  }), Object.defineProperty(n, "merge", {
    enumerable: !0,
    get: function() {
      return N.merge;
    }
  }), Object.defineProperty(n, "structuredPatch", {
    enumerable: !0,
    get: function() {
      return m.structuredPatch;
    }
  }), Object.defineProperty(n, "createTwoFilesPatch", {
    enumerable: !0,
    get: function() {
      return m.createTwoFilesPatch;
    }
  }), Object.defineProperty(n, "createPatch", {
    enumerable: !0,
    get: function() {
      return m.createPatch;
    }
  }), Object.defineProperty(n, "convertChangesToDMP", {
    enumerable: !0,
    get: function() {
      return v.convertChangesToDMP;
    }
  }), Object.defineProperty(n, "convertChangesToXML", {
    enumerable: !0,
    get: function() {
      return M.convertChangesToXML;
    }
  });
  var a = w(ri), s = lE, o = qo, c = Ji, E = EE, u = cE, R = Qo, d = fE, T = hT, S = TE, N = NT, m = Ys, v = ZS, M = qS;
  function w(y) {
    return y && y.__esModule ? y : { default: y };
  }
})(cL);
var M6 = Yt && Yt.__createBinding || (Object.create ? function(n, a, s, o) {
  o === void 0 && (o = s);
  var c = Object.getOwnPropertyDescriptor(a, s);
  (!c || ("get" in c ? !a.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
    return a[s];
  } }), Object.defineProperty(n, o, c);
} : function(n, a, s, o) {
  o === void 0 && (o = s), n[o] = a[s];
}), P6 = Yt && Yt.__setModuleDefault || (Object.create ? function(n, a) {
  Object.defineProperty(n, "default", { enumerable: !0, value: a });
} : function(n, a) {
  n.default = a;
}), U6 = Yt && Yt.__importStar || function(n) {
  if (n && n.__esModule)
    return n;
  var a = {};
  if (n != null)
    for (var s in n)
      s !== "default" && Object.prototype.hasOwnProperty.call(n, s) && M6(a, n, s);
  return P6(a, n), a;
};
Object.defineProperty(Wi, "__esModule", { value: !0 });
Wi.computeLineInformation = Wi.DiffMethod = Wi.DiffType = void 0;
const OS = U6(cL), x6 = OS;
var ti;
(function(n) {
  n[n.DEFAULT = 0] = "DEFAULT", n[n.ADDED = 1] = "ADDED", n[n.REMOVED = 2] = "REMOVED", n[n.CHANGED = 3] = "CHANGED";
})(ti || (Wi.DiffType = ti = {}));
var tT;
(function(n) {
  n.CHARS = "diffChars", n.WORDS = "diffWords", n.WORDS_WITH_SPACE = "diffWordsWithSpace", n.LINES = "diffLines", n.TRIMMED_LINES = "diffTrimmedLines", n.SENTENCES = "diffSentences", n.CSS = "diffCss", n.JSON = "diffJson";
})(tT || (Wi.DiffMethod = tT = {}));
const xm = (n) => n === "" ? [] : n.replace(/\n$/, "").split(`
`), w6 = (n, a, s = tT.CHARS) => {
  const o = x6[s](n, a), c = {
    left: [],
    right: []
  };
  return o.forEach(({ added: E, removed: u, value: R }) => {
    const d = {};
    return E && (d.type = ti.ADDED, d.value = R, c.right.push(d)), u && (d.type = ti.REMOVED, d.value = R, c.left.push(d)), !u && !E && (d.type = ti.DEFAULT, d.value = R, c.right.push(d), c.left.push(d)), d;
  }), c;
}, G6 = (n, a, s = !1, o = tT.CHARS, c = 0, E = []) => {
  let u = [];
  typeof n == "string" && typeof a == "string" ? u = OS.diffLines(n.trimRight(), a.trimRight(), {
    newlineIsToken: !1,
    ignoreWhitespace: !1,
    ignoreCase: !1
  }) : u = OS.diffJson(n, a);
  let R = c, d = c, T = [], S = 0;
  const N = [], m = [], v = (M, w, y, O, g) => xm(M).map((D, G) => {
    const P = {}, U = {};
    if (!(m.includes(`${w}-${G}`) || g && G !== 0)) {
      if (y || O) {
        let Y = !0;
        if (O) {
          d += 1, P.lineNumber = d, P.type = ti.REMOVED, P.value = D || " ";
          const X = u[w + 1];
          if (X && X.added) {
            const _ = xm(X.value)[G];
            if (_) {
              const F = v(_, w, !0, !1, !0), { value: j, lineNumber: z, type: Z } = F[0].right;
              if (m.push(`${w + 1}-${G}`), U.lineNumber = z, P.value === j)
                Y = !1, U.type = 0, P.type = 0, U.value = j;
              else if (U.type = Z, s)
                U.value = j;
              else {
                const ee = w6(D, j, o);
                U.value = ee.right, P.value = ee.left;
              }
            }
          }
        } else
          R += 1, U.lineNumber = R, U.type = ti.ADDED, U.value = D;
        Y && !g && (N.includes(S) || N.push(S));
      } else
        d += 1, R += 1, P.lineNumber = d, P.type = ti.DEFAULT, P.value = D, U.lineNumber = R, U.type = ti.DEFAULT, U.value = D;
      return (E != null && E.includes(`L-${P.lineNumber}`) || E != null && E.includes(`R-${U.lineNumber}`) && !N.includes(S)) && N.push(S), g || (S += 1), { right: U, left: P };
    }
  }).filter(Boolean);
  return u.forEach(({ added: M, removed: w, value: y }, O) => {
    T = [
      ...T,
      ...v(y, O, M, w)
    ];
  }), {
    lineInformation: T,
    diffLines: N
  };
};
Wi.computeLineInformation = G6;
var QS = {};
function H6(n) {
  if (n.sheet)
    return n.sheet;
  for (var a = 0; a < document.styleSheets.length; a++)
    if (document.styleSheets[a].ownerNode === n)
      return document.styleSheets[a];
}
function B6(n) {
  var a = document.createElement("style");
  return a.setAttribute("data-emotion", n.key), n.nonce !== void 0 && a.setAttribute("nonce", n.nonce), a.appendChild(document.createTextNode("")), a.setAttribute("data-s", ""), a;
}
var F6 = /* @__PURE__ */ function() {
  function n(s) {
    var o = this;
    this._insertTag = function(c) {
      var E;
      o.tags.length === 0 ? o.insertionPoint ? E = o.insertionPoint.nextSibling : o.prepend ? E = o.container.firstChild : E = o.before : E = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(c, E), o.tags.push(c);
    }, this.isSpeedy = s.speedy === void 0 ? !1 : s.speedy, this.tags = [], this.ctr = 0, this.nonce = s.nonce, this.key = s.key, this.container = s.container, this.prepend = s.prepend, this.insertionPoint = s.insertionPoint, this.before = null;
  }
  var a = n.prototype;
  return a.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, a.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(B6(this));
    var c = this.tags[this.tags.length - 1];
    {
      var E = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      E && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !E;
    }
    if (this.isSpeedy) {
      var u = H6(c);
      try {
        u.insertRule(o, u.cssRules.length);
      } catch (R) {
        /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) || console.error('There was a problem inserting the following rule: "' + o + '"', R);
      }
    } else
      c.appendChild(document.createTextNode(o));
    this.ctr++;
  }, a.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, this._alreadyInsertedOrderInsensitiveRule = !1;
  }, n;
}(), Xn = "-ms-", nT = "-moz-", ft = "-webkit-", $S = "comm", eh = "rule", th = "decl", Y6 = "@import", IL = "@keyframes", V6 = "@layer", W6 = Math.abs, IT = String.fromCharCode, k6 = Object.assign;
function X6(n, a) {
  return Un(n, 0) ^ 45 ? (((a << 2 ^ Un(n, 0)) << 2 ^ Un(n, 1)) << 2 ^ Un(n, 2)) << 2 ^ Un(n, 3) : 0;
}
function _L(n) {
  return n.trim();
}
function j6(n, a) {
  return (n = a.exec(n)) ? n[0] : n;
}
function Tt(n, a, s) {
  return n.replace(a, s);
}
function IS(n, a) {
  return n.indexOf(a);
}
function Un(n, a) {
  return n.charCodeAt(a) | 0;
}
function Qu(n, a, s) {
  return n.slice(a, s);
}
function _a(n) {
  return n.length;
}
function nh(n) {
  return n.length;
}
function Hf(n, a) {
  return a.push(n), n;
}
function K6(n, a) {
  return n.map(a).join("");
}
var _T = 1, zo = 1, CL = 0, Tr = 0, $t = 0, $o = "";
function CT(n, a, s, o, c, E, u) {
  return { value: n, root: a, parent: s, type: o, props: c, children: E, line: _T, column: zo, length: u, return: "" };
}
function Ju(n, a) {
  return k6(CT("", null, null, "", null, null, 0), n, { length: -n.length }, a);
}
function J6() {
  return $t;
}
function z6() {
  return $t = Tr > 0 ? Un($o, --Tr) : 0, zo--, $t === 10 && (zo = 1, _T--), $t;
}
function vr() {
  return $t = Tr < CL ? Un($o, Tr++) : 0, zo++, $t === 10 && (zo = 1, _T++), $t;
}
function ma() {
  return Un($o, Tr);
}
function kf() {
  return Tr;
}
function dE(n, a) {
  return Qu($o, n, a);
}
function $u(n) {
  switch (n) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function mL(n) {
  return _T = zo = 1, CL = _a($o = n), Tr = 0, [];
}
function vL(n) {
  return $o = "", n;
}
function Xf(n) {
  return _L(dE(Tr - 1, _S(n === 91 ? n + 2 : n === 40 ? n + 1 : n)));
}
function Z6(n) {
  for (; ($t = ma()) && $t < 33; )
    vr();
  return $u(n) > 2 || $u($t) > 3 ? "" : " ";
}
function q6(n, a) {
  for (; --a && vr() && !($t < 48 || $t > 102 || $t > 57 && $t < 65 || $t > 70 && $t < 97); )
    ;
  return dE(n, kf() + (a < 6 && ma() == 32 && vr() == 32));
}
function _S(n) {
  for (; vr(); )
    switch ($t) {
      case n:
        return Tr;
      case 34:
      case 39:
        n !== 34 && n !== 39 && _S($t);
        break;
      case 40:
        n === 41 && _S(n);
        break;
      case 92:
        vr();
        break;
    }
  return Tr;
}
function Q6(n, a) {
  for (; vr() && n + $t !== 47 + 10; )
    if (n + $t === 42 + 42 && ma() === 47)
      break;
  return "/*" + dE(a, Tr - 1) + "*" + IT(n === 47 ? n : vr());
}
function $6(n) {
  for (; !$u(ma()); )
    vr();
  return dE(n, Tr);
}
function eB(n) {
  return vL(jf("", null, null, null, [""], n = mL(n), 0, [0], n));
}
function jf(n, a, s, o, c, E, u, R, d) {
  for (var T = 0, S = 0, N = u, m = 0, v = 0, M = 0, w = 1, y = 1, O = 1, g = 0, V = "", D = c, G = E, P = o, U = V; y; )
    switch (M = g, g = vr()) {
      case 40:
        if (M != 108 && Un(U, N - 1) == 58) {
          IS(U += Tt(Xf(g), "&", "&\f"), "&\f") != -1 && (O = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        U += Xf(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        U += Z6(M);
        break;
      case 92:
        U += q6(kf() - 1, 7);
        continue;
      case 47:
        switch (ma()) {
          case 42:
          case 47:
            Hf(tB(Q6(vr(), kf()), a, s), d);
            break;
          default:
            U += "/";
        }
        break;
      case 123 * w:
        R[T++] = _a(U) * O;
      case 125 * w:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            y = 0;
          case 59 + S:
            O == -1 && (U = Tt(U, /\f/g, "")), v > 0 && _a(U) - N && Hf(v > 32 ? Gm(U + ";", o, s, N - 1) : Gm(Tt(U, " ", "") + ";", o, s, N - 2), d);
            break;
          case 59:
            U += ";";
          default:
            if (Hf(P = wm(U, a, s, T, S, c, R, V, D = [], G = [], N), E), g === 123)
              if (S === 0)
                jf(U, a, P, P, D, E, N, R, G);
              else
                switch (m === 99 && Un(U, 3) === 110 ? 100 : m) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    jf(n, P, P, o && Hf(wm(n, P, P, 0, 0, c, R, V, c, D = [], N), G), c, G, N, R, o ? D : G);
                    break;
                  default:
                    jf(U, P, P, P, [""], G, 0, R, G);
                }
        }
        T = S = v = 0, w = O = 1, V = U = "", N = u;
        break;
      case 58:
        N = 1 + _a(U), v = M;
      default:
        if (w < 1) {
          if (g == 123)
            --w;
          else if (g == 125 && w++ == 0 && z6() == 125)
            continue;
        }
        switch (U += IT(g), g * w) {
          case 38:
            O = S > 0 ? 1 : (U += "\f", -1);
            break;
          case 44:
            R[T++] = (_a(U) - 1) * O, O = 1;
            break;
          case 64:
            ma() === 45 && (U += Xf(vr())), m = ma(), S = N = _a(V = U += $6(kf())), g++;
            break;
          case 45:
            M === 45 && _a(U) == 2 && (w = 0);
        }
    }
  return E;
}
function wm(n, a, s, o, c, E, u, R, d, T, S) {
  for (var N = c - 1, m = c === 0 ? E : [""], v = nh(m), M = 0, w = 0, y = 0; M < o; ++M)
    for (var O = 0, g = Qu(n, N + 1, N = W6(w = u[M])), V = n; O < v; ++O)
      (V = _L(w > 0 ? m[O] + " " + g : Tt(g, /&\f/g, m[O]))) && (d[y++] = V);
  return CT(n, a, s, c === 0 ? eh : R, d, T, S);
}
function tB(n, a, s) {
  return CT(n, a, s, $S, IT(J6()), Qu(n, 2, -2), 0);
}
function Gm(n, a, s, o) {
  return CT(n, a, s, th, Qu(n, 0, o), Qu(n, o + 1, -1), o);
}
function jo(n, a) {
  for (var s = "", o = nh(n), c = 0; c < o; c++)
    s += a(n[c], c, n, a) || "";
  return s;
}
function nB(n, a, s, o) {
  switch (n.type) {
    case V6:
      if (n.children.length)
        break;
    case Y6:
    case th:
      return n.return = n.return || n.value;
    case $S:
      return "";
    case IL:
      return n.return = n.value + "{" + jo(n.children, o) + "}";
    case eh:
      n.value = n.props.join(",");
  }
  return _a(s = jo(n.children, o)) ? n.return = n.value + "{" + s + "}" : "";
}
function rB(n) {
  var a = nh(n);
  return function(s, o, c, E) {
    for (var u = "", R = 0; R < a; R++)
      u += n[R](s, o, c, E) || "";
    return u;
  };
}
function aB(n) {
  var a = /* @__PURE__ */ Object.create(null);
  return function(s) {
    return a[s] === void 0 && (a[s] = n(s)), a[s];
  };
}
var iB = function(a, s, o) {
  for (var c = 0, E = 0; c = E, E = ma(), c === 38 && E === 12 && (s[o] = 1), !$u(E); )
    vr();
  return dE(a, Tr);
}, sB = function(a, s) {
  var o = -1, c = 44;
  do
    switch ($u(c)) {
      case 0:
        c === 38 && ma() === 12 && (s[o] = 1), a[o] += iB(Tr - 1, s, o);
        break;
      case 2:
        a[o] += Xf(c);
        break;
      case 4:
        if (c === 44) {
          a[++o] = ma() === 58 ? "&\f" : "", s[o] = a[o].length;
          break;
        }
      default:
        a[o] += IT(c);
    }
  while (c = vr());
  return a;
}, oB = function(a, s) {
  return vL(sB(mL(a), s));
}, Hm = /* @__PURE__ */ new WeakMap(), lB = function(a) {
  if (!(a.type !== "rule" || !a.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  a.length < 1)) {
    for (var s = a.value, o = a.parent, c = a.column === o.column && a.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(a.props.length === 1 && s.charCodeAt(0) !== 58 && !Hm.get(o)) && !c) {
      Hm.set(a, !0);
      for (var E = [], u = oB(s, E), R = o.props, d = 0, T = 0; d < u.length; d++)
        for (var S = 0; S < R.length; S++, T++)
          a.props[T] = E[d] ? u[d].replace(/&\f/g, R[S]) : R[S] + " " + u[d];
    }
  }
}, uB = function(a) {
  if (a.type === "decl") {
    var s = a.value;
    // charcode for l
    s.charCodeAt(0) === 108 && // charcode for b
    s.charCodeAt(2) === 98 && (a.return = "", a.value = "");
  }
}, EB = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", cB = function(a) {
  return a.type === "comm" && a.children.indexOf(EB) > -1;
}, fB = function(a) {
  return function(s, o, c) {
    if (!(s.type !== "rule" || a.compat)) {
      var E = s.value.match(/(:first|:nth|:nth-last)-child/g);
      if (E) {
        for (var u = !!s.parent, R = u ? s.parent.children : (
          // global rule at the root level
          c
        ), d = R.length - 1; d >= 0; d--) {
          var T = R[d];
          if (T.line < s.line)
            break;
          if (T.column < s.column) {
            if (cB(T))
              return;
            break;
          }
        }
        E.forEach(function(S) {
          console.error('The pseudo class "' + S + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + S.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, LL = function(a) {
  return a.type.charCodeAt(1) === 105 && a.type.charCodeAt(0) === 64;
}, TB = function(a, s) {
  for (var o = a - 1; o >= 0; o--)
    if (!LL(s[o]))
      return !0;
  return !1;
}, Bm = function(a) {
  a.type = "", a.value = "", a.return = "", a.children = "", a.props = "";
}, dB = function(a, s, o) {
  LL(a) && (a.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Bm(a)) : TB(s, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Bm(a)));
};
function yL(n, a) {
  switch (X6(n, a)) {
    case 5103:
      return ft + "print-" + n + n;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ft + n + n;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ft + n + nT + n + Xn + n + n;
    case 6828:
    case 4268:
      return ft + n + Xn + n + n;
    case 6165:
      return ft + n + Xn + "flex-" + n + n;
    case 5187:
      return ft + n + Tt(n, /(\w+).+(:[^]+)/, ft + "box-$1$2" + Xn + "flex-$1$2") + n;
    case 5443:
      return ft + n + Xn + "flex-item-" + Tt(n, /flex-|-self/, "") + n;
    case 4675:
      return ft + n + Xn + "flex-line-pack" + Tt(n, /align-content|flex-|-self/, "") + n;
    case 5548:
      return ft + n + Xn + Tt(n, "shrink", "negative") + n;
    case 5292:
      return ft + n + Xn + Tt(n, "basis", "preferred-size") + n;
    case 6060:
      return ft + "box-" + Tt(n, "-grow", "") + ft + n + Xn + Tt(n, "grow", "positive") + n;
    case 4554:
      return ft + Tt(n, /([^-])(transform)/g, "$1" + ft + "$2") + n;
    case 6187:
      return Tt(Tt(Tt(n, /(zoom-|grab)/, ft + "$1"), /(image-set)/, ft + "$1"), n, "") + n;
    case 5495:
    case 3959:
      return Tt(n, /(image-set\([^]*)/, ft + "$1$`$1");
    case 4968:
      return Tt(Tt(n, /(.+:)(flex-)?(.*)/, ft + "box-pack:$3" + Xn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ft + n + n;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Tt(n, /(.+)-inline(.+)/, ft + "$1$2") + n;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (_a(n) - 1 - a > 6)
        switch (Un(n, a + 1)) {
          case 109:
            if (Un(n, a + 4) !== 45)
              break;
          case 102:
            return Tt(n, /(.+:)(.+)-([^]+)/, "$1" + ft + "$2-$3$1" + nT + (Un(n, a + 3) == 108 ? "$3" : "$2-$3")) + n;
          case 115:
            return ~IS(n, "stretch") ? yL(Tt(n, "stretch", "fill-available"), a) + n : n;
        }
      break;
    case 4949:
      if (Un(n, a + 1) !== 115)
        break;
    case 6444:
      switch (Un(n, _a(n) - 3 - (~IS(n, "!important") && 10))) {
        case 107:
          return Tt(n, ":", ":" + ft) + n;
        case 101:
          return Tt(n, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ft + (Un(n, 14) === 45 ? "inline-" : "") + "box$3$1" + ft + "$2$3$1" + Xn + "$2box$3") + n;
      }
      break;
    case 5936:
      switch (Un(n, a + 11)) {
        case 114:
          return ft + n + Xn + Tt(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
        case 108:
          return ft + n + Xn + Tt(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
        case 45:
          return ft + n + Xn + Tt(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
      }
      return ft + n + Xn + n + n;
  }
  return n;
}
var AB = function(a, s, o, c) {
  if (a.length > -1 && !a.return)
    switch (a.type) {
      case th:
        a.return = yL(a.value, a.length);
        break;
      case IL:
        return jo([Ju(a, {
          value: Tt(a.value, "@", "@" + ft)
        })], c);
      case eh:
        if (a.length)
          return K6(a.props, function(E) {
            switch (j6(E, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return jo([Ju(a, {
                  props: [Tt(E, /:(read-\w+)/, ":" + nT + "$1")]
                })], c);
              case "::placeholder":
                return jo([Ju(a, {
                  props: [Tt(E, /:(plac\w+)/, ":" + ft + "input-$1")]
                }), Ju(a, {
                  props: [Tt(E, /:(plac\w+)/, ":" + nT + "$1")]
                }), Ju(a, {
                  props: [Tt(E, /:(plac\w+)/, Xn + "input-$1")]
                })], c);
            }
            return "";
          });
    }
}, RB = [AB], pB = function(a) {
  var s = a.key;
  if (!s)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (s === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(w) {
      var y = w.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(w), w.setAttribute("data-s", ""));
    });
  }
  var c = a.stylisPlugins || RB;
  if (/[^a-z-]/.test(s))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + s + '" was passed');
  var E = {}, u, R = [];
  u = a.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + s + ' "]'),
    function(w) {
      for (var y = w.getAttribute("data-emotion").split(" "), O = 1; O < y.length; O++)
        E[y[O]] = !0;
      R.push(w);
    }
  );
  var d, T = [lB, uB];
  T.push(fB({
    get compat() {
      return M.compat;
    }
  }), dB);
  {
    var S, N = [nB, function(w) {
      w.root || (w.return ? S.insert(w.return) : w.value && w.type !== $S && S.insert(w.value + "{}"));
    }], m = rB(T.concat(c, N)), v = function(y) {
      return jo(eB(y), m);
    };
    d = function(y, O, g, V) {
      S = g, O.map !== void 0 && (S = {
        insert: function(G) {
          g.insert(G + O.map);
        }
      }), v(y ? y + "{" + O.styles + "}" : O.styles), V && (M.inserted[O.name] = !0);
    };
  }
  var M = {
    key: s,
    sheet: new F6({
      key: s,
      container: u,
      nonce: a.nonce,
      speedy: a.speedy,
      prepend: a.prepend,
      insertionPoint: a.insertionPoint
    }),
    nonce: a.nonce,
    inserted: E,
    registered: {},
    insert: d
  };
  return M.sheet.hydrate(R), M;
};
function SB(n) {
  for (var a = 0, s, o = 0, c = n.length; c >= 4; ++o, c -= 4)
    s = n.charCodeAt(o) & 255 | (n.charCodeAt(++o) & 255) << 8 | (n.charCodeAt(++o) & 255) << 16 | (n.charCodeAt(++o) & 255) << 24, s = /* Math.imul(k, m): */
    (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16), s ^= /* k >>> r: */
    s >>> 24, a = /* Math.imul(k, m): */
    (s & 65535) * 1540483477 + ((s >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16);
  switch (c) {
    case 3:
      a ^= (n.charCodeAt(o + 2) & 255) << 16;
    case 2:
      a ^= (n.charCodeAt(o + 1) & 255) << 8;
    case 1:
      a ^= n.charCodeAt(o) & 255, a = /* Math.imul(h, m): */
      (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16);
  }
  return a ^= a >>> 13, a = /* Math.imul(h, m): */
  (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16), ((a ^ a >>> 15) >>> 0).toString(36);
}
var hB = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Fm = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, NB = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", OB = /[A-Z]|^ms/g, gL = /_EMO_([^_]+?)_([^]*?)_EMO_/g, rh = function(a) {
  return a.charCodeAt(1) === 45;
}, Ym = function(a) {
  return a != null && typeof a != "boolean";
}, uS = /* @__PURE__ */ aB(function(n) {
  return rh(n) ? n : n.replace(OB, "-$&").toLowerCase();
}), rT = function(a, s) {
  switch (a) {
    case "animation":
    case "animationName":
      if (typeof s == "string")
        return s.replace(gL, function(o, c, E) {
          return Ca = {
            name: c,
            styles: E,
            next: Ca
          }, c;
        });
  }
  return hB[a] !== 1 && !rh(a) && typeof s == "number" && s !== 0 ? s + "px" : s;
};
{
  var IB = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, _B = ["normal", "none", "initial", "inherit", "unset"], CB = rT, mB = /^-ms-/, vB = /-(.)/g, Vm = {};
  rT = function(a, s) {
    if (a === "content" && (typeof s != "string" || _B.indexOf(s) === -1 && !IB.test(s) && (s.charAt(0) !== s.charAt(s.length - 1) || s.charAt(0) !== '"' && s.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + s + "\"'`");
    var o = CB(a, s);
    return o !== "" && !rh(a) && a.indexOf("-") !== -1 && Vm[a] === void 0 && (Vm[a] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + a.replace(mB, "ms-").replace(vB, function(c, E) {
      return E.toUpperCase();
    }) + "?")), o;
  };
}
var DL = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function eE(n, a, s) {
  if (s == null)
    return "";
  if (s.__emotion_styles !== void 0) {
    if (s.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(DL);
    return s;
  }
  switch (typeof s) {
    case "boolean":
      return "";
    case "object": {
      if (s.anim === 1)
        return Ca = {
          name: s.name,
          styles: s.styles,
          next: Ca
        }, s.name;
      if (s.styles !== void 0) {
        var o = s.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Ca = {
              name: o.name,
              styles: o.styles,
              next: Ca
            }, o = o.next;
        var c = s.styles + ";";
        return s.map !== void 0 && (c += s.map), c;
      }
      return LB(n, a, s);
    }
    case "function": {
      if (n !== void 0) {
        var E = Ca, u = s(n);
        return Ca = E, eE(n, a, u);
      } else
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      {
        var R = [], d = s.replace(gL, function(S, N, m) {
          var v = "animation" + R.length;
          return R.push("const " + v + " = keyframes`" + m.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + v + "}";
        });
        R.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(R, ["`" + d + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + d + "`"));
      }
      break;
  }
  if (a == null)
    return s;
  var T = a[s];
  return T !== void 0 ? T : s;
}
function LB(n, a, s) {
  var o = "";
  if (Array.isArray(s))
    for (var c = 0; c < s.length; c++)
      o += eE(n, a, s[c]) + ";";
  else
    for (var E in s) {
      var u = s[E];
      if (typeof u != "object")
        a != null && a[u] !== void 0 ? o += E + "{" + a[u] + "}" : Ym(u) && (o += uS(E) + ":" + rT(E, u) + ";");
      else {
        if (E === "NO_COMPONENT_SELECTOR")
          throw new Error(DL);
        if (Array.isArray(u) && typeof u[0] == "string" && (a == null || a[u[0]] === void 0))
          for (var R = 0; R < u.length; R++)
            Ym(u[R]) && (o += uS(E) + ":" + rT(E, u[R]) + ";");
        else {
          var d = eE(n, a, u);
          switch (E) {
            case "animation":
            case "animationName": {
              o += uS(E) + ":" + d + ";";
              break;
            }
            default:
              E === "undefined" && console.error(NB), o += E + "{" + d + "}";
          }
        }
      }
    }
  return o;
}
var Wm = /label:\s*([^\s;\n{]+)\s*(;|$)/g, bL;
bL = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
var Ca, ES = function(a, s, o) {
  if (a.length === 1 && typeof a[0] == "object" && a[0] !== null && a[0].styles !== void 0)
    return a[0];
  var c = !0, E = "";
  Ca = void 0;
  var u = a[0];
  u == null || u.raw === void 0 ? (c = !1, E += eE(o, s, u)) : (u[0] === void 0 && console.error(Fm), E += u[0]);
  for (var R = 1; R < a.length; R++)
    E += eE(o, s, a[R]), c && (u[R] === void 0 && console.error(Fm), E += u[R]);
  var d;
  E = E.replace(bL, function(m) {
    return d = m, "";
  }), Wm.lastIndex = 0;
  for (var T = "", S; (S = Wm.exec(E)) !== null; )
    T += "-" + // $FlowFixMe we know it's not null
    S[1];
  var N = SB(E) + T;
  return {
    name: N,
    styles: E,
    map: d,
    next: Ca,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  };
}, yB = !0;
function ML(n, a, s) {
  var o = "";
  return s.split(" ").forEach(function(c) {
    n[c] !== void 0 ? a.push(n[c] + ";") : o += c + " ";
  }), o;
}
var gB = function(a, s, o) {
  var c = a.key + "-" + s.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  yB === !1) && a.registered[c] === void 0 && (a.registered[c] = s.styles);
}, DB = function(a, s, o) {
  gB(a, s, o);
  var c = a.key + "-" + s.name;
  if (a.inserted[s.name] === void 0) {
    var E = s;
    do
      a.insert(s === E ? "." + c : "", E, a.sheet, !0), E = E.next;
    while (E !== void 0);
  }
};
function km(n, a) {
  if (n.inserted[a.name] === void 0)
    return n.insert("", a, n.sheet, !0);
}
function Xm(n, a, s) {
  var o = [], c = ML(n, o, s);
  return o.length < 2 ? s : c + a(o);
}
var bB = function(a) {
  var s = pB(a);
  s.sheet.speedy = function(R) {
    if (this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = R;
  }, s.compat = !0;
  var o = function() {
    for (var d = arguments.length, T = new Array(d), S = 0; S < d; S++)
      T[S] = arguments[S];
    var N = ES(T, s.registered, void 0);
    return DB(s, N, !1), s.key + "-" + N.name;
  }, c = function() {
    for (var d = arguments.length, T = new Array(d), S = 0; S < d; S++)
      T[S] = arguments[S];
    var N = ES(T, s.registered), m = "animation-" + N.name;
    return km(s, {
      name: N.name,
      styles: "@keyframes " + m + "{" + N.styles + "}"
    }), m;
  }, E = function() {
    for (var d = arguments.length, T = new Array(d), S = 0; S < d; S++)
      T[S] = arguments[S];
    var N = ES(T, s.registered);
    km(s, N);
  }, u = function() {
    for (var d = arguments.length, T = new Array(d), S = 0; S < d; S++)
      T[S] = arguments[S];
    return Xm(s.registered, o, MB(T));
  };
  return {
    css: o,
    cx: u,
    injectGlobal: E,
    keyframes: c,
    hydrate: function(d) {
      d.forEach(function(T) {
        s.inserted[T] = !0;
      });
    },
    flush: function() {
      s.registered = {}, s.inserted = {}, s.sheet.flush();
    },
    // $FlowFixMe
    sheet: s.sheet,
    cache: s,
    getRegisteredStyles: ML.bind(null, s.registered),
    merge: Xm.bind(null, s.registered, o)
  };
}, MB = function n(a) {
  for (var s = "", o = 0; o < a.length; o++) {
    var c = a[o];
    if (c != null) {
      var E = void 0;
      switch (typeof c) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(c))
            E = n(c);
          else {
            E = "";
            for (var u in c)
              c[u] && u && (E && (E += " "), E += u);
          }
          break;
        }
        default:
          E = c;
      }
      E && (s && (s += " "), s += E);
    }
  }
  return s;
};
const PB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bB
}, Symbol.toStringTag, { value: "Module" })), UB = /* @__PURE__ */ zm(PB);
var xB = Yt && Yt.__rest || function(n, a) {
  var s = {};
  for (var o in n)
    Object.prototype.hasOwnProperty.call(n, o) && a.indexOf(o) < 0 && (s[o] = n[o]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var c = 0, o = Object.getOwnPropertySymbols(n); c < o.length; c++)
      a.indexOf(o[c]) < 0 && Object.prototype.propertyIsEnumerable.call(n, o[c]) && (s[o[c]] = n[o[c]]);
  return s;
}, wB = Yt && Yt.__importDefault || function(n) {
  return n && n.__esModule ? n : { default: n };
};
Object.defineProperty(QS, "__esModule", { value: !0 });
const GB = wB(UB);
QS.default = (n, a = !1, s = "") => {
  const { variables: o = {} } = n, c = xB(n, ["variables"]), E = {
    light: Object.assign({
      diffViewerBackground: "#fff",
      diffViewerColor: "#212529",
      addedBackground: "#e6ffed",
      addedColor: "#24292e",
      removedBackground: "#ffeef0",
      removedColor: "#24292e",
      changedBackground: "#fffbdd",
      wordAddedBackground: "#acf2bd",
      wordRemovedBackground: "#fdb8c0",
      addedGutterBackground: "#cdffd8",
      removedGutterBackground: "#ffdce0",
      gutterBackground: "#f7f7f7",
      gutterBackgroundDark: "#f3f1f1",
      highlightBackground: "#fffbdd",
      highlightGutterBackground: "#fff5b1",
      codeFoldGutterBackground: "#dbedff",
      codeFoldBackground: "#f1f8ff",
      emptyLineBackground: "#fafbfc",
      gutterColor: "#212529",
      addedGutterColor: "#212529",
      removedGutterColor: "#212529",
      codeFoldContentColor: "#212529",
      diffViewerTitleBackground: "#fafbfc",
      diffViewerTitleColor: "#212529",
      diffViewerTitleBorderColor: "#eee"
    }, o.light || {}),
    dark: Object.assign({
      diffViewerBackground: "#2e303c",
      diffViewerColor: "#FFF",
      addedBackground: "#044B53",
      addedColor: "white",
      removedBackground: "#632F34",
      removedColor: "white",
      changedBackground: "#3e302c",
      wordAddedBackground: "#055d67",
      wordRemovedBackground: "#7d383f",
      addedGutterBackground: "#034148",
      removedGutterBackground: "#632b30",
      gutterBackground: "#2c2f3a",
      gutterBackgroundDark: "#262933",
      highlightBackground: "#2a3967",
      highlightGutterBackground: "#2d4077",
      codeFoldGutterBackground: "#21232b",
      codeFoldBackground: "#262831",
      emptyLineBackground: "#363946",
      gutterColor: "#666c87",
      addedGutterColor: "#8c8c8c",
      removedGutterColor: "#8c8c8c",
      codeFoldContentColor: "#656a8b",
      diffViewerTitleBackground: "#2f323e",
      diffViewerTitleColor: "#555a7b",
      diffViewerTitleBorderColor: "#353846"
    }, o.dark || {})
  }, u = a ? E.dark : E.light, { css: R, cx: d } = (0, GB.default)({ key: "react-diff", nonce: s }), T = R({
    width: "100%",
    label: "content"
  }), S = R({
    [`.${T}`]: {
      width: "50%"
    },
    label: "split-view"
  }), N = R({
    width: "100%",
    background: u.diffViewerBackground,
    pre: {
      margin: 0,
      whiteSpace: "pre-wrap",
      lineHeight: "25px"
    },
    label: "diff-container",
    borderCollapse: "collapse"
  }), m = R({
    color: u.codeFoldContentColor,
    label: "code-fold-content"
  }), v = R({
    color: u.diffViewerColor,
    label: "content-text"
  }), M = R({
    background: u.diffViewerTitleBackground,
    padding: 10,
    borderBottom: `1px solid ${u.diffViewerTitleBorderColor}`,
    label: "title-block",
    ":last-child": {
      borderLeft: `1px solid ${u.diffViewerTitleBorderColor}`
    },
    [`.${v}`]: {
      color: u.diffViewerTitleColor
    }
  }), w = R({
    color: u.gutterColor,
    label: "line-number"
  }), y = R({
    background: u.removedBackground,
    color: u.removedColor,
    pre: {
      color: u.removedColor
    },
    [`.${w}`]: {
      color: u.removedGutterColor
    },
    label: "diff-removed"
  }), O = R({
    background: u.addedBackground,
    color: u.addedColor,
    pre: {
      color: u.addedColor
    },
    [`.${w}`]: {
      color: u.addedGutterColor
    },
    label: "diff-added"
  }), g = R({
    background: u.changedBackground,
    [`.${w}`]: {
      color: u.gutterColor
    },
    label: "diff-changed"
  }), V = R({
    padding: 2,
    display: "inline-flex",
    borderRadius: 4,
    wordBreak: "break-all",
    label: "word-diff"
  }), D = R({
    background: u.wordAddedBackground,
    label: "word-added"
  }), G = R({
    background: u.wordRemovedBackground,
    label: "word-removed"
  }), P = R({
    backgroundColor: u.codeFoldGutterBackground,
    label: "code-fold-gutter"
  }), U = R({
    backgroundColor: u.codeFoldBackground,
    height: 40,
    fontSize: 14,
    fontWeight: 700,
    label: "code-fold",
    a: {
      textDecoration: "underline !important",
      cursor: "pointer",
      pre: {
        display: "inline"
      }
    }
  }), Y = R({
    backgroundColor: u.emptyLineBackground,
    label: "empty-line"
  }), X = R({
    width: 25,
    paddingLeft: 10,
    paddingRight: 10,
    userSelect: "none",
    label: "marker",
    [`&.${O}`]: {
      pre: {
        color: u.addedColor
      }
    },
    [`&.${y}`]: {
      pre: {
        color: u.removedColor
      }
    }
  }), _ = R({
    background: u.highlightBackground,
    label: "highlighted-line",
    [`.${D}, .${G}`]: {
      backgroundColor: "initial"
    }
  }), F = R({
    label: "highlighted-gutter"
  }), j = R({
    userSelect: "none",
    minWidth: 50,
    padding: "0 10px",
    whiteSpace: "nowrap",
    label: "gutter",
    textAlign: "right",
    background: u.gutterBackground,
    "&:hover": {
      cursor: "pointer",
      background: u.gutterBackgroundDark,
      pre: {
        opacity: 1
      }
    },
    pre: {
      opacity: 0.5
    },
    [`&.${O}`]: {
      background: u.addedGutterBackground
    },
    [`&.${y}`]: {
      background: u.removedGutterBackground
    },
    [`&.${F}`]: {
      background: u.highlightGutterBackground,
      "&:hover": {
        background: u.highlightGutterBackground
      }
    }
  }), z = R({
    "&:hover": {
      background: u.gutterBackground,
      cursor: "initial"
    },
    label: "empty-gutter"
  }), Z = R({
    verticalAlign: "baseline",
    label: "line"
  }), ee = {
    diffContainer: N,
    diffRemoved: y,
    diffAdded: O,
    diffChanged: g,
    splitView: S,
    marker: X,
    highlightedGutter: F,
    highlightedLine: _,
    gutter: j,
    line: Z,
    wordDiff: V,
    wordAdded: D,
    wordRemoved: G,
    codeFoldGutter: P,
    codeFold: U,
    emptyGutter: z,
    emptyLine: Y,
    lineNumber: w,
    contentText: v,
    content: T,
    codeFoldContent: m,
    titleBlock: M
  }, oe = Object.keys(c).reduce((ne, de) => Object.assign(Object.assign({}, ne), {
    [de]: R(c[de])
  }), {});
  return Object.keys(ee).reduce((ne, de) => Object.assign(Object.assign({}, ne), {
    [de]: oe[de] ? d(ee[de], oe[de]) : ee[de]
  }), {});
};
var mT = {};
Object.defineProperty(mT, "__esModule", { value: !0 });
mT.computeHiddenBlocks = void 0;
function HB(n, a, s) {
  let o = 0, c, E = {}, u = [];
  return n.forEach((R, d) => {
    const T = a.some((S) => S >= d - s && S <= d + s);
    !T && c == null ? (c = {
      index: o,
      startLine: d,
      endLine: d,
      lines: 1
    }, u.push(c), E[d] = c.index, o++) : T ? c = void 0 : (c.endLine = d, c.lines++, E[d] = c.index);
  }), {
    lineBlocks: E,
    blocks: u
  };
}
mT.computeHiddenBlocks = HB;
var jm = Number.isNaN || function(a) {
  return typeof a == "number" && a !== a;
};
function BB(n, a) {
  return !!(n === a || jm(n) && jm(a));
}
function FB(n, a) {
  if (n.length !== a.length)
    return !1;
  for (var s = 0; s < n.length; s++)
    if (!BB(n[s], a[s]))
      return !1;
  return !0;
}
function YB(n, a) {
  a === void 0 && (a = FB);
  var s = null;
  function o() {
    for (var c = [], E = 0; E < arguments.length; E++)
      c[E] = arguments[E];
    if (s && s.lastThis === this && a(c, s.lastArgs))
      return s.lastResult;
    var u = n.apply(this, c);
    return s = {
      lastResult: u,
      lastArgs: c,
      lastThis: this
    }, u;
  }
  return o.clear = function() {
    s = null;
  }, o;
}
const VB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: YB
}, Symbol.toStringTag, { value: "Module" })), WB = /* @__PURE__ */ zm(VB);
(function(n) {
  var a = Yt && Yt.__createBinding || (Object.create ? function(w, y, O, g) {
    g === void 0 && (g = O);
    var V = Object.getOwnPropertyDescriptor(y, O);
    (!V || ("get" in V ? !y.__esModule : V.writable || V.configurable)) && (V = { enumerable: !0, get: function() {
      return y[O];
    } }), Object.defineProperty(w, g, V);
  } : function(w, y, O, g) {
    g === void 0 && (g = O), w[g] = y[O];
  }), s = Yt && Yt.__setModuleDefault || (Object.create ? function(w, y) {
    Object.defineProperty(w, "default", { enumerable: !0, value: y });
  } : function(w, y) {
    w.default = y;
  }), o = Yt && Yt.__importStar || function(w) {
    if (w && w.__esModule)
      return w;
    var y = {};
    if (w != null)
      for (var O in w)
        O !== "default" && Object.prototype.hasOwnProperty.call(w, O) && a(y, w, O);
    return s(y, w), y;
  }, c = Yt && Yt.__importDefault || function(w) {
    return w && w.__esModule ? w : { default: w };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.DiffMethod = n.LineNumberPrefix = void 0;
  const E = p, u = o(x), R = c(UH), d = Wi;
  Object.defineProperty(n, "DiffMethod", { enumerable: !0, get: function() {
    return d.DiffMethod;
  } });
  const T = c(QS), S = mT, N = WB, m = N.default || N;
  var v;
  (function(w) {
    w.LEFT = "L", w.RIGHT = "R";
  })(v || (n.LineNumberPrefix = v = {}));
  class M extends u.Component {
    constructor(y) {
      super(y), this.resetCodeBlocks = () => this.state.expandedBlocks.length > 0 ? (this.setState({
        expandedBlocks: []
      }), !0) : !1, this.onBlockExpand = (O) => {
        const g = this.state.expandedBlocks.slice();
        g.push(O), this.setState({
          expandedBlocks: g
        });
      }, this.computeStyles = m(T.default), this.onLineNumberClickProxy = (O) => this.props.onLineNumberClick ? (g) => this.props.onLineNumberClick(O, g) : () => {
      }, this.renderWordDiff = (O, g) => O.map((V, D) => (0, E.jsx)("span", { className: (0, R.default)(this.styles.wordDiff, {
        [this.styles.wordAdded]: V.type === d.DiffType.ADDED,
        [this.styles.wordRemoved]: V.type === d.DiffType.REMOVED
      }), children: g ? g(V.value) : V.value }, D)), this.renderLine = (O, g, V, D, G, P) => {
        const U = `${V}-${O}`, Y = `${P}-${G}`, X = this.props.highlightLines.includes(U) || this.props.highlightLines.includes(Y), _ = g === d.DiffType.ADDED, F = g === d.DiffType.REMOVED, j = g === d.DiffType.CHANGED;
        let z;
        return Array.isArray(D) ? z = this.renderWordDiff(D, this.props.renderContent) : this.props.renderContent ? z = this.props.renderContent(D) : z = D, (0, E.jsxs)(u.Fragment, { children: [!this.props.hideLineNumbers && (0, E.jsx)("td", { onClick: O && this.onLineNumberClickProxy(U), className: (0, R.default)(this.styles.gutter, {
          [this.styles.emptyGutter]: !O,
          [this.styles.diffAdded]: _,
          [this.styles.diffRemoved]: F,
          [this.styles.diffChanged]: j,
          [this.styles.highlightedGutter]: X
        }), children: (0, E.jsx)("pre", { className: this.styles.lineNumber, children: O }) }), !this.props.splitView && !this.props.hideLineNumbers && (0, E.jsx)("td", { onClick: G && this.onLineNumberClickProxy(Y), className: (0, R.default)(this.styles.gutter, {
          [this.styles.emptyGutter]: !G,
          [this.styles.diffAdded]: _,
          [this.styles.diffRemoved]: F,
          [this.styles.diffChanged]: j,
          [this.styles.highlightedGutter]: X
        }), children: (0, E.jsx)("pre", { className: this.styles.lineNumber, children: G }) }), this.props.renderGutter ? this.props.renderGutter({
          lineNumber: O,
          type: g,
          prefix: V,
          value: D,
          additionalLineNumber: G,
          additionalPrefix: P,
          styles: this.styles
        }) : null, !this.props.hideMarkers && (0, E.jsx)("td", { className: (0, R.default)(this.styles.marker, {
          [this.styles.emptyLine]: !z,
          [this.styles.diffAdded]: _,
          [this.styles.diffRemoved]: F,
          [this.styles.diffChanged]: j,
          [this.styles.highlightedLine]: X
        }), children: (0, E.jsxs)("pre", { children: [_ && "+", F && "-"] }) }), (0, E.jsx)("td", { className: (0, R.default)(this.styles.content, {
          [this.styles.emptyLine]: !z,
          [this.styles.diffAdded]: _,
          [this.styles.diffRemoved]: F,
          [this.styles.diffChanged]: j,
          [this.styles.highlightedLine]: X
        }), children: (0, E.jsx)("pre", { className: this.styles.contentText, children: z }) })] });
      }, this.renderSplitView = ({ left: O, right: g }, V) => (0, E.jsxs)("tr", { className: this.styles.line, children: [this.renderLine(O.lineNumber, O.type, v.LEFT, O.value), this.renderLine(g.lineNumber, g.type, v.RIGHT, g.value)] }, V), this.renderInlineView = ({ left: O, right: g }, V) => {
        let D;
        return O.type === d.DiffType.REMOVED && g.type === d.DiffType.ADDED ? (0, E.jsxs)(u.Fragment, { children: [(0, E.jsx)("tr", { className: this.styles.line, children: this.renderLine(O.lineNumber, O.type, v.LEFT, O.value, null) }), (0, E.jsx)("tr", { className: this.styles.line, children: this.renderLine(null, g.type, v.RIGHT, g.value, g.lineNumber) })] }, V) : (O.type === d.DiffType.REMOVED && (D = this.renderLine(O.lineNumber, O.type, v.LEFT, O.value, null)), O.type === d.DiffType.DEFAULT && (D = this.renderLine(O.lineNumber, O.type, v.LEFT, O.value, g.lineNumber, v.RIGHT)), g.type === d.DiffType.ADDED && (D = this.renderLine(null, g.type, v.RIGHT, g.value, g.lineNumber)), (0, E.jsx)("tr", { className: this.styles.line, children: D }, V));
      }, this.onBlockClickProxy = (O) => () => this.onBlockExpand(O), this.renderSkippedLineIndicator = (O, g, V, D) => {
        const { hideLineNumbers: G, splitView: P } = this.props, U = this.props.codeFoldMessageRenderer ? this.props.codeFoldMessageRenderer(O, V, D) : (0, E.jsxs)("pre", { className: this.styles.codeFoldContent, children: ["Expand ", O, " lines ..."] }), Y = (0, E.jsx)("td", { children: (0, E.jsx)("a", { onClick: this.onBlockClickProxy(g), tabIndex: 0, children: U }) }), X = !P && !G;
        return (0, E.jsxs)("tr", { className: this.styles.codeFold, children: [!G && (0, E.jsx)("td", { className: this.styles.codeFoldGutter }), this.props.renderGutter ? (0, E.jsx)("td", { className: this.styles.codeFoldGutter }) : null, (0, E.jsx)("td", { className: (0, R.default)({
          [this.styles.codeFoldGutter]: X
        }) }), X ? (0, E.jsxs)(u.Fragment, { children: [(0, E.jsx)("td", {}), Y] }) : (0, E.jsxs)(u.Fragment, { children: [Y, this.props.renderGutter ? (0, E.jsx)("td", {}) : null, (0, E.jsx)("td", {})] }), (0, E.jsx)("td", {}), (0, E.jsx)("td", {})] }, `${V}-${D}`);
      }, this.renderDiff = () => {
        const { oldValue: O, newValue: g, splitView: V, disableWordDiff: D, compareMethod: G, linesOffset: P } = this.props, { lineInformation: U, diffLines: Y } = (0, d.computeLineInformation)(O, g, D, G, P, this.props.alwaysShowLines), X = this.props.extraLinesSurroundingDiff < 0 ? 0 : Math.round(this.props.extraLinesSurroundingDiff), { lineBlocks: _, blocks: F } = (0, S.computeHiddenBlocks)(U, Y, X);
        return U.map((j, z) => {
          if (this.props.showDiffOnly) {
            const ee = _[z];
            if (ee !== void 0) {
              const oe = F[ee].endLine === z;
              if (!this.state.expandedBlocks.includes(ee) && oe)
                return (0, E.jsx)(u.Fragment, { children: this.renderSkippedLineIndicator(F[ee].lines, ee, j.left.lineNumber, j.right.lineNumber) }, z);
              if (!this.state.expandedBlocks.includes(ee))
                return null;
            }
          }
          return V ? this.renderSplitView(j, z) : this.renderInlineView(j, z);
        });
      }, this.render = () => {
        const { oldValue: O, newValue: g, useDarkTheme: V, leftTitle: D, rightTitle: G, splitView: P, hideLineNumbers: U, hideMarkers: Y, nonce: X } = this.props;
        if (this.props.compareMethod !== d.DiffMethod.JSON && (typeof O != "string" || typeof g != "string"))
          throw Error('"oldValue" and "newValue" should be strings');
        this.styles = this.computeStyles(this.props.styles, V, X);
        const _ = this.renderDiff();
        let F = U ? 2 : 3, j = U ? 2 : 4;
        Y && (F -= 1, j -= 1);
        const z = this.props.renderGutter ? 1 : 0, Z = (D || G) && (0, E.jsxs)("tr", { children: [(0, E.jsx)("td", { colSpan: (P ? F : j) + z, className: this.styles.titleBlock, children: (0, E.jsx)("pre", { className: this.styles.contentText, children: D }) }), P && (0, E.jsx)("td", { colSpan: F + z, className: this.styles.titleBlock, children: (0, E.jsx)("pre", { className: this.styles.contentText, children: G }) })] });
        return (0, E.jsx)("table", { className: (0, R.default)(this.styles.diffContainer, {
          [this.styles.splitView]: P
        }), children: (0, E.jsxs)("tbody", { children: [Z, _] }) });
      }, this.state = {
        expandedBlocks: []
      };
    }
  }
  M.defaultProps = {
    oldValue: "",
    newValue: "",
    splitView: !0,
    highlightLines: [],
    disableWordDiff: !1,
    compareMethod: d.DiffMethod.CHARS,
    styles: {},
    hideLineNumbers: !1,
    hideMarkers: !1,
    extraLinesSurroundingDiff: 3,
    showDiffOnly: !0,
    useDarkTheme: !1,
    linesOffset: 0,
    nonce: ""
  }, n.default = M;
})(jS);
const kB = /* @__PURE__ */ Xi(jS), PL = typeof window < "u", tr = PL ? window : null;
function XB() {
  const [n, a] = x.useState(""), [s, o] = x.useState(""), [c, E] = x.useState(!1), u = tr == null ? void 0 : tr.BUILDER_HYDRATION_OVERLAY.ERROR, R = tr == null ? void 0 : tr.BUILDER_HYDRATION_OVERLAY.SSR_HTML, d = tr == null ? void 0 : tr.BUILDER_HYDRATION_OVERLAY.CSR_HTML;
  x.useEffect(() => {
    var S;
    if (PL) {
      if (!(tr != null && tr.BUILDER_HYDRATION_OVERLAY)) {
        vt("No hydration error found. Make sure you are using @builder.io/react-hydration-overlay");
        return;
      }
      const N = (S = document.getElementById("sentry-spotlight-root")) == null ? void 0 : S.shadowRoot;
      if (!R || !d || !(() => {
        if (c)
          return !0;
        const y = document.head.querySelectorAll("style"), O = Array.from(y).filter((D) => D.getAttribute("data-emotion")), g = new CSSStyleSheet(), V = Array.from(O).map((D) => D.innerHTML).join(`
`);
        return g.replaceSync(V), N && N.adoptedStyleSheets && !(N.adoptedStyleSheets.indexOf(g) >= 0) && O.length > 0 ? (N.adoptedStyleSheets = [...N.adoptedStyleSheets, g], E(!0), !0) : !1;
      })())
        return;
      const v = _m(R, { format: "html" });
      a(v);
      const M = _m(d, { format: "html" });
      o(M);
    }
  }, [R, d, u]);
  const T = {
    variables: {
      dark: {
        diffViewerBackground: "transparent",
        addedBackground: "transparent",
        removedBackground: "transparent",
        wordAddedBackground: "#055d67",
        wordRemovedBackground: "#7d383f",
        addedGutterBackground: "transparent",
        removedGutterBackground: "transparent",
        gutterBackground: "transparent",
        codeFoldBackground: "transparent",
        emptyLineBackground: "transparent",
        diffViewerTitleBorderColor: "transparent",
        highlightBackground: "transparent",
        highlightGutterBackground: "transparent",
        codeFoldGutterBackground: "transparent",
        gutterBackgroundDark: "transparent"
      }
    }
  };
  return tr != null && tr.BUILDER_HYDRATION_OVERLAY ? u ? /* @__PURE__ */ p.jsx("div", { className: "hydration-error-wrapper relative w-full overflow-x-auto", children: /* @__PURE__ */ p.jsx(
    kB,
    {
      styles: T,
      oldValue: n,
      newValue: s,
      leftTitle: c ? "Server-Side Render" : "",
      rightTitle: c ? "Client-Side Render" : "",
      compareMethod: jS.DiffMethod.WORDS,
      useDarkTheme: !0
    }
  ) }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 px-6 py-4", children: "No Hydration error found." }) : /* @__PURE__ */ p.jsx("div", { className: "text-primary-300 px-6 py-4", children: "No hydration error found. Make sure you are using @builder.io/react-hydration-overlay" });
}
function i8() {
  return {
    name: "hydration-error",
    tabs: () => [
      {
        id: "hydration-error",
        title: "Hydration Error",
        content: XB
      }
    ]
  };
}
function jB() {
  return /* @__PURE__ */ p.jsx("div", { className: "divide-primary-900 bg-primary-950 h-full w-full divide-y", children: /* @__PURE__ */ p.jsx("div", { className: "flex h-full w-full flex-col gap-2", children: /* @__PURE__ */ p.jsx("iframe", { title: "vite-inspect", src: "http://localhost:4321/__inspect/", className: "h-full w-full" }) }) });
}
function s8() {
  return {
    name: "vite-inspect",
    tabs: () => [
      {
        id: "vite-inspect",
        title: "Vite Inspect",
        content: jB
      }
    ],
    setup: () => {
    }
  };
}
function Km(n) {
  const a = new CSSStyleSheet();
  return a.replaceSync(n), a;
}
async function KB(n) {
  Av("open", { path: n });
}
async function JB() {
  Av("close");
}
async function o8(n) {
  sT("closed", n);
}
async function l8(n) {
  sT("opened", n);
}
async function u8(n) {
  sT("severeEventCount", (a) => {
    var s;
    n(((s = a.detail) == null ? void 0 : s.count) ?? 1);
  });
}
function Jm() {
  return !!(window.__spotlight && window.document.getElementById("sentry-spotlight-root"));
}
async function E8({
  openOnInit: n = !1,
  showTriggerButton: a = !0,
  injectImmediately: s = !1,
  sidecarUrl: o = bS,
  anchor: c = pv,
  debug: E = !1,
  integrations: u,
  experiments: R = TS,
  fullPage: d = !1,
  showClearEventsButton: T = !0
} = {}) {
  if (typeof document > "u")
    return;
  const S = { ...TS, ...R };
  if (Jm())
    return;
  E && i2();
  const N = [iH({ sidecarUrl: o })], m = {
    open: KB,
    close: JB,
    experiments: S
  }, [v] = await Sv(u ?? N, m), M = document.createElement("div");
  M.id = "sentry-spotlight-root";
  const w = M.attachShadow({ mode: "open" }), y = document.createElement("div");
  d ? (M.style.height = "100%", M.style.backgroundColor = zx.indigo[950], y.style.height = "inherit") : (y.style.position = "absolute", y.style.top = "0", y.style.left = "0", y.style.right = "0"), w.appendChild(y);
  const O = Km(l2);
  w.adoptedStyleSheets = [Km(bU), O];
  const g = v.map((G) => G.tabs ? G.tabs({ processedEvents: [] }).map((P) => ({
    ...P,
    processedEvents: []
  })) : []).flat(), V = g.length ? `/${g[0].id}` : "/no-tabs";
  pS.createRoot(y).render(
    // <React.StrictMode>
    /* @__PURE__ */ p.jsx(Ix, { initialEntries: [V], children: /* @__PURE__ */ p.jsx(Y2, { context: m, children: /* @__PURE__ */ p.jsx(
      o2,
      {
        integrations: v,
        openOnInit: n,
        showTriggerButton: a,
        sidecarUrl: o,
        anchor: c,
        fullPage: d,
        showClearEventsButton: T
      }
    ) }) })
    // </React.StrictMode>
  );
  function D() {
    vt("Injecting into application"), document.body.append(M);
  }
  s ? D() : window.addEventListener("load", () => {
    D();
  }), window.addEventListener("error", () => {
    Jm() || D();
  });
}
export {
  oC as C,
  pv as D,
  Qm as R,
  TS as a,
  bS as b,
  Yt as c,
  pS as d,
  sT as e,
  KB as f,
  Xi as g,
  JB as h,
  o8 as i,
  l8 as j,
  u8 as k,
  E8 as l,
  a8 as m,
  i8 as n,
  Qx as o,
  x as r,
  iH as s,
  Av as t,
  s8 as v
};
//# sourceMappingURL=index-2dea620f.js.map
